import React, { useState, useCallback, useEffect, useRef } from 'react';




import { removeBackground } from '@imgly/background-removal';
import './App.css';
import { Container, Typography, Button, TextField, Box, Alert, CircularProgress, Paper, List, ListItem, ListItemIcon, ListItemText, Select, MenuItem, FormControl, InputLabel, Tabs, Tab, Table, TableHead, TableRow, TableCell, TableBody, TableContainer, IconButton, Modal, Checkbox, FormControlLabel, Dialog, DialogTitle, DialogContent, DialogActions, Chip, Divider, Slider, Tooltip, Link, Autocomplete } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { AuthProvider, useAuth } from "./AuthContext";
import Login from "./Login";
import { useTranslation } from 'react-i18next';
import i18n, { changeLanguage } from './i18n';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import QrCodeIcon from '@mui/icons-material/QrCode';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import SportsOutlinedIcon from '@mui/icons-material/SportsOutlined';
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import DescriptionIcon from '@mui/icons-material/Description';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ShareIcon from '@mui/icons-material/Share';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import WarningIcon from '@mui/icons-material/Warning';
import ImageIcon from '@mui/icons-material/Image';
import CvTemplate from './templates/CvTemplate';
import CvSharePage from './components/CvSharePage';

import { config } from './config/env';
import { auth, db } from './firebase';
import { applyActionCode, confirmPasswordReset } from 'firebase/auth';
import { collection, doc, getDoc, onSnapshot, query, where } from 'firebase/firestore';
import { saveCvSettings, loadCvSettings, type CvSettings, type CvDesignSettings, defaultCvSettings } from './utils/cvSettings';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SaveIcon from '@mui/icons-material/Save';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import RestoreIcon from '@mui/icons-material/Restore';
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import SettingsIcon from '@mui/icons-material/Settings';
import RefreshIcon from '@mui/icons-material/Refresh';
import SearchIcon from '@mui/icons-material/Search';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PersonIcon from '@mui/icons-material/Person';
import Menu from '@mui/material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import DataObjectIcon from '@mui/icons-material/DataObject';
import StorageIcon from '@mui/icons-material/Storage';


import AiAssistant from './components/AiAssistant';
import FeedbackFab from './components/FeedbackFab';
import PricingPlans from './components/PricingPlans';
import { getTranslatedCvLabel as getTranslatedCvLabelFromDictionary } from './translations/cvLabels';

// Alle Firebase-Funktionen entfernt - Kommunikation läuft ausschließlich über Backend


// Funktion zur Erkennung der Browser-Sprache
const detectBrowserLanguage = (): string => {
  const browserLang = navigator.language || (navigator as any).userLanguage || 'de';
  const langCode = browserLang.split('-')[0].toLowerCase();
  
  // Unterstützte Sprachen: de, en, fr, it
  const supportedLanguages = ['de', 'en', 'fr', 'it'];
  
  // Wenn Browser-Sprache unterstützt wird, verwende sie, sonst 'de' als Fallback
  return supportedLanguages.includes(langCode) ? langCode : 'de';
};

const SHORT_PROFILE_PROMPT_VERSION = 'gpt-4o';
const SHORT_PROFILE_PROMPT_MAX_TOKENS = 900;
const SHORT_PROFILE_PROMPT_TEMPERATURE = 0.35;
const SHORT_PROFILE_PROMPT_ROLE = 'Du bist ein erfahrener Karriere-Coach und optimierst Kurzprofile präzise und individuell.';
type TonalitySectionSettings = {
  formalitaet: number;
  selbstbewusstsein: number;
  kreativitaet: number;
  tonAktiv: number;
  tonErgebnisorientiert: number;
  tonKompakt: number;
};
const defaultTonalitySettings: TonalitySectionSettings = {
  formalitaet: 70,
  selbstbewusstsein: 70,
  kreativitaet: 30,
  tonAktiv: 80,
  tonErgebnisorientiert: 80,
  tonKompakt: 50,
};

// Wrapper für PricingPlans, der den Token async holt
function PricingPlansWrapper({ open, onClose, currentPlan, user: pricingUser, onSubscriptionChange, language, hasSubscription, cancelAtPeriodEnd, currentPeriodEnd }: {
  open: boolean;
  onClose: () => void;
  currentPlan: 'Free' | 'Basic' | 'Pro' | 'Beta-Testing';
  user: any;
  onSubscriptionChange?: () => void;
  language?: string;
  hasSubscription?: boolean;
  cancelAtPeriodEnd?: boolean;
  currentPeriodEnd?: string | null;
}) {
  const [token, setToken] = useState<string | null>(null);
  
  useEffect(() => {
    if (open && pricingUser) {
      pricingUser.getIdToken().then((t: string) => setToken(t)).catch(() => setToken(null));
    }
  }, [open, pricingUser]);
  
  return (
    <PricingPlans
      open={open}
      onClose={onClose}
      currentPlan={currentPlan}
      userToken={token}
      onSubscriptionChange={onSubscriptionChange}
      language={language}
      hasSubscription={hasSubscription}
      cancelAtPeriodEnd={cancelAtPeriodEnd}
      currentPeriodEnd={currentPeriodEnd}
    />
  );
}

/** Select-Menüs im Portal – über CV-Daten-Dialog (zIndex 1600). */
const CV_DATA_MODAL_SELECT_MENU_PROPS = { sx: { zIndex: 2200 } };

function ProtectedApp() {
  const { t: tOriginal } = useTranslation();
  const { user, agbAccepted, agbLoading, acceptAgb, accountId, firstLogin, country: userCountry, accountRole, createAccount, checkAccountStatus, checkAgbStatus, logout } = useAuth();
  const legalBaseUrl = window.location.hostname.endsWith('.de')
    ? 'https://www.acceler-8.de'
    : 'https://www.acceler-8.ch';
  
  // Wrapper für t-Funktion, der automatisch ß durch ss ersetzt für CH
  const t = (key: string, options?: any) => {
    const translation = tOriginal(key, options);
    // Stelle sicher, dass translation ein String ist
    const translationString = typeof translation === 'string' ? translation : String(translation);
    if (userCountry === 'CH') {
      return translationString.replace(/ß/g, 'ss');
    }
    return translationString;
  };
  // Initialisiere immer mit Browser-Sprache (kein localStorage)
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    const browserLang = detectBrowserLanguage();
    console.log('🚀 Initial Language (Browser):', browserLang);
    return browserLang;
  });
  const getDictionaryLabel = (label: string) =>
    getTranslatedCvLabelFromDictionary(label, currentLanguage, userCountry);
  const getUiLanguageDictionaryLabel = (label: string) => {
    const activeUiLanguage = (i18n.language || currentLanguage).split('-')[0].toLowerCase();
    return getTranslatedCvLabelFromDictionary(label, activeUiLanguage, userCountry);
  };
  
  // Zielsprache für Übersetzungen basierend auf jobDescriptionLanguage
  const [targetLanguage, setTargetLanguage] = useState('deutsch');
  const [, setIsLoading] = useState(false);
  
  // AGB-Modal State - wird nur gezeigt wenn AGBs explizit NICHT akzeptiert wurden (false, nicht null)
  const showAgbModal: boolean = !agbLoading && !!user && agbAccepted === false;
  
  // Onboarding Modal State - wird gezeigt wenn firstLogin nicht null ist
  const showOnboardingModal = !agbLoading && !!user && !!firstLogin;
  
  // Handler für AGB-Akzeptierung
  const handleAcceptAgb = async () => {
    if (!hasReadAgb) return;
    
    // Wenn beide Modals aktiv sind, verwende Onboarding-Felder
    const firstName = showOnboardingModal ? onboardingFirstName : agbFirstName;
    const lastName = showOnboardingModal ? onboardingLastName : agbLastName;
    const gender = showOnboardingModal ? onboardingGender : agbGender;
    const company = showOnboardingModal ? onboardingCompany : agbCompany;
    
    // Validiere Felder
    if (!firstName || !lastName || !gender) {
      alert('Bitte füllen Sie alle Felder aus.');
      return;
    }
    
    setIsAccepting(true);
    setSavingAgbData(true);
    try {
      // Speichere AGB-Daten (Vorname, Nachname, Geschlecht, Firma)
      if (user) {
        const idToken = await user.getIdToken();
        const response = await fetch(`${config.backend.baseUrl}/api/user/agb-data`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${idToken}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            firstName: firstName,
            lastName: lastName,
            gender: gender,
            company: company
          })
        });
        
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.error || 'Fehler beim Speichern');
        }
        
        console.log('✅ AGB-Daten erfolgreich gespeichert');
        
        if (company) {
          setAccountName(company);
        }
      }
      
      // Akzeptiere AGBs
      await acceptAgb();
    } catch (error) {
      console.error('Error accepting AGBs:', error);
      alert('Fehler beim Akzeptieren der AGBs. Bitte versuchen Sie es erneut.');
      setIsAccepting(false);
      setSavingAgbData(false);
    }
  };
  
  // States für Onboarding Modal
  const [onboardingFirstName, setOnboardingFirstName] = useState('');
  const [onboardingLastName, setOnboardingLastName] = useState('');
  const [onboardingGender, setOnboardingGender] = useState('');
  const [onboardingCountry, setOnboardingCountry] = useState('');
  const [onboardingCompany, setOnboardingCompany] = useState('');
  const [savingOnboarding, setSavingOnboarding] = useState(false);
  
  // State für AGB-Modal
  const [hasReadAgb, setHasReadAgb] = useState(false);
  const [isAccepting, setIsAccepting] = useState(false);
  const [agbFirstName, setAgbFirstName] = useState('');
  const [agbLastName, setAgbLastName] = useState('');
  const [agbGender, setAgbGender] = useState('');
  const [agbCompany, setAgbCompany] = useState('');
  const [savingAgbData, setSavingAgbData] = useState(false);
  
  // Handler für Onboarding
  const handleSaveOnboarding = async () => {
    if (!user) return;
    
    if (!onboardingFirstName || !onboardingLastName || !onboardingGender || !onboardingCountry) {
      alert('Bitte füllen Sie alle Felder aus.');
      return;
    }
    
    setSavingOnboarding(true);
    try {
      const idToken = await user.getIdToken();
      const response = await fetch(`${config.backend.baseUrl}/api/user/onboarding`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${idToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          firstName: onboardingFirstName,
          lastName: onboardingLastName,
          gender: onboardingGender,
          country: onboardingCountry,
          company: onboardingCompany
        })
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Fehler beim Speichern');
      }
      
      // Erfolgreich gespeichert - aktualisiere AGB-Status (firstLogin wird dadurch zurückgesetzt)
      await checkAgbStatus();
      console.log('✅ Onboarding-Daten erfolgreich gespeichert');
    } catch (error) {
      console.error('❌ Fehler beim Speichern der Onboarding-Daten:', error);
      alert('Fehler beim Speichern. Bitte versuchen Sie es erneut.');
    } finally {
      setSavingOnboarding(false);
    }
  };
  
  // Versionsinformationen
  const [showVersionInfo, setShowVersionInfo] = useState(false);
  const [backendVersionInfo, setBackendVersionInfo] = useState<any>(null);

  // State für Textfarben-Modal
  const [showTextColorPalette, setShowTextColorPalette] = useState(false);
  const [nameTextColor, setNameTextColor] = useState('#333333');
  const [leftColumnTextColor, setLeftColumnTextColor] = useState('#333333');
  const [rightColumnTextColor, setRightColumnTextColor] = useState('#333333');
  const [leftColumnTitleColor, setLeftColumnTitleColor] = useState('#333333');
  const [rightColumnTitleColor, setRightColumnTitleColor] = useState('#333333');
  
  // Temporäre State-Variablen für Textfarben (werden erst beim Schließen angewendet)
  const [tempNameTextColor, setTempNameTextColor] = useState('#333333');
  const [tempLeftColumnTextColor, setTempLeftColumnTextColor] = useState('#333333');
  const [tempRightColumnTextColor, setTempRightColumnTextColor] = useState('#333333');
  const [tempLeftColumnTitleColor, setTempLeftColumnTitleColor] = useState('#333333');
  const [tempRightColumnTitleColor, setTempRightColumnTitleColor] = useState('#333333');
  const [loadingVersionInfo, setLoadingVersionInfo] = useState(false);
  
  // State für Schriftarten
  const [titleFont, setTitleFont] = useState('"Times New Roman", Times, serif');
  const [bodyFont, setBodyFont] = useState('Arial, sans-serif');
  
  // Frontend Build-Informationen
  const frontendVersion = '1.0.0';
  const buildTime = process.env.REACT_APP_BUILD_TIME || new Date().toISOString();

  // Funktion zum Übersetzen von CV-Text-Labels basierend auf currentLanguage (UI-Sprache)
  const getTranslatedCvLabel = (label: string) => {
    // Konvertiere currentLanguage zu ausgeschriebenem Format für Translations-Lookup
    const languageMap: { [key: string]: string } = {
      'de': 'deutsch',
      'fr': 'französisch',
      'it': 'italienisch',
      'en': 'englisch'
    };
    const uiLanguage = languageMap[currentLanguage] || 'deutsch';
    
    const translations: { [key: string]: { [key: string]: string } } = {
      'Name:': {
        'deutsch': 'Name:',
        'englisch': 'Name:',
        'französisch': 'Nom:',
        'italienisch': 'Nome:'
      },
      'Adresse:': {
        'deutsch': 'Adresse:',
        'englisch': 'Address:',
        'französisch': 'Adresse:',
        'italienisch': 'Indirizzo:'
      },
      'PLZ:': {
        'deutsch': 'PLZ:',
        'englisch': 'Postal Code:',
        'französisch': 'Code postal:',
        'italienisch': 'CAP:'
      },
      'Stadt:': {
        'deutsch': 'Stadt:',
        'englisch': 'City:',
        'französisch': 'Ville:',
        'italienisch': 'Città:'
      },
      'Land:': {
        'deutsch': 'Land:',
        'englisch': 'Country:',
        'französisch': 'Pays:',
        'italienisch': 'Paese:'
      },
      'Verfügbar ab:': {
        'deutsch': 'Verfügbar ab:',
        'englisch': 'Available from:',
        'französisch': 'Disponible à partir de:',
        'italienisch': 'Disponibile da:'
      },
      'Telefon:': {
        'deutsch': 'Telefon:',
        'englisch': 'Phone:',
        'französisch': 'Téléphone:',
        'italienisch': 'Telefono:'
      },
      'Email:': {
        'deutsch': 'Email:',
        'englisch': 'Email:',
        'französisch': 'Email:',
        'italienisch': 'Email:'
      },
      'Geburtsjahr:': {
        'deutsch': 'Geburtsjahr:',
        'englisch': 'Birth Year:',
        'französisch': 'Année de naissance:',
        'italienisch': 'Anno di nascita:'
      },
      'Nationalität:': {
        'deutsch': 'Nationalität:',
        'englisch': 'Nationality:',
        'französisch': 'Nationalité:',
        'italienisch': 'Nazionalità:'
      },
      'Aufenthaltsbewilligung:': {
        'deutsch': 'Aufenthaltsbewilligung:',
        'englisch': 'Residence Permit:',
        'französisch': 'Permis de séjour:',
        'italienisch': 'Permesso di soggiorno:'
      },
      'Familienstand:': {
        'deutsch': 'Familienstand:',
        'englisch': 'Marital Status:',
        'französisch': 'État civil:',
        'italienisch': 'Stato civile:'
      },
      'Profil:': {
        'deutsch': 'Profil:',
        'englisch': 'Profile:',
        'französisch': 'Profil:',
        'italienisch': 'Profilo:'
      },
      'Profilbild:': {
        'deutsch': 'Profilbild:',
        'englisch': 'Profile Picture:',
        'französisch': 'Photo de profil:',
        'italienisch': 'Foto del profilo:'
      },
      'Profilbild': {
        'deutsch': 'Profilbild',
        'englisch': 'Profile Picture',
        'französisch': 'Photo de profil',
        'italienisch': 'Foto del profilo'
      },
      'Zoom': {
        'deutsch': 'Zoom',
        'englisch': 'Zoom',
        'französisch': 'Zoom',
        'italienisch': 'Zoom'
      },
      'Horizontal': {
        'deutsch': 'Horizontal',
        'englisch': 'Horizontal',
        'französisch': 'Horizontal',
        'italienisch': 'Orizzontale'
      },
      'Vertikal': {
        'deutsch': 'Vertikal',
        'englisch': 'Vertical',
        'französisch': 'Vertical',
        'italienisch': 'Verticale'
      },
      'Helligkeit': {
        'deutsch': 'Helligkeit',
        'englisch': 'Brightness',
        'französisch': 'Luminosité',
        'italienisch': 'Luminosità'
      },
      'Kontrast': {
        'deutsch': 'Kontrast',
        'englisch': 'Contrast',
        'französisch': 'Contraste',
        'italienisch': 'Contrasto'
      },
      'Sättigung': {
        'deutsch': 'Sättigung',
        'englisch': 'Saturation',
        'französisch': 'Saturation',
        'italienisch': 'Saturazione'
      },
      'Rotation': {
        'deutsch': 'Rotation',
        'englisch': 'Rotation',
        'französisch': 'Rotation',
        'italienisch': 'Rotazione'
      },
      '90° links drehen': {
        'deutsch': '90° links drehen',
        'englisch': 'Rotate 90° left',
        'französisch': 'Tourner 90° à gauche',
        'italienisch': 'Ruota 90° a sinistra'
      },
      '90° rechts drehen': {
        'deutsch': '90° rechts drehen',
        'englisch': 'Rotate 90° right',
        'französisch': 'Tourner 90° à droite',
        'italienisch': 'Ruota 90° a destra'
      },
      'Graustufen': {
        'deutsch': 'Graustufen',
        'englisch': 'Grayscale',
        'französisch': 'Niveaux de gris',
        'italienisch': 'Scala di grigi'
      },
      'Schwarz-Weiss': {
        'deutsch': 'Schwarz-Weiss',
        'englisch': 'Black & White',
        'französisch': 'Noir et blanc',
        'italienisch': 'Bianco e nero'
      },
      'Alle Einstellungen zurücksetzen': {
        'deutsch': 'Alle Einstellungen zurücksetzen',
        'englisch': 'Reset all settings',
        'französisch': 'Réinitialiser tous les paramètres',
        'italienisch': 'Ripristina tutte le impostazioni'
      },
      'Hintergrund entfernen': {
        'deutsch': 'Hintergrund entfernen',
        'englisch': 'Remove background',
        'französisch': 'Supprimer l\'arrière-plan',
        'italienisch': 'Rimuovi sfondo'
      },
      'Hintergrund wird entfernt...': {
        'deutsch': 'Hintergrund wird entfernt...',
        'englisch': 'Removing background...',
        'französisch': 'Suppression de l\'arrière-plan...',
        'italienisch': 'Rimozione sfondo...'
      },
      'Signatur:': {
        'deutsch': 'Signatur:',
        'englisch': 'Signature:',
        'französisch': 'Signature:',
        'italienisch': 'Firma:'
      },
      'CV-Daten sind wahrheitsgetreu und aktuell.': {
        'deutsch': 'CV-Daten sind wahrheitsgetreu und aktuell.',
        'englisch': 'CV data is truthful and up-to-date.',
        'französisch': 'Les données du CV sont exactes et à jour.',
        'italienisch': 'I dati del CV sono veritieri e aggiornati.'
      },
      'CV-Daten': {
        'deutsch': 'CV-Daten',
        'englisch': 'CV Data',
        'französisch': 'Données CV',
        'italienisch': 'Dati CV'
      },
      'Bitte überprüfe deine CV-Daten genau und nimm nötige Änderungen direkt in dieser Maske vor.': {
        'deutsch': 'Bitte überprüfe deine CV-Daten genau und nimm nötige Änderungen direkt in dieser Maske vor.',
        'englisch': 'Please check your CV data carefully and make necessary changes directly in this form.',
        'französisch': 'Veuillez vérifier attentivement vos données CV et apporter les modifications nécessaires directement dans ce formulaire.',
        'italienisch': 'Si prega di controllare attentamente i dati del CV e apportare le modifiche necessarie direttamente in questo modulo.'
      },
      'CV-Daten bearbeiten': {
        'deutsch': 'CV-Daten bearbeiten',
        'englisch': 'Edit CV Data',
        'französisch': 'Modifier les données CV',
        'italienisch': 'Modifica dati CV'
      },
      'CV-Daten exportieren': {
        'deutsch': 'CV-Daten exportieren',
        'englisch': 'Export CV Data',
        'französisch': 'Exporter les données CV',
        'italienisch': 'Esporta dati CV'
      },
      'Stellenbeschreibung erfassen': {
        'deutsch': 'Stellenbeschreibung erfassen',
        'englisch': 'Enter Job Description',
        'französisch': 'Saisir la description du poste',
        'italienisch': 'Inserisci descrizione del lavoro'
      },
      'Neue Stellenbeschreibung erfassen': {
        'deutsch': 'Neue Stellenbeschreibung erfassen',
        'englisch': 'Enter New Job Description',
        'französisch': 'Saisir une nouvelle description du poste',
        'italienisch': 'Inserisci nuova descrizione del lavoro'
      },
      'Als neue Bewerbung speichern': {
        'deutsch': 'Als neue Bewerbung speichern',
        'englisch': 'Save as new application',
        'französisch': 'Enregistrer comme nouvelle candidature',
        'italienisch': 'Salva come nuova candidatura'
      },
      'Bewerbungen speichern': {
        'deutsch': 'Bewerbungen speichern',
        'englisch': 'Save applications',
        'französisch': 'Enregistrer les candidatures',
        'italienisch': 'Salva candidature'
      },
      'Meine Bewerbungen': {
        'deutsch': 'Meine Bewerbungen',
        'englisch': 'My Applications',
        'französisch': 'Mes candidatures',
        'italienisch': 'Le mie candidature'
      },
      'Meine CV Daten': {
        'deutsch': 'Meine CV Daten',
        'englisch': 'My CV Data',
        'französisch': 'Mes données CV',
        'italienisch': 'I miei dati CV'
      },
      'CV Name': {
        'deutsch': 'CV Name',
        'englisch': 'CV Name',
        'französisch': 'Nom du CV',
        'italienisch': 'Nome CV'
      },
      'Aktiv': {
        'deutsch': 'Aktiv',
        'englisch': 'Active',
        'französisch': 'Actif',
        'italienisch': 'Attivo'
      },
      'Letzte Änderung': {
        'deutsch': 'Letzte Änderung',
        'englisch': 'Last Modified',
        'französisch': 'Dernière modification',
        'italienisch': 'Ultima modifica'
      },
      'Keine CV Daten vorhanden': {
        'deutsch': 'Keine CV Daten vorhanden',
        'englisch': 'No CV data available',
        'französisch': 'Aucune donnée CV disponible',
        'italienisch': 'Nessun dato CV disponibile'
      },
      'Erstellt am': {
        'deutsch': 'Erstellt am',
        'englisch': 'Created on',
        'französisch': 'Créé le',
        'italienisch': 'Creato il'
      },
      'Sprache': {
        'deutsch': 'Sprache',
        'englisch': 'Language',
        'französisch': 'Langue',
        'italienisch': 'Lingua'
      },
      'Keine Bewerbungen vorhanden': {
        'deutsch': 'Keine Bewerbungen vorhanden',
        'englisch': 'No applications available',
        'französisch': 'Aucune candidature disponible',
        'italienisch': 'Nessuna candidatura disponibile'
      },
      'Laden': {
        'deutsch': 'Laden',
        'englisch': 'Load',
        'französisch': 'Charger',
        'italienisch': 'Carica'
      },
      'Firma': {
        'deutsch': 'Firma',
        'englisch': 'Company',
        'französisch': 'Entreprise',
        'italienisch': 'Azienda'
      },
      'Ausschreibedatum': {
        'deutsch': 'Ausschreibedatum',
        'englisch': 'Publish Date',
        'französisch': 'Date de publication',
        'italienisch': 'Data di pubblicazione'
      },
      'Startdatum': {
        'deutsch': 'Startdatum',
        'englisch': 'Start Date',
        'französisch': 'Date de debut',
        'italienisch': 'Data di inizio'
      },
      'Aufgaben': {
        'deutsch': 'Aufgaben',
        'englisch': 'Tasks',
        'französisch': 'Tâches',
        'italienisch': 'Compiti'
      },
      'Anforderungen': {
        'deutsch': 'Anforderungen',
        'englisch': 'Requirements',
        'französisch': 'Exigences',
        'italienisch': 'Requisiti'
      },
      'Muss-Anforderungen': {
        'deutsch': 'Muss-Anforderungen',
        'englisch': 'Must Requirements',
        'französisch': 'Exigences indispensables',
        'italienisch': 'Requisiti obbligatori'
      },
      'Soll-Anforderungen': {
        'deutsch': 'Soll-Anforderungen',
        'englisch': 'Preferred Requirements',
        'französisch': 'Exigences souhaitées',
        'italienisch': 'Requisiti preferenziali'
      },
      'Kann-Anforderungen': {
        'deutsch': 'Kann-Anforderungen',
        'englisch': 'Optional Requirements',
        'französisch': 'Exigences optionnelles',
        'italienisch': 'Requisiti facoltativi'
      },
      'In Prüfung': {
        'deutsch': 'In Prüfung',
        'englisch': 'Under Review',
        'französisch': 'En examen',
        'italienisch': 'In esame'
      },
      'Freigegeben': {
        'deutsch': 'Freigegeben',
        'englisch': 'Approved',
        'französisch': 'Approuvé',
        'italienisch': 'Approvato'
      },
      'Zusage': {
        'deutsch': 'Zusage',
        'englisch': 'Accepted',
        'französisch': 'Accepté',
        'italienisch': 'Accettato'
      },
      'Absage': {
        'deutsch': 'Absage',
        'englisch': 'Rejected',
        'französisch': 'Refusé',
        'italienisch': 'Rifiutato'
      },
      'CV-Informationen teilen': {
        'deutsch': 'CV-Informationen teilen',
        'englisch': 'Share CV information',
        'französisch': 'Partager les informations du CV',
        'italienisch': 'Condividi informazioni CV'
      },
      'CV-Vorschau öffnen': {
        'deutsch': 'CV-Vorschau öffnen',
        'englisch': 'Open CV preview',
        'französisch': 'Ouvrir l\'aperçu du CV',
        'italienisch': 'Apri anteprima CV'
      },
      'Keine Informationen verfügbar': {
        'deutsch': 'Keine Informationen verfügbar',
        'englisch': 'No information available',
        'französisch': 'Aucune information disponible',
        'italienisch': 'Nessuna informazione disponibile'
      },
      'Notizen zur Bewerbung hinzufügen...': {
        'deutsch': 'Notizen zur Bewerbung hinzufügen...',
        'englisch': 'Add notes to application...',
        'französisch': 'Ajouter des notes à la candidature...',
        'italienisch': 'Aggiungi note alla candidatura...'
      },
      'Rollentitel eingeben...': {
        'deutsch': 'Rollentitel eingeben...',
        'englisch': 'Enter role title...',
        'französisch': 'Saisir le titre du poste...',
        'italienisch': 'Inserisci titolo del ruolo...'
      },
      'Firmenname eingeben...': {
        'deutsch': 'Firmenname eingeben...',
        'englisch': 'Enter company name...',
        'französisch': 'Saisir le nom de l\'entreprise...',
        'italienisch': 'Inserisci nome azienda...'
      },
      'Branche eingeben...': {
        'deutsch': 'Branche eingeben...',
        'englisch': 'Enter industry...',
        'französisch': 'Saisir le secteur...',
        'italienisch': 'Inserisci settore...'
      },
      'Kontaktdaten eingeben...': {
        'deutsch': 'Kontaktdaten eingeben...',
        'englisch': 'Enter contact info...',
        'französisch': 'Saisir les coordonnées...',
        'italienisch': 'Inserisci dati di contatto...'
      },
      'Kontaktdaten': {
        'deutsch': 'Kontaktdaten',
        'englisch': 'Contact Info',
        'französisch': 'Coordonnées',
        'italienisch': 'Dati di contatto'
      },
      'Branche': {
        'deutsch': 'Branche',
        'englisch': 'Industry',
        'französisch': 'Secteur',
        'italienisch': 'Settore'
      },
      'Rollentitel': {
        'deutsch': 'Rollentitel',
        'englisch': 'Role Title',
        'französisch': 'Titre du poste',
        'italienisch': 'Titolo del ruolo'
      },
      'Auslastung': {
        'deutsch': 'Auslastung',
        'englisch': 'Workload',
        'französisch': 'Charge de travail',
        'italienisch': 'Carico di lavoro'
      },
      'Schlüsselstichworte': {
        'deutsch': 'Schlüsselstichworte',
        'englisch': 'Keywords',
        'französisch': 'Mots-clés',
        'italienisch': 'Parole chiave'
      },
      'Job-Informationen': {
        'deutsch': 'Job-Informationen',
        'englisch': 'Job Information',
        'französisch': 'Informations sur le poste',
        'italienisch': 'Informazioni sul lavoro'
      },
      'Job-Informationen löschen': {
        'deutsch': 'Job-Informationen löschen',
        'englisch': 'Delete Job Information',
        'französisch': 'Supprimer les informations sur le poste',
        'italienisch': 'Elimina informazioni sul lavoro'
      },
      'Job-Informationen manuell erfassen': {
        'deutsch': 'Job-Informationen manuell erfassen',
        'englisch': 'Enter job information manually',
        'französisch': 'Saisir les informations du poste manuellement',
        'italienisch': 'Inserisci manualmente le informazioni sul lavoro'
      },
      'Drag & Drop': {
        'deutsch': 'Ziehen & Ablegen',
        'englisch': 'Drag & Drop',
        'französisch': 'Glisser-déposer',
        'italienisch': 'Trascina e rilascia'
      },
      'Copy & Paste': {
        'deutsch': 'Kopieren & Einfügen',
        'englisch': 'Copy & Paste',
        'französisch': 'Copier-coller',
        'italienisch': 'Copia e incolla'
      },
      'Bitte Stellenbeschreibung eingeben. Copy&Paste oder URL Drag&Drop': {
        'deutsch': 'Bitte Stellenbeschreibung mit Copy&Paste oder über URL Drag&Drop eingeben.',
        'englisch': 'Please enter job description.\nCopy&Paste or URL Drag&Drop',
        'französisch': 'Veuillez saisir la description du poste.\nCopier-coller ou glisser-déposer l\'URL',
        'italienisch': 'Si prega di inserire la descrizione del lavoro.\nCopia e incolla o trascina e rilascia l\'URL'
      },
      'Bewerbungsdetails': {
        'deutsch': 'Bewerbungsdetails',
        'englisch': 'Application Details',
        'französisch': 'Détails de la candidature',
        'italienisch': 'Dettagli della candidatura'
      },
      'Bewerbung': {
        'deutsch': 'Bewerbung',
        'englisch': 'Application',
        'französisch': 'Candidature',
        'italienisch': 'Candidatura'
      },
      'Zur Stellenbeschreibung': {
        'deutsch': 'Zur Stellenbeschreibung',
        'englisch': 'Go to Job Description',
        'französisch': 'Aller à la description du poste',
        'italienisch': 'Vai alla descrizione del lavoro'
      },
      'Status': {
        'deutsch': 'Status',
        'englisch': 'Status',
        'französisch': 'Statut',
        'italienisch': 'Stato'
      },
      'PDF verfügbar zum Download': {
        'deutsch': 'PDF verfügbar zum Download',
        'englisch': 'PDF available for download',
        'französisch': 'PDF disponible au téléchargement',
        'italienisch': 'PDF disponibile per il download'
      },
      'CV': {
        'deutsch': 'CV',
        'englisch': 'CV',
        'französisch': 'CV',
        'italienisch': 'CV'
      },
      'Notizen': {
        'deutsch': 'Notizen',
        'englisch': 'Notes',
        'französisch': 'Notes',
        'italienisch': 'Note'
      },
      'Offen': {
        'deutsch': 'Offen',
        'englisch': 'Open',
        'französisch': 'Ouvert',
        'italienisch': 'Aperto'
      },
      'Eingereicht': {
        'deutsch': 'Eingereicht',
        'englisch': 'Submitted',
        'französisch': 'Soumis',
        'italienisch': 'Inviato'
      },
      'Vorstellungsgespräch': {
        'deutsch': 'Vorstellungsgespräch',
        'englisch': 'Interview',
        'französisch': 'Entretien',
        'italienisch': 'Colloquio'
      },
      'Geschlossen': {
        'deutsch': 'Geschlossen',
        'englisch': 'Closed',
        'französisch': 'Fermé',
        'italienisch': 'Chiuso'
      },
      'Geschlossene Bewerbungen anzeigen': {
        'deutsch': 'Geschlossene Bewerbungen anzeigen',
        'englisch': 'Show closed applications',
        'französisch': 'Afficher les candidatures fermées',
        'italienisch': 'Mostra candidature chiuse'
      },
      'Datumsfilter anzeigen': {
        'deutsch': 'Datumsfilter anzeigen',
        'englisch': 'Show date filters',
        'französisch': 'Afficher les filtres de date',
        'italienisch': 'Mostra filtri data'
      },
      'Datumsfilter verbergen': {
        'deutsch': 'Datumsfilter verbergen',
        'englisch': 'Hide date filters',
        'französisch': 'Masquer les filtres de date',
        'italienisch': 'Nascondi filtri data'
      },
      'Von': {
        'deutsch': 'Von',
        'englisch': 'From',
        'französisch': 'De',
        'italienisch': 'Da'
      },
      'Bis': {
        'deutsch': 'Bis',
        'englisch': 'To',
        'französisch': 'À',
        'italienisch': 'A'
      },
      'Suche': {
        'deutsch': 'Suche',
        'englisch': 'Search',
        'französisch': 'Recherche',
        'italienisch': 'Ricerca'
      },
      'Name, Firma, Rollentitel...': {
        'deutsch': 'Name, Firma, Rollentitel...',
        'englisch': 'Name, company, role title...',
        'französisch': 'Nom, entreprise, titre du poste...',
        'italienisch': 'Nome, azienda, titolo del ruolo...'
      },
      'CV Name, E-Mail...': {
        'deutsch': 'CV Name, E-Mail...',
        'englisch': 'CV name, email...',
        'französisch': 'Nom CV, e-mail...',
        'italienisch': 'Nome CV, e-mail...'
      },
      'Filter verbergen': {
        'deutsch': 'Filter verbergen',
        'englisch': 'Hide filters',
        'französisch': 'Masquer les filtres',
        'italienisch': 'Nascondi filtri'
      },
      'Filter anzeigen': {
        'deutsch': 'Filter anzeigen',
        'englisch': 'Show filters',
        'französisch': 'Afficher les filtres',
        'italienisch': 'Mostra filtri'
      },
      'Filter zurücksetzen': {
        'deutsch': 'Filter zurücksetzen',
        'englisch': 'Reset filter',
        'französisch': 'Réinitialiser le filtre',
        'italienisch': 'Reimposta filtro'
      },
      'Logout': {
        'deutsch': 'Abmelden',
        'englisch': 'Logout',
        'französisch': 'Déconnexion',
        'italienisch': 'Disconnetti'
      },
      'Beenden': {
        'deutsch': 'Beenden',
        'englisch': 'Finish',
        'französisch': 'Terminer',
        'italienisch': 'Terminare'
      },
      'Speicherung nicht möglich: Vollständiger Name fehlt': {
        'deutsch': 'Speicherung nicht möglich: Vollständiger Name fehlt',
        'englisch': 'Cannot save: Full name is missing',
        'französisch': 'Sauvegarde impossible: Nom complet manquant',
        'italienisch': 'Impossibile salvare: Nome completo mancante'
      },
      'Ungespeicherte Änderungen': {
        'deutsch': 'Ungespeicherte Änderungen',
        'englisch': 'Unsaved Changes',
        'französisch': 'Modifications non enregistrées',
        'italienisch': 'Modifiche non salvate'
      },
      'Sie haben ungespeicherte Änderungen. Möchten Sie wirklich schließen ohne zu speichern?': {
        'deutsch': 'Sie haben ungespeicherte Änderungen. Möchten Sie wirklich schließen ohne zu speichern?',
        'englisch': 'You have unsaved changes. Do you really want to close without saving?',
        'französisch': 'Vous avez des modifications non enregistrées. Voulez-vous vraiment fermer sans enregistrer?',
        'italienisch': 'Hai modifiche non salvate. Vuoi davvero chiudere senza salvare?'
      },
      'Abbrechen': {
        'deutsch': 'Abbrechen',
        'englisch': 'Cancel',
        'französisch': 'Annuler',
        'italienisch': 'Annulla'
      },
      'Ohne Speichern schließen': {
        'deutsch': 'Ohne Speichern schließen',
        'englisch': 'Close without saving',
        'französisch': 'Fermer sans enregistrer',
        'italienisch': 'Chiudi senza salvare'
      },
      'Stellenbeschreibung eingeben': {
        'deutsch': 'Stellenbeschreibung eingeben',
        'englisch': 'Enter Job Description',
        'französisch': 'Saisir la description du poste',
        'italienisch': 'Inserisci descrizione del lavoro'
      },
      'Extrahiere Text von Webseite...': {
        'deutsch': 'Extrahiere Text von Webseite...',
        'englisch': 'Extracting text from website...',
        'französisch': 'Extraction du texte du site web...',
        'italienisch': 'Estrazione del testo dal sito web...'
      },
      'Fügen Sie hier die vollständige Stellenbeschreibung ein oder ziehen Sie einen Link hinein...': {
        'deutsch': 'Fügen Sie hier die vollständige Stellenbeschreibung ein oder ziehen Sie einen Link hinein...',
        'englisch': 'Paste the complete job description here or drag a link into it...',
        'französisch': 'Collez ici la description complète du poste ou faites glisser un lien...',
        'italienisch': 'Incolla qui la descrizione completa del lavoro o trascina un link...'
      },
      'Sprache Stellenbeschreibung': {
        'deutsch': 'Sprache Stellenbeschreibung',
        'englisch': 'Job Description Language',
        'französisch': 'Langue de la description du poste',
        'italienisch': 'Lingua della descrizione del lavoro'
      },
      'CV-Daten Set': {
        'deutsch': 'CV-Daten Set',
        'englisch': 'CV Data Set',
        'französisch': 'Jeu de données CV',
        'italienisch': 'Set di dati CV'
      },
      'Passgenauigkeit prüfen': {
        'deutsch': 'Passgenauigkeit prüfen',
        'englisch': 'Check Match Score',
        'französisch': 'Vérifier la correspondance',
        'italienisch': 'Verifica corrispondenza'
      },
      'Passgenauigkeit:': {
        'deutsch': 'Passgenauigkeit:',
        'englisch': 'Match Score:',
        'französisch': 'Correspondance:',
        'italienisch': 'Corrispondenza:'
      },
      'Fehlende Skills/Erfahrungen:': {
        'deutsch': 'Fehlende Skills/Erfahrungen:',
        'englisch': 'Missing Skills/Experiences:',
        'französisch': 'Compétences/Expériences manquantes:',
        'italienisch': 'Competenze/Esperienze mancanti:'
      },
      'Fehlende Erfahrung': {
        'deutsch': 'Fehlende Erfahrung',
        'englisch': 'Missing Experience',
        'französisch': 'Expérience manquante',
        'italienisch': 'Esperienza mancante'
      },
      'Schwäche': {
        'deutsch': 'Schwäche',
        'englisch': 'Weakness',
        'französisch': 'Faiblesse',
        'italienisch': 'Debolezza'
      },
      'Ergänzt': {
        'deutsch': 'Ergänzt',
        'englisch': 'Added',
        'französisch': 'Ajouté',
        'italienisch': 'Aggiunto'
      },
      'CV optimieren': {
        'deutsch': 'CV optimieren',
        'englisch': 'Optimize CV',
        'französisch': 'Optimiser le CV',
        'italienisch': 'Ottimizza CV'
      },
      'CV anzeigen': {
        'deutsch': 'CV anzeigen',
        'englisch': 'Show CV',
        'französisch': 'Afficher le CV',
        'italienisch': 'Mostra CV'
      },
      'oder': {
        'deutsch': 'oder',
        'englisch': 'or',
        'französisch': 'ou',
        'italienisch': 'o'
      },
      'CV-Vorschau': {
        'deutsch': 'CV-Vorschau',
        'englisch': 'CV Preview',
        'französisch': 'Aperçu du CV',
        'italienisch': 'Anteprima CV'
      },
      'CV neu optimieren': {
        'deutsch': 'CV neu optimieren',
        'englisch': 'Re-optimize CV',
        'französisch': 'Réoptimiser le CV',
        'italienisch': 'Riottimizzare il CV'
      },
      'Motivationsschreiben-Vorschau': {
        'deutsch': 'Motivationsschreiben-Vorschau',
        'englisch': 'Cover Letter Preview',
        'französisch': 'Aperçu de la lettre de motivation',
        'italienisch': 'Anteprima lettera di motivazione'
      },
      'Motivationsschreiben': {
        'deutsch': 'Motivationsschreiben',
        'englisch': 'Cover Letter',
        'französisch': 'Lettre de motivation',
        'italienisch': 'Lettera di motivazione'
      },
      'Vorschau': {
        'deutsch': 'Vorschau',
        'englisch': 'Preview',
        'französisch': 'Aperçu',
        'italienisch': 'Anteprima'
      },
      'Profilbild anzeigen': {
        'deutsch': 'Profilbild anzeigen',
        'englisch': 'Show Profile Picture',
        'französisch': 'Afficher la photo de profil',
        'italienisch': 'Mostra foto profilo'
      },
      'Kurzprofil anzeigen': {
        'deutsch': 'Kurzprofil anzeigen',
        'englisch': 'Show Short Profile',
        'französisch': 'Afficher le profil court',
        'italienisch': 'Mostra profilo breve'
      },
      'Kernkompetenzen anzeigen': {
        'deutsch': 'Kernkompetenzen anzeigen',
        'englisch': 'Show Core Competencies',
        'französisch': 'Afficher les compétences clés',
        'italienisch': 'Mostra competenze chiave'
      },
      'Zertifizierungen anzeigen': {
        'deutsch': 'Zertifizierungen anzeigen',
        'englisch': 'Show Certifications',
        'französisch': 'Afficher les certifications',
        'italienisch': 'Mostra certificazioni'
      },
      'IT-Skills anzeigen': {
        'deutsch': 'IT-Skills anzeigen',
        'englisch': 'Show IT Skills',
        'französisch': 'Afficher les compétences IT',
        'italienisch': 'Mostra competenze IT'
      },
      'Branchen anzeigen': {
        'deutsch': 'Branchen anzeigen',
        'englisch': 'Show Industries',
        'französisch': 'Afficher les secteurs',
        'italienisch': 'Mostra settori'
      },
      'Sprachen anzeigen': {
        'deutsch': 'Sprachen anzeigen',
        'englisch': 'Show Languages',
        'französisch': 'Afficher les langues',
        'italienisch': 'Mostra lingue'
      },
      'Hobbys anzeigen': {
        'deutsch': 'Hobbys anzeigen',
        'englisch': 'Show Hobbies',
        'französisch': 'Afficher les loisirs',
        'italienisch': 'Mostra hobby'
      },
      'Ausbildung anzeigen': {
        'deutsch': 'Ausbildung anzeigen',
        'englisch': 'Show Education',
        'französisch': 'Afficher la formation',
        'italienisch': 'Mostra formazione'
      },
      'Berufserfahrung anzeigen': {
        'deutsch': 'Berufserfahrung anzeigen',
        'englisch': 'Show Work Experience',
        'französisch': 'Afficher l\'expérience professionnelle',
        'italienisch': 'Mostra esperienza lavorativa'
      },
      'Weitere Berufserfahrungen anzeigen': {
        'deutsch': 'Weitere Berufserfahrungen anzeigen',
        'englisch': 'Show Additional Work Experience',
        'französisch': 'Afficher l\'expérience professionnelle supplémentaire',
        'italienisch': 'Mostra esperienza lavorativa aggiuntiva'
      },
      'Zusätzliche Infos anzeigen': {
        'deutsch': 'Zusätzliche Infos anzeigen',
        'englisch': 'Show Additional Information',
        'französisch': 'Afficher les informations supplémentaires',
        'italienisch': 'Mostra informazioni aggiuntive'
      },
      'Spaltenfarbe': {
        'deutsch': 'Spaltenfarbe',
        'englisch': 'Column Color',
        'französisch': 'Couleur de colonne',
        'italienisch': 'Colore colonna'
      },
      'Textfarben': {
        'deutsch': 'Textfarben',
        'englisch': 'Text Colors',
        'französisch': 'Couleurs du texte',
        'italienisch': 'Colori del testo'
      },
      'Reset Design': {
        'deutsch': 'Reset Design',
        'englisch': 'Reset Design',
        'französisch': 'Réinitialiser le design',
        'italienisch': 'Ripristina design'
      },
      'CV-Einstellungen': {
        'deutsch': 'CV-Einstellungen',
        'englisch': 'CV Settings',
        'französisch': 'Paramètres CV',
        'italienisch': 'Impostazioni CV'
      },
      'Schriftarten': {
        'deutsch': 'Schriftarten',
        'englisch': 'Fonts',
        'französisch': 'Polices',
        'italienisch': 'Caratteri'
      },
      'Titel-Schrift': {
        'deutsch': 'Titel-Schrift',
        'englisch': 'Title Font',
        'französisch': 'Police des titres',
        'italienisch': 'Font titoli'
      },
      'Text-Schrift': {
        'deutsch': 'Text-Schrift',
        'englisch': 'Body Font',
        'französisch': 'Police du texte',
        'italienisch': 'Font testo'
      },
      'Sichtbarkeit': {
        'deutsch': 'Sichtbarkeit',
        'englisch': 'Visibility',
        'französisch': 'Visibilité',
        'italienisch': 'Visibilità'
      },
      'Weitere Sichtbarkeit': {
        'deutsch': 'Weitere Sichtbarkeit',
        'englisch': 'Additional Visibility',
        'französisch': 'Visibilité supplémentaire',
        'italienisch': 'Visibilità aggiuntiva'
      },
      'Firmennamen': {
        'deutsch': 'Firmennamen',
        'englisch': 'Company Names',
        'französisch': 'Noms d\'entreprise',
        'italienisch': 'Nomi aziendali'
      },
      'Kontakt': {
        'deutsch': 'Kontakt',
        'englisch': 'Contact',
        'französisch': 'Contact',
        'italienisch': 'Contatto'
      },
      'Design': {
        'deutsch': 'Design',
        'englisch': 'Design',
        'französisch': 'Design',
        'italienisch': 'Design'
      },
      'Hier kannst du dir deinen CV in 3 verschiedenen Designs anzeigen lassen. Wähle ein Design aus und lies die Texte sorgfältig durch. Wenn du etwas ändern willst, klicke auf das entsprechende Element. Die Einstellungen findest du links neben der CV-Vorschau. Willst du den CV herunterladen, klicke auf das Download Icon oben rechts.': {
        'deutsch': 'Hier kannst du dir deinen CV in 3 verschiedenen Designs anzeigen lassen. Wähle ein Design aus und lies die Texte sorgfältig durch. Wenn du etwas ändern willst, klicke auf das entsprechende Element. Die Einstellungen findest du links neben der CV-Vorschau. Willst du den CV herunterladen, klicke auf das Download Icon oben rechts.',
        'englisch': 'Here you can view your CV in 3 different designs. Choose a design and read through the texts carefully. If you want to change something, click on the corresponding element. You can find the settings on the left next to the CV preview. If you want to download the CV, click on the download icon in the top right.',
        'französisch': 'Ici vous pouvez voir votre CV dans 3 designs différents. Choisissez un design et lisez attentivement les textes. Si vous voulez changer quelque chose, cliquez sur l\'élément correspondant. Vous pouvez trouver les paramètres à gauche à côté de l\'aperçu du CV. Si vous voulez télécharger le CV, cliquez sur l\'icône de téléchargement en haut à droite.',
        'italienisch': 'Qui puoi visualizzare il tuo CV in 3 design diversi. Scegli un design e leggi attentamente i testi. Se vuoi cambiare qualcosa, clicca sull\'elemento corrispondente. Puoi trovare le impostazioni a sinistra accanto all\'anteprima del CV. Se vuoi scaricare il CV, clicca sull\'icona di download in alto a destra.'
      },
      'Modern': {
        'deutsch': 'Modern',
        'englisch': 'Modern',
        'französisch': 'Moderne',
        'italienisch': 'Moderno'
      },
      'Professional': {
        'deutsch': 'Professional',
        'englisch': 'Professional',
        'französisch': 'Professionnel',
        'italienisch': 'Professionale'
      },
      'Classic': {
        'deutsch': 'Classic',
        'englisch': 'Classic',
        'französisch': 'Classique',
        'italienisch': 'Classico'
      },
      'Profilbild im CV-Template anzeigen': {
        'deutsch': 'Profilbild im CV-Template anzeigen',
        'englisch': 'Show Profile Picture in CV Template',
        'französisch': 'Afficher la photo de profil dans le modèle CV',
        'italienisch': 'Mostra foto profilo nel template CV'
      },
      'Klicken und ziehen, um die Position zu ändern': {
        'deutsch': 'Klicken und ziehen, um die Position zu ändern',
        'englisch': 'Click and drag to change position',
        'französisch': 'Cliquer et faire glisser pour modifier la position',
        'italienisch': 'Fare clic e trascinare per modificare la posizione'
      },
      'Rundung:': {
        'deutsch': 'Rundung:',
        'englisch': 'Roundness:',
        'französisch': 'Arrondi:',
        'italienisch': 'Arrotondamento:'
      },
      'Eckig': {
        'deutsch': 'Eckig',
        'englisch': 'Square',
        'französisch': 'Carré',
        'italienisch': 'Quadrato'
      },
      'Rund': {
        'deutsch': 'Rund',
        'englisch': 'Round',
        'französisch': 'Rond',
        'italienisch': 'Rotondo'
      },
      'Rahmen': {
        'deutsch': 'Rahmen',
        'englisch': 'Border',
        'französisch': 'Bordure',
        'italienisch': 'Bordo'
      },
      'Rahmen um das Profilbild anzeigen': {
        'deutsch': 'Rahmen um das Profilbild anzeigen',
        'englisch': 'Show border around profile picture',
        'französisch': 'Afficher la bordure autour de la photo de profil',
        'italienisch': 'Mostra bordo attorno alla foto profilo'
      },
      'Rahmenfarbe': {
        'deutsch': 'Rahmenfarbe',
        'englisch': 'Border Color',
        'französisch': 'Couleur de bordure',
        'italienisch': 'Colore bordo'
      },
      'Rahmendicke:': {
        'deutsch': 'Rahmendicke:',
        'englisch': 'Border Thickness:',
        'französisch': 'Épaisseur de bordure:',
        'italienisch': 'Spessore bordo:'
      },
      'Breite:': {
        'deutsch': 'Breite:',
        'englisch': 'Width:',
        'französisch': 'Largeur:',
        'italienisch': 'Larghezza:'
      },
      'Profilbild-Größe': {
        'deutsch': 'Profilbild-Größe',
        'englisch': 'Profile Picture Size',
        'französisch': 'Taille de la photo de profil',
        'italienisch': 'Dimensione foto profilo'
      },
      'Profilbild-Ausrichtung': {
        'deutsch': 'Profilbild-Ausrichtung',
        'englisch': 'Profile Picture Alignment',
        'französisch': 'Alignement de la photo de profil',
        'italienisch': 'Allineamento foto profilo'
      },
      'Links': {
        'deutsch': 'Links',
        'englisch': 'Left',
        'französisch': 'Gauche',
        'italienisch': 'Sinistra'
      },
      'Mittig': {
        'deutsch': 'Mittig',
        'englisch': 'Center',
        'französisch': 'Centre',
        'italienisch': 'Centro'
      },
      'Rechts': {
        'deutsch': 'Rechts',
        'englisch': 'Right',
        'französisch': 'Droite',
        'italienisch': 'Destra'
      },
      'Schließen': {
        'deutsch': 'Schließen',
        'englisch': 'Close',
        'französisch': 'Fermer',
        'italienisch': 'Chiudi'
      },
      'Profil im CV-Template anzeigen': {
        'deutsch': 'Profil im CV-Template anzeigen',
        'englisch': 'Show Profile in CV Template',
        'französisch': 'Afficher le profil dans le modèle CV',
        'italienisch': 'Mostra profilo nel template CV'
      },
      'Bearbeiten Sie Ihr Profil:': {
        'deutsch': 'Bearbeiten Sie Ihr Profil:',
        'englisch': 'Edit your profile:',
        'französisch': 'Modifiez votre profil:',
        'italienisch': 'Modifica il tuo profilo:'
      },
      'Profil-Text': {
        'deutsch': 'Profil-Text',
        'englisch': 'Profile Text',
        'französisch': 'Texte du profil',
        'italienisch': 'Testo profilo'
      },
      'Beschreiben Sie sich selbst, Ihre Ziele und Ihre Stärken...': {
        'deutsch': 'Beschreiben Sie sich selbst, Ihre Ziele und Ihre Stärken...',
        'englisch': 'Describe yourself, your goals and your strengths...',
        'französisch': 'Décrivez-vous, vos objectifs et vos points forts...',
        'italienisch': 'Descrivi te stesso, i tuoi obiettivi e i tuoi punti di forza...'
      },
      'Prompts zur Verbesserung des Kurzprofils': {
        'deutsch': 'Prompts zur Verbesserung des Kurzprofils',
        'englisch': 'Prompts to improve the short profile',
        'französisch': 'Prompts pour améliorer le profil court',
        'italienisch': 'Prompt per migliorare il profilo breve'
      },
      'Prompts zur Verbesserung der Beschreibung': {
        'deutsch': 'Prompts zur Verbesserung der Beschreibung',
        'englisch': 'Prompts to improve the description',
        'französisch': 'Prompts pour améliorer la description',
        'italienisch': 'Prompt per migliorare la descrizione'
      },
      'Kurzprofil mit Prompt verbessern': {
        'deutsch': 'Kurzprofil mit Prompt verbessern',
        'englisch': 'Improve short profile with prompt',
        'französisch': 'Améliorer le profil court avec un prompt',
        'italienisch': 'Migliora il profilo breve con un prompt'
      },
      'Beschreiben Sie, welche Aspekte verbessert werden sollen...': {
        'deutsch': 'Beschreiben Sie, welche Aspekte verbessert werden sollen...',
        'englisch': 'Describe which aspects should be improved...',
        'französisch': 'Décrivez quels aspects doivent être améliorés...',
        'italienisch': 'Descrivi quali aspetti dovrebbero essere migliorati...'
      },
      'Beschreiben Sie, welche Aspekte dieser Berufserfahrung verbessert werden sollen...': {
        'deutsch': 'Beschreiben Sie, welche Aspekte dieser Berufserfahrung verbessert werden sollen...',
        'englisch': 'Describe which aspects of this work experience should be improved...',
        'französisch': 'Décrivez quels aspects de cette expérience professionnelle doivent être améliorés...',
        'italienisch': 'Descrivi quali aspetti di questa esperienza lavorativa dovrebbero essere migliorati...'
      },
      'Kernkompetenzen im CV-Template anzeigen': {
        'deutsch': 'Kernkompetenzen im CV-Template anzeigen',
        'englisch': 'Show Core Competencies in CV Template',
        'französisch': 'Afficher les compétences clés dans le modèle CV',
        'italienisch': 'Mostra competenze chiave nel template CV'
      },
      'Hier sind alle optimierten Kernkompetenzen aus Ihren CV-Daten:': {
        'deutsch': 'Hier sind alle optimierten Kernkompetenzen aus Ihren CV-Daten:',
        'englisch': 'Here are all optimized core competencies from your CV data:',
        'französisch': 'Voici toutes les compétences clés optimisées de vos données CV:',
        'italienisch': 'Ecco tutte le competenze chiave ottimizzate dai tuoi dati CV:'
      },
      'Hinzufügen': {
        'deutsch': 'Hinzufügen',
        'englisch': 'Add',
        'französisch': 'Ajouter',
        'italienisch': 'Aggiungi'
      },
      'Info anzeigen': {
        'deutsch': 'Info anzeigen',
        'englisch': 'Show info',
        'französisch': 'Afficher les infos',
        'italienisch': 'Mostra informazioni'
      },
      'Kernkompetenz': {
        'deutsch': 'Kernkompetenz',
        'englisch': 'Core Competency',
        'französisch': 'Compétence clé',
        'italienisch': 'Competenza chiave'
      },
      'Aktionen': {
        'deutsch': 'Aktionen',
        'englisch': 'Actions',
        'französisch': 'Actions',
        'italienisch': 'Azioni'
      },
      'Keine Kernkompetenzen verfügbar': {
        'deutsch': 'Keine Kernkompetenzen verfügbar',
        'englisch': 'No core competencies available',
        'französisch': 'Aucune compétence clé disponible',
        'italienisch': 'Nessuna competenza chiave disponibile'
      },
      'Ausbildungen im CV-Template anzeigen': {
        'deutsch': 'Ausbildungen im CV-Template anzeigen',
        'englisch': 'Show Education in CV Template',
        'französisch': 'Afficher la formation dans le modèle CV',
        'italienisch': 'Mostra formazione nel template CV'
      },
      'Hier sind alle optimierten Ausbildungen aus Ihren CV-Daten:': {
        'deutsch': 'Hier sind alle optimierten Ausbildungen aus Ihren CV-Daten:',
        'englisch': 'Here is all optimized education from your CV data:',
        'französisch': 'Voici toutes les formations optimisées de vos données CV:',
        'italienisch': 'Ecco tutta la formazione ottimizzata dai tuoi dati CV:'
      },
      'Keine Ausbildungen verfügbar': {
        'deutsch': 'Keine Ausbildungen verfügbar',
        'englisch': 'No education available',
        'französisch': 'Aucune formation disponible',
        'italienisch': 'Nessuna formazione disponibile'
      },
      'Zertifizierungen im CV-Template anzeigen': {
        'deutsch': 'Zertifizierungen im CV-Template anzeigen',
        'englisch': 'Show Certifications in CV Template',
        'französisch': 'Afficher les certifications dans le modèle CV',
        'italienisch': 'Mostra certificazioni nel template CV'
      },
      'Hier sind alle optimierten Zertifizierungen aus Ihren CV-Daten:': {
        'deutsch': 'Hier sind alle optimierten Zertifizierungen aus Ihren CV-Daten:',
        'englisch': 'Here are all optimized certifications from your CV data:',
        'französisch': 'Voici toutes les certifications optimisées de vos données CV:',
        'italienisch': 'Ecco tutte le certificazioni ottimizzate dai tuoi dati CV:'
      },
      'Zertifizierung': {
        'deutsch': 'Zertifizierung',
        'englisch': 'Certification',
        'französisch': 'Certification',
        'italienisch': 'Certificazione'
      },
      'Keine Zertifizierungen verfügbar': {
        'deutsch': 'Keine Zertifizierungen verfügbar',
        'englisch': 'No certifications available',
        'französisch': 'Aucune certification disponible',
        'italienisch': 'Nessuna certificazione disponibile'
      },
      'IT-Skills im CV-Template anzeigen': {
        'deutsch': 'IT-Skills im CV-Template anzeigen',
        'englisch': 'Show IT Skills in CV Template',
        'französisch': 'Afficher les compétences IT dans le modèle CV',
        'italienisch': 'Mostra competenze IT nel template CV'
      },
      'Hier sind alle optimierten IT-Skills aus Ihren CV-Daten:': {
        'deutsch': 'Hier sind alle optimierten IT-Skills aus Ihren CV-Daten:',
        'englisch': 'Here are all optimized IT skills from your CV data:',
        'französisch': 'Voici toutes les compétences IT optimisées de vos données CV:',
        'italienisch': 'Ecco tutte le competenze IT ottimizzate dai tuoi dati CV:'
      },
      'IT-Skill': {
        'deutsch': 'IT-Skill',
        'englisch': 'IT Skill',
        'französisch': 'Compétence IT',
        'italienisch': 'Competenza IT'
      },
      'Keine IT-Skills verfügbar': {
        'deutsch': 'Keine IT-Skills verfügbar',
        'englisch': 'No IT skills available',
        'französisch': 'Aucune compétence IT disponible',
        'italienisch': 'Nessuna competenza IT disponibile'
      },
      'Branchen im CV-Template anzeigen': {
        'deutsch': 'Branchen im CV-Template anzeigen',
        'englisch': 'Show Industries in CV Template',
        'französisch': 'Afficher les secteurs dans le modèle CV',
        'italienisch': 'Mostra settori nel template CV'
      },
      'Hier sind alle optimierten Branchen aus Ihren CV-Daten:': {
        'deutsch': 'Hier sind alle optimierten Branchen aus Ihren CV-Daten:',
        'englisch': 'Here are all optimized industries from your CV data:',
        'französisch': 'Voici tous les secteurs optimisés de vos données CV:',
        'italienisch': 'Ecco tutti i settori ottimizzati dai tuoi dati CV:'
      },
      'Keine Branchen verfügbar': {
        'deutsch': 'Keine Branchen verfügbar',
        'englisch': 'No industries available',
        'französisch': 'Aucun secteur disponible',
        'italienisch': 'Nessun settore disponibile'
      },
      'Sprachen im CV-Template anzeigen': {
        'deutsch': 'Sprachen im CV-Template anzeigen',
        'englisch': 'Show Languages in CV Template',
        'französisch': 'Afficher les langues dans le modèle CV',
        'italienisch': 'Mostra lingue nel template CV'
      },
      'Hier sind alle optimierten Sprachen aus Ihren CV-Daten:': {
        'deutsch': 'Hier sind alle optimierten Sprachen aus Ihren CV-Daten:',
        'englisch': 'Here are all optimized languages from your CV data:',
        'französisch': 'Voici toutes les langues optimisées de vos données CV:',
        'italienisch': 'Ecco tutte le lingue ottimizzate dai tuoi dati CV:'
      },
      'Keine Sprachen verfügbar': {
        'deutsch': 'Keine Sprachen verfügbar',
        'englisch': 'No languages available',
        'französisch': 'Aucune langue disponible',
        'italienisch': 'Nessuna lingua disponibile'
      },
      'Hobbies im CV-Template anzeigen': {
        'deutsch': 'Hobbies im CV-Template anzeigen',
        'englisch': 'Show Hobbies in CV Template',
        'französisch': 'Afficher les loisirs dans le modèle CV',
        'italienisch': 'Mostra hobby nel template CV'
      },
      'Hier sind alle optimierten Hobbies aus Ihren CV-Daten:': {
        'deutsch': 'Hier sind alle optimierten Hobbies aus Ihren CV-Daten:',
        'englisch': 'Here are all optimized hobbies from your CV data:',
        'französisch': 'Voici tous les loisirs optimisés de vos données CV:',
        'italienisch': 'Ecco tutti gli hobby ottimizzati dai tuoi dati CV:'
      },
      'Keine Hobbies verfügbar': {
        'deutsch': 'Keine Hobbies verfügbar',
        'englisch': 'No hobbies available',
        'französisch': 'Aucun loisir disponible',
        'italienisch': 'Nessun hobby disponibile'
      },
      'Weitere Angaben im CV-Template anzeigen': {
        'deutsch': 'Weitere Angaben im CV-Template anzeigen',
        'englisch': 'Show Additional Information in CV Template',
        'französisch': 'Afficher les informations supplémentaires dans le modèle CV',
        'italienisch': 'Mostra informazioni aggiuntive nel template CV'
      },
      'Hier sind alle optimierten Weitere Angaben aus Ihren CV-Daten:': {
        'deutsch': 'Hier sind alle optimierten Weitere Angaben aus Ihren CV-Daten:',
        'englisch': 'Here is all optimized additional information from your CV data:',
        'französisch': 'Voici toutes les informations supplémentaires optimisées de vos données CV:',
        'italienisch': 'Ecco tutte le informazioni aggiuntive ottimizzate dai tuoi dati CV:'
      },
      'Info': {
        'deutsch': 'Info',
        'englisch': 'Info',
        'französisch': 'Info',
        'italienisch': 'Info'
      },
      'Keine Weitere Angaben verfügbar': {
        'deutsch': 'Keine Weitere Angaben verfügbar',
        'englisch': 'No additional information available',
        'französisch': 'Aucune information supplémentaire disponible',
        'italienisch': 'Nessuna informazione aggiuntiva disponibile'
      },
      'Berufserfahrungen im CV-Template anzeigen': {
        'deutsch': 'Berufserfahrungen im CV-Template anzeigen',
        'englisch': 'Show Work Experience in CV Template',
        'französisch': 'Afficher l\'expérience professionnelle dans le modèle CV',
        'italienisch': 'Mostra esperienza lavorativa nel template CV'
      },
      'Weitere Berufserfahrungen im CV-Template anzeigen': {
        'deutsch': 'Weitere Berufserfahrungen im CV-Template anzeigen',
        'englisch': 'Show Additional Work Experience in CV Template',
        'französisch': 'Afficher l\'expérience professionnelle supplémentaire dans le modèle CV',
        'italienisch': 'Mostra esperienza lavorativa aggiuntiva nel template CV'
      },
      'Bearbeiten Sie diese Berufserfahrung:': {
        'deutsch': 'Bearbeiten Sie diese Berufserfahrung:',
        'englisch': 'Edit this work experience:',
        'französisch': 'Modifiez cette expérience professionnelle:',
        'italienisch': 'Modifica questa esperienza lavorativa:'
      },
      'Hier sind alle optimierten Berufserfahrungen aus Ihren CV-Daten:': {
        'deutsch': 'Hier sind alle optimierten Berufserfahrungen aus Ihren CV-Daten:',
        'englisch': 'Here is all optimized work experience from your CV data:',
        'französisch': 'Voici toutes les expériences professionnelles optimisées de vos données CV:',
        'italienisch': 'Ecco tutta l\'esperienza lavorativa ottimizzata dai tuoi dati CV:'
      },
      'Unternehmen': {
        'deutsch': 'Unternehmen',
        'englisch': 'Company',
        'französisch': 'Entreprise',
        'italienisch': 'Azienda'
      },
      'Relevant': {
        'deutsch': 'Relevant',
        'englisch': 'Relevant',
        'französisch': 'Pertinent',
        'italienisch': 'Rilevante'
      },
      'Nicht relevant': {
        'deutsch': 'Nicht relevant',
        'englisch': 'Not relevant',
        'französisch': 'Non pertinent',
        'italienisch': 'Non rilevante'
      },
      'Mit Relevanz kannst du angeben, ob eine Berufserfahrung mit Beschreibung unter BERUFLICHER WERDEGANG oder mit minimalen Informationen unter WEITERE BERUFSERFAHRUNGEN aufgeführt werden soll.': {
        'deutsch': 'Mit Relevanz kannst du angeben, ob eine Berufserfahrung mit Beschreibung unter BERUFLICHER WERDEGANG oder mit minimalen Informationen unter WEITERE BERUFSERFAHRUNGEN aufgeführt werden soll.',
        'englisch': 'With relevance you can specify whether a work experience should be listed with description under PROFESSIONAL EXPERIENCE or with minimal information under ADDITIONAL WORK EXPERIENCE.',
        'französisch': 'Avec la pertinence, vous pouvez spécifier si une expérience professionnelle doit être répertoriée avec description sous PARCOURS PROFESSIONNEL ou avec des informations minimales sous AUTRES EXPÉRIENCES PROFESSIONNELLES.',
        'italienisch': 'Con la rilevanza puoi specificare se un\'esperienza lavorativa deve essere elencata con descrizione sotto ESPERIENZA PROFESSIONALE o con informazioni minime sotto ALTRE ESPERIENZE PROFESSIONALI.'
      },
      'Speichern': {
        'deutsch': 'Speichern',
        'englisch': 'Save',
        'französisch': 'Enregistrer',
        'italienisch': 'Salva'
      },
      'Zurück': {
        'deutsch': 'Zurück',
        'englisch': 'Back',
        'französisch': 'Retour',
        'italienisch': 'Indietro'
      },
      'Löschen': {
        'deutsch': 'Löschen',
        'englisch': 'Delete',
        'französisch': 'Supprimer',
        'italienisch': 'Elimina'
      },
      'Keine Berufserfahrungen verfügbar': {
        'deutsch': 'Keine Berufserfahrungen verfügbar',
        'englisch': 'No work experience available',
        'französisch': 'Aucune expérience professionnelle disponible',
        'italienisch': 'Nessuna esperienza lavorativa disponibile'
      },
      'Motivationsschreiben erstellen': {
        'deutsch': 'Motivationsschreiben erstellen',
        'englisch': 'Create Cover Letter',
        'französisch': 'Créer une lettre de motivation',
        'italienisch': 'Crea lettera di motivazione'
      },
      'Motivationsschreiben anzeigen': {
        'deutsch': 'Motivationsschreiben anzeigen',
        'englisch': 'Show Cover Letter',
        'französisch': 'Afficher la lettre de motivation',
        'italienisch': 'Mostra lettera di motivazione'
      },
      'Bitte lies das Motivationsschreiben gut durch. Willst du etwas ändern, klicke auf den entsprechenden Text. Willst du es herunter laden, klicke auf das Download Icon oben rechts.': {
        'deutsch': 'Bitte lies das Motivationsschreiben gut durch. Willst du etwas ändern, klicke auf den entsprechenden Text. Willst du es herunter laden, klicke auf das Download Icon oben rechts.',
        'englisch': 'Please read the cover letter carefully. If you want to change something, click on the corresponding text. If you want to download it, click on the download icon at the top right.',
        'französisch': 'Veuillez lire attentivement la lettre de motivation. Si vous souhaitez modifier quelque chose, cliquez sur le texte correspondant. Si vous souhaitez la télécharger, cliquez sur l\'icône de téléchargement en haut à droite.',
        'italienisch': 'Si prega di leggere attentamente la lettera di motivazione. Se vuoi modificare qualcosa, fai clic sul testo corrispondente. Se vuoi scaricarla, fai clic sull\'icona di download in alto a destra.'
      },
      'Hier kannst du dir deinen CV in 3 verschiedenen Designs anzeigen lassen. Wähle ein Design aus und lies die Texte sorgfältig durch. Wenn du etwas ändern willst, klicke auf das entsprechende Element. Willst du ein Design ändern, klick auf das Zahnrad Icon oben rechts. Willst du den CV herunterladen, klicke auf das Download Icon oben rechts.': {
        'deutsch': 'Hier kannst du dir deinen CV in 3 verschiedenen Designs anzeigen lassen. Wähle ein Design aus und lies die Texte sorgfältig durch. Wenn du etwas ändern willst, klicke auf das entsprechende Element. Willst du ein Design ändern, klick auf das Zahnrad Icon oben rechts. Willst du den CV herunterladen, klicke auf das Download Icon oben rechts.',
        'englisch': 'Here you can view your CV in 3 different designs. Select a design and read the texts carefully. If you want to change something, click on the corresponding element. If you want to change a design, click on the gear icon at the top right. If you want to download the CV, click on the download icon at the top right.',
        'französisch': 'Ici, vous pouvez afficher votre CV dans 3 designs différents. Sélectionnez un design et lisez attentivement les textes. Si vous souhaitez modifier quelque chose, cliquez sur l\'élément correspondant. Si vous souhaitez modifier un design, cliquez sur l\'icône d\'engrenage en haut à droite. Si vous souhaitez télécharger le CV, cliquez sur l\'icône de téléchargement en haut à droite.',
        'italienisch': 'Qui puoi visualizzare il tuo CV in 3 design diversi. Seleziona un design e leggi attentamente i testi. Se vuoi modificare qualcosa, fai clic sull\'elemento corrispondente. Se vuoi modificare un design, fai clic sull\'icona dell\'ingranaggio in alto a destra. Se vuoi scaricare il CV, fai clic sull\'icona di download in alto a destra.'
      },
      'Beschreibung wird extrahiert': {
        'deutsch': 'Beschreibung wird extrahiert',
        'englisch': 'Description being extracted',
        'französisch': 'Description en cours d\'extraction',
        'italienisch': 'Descrizione in estrazione'
      },
      'QR-Code wird geladen...': {
        'deutsch': 'QR-Code wird geladen...',
        'englisch': 'QR code loading...',
        'französisch': 'Chargement du code QR...',
        'italienisch': 'Caricamento del codice QR...'
      },
      'Der QR-Code ist 10 Minuten gültig. Das Foto wird automatisch als Profilbild übernommen.': {
        'deutsch': 'Der QR-Code ist 10 Minuten gültig. Das Foto wird automatisch als Profilbild übernommen.',
        'englisch': 'The QR code is valid for 10 minutes. The photo will be automatically used as profile picture.',
        'französisch': 'Le code QR est valable 10 minutes. La photo sera automatiquement utilisée comme photo de profil.',
        'italienisch': 'Il codice QR è valido per 10 minuti. La foto verrà automaticamente utilizzata come foto profilo.'
      },
      'CV Daten werden importiert...': {
        'deutsch': 'CV Daten werden importiert...',
        'englisch': 'CV data being imported...',
        'französisch': 'Importation des données CV...',
        'italienisch': 'Importazione dati CV...'
      },
      'CV wird verarbeitet...': {
        'deutsch': 'CV wird verarbeitet...',
        'englisch': 'CV being processed...',
        'französisch': 'CV en cours de traitement...',
        'italienisch': 'CV in elaborazione...'
      },
      'Kurzprofil': {
        'deutsch': 'Kurzprofil',
        'englisch': 'Short Profile',
        'französisch': 'Profil court',
        'italienisch': 'Profilo breve'
      },
      'Kernkompetenzen': {
        'deutsch': 'Kernkompetenzen',
        'englisch': 'Core Competencies',
        'französisch': 'Compétences clés',
        'italienisch': 'Competenze chiave'
      },
      'Relevante Kernkompetenzen': {
        'deutsch': 'Relevante Kernkompetenzen',
        'englisch': 'Relevant Core Competencies',
        'französisch': 'Compétences clés pertinentes',
        'italienisch': 'Competenze chiave rilevanti'
      },
      'Kernkompetenz aus gespeicherten Daten hinzufügen': {
        'deutsch': 'Kernkompetenz aus gespeicherten Daten hinzufügen',
        'englisch': 'Add Core Competency from Saved Data',
        'französisch': 'Ajouter une compétence clé à partir des données enregistrées',
        'italienisch': 'Aggiungi competenza chiave dai dati salvati'
      },
      'Beschreibung': {
        'deutsch': 'Beschreibung',
        'englisch': 'Description',
        'französisch': 'Description',
        'italienisch': 'Descrizione'
      },
      'Jahre': {
        'deutsch': 'Jahre',
        'englisch': 'Years',
        'französisch': 'Années',
        'italienisch': 'Anni'
      },
      'Branchenerfahrung': {
        'deutsch': 'Branchenerfahrung',
        'englisch': 'Industry Experience',
        'französisch': 'Expérience sectorielle',
        'italienisch': 'Esperienza settoriale'
      },
      'Position': {
        'deutsch': 'Position',
        'englisch': 'Position',
        'französisch': 'Poste',
        'italienisch': 'Posizione'
      },
      'Start': {
        'deutsch': 'Start',
        'englisch': 'Start',
        'französisch': 'Début',
        'italienisch': 'Inizio'
      },
      'Ende': {
        'deutsch': 'Ende',
        'englisch': 'End',
        'französisch': 'Fin',
        'italienisch': 'Fine'
      },
      'Ausbildung': {
        'deutsch': 'Ausbildung',
        'englisch': 'Education',
        'französisch': 'Formation',
        'italienisch': 'Formazione'
      },
      'Institution': {
        'deutsch': 'Institution',
        'englisch': 'Institution',
        'französisch': 'Institution',
        'italienisch': 'Istituzione'
      },
      'Abschluss': {
        'deutsch': 'Abschluss',
        'englisch': 'Degree',
        'französisch': 'Diplôme',
        'italienisch': 'Diploma'
      },
      'Zertifikate': {
        'deutsch': 'Zertifikate',
        'englisch': 'Certificates',
        'französisch': 'Certificats',
        'italienisch': 'Certificati'
      },
      'Zertifikat': {
        'deutsch': 'Zertifikat',
        'englisch': 'Certificate',
        'französisch': 'Certificat',
        'italienisch': 'Certificato'
      },
      'Jahr': {
        'deutsch': 'Jahr',
        'englisch': 'Year',
        'französisch': 'Année',
        'italienisch': 'Anno'
      },
      'Datum': {
        'deutsch': 'Datum',
        'englisch': 'Date',
        'französisch': 'Date',
        'italienisch': 'Data'
      },
      'Projektsuche': {
        'deutsch': 'Projektsuche',
        'englisch': 'Project Search',
        'französisch': 'Recherche de projet',
        'italienisch': 'Ricerca progetto'
      },
      'Name': {
        'deutsch': 'Name',
        'englisch': 'Name',
        'französisch': 'Nom',
        'italienisch': 'Nome'
      },
      'Aussteller': {
        'deutsch': 'Aussteller',
        'englisch': 'Issuer',
        'französisch': 'Émetteur',
        'italienisch': 'Emittente'
      },
      'Sprachkenntnisse': {
        'deutsch': 'Sprachkenntnisse',
        'englisch': 'Language Skills',
        'französisch': 'Compétences linguistiques',
        'italienisch': 'Competenze linguistiche'
      },
      'Niveau': {
        'deutsch': 'Niveau',
        'englisch': 'Level',
        'französisch': 'Niveau',
        'italienisch': 'Livello'
      },
      'IT-Kenntnisse': {
        'deutsch': 'IT-Kenntnisse',
        'englisch': 'IT Skills',
        'französisch': 'Compétences IT',
        'italienisch': 'Competenze IT'
      },
      'Skill': {
        'deutsch': 'Skill',
        'englisch': 'Skill',
        'französisch': 'Compétence',
        'italienisch': 'Competenza'
      },
      'Weitere Angaben': {
        'deutsch': 'Weitere Angaben',
        'englisch': 'Additional Information',
        'französisch': 'Informations supplémentaires',
        'italienisch': 'Informazioni aggiuntive'
      },
      'Angabe': {
        'deutsch': 'Angabe',
        'englisch': 'Information',
        'französisch': 'Information',
        'italienisch': 'Informazione'
      },
      'Details': {
        'deutsch': 'Details',
        'englisch': 'Details',
        'französisch': 'Détails',
        'italienisch': 'Dettagli'
      },
      'Hobbys': {
        'deutsch': 'Hobbys',
        'englisch': 'Hobbies',
        'französisch': 'Loisirs',
        'italienisch': 'Hobby'
      },
      'Zertifizierungen': {
        'deutsch': 'Zertifizierungen',
        'englisch': 'Certifications',
        'französisch': 'Certifications',
        'italienisch': 'Certificazioni'
      },
      'IT-Skills': {
        'deutsch': 'IT-Skills',
        'englisch': 'IT Skills',
        'französisch': 'Compétences IT',
        'italienisch': 'Competenze IT'
      },
      'Branchen': {
        'deutsch': 'Branchen',
        'englisch': 'Industries',
        'französisch': 'Secteurs',
        'italienisch': 'Settori'
      },
      'Sprachen': {
        'deutsch': 'Sprachen',
        'englisch': 'Languages',
        'französisch': 'Langues',
        'italienisch': 'Lingue'
      },
      'Berufserfahrung': {
        'deutsch': 'Berufserfahrung',
        'englisch': 'Work Experience',
        'französisch': 'Expérience professionnelle',
        'italienisch': 'Esperienza lavorativa'
      },
      'Weitere Berufserfahrungen': {
        'deutsch': 'Weitere Berufserfahrungen',
        'englisch': 'Additional Work Experience',
        'französisch': 'Expériences professionnelles supplémentaires',
        'italienisch': 'Ulteriori esperienze lavorative'
      },
      'Zusätzliche Infos': {
        'deutsch': 'Zusätzliche Infos',
        'englisch': 'Additional Info',
        'französisch': 'Informations supplémentaires',
        'italienisch': 'Informazioni aggiuntive'
      },
      'Grafik': {
        'deutsch': 'Grafik',
        'englisch': 'Graphic',
        'französisch': 'Graphique',
        'italienisch': 'Grafica'
      },
      'Datei wählen': {
        'deutsch': 'Datei wählen',
        'englisch': 'Choose File',
        'französisch': 'Choisir un fichier',
        'italienisch': 'Scegli file'
      },
      'Farben': {
        'deutsch': 'Farben',
        'englisch': 'Colors',
        'französisch': 'Couleurs',
        'italienisch': 'Colori'
      },
      'Header': {
        'deutsch': 'Header',
        'englisch': 'Header',
        'französisch': 'En-tête',
        'italienisch': 'Intestazione'
      },
      'Spalte': {
        'deutsch': 'Spalte',
        'englisch': 'Column',
        'französisch': 'Colonne',
        'italienisch': 'Colonna'
      },
      'Titel links': {
        'deutsch': 'Titel links',
        'englisch': 'Title left',
        'französisch': 'Titre gauche',
        'italienisch': 'Titolo sinistra'
      },
      'Text links': {
        'deutsch': 'Text links',
        'englisch': 'Text left',
        'französisch': 'Texte gauche',
        'italienisch': 'Testo sinistra'
      },
      'Titel rechts': {
        'deutsch': 'Titel rechts',
        'englisch': 'Title right',
        'französisch': 'Titre droite',
        'italienisch': 'Titolo destra'
      },
      'Text rechts': {
        'deutsch': 'Text rechts',
        'englisch': 'Text right',
        'französisch': 'Texte droite',
        'italienisch': 'Testo destra'
      },
      'Hobby': {
        'deutsch': 'Hobby',
        'englisch': 'Hobby',
        'französisch': 'Loisir',
        'italienisch': 'Hobby'
      },
      'Daten manuell befüllen': {
        'deutsch': 'Daten manuell befüllen',
        'englisch': 'Fill in data manually',
        'französisch': 'Remplir les données manuellement',
        'italienisch': 'Compila i dati manualmente'
      },
      'Stellenbeschreibung': {
        'deutsch': 'Stellenbeschreibung',
        'englisch': 'Job Description',
        'französisch': 'Description du poste',
        'italienisch': 'Descrizione del lavoro'
      },
      'Spalte:': {
        'deutsch': 'Spalte:',
        'englisch': 'Column:',
        'französisch': 'Colonne:',
        'italienisch': 'Colonna:'
      },
      'Sichtbarkeit (0-100%):': {
        'deutsch': 'Sichtbarkeit (0-100%):',
        'englisch': 'Visibility (0-100%):',
        'französisch': 'Visibilité (0-100%) :',
        'italienisch': 'Visibilità (0-100%):'
      }
    };

    const translated = translations[label]?.[uiLanguage] || label;
    // Ersetze ß durch ss für Schweizer Benutzer
    if (userCountry === 'CH') {
      return translated.replace(/ß/g, 'ss');
    }
    return translated;
  };

  // Hilfsfunktionen für HEX/RGBA-Konvertierung
  const hexToRgba = (hex: string, alpha: number = 1): string => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!result) return `rgba(248, 246, 242, ${alpha})`;
    const r = parseInt(result[1], 16);
    const g = parseInt(result[2], 16);
    const b = parseInt(result[3], 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  const rgbaToHex = (rgba: string): string => {
    const matches = rgba.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
    if (!matches) return '#f8f6f2';
    const r = parseInt(matches[1]).toString(16).padStart(2, '0');
    const g = parseInt(matches[2]).toString(16).padStart(2, '0');
    const b = parseInt(matches[3]).toString(16).padStart(2, '0');
    return `#${r}${g}${b}`;
  };

  const getAlphaFromRgba = (rgba: string): number => {
    const matches = rgba.match(/rgba?\([\d\s,]+,\s*([\d.]+)\)/);
    return matches ? parseFloat(matches[1]) : 1;
  };

  // Funktion zum Übersetzen von Info-Nachrichten basierend auf currentLanguage (UI-Sprache)
  const getTranslatedInfoMessage = (messageKey: string) => {
    // Konvertiere currentLanguage zu ausgeschriebenem Format für Translations-Lookup
    const languageMap: { [key: string]: string } = {
      'de': 'deutsch',
      'fr': 'französisch',
      'it': 'italienisch',
      'en': 'englisch'
    };
    const uiLanguage = languageMap[currentLanguage] || 'deutsch';
    
    const translations: { [key: string]: { [key: string]: string } } = {
      'upload_cv': {
        'deutsch': 'Laden Sie zuerst Ihre CV hoch oder geben Sie Ihre Daten manuell ein. Hier ist wichtig, dass Ihre Daten möglichst viele Informationen enthalten. Schönschreibung ist nicht relevant.',
        'englisch': 'Please upload your CV first or enter your data manually. It is important that your data contains as much information as possible. Good writing style is not relevant.',
        'französisch': 'Veuillez d\'abord télécharger votre CV ou saisir vos données manuellement. Il est important que vos données contiennent autant d\'informations que possible. Le style d\'écriture n\'est pas pertinent.',
        'italienisch': 'Si prega di caricare prima il CV o inserire i dati manualmente. È importante che i tuoi dati contengano quante più informazioni possibili. Lo stile di scrittura non è rilevante.'
      },
      'open_cv_and_motivation': {
        'deutsch': 'Erfasse deine CV Daten, in dem du deinen aktuell CV hochlädst oder deine Daten manuell eingibst.',
        'englisch': 'Capture your CV data by uploading your current CV or entering your data manually.',
        'französisch': 'Saisissez vos données CV en téléchargeant votre CV actuel ou en saisissant vos données manuellement.',
        'italienisch': 'Cattura i tuoi dati CV caricando il tuo CV attuale o inserendo i tuoi dati manualmente.'
      },
      'open_cv_create_motivation': {
        'deutsch': 'Hier können Sie Ihren CV öffnen und das Motivationsschreiben erstellen. Weiter können Sie hier eine weitere CV Optimierung beginnen.',
        'englisch': 'Here you can open your CV and create your cover letter. You can also start another CV optimization here.',
        'französisch': 'Vous pouvez ouvrir votre CV et créer votre lettre de motivation ici. Vous pouvez également commencer une autre optimisation de CV ici.',
        'italienisch': 'Qui puoi aprire il tuo CV e creare la tua lettera di motivazione. Puoi anche iniziare un\'altra ottimizzazione del CV qui.'
      },
      'match_results': {
        'deutsch': 'Unten sehen Sie die berechnete Passgenauigkeit. Diese sollte mindestens 75% betragen. Weiter sehen Sie eine Liste mit fehlenden Erfahrungen und Schwächen, welche Ihre Daten im Vergleich mit der Stellenbeschreibung aufweisen. Sie können nun Ihre Daten ergänzen oder die CV-Optimierung starten.',
        'englisch': 'Below you can see the calculated match score. This should be at least 75%. You will also see a list of missing experiences and weaknesses that your data has compared to the job description. You can now supplement your data or start the CV optimization.',
        'französisch': 'Vous pouvez voir ci-dessous le score de correspondance calculé. Celui-ci devrait être d\'au moins 75%. Vous verrez également une liste des expériences manquantes et des faiblesses de vos données par rapport à la description du poste. Vous pouvez maintenant compléter vos données ou commencer l\'optimisation du CV.',
        'italienisch': 'Di seguito puoi vedere il punteggio di corrispondenza calcolato. Questo dovrebbe essere almeno del 75%. Vedrai anche un elenco di esperienze mancanti e debolezze che i tuoi dati hanno rispetto alla descrizione del lavoro. Ora puoi integrare i tuoi dati o iniziare l\'ottimizzazione del CV.'
      },
      'enter_job_description': {
        'deutsch': 'Geben Sie eine Stellenbeschreibung ein, um mit der CV-Optimierung zu beginnen.',
        'englisch': 'Enter a job description to start the CV optimization.',
        'französisch': 'Entrez une description de poste pour commencer l\'optimisation du CV.',
        'italienisch': 'Inserisci una descrizione del lavoro per iniziare l\'ottimizzazione del CV.'
      },
      'verify_data': {
        'deutsch': 'Bitte überprüfen Sie Ihre Daten. Sind alle Daten korrekt, bestätigen Sie bitte, dass diese wahrheitsgetreu und vollständig sind. Klicken Sie hierzu auch die Checkbox oberhalb Ihrer Daten.',
        'englisch': 'Please verify your data. If all data is correct, please confirm that it is truthful and complete. To do this, click the checkbox above your data.',
        'französisch': 'Veuillez vérifier vos données. Si toutes les données sont correctes, veuillez confirmer qu\'elles sont exactes et complètes. Pour ce faire, cliquez sur la case à cocher au-dessus de vos données.',
        'italienisch': 'Si prega di verificare i propri dati. Se tutti i dati sono corretti, si prega di confermare che sono veritieri e completi. Per farlo, fare clic sulla casella di controllo sopra i dati.'
      },
      'calculating_match': {
        'deutsch': 'Passgenauigkeit wird berechnet...',
        'englisch': 'Calculating match score...',
        'französisch': 'Calcul du score de correspondance...',
        'italienisch': 'Calcolo del punteggio di corrispondenza...'
      },
      'match_calculated': {
        'deutsch': 'Passgenauigkeit berechnet. Sie können nun Ihr CV optimieren oder ein Motivationsschreiben erstellen.',
        'englisch': 'Match score calculated. You can now optimize your CV or create a cover letter.',
        'französisch': 'Score de correspondance calculé. Vous pouvez maintenant optimiser votre CV ou créer une lettre de motivation.',
        'italienisch': 'Punteggio di corrispondenza calcolato. Ora puoi ottimizzare il tuo CV o creare una lettera di motivazione.'
      },
      'optimizing_cv': {
        'deutsch': 'CV wird optimiert...',
        'englisch': 'Optimizing CV...',
        'französisch': 'Optimisation du CV...',
        'italienisch': 'Ottimizzazione del CV...'
      },
      'optimized_cv_being_created': {
        'deutsch': 'Optimierter CV wird erstellt...',
        'englisch': 'Creating optimized CV...',
        'französisch': 'Création du CV optimisé...',
        'italienisch': 'Creazione del CV ottimizzato...'
      },
      'creating_motivation': {
        'deutsch': 'Motivationsschreiben wird erstellt...',
        'englisch': 'Creating cover letter...',
        'französisch': 'Création de la lettre de motivation...',
        'italienisch': 'Creazione della lettera di motivazione...'
      },
      'loading_cv_preview': {
        'deutsch': 'CV-Vorschau wird geladen...',
        'englisch': 'Loading CV preview...',
        'französisch': 'Chargement de l\'aperçu du CV...',
        'italienisch': 'Caricamento anteprima CV...'
      },
      'upload_cv_data_first': {
        'deutsch': 'Zuerst CV-Daten hochladen',
        'englisch': 'Upload CV data first',
        'französisch': 'Téléchargez d\'abord les données du CV',
        'italienisch': 'Carica prima i dati del CV'
      },
      'motivation_created': {
        'deutsch': 'Motivationsschreiben erstellt. Sie können es nun anzeigen oder bearbeiten.',
        'englisch': 'Cover letter created. You can now view or edit it.',
        'französisch': 'Lettre de motivation créée. Vous pouvez maintenant la visualiser ou la modifier.',
        'italienisch': 'Lettera di motivazione creata. Ora puoi visualizzarla o modificarla.'
      }
    };

    return translations[messageKey]?.[uiLanguage] || '';
  };
  
  // Funktion zum Abrufen der Benutzerrolle
  const fetchUserRole = async (user: any) => {
    if (!user) return;
    
    try {
      setLoadingUserRole(true);
      const idToken = await user.getIdToken();
      
      const response = await fetch(`${config.backend.fullApiUrl}/api/user-role`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${idToken}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        setUserRole(data.role || 'Normal');
        console.log('👤 Benutzerrolle geladen:', data.role);
      } else {
        console.warn('⚠️ Fehler beim Laden der Benutzerrolle, verwende Standard-Rolle');
        setUserRole('Normal');
      }
    } catch (error) {
      console.error('❌ Fehler beim Abrufen der Benutzerrolle:', error);
      setUserRole('Normal');
    } finally {
      setLoadingUserRole(false);
    }
  };
  
  // Debug: Logge Konfiguration beim Start
  React.useEffect(() => {
    config.logUrls();
    console.log('🔧 Frontend erfolgreich gestartet!');
    console.log('🌍 currentLanguage:', currentLanguage);
    
    // Stelle sicher, dass die Übersetzung aktiv ist
    changeLanguage(currentLanguage);
    console.log('✅ Übersetzung aktiviert für:', currentLanguage);
    
    // Checkbox "Daten sind wahheitsgetreu" bleibt standardmäßig auf false
    
    // Markiere App als geladen
    setHasLoaded(true);

  }, []);

  // Lade User-Warnungs-Präferenzen beim App-Start
  React.useEffect(() => {
    if (user) {
      loadUserWarningPreferences();
    }
  }, [user]);


  // Reagiere auf Änderungen von currentLanguage und aktiviere die Übersetzung
  React.useEffect(() => {
    console.log('🔄 currentLanguage geändert:', currentLanguage);
    changeLanguage(currentLanguage);
    console.log('✅ Übersetzung aktiviert:', currentLanguage);
  }, [currentLanguage]);

  // Lade Benutzerrolle wenn sich der Benutzer anmeldet
  React.useEffect(() => {
    if (user) {
      fetchUserRole(user);
      loadUserCvData(user);
      loadCvDesignSettings(user);
      // Sprache wird nicht mehr aus Firebase geladen - i18next verwendet localStorage
    } else {
      setUserRole('Normal');
      setLoadingUserRole(false);
      setLoadingCvDesignSettings(false);
      setCvDesignSettingsLoaded(false);
    }
  }, [user]);

  const loadAccountCvSettingsFromBackend = async (idToken: string): Promise<CvSettings | null> => {
    const response = await fetch(`${config.backend.baseUrl}/api/get-cv-design`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${idToken}`
      }
    });

    if (!response.ok) {
      return null;
    }

    const data = await response.json();
    const rawDesignSettings = data.designSettings || data;
    const hasStructuredTemplates =
      !!rawDesignSettings &&
      typeof rawDesignSettings === 'object' &&
      !!rawDesignSettings.template1 &&
      !!rawDesignSettings.template2 &&
      !!rawDesignSettings.template3;

    if (data.useDefaults || !hasStructuredTemplates) {
      return null;
    }

    return rawDesignSettings as CvSettings;
  };

  // Funktion zum Laden der CV-Design-Einstellungen aus der cvDesign Collection
  const loadCvDesignSettings = async (user: any) => {
    setLoadingCvDesignSettings(true);
    setCvDesignSettingsLoaded(false);
    try {
      const idToken = await user.getIdToken();
      const accountSettings = await loadAccountCvSettingsFromBackend(idToken);

      if (accountSettings) {
        console.log('🎨 CV-Design-Einstellungen geladen');

        // WICHTIG: Sobald ein konkretes CV aktiv ist, dürfen Account-Design-Settings
        // die CV-spezifischen Einstellungen nicht mehr überschreiben.
        const activeCvId = localStorage.getItem('selectedCvId') || selectedCvId;
        if (activeCvId) {
          console.log('ℹ️ Account-Design-Laden übersprungen, weil ein aktives CV vorhanden ist:', activeCvId);
          return;
        }

        applyCvSettings(accountSettings);
        setCvSettings(accountSettings);
        if (accountSettings.selectedTemplate) {
          setSelectedTemplateId(accountSettings.selectedTemplate);
        }
        await new Promise(resolve => setTimeout(resolve, 50));
      } else {
        console.log('ℹ️ Keine CV-Design-Einstellungen gefunden, Design-Einstellungen bleiben unverändert');
        // KEINE Standardwerte anwenden - Design-Einstellungen bleiben unverändert
      }
    } catch (error) {
      console.error('❌ Fehler beim Laden der CV-Design-Einstellungen:', error);
    } finally {
      setLoadingCvDesignSettings(false);
      setCvDesignSettingsLoaded(true);
    }
  };

  // Funktion zum Speichern der CV-Design-Einstellungen in der cvDesign Collection
  const saveCvDesignSettings = async (
    overrides: Partial<CvDesignSettings> = {},
    templateIdOverride?: 'template1' | 'template2' | 'template3'
  ) => {
    if (!user) return;
    
    try {
      const idToken = await user.getIdToken();
      const designSettings = getCurrentCvSettings(overrides, templateIdOverride);
      
      const response = await fetch(`${config.backend.baseUrl}/api/save-cv-design`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${idToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(designSettings)
      });

      if (response.ok) {
        console.log('✅ CV-Design-Einstellungen gespeichert');
      } else {
        let errorMessage = 'Fehler beim Speichern der CV-Design-Einstellungen';
        try {
          const errorData = await response.json();
          if (typeof errorData?.error === 'string' && errorData.error.trim()) {
            errorMessage = errorData.error;
          }
        } catch {
          // Ignoriere Parse-Fehler und verwende den Fallback-Text
        }
        throw new Error(errorMessage);
      }
    } catch (error) {
      console.error('❌ Fehler beim Speichern der CV-Design-Einstellungen:', error);
      throw error;
    }
  };

  // Funktion zum Laden der CV-Daten des Users
  // HINWEIS: Diese Funktion wurde deaktiviert - CV-Auswahl erfolgt über die Tabelle
  const loadUserCvData = async (_user: any) => {
    // CV-Daten werden ausschließlich über handleSelectCv geladen.
    return;
  };

  // Hilfsfunktion um zu überprüfen, ob der Benutzer Admin ist
  const isAdmin = () => {
    return userRole === 'Admin';
  };

  // User Menu Handlers
  const handleUserMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setUserMenuAnchorEl(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setUserMenuAnchorEl(null);
  };

  // Konto-Modal Handlers
  const handleAccountMenuClick = () => {
    handleUserMenuClose();
    setAccountModalOpen(true);
    // Daten werden bereits beim App-Start geladen, hier nur aktualisieren
    loadAccountType();
    loadAccountUsers();
  };

  const handleAccountModalClose = () => {
    // Für Mitglieder: Nur Modal schließen, keine Speicherung
    const isOwner = accountUsers.some((u: any) => u.userId === user?.uid && u.role === 'owner');
    if (!isOwner) {
      setAccountModalOpen(false);
      return;
    }
    // Für Owner: Modal schließen (Speicherung erfolgt über Speichern-Button)
    setAccountModalOpen(false);
  };

  const handleUpgradeModalClose = () => {
    setUpgradeModalOpen(false);
    setUpgradeModalReason('freePlan');
  };

  const handleUpgradeToAccount = () => {
    setUpgradeModalOpen(false);
    setPricingModalOpen(true);
  };

  // Account-Typ laden
  const loadAccountType = React.useCallback(async () => {
    if (!accountId || !user) {
      setAccountType('Free');
      return;
    }

    try {
      const userToken = await user.getIdToken();
      const backendApi = config.backend.fullApiUrl;
      
      const response = await fetch(`${backendApi}/api/account/get`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${userToken}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        if (data.accountType) {
          setAccountType(
            data.accountType === 'Beta-Testing' ? 'Beta-Testing' :
            data.accountType === 'Pro' ? 'Pro' : 
            data.accountType === 'Free' ? 'Free' : 
            data.accountType === 'Basic' ? 'Basic' : 'Free'
          );
        } else {
          setAccountType('Free');
        }
        if (data.accountName !== undefined) {
          setAccountName(data.accountName || '');
        }
      } else {
        setAccountType('Free');
      }
    } catch (error) {
      console.error('Fehler beim Laden des Account-Typs:', error);
      setAccountType('Free');
    }
  }, [accountId, user]);

  // Account-User laden
  const loadAccountUsers = React.useCallback(async () => {
    if (!accountId || !user) {
      setAccountUsers([]);
      return;
    }

    setLoadingAccountUsers(true);
    try {
      const userToken = await user.getIdToken();
      const backendApi = config.backend.fullApiUrl;
      
      const response = await fetch(`${backendApi}/api/account/users`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${userToken}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        if (data.users) {
          setAccountUsers(data.users);
        }
      } else {
        console.error('Fehler beim Laden der Account-User');
        setAccountUsers([]);
      }
    } catch (error) {
      console.error('Fehler beim Laden der Account-User:', error);
      setAccountUsers([]);
    } finally {
      setLoadingAccountUsers(false);
    }
  }, [accountId, user]);

  // Account-Daten beim App-Start laden
  React.useEffect(() => {
    if (user && accountId) {
      loadAccountType();
      loadAccountUsers();
    }
  }, [user, accountId, loadAccountType, loadAccountUsers]);

  // User einladen
  const handleInviteUser = async () => {
    if (!accountId || !user || !inviteEmail) {
      return;
    }

    // Prüfe User-Limit
    const limits = getAccountLimits(accountType);
    if (accountUsers.length >= limits.maxUsers) {
      alert(t('account.limit.users.reached', { max: limits.maxUsers }));
      return;
    }

    // E-Mail-Validierung
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(inviteEmail)) {
      alert(t('account.invite.invalid.email'));
      return;
    }

    setInvitingUser(true);
    setInviteSuccess(false);
    try {
      const userToken = await user.getIdToken();
      const backendApi = config.backend.fullApiUrl;
      
      const response = await fetch(`${backendApi}/api/account/invite-user`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${userToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: inviteEmail,
          language: currentLanguage,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        console.log('Einladung gesendet:', data);
        console.log('inviteLink:', data.inviteLink);
        console.log('emailSent:', data.emailSent);
        
        setInviteSuccess(true);
        setEmailSent(data.emailSent || false);
        setInviteLink(data.inviteLink || null);
        setLastInvitedEmail(inviteEmail); // Speichere E-Mail für mailto-Link
        setInviteEmail('');
        // Lade User-Liste neu
        loadAccountUsers();
        
        // Wenn keine E-Mail gesendet wurde, aber ein Link vorhanden ist, zeige ihn länger an
        if (!data.emailSent && data.inviteLink) {
          console.log('E-Mail nicht gesendet, aber Link vorhanden - zeige Warnung mit Link');
          // Zeige Warnung mit Link für 30 Sekunden (statt 10), damit der User Zeit hat, den Link zu kopieren
          setTimeout(() => {
            setInviteSuccess(false);
            setInviteLink(null);
            setEmailSent(false);
            setLastInvitedEmail('');
          }, 30000);
        } else {
          // Zeige Erfolgsmeldung für 10 Sekunden, damit der Link kopiert werden kann
          setTimeout(() => {
            setInviteSuccess(false);
            setInviteLink(null);
            setEmailSent(false);
            setLastInvitedEmail('');
          }, 10000);
        }
      } else {
        const errorData = await response.json();
        console.error('Fehler beim Einladen des Users:', errorData);
        alert(errorData.error || t('account.invite.error'));
      }
    } catch (error) {
      console.error('Fehler beim Einladen des Users:', error);
      alert(t('account.invite.error'));
    } finally {
      setInvitingUser(false);
    }
  };

  // Benutzer löschen
  const handleDeleteUser = async (userIdToDelete: string, userEmailToDelete?: string) => {
    if (!accountId || !user) {
      return;
    }

    // Bestätigung
    if (!window.confirm(t('account.users.delete.confirm'))) {
      return;
    }

    setDeletingUserId(userIdToDelete);
    try {
      const userToken = await user.getIdToken();
      const backendApi = config.backend.fullApiUrl;
      
      const response = await fetch(`${backendApi}/api/account/remove-user`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${userToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userIdToRemove: userIdToDelete,
          userEmailToRemove: userEmailToDelete || null,
        }),
      });

      if (response.ok) {
        // Lade User-Liste neu
        await loadAccountUsers();
        alert(t('account.users.delete.success'));
      } else {
        const errorData = await response.json();
        console.error('Fehler beim Löschen des Benutzers:', errorData);
        alert(errorData.error || t('account.users.delete.error'));
      }
    } catch (error) {
      console.error('Fehler beim Löschen des Benutzers:', error);
      alert(t('account.users.delete.error'));
    } finally {
      setDeletingUserId(null);
    }
  };

  // Benutzerrolle im Account ändern (Member <-> Owner)
  const handleUpdateUserRole = async (userIdToUpdate: string, newRole: 'owner' | 'member') => {
    if (!accountId || !user) {
      return;
    }

    const ownerCount = accountUsers.filter((u: any) => u.role === 'owner').length;
    if (newRole === 'member' && ownerCount <= 1) {
      alert(t('account.users.role.change.last.owner.error'));
      return;
    }

    const confirmText = newRole === 'owner'
      ? t('account.users.role.change.confirm.promote')
      : t('account.users.role.change.confirm.demote');

    if (!window.confirm(confirmText)) {
      return;
    }

    setUpdatingUserRoleId(userIdToUpdate);
    try {
      const userToken = await user.getIdToken();
      const backendApi = config.backend.fullApiUrl;

      const response = await fetch(`${backendApi}/api/account/update-user-role`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${userToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userIdToUpdate,
          newRole,
        }),
      });

      if (response.ok) {
        await loadAccountUsers();
        alert(newRole === 'owner'
          ? t('account.users.role.change.success.promote')
          : t('account.users.role.change.success.demote'));
      } else {
        const errorData = await response.json();
        console.error('Fehler beim Ändern der Benutzerrolle:', errorData);
        alert(errorData.error || t('account.users.role.change.error'));
      }
    } catch (error) {
      console.error('Fehler beim Ändern der Benutzerrolle:', error);
      alert(t('account.users.role.change.error'));
    } finally {
      setUpdatingUserRoleId(null);
    }
  };

  // Account-Typ speichern
  const handleSaveAccountType = async () => {
    if (!accountId || !user) {
      console.error('Kein Account oder User verfügbar');
      return;
    }

    // Prüfe ob zu viele User für den neuen Plan vorhanden sind
    const limits = getAccountLimits(accountType);
    if (accountUsers.length > limits.maxUsers) {
      const removeCount = accountUsers.length - limits.maxUsers;
      alert(t('account.type.change.too.many.users', { 
        currentUsers: accountUsers.length, 
        maxUsers: limits.maxUsers,
        planType: accountType,
        removeCount: removeCount
      }));
      return;
    }

    // Prüfe ob zu viele CV-Daten-Sets für den neuen Plan vorhanden sind
    if (userCvs.length > limits.maxCvs) {
      const removeCount = userCvs.length - limits.maxCvs;
      alert(t('account.type.change.too.many.cvs', { 
        currentCvs: userCvs.length, 
        maxCvs: limits.maxCvs,
        planType: accountType,
        removeCount: removeCount
      }));
      return;
    }

    setSavingAccountType(true);
    try {
      const userToken = await user.getIdToken();
      const backendApi = config.backend.fullApiUrl;
      
      const response = await fetch(`${backendApi}/api/account/update-type`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${userToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          accountType: accountType,
          accountName: accountName,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        console.log('Account gespeichert:', data);
        handleAccountModalClose();
      } else {
        const errorData = await response.json();
        console.error('Fehler beim Speichern des Account-Typs:', errorData);
        alert(t('account.save.error'));
      }
    } catch (error) {
      console.error('Fehler beim Speichern des Account-Typs:', error);
      alert(t('account.save.error'));
    } finally {
      setSavingAccountType(false);
    }
  };

  const handleCvSettingsMenuClose = () => {
    setCvSettingsMenuAnchorEl(null);
  };

  // Funktion zum Sammeln der aktuellen CV-Design-Einstellungen für die cvDesign Collection
  const getCurrentCvDesignSettings = (
    overrides: Partial<CvDesignSettings> = {},
    templateIdOverride?: 'template1' | 'template2' | 'template3'
  ) => {
    const resolvedTemplateId = templateIdOverride || selectedTemplateId;
    return {
      // Farben - speichere RGBA-Werte mit Alpha-Kanal
      leftColumnColor: hexToRgba(leftColumnColor, leftColumnAlpha),
      nameTextColor,
      leftColumnTextColor,
      rightColumnTextColor,
      leftColumnTitleColor,
      rightColumnTitleColor,
      
      // Sichtbarkeits-Einstellungen
      showCoreCompetenciesInCv,
      showCertificationsInCv,
      showItSkillsInCv,
      showIndustriesInCv,
      showLanguagesInCv,
      showHobbiesInCv,
      showEducationInCv,
      showWorkExperienceInCv,
      showProfileInCv,
      showAdditionalInfoInCv,
      showProfileImageInCv,
      showContactInCv,
      showCompanyNamesInCv,
      showIndustryInCv,
      showDateInCv,
      showProjectSearchInCv,
      showBulletPointsInCv,
      showAdditionalWorkExperienceInCv,
      showPhotoInCv,
      
      // Profilbild-Einstellungen
      profileImageBorderRadius,
      profileImageSize,
      profileImageWidth,
      profileImagePosition,
      profileImageAlignment,
      profileImageBorder,
      profileImageBorderColor,
      profileImageBorderThickness,
      
      // Namensgröße
      nameFontSize,
      
      // Schriftarten
      titleFont,
      bodyFont,
      
      // Kontakt-Display-Mode
      contactDisplayMode,
      
      // Header-Box-Einstellungen - speichere RGBA-Werte mit Alpha-Kanal
      topBoxColor: hexToRgba(topBoxColor, topBoxAlpha),
      topBoxAlpha: topBoxAlpha, // Speichere Alpha-Wert separat für korrektes Laden
      topBoxImage,
      topBoxHeightMode: 'nameBottom',
      
      // Linke Spalte Bild
      leftColumnImage,
      
      // Tonalität
      tonalitySettings: tonalitySettings as CvDesignSettings['tonalitySettings'],
      shortProfileTextLength,
      workExperienceTextLength,
      sortWorkExperienceByRelevance,
      
      // Template-Name
      templateName: resolvedTemplateId === 'template1' ? getTranslatedCvLabel('Modern') : 
                   resolvedTemplateId === 'template2' ? getTranslatedCvLabel('Professional') : getTranslatedCvLabel('Classic'),
      
      // Template-ID
      selectedTemplate: resolvedTemplateId,
      
      // Metadaten
      lastUpdated: new Date().toISOString(),
      version: '2.0.0',
      ...overrides
    };
  };

  // Funktion zum Anwenden der CV-Design-Einstellungen aus der cvDesign Collection
  const applyCvDesignSettings = (designSettings: any) => {
    // Markiere als Settings-Laden, damit das Save-Icon nicht aktiviert wird
    isLoadingSettingsRef.current = true;
    
    // Lade die Standard-Template-Einstellungen für das aktuelle Template
    const templateId = designSettings.selectedTemplate || selectedTemplateId;
    const isProfessional = templateId === 'template2';
    
    // Farben anwenden (mit Template-spezifischen Defaults)
    // Konvertiere RGBA zurück zu HEX und extrahiere Alpha
    const leftColumnColorValue = designSettings.leftColumnColor || (isProfessional ? '#2e2e2e' : '#f8f6f2');
    if (leftColumnColorValue.startsWith('rgba')) {
      setLeftColumnColor(rgbaToHex(leftColumnColorValue));
      setLeftColumnAlpha(getAlphaFromRgba(leftColumnColorValue));
    } else {
      setLeftColumnColor(leftColumnColorValue);
      setLeftColumnAlpha(1);
    }
    
    const topBoxColorValue = designSettings.topBoxColor || (isProfessional ? '#2e2e2e' : '#f8f6f2');
    if (topBoxColorValue.startsWith('rgba')) {
      // RGBA-Wert: Extrahiere Farbe und verwende separaten Alpha-Wert falls vorhanden
      setTopBoxColor(rgbaToHex(topBoxColorValue));
      // Verwende IMMER den separaten topBoxAlpha, falls vorhanden (genauer als aus RGBA-String)
      if (designSettings.topBoxAlpha !== undefined) {
        setTopBoxAlpha(designSettings.topBoxAlpha);
      } else {
        // Fallback: Extrahiere Alpha aus RGBA-String
        setTopBoxAlpha(getAlphaFromRgba(topBoxColorValue));
      }
    } else {
      // HEX-Wert: Setze Farbe und verwende Alpha-Wert aus Design-Settings falls vorhanden
      setTopBoxColor(topBoxColorValue);
      // Wenn eine explizite Header-Farbe gesetzt wurde, prüfe ob Alpha-Wert in Design-Settings vorhanden ist
      if (designSettings.topBoxColor) {
        // Wenn topBoxAlpha explizit in Design-Settings vorhanden ist, verwende diesen
        // Ansonsten verwende 1 (sichtbar) wenn eine Farbe gesetzt wurde
        if (designSettings.topBoxAlpha !== undefined) {
          setTopBoxAlpha(designSettings.topBoxAlpha);
        } else {
          // Prüfe ob die Farbe aus RGBA kommt (könnte als HEX gespeichert worden sein)
          // Wenn ja, extrahiere Alpha, ansonsten verwende 1
          setTopBoxAlpha(1); // Header-Farbe ist gesetzt, standardmäßig sichtbar
        }
      } else {
        setTopBoxAlpha(0); // Default: 100% transparent
      }
    }
    setTopBoxImage(designSettings.topBoxImage || ''); // Header-Box-Bild aus Settings
    setLeftColumnImage(designSettings.leftColumnImage || ''); // Linke Spalte Bild aus Settings
    setNameTextColor(designSettings.nameTextColor || '#333333');
    setLeftColumnTextColor(designSettings.leftColumnTextColor || (isProfessional ? '#ffffff' : '#333333'));
    setRightColumnTextColor(designSettings.rightColumnTextColor || '#333333');
    setLeftColumnTitleColor(designSettings.leftColumnTitleColor || (isProfessional ? '#ffffff' : '#333333'));
    setRightColumnTitleColor(designSettings.rightColumnTitleColor || '#333333');
    
    // Temporäre Farben auch setzen
    setTempNameTextColor(designSettings.nameTextColor || '#333333');
    setTempLeftColumnTextColor(designSettings.leftColumnTextColor || (isProfessional ? '#ffffff' : '#333333'));
    setTempRightColumnTextColor(designSettings.rightColumnTextColor || '#333333');
    setTempLeftColumnTitleColor(designSettings.leftColumnTitleColor || (isProfessional ? '#ffffff' : '#333333'));
    setTempRightColumnTitleColor(designSettings.rightColumnTitleColor || '#333333');
    // setTempLeftColumnColor entfernt - wird direkt über leftColumnColor gesteuert
    
    // Sichtbarkeits-Einstellungen anwenden
    if (typeof designSettings.showCoreCompetenciesInCv === 'boolean') setShowCoreCompetenciesInCv(designSettings.showCoreCompetenciesInCv);
    if (typeof designSettings.showCertificationsInCv === 'boolean') setShowCertificationsInCv(designSettings.showCertificationsInCv);
    if (typeof designSettings.showItSkillsInCv === 'boolean') setShowItSkillsInCv(designSettings.showItSkillsInCv);
    if (typeof designSettings.showIndustriesInCv === 'boolean') setShowIndustriesInCv(designSettings.showIndustriesInCv);
    if (typeof designSettings.showLanguagesInCv === 'boolean') setShowLanguagesInCv(designSettings.showLanguagesInCv);
    if (typeof designSettings.showHobbiesInCv === 'boolean') setShowHobbiesInCv(designSettings.showHobbiesInCv);
    if (typeof designSettings.showEducationInCv === 'boolean') setShowEducationInCv(designSettings.showEducationInCv);
    if (typeof designSettings.showWorkExperienceInCv === 'boolean') setShowWorkExperienceInCv(designSettings.showWorkExperienceInCv);
    if (typeof designSettings.showProfileInCv === 'boolean') setShowProfileInCv(designSettings.showProfileInCv);
    if (typeof designSettings.showAdditionalInfoInCv === 'boolean') setShowAdditionalInfoInCv(designSettings.showAdditionalInfoInCv);
    if (typeof designSettings.showProfileImageInCv === 'boolean') setShowProfileImageInCv(designSettings.showProfileImageInCv);
    setShowContactInCv(typeof designSettings.showContactInCv === 'boolean' ? designSettings.showContactInCv : true);
    setShowCompanyNamesInCv(typeof designSettings.showCompanyNamesInCv === 'boolean' ? designSettings.showCompanyNamesInCv : true);
    setShowIndustryInCv(typeof designSettings.showIndustryInCv === 'boolean' ? designSettings.showIndustryInCv : true);
    setShowDateInCv(typeof designSettings.showDateInCv === 'boolean' ? designSettings.showDateInCv : true);
    setShowProjectSearchInCv(typeof designSettings.showProjectSearchInCv === 'boolean' ? designSettings.showProjectSearchInCv : false);
    setShowBulletPointsInCv(typeof designSettings.showBulletPointsInCv === 'boolean' ? designSettings.showBulletPointsInCv : false);
    setShowAdditionalWorkExperienceInCv(typeof designSettings.showAdditionalWorkExperienceInCv === 'boolean' ? designSettings.showAdditionalWorkExperienceInCv : true);
    setShowPhotoInCv(typeof designSettings.showPhotoInCv === 'boolean' ? designSettings.showPhotoInCv : true);
    
    // Profilbild-Einstellungen anwenden (mit Template-spezifischen Defaults)
    setProfileImageBorderRadius(designSettings.profileImageBorderRadius !== undefined ? designSettings.profileImageBorderRadius : ((isProfessional || templateId === 'template3') ? 0 : 50));
    setProfileImageSize(designSettings.profileImageSize || 'M');
    setProfileImageWidth(designSettings.profileImageWidth || 100);
    setProfileImagePosition(designSettings.profileImagePosition || { x: 50, y: 50 });
    setProfileImageAlignment(designSettings.profileImageAlignment || (isProfessional ? 'left' : 'center'));
    if (typeof designSettings.profileImageBorder === 'boolean') setProfileImageBorder(designSettings.profileImageBorder);
    if (designSettings.profileImageBorderColor) setProfileImageBorderColor(designSettings.profileImageBorderColor);
    if (designSettings.profileImageBorderThickness) setProfileImageBorderThickness(designSettings.profileImageBorderThickness);
    
    // Namensgröße anwenden
    setNameFontSize(designSettings.nameFontSize || 36);
    
    // Schriftarten anwenden
    setTitleFont(designSettings.titleFont || '"Times New Roman", Times, serif');
    setBodyFont(designSettings.bodyFont || 'Arial, sans-serif');
    
    // Kontakt-Display-Mode anwenden
    setContactDisplayMode(designSettings.contactDisplayMode || 'text');
    
    // Tonalität anwenden
    if (designSettings.tonalitySettings) {
      setTonalitySettings({
        ...defaultTonalitySettings,
        ...designSettings.tonalitySettings
      });
    }
    if (designSettings.shortProfileTextLength) {
      setShortProfileTextLength(designSettings.shortProfileTextLength);
    }
    if (designSettings.workExperienceTextLength) {
      setWorkExperienceTextLength(designSettings.workExperienceTextLength);
    }
    setSortWorkExperienceByRelevance(
      typeof designSettings.sortWorkExperienceByRelevance === 'boolean'
        ? designSettings.sortWorkExperienceByRelevance
        : false
    );
    
    // Template-ID anwenden
    if (designSettings.selectedTemplate) {
      setSelectedTemplateId(designSettings.selectedTemplate);
      console.log('✅ Template-ID gesetzt:', designSettings.selectedTemplate);
    }
    
    console.log('✅ CV-Design-Einstellungen angewendet:', designSettings);
    console.log('✅ Angewendete Werte - selectedTemplateId wird sein:', designSettings.selectedTemplate || selectedTemplateId);
    console.log('✅ Angewendete Werte - leftColumnColor wird sein:', leftColumnColorValue);
    console.log('✅ Angewendete Werte - topBoxColor wird sein:', topBoxColorValue);
    console.log('✅ Angewendete Werte - nameTextColor wird sein:', designSettings.nameTextColor || '#333333');
  };

  // Funktion zum Sammeln aller aktuellen CV-Settings für das aktuelle Template
  const getCurrentCvSettings = (
    designSettingsOverrides: Partial<CvDesignSettings> = {},
    templateIdOverride?: 'template1' | 'template2' | 'template3'
  ): CvSettings => {
    const resolvedTemplateId = templateIdOverride || selectedTemplateId;
    const currentTemplateSettings: CvDesignSettings = {
      // Farben - konvertiere zu RGBA mit Alpha-Wert
      leftColumnColor: hexToRgba(leftColumnColor, leftColumnAlpha),
      nameTextColor,
      leftColumnTextColor,
      rightColumnTextColor,
      leftColumnTitleColor,
      rightColumnTitleColor,
      
      // Sichtbarkeits-Einstellungen
      showCoreCompetenciesInCv,
      showCertificationsInCv,
      showItSkillsInCv,
      showIndustriesInCv,
      showLanguagesInCv,
      showHobbiesInCv,
      showEducationInCv,
      showWorkExperienceInCv,
      showProfileInCv,
      showAdditionalInfoInCv,
      showProfileImageInCv,
      showContactInCv,
      showCompanyNamesInCv,
      showIndustryInCv,
      showDateInCv,
      showProjectSearchInCv,
      showBulletPointsInCv,
      showAdditionalWorkExperienceInCv,
      showPhotoInCv,
      
      // Profilbild-Einstellungen
      profileImageBorderRadius,
      profileImageSize,
      profileImageWidth,
      profileImagePosition,
      profileImageAlignment,
      profileImageBorder,
      profileImageBorderColor,
      profileImageBorderThickness,
      
      // Namensgröße
      nameFontSize,
      
      // Schriftarten
      titleFont,
      bodyFont,
      
      // Kontakt-Display-Mode
      contactDisplayMode,
      
      // Header-Box-Einstellungen - konvertiere zu RGBA mit Alpha-Wert
      topBoxColor: hexToRgba(topBoxColor, topBoxAlpha),
      topBoxAlpha: topBoxAlpha, // Speichere Alpha-Wert separat für korrektes Laden
      topBoxImage,
      topBoxHeightMode: 'nameBottom',
      
      // Linke Spalte Bild
      leftColumnImage,
      
      // Tonalität
      tonalitySettings: tonalitySettings as CvDesignSettings['tonalitySettings'],
      shortProfileTextLength,
      workExperienceTextLength,
      sortWorkExperienceByRelevance,
      
      // Template-Name
      templateName: resolvedTemplateId === 'template1' ? getTranslatedCvLabel('Modern') : 
                   resolvedTemplateId === 'template2' ? getTranslatedCvLabel('Professional') : getTranslatedCvLabel('Classic'),
      ...designSettingsOverrides
    };

    return {
      ...cvSettings,
      [resolvedTemplateId]: currentTemplateSettings,
      selectedTemplate: resolvedTemplateId,
      lastUpdated: new Date().toISOString(),
      version: '2.0.0'
    };
  };

  // Funktion zum Anwenden von CV-Settings für das aktuelle Template
  const applyCvSettings = (settings: CvSettings, preserveTemplate: boolean = false) => {
    // Markiere als Settings-Laden, damit das Save-Icon nicht aktiviert wird
    isLoadingSettingsRef.current = true;
    
    // Wenn preserveTemplate true ist, überschreibe KEINE Design-Einstellungen
    // Die Design-Einstellungen wurden bereits von applyCvDesignSettings gesetzt
    // und sollen erhalten bleiben. Nur die CV-Settings-Struktur wird aktualisiert.
    if (preserveTemplate) {
      console.log('ℹ️ preserveTemplate=true: Design-Einstellungen werden nicht überschrieben');
      // Aktualisiere nur die CV-Settings-Struktur, ohne Design-Einstellungen zu ändern
      setCvSettings(settings);
      return;
    }
    
    // Aktuelles Template aus den Settings laden
    const templateToUse = settings.selectedTemplate;
    const currentTemplate = settings[templateToUse];
    const isProfessional = templateToUse === 'template2';
    
    // Farben anwenden - konvertiere RGBA zurück zu HEX und extrahiere Alpha
    const leftColColor = currentTemplate.leftColumnColor || (isProfessional ? '#2e2e2e' : '#f8f6f2');
    if (leftColColor.startsWith('rgba')) {
      setLeftColumnColor(rgbaToHex(leftColColor));
      setLeftColumnAlpha(getAlphaFromRgba(leftColColor));
    } else {
      setLeftColumnColor(leftColColor);
      setLeftColumnAlpha(1);
    }
    
    // Header-Farbe setzen
    const topBoxCol = currentTemplate.topBoxColor || (isProfessional ? '#2e2e2e' : '#f8f6f2');
    if (topBoxCol.startsWith('rgba')) {
      setTopBoxColor(rgbaToHex(topBoxCol));
      // Verwende IMMER den separaten topBoxAlpha, falls vorhanden (genauer als aus RGBA-String)
      if (currentTemplate.topBoxAlpha !== undefined) {
        setTopBoxAlpha(currentTemplate.topBoxAlpha);
      } else {
        // Fallback: Extrahiere Alpha aus RGBA-String
        setTopBoxAlpha(getAlphaFromRgba(topBoxCol));
      }
    } else {
      setTopBoxColor(topBoxCol);
      // Gleiche Logik wie applyCvDesignSettings:
      // Ist eine Header-Farbe explizit gesetzt, ohne topBoxAlpha -> sichtbar (1),
      // ansonsten Default transparent (0).
      if (currentTemplate.topBoxColor) {
        if (currentTemplate.topBoxAlpha !== undefined) {
          setTopBoxAlpha(currentTemplate.topBoxAlpha);
        } else {
          setTopBoxAlpha(1);
        }
      } else {
        setTopBoxAlpha(0); // Default: 100% transparent
      }
    }
    
    // Header-Einstellungen setzen
    setTopBoxImage(currentTemplate.topBoxImage || ''); // Header-Box-Bild aus Settings
    setLeftColumnImage(currentTemplate.leftColumnImage || ''); // Linke Spalte Bild aus Settings
    // setTempLeftColumnColor entfernt - wird direkt über leftColumnColor gesteuert
    setNameTextColor(currentTemplate.nameTextColor || '#333333');
    setLeftColumnTextColor(currentTemplate.leftColumnTextColor || (isProfessional ? '#ffffff' : '#333333'));
    setRightColumnTextColor(currentTemplate.rightColumnTextColor || '#333333');
    setLeftColumnTitleColor(currentTemplate.leftColumnTitleColor || (isProfessional ? '#ffffff' : '#333333'));
    setRightColumnTitleColor(currentTemplate.rightColumnTitleColor || '#333333');
    setTempNameTextColor(currentTemplate.nameTextColor || '#333333');
    setTempLeftColumnTextColor(currentTemplate.leftColumnTextColor || (isProfessional ? '#ffffff' : '#333333'));
    setTempRightColumnTextColor(currentTemplate.rightColumnTextColor || '#333333');
    setTempLeftColumnTitleColor(currentTemplate.leftColumnTitleColor || (isProfessional ? '#ffffff' : '#333333'));
    setTempRightColumnTitleColor(currentTemplate.rightColumnTitleColor || '#333333');
    
    // Sichtbarkeits-Einstellungen anwenden
    setShowCoreCompetenciesInCv(typeof currentTemplate.showCoreCompetenciesInCv === 'boolean' ? currentTemplate.showCoreCompetenciesInCv : true);
    setShowCertificationsInCv(typeof currentTemplate.showCertificationsInCv === 'boolean' ? currentTemplate.showCertificationsInCv : true);
    setShowItSkillsInCv(typeof currentTemplate.showItSkillsInCv === 'boolean' ? currentTemplate.showItSkillsInCv : true);
    setShowIndustriesInCv(typeof currentTemplate.showIndustriesInCv === 'boolean' ? currentTemplate.showIndustriesInCv : true);
    setShowLanguagesInCv(typeof currentTemplate.showLanguagesInCv === 'boolean' ? currentTemplate.showLanguagesInCv : true);
    setShowHobbiesInCv(typeof currentTemplate.showHobbiesInCv === 'boolean' ? currentTemplate.showHobbiesInCv : true);
    setShowEducationInCv(typeof currentTemplate.showEducationInCv === 'boolean' ? currentTemplate.showEducationInCv : true);
    setShowWorkExperienceInCv(typeof currentTemplate.showWorkExperienceInCv === 'boolean' ? currentTemplate.showWorkExperienceInCv : true);
    setShowProfileInCv(typeof currentTemplate.showProfileInCv === 'boolean' ? currentTemplate.showProfileInCv : true);
    setShowAdditionalInfoInCv(typeof currentTemplate.showAdditionalInfoInCv === 'boolean' ? currentTemplate.showAdditionalInfoInCv : true);
    setShowProfileImageInCv(typeof currentTemplate.showProfileImageInCv === 'boolean' ? currentTemplate.showProfileImageInCv : true);
    setShowContactInCv(typeof currentTemplate.showContactInCv === 'boolean' ? currentTemplate.showContactInCv : true);
    setShowCompanyNamesInCv(typeof currentTemplate.showCompanyNamesInCv === 'boolean' ? currentTemplate.showCompanyNamesInCv : true);
    setShowIndustryInCv(typeof currentTemplate.showIndustryInCv === 'boolean' ? currentTemplate.showIndustryInCv : true);
    setShowDateInCv(typeof currentTemplate.showDateInCv === 'boolean' ? currentTemplate.showDateInCv : true);
    setShowProjectSearchInCv(typeof currentTemplate.showProjectSearchInCv === 'boolean' ? currentTemplate.showProjectSearchInCv : false);
    setShowBulletPointsInCv(typeof currentTemplate.showBulletPointsInCv === 'boolean' ? currentTemplate.showBulletPointsInCv : false);
    setShowAdditionalWorkExperienceInCv(typeof currentTemplate.showAdditionalWorkExperienceInCv === 'boolean' ? currentTemplate.showAdditionalWorkExperienceInCv : true);
    setShowPhotoInCv(typeof currentTemplate.showPhotoInCv === 'boolean' ? currentTemplate.showPhotoInCv : true);
    
    // Profilbild-Einstellungen anwenden
    setProfileImageBorderRadius(currentTemplate.profileImageBorderRadius !== undefined ? currentTemplate.profileImageBorderRadius : ((isProfessional || templateToUse === 'template3') ? 0 : 50));
    setProfileImageSize(currentTemplate.profileImageSize || 'M');
    setProfileImageWidth(currentTemplate.profileImageWidth || 100);
    setProfileImagePosition(currentTemplate.profileImagePosition || { x: 50, y: 50 });
    setProfileImageAlignment(currentTemplate.profileImageAlignment || (isProfessional ? 'left' : 'center'));
    setProfileImageBorder(typeof currentTemplate.profileImageBorder === 'boolean' ? currentTemplate.profileImageBorder : false);
    setProfileImageBorderColor(currentTemplate.profileImageBorderColor || '#333333');
    setProfileImageBorderThickness(currentTemplate.profileImageBorderThickness || 2);
    
    // Namensgröße anwenden
    setNameFontSize(currentTemplate.nameFontSize || 36);
    
    // Schriftarten anwenden
    setTitleFont(currentTemplate.titleFont || '"Times New Roman", Times, serif');
    setBodyFont(currentTemplate.bodyFont || 'Arial, sans-serif');
    
    // Kontakt-Display-Mode anwenden
    setContactDisplayMode(currentTemplate.contactDisplayMode || 'text');
    
    // Tonalität anwenden
    setTonalitySettings({
      ...defaultTonalitySettings,
      ...(currentTemplate.tonalitySettings || {})
    });
    setShortProfileTextLength(currentTemplate.shortProfileTextLength || 'S');
    setWorkExperienceTextLength(currentTemplate.workExperienceTextLength || 'S');
    setSortWorkExperienceByRelevance(
      typeof currentTemplate.sortWorkExperienceByRelevance === 'boolean'
        ? currentTemplate.sortWorkExperienceByRelevance
        : false
    );
    
    // Template-Settings und ausgewähltes Template aktualisieren
    setCvSettings(settings);
    setSelectedTemplateId(settings.selectedTemplate);
  };

  // Handler für das Öffnen des CV-Templates mit Auto-Load der Settings
  // Funktion zum Erstellen einer Bewerbung beim Öffnen der CV-Preview
  // Optional: designSettings können übergeben werden, um sicherzustellen, dass die korrekten Einstellungen verwendet werden
  const createApplicationFromCvPreview = async (designSettingsOverride?: any, collectedDataOverride?: any, forcedCvId?: string | null) => {
    if (!user) return null;
    
    try {
      console.log('📝 Erstelle neue Bewerbung beim Öffnen der CV-Preview...');
      const token = await user.getIdToken();

      // Stelle sicher, dass für die neu erstellte Bewerbung immer eine cvId vorhanden ist.
      // Ohne cvId können CV-spezifische Settings beim Reopen/Download nicht eindeutig zugeordnet werden.
      let cvIdForApplication = forcedCvId || selectedCvId;
      if (!cvIdForApplication) {
        setError('Kein CV-Daten-Set mit gültiger ID ausgewählt. Bewerbung kann nicht erstellt werden.');
        return null;
      }

      const snapshot = await resolveAndLoadCvSetOrThrow({
        cvId: cvIdForApplication,
        forceReload: hasCvDataChangedSinceLastMatch,
        maxAgeMs: 20000,
        label: currentCvName || 'CV'
      });
      cvIdForApplication = snapshot.cvId || cvIdForApplication;
      
      // Sammle alle CV-Preview-Daten (alle Daten, die in der CV-Preview angezeigt werden)
      // Übergebe die Design-Einstellungen direkt, damit sie verwendet werden, auch wenn State-Updates noch nicht verarbeitet wurden
      let cvPreviewData: any = getCvDataForTemplate(designSettingsOverride, snapshot.cvData);
      cvPreviewData.cvId = cvIdForApplication;
      
      // Falls collectedDataOverride übergeben wurde, verwende diese Daten direkt
      // Dies stellt sicher, dass die Daten verwendet werden, auch wenn sie noch nicht im State sind
      if (collectedDataOverride) {
        console.log('📥 Verwende gesammelte Daten direkt:', {
          hasOptimizedShortProfile: !!collectedDataOverride.optimizedShortProfile,
          hasOptimizedWorkExperiences: !!collectedDataOverride.optimizedWorkExperiences,
          hasRelevantEducations: !!collectedDataOverride.relevantEducations,
          hasRelevantCertifications: !!collectedDataOverride.relevantCertifications,
          hasRelevantCoreCompetencies: !!collectedDataOverride.relevantCoreCompetencies,
          hasRelevantLanguages: !!collectedDataOverride.relevantLanguages,
          hasRelevantIndustries: !!collectedDataOverride.relevantIndustries,
          hasRelevantItSkills: !!collectedDataOverride.relevantItSkills,
          hasRelevantHobbies: !!collectedDataOverride.relevantHobbies,
          hasRelevantAdditionalInfo: !!collectedDataOverride.relevantAdditionalInfo
        });
        
        // Überschreibe die Daten mit den gesammelten Daten
        if (collectedDataOverride.optimizedShortProfile !== undefined) {
          cvPreviewData.optimizedShortProfile = collectedDataOverride.optimizedShortProfile;
        }
        if (collectedDataOverride.optimizedWorkExperiences !== undefined) {
          cvPreviewData.optimizedWorkExperiences = collectedDataOverride.optimizedWorkExperiences;
          if (Array.isArray(collectedDataOverride.optimizedWorkExperiences)) {
            cvPreviewData.workExperience = collectedDataOverride.optimizedWorkExperiences.map((exp: any) => ({
              position: exp.position,
              company: exp.company,
              startDate: exp.startDate,
              endDate: exp.endDate,
              description: exp.description
            }));
          }
        }
        if (collectedDataOverride.relevantEducations) {
          cvPreviewData.relevantEducations = collectedDataOverride.relevantEducations;
        }
        if (collectedDataOverride.relevantCertifications) {
          cvPreviewData.relevantCertifications = collectedDataOverride.relevantCertifications;
        }
        if (collectedDataOverride.relevantCoreCompetencies) {
          cvPreviewData.relevantCoreCompetencies = collectedDataOverride.relevantCoreCompetencies;
        }
        if (collectedDataOverride.relevantLanguages) {
          cvPreviewData.relevantLanguages = collectedDataOverride.relevantLanguages;
        }
        if (collectedDataOverride.relevantIndustries) {
          cvPreviewData.relevantIndustries = collectedDataOverride.relevantIndustries;
        }
        if (collectedDataOverride.relevantItSkills) {
          cvPreviewData.relevantItSkills = collectedDataOverride.relevantItSkills;
        }
        if (collectedDataOverride.relevantHobbies) {
          cvPreviewData.relevantHobbies = collectedDataOverride.relevantHobbies;
        }
        if (collectedDataOverride.relevantAdditionalInfo) {
          cvPreviewData.relevantAdditionalInfo = collectedDataOverride.relevantAdditionalInfo;
        }
      }
      
      // Debug: Zeige alle CV-Preview-Daten, die gespeichert werden
      console.log('💾 CV-Preview-Daten die gespeichert werden:', {
        hasPersonalInfo: !!cvPreviewData.personalInfo,
        hasDesignSettings: !!cvPreviewData.designSettings,
        hasOptimizedShortProfile: !!cvPreviewData.optimizedShortProfile,
        optimizedShortProfileLength: cvPreviewData.optimizedShortProfile ? cvPreviewData.optimizedShortProfile.length : 0,
        hasOptimizedWorkExperiences: !!cvPreviewData.optimizedWorkExperiences,
        optimizedWorkExperiencesLength: cvPreviewData.optimizedWorkExperiences ? cvPreviewData.optimizedWorkExperiences.length : 0,
        hasRelevantItSkills: !!cvPreviewData.relevantItSkills,
        relevantItSkillsLength: cvPreviewData.relevantItSkills ? cvPreviewData.relevantItSkills.length : 0,
        hasRelevantLanguages: !!cvPreviewData.relevantLanguages,
        hasRelevantEducations: !!cvPreviewData.relevantEducations,
        allKeys: Object.keys(cvPreviewData)
      });
      console.log('💾 Optimiertes Kurzprofil:', cvPreviewData.optimizedShortProfile ? cvPreviewData.optimizedShortProfile.substring(0, 100) + '...' : 'KEIN');
      console.log('💾 Optimierte Arbeitserfahrungen:', cvPreviewData.optimizedWorkExperiences ? cvPreviewData.optimizedWorkExperiences.length + ' Erfahrungen' : 'KEINE');
      console.log('💾 Design-Settings die in Application gespeichert werden:', cvPreviewData.designSettings);
      console.log('💾 Design-Settings Keys:', cvPreviewData.designSettings ? Object.keys(cvPreviewData.designSettings) : 'keine');
      
      const response = await fetch(`${config.backend.baseUrl}/api/create-application-from-cv`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          cvName: snapshot.cvData?.fullName || snapshot.cvData?.personalInfo?.fullName || fullName || 'CV',
          cvId: cvIdForApplication,
          jobInfo: extractedJobInfo || null,
          jobDescription: jobDescription || '',
          matchScore: matchScore || null,
          missingSkills: missingSkills || [],
          weaknesses: weaknesses || [],
          jobUrl: jobUrl || null,
          cvPreviewData: cvPreviewData // Alle CV-Preview-Daten mit speichern
        })
      });

      if (response.ok) {
        const result = await response.json();
        const applicationId = result.applicationId;
        setSelectedApplicationId(applicationId);
        setSelectedApplication(null); // Reset: Verhindere, dass alte Bewerbung überschrieben wird
        console.log('✅ Neue Bewerbung erstellt beim Öffnen der CV-Preview:', applicationId);
        console.log('📊 Backend Response:', result);
        
        // Aktualisiere die Anwendungsliste
        const token2 = await user.getIdToken();
        const verifyResponse = await fetch(`${config.backend.baseUrl}/api/get-job-descriptions`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token2}`,
            'Content-Type': 'application/json'
          }
        });
        
        if (verifyResponse.ok) {
          const data = await verifyResponse.json();
          setApplications(data.applications || []);
        }
        
        return applicationId;
      } else {
        const errorText = await response.text();
        console.error('❌ Fehler beim Erstellen der Bewerbung:', response.status, errorText);
        return null;
      }
    } catch (error) {
      console.error('❌ Fehler beim Erstellen der Bewerbung:', error);
      return null;
    }
  };

  const createApplicationFromCvPreviewWithLock = async (
    designSettingsOverride?: any,
    collectedDataOverride?: any,
    forcedCvId?: string | null
  ): Promise<string> => {
    if (!matchApplicationCreationPromiseRef.current) {
      const createPromise = (async () => {
        const createdId = await createApplicationFromCvPreview(
          designSettingsOverride,
          collectedDataOverride,
          forcedCvId
        );
        if (!createdId) {
          throw new Error('Bewerbung konnte nicht erstellt werden.');
        }
        return createdId;
      })();
      matchApplicationCreationPromiseRef.current = createPromise;
      createPromise.finally(() => {
        if (matchApplicationCreationPromiseRef.current === createPromise) {
          matchApplicationCreationPromiseRef.current = null;
        }
      });
    }
    return await matchApplicationCreationPromiseRef.current;
  };

  // Gemeinsame Funktion zum Laden der Design-Einstellungen aus Firebase
  // Gibt die geladenen Design-Einstellungen zurück, damit sie direkt verwendet werden können
  const loadCvDesignSettingsForPreview = async (): Promise<any | null> => {
    // Lade CV-Design-Settings aus Firebase (inkl. zuletzt verwendetem Template, Header-Farbe, Grafiken, etc.)
    if (!user) return null;
    
    try {
      const idToken = await user.getIdToken();
      const accountSettings = await loadAccountCvSettingsFromBackend(idToken);
      if (accountSettings) {
        applyCvSettings(accountSettings);
        setCvSettings(accountSettings);

        const templateId: 'template1' | 'template2' | 'template3' =
          accountSettings.selectedTemplate === 'template2' || accountSettings.selectedTemplate === 'template3'
            ? accountSettings.selectedTemplate
            : 'template1';
        setSelectedTemplateId(templateId);

        // Für Preview-Aufrufe wird weiterhin ein flaches Design-Objekt des aktiven Templates zurückgegeben.
        return {
          ...accountSettings[templateId],
          selectedTemplate: templateId,
          selectedTemplateId: templateId
        };
      } else {
        console.log('ℹ️ Keine CV-Design-Einstellungen gefunden');
        return null;
      }
    } catch (error) {
      console.error('❌ Fehler beim Laden der CV-Design-Einstellungen:', error);
      return null;
    }
  };

  const triggerTemplateReflowAfterApplicationPreviewOpen = () => {
    // Wenn die Preview aus dem Bewerbungs-Modal geöffnet wird, bleibt das Modal offen.
    // Dadurch fehlt oft der sonst übliche Reflow-Trigger durch "modalClosed".
    // Zwei gestaffelte Reflows stabilisieren die Seitenumbrüche nach dem Mount.
    window.setTimeout(() => {
      window.dispatchEvent(new CustomEvent('refreshTemplate'));
    }, 180);
    window.setTimeout(() => {
      window.dispatchEvent(new CustomEvent('templateReflow'));
    }, 420);
    // Dritter Pass für späte Layout-Änderungen (z. B. nach Font-/Bild-Finalisierung).
    window.setTimeout(() => {
      window.dispatchEvent(new CustomEvent('templateReflow'));
    }, 760);
  };

  // Funktion zum Laden der CV-Daten aus einer Application und Öffnen des CV-Preview Modals
  const handleOpenCvPreviewFromApplication = async (
    applicationId: string,
    showLoadingIndicator: boolean = true,
    rowEntry?: any
  ) => {
    if (!user || !applicationId) return;

    // Neue Preview-Anfrage: ältere Anfrage abbrechen und nur die letzte Antwort anwenden.
    const previewRequestId = cvPreviewRequestIdRef.current + 1;
    cvPreviewRequestIdRef.current = previewRequestId;
    cvPreviewAbortControllerRef.current?.abort();
    const previewAbortController = new AbortController();
    cvPreviewAbortControllerRef.current = previewAbortController;
    const isLatestPreviewRequest = () =>
      cvPreviewRequestIdRef.current === previewRequestId &&
      cvPreviewAbortControllerRef.current === previewAbortController &&
      !previewAbortController.signal.aborted;
    
    // Modal bleibt offen - Warte-Animation wird im Modal angezeigt
    // setShowApplicationDetailsModal(false); // ENTFERNT: Modal soll offen bleiben
    
    // Starte Warte-Animation nur wenn gewuenscht (z.B. aus dem Bewerbungs-Modal optional ohne Spinner)
    if (showLoadingIndicator) {
      setLoadingCvPreview(true);
    }
    
    try {
      // Lade CV-Preview-Daten aus der Application
      const idToken = await user.getIdToken();
      const rowPayload = buildCvMatchRowPayload(rowEntry);
      const query = new URLSearchParams();
      if (rowPayload.cvId) query.set('cvId', rowPayload.cvId);
      if (rowPayload.cvSetRef) query.set('cvSetRef', rowPayload.cvSetRef);
      if (rowPayload.cvName) query.set('cvName', rowPayload.cvName);
      const querySuffix = query.toString() ? `?${query.toString()}` : '';

      const response = await fetch(`${config.backend.baseUrl}/api/get-application-cv-preview-data/${applicationId}${querySuffix}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${idToken}`,
          'Content-Type': 'application/json'
        },
        signal: previewAbortController.signal
      });
      if (!isLatestPreviewRequest()) return;
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        if (response.status === 404 && hasOptimizedCvData()) {
          // Fallback nach CV-Optimierung: Bewerbung noch nicht auffindbar, aber Daten sind im State
          console.warn('⚠️ Bewerbung noch nicht gefunden (404), öffne CV-Preview aus aktuellem State');
          activeProcessCvSnapshotRef.current = null;
          if (rowPayload.cvId || rowPayload.cvSetRef || rowPayload.cvName) {
            activeCvPreviewRowContextRef.current = { applicationId, rowEntry: rowEntry || rowPayload };
          } else {
            activeCvPreviewRowContextRef.current = null;
          }
          setSelectedApplicationId(null);
          setShowTemplatePreviewDialog(true);
          triggerTemplateReflowAfterApplicationPreviewOpen();
          setShowCvOptimierenButton(false);
          if (showLoadingIndicator) {
            setLoadingCvPreview(false);
          }
          return;
        }
        console.error('❌ Fehler beim Laden der CV-Daten:', errorData);
        setError('Fehler beim Laden der CV-Daten: ' + (errorData.error || 'Unbekannter Fehler'));
        return;
      }
      
      const data = await response.json();
      if (!isLatestPreviewRequest()) return;
      const cvPreviewData = data.cvPreviewData;
      const responseCvId = data.cvId || null;
      
      console.log('📥 CV-Preview-Daten aus Application geladen:', {
        hasCvPreviewData: !!cvPreviewData,
        hasOptimizedShortProfile: !!cvPreviewData?.optimizedShortProfile,
        optimizedShortProfileLength: cvPreviewData?.optimizedShortProfile?.length || 0,
        hasPersonalInfo: !!cvPreviewData?.personalInfo,
        hasOptimizedWorkExperiences: !!cvPreviewData?.optimizedWorkExperiences,
        optimizedWorkExperiencesLength: cvPreviewData?.optimizedWorkExperiences?.length || 0,
        allKeys: cvPreviewData ? Object.keys(cvPreviewData) : []
      });
      
      if (!cvPreviewData) {
        setError('Keine CV-Daten in der Bewerbung gefunden');
        return;
      }
      
      const applicationMeta = applications.find((app: any) => app.id === applicationId);
      const selectedApplicationCvId =
        selectedApplication && selectedApplication.id === applicationId
          ? selectedApplication.cvId
          : null;
      const cvIdFromApplication =
        responseCvId ||
        applicationMeta?.cvId ||
        selectedApplicationCvId ||
        cvPreviewData?.cvId ||
        null;
      // Setze selectedApplicationId
      setSelectedApplicationId(applicationId);
      if (cvIdFromApplication) {
        setSelectedCvId(cvIdFromApplication);
        localStorage.setItem('selectedCvId', cvIdFromApplication);
      }
      
      // Lade CV-Daten in State-Variablen
      // WICHTIG: optimizedShortProfile hat Priorität über personalInfo.shortProfile (für Share-Link-Änderungen)
      const pi = cvPreviewData?.personalInfo && typeof cvPreviewData.personalInfo === 'object'
        ? cvPreviewData.personalInfo
        : {};
      const nextOptimizedShortProfile =
        cvPreviewData.optimizedShortProfile !== undefined
          ? cvPreviewData.optimizedShortProfile
          : (pi.shortProfile !== undefined ? pi.shortProfile : '');
      setOptimizedShortProfile(nextOptimizedShortProfile || '');

      // Persönliche/contact Felder immer explizit setzen, damit keine stale Werte stehen bleiben.
      const nextFullName = pi.fullName || '';
      setOptimizedFullName(nextFullName);
      setFullName(nextFullName);
      setOptimizedEmail(pi.email || '');
      setOptimizedPhoneNumber(pi.phoneNumber || '');
      setOptimizedAddress(pi.address || '');
      setOptimizedPostalCode(pi.postalCode || '');
      setOptimizedCity(pi.city || '');
      setBirthYear(pi.birthYear || '');
      setNationality(pi.nationality || '');
      setResidencePermit(pi.residencePermit || '');
      setCivilStatus(pi.civilStatus || pi.maritalStatus || '');
      setAvailableFrom(pi.availableFrom || '');
      
      // Lade IT-Skills (mit Level-Mapping auf Select-Werte)
      if (cvPreviewData.relevantItSkills && Array.isArray(cvPreviewData.relevantItSkills)) {
        setRelevantItSkills(cvPreviewData.relevantItSkills.map((skill: any) => ({
          ...skill,
          level: mapItSkillLevelToSelectValue(skill.level || skill.proficiency || '')
        })));
      } else if (cvPreviewData.itSkills && Array.isArray(cvPreviewData.itSkills)) {
        setRelevantItSkills(cvPreviewData.itSkills.map((skill: any) => ({
          ...skill,
          level: mapItSkillLevelToSelectValue(skill.level || skill.proficiency || '')
        })));
      } else {
        setRelevantItSkills([]);
      }
      
      // Lade Berufserfahrungen
      if (cvPreviewData.optimizedWorkExperiences && Array.isArray(cvPreviewData.optimizedWorkExperiences)) {
        const hasExplicitRelevantFlags = cvPreviewData.optimizedWorkExperiences.some((exp: any) =>
          exp?.relevant === true ||
          exp?.relevant === false ||
          exp?.relevant === 'true' ||
          exp?.relevant === 'false'
        );
        const workExperiencesForPreview = hasExplicitRelevantFlags
          ? normalizeWorkExperienceRelevanceFlags(cvPreviewData.optimizedWorkExperiences)
          : applyTopRelevantWorkExperiences(cvPreviewData.optimizedWorkExperiences, 6);
        const normalizedOptimizedWorkExperiences = applySwissGermanToWorkExperiences(workExperiencesForPreview);
        // Setze optimizedWorkExperiences (wird vom Template verwendet)
        setOptimizedWorkExperiences(normalizedOptimizedWorkExperiences);
        // Filtere relevante Berufserfahrungen (relevant: true)
        const relevant = normalizedOptimizedWorkExperiences.filter((exp: any) => 
          exp.relevant === true || exp.relevant === 'true'
        );
        setRelevantWorkExperiences(relevant.length > 0 ? relevant : normalizedOptimizedWorkExperiences);
      } else if (cvPreviewData.workExperience && Array.isArray(cvPreviewData.workExperience)) {
        // Wenn keine optimizedWorkExperiences, verwende workExperience
        setRelevantWorkExperiences(applySwissGermanToWorkExperiences(cvPreviewData.workExperience));
        // Setze auch optimizedWorkExperiences auf workExperience (mit relevant: true)
        const withRelevant = cvPreviewData.workExperience.map((exp: any) => ({
          ...exp,
          relevant: true
        }));
        setOptimizedWorkExperiences(applySwissGermanToWorkExperiences(withRelevant));
      } else {
        setRelevantWorkExperiences([]);
        setOptimizedWorkExperiences([]);
      }
      
      // Lade Ausbildungen
      if (cvPreviewData.relevantEducations && Array.isArray(cvPreviewData.relevantEducations)) {
        setRelevantEducations(cvPreviewData.relevantEducations);
      } else if (cvPreviewData.educations && Array.isArray(cvPreviewData.educations)) {
        setRelevantEducations(cvPreviewData.educations);
      } else {
        setRelevantEducations([]);
      }
      
      // Lade Zertifizierungen
      // WICHTIG: relevantCertifications hat Priorität (für Share-Link-Änderungen)
      if (cvPreviewData.relevantCertifications && Array.isArray(cvPreviewData.relevantCertifications)) {
        setRelevantCertifications(cvPreviewData.relevantCertifications);
      } else if (cvPreviewData.certifications && Array.isArray(cvPreviewData.certifications)) {
        setRelevantCertifications(cvPreviewData.certifications);
      } else {
        setRelevantCertifications([]);
      }
      
      // Lade Sprachen (mit Level-Mapping auf CEFR-Werte)
      if (cvPreviewData.relevantLanguages && Array.isArray(cvPreviewData.relevantLanguages)) {
        setRelevantLanguages(cvPreviewData.relevantLanguages.map((lang: any) => ({
          ...lang,
          level: mapLanguageLevelToSelectValue(lang.level || lang.proficiency || '')
        })));
      } else if (cvPreviewData.languages && Array.isArray(cvPreviewData.languages)) {
        setRelevantLanguages(cvPreviewData.languages.map((lang: any) => ({
          ...lang,
          level: mapLanguageLevelToSelectValue(lang.level || lang.proficiency || '')
        })));
      } else {
        setRelevantLanguages([]);
      }
      
      // Lade Kernkompetenzen
      // WICHTIG: relevantCoreCompetencies hat Priorität (für Share-Link-Änderungen)
      if (cvPreviewData.relevantCoreCompetencies && Array.isArray(cvPreviewData.relevantCoreCompetencies)) {
        setRelevantCoreCompetencies(cvPreviewData.relevantCoreCompetencies);
      } else if (cvPreviewData.coreCompetencies && Array.isArray(cvPreviewData.coreCompetencies)) {
        setRelevantCoreCompetencies(cvPreviewData.coreCompetencies);
      } else {
        setRelevantCoreCompetencies([]);
      }
      
      // Lade Branchen
      if (cvPreviewData.relevantIndustries && Array.isArray(cvPreviewData.relevantIndustries)) {
        setRelevantIndustries(cvPreviewData.relevantIndustries);
      } else if (cvPreviewData.industryExperiences && Array.isArray(cvPreviewData.industryExperiences)) {
        setRelevantIndustries(cvPreviewData.industryExperiences);
      } else {
        setRelevantIndustries([]);
      }
      
      // Lade Hobbys
      if (cvPreviewData.relevantHobbies && Array.isArray(cvPreviewData.relevantHobbies)) {
        setRelevantHobbies(normalizeHobbyList(cvPreviewData.relevantHobbies));
      } else if (cvPreviewData.hobbies && Array.isArray(cvPreviewData.hobbies)) {
        setRelevantHobbies(normalizeHobbyList(cvPreviewData.hobbies));
      } else {
        setRelevantHobbies([]);
      }
      
      // Lade weitere Informationen
      if (cvPreviewData.relevantAdditionalInfo && Array.isArray(cvPreviewData.relevantAdditionalInfo)) {
        setRelevantAdditionalInfo(cvPreviewData.relevantAdditionalInfo);
      } else if (cvPreviewData.additionalInfo && Array.isArray(cvPreviewData.additionalInfo)) {
        setRelevantAdditionalInfo(cvPreviewData.additionalInfo);
      } else {
        setRelevantAdditionalInfo([]);
      }
      
      // Lade Profilbild und Signatur
      if (cvPreviewData.profileImage !== undefined) {
        const normalizedProfileImage = normalizeProfileImageValue(cvPreviewData.profileImage);
        setProfileImage(normalizedProfileImage || null);
      } else {
        setProfileImage(null);
      }
      setSignature(cvPreviewData.signature || null);
      
      if (cvPreviewData?.designSettings) {
        // Bei Öffnen aus Bewerbung haben bewerbungsspezifische Design-/Sichtbarkeitswerte Priorität.
        applyCvDesignSettings(cvPreviewData.designSettings);
        console.log('✅ Bewerbungsspezifische Design-Einstellungen angewendet');
      } else if (cvIdFromApplication) {
        // Fallback: CV-spezifische Settings über CV-ID laden.
        await loadAndApplyCvSettingsForCv(cvIdFromApplication);
        if (!isLatestPreviewRequest()) return;
      } else {
        // Letzter Fallback ohne cvId/designSettings.
        console.warn('⚠️ Keine cvId/designSettings für Bewerbung auflösbar - verwende CV-Default-Settings');
        applyCvSettings(buildDefaultCvLevelSettings());
      }
      
      // Lade Abschnittstitel aus cvPreviewData (damit bearbeitete Titel erhalten bleiben)
      if (cvPreviewData.sectionTitles) {
        const st = cvPreviewData.sectionTitles;
        if (st.coreCompetencies) setCurrentCoreCompetenciesTitle(st.coreCompetencies);
        if (st.certifications) setCurrentCertificationsTitle(st.certifications);
        if (st.itSkills) setCurrentItSkillsTitle(st.itSkills);
        if (st.industries) setCurrentIndustriesTitle(st.industries);
        if (st.languages) setCurrentLanguagesTitle(st.languages);
        if (st.hobbies) setCurrentHobbiesTitle(st.hobbies);
        if (st.additionalInfo) setCurrentAdditionalInfoTitle(st.additionalInfo);
        if (st.education) setCurrentEducationTitle(st.education);
        if (st.workExperience) setCurrentWorkExperienceTitle(st.workExperience);
        if (st.profile) setCurrentProfileTitle(st.profile);
      } else {
        setCurrentCoreCompetenciesTitle('Kernkompetenzen');
        setCurrentCertificationsTitle('Zertifizierungen');
        setCurrentItSkillsTitle('Informatik');
        setCurrentIndustriesTitle('Branchen');
        setCurrentLanguagesTitle('Sprachen');
        setCurrentHobbiesTitle('Hobbies');
        setCurrentAdditionalInfoTitle('Weitere Angaben');
        setCurrentEducationTitle('Ausbildung');
        setCurrentWorkExperienceTitle('Beruflicher Werdegang');
        setCurrentProfileTitle('Profil');
      }
      
      // Öffne CV-Preview Modal direkt (ohne Warnung)
      if (!isLatestPreviewRequest()) return;
      activeProcessCvSnapshotRef.current = {
        ...cvPreviewData,
        cvId: cvIdFromApplication || cvPreviewData?.cvId || undefined,
        cvSetRef: rowPayload.cvSetRef || cvPreviewData?.cvSetRef || undefined
      };
      if (rowPayload.cvId || rowPayload.cvSetRef || rowPayload.cvName) {
        activeCvPreviewRowContextRef.current = { applicationId, rowEntry: rowEntry || rowPayload };
      } else {
        activeCvPreviewRowContextRef.current = null;
      }
      setShowTemplatePreviewDialog(true);
      triggerTemplateReflowAfterApplicationPreviewOpen();
      setShowCvOptimierenButton(false);
      // NICHT hier setzen - wird erst beim Schließen der Preview gesetzt
      // setCvTemplateHasBeenOpened(true);
      
      // Modal bleibt offen - wird nicht geschlossen
      // setShowApplicationDetailsModal(false); // ENTFERNT: Modal soll offen bleiben
      
      console.log('✅ CV-Daten aus Application geladen und Preview geöffnet');
      
    } catch (error) {
      if (previewAbortController.signal.aborted || (error as any)?.name === 'AbortError') {
        console.log('ℹ️ Preview-Ladevorgang abgebrochen:', applicationId);
        return;
      }
      console.error('❌ Fehler beim Laden der CV-Daten aus Application:', error);
      setError('Fehler beim Laden der CV-Daten: ' + (error instanceof Error ? error.message : 'Unbekannter Fehler'));
    } finally {
      // Stoppe Warte-Animation
      if (showLoadingIndicator && isLatestPreviewRequest()) {
        setLoadingCvPreview(false);
      }
    }
  };

  // Wartet, bis optimierte CV-Daten im State verfügbar sind
  const waitForOptimizedCvData = async (maxWaitTime = 10000, checkInterval = 200) => {
    const startTime = Date.now();
    
    while (Date.now() - startTime < maxWaitTime) {
      if (hasOptimizedCvData()) {
        console.log('✅ Optimierte CV-Daten sind verfügbar');
        return true;
      }
      
      // Warte auf State-Updates
      await new Promise(resolve => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            setTimeout(resolve, checkInterval);
          });
        });
      });
    }
    
    console.warn('⚠️ Timeout: Optimierte CV-Daten wurden nicht innerhalb von', maxWaitTime, 'ms gefunden');
    return false;
  };

  const handleOpenCvTemplate = async (forceCreateNewAfterOptimization?: boolean, skipApplicationCreation: boolean = false) => {
    try {
      if (!skipApplicationCreation) {
        activeProcessCvSnapshotRef.current = null;
      }
      // Zeige Warnungs-Dialog vor dem Öffnen des Templates nur wenn nicht deaktiviert
      // und nicht explizit für den CV-Icon-Flow übersprungen.
      // WICHTIG: Auch im reinen Optimierungsflow (skipApplicationCreation=true) soll
      // der Warnhinweis beim ersten Öffnen erscheinen.
      if (!dontShowTemplateWarning && !skipTemplateWarningForIconFlowRef.current) {
        setShowCvTemplateWarningDialog(true);
      } else {
        if (skipApplicationCreation) {
          // Bei reiner CV-Optimierung keine Bewerbung anlegen, nur Preview öffnen.
          activeCvPreviewRowContextRef.current = null;
          setShowTemplatePreviewDialog(true);
          setShowCvOptimierenButton(false);
          setLoadingCvPreview(false);
          return;
        }

        // Verwende den exakten Prozess wie beim Modal "Bewerbungen"
        // Die Daten werden direkt aus dem State gelesen (wurden bereits gesetzt)
        // Falls die Daten noch nicht im State sind, werden sie beim Erstellen der Application aus dem State gelesen
        // und dann aus der Application geladen (wie beim Modal)
        
        // 1. Priorität: CV-spezifische Settings. Account-Design nur als Fallback ohne cvId.
        let designSettingsForApplication: any | undefined;
        if (selectedCvId) {
          await loadAndApplyCvSettingsForCv(selectedCvId);
        } else {
          const loadedDesignSettings = await loadCvDesignSettingsForPreview();
          const normalizedDesignSettings = loadedDesignSettings || getCurrentCvDesignSettings();
          if (normalizedDesignSettings) {
            applyCvDesignSettings(normalizedDesignSettings);
            designSettingsForApplication = normalizedDesignSettings;
          }
        }
        
        // 2. Prüfe ob bereits eine Bewerbung existiert (zweiter Klick)
        // Nach CV-Optimierung immer neue Bewerbung erstellen, damit keine veraltete/falsche ID verwendet wird
        let applicationId = forceCreateNewAfterOptimization ? null : selectedApplicationId;
        if (applicationId) {
          const existingApplication = applications.find((app: any) => app.id === applicationId);
          const isValidForCurrentCv = selectedCvId
            ? !!existingApplication?.cvId && existingApplication.cvId === selectedCvId
            : !!existingApplication;
          if (!isValidForCurrentCv) {
            console.warn('⚠️ Verwerfe veraltete selectedApplicationId beim Öffnen der Preview:', {
              applicationId,
              selectedCvId,
              applicationCvId: existingApplication?.cvId || null
            });
            applicationId = null;
            setSelectedApplicationId(null);
          }
        }
        
        // 3. Nur wenn keine Bewerbung existiert, erstelle eine neue (erster Klick)
        if (!applicationId) {
          // Hole die gesammelten Daten aus handleOptimizeCvParallel
          // Diese wurden direkt aus den API-Responses gesammelt und sind sofort verfügbar
          const collectedData = (window as any).collectedCvData || {};
          console.log('📥 Verwende gesammelte Daten für Application:', {
            hasOptimizedShortProfile: !!collectedData.optimizedShortProfile,
            hasOptimizedWorkExperiences: !!collectedData.optimizedWorkExperiences,
            hasRelevantEducations: !!collectedData.relevantEducations,
            hasRelevantCertifications: !!collectedData.relevantCertifications,
            hasRelevantCoreCompetencies: !!collectedData.relevantCoreCompetencies,
            hasRelevantLanguages: !!collectedData.relevantLanguages,
            hasRelevantIndustries: !!collectedData.relevantIndustries,
            hasRelevantItSkills: !!collectedData.relevantItSkills,
            hasRelevantHobbies: !!collectedData.relevantHobbies,
            hasRelevantAdditionalInfo: !!collectedData.relevantAdditionalInfo
          });
          
          // Erstelle automatisch eine Bewerbung
          // Die gesammelten Daten werden direkt verwendet, auch wenn sie noch nicht im State sind
          applicationId = await createApplicationFromCvPreviewWithLock(designSettingsForApplication, collectedData);
          
          if (!applicationId) {
            throw new Error('Fehler beim Erstellen der Application');
          }
          
          // Warte kurz, damit die Daten gespeichert werden
          await new Promise(resolve => setTimeout(resolve, 500));
        } else {
          console.log('✅ Verwende bestehende Bewerbung:', applicationId);
        }
        
        // 4. Vor dem Öffnen der Preview immer den korrekten CV-Datensatz neu laden,
        // damit globale CV-States (z.B. Berufserfahrung) nicht zwischen CV-Sets vermischt werden.
        const targetCvIdForPreview =
          applications.find((app: any) => app.id === applicationId)?.cvId ||
          selectedCvId ||
          null;
        if (targetCvIdForPreview) {
          await handleSelectCv(targetCvIdForPreview, false, false);
        }

        // 5. Verwende die exakte Funktion vom Modal, um die Preview zu öffnen
        // Dies lädt die Daten aus der Application und öffnet die Preview
        // Die Daten werden aus der Application geladen, auch wenn sie noch nicht im State sind
        await handleOpenCvPreviewFromApplication(applicationId);
      }
    } catch (error) {
      console.error('❌ Fehler in handleOpenCvTemplate:', error);
      setError('Fehler beim Öffnen der CV-Preview: ' + (error instanceof Error ? error.message : 'Unbekannter Fehler'));
      setLoadingCvPreview(false);
    }
  };

  // Handler für Reset Design
  const handleResetDesign = async () => {
    // Stelle den Template-Namen basierend auf selectedTemplateId fest
    const templateName = selectedTemplateId === 'template1' ? 'Modern' : 
                        selectedTemplateId === 'template2' ? 'Professional' : 'Minimal';
    
    // Hole die Standardwerte für das aktuelle Template
    const defaultTemplateSettings = defaultCvSettings[selectedTemplateId];
    
    // Wende die Standardwerte des aktuellen Templates an
    applyCvDesignSettings({
      ...defaultTemplateSettings,
      selectedTemplate: selectedTemplateId
    });
    
    // Kein automatisches Persistieren: Speichern erfolgt ausschließlich über das Save-Icon.
    setHasUnsavedCvSettings(true);
    console.log('✅ CV-Design-Einstellungen lokal auf Standardwerte gesetzt für Template:', templateName);
    
    // Schließe das Menü
    handleCvSettingsMenuClose();
  };

  // Handler für Template-Wechsel
  const handleTemplateChange = async (templateId: 'template1' | 'template2' | 'template3') => {
    // KEINE Speicherung beim Tab-Wechsel - Speicherung erfolgt nur beim Schließen der Preview
    
    // Markiere als Settings-Laden, damit das Save-Icon nicht aktiviert wird
    isLoadingSettingsRef.current = true;
    
    // Wechsle zum neuen Template
    setSelectedTemplateId(templateId);
    
    // Lade Settings für das neue Template (pro ausgewähltem CV)
    if (selectedCvId) {
      try {
        const savedSettings = await loadCvSettings(selectedCvId);
        if (!savedSettings) {
          const fallbackSettings = getCurrentCvSettings();
          const newSettings = {
            ...fallbackSettings,
            selectedTemplate: templateId
          };
          applyCvSettings(newSettings);
          return;
        }
        const newSettings = {
          ...savedSettings,
          selectedTemplate: templateId
        };
        applyCvSettings(newSettings);
        
      } catch (error) {
        console.error('Fehler beim Laden der Template-Settings:', error);
        // Bei Fehler Standardwerte für das neue Template verwenden
        const newSettings = {
          ...defaultCvSettings,
          selectedTemplate: templateId
        };
        applyCvSettings(newSettings);
      }
    } else {
      // Wenn kein User eingeloggt ist, Standardwerte für das neue Template verwenden
      const newSettings = {
        ...defaultCvSettings,
        selectedTemplate: templateId
      };
      applyCvSettings(newSettings);
    }
  };

  const handleOpenTextColorPalette = () => {
    setTempNameTextColor(nameTextColor);
    setTempLeftColumnTextColor(leftColumnTextColor);
    setTempRightColumnTextColor(rightColumnTextColor);
    setTempLeftColumnTitleColor(leftColumnTitleColor);
    setTempRightColumnTitleColor(rightColumnTitleColor);
    setShowTextColorPalette(true);
  };

  const handleCloseTextColorPalette = () => {
    setNameTextColor(tempNameTextColor);
    setLeftColumnTextColor(tempLeftColumnTextColor);
    setRightColumnTextColor(tempRightColumnTextColor);
    setLeftColumnTitleColor(tempLeftColumnTitleColor);
    setRightColumnTitleColor(tempRightColumnTitleColor);
    setShowTextColorPalette(false);
  };

  const handleTextColorSelect = useCallback((color: string, section: 'name' | 'left' | 'right' | 'leftTitle' | 'rightTitle') => {
    switch (section) {
      case 'name':
        setTempNameTextColor(color);
        break;
      case 'left':
        setTempLeftColumnTextColor(color);
        break;
      case 'right':
        setTempRightColumnTextColor(color);
        break;
      case 'leftTitle':
        setTempLeftColumnTitleColor(color);
        break;
      case 'rightTitle':
        setTempRightColumnTitleColor(color);
        break;
    }
  }, []);

  // Hilfsfunktion für Textfarben-Palette
  const renderTextColorPalette = (section: 'name' | 'left' | 'right' | 'leftTitle' | 'rightTitle', tempColor: string) => {
    // Für Titel-Sektionen: Schwarz-weiß Palette
    const titleColors = [
      '#000000', '#333333', '#666666', '#999999', '#CCCCCC', '#FFFFFF'
    ];
    
    // Für normale Text-Sektionen: Standard Palette
    const textColors = [
      '#333333', '#666666', '#999999', '#CCCCCC', '#E0E0E0', '#F5F5F5'
    ];
    
    const colors = (section === 'leftTitle' || section === 'rightTitle') ? titleColors : textColors;

    const handleColorPickerChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const colorValue = event.target.value;
      handleTextColorSelect(colorValue, section);
    };

    const getSectionTitle = () => {
      switch (section) {
        case 'name': return 'Name';
        case 'left': return 'Linke Spalte';
        case 'right': return 'Rechte Spalte';
        case 'leftTitle': return 'Titel Spalte Links';
        case 'rightTitle': return 'Titel Spalte Rechts';
        default: return '';
      }
    };

    return (
      <Box sx={{ p: 2 }}>
        <Typography variant="h6" sx={{ mb: 2, fontFamily: 'Times New Roman, serif' }}>
          {getSectionTitle()}
        </Typography>
        
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
          <Typography variant="body2" sx={{ fontFamily: 'Times New Roman, serif' }}>
            Farbpicker:
          </Typography>
          <input
            type="color"
            value={tempColor}
            onChange={handleColorPickerChange}
            style={{
              width: '40px',
              height: '40px',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          />
        </Box>
        
        {/* Farbpalette */}
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 1.5, p: 1 }}>
          {colors.map((color) => (
            <Box
              key={`${section}-${color}`}
              onClick={() => handleTextColorSelect(color, section)}
              sx={{
                width: 40,
                height: 40,
                backgroundColor: color,
                border: tempColor === color ? '3px solid #667eea' : '2px solid #ddd',
                borderRadius: 1,
                cursor: 'pointer',
                '&:hover': {
                  transform: 'scale(1.1)',
                  transition: 'transform 0.2s ease'
                }
              }}
            />
          ))}
        </Box>
      </Box>
    );
  };


  // Hilfsfunktion zum Öffnen des Motivationsschreiben-Dialogs
  const handleOpenMotivationDialog = () => {
    // Markiere, dass Dialog gerade geöffnet wird
    dialogJustOpenedRef.current = true;
    // Öffne Dialog - Initialisierung erfolgt im useEffect
    setShowMotivationDialog(true);
  };

  // Hilfsfunktion zum Schließen des Motivationsschreiben-Dialogs (mit Speichern)
  const handleCloseMotivationDialog = () => {
    // Speichere alle Änderungen
    setMotivationTitle(tempMotivationTitle);
    setMotivationGreeting(tempMotivationGreeting);
    setMotivationLetter(tempMotivationLetter);
    setMotivationSenderName(tempMotivationSenderName);
    setMotivationSenderAddress(tempMotivationSenderAddress);
    setMotivationSenderPostalCode(tempMotivationSenderPostalCode);
    setMotivationSenderCity(tempMotivationSenderCity);
    setMotivationRecipientCompany(tempMotivationRecipientCompany);
    setMotivationRecipientContactPerson(tempMotivationRecipientContactPerson);
    setMotivationRecipientAddress(tempMotivationRecipientAddress);
    setMotivationRecipientPostalCode(tempMotivationRecipientPostalCode);
    setMotivationRecipientCity(tempMotivationRecipientCity);
    setMotivationClosingText(tempMotivationClosingText);
    setMotivationDateLocation(tempMotivationDateLocation);
    setMotivationSignatureName(tempMotivationSignatureName);
    
    // Schließe Dialog
    setShowMotivationDialog(false);
    
    // Trigger Seitenberechnung im CV-Template
    window.dispatchEvent(new CustomEvent('modalClosed'));
  };

  const handleLogout = () => {
    handleUserMenuClose();
    logout();
  };

  // Funktion zum Neuladen der CV-Daten vom Backend
  async function reloadCvDataFromBackend() {
    if (!user) return;
    
    // Wenn ein CV ausgewählt ist, lade diesen CV neu
    if (selectedCvId) {
      await handleSelectCv(selectedCvId);
      return;
    }
    
    try {
      const idToken = await user.getIdToken();
      const response = await fetch(`${config.backend.userDataUrl}/${user.uid}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        }
      });

      if (response.ok) {
        const result = await response.json();
        const data = result.data || {};
        
        // Setze alle Daten aus der verschlüsselten Antwort
        setFullName(data?.fullName || data?.personalInfo?.fullName || "");
        setCompany(data?.company || "");
        setAddress(data?.address || "");
        setPostalCode(data?.postalCode || "");
        setCity(data?.city || "");
        setCountry(mapCountryToSelectValue(data?.country || ""));
        setAvailableFrom(data?.availableFrom || "");
        setPhoneNumber(data?.phoneNumber || "");
        setEmail(data?.email || "");
        setBirthYear(data?.birthYear || "");
        setNationality(mapNationalityToSelectValue(data?.nationality || ""));
        setResidencePermit(mapResidencePermitToSelectValue(data?.residencePermit || ""));
        setCivilStatus(mapCivilStatusToSelectValue(data?.civilStatus || ""));
        setShortProfile(data?.shortProfile || "");
        setWorkExperience(data?.workExperience || "");
        setEducation(data?.education || "");
        setCertificates(data?.certificates || "");
        setLanguages(data?.languages || "");
        setItSkills(data?.itSkills || "");
        setAdditionalInfo(data?.additionalInfo || "");
        
        setWorkExperiences(data?.workExperiences || []);
        setEducations(data?.educations || []);
        setCertifications(data?.certifications || []);
        setIndustryExperiences(data?.industryExperiences || []);
        setLanguages(Array.isArray(data?.languages) ? data.languages.map((lang: any) => ({
          ...lang,
          level: mapLanguageLevelToSelectValue(lang.level || lang.proficiency || '')
        })) : []);
        setCoreCompetencies(Array.isArray(data?.coreCompetencies) ? data.coreCompetencies : []);
        setItSkills(Array.isArray(data?.itSkills) ? data.itSkills.map((skill: any) => ({
          ...skill,
          level: mapItSkillLevelToSelectValue(skill.level || skill.proficiency || '')
        })) : []);
        setHobbies(normalizeHobbyList(data?.hobbies));
        setAdditionalInfo(Array.isArray(data?.additionalInfo) ? data.additionalInfo : []);
        
        // Profilfoto
        if (data?.profileImage) {
          if (typeof data.profileImage === 'string') {
            setProfileImage(data.profileImage);
          } else if (data.profileImage.data) {
            setProfileImage(`data:${data.profileImage.type};base64,${data.profileImage.data}`);
          } else {
            setProfileImage(null);
          }
        } else {
          setProfileImage(null);
        }
        
        // Signatur
        if (data?.signature) {
          if (typeof data.signature === 'string') {
            setSignature(data.signature);
          } else if (data.signature.data) {
            setSignature(`data:${data.signature.type};base64,${data.signature.data}`);
          } else {
            setSignature(null);
          }
        } else {
          setSignature(null);
        }
      }
    } catch (error) {
      console.error('❌ Fehler beim Neuladen der CV-Daten:', error);
    }
  }

  // Funktion zum Laden der User-Präferenzen für Warnungs-Dialoge
  const loadUserWarningPreferences = async () => {
    if (!user) return;
    
    try {
      const idToken = await user.getIdToken();
      
      // Lade User-Präferenzen aus der users Collection
      const response = await fetch(`${config.backend.baseUrl}/api/get-user-preferences`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        }
      });

      if (response.ok) {
        const result = await response.json();
        const data = result.data || {};
        
        setDontShowImportWarning(data.dontShowImportWarning || false);
        setDontShowTemplateWarning(data.dontShowTemplateWarning || false);
        setDontShowMotivationWarning(data.dontShowMotivationWarning || false);
        
        console.log('✅ User-Warnungs-Präferenzen geladen:', {
          dontShowImportWarning: data.dontShowImportWarning || false,
          dontShowTemplateWarning: data.dontShowTemplateWarning || false,
          dontShowMotivationWarning: data.dontShowMotivationWarning || false
        });
      } else {
        console.log('ℹ️ Keine User-Präferenzen gefunden, verwende Standardwerte');
        setDontShowImportWarning(false);
        setDontShowTemplateWarning(false);
        setDontShowMotivationWarning(false);
      }
    } catch (error) {
      console.error('❌ Fehler beim Laden der User-Warnungs-Präferenzen:', error);
      // Bei Fehler Standardwerte verwenden
      setDontShowImportWarning(false);
      setDontShowTemplateWarning(false);
      setDontShowMotivationWarning(false);
    }
  };

  // Funktion zum Speichern der User-Präferenzen für Warnungs-Dialoge
  const saveUserWarningPreferences = async (importWarning: boolean, templateWarning: boolean, motivationWarning?: boolean) => {
    if (!user) return;
    
    try {
      const idToken = await user.getIdToken();
      
      // Verwende POST-Methode anstatt PATCH (umgeht CORS-Probleme)
      const response = await fetch(`${config.backend.baseUrl}/api/save-user-preferences`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({
          dontShowImportWarning: importWarning,
          dontShowTemplateWarning: templateWarning,
          dontShowMotivationWarning: motivationWarning || false
        })
      });

      if (response.ok) {
        console.log('✅ User-Warnungs-Präferenzen gespeichert:', {
          dontShowImportWarning: importWarning,
          dontShowTemplateWarning: templateWarning,
          dontShowMotivationWarning: motivationWarning || false
        });
      } else {
        console.error('❌ Fehler beim Speichern der User-Warnungs-Präferenzen');
      }
    } catch (error) {
      console.error('❌ Fehler beim Speichern der User-Warnungs-Präferenzen:', error);
    }
  };

  // Funktion zum Löschen aller CV-Daten (für neuen CV)
  const clearAllCvData = () => {
    console.log('🗑️ Lösche alle CV-Daten für neuen CV...');
    
    // Lösche alle persönlichen Daten
    setFullName('');
    setCompany('');
    setAddress('');
    setPostalCode('');
    setCity('');
    setCountry('');
    setAvailableFrom('');
    setPhoneNumber('');
    setEmail('');
    setBirthYear('');
    setNationality('');
    setResidencePermit('');
    setCivilStatus('');
    setDrivingLicense('');
    setShortProfile('');
    setWorkExperience('');
    setEducation('');
    setCertificates('');
    
    // Lösche alle Array-Daten
    setLanguages([]);
    setCoreCompetencies([]);
    setItSkills([]);
    setAdditionalInfo([]);
    setHobbies([]);
    setWorkExperiences([]);
    setEducations([]);
    setCertifications([]);
    setIndustryExperiences([]);
    
    // Lösche Bilder und Signaturen
    setProfileImage(null);
    setSignature(null);
    
    // Setze CV-Auswahl zurück
    setSelectedCvId(null);
    setCurrentCvName('');
    
    // Setze ungespeicherte Änderungen zurück
    setHasUnsavedChanges(false);
    
    console.log('✅ Alle CV-Daten gelöscht - bereit für neuen CV');
  };

  const handleCloseCvDataModal = () => {
    // Prüfe ob es ungespeicherte Änderungen gibt
    if (hasUnsavedChanges) {
      setShowUnsavedChangesDialog(true);
      return;
    }
    
    // Schließe Modal
    setShowCvDataModal(false);
    // Setze Flag zurück, dass Modal nicht mehr von "Passgenauigkeit prüfen" geöffnet wurde
    setOpenCvModalFromPassgenauigkeit(false);
    
    // Wenn keine CV-Daten vorhanden sind, zeige Tab "CV Daten" (Index 1)
    if (!hasData()) {
      setCvTabIndex(1);
    } else if (cvTabIndex < 1) {
      // Wenn CV-Daten vorhanden sind und Tab kleiner als 1, setze auf Tab "Bewerbungen" (Index 0)
      setCvTabIndex(0);
    }
  };
  
  const confirmCloseCvDataModal = () => {
    setShowUnsavedChangesDialog(false);
    setShowCvDataModal(false);
    setHasUnsavedChanges(false);
    // Setze Flag zurück, dass Modal nicht mehr von "Passgenauigkeit prüfen" geöffnet wurde
    setOpenCvModalFromPassgenauigkeit(false);
    
    // Wenn keine CV-Daten vorhanden sind, zeige Tab "CV Daten" (Index 1)
    if (!hasData()) {
      setCvTabIndex(1);
    } else if (cvTabIndex < 1) {
      // Wenn CV-Daten vorhanden sind und Tab kleiner als 1, setze auf Tab "Bewerbungen" (Index 0)
      setCvTabIndex(0);
    }
  };



  // Funktion zum Laden der Backend-Versionsinfo
  const loadBackendVersionInfo = async () => {
    if (backendVersionInfo) return; // Bereits geladen
    
    setLoadingVersionInfo(true);
    try {
      const response = await fetch(`${config.backend.fullApiUrl}/api/version-info`);
      if (response.ok) {
        const data = await response.json();
        setBackendVersionInfo(data);
        console.log('📋 Backend-Versionsinfo geladen:', data);
      } else {
        console.error('❌ Fehler beim Laden der Backend-Versionsinfo:', response.status);
      }
    } catch (error) {
      console.error('❌ Fehler beim Laden der Backend-Versionsinfo:', error);
    } finally {
      setLoadingVersionInfo(false);
    }
  };







  // Funktion zum Generieren des Textes für mitgelieferte Daten
  const getMitgelieferteDatenText = () => {
    // Analysiere den aktuellen Prompt und zeige nur die relevanten Daten
    const currentPrompt = editingPromptText || '';
    let dataText = '';
    
    // Prüfe welche Platzhalter im Prompt verwendet werden
    if (currentPrompt.includes('{cvText}')) {
      // Zeige alle CV-Daten ohne Label
      if (fullName) dataText += `${fullName}\n`;
      if (address) dataText += `${address}\n`;
      if (city) dataText += `${city}\n`;
      if (shortProfile) dataText += `${shortProfile}\n`;
      
      if (workExperiences && workExperiences.length > 0) {
        workExperiences.forEach((exp: any) => {
          dataText += `${exp.position} bei ${exp.company} (${exp.startDate} - ${exp.endDate})\n`;
          if (exp.description) dataText += `${exp.description}\n`;
        });
      }
      
      if (educations && educations.length > 0) {
        educations.forEach((edu: any) => {
          const description = edu.description ? ` - ${edu.description}` : '';
          dataText += `${edu.degree}${description} an ${edu.institution} (${edu.startDate} - ${edu.endDate})\n`;
        });
      }
      
      if (itSkills && itSkills.length > 0) {
        itSkills.forEach((skill: any) => {
          dataText += `${skill.skill} (${skill.level})\n`;
        });
      }
      
      if (languages && languages.length > 0) {
        languages.forEach((lang: any) => {
          dataText += `${lang.language} (${lang.level})\n`;
        });
      }
      
      if (certifications && certifications.length > 0) {
        certifications.forEach((cert: any) => {
          const description = cert.description ? ` - ${cert.description}` : '';
          dataText += `${cert.name}${description} - ${cert.issuer} (${cert.date})\n`;
        });
      }
      
      if (hobbies && hobbies.length > 0) {
        hobbies.forEach((hobby: any) => {
          dataText += `${hobby.hobby}: ${hobby.description}\n`;
        });
      }
      
      if (additionalInfo && additionalInfo.length > 0) {
        additionalInfo.forEach((info: any) => {
          dataText += `${info.info}: ${info.details}\n`;
        });
      }
      
      if (coreCompetencies && coreCompetencies.length > 0) {
        coreCompetencies.forEach((comp: any) => {
          dataText += `${comp.competency}\n`;
        });
      }
      
      if (industryExperiences && industryExperiences.length > 0) {
        industryExperiences.forEach((exp: any) => {
          dataText += `${exp.industry} (${exp.years} Jahre)\n`;
        });
      }
    }
    
    if (currentPrompt.includes('{jobDescription}')) {
      // Zeige Stellenbeschreibung nur wenn es nicht IT-Skills-Optimierung ist
      if (jobDescription && !currentPrompt.includes('{itSkillData}')) {
        dataText += jobDescription;
      }
    }
    
    if (currentPrompt.includes('{itSkillData}')) {
      if (itSkills && itSkills.length > 0) {
        itSkills.forEach((skill: any) => {
          dataText += `${skill.skill || 'Kein Skill'}: ${skill.level || 'Kein Level'}\n`;
        });
      } else {
        dataText += 'Keine IT-Skills im CV gefunden';
      }
    }
    
    if (currentPrompt.includes('{coreCompetencyData}')) {
      if (coreCompetencies && coreCompetencies.length > 0) {
        coreCompetencies.forEach((comp: any) => {
          dataText += `${comp.competency || 'Keine Kompetenz'}\n`;
        });
      } else {
        dataText += 'Keine Kernkompetenzen im CV gefunden';
      }
    }
    
    if (currentPrompt.includes('{educationData}')) {
      if (educations && educations.length > 0) {
        educations.forEach((edu: any) => {
          const degree = edu.degree || 'Kein Abschluss';
          const institution = edu.institution || 'Keine Institution';
          const startDate = edu.startDate || 'Kein Start';
          const endDate = edu.endDate || 'Kein Ende';
          const description = edu.description ? ` - ${edu.description}` : '';
          dataText += `${degree}${description} an ${institution} (${startDate} - ${endDate})\n`;
        });
      } else {
        dataText += 'Keine Ausbildungen im CV gefunden';
      }
    }
    
    if (currentPrompt.includes('{workExperienceData}')) {
      if (workExperiences && workExperiences.length > 0) {
        workExperiences.forEach((exp: any) => {
          dataText += `${exp.position || 'Keine Position'} bei ${exp.company || 'Keine Firma'} (${exp.startDate || 'Kein Start'} - ${exp.endDate || 'Kein Ende'})\n${exp.description || 'Keine Beschreibung'}\n`;
        });
      } else {
        dataText += 'Keine Arbeitserfahrungen im CV gefunden';
      }
    }
    
    if (currentPrompt.includes('{industryData}')) {
      if (industryExperiences && industryExperiences.length > 0) {
        industryExperiences.forEach((exp: any) => {
          dataText += `${exp.industry || 'Keine Branche'} (${exp.years || 'Keine Jahre'} Jahre)\n`;
        });
      } else {
        dataText += 'Keine Branchen-Erfahrungen im CV gefunden';
      }
    }
    
    if (currentPrompt.includes('{languageData}')) {
      if (languages && languages.length > 0) {
        languages.forEach((lang: any) => {
          dataText += `${lang.language || 'Keine Sprache'}: ${lang.level || 'Kein Level'}\n`;
        });
      }
    }
    
    if (currentPrompt.includes('{hobbyData}')) {
      if (hobbies && hobbies.length > 0) {
        hobbies.forEach((hobby: any) => {
          dataText += `${hobby.hobby || 'Kein Hobby'}: ${hobby.description || 'Keine Beschreibung'}\n`;
        });
      } else {
        // Fallback für leere Hobby-Daten
        dataText += 'Keine Hobbydaten verfügbar\n';
      }
    }
    

    
    if (currentPrompt.includes('{workExperienceData}')) {
      if (workExperiences && workExperiences.length > 0) {
        workExperiences.forEach((exp: any) => {
          dataText += `${exp.position || 'Keine Position'} bei ${exp.company || 'Keine Firma'} (${exp.startDate || ''} - ${exp.endDate || 'Heute'})\n`;
          if (exp.description) dataText += `${exp.description}\n`;
        });
      }
    }
    
    if (currentPrompt.includes('{certificationData}')) {
      if (certifications && certifications.length > 0) {
        certifications.forEach((cert: any) => {
          const name = cert.name || 'Kein Name';
          const issuer = cert.issuer || 'Kein Aussteller';
          const date = cert.date || 'Kein Datum';
          const description = cert.description ? ` - ${cert.description}` : '';
          dataText += `${name}${description} - ${issuer} (${date})\n`;
        });
      }
    }
    
    if (currentPrompt.includes('{additionalInfoData}')) {
      if (additionalInfo && additionalInfo.length > 0) {
        additionalInfo.forEach((info: any) => {
          dataText += `${info.info || 'Keine Info'}: ${info.details || 'Keine Details'}\n`;
        });
      }
    }
    
    if (currentPrompt.includes('{industryExperienceData}')) {
      if (industryExperiences && industryExperiences.length > 0) {
        industryExperiences.forEach((exp: any) => {
          dataText += `${exp.industry || 'Keine Branche'} (${exp.years || '0'} Jahre): ${exp.description || 'Keine Beschreibung'}\n`;
        });
      }
    }
    
    return dataText || 'Keine Daten verfügbar';
  };

  // Funktion zum Laden der Prompts von Firebase
  const loadPromptsFromFirebase = async () => {
    try {
      if (!user) {
        console.log('⚠️ Kein User - verwende Default-Prompts');
        return;
      }

      const idToken = await user.getIdToken();
      const response = await fetch(`${config.backend.baseUrl}/api/prompts`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${idToken}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        console.log('✅ Prompts von Firebase geladen:', data);

        // Prompts aus Firebase-Daten erstellen - ALLE Prompts laden
        const firebasePrompts: Array<{type: string; text: string; originalText: string; chatGptVersion?: string; usage?: string; temperature?: string; maxTokens?: string; systemRole?: string}> = [];

        // Alle Prompts aus Firebase laden (nicht nur bekannte)
        if (data.prompts) {
          Object.keys(data.prompts).forEach(promptType => {
            firebasePrompts.push({
              type: promptType,
              text: data.prompts[promptType],
              originalText: data.prompts[promptType],
              chatGptVersion: data.versions?.[promptType] || 'gpt-4o',
              usage: data.usages?.[promptType] || data.types?.[promptType] || 'Optimierung',
              temperature: data.temperatures?.[promptType] || '0.0',
              maxTokens: data.maxTokens?.[promptType] || '8000',
              systemRole: data.systemRoles?.[promptType] || 'Du bist ein Experte für CV-Optimierung.'
            });
          });
        }

        if (firebasePrompts.length > 0) {
          setPrompts(firebasePrompts);
          console.log('✅ Alle Prompts erfolgreich geladen:', firebasePrompts.length);
        } else {
          console.log('⚠️ Keine Prompts in Firebase gefunden');
          setPrompts([]);
        }
      } else {
        console.log('⚠️ Fehler beim Laden der Prompts');
        setPrompts([]);
      }
    } catch (error) {
      console.error('❌ Fehler beim Laden der Prompts:', error);
      setPrompts([]);
    }
  };

  // State für die Prompts
  const [prompts, setPrompts] = useState<Array<{type: string; text: string; originalText: string; chatGptVersion?: string; usage?: string; temperature?: string; maxTokens?: string; systemRole?: string}>>([]);

  // Funktion zum Sortieren der Prompts (zweistufig: 1. nach Usage, 2. nach Type)
  const sortPrompts = (promptsToSort: Array<{type: string; text: string; originalText: string; chatGptVersion?: string; usage?: string; temperature?: string; maxTokens?: string; systemRole?: string}>) => {
    return promptsToSort.sort((a, b) => {
      // Primäre Sortierung: Nach Usage (Verwendung)
      const usageA = a.usage || 'Optimierung';
      const usageB = b.usage || 'Optimierung';
      const usageComparison = usageA.localeCompare(usageB);
      
      // Wenn Usage gleich ist, sekundäre Sortierung nach Type
      if (usageComparison === 0) {
        return a.type.localeCompare(b.type);
      }
      
      return usageComparison;
    });
  };

  const [, setCvFile] = useState<File | null>(null);
  const [jobDescription, setJobDescription] = useState('');
  const [jobDescriptionLanguage, setJobDescriptionLanguage] = useState<string>('DE');
  const [, setLanguageDetected] = useState<boolean>(false);
  const [applications, setApplications] = useState<any[]>([]);
  const [selectedApplicationId, setSelectedApplicationId] = useState<string | null>(null);
  const [userCvs, setUserCvs] = useState<any[]>([]);
  const cvKeywordSearchCacheRef = useRef<Map<string, string>>(new Map());
  const [matchingCvSetsByKeywords, setMatchingCvSetsByKeywords] = useState<boolean>(false);
  const [keywordMatchMinPercent, setKeywordMatchMinPercent] = useState<number>(40);
  const [cvKeywordMatchPercentByCvId, setCvKeywordMatchPercentByCvId] = useState<Record<string, number>>({});
  const cvKeywordAutoSelectionRequestIdRef = useRef(0);
  const [selectedCvId, setSelectedCvId] = useState<string | null>(null);
  const [currentCvName, setCurrentCvName] = useState<string>('');
  const cvSelectionRequestIdRef = useRef(0);
  const cvSelectionAbortControllerRef = useRef<AbortController | null>(null);
  const cvPreviewRequestIdRef = useRef(0);
  const cvPreviewAbortControllerRef = useRef<AbortController | null>(null);
  const matchApplicationCreationPromiseRef = useRef<Promise<string> | null>(null);
  const cvSnapshotCacheRef = useRef<Map<string, { cvData: any; cvSetRef: string; stamp: string; loadedAt: number }>>(new Map());
  const activeProcessCvSnapshotRef = useRef<any | null>(null);
  const activeCvPreviewRowContextRef = useRef<{ applicationId: string; rowEntry: any } | null>(null);
  const [showDeleteCvDialog, setShowDeleteCvDialog] = useState<boolean>(false);
  const [, setUserBasic] = useState<{ fullName: string; email: string }>({ fullName: '', email: '' });
  const [, setLoadingApplications] = useState<boolean>(false);
  const [showApplicationDetailsModal, setShowApplicationDetailsModal] = useState<boolean>(false);
  const [selectedApplication, setSelectedApplication] = useState<any>(null);
  const [editableNotes, setEditableNotes] = useState<string>('');
  const [editableCompany, setEditableCompany] = useState<string>('');
  const [editableIndustry, setEditableIndustry] = useState<string>('');
  const [editableRoleTitle, setEditableRoleTitle] = useState<string>('');
  const [editableContactInfo, setEditableContactInfo] = useState<string>('');
  const [editableRequirementsMuss, setEditableRequirementsMuss] = useState<string>('');
  const [editableRequirementsSoll, setEditableRequirementsSoll] = useState<string>('');
  const [editableRequirementsKann, setEditableRequirementsKann] = useState<string>('');
  const [editableTasks, setEditableTasks] = useState<string>('');
  const [editableApplicationDetails, setEditableApplicationDetails] = useState<string>('');
  const [editableKeywords, setEditableKeywords] = useState<string[]>([]);
  const [applicationKeywordInput, setApplicationKeywordInput] = useState<string>('');
  const [isJobInformationCollapsed, setIsJobInformationCollapsed] = useState<boolean>(true);

  const [generatingShareLinkRowKey, setGeneratingShareLinkRowKey] = useState<string | null>(null);
  const [optimizingCvRowKey, setOptimizingCvRowKey] = useState<string | null>(null);
  const [shareLinkUrl, setShareLinkUrl] = useState<string | null>(null);
  const [showShareLinkDialog, setShowShareLinkDialog] = useState<boolean>(false);

  const buildCvMatchRowPayload = (entry?: any): { cvId?: string; cvSetRef?: string; cvName?: string } => {
    if (!entry || typeof entry !== 'object') return {};
    const payload: { cvId?: string; cvSetRef?: string; cvName?: string } = {};
    if (typeof entry.cvId === 'string' && entry.cvId.trim()) payload.cvId = entry.cvId.trim();
    if (typeof entry.cvSetRef === 'string' && entry.cvSetRef.trim()) payload.cvSetRef = entry.cvSetRef.trim();
    if (typeof entry.cvName === 'string' && entry.cvName.trim()) payload.cvName = entry.cvName.trim();
    return payload;
  };

  const matchesCvRowByIdentity = (
    targetEntry: any,
    candidateEntry: any,
    targetIndex?: number,
    candidateIndex?: number
  ): boolean => {
    const targetCvId = typeof targetEntry?.cvId === 'string' ? targetEntry.cvId.trim() : '';
    const candidateCvId = typeof candidateEntry?.cvId === 'string' ? candidateEntry.cvId.trim() : '';
    if (targetCvId && candidateCvId) return targetCvId === candidateCvId;

    const targetCvSetRef = typeof targetEntry?.cvSetRef === 'string' ? targetEntry.cvSetRef.trim() : '';
    const candidateCvSetRef = typeof candidateEntry?.cvSetRef === 'string' ? candidateEntry.cvSetRef.trim() : '';
    if (targetCvSetRef && candidateCvSetRef) return targetCvSetRef === candidateCvSetRef;

    // Niemals auf cvName matchen (nicht eindeutig). Letzter Fallback: exakter Tabellenindex.
    if (typeof targetIndex === 'number' && typeof candidateIndex === 'number') {
      return targetIndex === candidateIndex;
    }
    return false;
  };

  const hasOptimizedFieldsInPreviewData = (previewData: any): boolean => {
    if (!previewData || typeof previewData !== 'object') return false;
    const fields: Array<keyof typeof previewData> = [
      'optimizedShortProfile',
      'optimizedWorkExperiences',
      'optimizedCvText',
      'relevantItSkills',
      'relevantLanguages',
      'relevantCertifications',
      'relevantCoreCompetencies',
      'relevantAdditionalInfo',
      'relevantHobbies',
      'relevantIndustries',
      'relevantEducations'
    ];
    return fields.some((field) => {
      const value = (previewData as any)[field];
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === 'string') return value.trim().length > 0;
      return value !== null && value !== undefined;
    });
  };

  // Funktion zum Generieren eines Share-Links
  const generateShareLink = async (
    applicationId: string,
    email?: string,
    rowEntry?: any,
    rowLoadingKey?: string,
    rowIndex?: number
  ) => {
    if (!user) return;
    
    try {
      setGeneratingShareLinkRowKey(rowLoadingKey || null);
      const token = await user.getIdToken();
      
      const response = await fetch(`${config.backend.baseUrl}/api/generate-cv-share-link`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          applicationId: applicationId,
          email: email || null,
          ...buildCvMatchRowPayload(rowEntry)
        })
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Fehler beim Generieren des Share-Links');
      }
      
      const result = await response.json();
      setShareLinkUrl(result.shareUrl);
      setShowShareLinkDialog(true);
      
      // Bei Share-Link aus der CV-Match-Tabelle nur den Status der betroffenen Zeile setzen.
      const rowPayload = buildCvMatchRowPayload(rowEntry);
      const hasRowPayload = !!rowPayload.cvId || !!rowPayload.cvSetRef || typeof rowIndex === 'number';

      try {
        if (hasRowPayload) {
          const sourceApplication =
            applications.find((app: any) => app.id === applicationId) ||
            (selectedApplication?.id === applicationId ? selectedApplication : null);
          const currentCvMatchResults = Array.isArray(sourceApplication?.cvMatchResults)
            ? sourceApplication.cvMatchResults
            : [];

          if (currentCvMatchResults.length > 0) {
            const updatedCvMatchResults = currentCvMatchResults.map((row: any, candidateIndex: number) => {
              if (matchesCvRowByIdentity(rowEntry, row, rowIndex, candidateIndex)) {
                return { ...row, rowStatus: 'In Prüfung' };
              }
              return row;
            });

            await persistApplicationMatchData(
              applicationId,
              typeof sourceApplication?.matchScore === 'number' ? sourceApplication.matchScore : null,
              normalizeMatchList(sourceApplication?.missingSkills),
              normalizeMatchList(sourceApplication?.weaknesses),
              token,
              updatedCvMatchResults
            );
          }
        } else {
          // Ohne Zeilenkontext (z. B. globaler Share-Flow) weiterhin globalen Bewerbungsstatus setzen.
          const statusResponse = await fetch(`${config.backend.baseUrl}/api/update-application-status`, {
            method: 'PUT',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: applicationId,
              status: 'In Prüfung'
            })
          });
          
          if (statusResponse.ok) {
            console.log('✅ Status auf "In Prüfung" gesetzt');
            // Aktualisiere den Status in der lokalen Anwendungsliste
            setApplications((prevApps: any[]) =>
              prevApps.map((app: any) =>
                app.id === applicationId
                  ? { ...app, status: 'In Prüfung' }
                  : app
              )
            );
            // Aktualisiere auch selectedApplication falls es die gleiche ist
            if (selectedApplication && selectedApplication.id === applicationId) {
              setSelectedApplication({ ...selectedApplication, status: 'In Prüfung' });
            }
          } else {
            console.warn('⚠️ Fehler beim Setzen des Status auf "In Prüfung"');
          }
        }
      } catch (statusError) {
        console.error('⚠️ Fehler beim Setzen des Status:', statusError);
        // Ignoriere Fehler beim Status-Setzen, da der Share-Link bereits generiert wurde
      }
      
      if (email && result.emailSent) {
        alert('Share-Link wurde per E-Mail versendet!');
      }
    } catch (error: any) {
      console.error('Fehler beim Generieren des Share-Links:', error);
      alert('Fehler beim Generieren des Share-Links: ' + (error.message || 'Unbekannter Fehler'));
    } finally {
      setGeneratingShareLinkRowKey(null);
    }
  };
  
  const copyShareLinkToClipboard = () => {
    if (shareLinkUrl) {
      navigator.clipboard.writeText(shareLinkUrl);
      // Kein Popup mehr - nur stilles Kopieren
    }
  };

  const handleAddApplicationKeyword = (rawValue: string) => {
    const keyword = rawValue.trim().replace(/,+$/, '');
    if (!keyword) return;
    setEditableKeywords((prev) => {
      const alreadyExists = prev.some(
        (existingKeyword) => existingKeyword.toLowerCase() === keyword.toLowerCase()
      );
      if (alreadyExists) return prev;
      return [...prev, keyword];
    });
    setApplicationKeywordInput('');
  };

  const handleRemoveApplicationKeyword = (keywordToRemove: string) => {
    setEditableKeywords((prev) => prev.filter((keyword) => keyword !== keywordToRemove));
  };

  useEffect(() => {
    return () => {
      cvSelectionAbortControllerRef.current?.abort();
      cvPreviewAbortControllerRef.current?.abort();
    };
  }, []);
  
  // Funktion zum Speichern der Bewerbungs-Metadaten inkl. Anforderungen
  // CV-Preview-Daten werden NUR beim Schließen des CV-Preview-Modals gespeichert
  const saveApplicationData = async () => {
    if (!selectedApplication || !user) return;
    
    try {
      const token = await user.getIdToken();
      
      // Speichere Notizen
      const notesResponse = await fetch(`${config.backend.baseUrl}/api/update-application-notes`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          applicationId: selectedApplication.id,
          notes: editableNotes
        })
      });

      // Speichere Firma
      const companyResponse = await fetch(`${config.backend.baseUrl}/api/update-application-company`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          applicationId: selectedApplication.id,
          company: editableCompany
        })
      });

      // Speichere Branche
      const industryResponse = await fetch(`${config.backend.baseUrl}/api/update-application-industry`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          applicationId: selectedApplication.id,
          industry: editableIndustry
        })
      });

      // Speichere Rollentitel
      const roleTitleResponse = await fetch(`${config.backend.baseUrl}/api/update-application-role-title`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          applicationId: selectedApplication.id,
          roleTitle: editableRoleTitle
        })
      });

      // Speichere Kontaktdaten
      const contactInfoResponse = await fetch(`${config.backend.baseUrl}/api/update-application-contact-info`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          applicationId: selectedApplication.id,
          contactInfo: editableContactInfo
        })
      });

      // Speichere Anforderungen (Muss/Soll/Kann)
      const requirementsResponse = await fetch(`${config.backend.baseUrl}/api/update-application-requirements`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          applicationId: selectedApplication.id,
          anforderungenMuss: editableRequirementsMuss,
          anforderungenSoll: editableRequirementsSoll,
          anforderungenKann: editableRequirementsKann
        })
      });

      // Speichere Schlüsselstichworte über Job-Info-Endpoint
      const keywordsResponse = await fetch(`${config.backend.baseUrl}/api/update-application-job-info`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          applicationId: selectedApplication.id,
          jobInfo: {
            company: editableCompany || '',
            publishDate: selectedApplication.publishDate || '',
            startDate: selectedApplication.startDate || '',
            contactInfo: editableContactInfo || '',
            industry: editableIndustry || '',
            roleTitle: editableRoleTitle || '',
            workload: selectedApplication.workload || '',
            tasks: editableTasks || '',
            requirements: selectedApplication.anforderungen || '',
            'requirements-muss': editableRequirementsMuss || '',
            'requirements-soll': editableRequirementsSoll || '',
            'requirements-kann': editableRequirementsKann || '',
            applicationDetails: editableApplicationDetails || '',
            keywords: Array.isArray(editableKeywords) ? editableKeywords : []
          }
        })
      });

      if (notesResponse.ok && companyResponse.ok && industryResponse.ok && roleTitleResponse.ok && contactInfoResponse.ok && requirementsResponse.ok && keywordsResponse.ok) {
        const combinedRequirements = [editableRequirementsMuss, editableRequirementsSoll, editableRequirementsKann]
          .filter((item) => typeof item === 'string' && item.trim())
          .join('\n\n');
        // Update local state
        setSelectedApplication((prev: any) => ({ 
          ...prev, 
          notes: editableNotes,
          company: editableCompany,
          industry: editableIndustry,
          roleTitle: editableRoleTitle,
          contactInfo: editableContactInfo,
          aufgaben: editableTasks || null,
          anforderungenMuss: editableRequirementsMuss,
          anforderungenSoll: editableRequirementsSoll,
          anforderungenKann: editableRequirementsKann,
          anforderungen: combinedRequirements || null,
          applicationDetails: editableApplicationDetails,
          keywords: Array.isArray(editableKeywords) ? editableKeywords : []
        }));
        setApplications((prev: any[]) => 
          prev.map(app => 
            app.id === selectedApplication.id 
              ? {
                  ...app,
                  notes: editableNotes,
                  company: editableCompany,
                  industry: editableIndustry,
                  roleTitle: editableRoleTitle,
                  contactInfo: editableContactInfo,
                  aufgaben: editableTasks || null,
                  anforderungenMuss: editableRequirementsMuss,
                  anforderungenSoll: editableRequirementsSoll,
                  anforderungenKann: editableRequirementsKann,
                  anforderungen: combinedRequirements || null,
                  applicationDetails: editableApplicationDetails,
                  keywords: Array.isArray(editableKeywords) ? editableKeywords : []
                }
              : app
          )
        );
        console.log('✅ Notizen, Firma, Branche, Rollentitel, Kontaktdaten, Anforderungen und Schlüsselstichworte gespeichert');
      } else {
        console.error('❌ Fehler beim Speichern der Bewerbungs-Metadaten');
      }
    } catch (error) {
      console.error('❌ Fehler beim Speichern der Daten:', error);
    }
  };

  const saveExtractedJobInfoForSelectedApplication = async () => {
    if (!user || !extractedJobInfo) return;
    let applicationId = selectedApplication?.id || selectedApplicationId;
    if (!applicationId) return;

    try {
      const token = await user.getIdToken();

      // Preflight: Stelle vor dem ersten Save sicher, dass die Ziel-Bewerbung
      // serverseitig existiert. Das verhindert unnötige 404-POSTs im Normalfall.
      try {
        const refreshResponse = await fetch(`${config.backend.baseUrl}/api/get-job-descriptions`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        if (refreshResponse.ok) {
          const refreshData = await refreshResponse.json();
          const refreshedApplications = Array.isArray(refreshData.applications) ? refreshData.applications : [];
          setApplications(refreshedApplications);
          const existsOnServer = refreshedApplications.some((app: any) => app.id === applicationId);
          if (!existsOnServer) {
            if (selectedApplicationId === applicationId) {
              setSelectedApplicationId(null);
            }
            setSelectedApplication((prev: any) => (prev?.id === applicationId ? null : prev));
            return;
          }
        }
      } catch (preflightError) {
        console.warn('⚠️ Preflight-Check für Job-Info-Save fehlgeschlagen, versuche Save trotzdem:', preflightError);
      }

      const postJobInfo = async (targetApplicationId: string) =>
        fetch(`${config.backend.baseUrl}/api/update-application-job-info`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            applicationId: targetApplicationId,
            jobInfo: extractedJobInfo
          })
        });

      let response = await postJobInfo(applicationId);

      if (!response.ok) {
        const errorText = await response.text().catch(() => '');
        console.warn('⚠️ Fehler beim Speichern der Job-Informationen vor Passgenauigkeit:', response.status, errorText);

        // Wenn die Bewerbung serverseitig nicht mehr existiert, lokalen Zustand bereinigen.
        if (response.status === 404) {
          try {
            const refreshResponse = await fetch(`${config.backend.baseUrl}/api/get-job-descriptions`, {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            });
            if (refreshResponse.ok) {
              const refreshData = await refreshResponse.json();
              const refreshedApplications = Array.isArray(refreshData.applications) ? refreshData.applications : [];
              setApplications(refreshedApplications);
              const stillExists = refreshedApplications.some((app: any) => app.id === applicationId);
              if (!stillExists) {
                if (selectedApplicationId === applicationId) {
                  setSelectedApplicationId(null);
                }
                setSelectedApplication((prev: any) => (prev?.id === applicationId ? null : prev));
              }
            }
          } catch (refreshError) {
            console.warn('⚠️ Konnte Applications nach 404 beim Job-Info-Save nicht neu laden:', refreshError);
          }
        }
        if (!response.ok) {
          return;
        }
      }

      const requirementsMuss = extractedJobInfo['requirements-muss'] || '';
      const requirementsSoll = extractedJobInfo['requirements-soll'] || '';
      const requirementsKann = extractedJobInfo['requirements-kann'] || '';
      const legacyRequirements = extractedJobInfo.requirements || '';
      const combinedRequirements = [requirementsMuss, requirementsSoll, requirementsKann]
        .filter((item) => typeof item === 'string' && item.trim())
        .join('\n\n');

      setSelectedApplication((prev: any) =>
        prev && prev.id === applicationId
          ? {
              ...prev,
              company: extractedJobInfo.company || '',
              publishDate: extractedJobInfo.publishDate || '',
              startDate: extractedJobInfo.startDate || '',
              contactInfo: extractedJobInfo.contactInfo || '',
              industry: extractedJobInfo.industry || '',
              roleTitle: extractedJobInfo.roleTitle || '',
              workload: extractedJobInfo.workload || '',
              keywords: extractedJobInfo.keywords || [],
              aufgaben: extractedJobInfo.tasks || null,
              anforderungenMuss: requirementsMuss,
              anforderungenSoll: requirementsSoll,
              anforderungenKann: requirementsKann,
              anforderungen: legacyRequirements || combinedRequirements || null,
              applicationDetails: extractedJobInfo.applicationDetails || ''
            }
          : prev
      );

      setApplications((prev: any[]) =>
        prev.map((app: any) =>
          app.id === applicationId
            ? {
                ...app,
                company: extractedJobInfo.company || '',
                publishDate: extractedJobInfo.publishDate || '',
                startDate: extractedJobInfo.startDate || '',
                contactInfo: extractedJobInfo.contactInfo || '',
                industry: extractedJobInfo.industry || '',
                roleTitle: extractedJobInfo.roleTitle || '',
                workload: extractedJobInfo.workload || '',
                keywords: extractedJobInfo.keywords || [],
                aufgaben: extractedJobInfo.tasks || null,
                anforderungenMuss: requirementsMuss,
                anforderungenSoll: requirementsSoll,
                anforderungenKann: requirementsKann,
                anforderungen: legacyRequirements || combinedRequirements || null,
                applicationDetails: extractedJobInfo.applicationDetails || ''
              }
            : app
        )
      );
    } catch (error) {
      console.error('❌ Fehler beim Speichern der Job-Informationen:', error);
    }
  };

  const persistApplicationMatchData = async (
    applicationId: string,
    score: number | null,
    missing: string[],
    weak: string[],
    tokenOverride?: string,
    cvMatchResults?: Array<{
      cvId?: string;
      cvSetRef?: string;
      cvName?: string;
      matchScore: number | null;
      missingSkills: string[];
      weaknesses: string[];
      hasOptimizedCv?: boolean;
      calculationError?: string;
    }>
  ) => {
    if (!user || !applicationId) return;

    // Guard gegen veraltete IDs im UI-State (z. B. nach Löschen/Wechsel der Bewerbung).
    // Wichtig: frisch erstellte Bewerbungen können kurzzeitig noch nicht in `applications` sein.
    // Daher nicht sofort abbrechen, sondern bei unbekannter ID einmalig serverseitig verifizieren.
    if (!applications.some((app: any) => app.id === applicationId)) {
      console.warn('⚠️ applicationId noch nicht in lokaler Liste - verifiziere serverseitig vor Persistierung', { applicationId });
      try {
        const tokenForCheck = tokenOverride || await user.getIdToken();
        const refreshResponse = await fetch(`${config.backend.baseUrl}/api/get-job-descriptions`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${tokenForCheck}`
          }
        });

        if (refreshResponse.ok) {
          const refreshData = await refreshResponse.json();
          const refreshedApplications = Array.isArray(refreshData.applications) ? refreshData.applications : [];
          setApplications(refreshedApplications);
          const stillUnknown = !refreshedApplications.some((app: any) => app.id === applicationId);
          if (stillUnknown) {
            console.warn('⚠️ Überspringe Match-Persistierung: applicationId existiert serverseitig nicht mehr', { applicationId });
            if (selectedApplicationId === applicationId) {
              setSelectedApplicationId(null);
            }
            setSelectedApplication((prev: any) => (prev?.id === applicationId ? null : prev));
            return;
          }
        }
      } catch (precheckError) {
        console.warn('⚠️ Vorab-Verifikation für Match-Persistierung fehlgeschlagen, versuche Persistierung trotzdem:', precheckError);
      }
    }

    try {
      const token = tokenOverride || await user.getIdToken();
      const response = await fetch(`${config.backend.baseUrl}/api/update-application-match-data`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          applicationId,
          matchScore: score,
          missingSkills: missing,
          weaknesses: weak,
          cvMatchResults: Array.isArray(cvMatchResults) ? cvMatchResults : undefined
        })
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ Fehler beim Speichern der Passgenauigkeitsdaten:', response.status, errorText);

        // Wenn die Bewerbung serverseitig nicht mehr existiert, lokale Selektion bereinigen und Liste nachladen
        if (response.status === 404) {
          try {
            const refreshResponse = await fetch(`${config.backend.baseUrl}/api/get-job-descriptions`, {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${token}`
              }
            });

            if (refreshResponse.ok) {
              const refreshData = await refreshResponse.json();
              const refreshedApplications = Array.isArray(refreshData.applications) ? refreshData.applications : [];
              setApplications(refreshedApplications);

              const stillExists = refreshedApplications.some((app: any) => app.id === applicationId);
              if (!stillExists) {
                if (selectedApplicationId === applicationId) {
                  setSelectedApplicationId(null);
                }
                setSelectedApplication((prev: any) => (prev?.id === applicationId ? null : prev));
              }
            }
          } catch (refreshError) {
            console.warn('⚠️ Konnte Applications nach 404 nicht neu laden:', refreshError);
          }
        }
        return;
      }

      setApplications((prev: any[]) =>
        prev.map((app: any) =>
          app.id === applicationId
            ? { ...app, matchScore: score, missingSkills: missing, weaknesses: weak, cvMatchResults: Array.isArray(cvMatchResults) ? cvMatchResults : app.cvMatchResults }
            : app
        )
      );
      setSelectedApplication((prev: any) =>
        prev && prev.id === applicationId
          ? { ...prev, matchScore: score, missingSkills: missing, weaknesses: weak, cvMatchResults: Array.isArray(cvMatchResults) ? cvMatchResults : prev.cvMatchResults }
          : prev
      );
    } catch (error) {
      console.error('❌ Fehler beim Persistieren der Passgenauigkeitsdaten:', error);
    }
  };

  const openApplicationDetailsForId = async (
    applicationId: string,
    tokenOverride?: string,
    forceRefresh: boolean = false,
    keepCurrentModal: boolean = false,
    preferredApplication?: any
  ) => {
    if (!user || !applicationId) return;

    let targetApplication = preferredApplication || (forceRefresh
      ? null
      : (applications.find((app: any) => app.id === applicationId) || null));
    const token = tokenOverride || await user.getIdToken();

    if (!targetApplication) {
      try {
        const response = await fetch(`${config.backend.baseUrl}/api/get-job-descriptions`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        if (response.ok) {
          const data = await response.json();
          const refreshedApplications = Array.isArray(data.applications) ? data.applications : [];
          setApplications(refreshedApplications);
          targetApplication = refreshedApplications.find((app: any) => app.id === applicationId) || null;
        }
      } catch (error) {
        console.warn('⚠️ Konnte Bewerbungsdetails nicht nachladen:', error);
      }
    }

    if (!targetApplication) return;

    setSelectedApplicationId(applicationId);
    setSelectedApplication(targetApplication);
    setEditableNotes(targetApplication.notes || '');
    setEditableCompany(targetApplication.company || '');
    setEditableIndustry(targetApplication.industry || '');
    setEditableRoleTitle(targetApplication.roleTitle || '');
    setEditableContactInfo(targetApplication.contactInfo || '');
    setEditableRequirementsMuss(
      targetApplication.anforderungenMuss ||
      ((!targetApplication.anforderungenSoll && !targetApplication.anforderungenKann)
        ? (targetApplication.anforderungen || '')
        : '')
    );
    setEditableRequirementsSoll(targetApplication.anforderungenSoll || '');
    setEditableRequirementsKann(targetApplication.anforderungenKann || '');
    setEditableTasks(
      Array.isArray(targetApplication.aufgaben)
        ? targetApplication.aufgaben.join('\n')
        : (targetApplication.aufgaben || '')
    );
    setEditableApplicationDetails(targetApplication.applicationDetails || '');
    setEditableKeywords(Array.isArray(targetApplication.keywords) ? targetApplication.keywords : []);
    setApplicationKeywordInput('');
    setJobUrl(targetApplication.jobUrl || null);
    if (!keepCurrentModal) {
      setShowCvDataModal(false);
      setShowApplicationDetailsModal(true);
    }
  };

  const getCvMatchResultsForApplication = (application: any): any[] => {
    if (!application) return [];
    if (Array.isArray(application.cvMatchResults)) return application.cvMatchResults;
    const latestFromList = applications.find((app: any) => app.id === application.id);
    if (latestFromList && Array.isArray((latestFromList as any).cvMatchResults)) {
      return (latestFromList as any).cvMatchResults;
    }
    return [];
  };
  const [showClosedApplications, setShowClosedApplications] = useState<boolean>(false);
  const [showDateFilters, setShowDateFilters] = useState<boolean>(false);
  const [applicationDateFrom, setApplicationDateFrom] = useState<string>('');
  const [applicationDateTo, setApplicationDateTo] = useState<string>('');
  const [applicationSearchText, setApplicationSearchText] = useState<string>('');
  const [showCvDataFilters, setShowCvDataFilters] = useState<boolean>(false);
  const [cvDataSearchText, setCvDataSearchText] = useState<string>('');
  const [extractedJobInfo, setExtractedJobInfo] = useState<{
    company?: string;
    publishDate?: string;
    startDate?: string;
    contactInfo?: string;
    industry?: string;
    roleTitle?: string;
    tasks?: string;
    requirements?: string;
    'requirements-muss'?: string;
    'requirements-soll'?: string;
    'requirements-kann'?: string;
    applicationDetails?: string;
    workload?: string;
    keywords?: string[];
    cvSetRefs?: string[];
    cvIds?: string[];
  } | null>(null);
  const [jobKeywordInput, setJobKeywordInput] = useState<string>('');
  const [extractingJobInfo, setExtractingJobInfo] = useState<boolean>(false);
  const [jobUrl, setJobUrl] = useState<string | null>(null);

  const buildCvSetFingerprint = (cv: any): string => {
    if (!cv || typeof cv !== 'object') return '';
    const parts = [
      typeof cv?.cvName === 'string' ? cv.cvName.trim().toLowerCase() : '',
      typeof cv?.email === 'string' ? cv.email.trim().toLowerCase() : '',
      typeof cv?.fullName === 'string' ? cv.fullName.trim().toLowerCase() : '',
      typeof cv?.phoneNumber === 'string' ? cv.phoneNumber.trim().toLowerCase() : '',
      typeof cv?.postalCode === 'string' ? cv.postalCode.trim().toLowerCase() : '',
      typeof cv?.city === 'string' ? cv.city.trim().toLowerCase() : '',
      typeof cv?.birthYear === 'string' ? cv.birthYear.trim().toLowerCase() : '',
      typeof cv?.availableFrom === 'string' ? cv.availableFrom.trim().toLowerCase() : ''
    ].filter(Boolean);
    return parts.length > 0 ? `fp:${parts.join('|')}` : '';
  };

  const getCvSetRef = (cv: any): string => {
    if (!cv || typeof cv !== 'object') return '';
    // Verwende nur stabile technische IDs (kein cvName-Fallback).
    const technicalRef = cv.cvId || cv.id || cv.tempId || cv.localId || '';
    if (technicalRef) return technicalRef;
    return buildCvSetFingerprint(cv);
  };

  const getCvSetRefCandidates = (cv: any): string[] => {
    if (!cv || typeof cv !== 'object') return [];
    const technicalCandidates = [
      typeof cv?.cvId === 'string' ? cv.cvId.trim() : '',
      typeof cv?.id === 'string' ? cv.id.trim() : '',
      typeof cv?.tempId === 'string' ? cv.tempId.trim() : '',
      typeof cv?.localId === 'string' ? cv.localId.trim() : ''
    ].filter(Boolean);
    const fingerprint = buildCvSetFingerprint(cv);
    return fingerprint ? [...technicalCandidates, fingerprint] : technicalCandidates;
  };

  const doesCvMatchSetRef = (cv: any, targetRef: string): boolean => {
    const normalizedTargetRef = typeof targetRef === 'string' ? targetRef.trim() : '';
    if (!normalizedTargetRef) return false;
    return getCvSetRefCandidates(cv).includes(normalizedTargetRef);
  };

  const getNormalizedCvId = (value: any): string => {
    return typeof value === 'string' && value.trim() ? value.trim() : '';
  };

  const resolveCvIdBySetRefStrict = (setRef: string): string | null => {
    const normalizedSetRef = typeof setRef === 'string' ? setRef.trim() : '';
    if (!normalizedSetRef) return null;
    const matchingCvs = (userCvs || []).filter((cv: any) => doesCvMatchSetRef(cv, normalizedSetRef));
    if (matchingCvs.length !== 1) return null;
    const resolvedCvId = getNormalizedCvId(matchingCvs[0]?.cvId);
    return resolvedCvId || null;
  };

  const selectCvForMatchEntry = async (entry: any): Promise<{ resolvedCvId: string | null; resolvedCv: any | null; resolvedCvSetRef: string }> => {
    const entryCvSetRef = typeof entry?.cvSetRef === 'string' ? entry.cvSetRef.trim() : '';
    if (!entryCvSetRef) {
      const debugPayload = {
        entryCvId: entry?.cvId || null,
        entryCvSetRef: entry?.cvSetRef || null,
        entryCvName: entry?.cvName || null,
        selectedCvId
      };
      console.warn('⚠️ Konnte CV-Daten-Set für Tabellenzeile nicht auflösen (cvSetRef fehlt):', debugPayload);
      throw new Error('CV-Daten-Set dieser Zeile konnte nicht eindeutig aufgeloest werden.');
    }

    const strictMatches = (userCvs || []).filter((cv: any) => doesCvMatchSetRef(cv, entryCvSetRef));
    if (strictMatches.length !== 1) {
      const debugPayload = {
        entryCvSetRef,
        matches: strictMatches.length
      };
      console.warn('⚠️ Konnte CV-Daten-Set für Tabellenzeile nicht eindeutig auflösen:', debugPayload);
      throw new Error('CV-Daten-Set dieser Zeile konnte nicht eindeutig aufgeloest werden.');
    }

    const resolvedCv = strictMatches[0];
    const resolvedCvId = typeof resolvedCv?.cvId === 'string' && resolvedCv.cvId.trim()
      ? resolvedCv.cvId.trim()
      : null;

    // Auswahlentscheidung erfolgt ausschließlich über cvSetRef.
    // cvId bleibt optionales Metadatum und wird hier bewusst NICHT
    // für einen CV-Wechsel (handleSelectCv) verwendet.

    return {
      resolvedCvId,
      resolvedCv,
      resolvedCvSetRef: entryCvSetRef
    };
  };

  const fetchCvDataById = async (cvId: string): Promise<any | null> => {
    if (!user || !cvId) return null;
    const idToken = await user.getIdToken();
    const response = await fetch(`${config.backend.baseUrl}/api/get-encrypted-data/${cvId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`
      }
    });
    if (!response.ok) return null;
    const result = await response.json();
    return result?.data || null;
  };

  const hasUsableCvSourceData = (source: any): boolean => {
    if (!source || typeof source !== 'object') return false;
    const hasStructuredArrays =
      !!source?.workExperiences?.length ||
      !!source?.workExperience?.length ||
      !!source?.educations?.length ||
      !!source?.education?.length ||
      !!source?.certifications?.length ||
      !!source?.languages?.length ||
      !!source?.itSkills?.length ||
      !!source?.coreCompetencies?.length ||
      !!source?.industryExperiences?.length ||
      !!source?.hobbies?.length ||
      !!source?.additionalInfo?.length;
    const hasProfileText =
      (typeof source?.shortProfile === 'string' && source.shortProfile.trim().length > 0) ||
      (typeof source?.personalInfo?.shortProfile === 'string' && source.personalInfo.shortProfile.trim().length > 0);
    return hasStructuredArrays || hasProfileText;
  };

  const getCvMetaStamp = (cv: any): string => {
    if (!cv || typeof cv !== 'object') return '';
    const rawLastModified =
      cv?.lastModified?.seconds ||
      cv?.lastModified?._seconds ||
      cv?.updatedAt?.seconds ||
      cv?.updatedAt?._seconds ||
      cv?.createdAt?.seconds ||
      cv?.createdAt?._seconds ||
      cv?.lastModified ||
      cv?.updatedAt ||
      cv?.createdAt ||
      '';
    const normalizedLastModified = String(rawLastModified || '').trim();
    const cvId = typeof cv?.cvId === 'string' ? cv.cvId.trim() : '';
    const cvSetRef = getCvSetRef(cv);
    return `${cvId}|${cvSetRef}|${normalizedLastModified}`;
  };

  async function loadCvSnapshotForProcess(options: {
    cvId?: string | null;
    cvSetRef?: string | null;
    sourceCvData?: any;
    forceReload?: boolean;
    maxAgeMs?: number;
  }): Promise<{ cvId: string | null; cvSetRef: string; cvData: any; fromCache: boolean }> {
    const {
      cvId,
      cvSetRef,
      sourceCvData,
      forceReload = false,
      maxAgeMs = 15000
    } = options || {};

    const normalizedCvId = typeof cvId === 'string' && cvId.trim() ? cvId.trim() : null;
    const normalizedSetRef = typeof cvSetRef === 'string' && cvSetRef.trim() ? cvSetRef.trim() : '';

    const cvMeta = normalizedCvId
      ? (userCvs || []).find((cv: any) => typeof cv?.cvId === 'string' && cv.cvId.trim() === normalizedCvId)
      : (normalizedSetRef ? (userCvs || []).find((cv: any) => doesCvMatchSetRef(cv, normalizedSetRef)) : null);

    const resolvedCvId =
      normalizedCvId ||
      (typeof cvMeta?.cvId === 'string' && cvMeta.cvId.trim() ? cvMeta.cvId.trim() : null);
    const resolvedCvSetRef = normalizedSetRef || (cvMeta ? getCvSetRef(cvMeta) : '');
    const stamp = cvMeta ? getCvMetaStamp(cvMeta) : `${resolvedCvId || resolvedCvSetRef}|no-meta`;

    if (resolvedCvId) {
      const cached = cvSnapshotCacheRef.current.get(resolvedCvId);
      const isFresh = !!cached && (Date.now() - cached.loadedAt) <= maxAgeMs && cached.stamp === stamp;
      if (!forceReload && isFresh && hasUsableCvSourceData(cached?.cvData)) {
        console.log('[CV-LOAD] cache-hit', {
          cvId: resolvedCvId,
          cvSetRef: resolvedCvSetRef || cached!.cvSetRef,
          fromCache: true
        });
        return {
          cvId: resolvedCvId,
          cvSetRef: resolvedCvSetRef || cached!.cvSetRef,
          cvData: cached!.cvData,
          fromCache: true
        };
      }
    }

    let cvData: any = null;
    if (resolvedCvId) {
      // Bei vorhandener cvId nie auf Listen-Metadaten zurückfallen:
      // immer Backend/Cache als einzige Quelle verwenden.
      cvData = await fetchCvDataById(resolvedCvId);
      if (!hasUsableCvSourceData(cvData)) {
        throw new Error(`CV-Snapshot konnte für cvId "${resolvedCvId}" nicht aus dem Backend geladen werden.`);
      }
    } else {
      cvData = sourceCvData;
      if (!hasUsableCvSourceData(cvData) && cvMeta?.data && hasUsableCvSourceData(cvMeta.data)) {
        cvData = cvMeta.data;
      }
      if (!hasUsableCvSourceData(cvData) && hasUsableCvSourceData(cvMeta)) {
        cvData = cvMeta;
      }
    }
    if (!hasUsableCvSourceData(cvData)) {
      throw new Error('CV-Snapshot konnte nicht geladen werden.');
    }

    if (resolvedCvId) {
      cvSnapshotCacheRef.current.set(resolvedCvId, {
        cvData,
        cvSetRef: resolvedCvSetRef,
        stamp,
        loadedAt: Date.now()
      });
    }

    console.log('[CV-LOAD] backend-fetch', {
      cvId: resolvedCvId,
      cvSetRef: resolvedCvSetRef,
      fromCache: false
    });

    return {
      cvId: resolvedCvId,
      cvSetRef: resolvedCvSetRef,
      cvData,
      fromCache: false
    };
  }

  async function resolveAndLoadCvSetOrThrow(options: {
    cv?: any;
    cvId?: string | null;
    cvSetRef?: string | null;
    sourceCvData?: any;
    forceReload?: boolean;
    maxAgeMs?: number;
    label?: string;
  }): Promise<{ cvId: string | null; cvSetRef: string; cvData: any; fromCache: boolean }> {
    const {
      cv,
      cvId,
      cvSetRef,
      sourceCvData,
      forceReload = false,
      maxAgeMs = 20000,
      label = 'CV'
    } = options || {};

    const derivedCvId =
      (typeof cvId === 'string' && cvId.trim()) ||
      (typeof cv?.cvId === 'string' && cv.cvId.trim()) ||
      null;
    const derivedCvSetRef =
      (typeof cvSetRef === 'string' && cvSetRef.trim()) ||
      (cv ? getCvSetRef(cv) : '');
    const derivedSource =
      sourceCvData !== undefined
        ? sourceCvData
        : (cv?.data && typeof cv.data === 'object' ? cv.data : null);

    if (!derivedCvId) {
      throw new Error(`${label}: cvId fehlt. Prozess wurde aus Sicherheitsgruenden abgebrochen.`);
    }

    if (derivedCvSetRef) {
      const setRefMeta = (userCvs || []).find((candidate: any) => doesCvMatchSetRef(candidate, derivedCvSetRef));
      const setRefCvId =
        typeof setRefMeta?.cvId === 'string' && setRefMeta.cvId.trim()
          ? setRefMeta.cvId.trim()
          : null;
      if (setRefCvId && setRefCvId !== derivedCvId) {
        throw new Error(
          `${label}: cvId/cvSetRef Mismatch erkannt (${derivedCvId} != ${setRefCvId}). Prozess wurde abgebrochen.`
        );
      }
    }

    const snapshot = await loadCvSnapshotForProcess({
      cvId: typeof derivedCvId === 'string' ? derivedCvId : null,
      cvSetRef: derivedCvSetRef || null,
      sourceCvData: derivedSource,
      forceReload,
      maxAgeMs
    });

    if (!hasUsableCvSourceData(snapshot?.cvData)) {
      throw new Error(`${label}: CV-Snapshot enthält keine verwertbaren Daten.`);
    }

    if (!snapshot?.cvId || (typeof snapshot.cvId === 'string' && !snapshot.cvId.trim())) {
      throw new Error(`${label}: CV-Snapshot ohne gueltige cvId ist nicht zulaessig.`);
    }

    return snapshot;
  }

  const applyCvSourceToEditorState = (source: any, cvNameOverride?: string): boolean => {
    if (!source || typeof source !== 'object') return false;

    const data = source;

    setFullName(data?.fullName || data?.personalInfo?.fullName || "");
    setCompany(data?.company || "");
    setAddress(data?.address || data?.personalInfo?.address || "");
    setPostalCode(data?.postalCode || data?.personalInfo?.postalCode || "");
    setCity(data?.city || data?.personalInfo?.city || "");
    setCountry(mapCountryToSelectValue(data?.country || data?.personalInfo?.country || ""));
    setAvailableFrom(data?.availableFrom || data?.personalInfo?.availableFrom || "");
    setPhoneNumber(data?.phoneNumber || data?.personalInfo?.phoneNumber || "");
    setEmail(data?.email || data?.personalInfo?.email || "");
    setBirthYear(data?.birthYear || data?.personalInfo?.birthYear || "");
    setNationality(mapNationalityToSelectValue(data?.nationality || data?.personalInfo?.nationality || ""));
    setResidencePermit(mapResidencePermitToSelectValue(data?.residencePermit || data?.personalInfo?.residencePermit || ""));
    setCivilStatus(mapCivilStatusToSelectValue(data?.civilStatus || data?.personalInfo?.civilStatus || ""));
    setShortProfile(data?.shortProfile || data?.personalInfo?.shortProfile || "");

    setWorkExperiences(data?.workExperiences || data?.workExperience || []);
    setEducations(data?.educations || data?.education || []);
    setCertifications(data?.certifications || []);
    setIndustryExperiences(data?.industryExperiences || []);
    setLanguages(Array.isArray(data?.languages) ? data.languages.map((lang: any) => ({
      ...lang,
      level: mapLanguageLevelToSelectValue(lang.level || lang.proficiency || '')
    })) : []);
    setCoreCompetencies(Array.isArray(data?.coreCompetencies) ? data.coreCompetencies : []);
    setItSkills(Array.isArray(data?.itSkills) ? data.itSkills.map((skill: any) => ({
      ...skill,
      level: mapItSkillLevelToSelectValue(skill.level || skill.proficiency || '')
    })) : []);
    setHobbies(normalizeHobbyList(data?.hobbies));
    setAdditionalInfo(Array.isArray(data?.additionalInfo) ? data.additionalInfo : []);

    if (data?.profileImage) {
      if (typeof data.profileImage === 'string') {
        setProfileImage(data.profileImage);
      } else if (data.profileImage.data) {
        setProfileImage(`data:${data.profileImage.type};base64,${data.profileImage.data}`);
      }
    } else {
      setProfileImage(null);
    }

    if (data?.signature) {
      if (typeof data.signature === 'string') {
        setSignature(data.signature);
      } else if (data.signature.data) {
        setSignature(`data:${data.signature.type};base64,${data.signature.data}`);
      }
    } else {
      setSignature(null);
    }

    if (typeof cvNameOverride === 'string' && cvNameOverride.trim()) {
      setCurrentCvName(cvNameOverride.trim());
    }

    return true;
  };

  const normalizeProfileImageValue = (value: any): string | null => {
    if (typeof value === 'string') {
      const trimmed = value.trim();
      return trimmed ? trimmed : null;
    }
    if (value && typeof value === 'object') {
      const base64Data = typeof value.data === 'string' ? value.data.trim() : '';
      const mimeType = typeof value.type === 'string' ? value.type.trim() : '';
      if (base64Data) {
        return mimeType ? `data:${mimeType};base64,${base64Data}` : `data:image/jpeg;base64,${base64Data}`;
      }
    }
    return null;
  };

  const normalizeExtractedJobInfo = (jobInfo: any) => {
    const normalizedCvSetRefs = Array.isArray(jobInfo?.cvSetRefs)
      ? jobInfo.cvSetRefs.filter((ref: any) => typeof ref === 'string' && ref.trim())
      : [];
    const normalizedCvIds = Array.isArray(jobInfo?.cvIds)
      ? jobInfo.cvIds.filter((id: any) => typeof id === 'string' && id.trim())
      : [];
    const getComparableTimestamp = (value: any): number => {
      if (value === null || value === undefined) return 0;
      if (typeof value === 'number' && Number.isFinite(value)) return value;
      if (typeof value === 'string') {
        const parsed = Date.parse(value);
        return Number.isFinite(parsed) ? parsed : 0;
      }
      if (typeof value === 'object') {
        const seconds = (value as any)?.seconds ?? (value as any)?._seconds;
        const nanoseconds = (value as any)?.nanoseconds ?? (value as any)?._nanoseconds ?? 0;
        if (typeof seconds === 'number' && Number.isFinite(seconds)) {
          return (seconds * 1000) + Math.floor((Number(nanoseconds) || 0) / 1_000_000);
        }
        if (typeof (value as any)?.toDate === 'function') {
          try {
            const asDate = (value as any).toDate();
            const ms = asDate instanceof Date ? asDate.getTime() : Date.parse(String(asDate));
            return Number.isFinite(ms) ? ms : 0;
          } catch {
            return 0;
          }
        }
      }
      return 0;
    };
    const latestChangedCv = (userCvs || [])
      .filter((cv: any) => !!getCvSetRef(cv))
      .reduce((latest: any, current: any) => {
        const latestTs = latest
          ? Math.max(
              getComparableTimestamp(latest?.lastModified),
              getComparableTimestamp(latest?.updatedAt),
              getComparableTimestamp(latest?.createdAt)
            )
          : -1;
        const currentTs = Math.max(
          getComparableTimestamp(current?.lastModified),
          getComparableTimestamp(current?.updatedAt),
          getComparableTimestamp(current?.createdAt)
        );
        return currentTs > latestTs ? current : latest;
      }, null);
    const latestChangedCvSetRef = latestChangedCv ? getCvSetRef(latestChangedCv) : '';
    const latestChangedCvId = latestChangedCv ? getNormalizedCvId(latestChangedCv?.cvId) : '';
    const derivedCvIdsFromSetRefs = normalizedCvSetRefs
      .map((setRef: string) => resolveCvIdBySetRefStrict(setRef))
      .filter((id: string | null): id is string => !!id);

    return {
      company: jobInfo?.company ?? '',
      publishDate: jobInfo?.publishDate ?? '',
      startDate: jobInfo?.startDate ?? '',
      contactInfo: jobInfo?.contactInfo ?? '',
      industry: jobInfo?.industry ?? '',
      roleTitle: jobInfo?.roleTitle ?? '',
      tasks: jobInfo?.tasks ?? '',
      requirements: jobInfo?.requirements ?? '',
      'requirements-muss': jobInfo?.['requirements-muss'] ?? '',
      'requirements-soll': jobInfo?.['requirements-soll'] ?? '',
      'requirements-kann': jobInfo?.['requirements-kann'] ?? '',
      applicationDetails: jobInfo?.applicationDetails ?? '',
      workload: jobInfo?.workload ?? '',
      keywords: Array.isArray(jobInfo?.keywords) ? jobInfo.keywords : [],
      cvSetRefs: normalizedCvSetRefs.length > 0
        ? normalizedCvSetRefs
        : (latestChangedCvSetRef ? [latestChangedCvSetRef] : []),
      cvIds: normalizedCvIds.length > 0
        ? normalizedCvIds
        : (derivedCvIdsFromSetRefs.length > 0
            ? derivedCvIdsFromSetRefs
            : (latestChangedCvId ? [latestChangedCvId] : []))
    };
  };

  const buildCvDataFromSource = (data: any) => ({
    personalInfo: {
      fullName: data?.fullName || data?.personalInfo?.fullName || '',
      address: data?.address || data?.personalInfo?.address || '',
      postalCode: data?.postalCode || data?.personalInfo?.postalCode || '',
      city: data?.city || data?.personalInfo?.city || '',
      country: data?.country || data?.personalInfo?.country || '',
      availableFrom: data?.availableFrom || data?.personalInfo?.availableFrom || '',
      phoneNumber: data?.phoneNumber || data?.personalInfo?.phoneNumber || '',
      email: data?.email || data?.personalInfo?.email || '',
      birthYear: data?.birthYear || data?.personalInfo?.birthYear || '',
      nationality: data?.nationality || data?.personalInfo?.nationality || '',
      residencePermit: data?.residencePermit || data?.personalInfo?.residencePermit || '',
      civilStatus: data?.civilStatus || data?.personalInfo?.civilStatus || '',
      shortProfile: data?.shortProfile || data?.personalInfo?.shortProfile || ''
    },
    workExperience: data?.workExperiences || data?.workExperience || [],
    education: data?.educations || data?.education || [],
    certifications: data?.certifications || [],
    languages: data?.languages || [],
    itSkills: data?.itSkills || [],
    coreCompetencies: data?.coreCompetencies || [],
    industryExperiences: data?.industryExperiences || [],
    hobbies: data?.hobbies || [],
    additionalInfo: data?.additionalInfo || []
  });

  const normalizeKeywordForMatching = (value: string): string =>
    value
      .toLowerCase()
      .replace(/[^a-z0-9äöüàâçéèêëîïôùûüÿñæœß\s+\-./#]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  const escapeRegex = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const parseDateForAvailabilityCheck = (value: any): Date | null => {
    if (value === null || value === undefined) return null;
    const normalized = String(value).trim();
    if (!normalized) return null;

    // ISO yyyy-mm-dd
    const isoDateMatch = normalized.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (isoDateMatch) {
      const year = Number(isoDateMatch[1]);
      const month = Number(isoDateMatch[2]);
      const day = Number(isoDateMatch[3]);
      if (year >= 1900 && month >= 1 && month <= 12 && day >= 1 && day <= 31) {
        return new Date(Date.UTC(year, month - 1, day));
      }
    }

    // ISO yyyy-mm -> als Monatserster interpretieren
    const isoMonthMatch = normalized.match(/^(\d{4})-(\d{2})$/);
    if (isoMonthMatch) {
      const year = Number(isoMonthMatch[1]);
      const month = Number(isoMonthMatch[2]);
      if (year >= 1900 && month >= 1 && month <= 12) {
        return new Date(Date.UTC(year, month - 1, 1));
      }
    }

    // yyyy -> als Jahresanfang interpretieren
    const yearMatch = normalized.match(/^(\d{4})$/);
    if (yearMatch) {
      const year = Number(yearMatch[1]);
      if (year >= 1900) {
        return new Date(Date.UTC(year, 0, 1));
      }
    }

    // dd.mm.yyyy oder dd/mm/yyyy
    const dmyMatch = normalized.match(/^(\d{1,2})[./](\d{1,2})[./](\d{4})$/);
    if (dmyMatch) {
      const day = Number(dmyMatch[1]);
      const month = Number(dmyMatch[2]);
      const year = Number(dmyMatch[3]);
      if (year >= 1900 && month >= 1 && month <= 12 && day >= 1 && day <= 31) {
        return new Date(Date.UTC(year, month - 1, day));
      }
    }

    const parsed = Date.parse(normalized);
    if (Number.isFinite(parsed)) {
      const parsedDate = new Date(parsed);
      return new Date(Date.UTC(parsedDate.getUTCFullYear(), parsedDate.getUTCMonth(), parsedDate.getUTCDate()));
    }

    return null;
  };

  const scoreCvAgainstKeywords = (
    searchText: string,
    keywords: string[]
  ): { score: number; matchedKeywords: string[] } => {
    if (!searchText || !Array.isArray(keywords) || keywords.length === 0) {
      return { score: 0, matchedKeywords: [] };
    }

    const matchedKeywords: string[] = [];
    let score = 0;

    keywords.forEach((keyword) => {
      const normalizedKeyword = normalizeKeywordForMatching(keyword);
      if (!normalizedKeyword || normalizedKeyword.length < 2) return;

      const wholeWordRegex = new RegExp(`\\b${escapeRegex(normalizedKeyword)}\\b`, 'i');
      if (wholeWordRegex.test(searchText)) {
        matchedKeywords.push(keyword);
        score += 3;
        return;
      }

      if (searchText.includes(normalizedKeyword)) {
        matchedKeywords.push(keyword);
        score += 1;
      }
    });

    return { score, matchedKeywords };
  };

  const createCvTextFromData = (data: any) => {
    let cvText = '';

    if (data.personalInfo?.fullName) cvText += `${getTranslatedCvLabel('Name:')} ${data.personalInfo.fullName}\n`;
    if (data.personalInfo?.address) cvText += `${getTranslatedCvLabel('Adresse:')} ${data.personalInfo.address}\n`;
    if (data.personalInfo?.postalCode) cvText += `${getTranslatedCvLabel('PLZ:')} ${data.personalInfo.postalCode}\n`;
    if (data.personalInfo?.city) cvText += `${getTranslatedCvLabel('Stadt:')} ${data.personalInfo.city}\n`;
    if (data.personalInfo?.country) cvText += `${getTranslatedCvLabel('Land:')} ${data.personalInfo.country}\n`;
    if (data.personalInfo?.availableFrom) cvText += `${getTranslatedCvLabel('Verfügbar ab:')} ${data.personalInfo.availableFrom}\n`;
    if (data.personalInfo?.phoneNumber) cvText += `${getTranslatedCvLabel('Telefon:')} ${data.personalInfo.phoneNumber}\n`;
    if (data.personalInfo?.email) cvText += `${getTranslatedCvLabel('Email:')} ${data.personalInfo.email}\n`;
    if (data.personalInfo?.birthYear) cvText += `${getTranslatedCvLabel('Geburtsjahr:')} ${data.personalInfo.birthYear}\n`;
    if (data.personalInfo?.nationality) cvText += `${getTranslatedCvLabel('Nationalität:')} ${data.personalInfo.nationality}\n`;
    if (data.personalInfo?.residencePermit) cvText += `${getTranslatedCvLabel('Aufenthaltsbewilligung:')} ${data.personalInfo.residencePermit}\n`;
    if (data.personalInfo?.civilStatus) cvText += `${getTranslatedCvLabel('Familienstand:')} ${data.personalInfo.civilStatus}\n`;
    if (data.personalInfo?.shortProfile) cvText += `${getTranslatedCvLabel('Profil:')} ${data.personalInfo.shortProfile}\n`;

    if (Array.isArray(data.workExperience) && data.workExperience.length > 0) {
      cvText += '\nArbeitserfahrung:\n';
      data.workExperience.forEach((exp: any) => {
        cvText += `${exp.position} bei ${exp.company} (${exp.startDate} - ${exp.endDate})\n`;
        if (exp.description) cvText += `${exp.description}\n`;
      });
    }

    if (Array.isArray(data.education) && data.education.length > 0) {
      cvText += '\nAusbildung:\n';
      data.education.forEach((edu: any) => {
        const description = edu.description ? ` - ${edu.description}` : '';
        cvText += `${edu.degree}${description} an ${edu.institution} (${edu.startDate} - ${edu.endDate})\n`;
      });
    }

    if (Array.isArray(data.certifications) && data.certifications.length > 0) {
      cvText += '\nZertifikate:\n';
      data.certifications.forEach((cert: any) => {
        const certName = cert.name || cert.certification || '';
        const description = cert.description ? ` - ${cert.description}` : '';
        cvText += `${certName}${description} - ${cert.issuer} (${cert.date})\n`;
      });
    }

    if (Array.isArray(data.itSkills) && data.itSkills.length > 0) {
      cvText += '\nIT-Skills:\n';
      data.itSkills.forEach((skill: any) => {
        cvText += `${skill.skill} (${skill.level})\n`;
      });
    }

    if (Array.isArray(data.languages) && data.languages.length > 0) {
      cvText += '\nSprachen:\n';
      data.languages.forEach((lang: any) => {
        cvText += `${lang.language} (${lang.level})\n`;
      });
    }

    if (Array.isArray(data.hobbies) && data.hobbies.length > 0) {
      cvText += '\nHobbys:\n';
      data.hobbies.forEach((hobby: any) => {
        cvText += `${hobby.hobby}: ${hobby.description}\n`;
      });
    }

    if (Array.isArray(data.additionalInfo) && data.additionalInfo.length > 0) {
      cvText += '\nZusätzliche Informationen:\n';
      data.additionalInfo.forEach((info: any) => {
        cvText += `${info.info}: ${info.details}\n`;
      });
    }

    if (Array.isArray(data.coreCompetencies) && data.coreCompetencies.length > 0) {
      cvText += '\nKernkompetenzen:\n';
      data.coreCompetencies.forEach((comp: any) => {
        cvText += `${comp.competency}\n`;
      });
    }

    if (Array.isArray(data.industryExperiences) && data.industryExperiences.length > 0) {
      cvText += '\nBranchenerfahrungen:\n';
      data.industryExperiences.forEach((exp: any) => {
        cvText += `${exp.industry} (${exp.years} Jahre)\n`;
      });
    }

    return cvText;
  };

  const buildCvKeywordSearchText = (cv: any, cvData: any): string => {
    const cvText = createCvTextFromData(cvData);
    const nameText = typeof cv?.cvName === 'string' ? cv.cvName : '';
    const emailText = typeof cv?.email === 'string' ? cv.email : '';
    return normalizeKeywordForMatching([cvText, nameText, emailText].join(' '));
  };
  
  
  // Lade Applications beim App-Start
  React.useEffect(() => {
    const loadApplications = async () => {
      if (!user) return;
      
      setLoadingApplications(true);
      // Deaktiviere Motivationsschreiben-Icon beim Laden der Applications
      setCvTemplateHasBeenOpened(false);
      
      try {
        const idToken = await user.getIdToken();
        const response = await fetch(`${config.backend.baseUrl}/api/get-job-descriptions`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${idToken}`
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          setApplications(data.applications || []);
          console.log('✅ Applications geladen:', data.count);
          // Debug: Prüfe ob URLs vorhanden sind
          if (data.applications && data.applications.length > 0) {
            data.applications.forEach((app: any, index: number) => {
              if (app.jobUrl) {
                console.log(`🔗 Application ${index + 1} (${app.id}) hat URL:`, app.jobUrl);
              }
            });
          }
        }
      } catch (error) {
        console.error('❌ Fehler beim Laden der Applications:', error);
      } finally {
        setLoadingApplications(false);
      }
    };
    
    loadApplications();
  }, [user]);

  // Realtime-Sync für Applications via Firestore (ersetzt Status-Polling)
  React.useEffect(() => {
    if (!user) return;

    const unsubscribers: Array<() => void> = [];
    const applicationsCol = collection(db, 'applications');

    const applyRealtimePatch = (realtimeApplications: any[]) => {
      if (!Array.isArray(realtimeApplications) || realtimeApplications.length === 0) return;

      const realtimeMap = new Map(realtimeApplications.map((app: any) => [app.id, app]));

      setApplications((prev: any[]) => {
        const byId = new Map(prev.map((app: any) => [app.id, app]));

        realtimeApplications.forEach((realtimeApp: any) => {
          const current = byId.get(realtimeApp.id);
          if (!current) {
            byId.set(realtimeApp.id, realtimeApp);
            return;
          }

          byId.set(realtimeApp.id, {
            ...current,
            status: realtimeApp.status ?? current.status,
            matchScore: realtimeApp.matchScore ?? current.matchScore,
            missingSkills: Array.isArray(realtimeApp.missingSkills) ? realtimeApp.missingSkills : current.missingSkills,
            weaknesses: Array.isArray(realtimeApp.weaknesses) ? realtimeApp.weaknesses : current.weaknesses,
            cvMatchResults: Array.isArray(realtimeApp.cvMatchResults) ? realtimeApp.cvMatchResults : current.cvMatchResults
          });
        });

        return Array.from(byId.values());
      });

      setSelectedApplication((prev: any) => {
        if (!prev?.id) return prev;
        const realtimeApp = realtimeMap.get(prev.id);
        if (!realtimeApp) return prev;

        return {
          ...prev,
          status: realtimeApp.status ?? prev.status,
          matchScore: realtimeApp.matchScore ?? prev.matchScore,
          missingSkills: Array.isArray(realtimeApp.missingSkills) ? realtimeApp.missingSkills : prev.missingSkills,
          weaknesses: Array.isArray(realtimeApp.weaknesses) ? realtimeApp.weaknesses : prev.weaknesses,
          cvMatchResults: Array.isArray(realtimeApp.cvMatchResults) ? realtimeApp.cvMatchResults : prev.cvMatchResults
        };
      });
    };

    const attachListener = (q: any) => {
      const unsubscribe = onSnapshot(
        q,
        (snapshot: any) => {
          const docs = snapshot.docs.map((docSnap: any) => ({
            id: docSnap.id,
            ...docSnap.data()
          }));
          applyRealtimePatch(docs);
        },
        (error: any) => {
          console.warn('⚠️ Realtime-Listener für Applications fehlgeschlagen:', error);
        }
      );
      unsubscribers.push(unsubscribe);
    };

    attachListener(query(applicationsCol, where('userId', '==', user.uid)));

    let isCancelled = false;
    (async () => {
      try {
        const userDocRef = doc(db, 'users', user.uid);
        const userDocSnap = await getDoc(userDocRef);
        if (isCancelled || !userDocSnap.exists()) return;

        const accountId = userDocSnap.data()?.accountId;
        if (!accountId) return;

        attachListener(query(applicationsCol, where('accountId', '==', accountId)));
      } catch (error) {
        console.warn('⚠️ Konnte Account-Realtime-Listener nicht initialisieren:', error);
      }
    })();

    return () => {
      isCancelled = true;
      unsubscribers.forEach((unsubscribe) => {
        try {
          unsubscribe();
        } catch {
          // noop
        }
      });
    };
  }, [user]);

  // Lade CV-Daten beim App-Start
  React.useEffect(() => {
    const loadUserCvs = async () => {
      if (!user) {
        setCvDataLoaded(true); // Wenn kein User, markiere als geladen (keine Daten zu laden)
        return;
      }
      
      try {
        const idToken = await user.getIdToken();
        const response = await fetch(`${config.backend.baseUrl}/api/get-user-cvs`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${idToken}`
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          setUserCvs(data.userCvs || []);
          
          // Prüfe ob das aktuell ausgewählte CV noch in der Liste existiert
          if (selectedCvId && data.userCvs && data.userCvs.length > 0) {
            const cvStillExists = data.userCvs.find((cv: any) => cv.cvId === selectedCvId);
            if (!cvStillExists) {
              console.log('⚠️ Ausgewähltes CV existiert nicht mehr:', selectedCvId, '→ wechsle auf verfügbares CV');
              localStorage.removeItem('selectedCvId');
              const fallbackCv = data.userCvs.find((cv: any) => cv.isDefault) || data.userCvs[0];
              if (fallbackCv && fallbackCv.cvId) {
                await handleSelectCv(fallbackCv.cvId, false);
              } else {
                setSelectedCvId(null);
                setCurrentCvName('');
              }
            }
          }
          
          // Wähle automatisch das gespeicherte CV, Standard-CV oder den neuesten CV aus
          if (data.userCvs && data.userCvs.length > 0 && !selectedCvId) {
            // 1. Versuche selectedCvId aus localStorage zu laden
            const savedCvId = localStorage.getItem('selectedCvId');
            let cvToSelect = null;
            
            if (savedCvId) {
              // Prüfe, ob das gespeicherte CV noch existiert
              cvToSelect = data.userCvs.find((cv: any) => cv.cvId === savedCvId);
              if (cvToSelect) {
                console.log('✅ Lade gespeichertes CV aus localStorage:', savedCvId);
              }
            }
            
            // 2. Falls nicht gefunden, verwende Standard-CV
            if (!cvToSelect) {
              cvToSelect = data.userCvs.find((cv: any) => cv.isDefault);
              if (cvToSelect) {
                console.log('✅ Lade Standard-CV:', cvToSelect.cvId);
              }
            }
            
            // 3. Falls kein Standard-CV, verwende den neuesten CV
            if (!cvToSelect) {
              cvToSelect = data.userCvs[0];
              if (cvToSelect) {
                console.log('✅ Lade neuesten CV:', cvToSelect.cvId);
              }
            }
            
            if (cvToSelect && cvToSelect.cvId) {
              // Lade CV, aber setze es nur als Standard, wenn es noch nicht als Standard gesetzt ist
              const shouldSetAsDefault = !cvToSelect.isDefault && savedCvId === cvToSelect.cvId;
              await handleSelectCv(cvToSelect.cvId, false, shouldSetAsDefault);
            }
          }
        }
        // Markiere als geladen, auch wenn die Antwort nicht ok war
        setCvDataLoaded(true);
      } catch (error) {
        console.error('❌ Fehler beim Laden der CV-Daten:', error);
        // Markiere als geladen, auch bei Fehler (damit die Prüfung nicht ewig wartet)
        setCvDataLoaded(true);
      }
    };
    
    setCvDataLoaded(false); // Zurücksetzen beim Neuladen
    loadUserCvs();
  }, [user]);

  const handleMatchCvSetsByKeywords = async () => {
    if (!user || !Array.isArray(userCvs) || userCvs.length === 0 || !extractedJobInfo) return;
    if (matchingCvSetsByKeywords) return;

    const normalizedKeywords = (Array.isArray(extractedJobInfo.keywords) ? extractedJobInfo.keywords : [])
      .map((keyword: any) => (typeof keyword === 'string' ? keyword.trim() : ''))
      .filter((keyword: string) => keyword.length > 0);
    if (normalizedKeywords.length === 0) return;
    const validKeywordsForScoring = normalizedKeywords.filter((keyword: string) => {
      const normalizedKeyword = normalizeKeywordForMatching(keyword);
      return !!normalizedKeyword && normalizedKeyword.length >= 2;
    });
    if (validKeywordsForScoring.length === 0) return;
    const maxKeywordScore = validKeywordsForScoring.length * 3;
    const minRequiredKeywordScore = Math.ceil(maxKeywordScore * (Math.max(0, Math.min(100, keywordMatchMinPercent)) / 100));

    const normalizedStartDate = parseDateForAvailabilityCheck(extractedJobInfo?.startDate);
    const latestAllowedAvailabilityDate = normalizedStartDate
      ? (() => {
          const maxDate = new Date(normalizedStartDate.getTime());
          maxDate.setUTCMonth(maxDate.getUTCMonth() + 1);
          return maxDate;
        })()
      : null;

    const requestId = ++cvKeywordAutoSelectionRequestIdRef.current;
    setMatchingCvSetsByKeywords(true);
    try {
      const idToken = await user.getIdToken();
      const cvsWithIds = userCvs.filter((cv: any) => typeof cv?.cvId === 'string' && cv.cvId.trim());

      const scoredEntries = await Promise.allSettled(
        cvsWithIds.map(async (cv: any) => {
          const cvId = cv.cvId.trim();
          if (!cvId) return null;

          let searchText = cvKeywordSearchCacheRef.current.get(cvId);
          let loadedCvData: any = null;
          if (!searchText || latestAllowedAvailabilityDate) {
            const response = await fetch(`${config.backend.baseUrl}/api/get-encrypted-data/${cvId}`, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${idToken}`
              }
            });
            if (!response.ok) return null;
            const result = await response.json();
            const cvPayload = result?.data || {};
            loadedCvData = buildCvDataFromSource(cvPayload);
            if (!searchText) {
              searchText = buildCvKeywordSearchText(cv, loadedCvData);
              cvKeywordSearchCacheRef.current.set(cvId, searchText);
            }
          }

          let passesAvailabilityRule = true;
          if (latestAllowedAvailabilityDate) {
            const rawAvailableFrom =
              loadedCvData?.availableFrom ||
              loadedCvData?.personalInfo?.availableFrom ||
              cv?.availableFrom ||
              '';
            const availableFromDate = parseDateForAvailabilityCheck(rawAvailableFrom);
            // Regel:
            // - Kein Datum im CV => CV bleibt zulässig
            // - Datum im CV vorhanden => maximal bis Startdatum + 1 Monat
            if (availableFromDate && availableFromDate.getTime() > latestAllowedAvailabilityDate.getTime()) {
              passesAvailabilityRule = false;
            }
          }

          const { score, matchedKeywords } = scoreCvAgainstKeywords(searchText || '', normalizedKeywords);
          const matchPercent = maxKeywordScore > 0
            ? Math.max(0, Math.min(100, Math.round((score / maxKeywordScore) * 100)))
            : 0;
          const passesKeywordThreshold = score >= minRequiredKeywordScore && matchedKeywords.length > 0;

          return {
            cvSetRef: getCvSetRef(cv),
            cvId,
            score,
            matchedCount: matchedKeywords.length,
            matchPercent,
            passesKeywordThreshold,
            passesAvailabilityRule
          };
        })
      );

      if (requestId !== cvKeywordAutoSelectionRequestIdRef.current) return;

      const nextMatchPercentByCvId: Record<string, number> = {};
      scoredEntries.forEach((entry: any) => {
        if (entry?.status !== 'fulfilled' || !entry?.value) return;
        const cvId = getNormalizedCvId(entry.value.cvId);
        const percent = typeof entry.value.matchPercent === 'number' ? entry.value.matchPercent : null;
        if (!cvId || percent === null) return;
        nextMatchPercentByCvId[cvId] = Math.max(0, Math.min(100, Math.round(percent)));
      });
      setCvKeywordMatchPercentByCvId(nextMatchPercentByCvId);

      const ranked = scoredEntries
        .filter((entry: any) =>
          entry.status === 'fulfilled' &&
          entry.value?.cvSetRef &&
          entry.value?.passesKeywordThreshold &&
          entry.value?.passesAvailabilityRule
        )
        .map((entry: any) => entry.value)
        .sort((a: any, b: any) => {
          if (b.score !== a.score) return b.score - a.score;
          return b.matchedCount - a.matchedCount;
        });

      if (ranked.length === 0) {
        let hasSelectionChanged = false;
        setExtractedJobInfo((prev) => {
          if (!prev) return prev;
          const prevRefs = Array.isArray(prev.cvSetRefs)
            ? prev.cvSetRefs.filter((ref: any) => typeof ref === 'string' && ref.trim())
            : [];
          const prevIds = Array.isArray(prev.cvIds)
            ? prev.cvIds.filter((id: any) => typeof id === 'string' && id.trim())
            : [];
          if (prevRefs.length === 0 && prevIds.length === 0) return prev;
          hasSelectionChanged = true;
          return { ...prev, cvSetRefs: [], cvIds: [] };
        });
        if (hasSelectionChanged) {
          setHasJobInfoChangedSinceLastMatch(true);
        }
        return;
      }

      const maxAutoSelectedCvSets = isMultiCvSelectionAllowed ? 3 : 1;
      const autoSelectedRefs = ranked.slice(0, maxAutoSelectedCvSets).map((entry: any) => entry.cvSetRef);
      const autoSelectedCvIds = ranked.slice(0, maxAutoSelectedCvSets).map((entry: any) => entry.cvId).filter((id: any) => typeof id === 'string' && id.trim());
      if (autoSelectedRefs.length === 0) return;

      let hasSelectionChanged = false;
      setExtractedJobInfo((prev) => {
        if (!prev) return prev;
        const refs = Array.isArray(prev.cvSetRefs)
          ? prev.cvSetRefs.filter((ref: any) => typeof ref === 'string' && ref.trim())
          : [];
        const refsNormalized = refs.map((ref: string) => ref.trim());
        const isSameSelection =
          refsNormalized.length === autoSelectedRefs.length &&
          refsNormalized.every((ref: string, index: number) => ref === autoSelectedRefs[index]);
        if (isSameSelection) return prev;
        hasSelectionChanged = true;
        return { ...prev, cvSetRefs: autoSelectedRefs, cvIds: autoSelectedCvIds };
      });
      if (hasSelectionChanged) {
        setHasJobInfoChangedSinceLastMatch(true);
      }
    } catch (error) {
      console.warn('⚠️ Manuelles CV-Keyword-Matching fehlgeschlagen:', error);
    } finally {
      if (requestId === cvKeywordAutoSelectionRequestIdRef.current) {
        setMatchingCvSetsByKeywords(false);
      }
    }
  };

  // Lade Basisdaten (fullName, email) beim App-Start
  React.useEffect(() => {
    const loadUserBasic = async () => {
      if (!user) return;
      try {
        const idToken = await user.getIdToken();
        const response = await fetch(`${config.backend.baseUrl}/api/get-user-basic`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${idToken}`
          }
        });
        if (response.ok) {
          const data = await response.json();
          setUserBasic({ fullName: data.fullName || '', email: data.email || '' });
        }
      } catch (e) {
        // ignore
      }
    };
    loadUserBasic();
  }, [user]);
  
  // Setze Zielsprache basierend auf jobDescriptionLanguage
  React.useEffect(() => {
    const languageMap: { [key: string]: string } = {
      'de': 'deutsch',
      'DE': 'deutsch',
      'fr': 'französisch',
      'FR': 'französisch',
      'it': 'italienisch',
      'IT': 'italienisch',
      'en': 'englisch',
      'EN': 'englisch'
    };
    
    const newTargetLanguage = languageMap[jobDescriptionLanguage] || 'deutsch';
    setTargetLanguage(newTargetLanguage);
  }, [jobDescriptionLanguage]);
  const [detectingLanguage, setDetectingLanguage] = useState(false);

  const [, setError] = useState<string | null>(null);
  // originalCvText wurde entfernt - nicht mehr benötigt
  const [fullName, setFullName] = useState('');
  const [company, setCompany] = useState('');
  const [address, setAddress] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [city, setCity] = useState('');
  const [country, setCountry] = useState('');
  const [availableFrom, setAvailableFrom] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [birthYear, setBirthYear] = useState('');
  const [nationality, setNationality] = useState('');
  const [residencePermit, setResidencePermit] = useState('');
  const [civilStatus, setCivilStatus] = useState('');
  const [drivingLicense, setDrivingLicense] = useState('');
  const [shortProfile, setShortProfile] = useState('');
  const [workExperience, setWorkExperience] = useState('');
  const [education, setEducation] = useState('');
  const [certificates, setCertificates] = useState('');
  const [languages, setLanguages] = useState<Array<{language: string; level: string}>>([]);
  const [coreCompetencies, setCoreCompetencies] = useState<Array<{competency: string}>>([]);
  const [itSkills, setItSkills] = useState<Array<{skill: string; level: string}>>([]);
  const [additionalInfo, setAdditionalInfo] = useState<Array<{info: string; details: string}>>([]);
  const [hobbies, setHobbies] = useState<Array<{hobby: string; description: string}>>([]);
  const [optimizedImages, setOptimizedImages] = useState<Array<{id: number; name: string; description: string; image: string; optimizationInstructions?: string; isOriginal?: boolean; isOptimized?: boolean; isMask?: boolean}>>([]);
  const [showImageOptimizer, setShowImageOptimizer] = useState(false);
  const [workExperiences, setWorkExperiences] = useState<Array<{company: string; position: string; startDate: string; endDate: string; description: string; industry?: string}>>([]);
  const [draftWorkExperiences, setDraftWorkExperiences] = useState<Array<{company: string; position: string; startDate: string; endDate: string; description: string; industry?: string}>>([]);
  const [educations, setEducations] = useState<Array<{institution: string; degree: string; description?: string; startDate: string; endDate: string}>>([]);
  const [draftEducations, setDraftEducations] = useState<Array<{institution: string; degree: string; description?: string; startDate: string; endDate: string}>>([]);
  const [certifications, setCertifications] = useState<Array<{name: string; description?: string; issuer: string; date: string}>>([]);
  const [draftCertifications, setDraftCertifications] = useState<Array<{name: string; description?: string; issuer: string; date: string}>>([]);
  const [industryExperiences, setIndustryExperiences] = useState<Array<{industry: string; years: string}>>([]);
  const [profileImage, setProfileImage] = useState<string | null>(null);
  const [showQrCodeDialog, setShowQrCodeDialog] = useState(false);

  const normalizeComparableText = (value: any): string => {
    const raw = (value ?? '').toString().toLowerCase();

    // Keep this compatible with older JS targets/browsers:
    // - avoid Unicode property escapes (\p{...})
    // - avoid the unicode RegExp flag "u"
    // Best-effort: remove diacritics if String#normalize exists.
    const normalized = typeof (raw as any).normalize === 'function' ? (raw as any).normalize('NFKD') : raw;
    const withoutDiacritics = normalized.replace(/[\u0300-\u036f]/g, '');

    return withoutDiacritics
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  };

  const normalizeHobbyValue = (item: any): string => {
    if (typeof item === 'string') {
      const hobbyNamePart = item.split(':')[0] || '';
      return normalizeComparableText(hobbyNamePart);
    }

    const rawValue = item?.hobby ?? item?.name ?? item?.title ?? '';
    return normalizeComparableText(rawValue);
  };

  const normalizeHobbyItem = (item: any): { hobby: string; description: string } => {
    if (typeof item === 'string') {
      const parts = item.split(':');
      const hobby = (parts.shift() || '').toString().trim();
      const description = parts.join(':').toString().trim();
      return { hobby, description };
    }

    const hobby = (item?.hobby ?? item?.name ?? item?.title ?? '').toString().trim();
    const description = (item?.description ?? item?.details ?? '').toString().trim();
    return { hobby, description };
  };

  const normalizeHobbyList = (items: any): Array<{ hobby: string; description: string }> => {
    if (!Array.isArray(items)) return [];

    const seen = new Set<string>();
    return items.reduce((acc: Array<{ hobby: string; description: string }>, item: any) => {
      const normalizedItem = normalizeHobbyItem(item);
      const hobbyKey = normalizeHobbyValue(normalizedItem);
      if (!hobbyKey || seen.has(hobbyKey)) return acc;
      seen.add(hobbyKey);
      acc.push(normalizedItem);
      return acc;
    }, []);
  };

  const isSameHobbyEntry = (left: any, right: any): boolean => {
    const leftKey = normalizeHobbyValue(left);
    const rightKey = normalizeHobbyValue(right);
    if (!leftKey || !rightKey) return false;
    if (leftKey === rightKey) return true;

    // Tolerant comparison for legacy variants like "lesen freizeit" vs "lesen".
    if (leftKey.length >= 4 && rightKey.length >= 4) {
      return leftKey.includes(rightKey) || rightKey.includes(leftKey);
    }
    return false;
  };
  
  
  const [qrCodeData, setQrCodeData] = useState<string | null>(null);
  const [qrSessionId, setQrSessionId] = useState<string | null>(null);
  

  const [qrExpiresAt, setQrExpiresAt] = useState<string | null>(null);
  const [isGeneratingQr, setIsGeneratingQr] = useState(false);
  const [signature, setSignature] = useState<string | null>(null);
  const [, setOriginalCvMarkdown] = useState<string | null>(null);
  const [extracting, setExtracting] = useState(false);
  const [extractingJobUrl, setExtractingJobUrl] = useState(false); // State für URL-Extraktion
  
  // State für Import-Fortschrittsanzeige
  const [importProgress, setImportProgress] = useState<{[key: string]: 'pending' | 'running' | 'completed' | 'failed'}>({});
  
  // Funktion zum Abrufen des passenden Icons für jedes Thema
  const getTopicIcon = (topicName: string, status: string) => {
    // Blau-violettes Farbschema für abgeschlossene Tasks (wie CV Hochladen Button)
    const iconColor = status === 'completed' ? '#667eea' : 'grey.400';
    const isAnimated = status !== 'completed';
    
    const iconSx = {
      fontSize: 24, 
      color: iconColor,
      ...(isAnimated && {
        animation: 'pulse 2s ease-in-out infinite',
        '@keyframes pulse': {
          '0%': {
            opacity: 0.4,
            transform: 'scale(1)',
          },
          '50%': {
            opacity: 0.8,
            transform: 'scale(1.05)',
          },
          '100%': {
            opacity: 0.4,
            transform: 'scale(1)',
          },
        },
      }),
    };
    
    switch (topicName) {
      case 'Text extrahieren':
        return <DescriptionOutlinedIcon sx={iconSx} />;
      case 'Persönliche Informationen':
        return <PersonIcon sx={iconSx} />;
      case 'Kernkompetenzen':
        return <StarOutlineIcon sx={iconSx} />;
      case 'Branchen':
        return <BusinessCenterOutlinedIcon sx={iconSx} />;
      case 'Hobbies':
        return <SportsOutlinedIcon sx={iconSx} />;
      case 'IT-Skills':
        return <ComputerOutlinedIcon sx={iconSx} />;
      case 'Sprachen':
        return <LanguageOutlinedIcon sx={iconSx} />;
      case 'Ausbildung':
        return <SchoolOutlinedIcon sx={iconSx} />;
      case 'Zertifizierungen':
        return <WorkspacePremiumOutlinedIcon sx={iconSx} />;
      case 'Berufserfahrung':
        return <WorkOutlineIcon sx={iconSx} />;
      case 'Weitere Angaben':
        return <InfoOutlinedIcon sx={iconSx} />;
      default:
        return <DescriptionOutlinedIcon sx={iconSx} />;
    }
  };

  // Funktion zum Abrufen des passenden Icons für Optimierungs-Fortschritt
  const getOptimizationIcon = (taskName: string, status: string) => {
    // Blau-violettes Farbschema für abgeschlossene Tasks (wie CV Hochladen Button)
    const iconColor = status === 'completed' ? '#667eea' : 'grey.400';
    const isAnimated = status !== 'completed';
    
    const iconSx = {
      fontSize: 24, 
      color: iconColor,
      ...(isAnimated && {
        animation: 'pulse 2s ease-in-out infinite',
        '@keyframes pulse': {
          '0%': {
            opacity: 0.4,
            transform: 'scale(1)',
          },
          '50%': {
            opacity: 0.8,
            transform: 'scale(1.05)',
          },
          '100%': {
            opacity: 0.4,
            transform: 'scale(1)',
          },
        },
      }),
    };
    
    switch (taskName) {
      case 'Kurzprofil':
        return <PersonIcon sx={iconSx} />;
      case 'Arbeitserfahrung':
        return <WorkOutlineIcon sx={iconSx} />;
      case 'Kernkompetenzen':
        return <StarOutlineIcon sx={iconSx} />;
      case 'Branchen':
        return <BusinessCenterOutlinedIcon sx={iconSx} />;
      case 'Hobbies':
        return <SportsOutlinedIcon sx={iconSx} />;
      case 'Hobbys':
        return <SportsOutlinedIcon sx={iconSx} />;
      case 'IT-Skills':
        return <ComputerOutlinedIcon sx={iconSx} />;
      case 'Sprachen':
        return <LanguageOutlinedIcon sx={iconSx} />;
      case 'Ausbildung':
        return <SchoolOutlinedIcon sx={iconSx} />;
      case 'Zertifizierungen':
        return <WorkspacePremiumOutlinedIcon sx={iconSx} />;
      case 'Zertifikate':
        return <WorkspacePremiumOutlinedIcon sx={iconSx} />;
      case 'Weitere Informationen':
        return <InfoOutlinedIcon sx={iconSx} />;
      case 'Weitere Angaben':
        return <InfoOutlinedIcon sx={iconSx} />;
      default:
        return <DescriptionOutlinedIcon sx={iconSx} />;
    }
  };
  const [matchScore, setMatchScore] = useState<number | null>(null);
  const [missingSkills, setMissingSkills] = useState<string[]>([]);
  const [hiddenMissingSkills, setHiddenMissingSkills] = useState<Set<number>>(new Set());
  
  const [weaknesses, setWeaknesses] = useState<string[]>([]);
  const [hiddenWeaknesses, setHiddenWeaknesses] = useState<Set<number>>(new Set());
  
  // Hilfsfunktion zum Zurücksetzen aller Match-Daten
  const resetMatchData = () => {
    setMissingSkills([]);
    setWeaknesses([]);
    setHiddenMissingSkills(new Set());
    setHiddenWeaknesses(new Set());
  };

  const applyMatchDetails = (score: number | null, missing: string[], weak: string[]) => {
    setMatchScore(score);
    setMissingSkills(missing);
    setWeaknesses(weak);
    setHiddenMissingSkills(new Set());
    setHiddenWeaknesses(new Set());
  };

  const hasAnyMatchData = (score: number | null, missing: string[], weak: string[]) => {
    return score !== null || missing.length > 0 || weak.length > 0;
  };

  const hasCompleteMatchData = (score: number | null, missing: string[], weak: string[]) => {
    return score !== null && (missing.length > 0 || weak.length > 0);
  };

  const normalizeMatchList = (value: any): string[] => {
    const pickObjectText = (entry: any): string | null => {
      if (!entry || typeof entry !== 'object') return null;

      const preferredKeys = [
        'text',
        'skill',
        'weakness',
        'name',
        'title',
        'label',
        'description',
        'value'
      ];

      for (const key of preferredKeys) {
        const candidate = entry[key];
        if (typeof candidate === 'string' && candidate.trim()) {
          return candidate.trim();
        }
      }

      const firstStringValue = Object.values(entry).find(
        (item) => typeof item === 'string' && item.trim()
      ) as string | undefined;

      return firstStringValue ? firstStringValue.trim() : null;
    };

    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (!trimmed) return [];
      if ((trimmed.startsWith('[') && trimmed.endsWith(']')) || (trimmed.startsWith('{') && trimmed.endsWith('}'))) {
        try {
          return normalizeMatchList(JSON.parse(trimmed));
        } catch {
          // Fallback unten
        }
      }
      return trimmed
        .split(/\n|,|;/)
        .map((part) => part.trim())
        .filter(Boolean);
    }

    if (Array.isArray(value)) {
      return value
        .map((item) => {
          if (typeof item === 'string') return item.trim();
          return pickObjectText(item);
        })
        .filter((item): item is string => Boolean(item));
    }

    if (value && typeof value === 'object') {
      // Falls versehentlich ein Wrapper-Objekt geliefert wird
      const nestedKeys = ['items', 'list', 'values', 'missingSkills', 'weaknesses', 'missing_skills'];
      for (const key of nestedKeys) {
        if (value[key] !== undefined) {
          return normalizeMatchList(value[key]);
        }
      }
      return Object.values(value)
        .map((item) => {
          if (typeof item === 'string') return item.trim();
          return pickObjectText(item);
        })
        .filter((item): item is string => Boolean(item));
    }

    return [];
  };

  type MatchPriority = 'MUSS' | 'SOLL' | 'KANN';

  const PRIORITY_ALIASES: Record<MatchPriority, string[]> = {
    MUSS: ['MUSS', 'MUST', 'REQUIRED', 'OBLIGATOIRE', 'OBBLIGATORIO'],
    SOLL: ['SOLL', 'SHOULD', 'PREFERRED', 'SOUHAITE', 'PREFERENZIALE'],
    KANN: ['KANN', 'OPTIONAL', 'NICE TO HAVE', 'NICE-TO-HAVE', 'OPTIONNEL', 'FACOLTATIVO']
  };

  const normalizePriorityToken = (token: string) =>
    token
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase()
      .replace(/\s+/g, ' ')
      .trim();

  const mapPriorityToken = (token: string): MatchPriority | null => {
    const normalized = normalizePriorityToken(token);
    for (const [priority, aliases] of Object.entries(PRIORITY_ALIASES) as [MatchPriority, string[]][]) {
      if (aliases.includes(normalized)) return priority;
    }
    return null;
  };

  const parseMatchPriority = (rawText: string): { priority: MatchPriority | null; text: string } => {
    const value = String(rawText || '').trim();
    const match = value.match(/^([^:]{2,40})\s*:\s*(.+)$/);
    if (!match) {
      return { priority: null, text: value };
    }
    const priority = mapPriorityToken(match[1]);
    if (!priority) {
      return { priority: null, text: value };
    }
    return {
      priority,
      text: match[2].trim()
    };
  };

  const getPriorityChipSx = (priority: MatchPriority) => {
    if (priority === 'MUSS') {
      return {
        height: 20,
        fontSize: '0.65rem',
        fontWeight: 700,
        backgroundColor: '#fee2e2',
        color: '#b91c1c',
        border: '1px solid #fecaca'
      };
    }
    if (priority === 'SOLL') {
      return {
        height: 20,
        fontSize: '0.65rem',
        fontWeight: 700,
        backgroundColor: '#fef3c7',
        color: '#92400e',
        border: '1px solid #fde68a'
      };
    }
    return {
      height: 20,
      fontSize: '0.65rem',
      fontWeight: 700,
      backgroundColor: '#dbeafe',
      color: '#1d4ed8',
      border: '1px solid #bfdbfe'
    };
  };

  const getPriorityChipLabel = (priority: MatchPriority) => {
    const normalizedLanguage = (currentLanguage || 'de').toLowerCase();
    const language = normalizedLanguage.startsWith('en') ? 'en'
      : normalizedLanguage.startsWith('fr') ? 'fr'
      : normalizedLanguage.startsWith('it') ? 'it'
      : normalizedLanguage.startsWith('de') ? 'de'
      : normalizedLanguage.includes('englisch') ? 'en'
      : normalizedLanguage.includes('franz') ? 'fr'
      : normalizedLanguage.includes('ital') ? 'it'
      : 'de';

    const labels: Record<'de' | 'en' | 'fr' | 'it', Record<MatchPriority, string>> = {
      de: { MUSS: 'MUSS', SOLL: 'SOLL', KANN: 'KANN' },
      en: { MUSS: 'MUST', SOLL: 'SHOULD', KANN: 'OPTIONAL' },
      fr: { MUSS: 'OBLIGATOIRE', SOLL: 'SOUHAITE', KANN: 'OPTIONNEL' },
      it: { MUSS: 'OBBLIGATORIO', SOLL: 'PREFERENZIALE', KANN: 'FACOLTATIVO' }
    };

    return labels[language][priority];
  };

  const getApplicationMatchPayload = (application: any, expectedCvId: string | null) => {
    if (!application) return null;
    if (expectedCvId && application.cvId && application.cvId !== expectedCvId) return null;
    if (application.matchScore === null || application.matchScore === undefined) return null;

    return {
      matchScore: typeof application.matchScore === 'number' ? application.matchScore : null,
      missingSkills: normalizeMatchList(application.missingSkills),
      weaknesses: normalizeMatchList(application.weaknesses)
    };
  };

  // Funktion zum Löschen/Leeren von Passgenauigkeiten, optimierten CV-Daten und Motivationsschreiben
  const clearOptimizedAndMatchData = (preserveMatchScore: boolean = false) => {
    // Passgenauigkeit zurücksetzen (nur wenn nicht explizit erhalten werden soll)
    if (!preserveMatchScore) {
      setMatchScore(null);
    }
    resetMatchData();
    
    // Motivationsschreiben löschen
    setMotivationLetter(null);
    
    // Optimierte CV-Daten löschen
    setOptimizedShortProfile('');
    setOptimizedWorkExperiences([]);
    
    // Relevante Daten löschen
    setRelevantWorkExperiences([]);
    setRelevantItSkills([]);
    setRelevantCertifications([]);
    setRelevantCoreCompetencies([]);
    setRelevantIndustries([]);
    setRelevantHobbies([]);
    setRelevantAdditionalInfo([]);
    setRelevantEducations([]);
    setRelevantLanguages([]);
    
    // Optimierte persönliche Angaben löschen
    setOptimizedFullName('');
    setOptimizedCompany('');
    setOptimizedAddress('');
    setOptimizedPostalCode('');
    setOptimizedCity('');
    setOptimizedPhoneNumber('');
    setOptimizedEmail('');
    setOptimizedBirthYear('');
    setOptimizedNationality('');
    setOptimizedResidencePermit('');
    setOptimizedCivilStatus('');
    
    console.log('✅ Passgenauigkeiten, optimierte CV-Daten und Motivationsschreiben gelöscht');
  };
  
  // Handler für das Verstecken von fehlenden Skills
  const handleHideMissingSkill = (index: number) => {
    setHiddenMissingSkills(prev => {
      const newSet = new Set(prev);
      newSet.add(index);
      return newSet;
    });
  };
  
  // Handler für das Verstecken von Schwächen
  const handleHideWeakness = (index: number) => {
    setHiddenWeaknesses(prev => {
      const newSet = new Set(prev);
      newSet.add(index);
      return newSet;
    });
  };
  
  const [checkingMatch, setCheckingMatch] = useState(false);
  const [checkingMatchInModal, setCheckingMatchInModal] = useState(false);
  const [improvedCvText, setImprovedCvText] = useState<string | null>(null);
  const [optimizing, setOptimizing] = useState(false);
  const wasOptimizingRef = useRef(false);
  const [optimizationProgress, setOptimizationProgress] = useState<{[key: string]: 'pending' | 'running' | 'completed' | 'failed'}>({});
  const [motivationLetter, setMotivationLetter] = useState<string | null>(null);
  const [motivationTitle, setMotivationTitle] = useState<string>('');
  const [showMotivationBorder, setShowMotivationBorder] = useState<boolean>(false);
  const [showCvBorder, setShowCvBorder] = useState<boolean>(false);
  const [showFrames, setShowFrames] = useState<boolean>(false);
  const [, setForceShowCvData] = useState<boolean>(false);
  
  // Kombinierte Funktion für beide Rahmen-Typen
  const toggleAllBorders = () => {
    setShowCvBorder(!showCvBorder);
    setShowFrames(!showFrames);
  };

  const [motivationGreeting, setMotivationGreeting] = useState<string>('');
  const [, setMotivationRecipientInfo] = useState<any>(null);
  
  // States für editierbare Motivationsschreiben-Felder
  const [motivationSenderName, setMotivationSenderName] = useState<string>('');
  const [motivationSenderAddress, setMotivationSenderAddress] = useState<string>('');
  const [motivationSenderPostalCode, setMotivationSenderPostalCode] = useState<string>('');
  const [motivationSenderCity, setMotivationSenderCity] = useState<string>('');
  const [motivationRecipientCompany, setMotivationRecipientCompany] = useState<string>('');
  const [motivationRecipientContactPerson, setMotivationRecipientContactPerson] = useState<string>('');
  const [motivationRecipientAddress, setMotivationRecipientAddress] = useState<string>('');
  const [motivationRecipientPostalCode, setMotivationRecipientPostalCode] = useState<string>('');
  const [motivationRecipientCity, setMotivationRecipientCity] = useState<string>('');
  const [motivationClosingText, setMotivationClosingText] = useState<string>(() => {
    const defaultClosing = 'Mit freundlichen Grüßen';
    // Initialisierung wird im useEffect basierend auf userCountry angepasst
    return defaultClosing;
  });
  const [motivationDateLocation, setMotivationDateLocation] = useState<string>('');
  const [motivationSignatureName, setMotivationSignatureName] = useState<string>('');
  const [creatingMotivation, setCreatingMotivation] = useState(false);
  const [loadingCvPreview, setLoadingCvPreview] = useState(false);
  const [downloadingPdf, setDownloadingPdf] = useState(false);
  
  // Passe die Grussformel an die erkannte Sprache der Stellenausschreibung an,
  // sofern keine AI-Anrede geliefert wurde oder der Nutzer sie nicht manuell gesetzt hat
  React.useEffect(() => {
    const languageToGreeting: Record<string, string> = {
      'DE': 'Sehr geehrte Damen und Herren,',
      'EN': 'Dear Hiring Team,',
      'FR': 'Madame, Monsieur,',
      'IT': 'Gentili Signore e Signori,'
    };
    const mapped = languageToGreeting[jobDescriptionLanguage] || languageToGreeting['DE'];
    // Nur setzen, wenn aktuell leer oder nur Whitespace
    if (!motivationGreeting || motivationGreeting.trim().length === 0) {
      setMotivationGreeting(mapped);
    }
  }, [jobDescriptionLanguage]);

  // Passe die Abschluss-Grussformel an die erkannte Sprache an,
  // sofern sie leer ist oder dem Standard entspricht (nicht manuell gesetzt)
  React.useEffect(() => {
    const languageToClosing: Record<string, string> = {
      'DE': 'Mit freundlichen Grüßen',
      'EN': 'Kind regards',
      'FR': 'Cordialement',
      'IT': 'Cordiali saluti'
    };
    let mapped = languageToClosing[jobDescriptionLanguage] || languageToClosing['DE'];
    // Ersetze ß durch ss für Schweizer Benutzer
    if (userCountry === 'CH') {
      mapped = mapped.replace(/ß/g, 'ss');
    }
    const current = (motivationClosingText || '').trim();
    const knownClosings = Object.values(languageToClosing);
    // Auch bekannte Grußformeln für Vergleich anpassen, wenn CH
    const adjustedCurrent = userCountry === 'CH' ? current.replace(/ß/g, 'ss') : current;
    const adjustedKnownClosings = userCountry === 'CH' 
      ? knownClosings.map(c => c.replace(/ß/g, 'ss'))
      : knownClosings;
    if (current.length === 0 || adjustedKnownClosings.includes(adjustedCurrent)) {
      setMotivationClosingText(mapped);
    }
  }, [jobDescriptionLanguage, userCountry]);

  // Temporäre States für Motivationsschreiben-Bearbeitung (werden erst beim Schließen gespeichert)
  const [tempMotivationTitle, setTempMotivationTitle] = useState<string>('');
  const [tempMotivationGreeting, setTempMotivationGreeting] = useState<string>('');
  const [tempMotivationLetter, setTempMotivationLetter] = useState<string>('');
  const [tempMotivationSenderName, setTempMotivationSenderName] = useState<string>('');
  const [tempMotivationSenderAddress, setTempMotivationSenderAddress] = useState<string>('');
  const [tempMotivationSenderPostalCode, setTempMotivationSenderPostalCode] = useState<string>('');
  const [tempMotivationSenderCity, setTempMotivationSenderCity] = useState<string>('');
  const [tempMotivationRecipientCompany, setTempMotivationRecipientCompany] = useState<string>('');
  const [tempMotivationRecipientContactPerson, setTempMotivationRecipientContactPerson] = useState<string>('');
  const [tempMotivationRecipientAddress, setTempMotivationRecipientAddress] = useState<string>('');
  const [tempMotivationRecipientPostalCode, setTempMotivationRecipientPostalCode] = useState<string>('');
  const [tempMotivationRecipientCity, setTempMotivationRecipientCity] = useState<string>('');
  const [tempMotivationClosingText, setTempMotivationClosingText] = useState<string>('');
  const [tempMotivationDateLocation, setTempMotivationDateLocation] = useState<string>('');
  const [tempMotivationSignatureName, setTempMotivationSignatureName] = useState<string>('');
  const [motivationInput, setMotivationInput] = useState<string>(''); // Eingabe für Motivation
  const [generatedMotivationText, setGeneratedMotivationText] = useState<string>(''); // Anzeige des erstellten Motivationsschreibens
  const [showMotivationPromptInput, setShowMotivationPromptInput] = useState(false);
  const [motivationPromptText, setMotivationPromptText] = useState('');
  const [optimizingMotivationPrompt, setOptimizingMotivationPrompt] = useState(false);
  // History-Stack für Undo/Redo im Motivationsschreiben-Modal
  const [motivationHistory, setMotivationHistory] = useState<string[]>([]);
  const [motivationHistoryIndex, setMotivationHistoryIndex] = useState(-1);
  const motivationHistoryRef = React.useRef<{ history: string[]; index: number }>({ history: [], index: -1 });
  const isMotivationUndoRedoAction = React.useRef(false);
  const skipTemplateWarningForIconFlowRef = React.useRef(false);

  const [tabIndex, setTabIndex] = useState(0);
  const [mainTabIndex, setMainTabIndex] = useState(0);
  const [cvTabIndex, setCvTabIndex] = useState(0);
  const [bewerbungenSubTabIndex, setBewerbungenSubTabIndex] = useState(0); // Sub-Tabs für Bewerbungen
  const cvDataTabContentRef = useRef<HTMLDivElement | null>(null);
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };
  const handleCvTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setCvTabIndex(newValue);
  };

  React.useEffect(() => {
    if (cvDataTabContentRef.current) {
      cvDataTabContentRef.current.scrollTop = 0;
    }
  }, [tabIndex]);


  const [hasLoaded, setHasLoaded] = useState(false);
  const [tabSelectionExecuted, setTabSelectionExecuted] = useState(false);
  const [cvDataLoaded, setCvDataLoaded] = useState(false);
  const [showCvImportWarningDialog, setShowCvImportWarningDialog] = useState(false);
  const [showCvTemplateWarningDialog, setShowCvTemplateWarningDialog] = useState(false);
  const [showMotivationWarningDialog, setShowMotivationWarningDialog] = useState(false);
  const [dontShowImportWarning, setDontShowImportWarning] = useState(false);
  const [dontShowTemplateWarning, setDontShowTemplateWarning] = useState(false);
  const [dontShowMotivationWarning, setDontShowMotivationWarning] = useState(false);
  const [newWorkExperience, setNewWorkExperience] = useState({ company: '', position: '', startDate: '', endDate: '', description: '', industry: '' });
  const [showNewWorkExperienceForm, setShowNewWorkExperienceForm] = useState(false);
  const [, setNewEducation] = useState({ institution: '', degree: '', startDate: '', endDate: '' });
  const [, setShowNewEducationForm] = useState(false);


  const handleCoreCompetencyChange = (index: number, text: string) => {
    const updatedCompetencies = [...coreCompetencies];
    if (updatedCompetencies[index]) {
      updatedCompetencies[index] = { competency: text };
      setCoreCompetencies(updatedCompetencies);
 // Setze Checkbox auf false bei manuellen Änderungen
      markCvDataAsChanged(); // Markiere als ungespeichert
    }
  };

  const handleCoreCompetenciesTitleChange = (title: string) => {
    setCurrentCoreCompetenciesTitle(title);
  };

  const handleCertificationsTitleChange = (title: string) => {
    setCurrentCertificationsTitle(title);
  };

  const handleItSkillsTitleChange = (title: string) => {
    setCurrentItSkillsTitle(title);
  };

  const handleIndustriesTitleChange = (title: string) => {
    setCurrentIndustriesTitle(title);
  };

  const handleLanguagesTitleChange = (title: string) => {
    setCurrentLanguagesTitle(title);
  };

  const handleHobbiesTitleChange = (title: string) => {
    setCurrentHobbiesTitle(title);
  };

  const handleEducationTitleChange = (title: string) => {
    setCurrentEducationTitle(title);
  };

  const handleWorkExperienceTitleChange = (title: string) => {
    setCurrentWorkExperienceTitle(title);
  };

  const handleProfileTitleChange = (title: string) => {
    setCurrentProfileTitle(title);
  };

  
  // State für minimierte/maximierte Tabs
  const [, setMinimizedSections] = useState({
    industryExperiences: false,
    workExperience: false,
    education: false,
    certifications: false,
    languages: false,
    coreCompetencies: false,
    itSkills: false,
    additionalInfo: false,
    hobbies: false
  });
  
  // State für das Ausblenden des Stellenbeschreibung-Textfelds
  const [hideJobDescription, setHideJobDescription] = useState(false);
  
  // State für Info-Nachrichten
  const [, setInfoMessage] = useState(getTranslatedInfoMessage('upload_cv'));
  
  // Funktion zum Aktualisieren der Info-Nachricht basierend auf dem Zustand
  const updateInfoMessage = () => {
    if (hasOptimizedCvData() && cvTemplateHasBeenOpened && motivationLetter) {
      setInfoMessage(getTranslatedInfoMessage('open_cv_and_motivation'));
    } else if (hasOptimizedCvData() && cvTemplateHasBeenOpened && !motivationLetter) {
      setInfoMessage(getTranslatedInfoMessage('open_cv_create_motivation'));
    } else if (hasOptimizedCvData() && !cvTemplateHasBeenOpened) {
      setInfoMessage(''); // Kein Info-Text während CV-Optimierung läuft und Template noch nicht geöffnet wurde
    } else if (hasData() && jobDescription.trim() && matchScore !== null && !optimizedShortProfile.trim()) {
      setInfoMessage(getTranslatedInfoMessage('match_results'));
    } else if (hasData() && jobDescription.trim()) {
      setInfoMessage(getTranslatedInfoMessage('enter_job_description'));
    } else if (hasData()) {
      setInfoMessage(getTranslatedInfoMessage('enter_job_description'));
    } else {
      setInfoMessage(getTranslatedInfoMessage('upload_cv'));
    }
  };

  // Update Info-Nachricht wenn sich die UI-Sprache ändert
  React.useEffect(() => {
    updateInfoMessage();
  }, [currentLanguage]);
  
  
  // State für Template-System (verknüpft mit dem neuen Template-System)


  const [showTemplatePreviewDialog, setShowTemplatePreviewDialog] = useState(false);
  const [cvPreviewPageCount, setCvPreviewPageCount] = useState(1);
  const [showMotivationDialog, setShowMotivationDialog] = useState(false);

  const [cvTemplateHasBeenOpened, setCvTemplateHasBeenOpened] = useState(false);
  const [cvTemplateSettingsSaved, setCvTemplateSettingsSaved] = useState(false);
  
  // Referenz zum Tracken ob Dialog gerade geöffnet wurde
  const dialogJustOpenedRef = React.useRef(false);

  // Initialisiere temporäre States nur beim ersten Öffnen des Modals
  React.useEffect(() => {
    if (showMotivationDialog && dialogJustOpenedRef.current) {
      setTempMotivationTitle(motivationTitle);
      setTempMotivationGreeting(motivationGreeting);
      setTempMotivationLetter(motivationLetter || '');
      setTempMotivationSenderName(motivationSenderName);
      setTempMotivationSenderAddress(motivationSenderAddress);
      setTempMotivationSenderPostalCode(motivationSenderPostalCode);
      setTempMotivationSenderCity(motivationSenderCity);
      setTempMotivationRecipientCompany(motivationRecipientCompany);
      setTempMotivationRecipientContactPerson(motivationRecipientContactPerson);
      setTempMotivationRecipientAddress(motivationRecipientAddress);
      setTempMotivationRecipientPostalCode(motivationRecipientPostalCode);
      setTempMotivationRecipientCity(motivationRecipientCity);
      setTempMotivationClosingText(motivationClosingText);
      setTempMotivationDateLocation(motivationDateLocation);
      setTempMotivationSignatureName(motivationSignatureName);
      dialogJustOpenedRef.current = false;
      // History mit aktuellem Motivationstext initialisieren
      const currentMotivation = generatedMotivationText || motivationLetter || '';
      const initialHistory = [currentMotivation];
      setMotivationHistory(initialHistory);
      setMotivationHistoryIndex(0);
      motivationHistoryRef.current = { history: initialHistory, index: 0 };
    }
    if (!showMotivationDialog) {
      // History beim Schließen des Modals zurücksetzen
      setMotivationHistory([]);
      setMotivationHistoryIndex(-1);
      motivationHistoryRef.current = { history: [], index: -1 };
    }
  }, [showMotivationDialog, motivationTitle, motivationGreeting, motivationLetter, motivationSenderName, 
      motivationSenderAddress, motivationSenderPostalCode, motivationSenderCity, motivationRecipientCompany,
      motivationRecipientContactPerson, motivationRecipientAddress, motivationRecipientPostalCode,
      motivationRecipientCity, motivationClosingText, motivationDateLocation, motivationSignatureName]);
  
  // Template-Switcher States
  const [selectedTemplateId, setSelectedTemplateId] = useState<'template1' | 'template2' | 'template3'>('template1');
  const [cvSettings, setCvSettings] = useState<CvSettings>(defaultCvSettings);

  useEffect(() => {
    const optimizationJustFinished = wasOptimizingRef.current && !optimizing;
    wasOptimizingRef.current = optimizing;

    if (optimizationJustFinished && showTemplatePreviewDialog) {
      window.dispatchEvent(new CustomEvent('templateReflow'));
    }
  }, [optimizing, showTemplatePreviewDialog]);
  
  // Template-Mapping für das alte System
  const getTemplateStyle = (templateId: 'template1' | 'template2' | 'template3'): 'modern' | 'professional' | 'classic' => {
    switch (templateId) {
      case 'template1': return 'modern';
      case 'template2': return 'professional';
      case 'template3': return 'classic';
      default: return 'modern';
    }
  };



  
  // State für CV-Daten-Bearbeitungsmodus - verfolgt ob "CV-Daten bearbeiten" geklickt wurde
  const [, setCvDataEditMode] = useState(false);
  
  // State für das Ausblenden der Upload-Buttons - versteckt sie nach Klick auf "Daten manuell befüllen"
  const [, setHideUploadButtons] = useState(false);
  
  // Flag: Manuelle CV-Erstellung - wenn true, wird beim Speichern ein neues CV erstellt statt ein bestehendes zu aktualisieren
  const [, setIsManualCvCreation] = useState(false);
  
  // State für das Ausblenden der Buttons nach Klick auf "Neue Stellenbeschreibung erfassen"

  
  // State für das Ausblenden der optimierten CV-Daten - standardmäßig minimiert
  const [hideOptimizedCvData, setHideOptimizedCvData] = useState(true);
  
  // State für das Ausblenden der Prompt-Daten - standardmäßig minimiert
  const [hidePromptData, setHidePromptData] = useState(true);
  
  // State für Benutzerrollen
  const [userRole, setUserRole] = useState<string>('Normal'); // 'Normal' oder 'Admin'
  const [, setLoadingUserRole] = useState(true);
  
  // User Dropdown Menu State
  const [userMenuAnchorEl, setUserMenuAnchorEl] = useState<null | HTMLElement>(null);
  const isUserMenuOpen = Boolean(userMenuAnchorEl);
  
  // CV-Daten-Set Dropdown State (für Tooltip-Steuerung)
  const [, setCvDropdownOpen] = useState(false);
  const [cvDropdownSearchText, setCvDropdownSearchText] = useState('');
  
  // State für CV-Template Settings Menu
  const [, setCvSettingsMenuAnchorEl] = useState<null | HTMLElement>(null);
  
  // State für Konto-Modal
  const [accountModalOpen, setAccountModalOpen] = useState(false);
  const [accountType, setAccountType] = useState<'Free' | 'Basic' | 'Pro' | 'Beta-Testing'>('Free');
  const [accountName, setAccountName] = useState('');
  const [loadingCvDesignSettings, setLoadingCvDesignSettings] = useState(false);
  const [cvDesignSettingsLoaded, setCvDesignSettingsLoaded] = useState(false);
  const [upgradeModalOpen, setUpgradeModalOpen] = useState(false);
  const [upgradeModalReason, setUpgradeModalReason] = useState<'freePlan' | 'pdfLimitReached'>('freePlan');
  
  // State für Stripe Subscription
  const [pricingModalOpen, setPricingModalOpen] = useState(false);
  const [hasStripeSubscription, setHasStripeSubscription] = useState(false);
  const [, setSubscriptionStatus] = useState<string | null>(null);
  const [cancelAtPeriodEnd, setCancelAtPeriodEnd] = useState(false);
  const [currentPeriodEnd, setCurrentPeriodEnd] = useState<string | null>(null);
  
  // Subscription-Daten von Stripe synchronisieren (Fallback wenn Webhook fehlt)
  const syncSubscription = React.useCallback(async () => {
    if (!user) return;
    try {
      const token = await user.getIdToken();
      const response = await fetch(`${config.backend.fullApiUrl}/api/stripe/sync-subscription`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
      });
      if (response.ok) {
        const data = await response.json();
        if (data.synced) {
          setHasStripeSubscription(data.hasSubscription || false);
          setSubscriptionStatus(data.status || null);
          setCancelAtPeriodEnd(data.cancelAtPeriodEnd || false);
          setCurrentPeriodEnd(data.currentPeriodEnd || null);
          if (data.planType) {
            setAccountType(data.planType as any);
          }
          return true;
        }
        if (data.expired) {
          // Abo abgelaufen, Backend hat auf Free zurückgesetzt
          setAccountType('Free');
          setHasStripeSubscription(false);
          setCancelAtPeriodEnd(false);
          setCurrentPeriodEnd(null);
          setSubscriptionStatus(null);
          return false;
        }
      }
    } catch (error) {
      console.error('Fehler beim Synchronisieren der Subscription:', error);
    }
    return false;
  }, [user]);

  // Subscription-Status laden
  const loadSubscriptionStatus = React.useCallback(async () => {
    if (!user) return;
    try {
      const token = await user.getIdToken();
      const response = await fetch(`${config.backend.fullApiUrl}/api/stripe/subscription-status`, {
        headers: { 'Authorization': `Bearer ${token}` },
      });
      if (response.ok) {
        const data = await response.json();
        setHasStripeSubscription(data.hasSubscription || false);
        setSubscriptionStatus(data.status || null);
        setCancelAtPeriodEnd(data.cancelAtPeriodEnd || false);
        setCurrentPeriodEnd(data.currentPeriodEnd || null);
        if (data.planType && data.planType !== accountType) {
          setAccountType(data.planType as any);
        }
        // Falls Bezahlplan aber Daten unvollständig: Stripe-Sync starten
        const needsSync = data.planType && data.planType !== 'Free' && data.planType !== 'Beta-Testing' && 
          (!data.hasSubscription || !data.currentPeriodEnd);
        if (needsSync) {
          console.log('Subscription-Daten unvollständig, synchronisiere mit Stripe...');
          await syncSubscription();
        }
        // Falls gekündigt und Periodenende überschritten: Sync prüft ob Abo noch existiert
        if (data.cancelAtPeriodEnd && data.currentPeriodEnd && new Date(data.currentPeriodEnd) < new Date()) {
          console.log('Abo-Periodenende überschritten, prüfe bei Stripe...');
          const synced = await syncSubscription();
          if (!synced) {
            // Keine aktive Subscription mehr bei Stripe → auf Free setzen
            setAccountType('Free');
            setHasStripeSubscription(false);
            setCancelAtPeriodEnd(false);
            setCurrentPeriodEnd(null);
          }
        }
      }
    } catch (error) {
      console.error('Fehler beim Laden des Subscription-Status:', error);
    }
  }, [user, accountType, syncSubscription]);
  
  // Subscription-Status beim Start und nach Rückkehr von Stripe laden
  React.useEffect(() => {
    if (user && accountId) {
      loadSubscriptionStatus();
      // Prüfe ob User gerade von Stripe zurückkommt
      const params = new URLSearchParams(window.location.search);
      if (params.get('subscription') === 'success') {
        // Stripe-Daten synchronisieren nach Checkout
        syncSubscription().then(() => {
          loadSubscriptionStatus();
          loadAccountType();
        });
        // URL bereinigen
        window.history.replaceState({}, '', window.location.pathname);
      } else if (params.get('subscription') === 'cancelled') {
        window.history.replaceState({}, '', window.location.pathname);
      }
    }
  }, [user, accountId, loadSubscriptionStatus, loadAccountType, syncSubscription]);

  // Funktion zur Ermittlung der Account-Limits
  const getAccountLimits = (type: 'Free' | 'Basic' | 'Pro' | 'Beta-Testing') => {
    switch (type) {
      case 'Beta-Testing':
        return { maxUsers: Infinity, maxCvs: Infinity };
      case 'Free':
        return { maxUsers: 1, maxCvs: 1 };
      case 'Basic':
        return { maxUsers: 1, maxCvs: 3 };
      case 'Pro':
        return { maxUsers: 5, maxCvs: 20 };
      default:
        return { maxUsers: 1, maxCvs: 1 };
    }
  };
  const isMultiCvSelectionAllowed = accountType === 'Pro' || accountType === 'Beta-Testing';
  React.useEffect(() => {
    if (isMultiCvSelectionAllowed || !extractedJobInfo) return;
    const selectedRefs = Array.isArray(extractedJobInfo.cvSetRefs)
      ? extractedJobInfo.cvSetRefs.filter((ref: any) => typeof ref === 'string' && ref.trim())
      : [];
    if (selectedRefs.length <= 1) return;

    const reducedRefs = selectedRefs.slice(-1);
    const reducedCvIds = reducedRefs
      .map((setRef: string) => resolveCvIdBySetRefStrict(setRef))
      .filter((id: string | null): id is string => !!id);
    setExtractedJobInfo((prev) => (prev ? { ...prev, cvSetRefs: reducedRefs, cvIds: reducedCvIds } : prev));
    setHasJobInfoChangedSinceLastMatch(true);
  }, [isMultiCvSelectionAllowed, extractedJobInfo]);

  const [savingAccountType, setSavingAccountType] = useState(false);
  const [accountUsers, setAccountUsers] = useState<any[]>([]);
  const [loadingAccountUsers, setLoadingAccountUsers] = useState(false);
  const [inviteEmail, setInviteEmail] = useState('');
  const [invitingUser, setInvitingUser] = useState(false);
  const [inviteSuccess, setInviteSuccess] = useState(false);
  const [inviteLink, setInviteLink] = useState<string | null>(null);
  const [emailSent, setEmailSent] = useState(false);
  const [, setLastInvitedEmail] = useState<string>('');
  const [deletingUserId, setDeletingUserId] = useState<string | null>(null);
  const [updatingUserRoleId, setUpdatingUserRoleId] = useState<string | null>(null);
  
  // State für Farben
  const [leftColumnColor, setLeftColumnColor] = useState('#f8f6f2');
  const [leftColumnAlpha, setLeftColumnAlpha] = useState(1); // Alpha-Wert für linke Spalte (0-1)
  const [topBoxColor, setTopBoxColor] = useState('#f8f6f2'); // Initial gleiche Farbe wie linke Spalte
  const [topBoxAlpha, setTopBoxAlpha] = useState(0); // Alpha-Wert für Header-Box (0-1), default 0 (100% transparent)
  
  // State für Color-Picker-Modal
  const [openColorPickerModal, setOpenColorPickerModal] = useState(false);
  const [currentColorPicker, setCurrentColorPicker] = useState<'header' | 'column' | 'name' | 'leftTitle' | 'leftText' | 'rightTitle' | 'rightText' | null>(null);
  const [tempColor, setTempColor] = useState('#000000');
  const [tempAlpha, setTempAlpha] = useState(1);
  
  // State für Header-Box-Bild
  const [topBoxImage, setTopBoxImage] = useState<string>(''); // Bild für Header-Box (Base64)
  
  // State für linke Spalte Bild
  const [leftColumnImage, setLeftColumnImage] = useState<string>(''); // Bild für linke Spalte (Base64)
  
  // State für Grafik-Upload-Modal
  const [showImageUploadModal, setShowImageUploadModal] = useState(false);
  const [imageTypeToUpload, setImageTypeToUpload] = useState<'header' | 'column' | null>(null);

  // Debug-Log für Admin-Bereiche
  // Debug Admin-Bereiche entfernt für bessere Performance
  
  // State für die Option, das Foto im CV anzuzeigen oder nicht
  const [showPhotoInCv, setShowPhotoInCv] = useState(true);
  
  // Keine Default-Prompts - nur Firebase-Prompts verwenden
 
  
        // States für das Prompt-Editor Modal
  const [promptEditorOpen, setPromptEditorOpen] = useState(false);
  const [editingPromptIndex, setEditingPromptIndex] = useState<number | null>(null);
  const [editingPromptText, setEditingPromptText] = useState('');
  const [editingPromptVersion, setEditingPromptVersion] = useState<string>('gpt-4o');
  const [editingPromptUsage, setEditingPromptUsage] = useState<string>('Optimierung');
  const [editingPromptTemperature, setEditingPromptTemperature] = useState<string>('0.0');
  const [editingPromptMaxTokens, setEditingPromptMaxTokens] = useState<string>('8000');
  const [editingPromptName, setEditingPromptName] = useState<string>('');
  const [originalPromptName, setOriginalPromptName] = useState<string>(''); // Speichert den ursprünglichen Namen
  
  // State für Prompt-Testing
  const [testResult, setTestResult] = useState<string>('');
  const [isTesting, setIsTesting] = useState(false);
  const [showMitgelieferteDaten, setShowMitgelieferteDaten] = useState(false);
  const [showVerwendeteDatensets, setShowVerwendeteDatensets] = useState(false);
  const [editingPromptSystemRole, setEditingPromptSystemRole] = useState<string>('Du bist ein Experte für CV-Optimierung.');


  // Verfügbare ChatGPT-Versionen mit Informationen
  const chatGptVersions = [
    {
      value: 'gpt-5.2',
      label: 'GPT-5.2',
      description: 'Neueste Generation, höchste Qualität',
      speed: 'Schnell',
      quality: 'Exzellent',
      speedColor: '#4caf50',
      qualityColor: '#9c27b0',
      details: '400K Kontext, $1.75/$14.00 pro 1M Tokens'
    },
    {
      value: 'gpt-5.2-pro',
      label: 'GPT-5.2 Pro',
      description: 'Premium-Version für komplexeste Aufgaben',
      speed: 'Mittel',
      quality: 'Maximum',
      speedColor: '#ff9800',
      qualityColor: '#9c27b0',
      details: '400K Kontext, $21.00/$168.00 pro 1M Tokens'
    },
    {
      value: 'gpt-5-mini',
      label: 'GPT-5 Mini',
      description: 'Kompakt und günstig, GPT-5 Qualität',
      speed: 'Sehr schnell',
      quality: 'Sehr hoch',
      speedColor: '#4caf50',
      qualityColor: '#2196f3',
      details: '400K Kontext, $0.25/$2.00 pro 1M Tokens'
    },
    {
      value: 'gpt-4o',
      label: 'GPT-4o',
      description: 'Leistungsfähige GPT-4 Version',
      speed: 'Schnell',
      quality: 'Sehr hoch',
      speedColor: '#4caf50',
      qualityColor: '#2196f3',
      details: 'Multimodal, sehr schnell, beste Qualität'
    },
    {
      value: 'gpt-4o-mini',
      label: 'GPT-4o Mini',
      description: 'Kompakte Version von GPT-4o',
      speed: 'Sehr schnell',
      quality: 'Hoch',
      speedColor: '#4caf50',
      qualityColor: '#4caf50',
      details: 'Schneller als GPT-4o, etwas geringere Qualität'
    },
    {
      value: 'gpt-4-turbo',
      label: 'GPT-4 Turbo',
      description: 'Optimierte Version von GPT-4',
      speed: 'Mittel',
      quality: 'Sehr hoch',
      speedColor: '#ff9800',
      qualityColor: '#2196f3',
      details: 'Gute Qualität, moderate Geschwindigkeit'
    },
    {
      value: 'gpt-3.5-turbo',
      label: 'GPT-3.5 Turbo',
      description: 'Schnelle und kostengünstige Version',
      speed: 'Sehr schnell',
      quality: 'Mittel',
      speedColor: '#4caf50',
      qualityColor: '#ff9800',
      details: 'Sehr schnell, moderate Qualität, günstig'
    },
    {
      value: 'gpt-4',
      label: 'GPT-4',
      description: 'Klassische GPT-4 Version',
      speed: 'Langsam',
      quality: 'Sehr hoch',
      speedColor: '#f44336',
      qualityColor: '#2196f3',
      details: 'Beste Qualität, aber langsam und teuer'
    },
    {
      value: 'gpt-image-1',
      label: 'GPT-Image-1',
      description: 'Neueste Bildgenerierung und -bearbeitung',
      speed: 'Mittel',
      quality: 'Sehr hoch',
      speedColor: '#ff9800',
      qualityColor: '#2196f3',
      details: 'Spezialisiert für Bildbearbeitung und -generierung'
    },
    {
      value: 'dall-e-2',
      label: 'DALL-E 2',
      description: 'Bewährtes Modell für Bildbearbeitung',
      speed: 'Mittel',
      quality: 'Hoch',
      speedColor: '#ff9800',
      qualityColor: '#4caf50',
      details: 'Stabil und zuverlässig für Foto-Optimierung und Hintergrund-Ersetzung'
    },
    {
      value: 'dall-e-3',
      label: 'DALL-E 3',
      description: 'Neuestes Modell für erweiterte Bildbearbeitung',
      speed: 'Langsam',
      quality: 'Sehr hoch',
      speedColor: '#f44336',
      qualityColor: '#2196f3',
      details: 'Erweiterte Bearbeitungsfähigkeiten mit besserer Masken-Unterstützung'
    }
  ];

    
    // State für die CV-Daten Checkbox
  
  // State für die Sichtbarkeit der CV-Bereiche im Template
  const [showCoreCompetenciesInCv, setShowCoreCompetenciesInCv] = useState(true);
  const [showCertificationsInCv, setShowCertificationsInCv] = useState(true);
  const [showItSkillsInCv, setShowItSkillsInCv] = useState(true);
  const [showIndustriesInCv, setShowIndustriesInCv] = useState(true);
  const [showLanguagesInCv, setShowLanguagesInCv] = useState(true);
  const [showHobbiesInCv, setShowHobbiesInCv] = useState(true);
  const [showEducationInCv, setShowEducationInCv] = useState(true);
  const [showWorkExperienceInCv, setShowWorkExperienceInCv] = useState(true);
  const [showAdditionalWorkExperienceInCv, setShowAdditionalWorkExperienceInCv] = useState(true);
  const [showProfileInCv, setShowProfileInCv] = useState(true);
  const [showAdditionalInfoInCv, setShowAdditionalInfoInCv] = useState(true);
  const [showProfileImageInCv, setShowProfileImageInCv] = useState(true);
  const [showContactInCv, setShowContactInCv] = useState(true);
  const [showCompanyNamesInCv, setShowCompanyNamesInCv] = useState(true);
  const [showIndustryInCv, setShowIndustryInCv] = useState(true);
  const [showDateInCv, setShowDateInCv] = useState(true);
  const [showProjectSearchInCv, setShowProjectSearchInCv] = useState(false);
  const [showBulletPointsInCv, setShowBulletPointsInCv] = useState(false);
  const [tempShowBulletPointsInCv, setTempShowBulletPointsInCv] = useState(false);
  const [sortWorkExperienceByRelevance, setSortWorkExperienceByRelevance] = useState(false);
  const [tempSortWorkExperienceByRelevance, setTempSortWorkExperienceByRelevance] = useState(false);
  const [showTonalityModal, setShowTonalityModal] = useState(false);
  const [tonalitySettings, setTonalitySettings] = useState<TonalitySectionSettings>({ ...defaultTonalitySettings });
  const [shortProfileTextLength, setShortProfileTextLength] = useState<'S' | 'M' | 'L'>('S');
  const [workExperienceTextLength, setWorkExperienceTextLength] = useState<'S' | 'M' | 'L'>('S');
  const textSettingsSnapshotRef = useRef<string>('');
  const hadUnsavedCvSettingsBeforeTextModalRef = useRef(false);
  const textSettingsTemplateIdRef = useRef<'template1' | 'template2' | 'template3' | null>(null);
  const textSettingsPendingCloseRef = useRef<{
    hasChanged: boolean;
    designSettingsOverrides: Partial<CvDesignSettings>;
    useBulletPoints: boolean;
    useSortByRelevance: boolean;
  } | null>(null);
  const [profileImageBorderRadius, setProfileImageBorderRadius] = useState(50); // 0 = eckig, 50 = rund
  const [profileImageSize, setProfileImageSize] = useState('M'); // S, M, L
  const [profileImageWidth, setProfileImageWidth] = useState(100); // 50-100% der ursprünglichen Breite
  const [profileImageAlignment, setProfileImageAlignment] = useState('center'); // left, center, right
  const [profileImagePosition, setProfileImagePosition] = useState({ x: 50, y: 50 }); // Position des Bildes im Rahmen (0-100%)
  const [profileImageBorder, setProfileImageBorder] = useState(false); // Rahmen um das Profilbild
  const [profileImageBorderColor, setProfileImageBorderColor] = useState('#333333'); // Farbe des Rahmens
  const [profileImageBorderThickness, setProfileImageBorderThickness] = useState(2); // Dicke des Rahmens
  
  // Temporäre State-Variablen für das Profilbild-Modal
  const [tempProfileImageBorder, setTempProfileImageBorder] = useState(false);
  const [tempProfileImageBorderColor, setTempProfileImageBorderColor] = useState('#333333');
  const [tempProfileImageBorderThickness, setTempProfileImageBorderThickness] = useState(2);
  const [nameFontSize, setNameFontSize] = useState(36); // Schriftgröße für den Namen (wird automatisch überschrieben)
  const [contactDisplayMode, setContactDisplayMode] = useState<'text' | 'icon'>('text'); // Kontakt-Anzeigemodus
  
  // Design-Einstellungen werden nur beim Schließen der CV-Preview gespeichert
  // (nicht automatisch bei jeder Änderung)
  
  // Track unsaved CV-Settings changes (skip initial render and template switches)
  const cvSettingsInitializedRef = React.useRef(false);
  const isLoadingSettingsRef = React.useRef(false);
  React.useEffect(() => {
    if (!cvSettingsInitializedRef.current) {
      cvSettingsInitializedRef.current = true;
      return;
    }
    if (isLoadingSettingsRef.current) {
      isLoadingSettingsRef.current = false;
      return;
    }
    setHasUnsavedCvSettings(true);
  }, [
    showProfileImageInCv, showContactInCv, showProfileInCv, showCoreCompetenciesInCv,
    showEducationInCv, showCertificationsInCv, showItSkillsInCv, showIndustriesInCv,
    showLanguagesInCv, showWorkExperienceInCv, showAdditionalWorkExperienceInCv,
    showHobbiesInCv, showAdditionalInfoInCv, showCompanyNamesInCv, showIndustryInCv,
    showDateInCv, showProjectSearchInCv, showBulletPointsInCv, topBoxColor, topBoxAlpha, leftColumnColor, leftColumnAlpha,
    nameTextColor, leftColumnTextColor, rightColumnTextColor, leftColumnTitleColor,
    rightColumnTitleColor, topBoxImage, leftColumnImage, profileImageBorderRadius,
    profileImageSize, profileImageWidth, profileImagePosition, profileImageAlignment,
    profileImageBorder, profileImageBorderColor, profileImageBorderThickness,
    contactDisplayMode, titleFont, bodyFont, tonalitySettings, sortWorkExperienceByRelevance,
    shortProfileTextLength, workExperienceTextLength
  ]);
  
  // Handler für Namensgröße-Änderung (wird automatisch überschrieben)
  const handleNameFontSizeChange = (newFontSize: number) => {
    setNameFontSize(newFontSize);
    // Automatische Berechnung überschreibt manuelle Einstellungen
  };

  // Handler für Kontakt-Display-Mode-Änderung
  const handleContactDisplayModeChange = (mode: 'text' | 'icon') => {
    setContactDisplayMode(mode);
  };

  // Einheitliche Quelle für Text-Einstellungen in Optimierungs-Requests.
  // Wenn das Modal offen ist, berücksichtigen wir den temporären Bullet-Points-Wert.
  const getEffectiveTextSettings = (useBulletPointsOverride?: boolean) => {
    const effectiveUseBulletPoints = useBulletPointsOverride ??
      (showTonalityModal ? tempShowBulletPointsInCv : showBulletPointsInCv);

    return {
      useBulletPoints: effectiveUseBulletPoints,
      tonalitySettings,
      shortProfileTextLength,
      workExperienceTextLength
    };
  };

  const buildWorkExperienceOptimizePayload = (
    cvData: any,
    cvText: string,
    jobDescriptionValue: string,
    extras: Record<string, any> = {}
  ) => {
    const effectiveTextSettings = getEffectiveTextSettings(
      typeof extras.useBulletPoints === 'boolean' ? extras.useBulletPoints : undefined
    );

    return {
      cvData,
      cvText,
      jobDescription: jobDescriptionValue,
      optimizeType: 'workExperience',
      targetLanguage,
      useBulletPoints: effectiveTextSettings.useBulletPoints,
      tonalitySettings: effectiveTextSettings.tonalitySettings,
      shortProfileTextLength: effectiveTextSettings.shortProfileTextLength,
      workExperienceTextLength: effectiveTextSettings.workExperienceTextLength,
      ...extras
    };
  };

  const ensureCvDesignSettingsReady = async () => {
    if (!user || cvDesignSettingsLoaded || loadingCvDesignSettings) {
      return;
    }
    await loadCvDesignSettings(user);
  };

  const getTextSettingsSnapshot = (
    bulletPointsValue: boolean = tempShowBulletPointsInCv,
    sortByRelevanceValue: boolean = tempSortWorkExperienceByRelevance
  ) => JSON.stringify({
    tonalitySettings,
    shortProfileTextLength,
    workExperienceTextLength,
    showBulletPointsInCv: bulletPointsValue,
    sortWorkExperienceByRelevance: sortByRelevanceValue
  });

  const openTextSettingsModal = () => {
    const currentBulletPointsValue = showBulletPointsInCv;
    const currentSortByRelevanceValue = sortWorkExperienceByRelevance;
    textSettingsTemplateIdRef.current = selectedTemplateId;
    hadUnsavedCvSettingsBeforeTextModalRef.current = hasUnsavedCvSettings;
    setTempShowBulletPointsInCv(currentBulletPointsValue);
    setTempSortWorkExperienceByRelevance(currentSortByRelevanceValue);
    textSettingsSnapshotRef.current = getTextSettingsSnapshot(currentBulletPointsValue, currentSortByRelevanceValue);
    textSettingsPendingCloseRef.current = null;
    setShowTonalityModal(true);
  };

  const closeTextSettingsModal = () => {
    const hasChanged = textSettingsSnapshotRef.current !== getTextSettingsSnapshot();
    const hasBulletPointsChanged = showBulletPointsInCv !== tempShowBulletPointsInCv;
    const hasSortByRelevanceChanged = sortWorkExperienceByRelevance !== tempSortWorkExperienceByRelevance;
    const designSettingsOverrides = {
      ...(hasBulletPointsChanged ? { showBulletPointsInCv: tempShowBulletPointsInCv } : {}),
      ...(hasSortByRelevanceChanged ? { sortWorkExperienceByRelevance: tempSortWorkExperienceByRelevance } : {})
    };

    textSettingsPendingCloseRef.current = {
      hasChanged,
      designSettingsOverrides,
      useBulletPoints: tempShowBulletPointsInCv,
      useSortByRelevance: tempSortWorkExperienceByRelevance
    };

    if (hasBulletPointsChanged) {
      setShowBulletPointsInCv(tempShowBulletPointsInCv);
    }
    if (hasSortByRelevanceChanged) {
      setSortWorkExperienceByRelevance(tempSortWorkExperienceByRelevance);
    }
    setShowTonalityModal(false);
  };

  const handleTextSettingsModalExited = async () => {
    const pendingClose = textSettingsPendingCloseRef.current;
    const templateIdForSave = textSettingsTemplateIdRef.current || selectedTemplateId;
    textSettingsTemplateIdRef.current = null;
    textSettingsPendingCloseRef.current = null;
    if (!pendingClose?.hasChanged) {
      return;
    }

    const textSettingsOverrides: Partial<CvDesignSettings> = {
      tonalitySettings: tonalitySettings as CvDesignSettings['tonalitySettings'],
      shortProfileTextLength,
      workExperienceTextLength,
      showBulletPointsInCv: pendingClose.useBulletPoints,
      sortWorkExperienceByRelevance: pendingClose.useSortByRelevance
    };

    try {
      await saveCvDesignSettings(textSettingsOverrides, templateIdForSave);
      if (selectedCvId) {
        const currentSettings = getCurrentCvSettings(textSettingsOverrides, templateIdForSave);
        await saveCvSettings(selectedCvId, currentSettings);
      }
      setHasUnsavedCvSettings(hadUnsavedCvSettingsBeforeTextModalRef.current);
    } catch (error) {
      console.error('❌ Fehler beim account-weiten Speichern der Text-Einstellungen:', error);
      setHasUnsavedCvSettings(true);
    }

    window.dispatchEvent(new CustomEvent('refreshTemplate'));
    await handleReOptimizeCv(pendingClose.useBulletPoints);
  };
  
  // State für das Kernkompetenzen-Modal
  const [showCoreCompetenciesModal, setShowCoreCompetenciesModal] = useState(false);
  
  // State für den aktuellen Titel aus dem CV-Template
  const [currentCoreCompetenciesTitle, setCurrentCoreCompetenciesTitle] = useState('Kernkompetenzen');
  
  // State für das Auswahl-Modal der verfügbaren Kernkompetenzen
  const [showAvailableCoreCompetenciesModal, setShowAvailableCoreCompetenciesModal] = useState(false);
  
  // State für das Zertifizierungen-Modal
  const [showCertificationsModal, setShowCertificationsModal] = useState(false);
  
  // State für den aktuellen Zertifizierungen-Titel aus dem CV-Template
  const [currentCertificationsTitle, setCurrentCertificationsTitle] = useState('Zertifizierungen');
  
  // State für das Auswahl-Modal der verfügbaren Zertifizierungen
  const [showAvailableCertificationsModal, setShowAvailableCertificationsModal] = useState(false);
  
  // State für das CV-Daten Modal
  const [showCvDataModal, setShowCvDataModal] = useState(false);
  const [showAddCvModal, setShowAddCvModal] = useState(false);
  const [newCvName, setNewCvName] = useState<string>('');
  
  // State für minimierte Info-Boxen (Toggle-Verhalten) - standardmäßig alle verborgen
  const [minimizedInfoBoxes, setMinimizedInfoBoxes] = useState<{[key: string]: boolean}>({
    applications: true,
    cvData: true,
    jobDescription: true,
    cvTemplate: true,
    motivation: true,
    matchScore: true,
    cvDataInfo: true,
    relevance: true
  });
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showUnsavedChangesDialog, setShowUnsavedChangesDialog] = useState(false);
  const [hasUnsavedCvSettings, setHasUnsavedCvSettings] = useState(false);
  const [, setCvModalManuallyClosed] = useState(false);
  const [openCvModalFromPassgenauigkeit, setOpenCvModalFromPassgenauigkeit] = useState(false);
  const [hasCvDataChangedSinceLastMatch, setHasCvDataChangedSinceLastMatch] = useState(false);
  const [hasJobInfoChangedSinceLastMatch, setHasJobInfoChangedSinceLastMatch] = useState(false);

  // Hilfsfunktion zum Markieren von CV-Daten als geändert (für Speicher-Status und Refresh-Icon)
  const markCvDataAsChanged = () => {
    setHasUnsavedChanges(true);
    setHasCvDataChangedSinceLastMatch(true);
  };

  // Lokaler Draft für Berufserfahrungen im CV-Daten-Modal.
  // So bleibt Tippen performant und globale Daten werden erst beim Speichern übernommen.
  React.useEffect(() => {
    if (!showCvDataModal) {
      return;
    }
    // Beim Öffnen des CV-Daten-Modals Motivationsschreiben-Icon immer deaktivieren
    setCvTemplateHasBeenOpened(false);
    setDraftWorkExperiences((workExperiences || []).map(exp => ({ ...exp })));
    setDraftEducations((educations || []).map(edu => ({ ...edu })));
    setDraftCertifications((certifications || []).map(cert => ({ ...cert })));
    setNewWorkExperience({ company: '', position: '', startDate: '', endDate: '', description: '', industry: '' });
    setNewEducation({ institution: '', degree: '', startDate: '', endDate: '' });
    setShowNewWorkExperienceForm(false);
    setShowNewEducationForm(false);
  }, [showCvDataModal]);

  // Funktion zum Öffnen des CV-Daten-Modals mit dem richtigen Tab
  // skipReload: wenn true, wird das Neuladen aus dem Backend übersprungen
  const openCvDataModal = async (
    fromPassgenauigkeit: boolean = false,
    skipReload: boolean = false,
    clearMatchScore: boolean = false,
    prefetchedMatchData?: { matchScore: number | null; missingSkills: string[]; weaknesses: string[] }
  ) => {
    // Speichere Passgenauigkeitsdaten vor dem Reload, falls vorhanden
    const savedMatchScore = matchScore;
    const savedMissingSkills = [...missingSkills];
    const savedWeaknesses = [...weaknesses];
    
    // Lade gespeicherte Daten vom Backend neu, um ungespeicherte Änderungen zu verwerfen
    // Dies kann die Passgenauigkeit löschen (durch handleSelectCv -> clearOptimizedAndMatchData)
    if (!skipReload) {
      await reloadCvDataFromBackend();
    }
    
    // WICHTIG: Passgenauigkeit wird NUR angezeigt, wenn fromPassgenauigkeit=true (Modal wurde nach "Passgenauigkeit prüfen" geöffnet)
    // In allen anderen Fällen wird die Passgenauigkeit NICHT angezeigt, auch wenn matchScore !== null ist
    
    if (fromPassgenauigkeit) {
      // Modal wurde nach "Passgenauigkeit prüfen" geöffnet - Passgenauigkeit anzeigen
      const applicationMatchPayload = selectedApplicationId
        ? getApplicationMatchPayload(
            applications.find((app: any) => app.id === selectedApplicationId),
            selectedCvId
          )
        : null;

      if (prefetchedMatchData) {
        applyMatchDetails(
          prefetchedMatchData.matchScore,
          prefetchedMatchData.missingSkills,
          prefetchedMatchData.weaknesses
        );
        console.log('✅ Passgenauigkeit inkl. Details aus übergebenen Berechnungsdaten gesetzt');
      } else {

        const shouldPreferLocalMatchData =
          skipReload && hasAnyMatchData(savedMatchScore, savedMissingSkills, savedWeaknesses);

        if (shouldPreferLocalMatchData) {
          applyMatchDetails(savedMatchScore, savedMissingSkills, savedWeaknesses);
          console.log('✅ Passgenauigkeit inkl. Details aus lokalem Zustand gesetzt');
        } else if (applicationMatchPayload) {
          applyMatchDetails(
            applicationMatchPayload.matchScore,
            applicationMatchPayload.missingSkills,
            applicationMatchPayload.weaknesses
          );
          console.log('✅ Passgenauigkeit inkl. Details aus Application gesetzt');
        } else if (savedMatchScore !== null && savedMatchScore !== undefined) {
          applyMatchDetails(savedMatchScore, savedMissingSkills, savedWeaknesses);
          console.log('✅ Passgenauigkeit inkl. Details aus gespeichertem Wert wiederhergestellt');
        } else {
          resetMatchData();
          console.log('⚠️ Keine Passgenauigkeit gefunden. selectedApplicationId:', selectedApplicationId, 'applications.length:', applications.length);
        }
      }
      
      // Setze Flag, dass Modal von Passgenauigkeit geöffnet wurde
      setOpenCvModalFromPassgenauigkeit(true);
    } else {
      // Modal wurde NICHT nach "Passgenauigkeit prüfen" geöffnet - Passgenauigkeit NICHT anzeigen
      setMatchScore(null);
      resetMatchData();
      setOpenCvModalFromPassgenauigkeit(false);
      console.log('🔄 Passgenauigkeit wird nicht angezeigt (Modal nicht über "Passgenauigkeit prüfen" geöffnet)');
    }
    
    // Öffne CV-Daten Modal
    setShowCvDataModal(true);
    setCvDataEditMode(true);
    setHasUnsavedChanges(false);
    
    // Setze den richtigen Tab basierend auf der Quelle
    if (fromPassgenauigkeit) {
      setTabIndex(1); // Tab "Berufserfahrung" nach Passgenauigkeit
    } else {
      setTabIndex(0); // Tab "Persönliche Informationen" für normalen Klick
    }
    
  };

  // CV-Upload-Modal wird nicht mehr automatisch geöffnet
  // React.useEffect(() => {
  //   if (user && userCvs.length === 0 && !showAddCvModal && !cvModalManuallyClosed) {
  //     // Kleine Verzögerung, damit die App vollständig geladen ist
  //     const timer = setTimeout(() => {
  //       setShowAddCvModal(true);
  //       console.log('🎯 CV-Upload-Modal automatisch geöffnet - keine CV-Daten vorhanden');
  //     }, 1000);
  //     
  //     return () => clearTimeout(timer);
  //   }
  // }, [user, userCvs.length, showAddCvModal, cvModalManuallyClosed]);
  
  // State für collapsed sections im Modal
  const [showHobbiesCollapsed, setShowHobbiesCollapsed] = useState(false);
  const [showItSkillsCollapsed, setShowItSkillsCollapsed] = useState(false);
  const [showLanguagesCollapsed, setShowLanguagesCollapsed] = useState(false);
  const [showCertificationsCollapsed, setShowCertificationsCollapsed] = useState(false);
  const [showCoreCompetenciesCollapsed, setShowCoreCompetenciesCollapsed] = useState(false);
  const [showAdditionalInfoCollapsed, setShowAdditionalInfoCollapsed] = useState(false);
  const [showEducationCollapsed, setShowEducationCollapsed] = useState(false);
  const [showIndustryExperiencesCollapsed, setShowIndustryExperiencesCollapsed] = useState(false);
  const [showWorkExperiencesCollapsed, setShowWorkExperiencesCollapsed] = useState(false);
  
  // State für das IT-Skills-Modal
  const [showItSkillsModal, setShowItSkillsModal] = useState(false);
  const [currentItSkillsTitle, setCurrentItSkillsTitle] = useState('Informatik');
  
  // State für das Auswahl-Modal der verfügbaren IT-Skills
  const [showAvailableItSkillsModal, setShowAvailableItSkillsModal] = useState(false);
  
  // State für das Branchen-Modal
  const [showIndustriesModal, setShowIndustriesModal] = useState(false);
  const [currentIndustriesTitle, setCurrentIndustriesTitle] = useState('Branchen');
  
  // State für das Auswahl-Modal der verfügbaren Branchen
  const [showAvailableIndustriesModal, setShowAvailableIndustriesModal] = useState(false);
  
  // State für das Sprachen-Modal
  const [showLanguagesModal, setShowLanguagesModal] = useState(false);
  const [currentLanguagesTitle, setCurrentLanguagesTitle] = useState('Sprachen');
  
  // State für das Auswahl-Modal der verfügbaren Sprachen
  const [showAvailableLanguagesModal, setShowAvailableLanguagesModal] = useState(false);
  
  // State für das Hobbies-Modal
  const [showHobbiesModal, setShowHobbiesModal] = useState(false);
  const [currentHobbiesTitle, setCurrentHobbiesTitle] = useState('Hobbies');
  
  // State für das Auswahl-Modal der verfügbaren Hobbys
  const [showAvailableHobbiesModal, setShowAvailableHobbiesModal] = useState(false);
  
  // State für das Weitere-Angaben-Modal
  const [showAdditionalInfoModal, setShowAdditionalInfoModal] = useState(false);
  const [currentAdditionalInfoTitle, setCurrentAdditionalInfoTitle] = useState('Weitere Angaben');
  
  // State für das Auswahl-Modal der verfügbaren Weiteren Angaben
  const [showAvailableAdditionalInfoModal, setShowAvailableAdditionalInfoModal] = useState(false);
  
  // State für das Ausbildung-Modal
  const [showEducationModal, setShowEducationModal] = useState(false);
  const [currentEducationTitle, setCurrentEducationTitle] = useState('Ausbildung');
  
  // State für das Berufserfahrungen-Modal
  const [showWorkExperienceModal, setShowWorkExperienceModal] = useState(false);
  const [currentWorkExperienceTitle, setCurrentWorkExperienceTitle] = useState('Beruflicher Werdegang');
  const [selectedWorkExperience, setSelectedWorkExperience] = useState<{
    position?: string;
    company?: string;
    industry?: string;
    startDate?: string;
    endDate?: string;
    description?: string;
    responsibilities?: string[];
    relevant?: boolean | string;
    relevanzranking?: number | string;
    relevanceRanking?: number | string;
    relevanceScore?: number | string;
  } | null>(null);
  const [originalWorkExperience, setOriginalWorkExperience] = useState<{
    position?: string;
    company?: string;
    industry?: string;
    startDate?: string;
    endDate?: string;
    description?: string;
    responsibilities?: string[];
    relevant?: boolean | string;
    relevanzranking?: number | string;
    relevanceRanking?: number | string;
    relevanceScore?: number | string;
  } | null>(null);
  const [isNonRelevantWorkExperience, setIsNonRelevantWorkExperience] = useState(false);
  
  // State für das Profil-Modal
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [currentProfileTitle, setCurrentProfileTitle] = useState('Profil');
  
  // State für das Profilbild-Modal
  const [showProfileImageModal, setShowProfileImageModal] = useState(false);
  
  // State für das Profilbild-Vorschau-Modal
  const [showProfileImagePreviewModal, setShowProfileImagePreviewModal] = useState(false);
  const [originalProfileImage, setOriginalProfileImage] = useState<string | null>(null);
  const [previewImageZoom, setPreviewImageZoom] = useState(100);
  const [previewImagePositionX, setPreviewImagePositionX] = useState(50);
  const [previewImagePositionY, setPreviewImagePositionY] = useState(50);
  const [previewImageBrightness, setPreviewImageBrightness] = useState(100);
  const [previewImageContrast, setPreviewImageContrast] = useState(100);
  const [previewImageSaturation, setPreviewImageSaturation] = useState(100);
  const [previewImageGrayscale, setPreviewImageGrayscale] = useState(false);
  const [previewImageRotation, setPreviewImageRotation] = useState(0);
  const [removingBackground, setRemovingBackground] = useState(false);

  // Funktion zum AI-basierten Hintergrund entfernen
  const handleRemoveBackground = async () => {
    if (!profileImage || removingBackground) return;
    
    setRemovingBackground(true);
    try {
      // Konvertiere Base64/URL zu Blob
      const response = await fetch(profileImage);
      const blob = await response.blob();
      
      // AI-Hintergrundentfernung ausführen
      const resultBlob = await removeBackground(blob, {
        progress: (key: string, current: number, total: number) => {
          console.log(`BG-Removal: ${key} ${Math.round((current / total) * 100)}%`);
        }
      });
      
      // Blob zu Base64 konvertieren
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64data = reader.result as string;
        setProfileImage(base64data);
        markCvDataAsChanged();
        setRemovingBackground(false);
        console.log('✅ Hintergrund erfolgreich entfernt');
      };
      reader.onerror = () => {
        console.error('❌ Fehler beim Konvertieren des Ergebnisses');
        setRemovingBackground(false);
      };
      reader.readAsDataURL(resultBlob);
    } catch (error) {
      console.error('❌ Fehler bei der Hintergrundentfernung:', error);
      setRemovingBackground(false);
    }
  };

  // Funktion zum Speichern des zugeschnittenen Profilbilds
  const handleSaveProfileImageCrop = () => {
    // Modal sofort schließen
    setShowProfileImagePreviewModal(false);
    
    if (!profileImage) {
      return;
    }

    // Speichere aktuelle Slider-Werte vor dem Reset
    const currentZoom = previewImageZoom;
    const currentPosX = previewImagePositionX;
    const currentPosY = previewImagePositionY;
    const currentBrightness = previewImageBrightness;
    const currentContrast = previewImageContrast;
    const currentSaturation = previewImageSaturation;
    const currentGrayscale = previewImageGrayscale;
    const currentRotation = previewImageRotation;
    
    // Setze die Slider zurück
    setPreviewImageZoom(100);
    setPreviewImagePositionX(50);
    setPreviewImagePositionY(50);
    setPreviewImageBrightness(100);
    setPreviewImageContrast(100);
    setPreviewImageSaturation(100);
    setPreviewImageGrayscale(false);
    setPreviewImageRotation(0);

    // Prüfe ob Änderungen vorgenommen wurden
    const hasChanges = currentZoom !== 100 || currentPosX !== 50 || currentPosY !== 50 ||
      currentBrightness !== 100 || currentContrast !== 100 || currentSaturation !== 100 ||
      currentGrayscale !== false || currentRotation !== 0;

    if (!hasChanges) {
      // Keine Änderungen - Bild nicht neu speichern
      return;
    }

    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      // Quadratisches Canvas - exakt wie die 400x400 Anzeigefläche im Modal
      const canvasSize = 400;
      const canvas = document.createElement('canvas');
      canvas.width = canvasSize;
      canvas.height = canvasSize;
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        return;
      }

      // Wende CSS-Filter auf Canvas an
      const filterParts: string[] = [];
      if (currentBrightness !== 100) filterParts.push(`brightness(${currentBrightness}%)`);
      if (currentContrast !== 100) filterParts.push(`contrast(${currentContrast}%)`);
      if (currentSaturation !== 100) filterParts.push(`saturate(${currentSaturation}%)`);
      if (currentGrayscale) filterParts.push('grayscale(100%)');
      if (filterParts.length > 0) {
        ctx.filter = filterParts.join(' ');
      }

      // contain-Logik: Bild proportional in 400x400 einpassen (wie objectFit: contain)
      const imgAR = img.naturalWidth / img.naturalHeight;
      let containWidth: number, containHeight: number;
      if (imgAR > 1) {
        containWidth = canvasSize;
        containHeight = canvasSize / imgAR;
      } else {
        containHeight = canvasSize;
        containWidth = canvasSize * imgAR;
      }

      // Zoom anwenden
      const scale = currentZoom / 100;
      const scaledWidth = containWidth * scale;
      const scaledHeight = containHeight * scale;

      // Bild zentrieren + Position-Slider anwenden
      // CSS transform: translate((posX-50)*2%, (posY-50)*2%) bezieht sich auf das Element selbst
      const baseX = (canvasSize - scaledWidth) / 2;
      const baseY = (canvasSize - scaledHeight) / 2;
      const offsetX = baseX + ((currentPosX - 50) * 2 * scaledWidth / 100);
      const offsetY = baseY + ((currentPosY - 50) * 2 * scaledHeight / 100);

      // Wende Rotation an
      if (currentRotation !== 0) {
        ctx.save();
        ctx.translate(canvasSize / 2, canvasSize / 2);
        ctx.rotate((currentRotation * Math.PI) / 180);
        ctx.translate(-canvasSize / 2, -canvasSize / 2);
      }

      // Zeichne das Bild
      ctx.drawImage(img, offsetX, offsetY, scaledWidth, scaledHeight);

      // Rotation wiederherstellen
      if (currentRotation !== 0) {
        ctx.restore();
      }

      // Exportiere als Base64
      const croppedImageData = canvas.toDataURL('image/png');
      
      // Aktualisiere das Profilbild
      setProfileImage(croppedImageData);
      
      // Markiere als geändert, damit es gespeichert wird
      markCvDataAsChanged();
      
      console.log('✅ Profilbild bearbeitet und gespeichert (Filter: Helligkeit=' + currentBrightness + '%, Kontrast=' + currentContrast + '%, Sättigung=' + currentSaturation + '%, Graustufen=' + currentGrayscale + ', Rotation=' + currentRotation + '°)');
    };
    
    img.onerror = () => {
      console.error('❌ Fehler beim Laden des Profilbilds');
    };
    
    img.src = profileImage;
  };
  
  // State für die übersetzte "Jahre"-Bezeichnung
  const [translatedYears, setTranslatedYears] = useState('Jahre');
  
  // Event Listener für das Kernkompetenzen-Modal
  React.useEffect(() => {
    const handleOpenCoreCompetenciesModal = (event: any) => {
      // Übernehme den aktuellen Titel aus dem Template
      if (event.detail && event.detail.title) {
        setCurrentCoreCompetenciesTitle(event.detail.title);
      }
      setShowCoreCompetenciesModal(true);
    };
    
    window.addEventListener('openCoreCompetenciesModal', handleOpenCoreCompetenciesModal);
    
    return () => {
      window.removeEventListener('openCoreCompetenciesModal', handleOpenCoreCompetenciesModal);
    };
  }, []);

  // Event Listener für Titel-Änderungen im Modal
  React.useEffect(() => {
    if (!showCoreCompetenciesModal) {
      return;
    }
    const event = new CustomEvent('updateCoreCompetenciesTitle', {
      detail: { title: currentCoreCompetenciesTitle }
    });
    window.dispatchEvent(event);
  }, [currentCoreCompetenciesTitle, showCoreCompetenciesModal]);

  // Event Listener für das Zertifizierungen-Modal
  React.useEffect(() => {
    const handleOpenCertificationsModal = (event: any) => {
      // Übernehme den aktuellen Titel aus dem Template
      if (event.detail && event.detail.title) {
        setCurrentCertificationsTitle(event.detail.title);
      }
      setShowCertificationsModal(true);
    };
    
    window.addEventListener('openCertificationsModal', handleOpenCertificationsModal);
    
    return () => {
      window.removeEventListener('openCertificationsModal', handleOpenCertificationsModal);
    };
  }, []);

  // Event Listener für Zertifizierungen-Titel-Änderungen im Modal
  React.useEffect(() => {
    if (!showCertificationsModal) {
      return;
    }
    const event = new CustomEvent('updateCertificationsTitle', {
      detail: { title: currentCertificationsTitle }
    });
    window.dispatchEvent(event);
  }, [currentCertificationsTitle, showCertificationsModal]);

  // Funktion zum Filtern der verfügbaren (nicht ausgewählten) Kernkompetenzen
  const getAvailableCoreCompetencies = () => {
    if (!coreCompetencies || coreCompetencies.length === 0) {
      return [];
    }
    
    // Filtere alle Kernkompetenzen, die noch nicht in relevantCoreCompetencies sind
    return coreCompetencies.filter(comp => {
      // Prüfe, ob diese Kompetenz bereits in relevantCoreCompetencies ist
      const isAlreadySelected = relevantCoreCompetencies.some(relComp => 
        relComp.competency === comp.competency
      );
      return !isAlreadySelected;
    });
  };

  // Funktion zum Filtern der verfügbaren (nicht ausgewählten) Zertifizierungen
  const getAvailableCertifications = () => {
    if (!certifications || certifications.length === 0) {
      return [];
    }
    
    // Filtere alle Zertifizierungen, die noch nicht in relevantCertifications sind
    return certifications.filter(cert => {
      // Prüfe, ob diese Zertifizierung bereits in relevantCertifications ist (nur nach Zertifizierungs-Name)
      const isAlreadySelected = relevantCertifications.some(relCert => 
        relCert.name === cert.name
      );
      return !isAlreadySelected;
    });
  };

  // Funktion zum Filtern der verfügbaren (nicht ausgewählten) IT-Skills
  const getAvailableItSkills = () => {
    if (!itSkills || itSkills.length === 0) {
      return [];
    }
    
    // Filtere alle IT-Skills, die noch nicht in relevantItSkills sind
    return itSkills.filter(skill => {
      // Prüfe, ob dieser Skill bereits in relevantItSkills ist (nur nach Skill-Name)
      const isAlreadySelected = relevantItSkills.some(relSkill => 
        relSkill.skill === skill.skill
      );
      return !isAlreadySelected;
    });
  };

  // Funktion zum Filtern der verfügbaren (nicht ausgewählten) Hobbys
  const getAvailableHobbies = () => {
    if (!hobbies || hobbies.length === 0) {
      return [];
    }

    // Filtere alle Hobbys, die noch nicht in relevantHobbies sind
    const selectedHobbies = normalizeHobbyList(relevantHobbies);
    return normalizeHobbyList(hobbies).filter(
      hobby => !selectedHobbies.some(selected => isSameHobbyEntry(selected, hobby))
    );
  };

  // Funktion zum Filtern der verfügbaren (nicht ausgewählten) Weiteren Angaben
  const getAvailableAdditionalInfo = () => {
    if (!additionalInfo || additionalInfo.length === 0) {
      return [];
    }
    
    // Filtere alle Weiteren Angaben, die noch nicht in relevantAdditionalInfo sind
    return additionalInfo.filter(info => {
      // Prüfe, ob diese Information bereits in relevantAdditionalInfo ist (nur nach Info-Titel)
      const isAlreadySelected = relevantAdditionalInfo.some(relInfo => 
        relInfo.info === info.info
      );
      return !isAlreadySelected;
    });
  };

  // Funktion zum Filtern der verfügbaren (nicht ausgewählten) Sprachen
  const getAvailableLanguages = () => {
    if (!languages || languages.length === 0) {
      return [];
    }
    
    // Filtere alle Sprachen, die noch nicht in relevantLanguages sind
    return languages.filter(lang => {
      // Prüfe, ob diese Sprache bereits in relevantLanguages ist (nur nach Sprachen-Name)
      const isAlreadySelected = relevantLanguages.some(relLang => 
        relLang.language === lang.language
      );
      return !isAlreadySelected;
    });
  };

  // Funktion zum Filtern der verfügbaren (nicht ausgewählten) Branchen
  const getAvailableIndustries = () => {
    if (!industryExperiences || industryExperiences.length === 0) {
      return [];
    }
    
    // Filtere alle Branchen, die noch nicht in relevantIndustries sind
    return industryExperiences.filter(industry => {
      // Prüfe, ob diese Branche bereits in relevantIndustries ist (nur nach Branchen-Name)
      const isAlreadySelected = relevantIndustries.some(relIndustry => 
        relIndustry.industry === industry.industry
      );
      return !isAlreadySelected;
    });
  };

  // Event Listener für IT-Skills-Modal
  React.useEffect(() => {
    const handleOpenItSkillsModal = (event: any) => {
      if (event.detail && event.detail.title) {
        setCurrentItSkillsTitle(event.detail.title);
      }
      setShowItSkillsModal(true);
    };
    
    window.addEventListener('openItSkillsModal', handleOpenItSkillsModal);
    
    return () => {
      window.removeEventListener('openItSkillsModal', handleOpenItSkillsModal);
    };
  }, []);

  // Event Listener für Branchen-Modal
  React.useEffect(() => {
    const handleOpenIndustriesModal = (event: any) => {
      if (event.detail && event.detail.title) {
        setCurrentIndustriesTitle(event.detail.title);
      }
      setShowIndustriesModal(true);
    };
    
    window.addEventListener('openIndustriesModal', handleOpenIndustriesModal);
    
    return () => {
      window.removeEventListener('openIndustriesModal', handleOpenIndustriesModal);
    };
  }, []);

  // Event Listener für Sprachen-Modal
  React.useEffect(() => {
    const handleOpenLanguagesModal = (event: any) => {
      if (event.detail && event.detail.title) {
        setCurrentLanguagesTitle(event.detail.title);
      }
      setShowLanguagesModal(true);
    };
    
    window.addEventListener('openLanguagesModal', handleOpenLanguagesModal);
    
    return () => {
      window.removeEventListener('openLanguagesModal', handleOpenLanguagesModal);
    };
  }, []);

  // Event Listener für Hobbies-Modal
  React.useEffect(() => {
    const handleOpenHobbiesModal = (event: any) => {
      if (event.detail && event.detail.title) {
        setCurrentHobbiesTitle(event.detail.title);
      }
      setShowHobbiesModal(true);
    };
    
    window.addEventListener('openHobbiesModal', handleOpenHobbiesModal);
    
    return () => {
      window.removeEventListener('openHobbiesModal', handleOpenHobbiesModal);
    };
  }, []);

  // Event Listener für das Weitere-Angaben-Modal
  React.useEffect(() => {
    const handleOpenAdditionalInfoModal = (event: any) => {
      if (event.detail && event.detail.title) {
        setCurrentAdditionalInfoTitle(event.detail.title);
      }
      setShowAdditionalInfoModal(true);
    };
    
    window.addEventListener('openAdditionalInfoModal', handleOpenAdditionalInfoModal);
    
    return () => {
      window.removeEventListener('openAdditionalInfoModal', handleOpenAdditionalInfoModal);
    };
  }, []);

  // Event Listener für das Ausbildung-Modal
  React.useEffect(() => {
    const handleOpenEducationModal = (event: any) => {
      if (event.detail && event.detail.title) {
        setCurrentEducationTitle(event.detail.title);
      }
      setShowEducationModal(true);
    };
    
    window.addEventListener('openEducationModal', handleOpenEducationModal);
    
    return () => {
      window.removeEventListener('openEducationModal', handleOpenEducationModal);
    };
  }, []);

  // Event Listener für das Berufserfahrungen-Modal
  React.useEffect(() => {
    const handleOpenWorkExperienceModal = (event: any) => {
      if (event.detail && event.detail.workExperience) {
        setSelectedWorkExperience(event.detail.workExperience);
        setOriginalWorkExperience(event.detail.workExperience);
        setIsNonRelevantWorkExperience(event.detail.isNonRelevant || false);
        setShowWorkExperiencePromptInput(false);
        setWorkExperiencePromptText('');
        
        // Verwende den vom CV-Template übergebenen Titel, falls vorhanden
        if (event.detail.title) {
          setCurrentWorkExperienceTitle(event.detail.title);
        } else {
          if (event.detail.isNonRelevant) {
            setCurrentWorkExperienceTitle('Weitere Berufserfahrungen');
          }
        }
      }
      setShowWorkExperienceModal(true);
    };
    
    window.addEventListener('openWorkExperienceModal', handleOpenWorkExperienceModal);
    
    return () => {
      window.removeEventListener('openWorkExperienceModal', handleOpenWorkExperienceModal);
    };
  }, []);

  // Event Listener für das Profil-Modal
  React.useEffect(() => {
    const handleOpenProfileModal = (event: any) => {
      if (event.detail && event.detail.title) {
        setCurrentProfileTitle(event.detail.title);
      }
      // Initialisiere temporäre Werte beim Öffnen des Modals
      initializeProfileModal();
      setShowProfileModal(true);
    };
    
    window.addEventListener('openProfileModal', handleOpenProfileModal);
    
    return () => {
      window.removeEventListener('openProfileModal', handleOpenProfileModal);
    };
  }, []);

  // Event Listener für das Profilbild-Modal
  React.useEffect(() => {
    const handleOpenProfileImageModal = (event: any) => {
      // Setze temporäre Werte beim Öffnen des Modals
      setTempProfileImageBorder(profileImageBorder);
      setTempProfileImageBorderColor(profileImageBorderColor);
      setTempProfileImageBorderThickness(profileImageBorderThickness);
      setShowProfileImageModal(true);
    };
    
    window.addEventListener('openProfileImageModal', handleOpenProfileImageModal);
    
    return () => {
      window.removeEventListener('openProfileImageModal', handleOpenProfileImageModal);
    };
  }, [profileImageBorder, profileImageBorderColor, profileImageBorderThickness]);

  // Handler für das Schließen des Profilbild-Modals
  const handleCloseProfileImageModal = () => {
    // Übernehme die temporären Werte beim Schließen
    setProfileImageBorder(tempProfileImageBorder);
    setProfileImageBorderColor(tempProfileImageBorderColor);
    setProfileImageBorderThickness(tempProfileImageBorderThickness);
    setShowProfileImageModal(false);
  };

  // Event Listener für Textfarben-Modal
  React.useEffect(() => {
    
    window.addEventListener('openTextColorPalette', handleOpenTextColorPalette);
    
    return () => {
      window.removeEventListener('openTextColorPalette', handleOpenTextColorPalette);
    };
  }, []);

  // Globaler Keyboard Event Listener für CTRL+V ins Stellenbeschreibung-Textfeld
  React.useEffect(() => {
    const handleGlobalPaste = async (e: KeyboardEvent) => {
      // Prüfe ob CTRL+V (oder CMD+V auf Mac) gedrückt wurde
      const isCtrlV = (e.ctrlKey || e.metaKey) && e.key === 'v';
      
      if (!isCtrlV) return;
      
      // Prüfe ob Stellenbeschreibung-Textfeld sichtbar ist
      const isJobDescriptionVisible = !hideJobDescription && !extracting;
      
      // Prüfe ob Textfeld leer ist
      const isJobDescriptionEmpty = !jobDescription || !jobDescription.trim();
      
      // Nur wenn sichtbar und leer
      if (isJobDescriptionVisible && isJobDescriptionEmpty) {
        try {
          // Lese Text aus Zwischenablage
          const clipboardText = await navigator.clipboard.readText();
          
          if (clipboardText && clipboardText.trim()) {
            // Reset language detection (wie in handleJobDescriptionChange)
            setLanguageDetected(false);
            
            // Füge Text ins Textfeld ein
            resetApplicationSelectionForNewJobDescription();
            setJobDescription(clipboardText);
            console.log('📋 Text aus Zwischenablage eingefügt');
            
            // Prompt Spracherkennung nach Copy/Paste
            if (clipboardText.trim().length > 10) {
              console.log('🔍 Starte Spracherkennung nach Copy/Paste...');
              await handleLanguageDetection(clipboardText.trim());
            }
            
            // Optional: Fokussiere das Textfeld
            // Das Textfeld wird automatisch durch den Wert-Update fokussiert
          }
        } catch (error) {
          console.error('❌ Fehler beim Lesen der Zwischenablage:', error);
        }
      }
    };
    
    // Füge Event Listener hinzu
    window.addEventListener('keydown', handleGlobalPaste);
    
    return () => {
      window.removeEventListener('keydown', handleGlobalPaste);
    };
  }, [hideJobDescription, extracting, jobDescription]);

  // Event Listener für Titel-Änderungen im Modal
  React.useEffect(() => {
    if (!showItSkillsModal) {
      return;
    }
    const event = new CustomEvent('updateItSkillsTitle', {
      detail: { title: currentItSkillsTitle }
    });
    window.dispatchEvent(event);
  }, [currentItSkillsTitle, showItSkillsModal]);

  React.useEffect(() => {
    if (!showIndustriesModal) {
      return;
    }
    const event = new CustomEvent('updateIndustriesTitle', {
      detail: { title: currentIndustriesTitle }
    });
    window.dispatchEvent(event);
  }, [currentIndustriesTitle, showIndustriesModal]);

  React.useEffect(() => {
    if (!showLanguagesModal) {
      return;
    }
    const event = new CustomEvent('updateLanguagesTitle', {
      detail: { title: currentLanguagesTitle }
    });
    window.dispatchEvent(event);
  }, [currentLanguagesTitle, showLanguagesModal]);

  React.useEffect(() => {
    if (!showHobbiesModal) {
      return;
    }
    const event = new CustomEvent('updateHobbiesTitle', {
      detail: { title: currentHobbiesTitle }
    });
    window.dispatchEvent(event);
  }, [currentHobbiesTitle, showHobbiesModal]);

  React.useEffect(() => {
    if (!showEducationModal) {
      return;
    }
    const event = new CustomEvent('updateEducationTitle', {
      detail: { title: currentEducationTitle }
    });
    window.dispatchEvent(event);
  }, [currentEducationTitle, showEducationModal]);

  // Event Listener für Berufserfahrungen-Titel-Änderungen
  React.useEffect(() => {
    const handleTitleChange = () => {
      // Nur ausführen, wenn das Modal geöffnet ist
      if (!showWorkExperienceModal) {
        return;
      }
      
      if (isNonRelevantWorkExperience) {
        // Für nicht-relevante Berufserfahrungen: "Weitere Berufserfahrungen" Titel aktualisieren
        const event = new CustomEvent('updateAdditionalWorkExperienceTitle', {
          detail: { title: currentWorkExperienceTitle }
        });
        window.dispatchEvent(event);
      } else {
        // Für relevante Berufserfahrungen: "Beruflicher Werdegang" Titel aktualisieren
        const event = new CustomEvent('updateWorkExperienceTitle', {
          detail: { title: currentWorkExperienceTitle }
        });
        window.dispatchEvent(event);
      }
    };
    handleTitleChange();
  }, [currentWorkExperienceTitle, isNonRelevantWorkExperience, showWorkExperienceModal]);

  React.useEffect(() => {
    if (!showProfileModal) {
      return;
    }
    const event = new CustomEvent('updateProfileTitle', {
      detail: { title: currentProfileTitle }
    });
    window.dispatchEvent(event);
  }, [currentProfileTitle, showProfileModal]);

  React.useEffect(() => {
    if (!showAdditionalInfoModal) {
      return;
    }
    const event = new CustomEvent('updateAdditionalInfoTitle', {
      detail: { title: currentAdditionalInfoTitle }
    });
    window.dispatchEvent(event);
  }, [currentAdditionalInfoTitle, showAdditionalInfoModal]);

  // Aktualisiere den Titel wenn sich die Zielsprache ändert
  React.useEffect(() => {
    const titleTranslations: { [key: string]: { [lang: string]: string } } = {
      'KERNKOMPETENZEN': { deutsch: 'Kernkompetenzen', englisch: 'Core Competencies', französisch: 'Compétences clés', italienisch: 'Competenze chiave' },
      'ZERTIFIZIERUNG': { deutsch: 'Zertifizierungen', englisch: 'Certifications', französisch: 'Certifications', italienisch: 'Certificazioni' },
      'INFORMATIK': { deutsch: 'Informatik', englisch: 'IT Skills', französisch: 'Compétences IT', italienisch: 'Competenze IT' },
      'BRANCHEN': { deutsch: 'Branchen', englisch: 'Industries', französisch: 'Secteurs', italienisch: 'Settori' },
      'SPRACHEN': { deutsch: 'Sprachen', englisch: 'Languages', französisch: 'Langues', italienisch: 'Lingue' },
      'HOBBYS': { deutsch: 'Hobbies', englisch: 'Hobbies', französisch: 'Loisirs', italienisch: 'Hobby' },
      'AUSBILDUNG': { deutsch: 'Ausbildung', englisch: 'Education', französisch: 'Formation', italienisch: 'Formazione' },
      'BERUFLICHER WERDEGANG': { deutsch: 'Beruflicher Werdegang', englisch: 'Work Experience', französisch: 'Expérience professionnelle', italienisch: 'Esperienza professionale' },
      'PROJEKTERFAHRUNG': { deutsch: 'Projekterfahrung', englisch: 'Project Experience', französisch: 'Expérience de projet', italienisch: 'Esperienza di progetto' },
      'PROFIL': { deutsch: 'Profil', englisch: 'Profile', französisch: 'Profil', italienisch: 'Profilo' },
    };

    const getTranslatedTitle = (key: string) => {
      return titleTranslations[key]?.[targetLanguage] || titleTranslations[key]?.['deutsch'] || key;
    };

    const yearsTranslations: { [lang: string]: string } = {
      deutsch: 'Jahre', englisch: 'Years', französisch: 'Ans', italienisch: 'Anni'
    };

    const getTranslatedYears = () => {
      return yearsTranslations[targetLanguage] || 'Jahre';
    };
    
    setCurrentCoreCompetenciesTitle(getTranslatedTitle('KERNKOMPETENZEN'));
    setCurrentCertificationsTitle(getTranslatedTitle('ZERTIFIZIERUNG'));
    setCurrentItSkillsTitle(getTranslatedTitle('INFORMATIK'));
    setCurrentIndustriesTitle(getTranslatedTitle('BRANCHEN'));
    setCurrentLanguagesTitle(getTranslatedTitle('SPRACHEN'));
    setCurrentHobbiesTitle(getTranslatedTitle('HOBBYS'));
    setCurrentEducationTitle(getTranslatedTitle('AUSBILDUNG'));
    setCurrentWorkExperienceTitle(
      showProjectSearchInCv
        ? getTranslatedTitle('PROJEKTERFAHRUNG')
        : getTranslatedTitle('BERUFLICHER WERDEGANG')
    );
    setCurrentProfileTitle(getTranslatedTitle('PROFIL'));
    setTranslatedYears(getTranslatedYears());
  }, [targetLanguage, showProjectSearchInCv]);
  
  
  // Funktion zum Konvertieren von File zu Base64
  const convertFileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const result = reader.result as string;
        // Entferne den Data URL Prefix (z.B. "data:application/pdf;base64,")
        const base64 = result.split(',')[1];
        resolve(base64);
      };
      reader.onerror = error => reject(error);
    });
  };
// State für das Ausblenden der Match-Ergebnisse
  const [, setHideMatchResults] = useState(false);
  
  // Separate State-Variablen für Button-Sichtbarkeit
  const [, setShowPassgenauigkeitButton] = useState(true);
  const [, setShowCvOptimierenButton] = useState(true);

  // Async-Queue Wrapper für /api/optimize-cv inkl. Polling des Job-Status
  const requestOptimizeCvWithQueue = async (
    requestBody: any,
    idToken: string,
    useAsyncQueue: boolean = true
  ) => {
    const requestedUseBulletPoints = typeof requestBody?.useBulletPoints === 'boolean'
      ? requestBody.useBulletPoints
      : undefined;
    const effectiveTextSettings = getEffectiveTextSettings(requestedUseBulletPoints);

    const enrichedRequestBody = {
      ...requestBody,
      useBulletPoints: requestBody?.useBulletPoints ?? effectiveTextSettings.useBulletPoints,
      tonalitySettings: requestBody?.tonalitySettings ?? effectiveTextSettings.tonalitySettings,
      shortProfileTextLength: requestBody?.shortProfileTextLength ?? effectiveTextSettings.shortProfileTextLength,
      workExperienceTextLength: requestBody?.workExperienceTextLength ?? effectiveTextSettings.workExperienceTextLength
    };

    // Queue nur für den Parent-CV-Flow nutzen, alle anderen Aufrufe direkt synchron.
    const shouldUseQueue = Boolean(useAsyncQueue && enrichedRequestBody?.optimizeType === 'cv');

    const response = await fetch(config.backend.optimizeCvJsonUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`
      },
      body: JSON.stringify(shouldUseQueue ? { ...enrichedRequestBody, async: true } : enrichedRequestBody),
    });

    if (!response.ok) {
      let serverError = '';
      try {
        const errorData = await response.json();
        serverError = typeof errorData?.error === 'string' ? errorData.error : '';
      } catch {
        // ignore parse errors, use generic fallback
      }
      throw new Error(serverError || t('error.optimize.cv'));
    }

    const initialData = await response.json();
    if (!initialData?.queued || !initialData?.jobId) {
      return initialData;
    }

    const startTime = Date.now();
    const timeoutMs = 7 * 60 * 1000;
    // Adaptives Polling: schnell starten, dann mit der Zeit etwas reduzieren.
    const getPollIntervalMs = (elapsedMs: number) => {
      if (elapsedMs < 10_000) return 1000;
      if (elapsedMs < 30_000) return 1500;
      if (elapsedMs < 90_000) return 2500;
      return 4000;
    };

    while (Date.now() - startTime < timeoutMs) {
      const elapsed = Date.now() - startTime;
      await new Promise((resolve) => setTimeout(resolve, getPollIntervalMs(elapsed)));
      const statusResponse = await fetch(`${config.backend.fullApiUrl}/api/optimize-cv/jobs/${initialData.jobId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        }
      });

      if (!statusResponse.ok) {
        throw new Error('Queue-Status konnte nicht geladen werden.');
      }

      const statusData = await statusResponse.json();
      if (statusData?.status === 'completed') {
        return statusData?.result || {};
      }
      if (statusData?.status === 'failed') {
        throw new Error(statusData?.error || 'Queue-Job ist fehlgeschlagen.');
      }
    }

    throw new Error('Queue-Job Timeout. Bitte später erneut versuchen.');
  };
  
  // Handler zum Hinzufügen einer neuen Ausbildung
  const handleAddEducation = () => {
    setDraftEducations(prev => [{ institution: '', degree: '', startDate: '', endDate: '' }, ...prev]);
    markCvDataAsChanged();
  };

  // Handler zum Löschen einer Ausbildung
  const handleDeleteEducation = (idx: number) => {
    setDraftEducations(prev => prev.filter((_, i) => i !== idx));
    markCvDataAsChanged();
  };

  // Handler zum Editieren einer Ausbildung
  const handleEducationChange = useCallback((idx: number, field: string, value: string) => {
    setDraftEducations(prev => {
      const newEducations = [...prev];
      newEducations[idx] = { ...newEducations[idx], [field]: value };
      return newEducations;
    });
    markCvDataAsChanged();
  }, []);

  // Handler zum Hinzufügen einer neuen Zertifizierung
  const handleAddCertification = () => {
    setDraftCertifications(prev => [{ name: '', issuer: '', date: '' }, ...prev]);
    markCvDataAsChanged();
  };

  // Handler zum Löschen einer Zertifizierung
  const handleDeleteCertification = (idx: number) => {
    setDraftCertifications(prev => prev.filter((_, i) => i !== idx));
    markCvDataAsChanged();
  };

  // Handler zum Editieren einer Zertifizierung
  const handleCertificationChange = useCallback((idx: number, field: string, value: string) => {
    setDraftCertifications(prev => {
      const newCertifications = [...prev];
      newCertifications[idx] = { ...newCertifications[idx], [field]: value };
      return newCertifications;
    });
    markCvDataAsChanged();
  }, []);

  // Handler zum Editieren eines Hobbys
  const handleHobbyChange = useCallback((idx: number, field: string, value: string) => {
    setHobbies(prev => {
      const newHobbies = [...prev];
      newHobbies[idx] = { ...newHobbies[idx], [field]: value };
      return newHobbies;
    });
    markCvDataAsChanged();
  }, []);

  // Globaler Keyboard Event Listener für Enter-Taste → Passgenauigkeit prüfen
  React.useEffect(() => {
    const handleGlobalEnter = (e: KeyboardEvent) => {
      // Prüfe ob Enter gedrückt wurde (ohne Shift)
      if (e.key !== 'Enter' || e.shiftKey) return;
      
      // Prüfe ob gerade ein Textfeld/Textarea fokussiert ist (außer Stellenbeschreibung)
      // Damit Enter in anderen Feldern normal funktioniert
      const activeElement = document.activeElement;
      const isInputFocused = activeElement && (
        activeElement.tagName === 'INPUT' || 
        activeElement.tagName === 'TEXTAREA' ||
        activeElement.getAttribute('contenteditable') === 'true'
      );
      
      // Wenn ein anderes Input-Element fokussiert ist, nicht abfangen
      // (Stellenbeschreibung-Textfeld hat eigenen onKeyDown Handler)
      if (isInputFocused) return;
      
      // Prüfe ob Stellenbeschreibung-Textfeld sichtbar ist
      const isJobDescriptionVisible = !hideJobDescription && !extracting;
      
      // Prüfe ob Button aktiviert ist (nicht disabled)
      const isButtonEnabled = !checkingMatch && hasData() && 
                              jobDescription && jobDescription.trim();
      
      // Nur wenn alles passt: Passgenauigkeit prüfen
      if (isJobDescriptionVisible && isButtonEnabled && !checkingMatch && !optimizing) {
        e.preventDefault();
        console.log('⌨️ Enter gedrückt - starte Passgenauigkeitsprüfung');
        handleCheckMatchScore();
      }
    };
    
      // Füge Event Listener hinzu
    window.addEventListener('keydown', handleGlobalEnter);
    
    return () => {
      window.removeEventListener('keydown', handleGlobalEnter);
    };
  }, [hideJobDescription, extracting, 
      checkingMatch, optimizing, jobDescription]);

  // Überwache Änderungen im CV-Daten Modal
  React.useEffect(() => {
    if (!showCvDataModal) {
      // Setze hasUnsavedChanges zurück, wenn Modal geschlossen wird
      setHasUnsavedChanges(false);
      return;
    }

    const handleInput = () => {
      markCvDataAsChanged();
      // Setze Passgenauigkeit auf null (wird als "..%" angezeigt) und Ring auf 0
      // wenn Daten im Modal geändert werden
      if (matchScore !== null) {
        setMatchScore(null);
        console.log('🔄 Passgenauigkeit zurückgesetzt wegen Datenänderung im Modal');
      }
    };

    // Lausche auf Input-Events im gesamten Dokument während Modal offen ist
    document.addEventListener('input', handleInput);
    document.addEventListener('change', handleInput);

    return () => {
      document.removeEventListener('input', handleInput);
      document.removeEventListener('change', handleInput);
    };
  }, [showCvDataModal, matchScore]);

  // Funktion zum Löschen des aktuellen CVs
  const handleDeleteCv = async () => {
    if (!user || !selectedCvId) return;
    
    try {
      const idToken = await user.getIdToken();
      const response = await fetch(`${config.backend.baseUrl}/api/delete-cv/${selectedCvId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${idToken}`
        }
      });
      
      if (response.ok) {
        console.log('✅ CV erfolgreich gelöscht:', selectedCvId);
        
        // Bereinige localStorage, wenn das gelöschte CV das aktuelle war
        const savedCvId = localStorage.getItem('selectedCvId');
        if (savedCvId === selectedCvId) {
          localStorage.removeItem('selectedCvId');
        }
        
        // Schließe Dialog und Modal
        setShowDeleteCvDialog(false);
        setShowCvDataModal(false);
        
        // Lade CV-Liste neu
        const cvListResponse = await fetch(`${config.backend.baseUrl}/api/get-user-cvs`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${idToken}`
          }
        });
        
        if (cvListResponse.ok) {
          const cvListData = await cvListResponse.json();
          setUserCvs(cvListData.userCvs || []);
          
          // Wähle automatisch den ersten verfügbaren CV aus
          if (cvListData.userCvs && cvListData.userCvs.length > 0) {
            const defaultCv = cvListData.userCvs.find((cv: any) => cv.isDefault);
            const cvToSelect = defaultCv || cvListData.userCvs[0];
            if (cvToSelect && cvToSelect.cvId) {
              await handleSelectCv(cvToSelect.cvId);
            }
          } else {
            // Keine CVs mehr vorhanden
            setSelectedCvId(null);
            setCurrentCvName('');
            // Bereinige localStorage
            localStorage.removeItem('selectedCvId');
          }
        }
      } else {
        const errorData = await response.json();
        console.error('❌ Fehler beim Löschen:', errorData.error);
        setError('Fehler beim Löschen: ' + errorData.error);
      }
    } catch (error) {
      console.error('❌ Fehler beim Löschen des CVs:', error);
      setError('Fehler beim Löschen des CVs');
    }
  };

  // Funktion zum Export der CV-Daten als CSV
  const exportCvDataAsCsv = () => {
    if (!selectedCvId) {
      console.error('Kein CV ausgewählt');
      return;
    }
    
    // CSV-Header und Daten erstellen
    const csvRows = [];
    
    // Persönliche Informationen
    csvRows.push(['Kategorie', 'Feld', 'Wert']);
    csvRows.push(['Persönliche Daten', 'Name', fullName || '']);
    csvRows.push(['Persönliche Daten', 'Firma', company || '']);
    csvRows.push(['Persönliche Daten', 'Email', email || '']);
    csvRows.push(['Persönliche Daten', 'Telefon', phoneNumber || '']);
    csvRows.push(['Persönliche Daten', 'Adresse', address || '']);
    csvRows.push(['Persönliche Daten', 'PLZ', postalCode || '']);
    csvRows.push(['Persönliche Daten', 'Stadt', city || '']);
    csvRows.push(['Persönliche Daten', 'Land', country || '']);
    csvRows.push(['Persönliche Daten', 'Verfügbar ab', availableFrom || '']);
    csvRows.push(['Persönliche Daten', 'Geburtsjahr', birthYear || '']);
    csvRows.push(['Persönliche Daten', 'Nationalität', nationality || '']);
    csvRows.push(['Persönliche Daten', 'Aufenthaltsbewilligung', residencePermit || '']);
    csvRows.push(['Persönliche Daten', 'Familienstand', civilStatus || '']);
    csvRows.push(['', '', '']); // Leerzeile
    
    // Kurzprofil
    csvRows.push(['Kurzprofil', 'Text', shortProfile || '']);
    csvRows.push(['', '', '']); // Leerzeile
    
    // Berufserfahrung
    workExperiences.forEach((exp, index) => {
      csvRows.push([`Berufserfahrung ${index + 1}`, 'Position', exp.position || '']);
      csvRows.push([`Berufserfahrung ${index + 1}`, 'Firma', exp.company || '']);
      csvRows.push([`Berufserfahrung ${index + 1}`, 'Von', exp.startDate || '']);
      csvRows.push([`Berufserfahrung ${index + 1}`, 'Bis', exp.endDate || '']);
      csvRows.push([`Berufserfahrung ${index + 1}`, 'Beschreibung', exp.description || '']);
      csvRows.push(['', '', '']); // Leerzeile
    });
    
    // Ausbildung
    educations.forEach((edu, index) => {
      csvRows.push([`Ausbildung ${index + 1}`, 'Titel', edu.degree || '']);
      csvRows.push([`Ausbildung ${index + 1}`, 'Beschreibung', edu.description || '']);
      csvRows.push([`Ausbildung ${index + 1}`, 'Institution', edu.institution || '']);
      csvRows.push([`Ausbildung ${index + 1}`, 'Von', edu.startDate || '']);
      csvRows.push([`Ausbildung ${index + 1}`, 'Bis', edu.endDate || '']);
      csvRows.push(['', '', '']); // Leerzeile
    });
    
    // Zertifizierungen
    certifications.forEach((cert, index) => {
      csvRows.push([`Zertifizierung ${index + 1}`, 'Name', cert.name || '']);
      csvRows.push([`Zertifizierung ${index + 1}`, 'Beschreibung', cert.description || '']);
      csvRows.push([`Zertifizierung ${index + 1}`, 'Aussteller', cert.issuer || '']);
      csvRows.push([`Zertifizierung ${index + 1}`, 'Datum', cert.date || '']);
      csvRows.push(['', '', '']); // Leerzeile
    });
    
    // Kernkompetenzen
    csvRows.push(['Kernkompetenzen', 'Liste', coreCompetencies.join(', ')]);
    csvRows.push(['', '', '']); // Leerzeile
    
    // IT-Skills
    csvRows.push(['IT-Skills', 'Liste', itSkills.join(', ')]);
    csvRows.push(['', '', '']); // Leerzeile
    
    // Sprachen
    languages.forEach((lang, index) => {
      csvRows.push([`Sprache ${index + 1}`, 'Sprache', lang.language || '']);
      csvRows.push([`Sprache ${index + 1}`, 'Level', lang.level || '']);
      csvRows.push(['', '', '']); // Leerzeile
    });
    
    // Hobbys
    csvRows.push(['Hobbys', 'Liste', hobbies.join(', ')]);
    csvRows.push(['', '', '']); // Leerzeile
    
    // Branchenerfahrungen
    industryExperiences.forEach((ind, index) => {
      csvRows.push([`Branchenerfahrung ${index + 1}`, 'Branche', ind.industry || '']);
      csvRows.push([`Branchenerfahrung ${index + 1}`, 'Jahre', ind.years || '']);
      csvRows.push(['', '', '']); // Leerzeile
    });
    
    // Weitere Angaben
    additionalInfo.forEach((info, index) => {
      csvRows.push([`Weitere Angaben ${index + 1}`, 'Text', info || '']);
    });
    
    // CSV-String erstellen
    const csvContent = csvRows
      .map(row => row.map(cell => `"${cell.toString().replace(/"/g, '""')}"`).join(','))
      .join('\n');
    
    // BOM für UTF-8 hinzufügen (für korrekte Umlaute in Excel)
    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
    
    // Download auslösen
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', `${currentCvName || 'CV-Daten'}_${new Date().toISOString().split('T')[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
    console.log('✅ CV-Daten als CSV exportiert');
  };

  const buildDefaultCvLevelSettings = (templateId: 'template1' | 'template2' | 'template3' = selectedTemplateId): CvSettings => ({
    ...defaultCvSettings,
    template1: { ...defaultCvSettings.template1 },
    template2: { ...defaultCvSettings.template2 },
    template3: { ...defaultCvSettings.template3 },
    selectedTemplate: templateId,
    lastUpdated: new Date().toISOString()
  });

  // Funktion zum Laden eines spezifischen CVs
  const loadAndApplyCvSettingsForCv = async (cvId: string) => {
    const cvSpecificSettings = await loadCvSettings(cvId);
    if (cvSpecificSettings) {
      applyCvSettings(cvSpecificSettings);
      return;
    }

    // Kein CV-spezifisches Setting vorhanden:
    // Initialisiere neues CV mit Account-Settings im strukturierten Format.
    try {
      const idToken = await user?.getIdToken();
      if (idToken) {
        const accountSettings = await loadAccountCvSettingsFromBackend(idToken);
        if (accountSettings) {
          const accountBasedCvSettings: CvSettings = {
            ...buildDefaultCvLevelSettings(accountSettings.selectedTemplate || 'template1'),
            ...accountSettings,
            selectedTemplate: accountSettings.selectedTemplate || 'template1',
            lastUpdated: new Date().toISOString(),
            version: '2.0.0'
          };

          applyCvSettings(accountBasedCvSettings);
          await saveCvSettings(cvId, accountBasedCvSettings);
          console.log('✅ Neues CV mit Account-Design initialisiert und gespeichert:', cvId);
          return;
        }
      }
    } catch (error) {
      console.warn('⚠️ Account-Design konnte für neues CV nicht geladen werden, verwende Defaults:', error);
    }

    const defaultCvLevelSettings = buildDefaultCvLevelSettings();
    applyCvSettings(defaultCvLevelSettings);
  };

  const handleSelectCv = async (cvId: string, openModal: boolean = false, setAsDefault: boolean = true, clearMatchScore: boolean = false) => {
    if (!user || !cvId) {
      console.error('❌ handleSelectCv: Kein User oder keine cvId', { user: !!user, cvId });
      return;
    }

    // Prüfe ob CV gewechselt wird (nicht nur erstmalige Auswahl)
    const previousCvId = selectedCvId;
    const previousCvName = currentCvName;
    const isCvChanged = previousCvId !== null && previousCvId !== cvId;

    // Neue Auswahl-Operation: laufende Auswahl abbrechen und Request markieren
    const requestId = cvSelectionRequestIdRef.current + 1;
    cvSelectionRequestIdRef.current = requestId;
    cvSelectionAbortControllerRef.current?.abort();
    const abortController = new AbortController();
    cvSelectionAbortControllerRef.current = abortController;
    const isLatestSelectionRequest = () =>
      cvSelectionRequestIdRef.current === requestId &&
      cvSelectionAbortControllerRef.current === abortController &&
      !abortController.signal.aborted;

    // Wenn CV gewechselt wird, lösche Passgenauigkeit und optimierte Daten
    // (da sie sich auf das vorherige CV beziehen)
    if (isCvChanged) {
      console.log('🔄 CV gewechselt:', previousCvId, '->', cvId, '- Lösche Passgenauigkeit und optimierte Daten');
      clearOptimizedAndMatchData();
      setSelectedApplicationId(null); // Application bezieht sich auch auf das vorherige CV
      setCvTemplateHasBeenOpened(false); // Deaktiviere Motivationsschreiben-Icon
    }

    try {
      setIsLoading(true);
      setSelectedCvId(cvId);
      // Speichere selectedCvId im localStorage
      localStorage.setItem('selectedCvId', cvId);

      const idToken = await user.getIdToken();
      if (!isLatestSelectionRequest()) return;

      // Setze CV als Standard-CV im Backend (nur wenn setAsDefault true ist)
      if (setAsDefault) {
        try {
          await fetch(`${config.backend.baseUrl}/api/set-default-cv/${cvId}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${idToken}`
            },
            signal: abortController.signal
          });
          if (!isLatestSelectionRequest()) return;
          console.log('✅ CV als Standard gesetzt:', cvId);
        } catch (error) {
          if (abortController.signal.aborted || (error as any)?.name === 'AbortError') {
            return;
          }
          console.error('❌ Fehler beim Setzen des Standard-CVs:', error);
          // Weiter machen, auch wenn das Setzen als Standard fehlschlägt
        }
      }
      const response = await fetch(`${config.backend.baseUrl}/api/get-encrypted-data/${cvId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        signal: abortController.signal
      });
      if (!isLatestSelectionRequest()) return;

      if (response.ok) {
        const result = await response.json();
        if (!isLatestSelectionRequest()) return;
        const data = result.data || {};

        // Setze alle Daten aus der verschlüsselten Antwort
        setFullName(data?.fullName || data?.personalInfo?.fullName || "");
        setCompany(data?.company || "");
        setAddress(data?.address || "");
        setPostalCode(data?.postalCode || "");
        setCity(data?.city || "");
        setCountry(mapCountryToSelectValue(data?.country || ""));
        setAvailableFrom(data?.availableFrom || "");
        setPhoneNumber(data?.phoneNumber || "");
        setEmail(data?.email || "");
        setBirthYear(data?.birthYear || "");
        setNationality(mapNationalityToSelectValue(data?.nationality || ""));
        setResidencePermit(mapResidencePermitToSelectValue(data?.residencePermit || ""));
        setCivilStatus(mapCivilStatusToSelectValue(data?.civilStatus || ""));
        setShortProfile(data?.shortProfile || "");
        
        // Arrays
        setWorkExperiences(data?.workExperiences || []);
        setEducations(data?.educations || []);
        setCertifications(data?.certifications || []);
        setIndustryExperiences(data?.industryExperiences || []);
        setLanguages(Array.isArray(data?.languages) ? data.languages.map((lang: any) => ({
          ...lang,
          level: mapLanguageLevelToSelectValue(lang.level || lang.proficiency || '')
        })) : []);
        setCoreCompetencies(Array.isArray(data?.coreCompetencies) ? data.coreCompetencies : []);
        setItSkills(Array.isArray(data?.itSkills) ? data.itSkills.map((skill: any) => ({
          ...skill,
          level: mapItSkillLevelToSelectValue(skill.level || skill.proficiency || '')
        })) : []);
        setHobbies(normalizeHobbyList(data?.hobbies));
        setAdditionalInfo(Array.isArray(data?.additionalInfo) ? data.additionalInfo : []);
        
        // Profilfoto
        if (data?.profileImage) {
          if (typeof data.profileImage === 'string') {
            setProfileImage(data.profileImage);
          } else if (data.profileImage.data) {
            setProfileImage(`data:${data.profileImage.type};base64,${data.profileImage.data}`);
          }
        } else {
          setProfileImage(null);
        }
        
        // Signatur
        if (data?.signature) {
          if (typeof data.signature === 'string') {
            setSignature(data.signature);
          } else if (data.signature.data) {
            setSignature(`data:${data.signature.type};base64,${data.signature.data}`);
          }
        } else {
          setSignature(null);
        }

        // Setze CV-Namen
        setCurrentCvName(result.cvName || '');
        if (!isLatestSelectionRequest()) return;

        // Lade zuerst account-basierte Settings und überschreibe sie ggf. mit CV-spezifischen Settings
        await loadAndApplyCvSettingsForCv(cvId);
        if (!isLatestSelectionRequest()) return;

        // Öffne Modal wenn gewünscht
        if (openModal) {
          // skipReload=true verhindert, dass direkt danach erneut mit alter selectedCvId geladen wird
          // clearMatchScore wird vom Aufrufer übergeben (true wenn Modal über Zahnrad-Icon geöffnet wird)
          await openCvDataModal(false, true, clearMatchScore); // false = normaler Klick, true = skipReload, clearMatchScore = Passgenauigkeit löschen
        }
      } else {
        throw new Error(`Fehler beim Laden der CV-Daten: ${response.status} ${response.statusText}`);
      }
    } catch (error) {
      if (abortController.signal.aborted || (error as any)?.name === 'AbortError') {
        console.log('ℹ️ CV-Ladevorgang abgebrochen:', cvId);
        return;
      }
      if (!isLatestSelectionRequest()) return;

      console.error('❌ Fehler beim Laden des CVs:', error);

      // Fallback: Auswahl auf vorheriges CV zurücksetzen (falls vorhanden),
      // sonst Daten leeren, damit keine veralteten Inhalte gespeichert werden.
      if (previousCvId) {
        setSelectedCvId(previousCvId);
        localStorage.setItem('selectedCvId', previousCvId);
        setCurrentCvName(previousCvName || '');
      } else {
        localStorage.removeItem('selectedCvId');
        clearAllCvData();
      }
    }
    finally {
      if (isLatestSelectionRequest()) {
        setIsLoading(false);
      }
    }
  };

  // HINWEIS: Der alte fetchCv useEffect wurde entfernt
  // CV-Auswahl erfolgt über das Dropdown "CV-Daten Set" in den Job-Informationen
  // Die automatische Auswahl des Standard-/neuesten CVs passiert in der loadUserCvs Funktion

  // Automatische Tab-Auswahl nur beim ersten Laden der App
  React.useEffect(() => {
    // Warte bis alle Daten geladen sind: App geladen, User vorhanden, CV-Daten geladen
    if (hasLoaded && user && cvDataLoaded && !tabSelectionExecuted) {
      const hasDataResult = hasData();
      console.log('🔍 Tab-Auswahl Debug (nur beim App-Start):', {
        hasLoaded,
        cvDataLoaded,
        hasDataResult,
        fullName,
        company,
        workExperiencesLength: workExperiences?.length || 0,
        educationsLength: educations?.length || 0,
        languagesLength: languages?.length || 0,
        userCvsLength: userCvs?.length || 0
      });
      
      if (hasDataResult) {
        // CV-Daten vorhanden → "Bewerbungen" Tab (Index 0 = "Start")
        setCvTabIndex(0);
        console.log('✅ CV-Daten vorhanden - zeige "Bewerbungen" Tab (Index 0)');
      } else {
        // Keine CV-Daten → "CV Daten" Tab (Index 1)
        setCvTabIndex(1);
        console.log('ℹ️ Keine CV-Daten - zeige "CV Daten" Tab (Index 1)');
      }
      
      // Markiere Tab-Auswahl als ausgeführt
      setTabSelectionExecuted(true);
    }
  }, [hasLoaded, user, cvDataLoaded, userCvs, tabSelectionExecuted]); // Warte auf cvDataLoaded

  // DEAKTIVIERT: Automatisches Speichern von CV-Daten
  // CV-Daten werden jetzt nur noch gespeichert, wenn die Checkbox "Daten sind wahrheitsgetreu" auf true gesetzt wird
  // React.useEffect(() => {
  //   if (!user || !hasLoaded) return; // Warte bis Daten geladen sind
  //   
  //   // Nur speichern wenn tatsächlich Daten vorhanden sind
  //   const hasData = fullName || company || address || postalCode || city || phoneNumber || email || birthYear || nationality || residencePermit || civilStatus || shortProfile || workExperience || education || certificates || 
  //                  (Array.isArray(languages) && languages.length > 0) || 
  //                  (Array.isArray(coreCompetencies) && coreCompetencies.length > 0) || 
  //                  (Array.isArray(itSkills) && itSkills.length > 0) || 
  //                  (Array.isArray(hobbies) && hobbies.length > 0) || 
  //                  (Array.isArray(additionalInfo) && additionalInfo.length > 0) ||
  //                  (Array.isArray(workExperiences) && workExperiences.length > 0) || 
  //                  (Array.isArray(educations) && educations.length > 0) || 
  //                  (Array.isArray(certifications) && certifications.length > 0) || 
  //                  (Array.isArray(industryExperiences) && industryExperiences.length > 0) ||
  //                  profileImage || signature;
  //   
  //   if (hasData) {
  //     // Verwende Backend-Endpoint für automatische Klassifizierung und Verschlüsselung
  //     const saveData = async () => {
  //       try {
  //         // Echten Firebase ID Token für Backend-Authentication verwenden
  //         const idToken = await user.getIdToken();
  //         const response = await fetch(`${config.backend.saveDataUrl}`, {
  //           method: 'POST',
  //           headers: {
  //             'Content-Type': 'application/json',
  //             'Authorization': `Bearer ${idToken}`
  //           },
  //           body: JSON.stringify({
  //             uid: user.uid,
  //             data: {
  //               fullName,
  //               company,
  //               address,
  //               postalCode,
  //               city,
  //               country,
  //               availableFrom,
  //               phoneNumber,
  //               email,
  //               birthYear,
  //               nationality,
  //               residencePermit,
  //               civilStatus,
  //               shortProfile,
  //               workExperience,
  //               education,
  //               certificates,
  //               languages,
  //               coreCompetencies,
  //               itSkills,
  //               hobbies,
  //               additionalInfo,
  //               workExperiences,
  //               educations,
  //               certifications,
  //               industryExperiences,
  //               profileImage,
  //               signature,
  //             }
  //           })
  //         });

  //         if (response.ok) {
  //           const result = await response.json();
  //           console.log('🔒 Daten erfolgreich klassifiziert und verschlüsselt gespeichert:', result.classification);
  //         } else {
  //           console.error('Fehler beim Speichern verschlüsselter Daten');
  //         }
  //       } catch (error) {
  //         console.error('Fehler beim Speichern verschlüsselter Daten:', error);
  //       }
  //     };

  //     saveData();
  //   }
  // }, [fullName, address, phoneNumber, email, birthYear, nationality, residencePermit, civilStatus, shortProfile, workExperience, education, certificates, languages, itSkills, additionalInfo, workExperiences, educations, certifications, industryExperiences, coreCompetencies, profileImage, signature, country, availableFrom, user, hasLoaded]);

  // Debug useEffect für Profilbild-Status
  // Profilbild Debug-Log entfernt für bessere Performance

  // Funktion zum Upload von Original-Dokumenten


  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setCvFile(file);
      
      // Prüfe CV-Limit
      const limits = getAccountLimits(accountType);
      if (userCvs.length >= limits.maxCvs) {
        setError(t('account.limit.cvs.reached', { max: limits.maxCvs }));
        e.target.value = ''; // Reset file input
        return;
      }
      
      // Setze Checkbox "Daten sind wahrheitsgetreu" auf false beim CV-Upload
      
      // Prüfe Dateityp
      const fileExt = file.name.split('.').pop()?.toLowerCase();
      if (!fileExt || !['docx', 'doc', 'pdf', 'txt'].includes(fileExt)) {
        setError('Nur Word-Dateien (.docx, .doc), PDF-Dateien (.pdf) und Text-Dateien (.txt) werden unterstützt.');
        return;
      }
      
      // Prüfe Dateigröße (max 10MB)
      if (file.size > 10 * 1024 * 1024) {
        setError('Datei ist zu groß. Maximale Größe: 10MB.');
        return;
      }
      
      // Sende Original-Dokument direkt an Backend
      uploadOriginalDocument(file);
    }
  };

  // QR-Code für Foto-Upload generieren
  const generatePhotoQrCode = async () => {
    if (!user) {
      setError('Kein User angemeldet');
      return;
    }
    
    setIsGeneratingQr(true);
    setError(null);
    
    try {
      // QR-Code-Generierung gestartet
      const idToken = await user.getIdToken();
      console.log('🔐 ID Token erhalten');
      
      const requestUrl = `${config.backend.baseUrl}/api/generate-photo-qr`;
      console.log('🌐 Request URL:', requestUrl);
      
      const response = await fetch(requestUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        }
      });
      
      console.log('📥 Response Status:', response.status, response.statusText);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ Response Error:', errorText);
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }
      
      const data = await response.json();
      console.log('📦 Response Data:', data);
      
      if (data.success && data.qrCode) {
        console.log('✅ QR-Code erhalten, Länge:', data.qrCode.length);
        setQrCodeData(data.qrCode);
        setQrSessionId(data.sessionId);
        setQrExpiresAt(data.expiresAt);
        setShowQrCodeDialog(true);
        console.log('✅ QR-Code Dialog geöffnet');
      } else {
        console.error('❌ Kein QR-Code in Response:', data);
        throw new Error('QR-Code konnte nicht generiert werden');
      }
      
    } catch (error) {
      console.error('❌ Fehler beim Generieren des QR-Codes:', error);
      setError('Fehler beim Generieren des QR-Codes: ' + (error as Error).message);
    } finally {
      setIsGeneratingQr(false);
    }
  };

  // QR-Code Session Status prüfen
  const checkQrSessionStatus = async () => {
    if (!qrSessionId || !user) return;
    
    try {
      const idToken = await user.getIdToken();
      
      // Prüfe ob das Foto hochgeladen wurde
      const response = await fetch(`${config.backend.userDataUrl}/${user.uid}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        }
      });
      
      if (response.ok) {
        const result = await response.json();
        const data = result.data || {};
        
        // Prüfe ob ein neues Foto hochgeladen wurde - unterstützt beide Formate
        if (data?.profileImage) {
          if (typeof data.profileImage === 'string') {
            // Direkter Base64-String (aus verschlüsselten Daten)
            setProfileImage(data.profileImage);
            setShowQrCodeDialog(false);
            console.log('✅ Neues Profilfoto über QR-Code empfangen (verschlüsselt)');
          } else if (data.profileImage.data) {
            // Strukturiertes Format mit data und type
            setProfileImage(`data:${data.profileImage.type};base64,${data.profileImage.data}`);
            setShowQrCodeDialog(false);
            console.log('✅ Neues Profilfoto über QR-Code empfangen (strukturiert)');
          }
        }
      }
      
    } catch (error) {
      console.error('❌ Fehler beim Prüfen des QR-Session-Status:', error);
    }
  };

  // Polling für QR-Code Status
  React.useEffect(() => {
    if (showQrCodeDialog && qrSessionId) {
      const interval = setInterval(checkQrSessionStatus, 2000); // Alle 2 Sekunden prüfen
      return () => clearInterval(interval);
    }
  }, [showQrCodeDialog, qrSessionId, user]);

  // Funktion um Account-Status zu überprüfen und bei Bedarf zu erstellen
  const ensureAccountExists = async (): Promise<boolean> => {
    if (accountId) {
      console.log('✅ Account bereits vorhanden:', accountId);
      return true;
    }
    
    console.log('🔄 Kein Account gefunden, versuche Account zu erstellen...');
    try {
      const existingAccountId = await checkAccountStatus();
      
      if (existingAccountId) {
        console.log('✅ Account nach Status-Check gefunden:', existingAccountId);
        return true;
      }
      
      // Versuche Account zu erstellen
      const newAccountId = await createAccount();
      
      if (newAccountId) {
        console.log('✅ Account erstellt und gefunden:', newAccountId);
        return true;
      }
      
      console.error('❌ Account konnte nicht erstellt oder gefunden werden');
      return false;
    } catch (error) {
      console.error('❌ Fehler beim Account-Setup:', error);
      return false;
    }
  };

  const uploadOriginalDocument = async (file: File) => {
    // Prüfe ob User einen Account hat, falls nicht, versuche einen zu erstellen
    const hasAccount = await ensureAccountExists();
    if (!hasAccount) {
      setError('Bitte warten Sie, bis Ihr Account erstellt wurde, und versuchen Sie es erneut.');
      return;
    }
    
    console.log('✅ Account gefunden für CV-Upload:', accountId);
    
    // Schließe das CV-Upload-Modal während des Uploads und markiere als manuell geschlossen
    setShowAddCvModal(false);
    setCvModalManuallyClosed(true);
    
    // Reset alle Daten
    // originalCvText wurde entfernt
    setFullName('');
    setCompany('');
    setAddress('');
    setPostalCode('');
    setCity('');
    setCountry('');
    setAvailableFrom('');
    setPhoneNumber('');
    setEmail('');
    setBirthYear('');
    setNationality('');
    setResidencePermit('');
    setCivilStatus('');
    setShortProfile('');
    setWorkExperience('');
    setEducation('');
    setCertificates('');
    setLanguages([]);
    setCoreCompetencies([]);
    setItSkills([]);
    setHobbies([]);
    setAdditionalInfo([]);
    setProfileImage(null);
    setSignature(null);
    setOptimizedImages([]);
    setShowImageOptimizer(false);
    setOriginalCvMarkdown(null);
    setError(null);
    setExtracting(true);
    
    // Generiere Session-ID für SSE
    const sessionId = `upload_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    
    // Initialisiere Import-Fortschrittsanzeige (ähnlich wie CV-Optimierung)
    setImportProgress({
      'Text extrahieren': 'pending',
      'Persönliche Informationen': 'pending',
      'Kernkompetenzen': 'pending',
      'Branchen': 'pending',
      'Hobbies': 'pending',
      'IT-Skills': 'pending',
      'Sprachen': 'pending',
      'Ausbildung': 'pending',
      'Zertifizierungen': 'pending',
      'Berufserfahrung': 'pending',
      'Weitere Angaben': 'pending'
    });
    
    // Starte SSE-Verbindung für Fortschrittsupdates
    const eventSource = new EventSource(`${config.backend.baseUrl}/api/upload-progress/${sessionId}`);
    
    eventSource.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log('📡 SSE-Update erhalten:', data);
        
        if (data.type === 'progress') {
          // Update Fortschrittsanzeige basierend auf Backend-Updates
          setImportProgress(prev => {
            const updated = { ...prev };
            
            // Mappe Backend-Schritte zu Frontend-Schritten (jeder Prompt einzeln)
            switch (data.step) {
              case 'text_extraction':
                if (data.status === 'running') {
                  updated['Text extrahieren'] = 'running';
                } else if (data.status === 'completed') {
                  updated['Text extrahieren'] = 'completed';
                }
                break;
              case 'main_prompt':
                if (data.status === 'running') {
                  updated['Persönliche Informationen'] = 'running';
                } else if (data.status === 'completed') {
                  updated['Persönliche Informationen'] = 'completed';
                }
                break;
              case 'core_competencies':
                if (data.status === 'running') {
                  updated['Kernkompetenzen'] = 'running';
                } else if (data.status === 'completed') {
                  updated['Kernkompetenzen'] = 'completed';
                }
                break;
              case 'branches':
                if (data.status === 'running') {
                  updated['Branchen'] = 'running';
                } else if (data.status === 'completed') {
                  updated['Branchen'] = 'completed';
                }
                break;
              case 'hobbies':
                if (data.status === 'running') {
                  updated['Hobbies'] = 'running';
                } else if (data.status === 'completed') {
                  updated['Hobbies'] = 'completed';
                }
                break;
              case 'it_skills':
                if (data.status === 'running') {
                  updated['IT-Skills'] = 'running';
                } else if (data.status === 'completed') {
                  updated['IT-Skills'] = 'completed';
                }
                break;
              case 'languages':
                if (data.status === 'running') {
                  updated['Sprachen'] = 'running';
                } else if (data.status === 'completed') {
                  updated['Sprachen'] = 'completed';
                }
                break;
              case 'education':
                if (data.status === 'running') {
                  updated['Ausbildung'] = 'running';
                } else if (data.status === 'completed') {
                  updated['Ausbildung'] = 'completed';
                }
                break;
              case 'certificates':
                if (data.status === 'running') {
                  updated['Zertifizierungen'] = 'running';
                } else if (data.status === 'completed') {
                  updated['Zertifizierungen'] = 'completed';
                }
                break;
              case 'work_experience':
                if (data.status === 'running') {
                  updated['Berufserfahrung'] = 'running';
                } else if (data.status === 'completed') {
                  updated['Berufserfahrung'] = 'completed';
                }
                break;
              case 'additional_info':
                if (data.status === 'running') {
                  updated['Weitere Angaben'] = 'running';
                } else if (data.status === 'completed') {
                  updated['Weitere Angaben'] = 'completed';
                }
                break;
              case 'photo_extraction':
                // Foto-Extraktion wird nicht in der Fortschrittsanzeige angezeigt
                break;
              case 'data_saving':
                // Daten speichern wird nicht in der Fortschrittsanzeige angezeigt
                break;
            }
            
            return updated;
          });
        }
      } catch (error) {
        console.error('❌ Fehler beim Parsen der SSE-Daten:', error);
      }
    };
    
    eventSource.onerror = (error) => {
      console.error('❌ SSE-Verbindungsfehler:', error);
    };
    
    // Variablen für die neue CV-ID und -Name (im gesamten Scope verfügbar)
    let importedCvId: string | null = null;
    let importedCvName: string | null = null;
    
    try {
      console.log('📤 Sende Original-Dokument an Backend:', {
        fileName: file.name,
        fileSize: file.size,
        fileType: file.type
      });
      
      // Konvertiere File zu Base64 und sende als JSON
      // Beachte: Wir können den FullName hier noch nicht verwenden, da er erst aus der Backend-Antwort kommt
      // Wir verwenden einen Platzhalter, der später durch den FullName ersetzt wird
      const fileData = await convertFileToBase64(file);
      const requestData = {
        fileData: fileData,
        fileName: file.name,
        fileType: file.type,
        jobDescription: jobDescription || getTranslatedCvLabel('CV wird verarbeitet...'),
        sessionId: sessionId,
        cvName: newCvName || '__USE_FULLNAME__', // Platzhalter, der später durch FullName ersetzt wird
        language: currentLanguage
      };
      
      // User-Authentifizierung für Backend-Request
      if (!user) {
        throw new Error('Kein User angemeldet');
      }
      
      const idToken = await user.getIdToken();
      
      const response = await fetch(config.backend.extractCvUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify(requestData),
      });
      
      console.log('📥 Backend-Antwort erhalten:', response.status, response.statusText);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ Backend-Fehler:', errorText);
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }
      
      const data = await response.json();
      
      console.log('✅ Original-Dokument erfolgreich verarbeitet!');
      console.log('📋 Neue CV-ID aus Backend-Response:', data.cvId);
      console.log('📋 Neuer CV-Name aus Backend-Response:', data.cvName);
      
      // Speichere die cvId und cvName für spätere Verwendung
      importedCvId = data.cvId;
      importedCvName = data.cvName;
      
      // SSE-Updates übernehmen die Fortschrittsanzeige
      
      // Verarbeite die AI-extrahierten Daten
      // originalCvText wurde entfernt - nicht mehr benötigt
      
      // Verwende die Daten direkt aus der Backend-Antwort
      const extractedData = data;
      
      // Persönliche Informationen aus der AI-extrahierten Backend-Antwort setzen
      // AI-extrahierten Daten verarbeitet
      
      if (extractedData.fullName && extractedData.fullName !== 'CV Upload' && extractedData.fullName !== 'Unbekannt') {
        setFullName(extractedData.fullName);
        console.log('✅ Echten Namen gesetzt:', extractedData.fullName);
      }
      
      
      if (extractedData.email) {
        setEmail(extractedData.email);
        console.log('✅ E-Mail gesetzt:', extractedData.email);
      }
      
      if (extractedData.phoneNumber) {
        setPhoneNumber(extractedData.phoneNumber);
        console.log('✅ Telefonnummer gesetzt:', extractedData.phoneNumber);
      }
      
      if (extractedData.address) {
        setAddress(extractedData.address);
        console.log('✅ Adresse gesetzt:', extractedData.address);
      } else {
        console.log('❌ Keine Adresse in AI-Antwort gefunden');
      }
      
      if (extractedData.postalCode) {
        setPostalCode(extractedData.postalCode);
        console.log('✅ PLZ gesetzt:', extractedData.postalCode);
      }
      
      if (extractedData.city) {
        setCity(extractedData.city);
        console.log('✅ Stadt gesetzt:', extractedData.city);
      }
      
      if (extractedData.country) {
        setCountry(mapCountryToSelectValue(extractedData.country));
        console.log('✅ Land gesetzt:', extractedData.country, '->', mapCountryToSelectValue(extractedData.country));
      }
      
      if (extractedData.company) {
        setCompany(extractedData.company);
        console.log('✅ Firma gesetzt:', extractedData.company);
      }
      
      if (extractedData.birthYear) {
        setBirthYear(extractedData.birthYear);
        console.log('✅ Geburtsjahr gesetzt:', extractedData.birthYear);
      }
      
      if (extractedData.availableFrom) {
        setAvailableFrom(extractedData.availableFrom);
        console.log('✅ Verfügbar ab gesetzt:', extractedData.availableFrom);
      }
      
      // Nationalität und Aufenthaltsbewilligung nicht aus CV übernehmen – müssen manuell erfasst werden
      setNationality('');
      setResidencePermit('');
      
      if (extractedData.civilStatus) {
        const mappedCivilStatus = mapCivilStatusToSelectValue(extractedData.civilStatus);
        setCivilStatus(mappedCivilStatus);
        console.log('✅ Familienstand gesetzt:', extractedData.civilStatus, '->', mappedCivilStatus);
      }
      
      if (extractedData.shortProfile && extractedData.shortProfile !== getTranslatedCvLabel('CV wird verarbeitet...')) {
        setShortProfile(extractedData.shortProfile);
        console.log('✅ Echtes Profil gesetzt:', extractedData.shortProfile);
      }
      
      // Berufserfahrung und Ausbildung
      if (extractedData.workExperiences && extractedData.workExperiences.length > 0) {
        setWorkExperiences(extractedData.workExperiences);
        console.log('✅ Berufserfahrungen gesetzt:', extractedData.workExperiences.length);
      }
      
      
      if (extractedData.educations && extractedData.educations.length > 0) {
        setEducations(extractedData.educations);
        console.log('✅ Ausbildung gesetzt:', extractedData.educations.length);
      }
      
      
      if (extractedData.certifications && extractedData.certifications.length > 0) {
        setCertifications(extractedData.certifications);
        console.log('✅ Zertifizierungen gesetzt:', extractedData.certifications.length);
      } else {
        console.log('❌ Keine Zertifizierungen in AI-Antwort gefunden');
      }
      
      
      if (extractedData.industryExperiences && extractedData.industryExperiences.length > 0) {
        setIndustryExperiences(extractedData.industryExperiences);
        console.log('✅ Branchenerfahrungen gesetzt:', extractedData.industryExperiences.length);
      } else {
        console.log('❌ Keine Branchenerfahrungen in AI-Antwort gefunden');
      }
      
      // IT-Skills, Sprachen und Kompetenzen
      if (extractedData.itSkills && extractedData.itSkills.length > 0) {
        setItSkills(extractedData.itSkills);
        console.log('✅ IT-Skills gesetzt:', extractedData.itSkills.length);
      }
      
      
      if (extractedData.languages && extractedData.languages.length > 0) {
        setLanguages(extractedData.languages);
        console.log('✅ Sprachen gesetzt:', extractedData.languages.length);
      }
      
      
      if (extractedData.coreCompetencies && extractedData.coreCompetencies.length > 0) {
        setCoreCompetencies(extractedData.coreCompetencies);
        console.log('✅ Kernkompetenzen gesetzt:', extractedData.coreCompetencies.length);
      }
      
      if (extractedData.hobbies && extractedData.hobbies.length > 0) {
        setHobbies(normalizeHobbyList(extractedData.hobbies));
        console.log('✅ Hobbys erfolgreich gesetzt:', extractedData.hobbies.length);
      }
      
      
      if (extractedData.additionalInfo && extractedData.additionalInfo.length > 0) {
        setAdditionalInfo(extractedData.additionalInfo);
        console.log('✅ Zusätzliche Informationen gesetzt:', extractedData.additionalInfo.length);
      }
      
      // Foto-Verarbeitung - unterstützt beide Formate
      if (data.profileImage) {
        if (typeof data.profileImage === 'string') {
          // Direkter Base64-String
          setProfileImage(data.profileImage);
          console.log('✅ Profilfoto gesetzt (direkter String)');
        } else if (data.profileImage.data) {
          // Strukturiertes Format mit data und type
          setProfileImage(`data:${data.profileImage.type};base64,${data.profileImage.data}`);
          console.log('✅ Profilfoto gesetzt:', data.profileImage.size, 'Bytes');
        } else {
          console.log('📸 Kein Profilfoto in der Antwort gefunden');
        }
      } else {
        console.log('📸 Kein Profilfoto in der Antwort gefunden');
      }
      

      // Speichere die Daten über das Backend in Firebase
      if (data.savedToFirebase) {
        console.log('✅ CV-Daten wurden über das Backend in Firebase gespeichert');
      }
      
      // Zeige Erfolgsmeldung für AI-Extraktion
      if (data.extractionMethod === 'AI-GPT4' || data.extractionMethod === 'Fallback-Extraktion') {
        console.log('🤖 Persönliche-Informationen-Extraktion erfolgreich abgeschlossen');
        setError(null); // Lösche eventuelle Fehler
        
        // Maximiere alle CV-Sektionen nach der Extraktion
        setMinimizedSections({
          industryExperiences: false,
          workExperience: false,
          education: false,
          certifications: false,
          languages: false,
          coreCompetencies: false,
          itSkills: false,
          additionalInfo: false,
          hobbies: false
        });
        
        console.log('✅ Alle CV-Sektionen wurden maximiert');
        
        // Aktiviere den neu importierten CV und öffne das Modal
        // Die Daten sind BEREITS im State geladen - wir laden sie NICHT nochmal vom Backend!
        if (importedCvId && importedCvName) {
          // Wenn kein expliziter CV-Name angegeben wurde und ein FullName vorhanden ist, verwende den FullName
          let finalCvName = importedCvName;
          // Prüfe ob der Platzhalter verwendet wurde oder ob der Default-Name gesetzt wurde
          const isPlaceholder = importedCvName === '__USE_FULLNAME__';
          const isDefaultName = !newCvName && importedCvName.startsWith('CV vom ');
          
          if ((isPlaceholder || isDefaultName) && extractedData.fullName && extractedData.fullName !== 'CV Upload' && extractedData.fullName !== 'Unbekannt') {
            // Der Platzhalter oder Default-Name wurde verwendet, aktualisiere mit FullName
            finalCvName = extractedData.fullName;
            // Aktualisiere den CV-Namen im Backend
            try {
              const updateResponse = await fetch(`${config.backend.baseUrl}/api/update-cv-name/${importedCvId}`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${idToken}`
                },
                body: JSON.stringify({ cvName: finalCvName })
              });
              if (updateResponse.ok) {
                console.log('✅ CV-Name aktualisiert zu FullName:', finalCvName);
                // Aktualisiere auch in der userCvs Liste
                setUserCvs((prev: any[]) => 
                  prev.map((cv: any) => 
                    cv.cvId === importedCvId ? { ...cv, cvName: finalCvName } : cv
                  )
                );
              } else {
                const errorData = await updateResponse.json().catch(() => ({}));
                console.error('❌ Fehler beim Aktualisieren des CV-Namens:', errorData);
              }
            } catch (error) {
              console.error('❌ Fehler beim Aktualisieren des CV-Namens:', error);
            }
          }
          // Setze selectedCvId und CV-Name
          setSelectedCvId(importedCvId);
          setCurrentCvName(finalCvName);
          console.log('✅ Neuer CV aktiviert:', importedCvId, '(', finalCvName, ')');
          
          // Öffne das Modal mit den bereits geladenen Daten
          setShowCvDataModal(true);
          setTabIndex(0); // Setze Modal auf Tab "Persönliche Informationen" nach CV-Import
          setCvDataEditMode(true);
          setHasUnsavedChanges(false);
          console.log('✅ CV-Daten Modal geöffnet mit importierten Daten');
          
          // Zeige Warnung über AI-Genauigkeit nur wenn nicht deaktiviert
          if (!dontShowImportWarning) {
            setShowCvImportWarningDialog(true);
          }
        }
        
        // Alle Schritte abgeschlossen
        
        // SSE-Verbindung schließen
        eventSource.close();
      }
      
    } catch (err: any) {
      console.error('❌ Fehler beim Upload des Original-Dokuments:', err);
      setError('Fehler beim Verarbeiten des Dokuments: ' + (err.message || 'Unbekannter Fehler'));
      
      // Setze alle laufenden Schritte auf fehlgeschlagen
      setImportProgress(prev => {
        const updated = { ...prev };
        Object.keys(updated).forEach(key => {
          if (updated[key] === 'running') {
            updated[key] = 'failed';
          }
        });
        return updated;
      });
      
      // SSE-Verbindung schließen
      eventSource.close();
    } finally {
      setTimeout(async () => {
        setExtracting(false);
        // Setze Import-Fortschrittsanzeige zurück
        setImportProgress({});
        // Setze Checkbox "Daten sind wahrheitsgetreu" auf false nach CV-Import
        
        // Lade CV-Liste neu nach erfolgreichem Upload (für die Tabelle)
        if (user) {
          try {
            const idToken = await user.getIdToken();
            const response = await fetch(`${config.backend.baseUrl}/api/get-user-cvs`, {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${idToken}`
              }
            });
            
            if (response.ok) {
              const data = await response.json();
              setUserCvs(data.userCvs || []);
              console.log('✅ CV-Liste aktualisiert, Anzahl CVs:', data.userCvs?.length || 0);
            }
          } catch (error) {
            console.error('❌ Fehler beim Aktualisieren der CV-Liste:', error);
          }
        }
        
        // KEINE automatische Tab-Umschaltung nach CV-Upload
        // Der User bleibt auf dem aktuellen Tab
        console.log('ℹ️ CV-Upload abgeschlossen - Tab bleibt unverändert');
        
        // Modal wurde bereits im try-Block geöffnet mit den korrekten Daten
        // KEIN reloadCvDataFromBackend() hier - das würde die neuen Daten überschreiben!
      }, 1000); // Kurze Verzögerung, damit der Benutzer "100% Complete" sieht
    }
  };
  // Funktion zum Löschen aller CV-Daten
  const handleClearAllData = async () => {
    try {
      if (!user) return;
      
      // Alle States zurücksetzen
      setFullName('');
      setCompany('');
      setAddress('');
      setPostalCode('');
      setCity('');
      setCountry('');
      setAvailableFrom('');
      setPhoneNumber('');
      setEmail('');
      setBirthYear('');
      setNationality('');
      setResidencePermit('');
      setCivilStatus('');
      setShortProfile('');
      setWorkExperience('');
      setEducation('');
      setCertificates('');
      setLanguages([]);
      setCoreCompetencies([]);
      setItSkills([]);
      setAdditionalInfo([]);
      setOriginalCvMarkdown(null);
      setError(null);
      setMatchScore(null);
      resetMatchData();
      setImprovedCvText(null);
      setMotivationLetter(null);
      setWorkExperiences([]);
      setEducations([]);
      setCertifications([]);
      setIndustryExperiences([]);
      setHobbies([]);
      setProfileImage(null);
      setSignature(null);
      setOptimizedImages([]);
      setShowImageOptimizer(false);
 // Checkbox-Status zurücksetzen
      
      // Daten aus verschlüsselten Backend-Endpoints löschen
      try {
        // Echten Firebase ID Token für Backend-Authentication verwenden
        const idToken = await user.getIdToken();
        const response = await fetch(`${config.backend.deleteDataUrl}/${user.uid}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
          }
        });

        if (response.ok) {
          console.log('🔒 Daten erfolgreich aus verschlüsselten Backend-Endpoints gelöscht');
        } else {
          console.error('Fehler beim Löschen verschlüsselter Daten');
        }
      } catch (error) {
        console.error('Fehler beim Löschen verschlüsselter Daten:', error);
      }
      
      // Warte kurz, damit alle State-Updates verarbeitet werden können
      // Dann setze den Tab-Index auf 0 (erster Tab im Hauptfenster)
      await new Promise(resolve => setTimeout(resolve, 100));
      setMainTabIndex(0);
      
      console.log('✅ Alle Daten gelöscht und Tab 0 gesetzt');
      
    } catch (err: any) {
      console.error('Fehler beim Löschen der Daten:', err);
      setError(t('error.clear.data') + (err.message || ''));
    }
  };

  // Funktion zum Neuberechnen der Passgenauigkeit aus dem Modal
  const handleRecalculateMatchScoreFromModal = async () => {
    // Verwende dieselbe Fallback-Logik wie bei der Re-Optimierung:
    // Wenn jobDescription lokal leer ist, aus aktiver Bewerbung übernehmen.
    let effectiveJobDescription = jobDescription.trim();
    if (!effectiveJobDescription && selectedApplicationId && applications.length > 0) {
      const currentApp = applications.find((app: any) => app.id === selectedApplicationId);
      if (currentApp?.jobDescription) {
        effectiveJobDescription = currentApp.jobDescription;
        setJobDescription(effectiveJobDescription);
      }
    }
    if (!effectiveJobDescription) {
      setError('Stellenbeschreibung ist erforderlich.');
      return;
    }

    // Speichere zuerst CV-Daten inkl. lokaler Drafts aus dem Modal,
    // damit die Neuberechnung wirklich mit dem aktuell sichtbaren Stand arbeitet.
    const committedWorkExperiences = (draftWorkExperiences || []).map(exp => ({ ...exp }));
    const committedEducations = (draftEducations || []).map(edu => ({ ...edu }));
    const committedCertifications = (draftCertifications || []).map(cert => ({ ...cert }));
    const activeRowContext = activeCvPreviewRowContextRef.current;
    const activeRowEntry =
      activeRowContext && activeRowContext.applicationId === selectedApplicationId
        ? activeRowContext.rowEntry
        : null;
    const activeRowCvId =
      typeof activeRowEntry?.cvId === 'string' && activeRowEntry.cvId.trim()
        ? activeRowEntry.cvId.trim()
        : (resolveCvIdBySetRefStrict(typeof activeRowEntry?.cvSetRef === 'string' ? activeRowEntry.cvSetRef : '') || null);
    const selectedCvIdsFromJobInfo = Array.isArray(extractedJobInfo?.cvIds)
      ? (extractedJobInfo?.cvIds || []).map((id: any) => getNormalizedCvId(id)).filter((id: string) => !!id)
      : [];
    const selectedCvSetRefsFallback = Array.isArray(extractedJobInfo?.cvSetRefs)
      ? (extractedJobInfo?.cvSetRefs || []).filter((ref: any) => typeof ref === 'string' && ref.trim())
      : [];
    const selectedCvIds = activeRowCvId
      ? [activeRowCvId]
      : (selectedCvIdsFromJobInfo.length > 0
          ? selectedCvIdsFromJobInfo
          : selectedCvSetRefsFallback
              .map((setRef: string) => resolveCvIdBySetRefStrict(setRef))
              .filter((id: string | null): id is string => !!id));
    const hasMultipleSelectedCvSets = selectedCvIds.length > 1;

    if (!hasMultipleSelectedCvSets && selectedCvIds.length === 1) {
      // Bei einem einzelnen CV-Set erzwingen wir die Ziel-cvId explizit, damit
      // keine Daten auf ein anderes (global selektiertes) CV geschrieben werden.
      const forcedCvIdForSave: string | null = selectedCvIds[0] || null;

      if (!forcedCvIdForSave) {
        setError('❌ CV-Daten konnten nicht eindeutig einem CV-Daten-Set zugeordnet werden');
        return;
      }
      const persistedCvId = await saveAllCvDataToFirebase({
        updatedWorkExperiences: committedWorkExperiences,
        updatedEducations: committedEducations,
        updatedCertifications: committedCertifications
      }, forcedCvIdForSave);
      if (!persistedCvId) {
        setError('❌ CV-Daten konnten nicht eindeutig einem CV zugeordnet werden');
        return;
      }

      // Synchronisiere den In-Memory-State mit den gespeicherten Draft-Daten.
      setWorkExperiences(committedWorkExperiences);
      setEducations(committedEducations);
      setCertifications(committedCertifications);
    } else {
      // Bei Multi-CV oder unklarer Auswahl keine CV-Level-Persistierung:
      // sonst könnten globale Zustände versehentlich ein fremdes CV überschreiben.
      console.log('ℹ️ Recalculate ohne eindeutiges Einzel-CV-Set: Überspringe CV-Level-Speicherung zur Vermeidung von Überschreiben.');
    }
    
    // Setze ungespeicherte Änderungen zurück
    setHasUnsavedChanges(false);
    
    // Starte Neuberechnung mit Modal-spezifischer Warte-Animation
    setError(null);
    setMatchScore(null);
    resetMatchData();
    setCheckingMatchInModal(true);
    setCheckingMatch(false); // Stelle sicher, dass die normale Warte-Animation nicht angezeigt wird
    setHideJobDescription(true); // Verstecke das Stellenbeschreibung-Textfeld
    setHideMatchResults(false); // Zeige Match-Ergebnisse an
    setInfoMessage(getTranslatedInfoMessage('calculating_match'));
    
    // Rufe die normale Funktion mit den soeben gespeicherten Daten auf
    await handleCheckMatchScoreInternal({
      workExperiences: committedWorkExperiences,
      educations: committedEducations,
      certifications: committedCertifications
    }, 'recalculate');
    
    // Setze Modal-Warte-Animation zurück
    setCheckingMatchInModal(false);
  };
  
  // Interne Funktion für die Passgenauigkeits-Berechnung (ohne setCheckingMatch)
  const handleCheckMatchScoreInternal = async (
    overrides?: {
      workExperiences?: Array<any>;
      educations?: Array<any>;
      certifications?: Array<any>;
    },
    matchAction: 'calculate' | 'recalculate' = 'calculate'
  ) => {
    let effectiveJobDescription = jobDescription.trim();
    if (!effectiveJobDescription && selectedApplicationId && applications.length > 0) {
      const currentApp = applications.find((app: any) => app.id === selectedApplicationId);
      if (currentApp?.jobDescription) {
        effectiveJobDescription = currentApp.jobDescription;
        setJobDescription(effectiveJobDescription);
      }
    }

    // Ergänze die editierbaren strukturierten Job-Informationen, damit
    // die Passgenauigkeit mit den neuesten Änderungen berechnet wird.
    effectiveJobDescription = enrichJobDescriptionWithExtractedInfo(
      effectiveJobDescription,
      extractedJobInfo
    );

    if (!normalizeJobDescriptionText(effectiveJobDescription)) {
      setError('Stellenbeschreibung ist erforderlich.');
      setCheckingMatch(false);
      setCheckingMatchInModal(false);
      return;
    }


    // Prüfe ob User-Daten vorhanden sind
    if (!user) {
      setError('Benutzer nicht angemeldet.');
      setCheckingMatch(false);
      setCheckingMatchInModal(false);
      return;
    }

    try {
      // Hole ID Token für API-Aufruf
      const idToken = await user.getIdToken();
      const matchRunId = `match_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
      const matchSource = matchAction === 'recalculate' ? 'match-modal-recalculate' : 'passgenauigkeit-icon';

      const activeRowContext = activeCvPreviewRowContextRef.current;
      const activeRowEntry =
        activeRowContext && activeRowContext.applicationId === selectedApplicationId
          ? activeRowContext.rowEntry
          : null;
      const activeRowCvId =
        typeof activeRowEntry?.cvId === 'string' && activeRowEntry.cvId.trim()
          ? activeRowEntry.cvId.trim()
          : (resolveCvIdBySetRefStrict(typeof activeRowEntry?.cvSetRef === 'string' ? activeRowEntry.cvSetRef : '') || null);
      const selectedCvIdsFromJobInfo = Array.isArray(extractedJobInfo?.cvIds)
        ? (extractedJobInfo?.cvIds || []).map((id: any) => getNormalizedCvId(id)).filter((id: string) => !!id)
        : [];
      const selectedCvSetRefsFallback = Array.isArray(extractedJobInfo?.cvSetRefs)
        ? (extractedJobInfo?.cvSetRefs || []).filter((ref: any) => typeof ref === 'string' && ref.trim())
        : [];
      const selectedCvIdsRaw = activeRowCvId
        ? [activeRowCvId]
        : (selectedCvIdsFromJobInfo.length > 0
            ? selectedCvIdsFromJobInfo
            : selectedCvSetRefsFallback
                .map((setRef: string) => resolveCvIdBySetRefStrict(setRef))
                .filter((id: string | null): id is string => !!id));
      const selectedCvIds = Array.from(new Set(selectedCvIdsRaw));
      const selectedCvSets = selectedCvIds
        .map((cvId: string) => (userCvs || []).find((cv: any) => getNormalizedCvId(cv?.cvId) === cvId))
        .filter((cv: any) => !!cv);
      const isSingleRowRecalculate = !!activeRowEntry;

      if (isSingleRowRecalculate && !activeRowCvId) {
        throw new Error('Die cvId der ausgewählten Tabellenzeile konnte nicht aufgelöst werden.');
      }

      if (selectedCvSets.length !== selectedCvIds.length) {
        const resolvedIds = selectedCvSets.map((cv: any) => getNormalizedCvId(cv?.cvId)).filter((id: string) => !!id);
        const missingIds = selectedCvIds.filter((id: string) => !resolvedIds.includes(id));
        throw new Error(`Folgende cvIds konnten nicht zugeordnet werden: ${missingIds.join(', ')}`);
      }

      if (isSingleRowRecalculate && selectedCvSets.length === 0) {
        throw new Error('Das CV-Daten-Set der ausgewählten Tabellenzeile konnte nicht aufgelöst werden.');
      }

      if (!isSingleRowRecalculate && selectedCvSets.length === 0) {
        throw new Error('Bitte mindestens ein CV-Daten-Set im Dropdown "CV-Daten Set" auswählen.');
      }

      if (selectedCvSets.length > 0) {
        const cvSetsWithoutValidId = selectedCvSets.filter((cv: any) =>
          !(typeof cv?.cvId === 'string' && cv.cvId.trim())
        );
        if (cvSetsWithoutValidId.length > 0) {
          const invalidLabels = cvSetsWithoutValidId.map((cv: any) => cv?.cvName || getCvSetRef(cv) || 'CV').join(', ');
          throw new Error(`Mindestens ein CV-Daten-Set hat keine gueltige cvId: ${invalidLabels}`);
        }

        // Harte ID-Regel:
        // Wenn eine gültige selectedApplicationId vorhanden ist, immer diese verwenden
        // und niemals eine neue Bewerbung erstellen.
        const hasValidSelectedApplicationId =
          !!selectedApplicationId &&
          applications.some((app: any) => app.id === selectedApplicationId);

        let targetApplicationId = hasValidSelectedApplicationId ? selectedApplicationId : null;
        if (!targetApplicationId) {
          const firstCvWithId = selectedCvSets[0];
          targetApplicationId = await createApplicationFromCvPreviewWithLock(undefined, undefined, firstCvWithId.cvId);
        }
        setSelectedApplicationId(targetApplicationId);

        const preloadedSnapshots = await Promise.allSettled(
          selectedCvSets.map((cv: any) =>
            resolveAndLoadCvSetOrThrow({
              cv,
              cvId: typeof cv?.cvId === 'string' ? cv.cvId : null,
              cvSetRef: getCvSetRef(cv),
              sourceCvData: cv?.data && typeof cv.data === 'object' ? cv.data : null,
              forceReload: true,
              maxAgeMs: 20000,
              label: cv?.cvName || cv?.cvId || 'CV'
            })
          )
        );

        const runMatchForCv = async (cv: any, index: number) => {
          const cvId = typeof cv?.cvId === 'string' ? cv.cvId.trim() : '';
          if (!cvId) {
            throw new Error(`${cv?.cvName || 'CV'}: cvId fehlt.`);
          }
          const preloadedSnapshot = preloadedSnapshots[index];
          if (!preloadedSnapshot || preloadedSnapshot.status !== 'fulfilled') {
            const reason: any = (preloadedSnapshot as any)?.reason;
            const reasonMessage =
              typeof reason === 'string'
                ? reason
                : (reason?.message || 'CV-Snapshot konnte nicht geladen werden.');
            throw new Error(`${cv?.cvName || cvId || 'CV'}: ${reasonMessage}`);
          }
          const snapshot = preloadedSnapshot.value;
          if (!snapshot?.cvId || !String(snapshot.cvId).trim()) {
            throw new Error(`${cv?.cvName || cvId || 'CV'}: Snapshot ohne cvId.`);
          }
          const cvDataForMatch = buildCvDataFromSource(snapshot.cvData);
          const cvTextForMatch = createCvTextFromData(cvDataForMatch);
          const matchData = await requestOptimizeCvWithQueue({
            cvData: cvDataForMatch,
            cvText: cvTextForMatch,
            jobDescription: effectiveJobDescription,
            optimizeType: 'match',
            matchAction,
            matchRunId,
            matchSource,
            targetLanguage: targetLanguage,
            browserLanguage: { 'de': 'deutsch', 'en': 'englisch', 'fr': 'französisch', 'it': 'italienisch' }[currentLanguage] || 'deutsch'
          }, idToken, true);

          return {
            cvId: snapshot.cvId,
            cvSetRef: getCvSetRef(cv),
            cvName: cv.cvName || snapshot.cvData?.cvName || snapshot.cvData?.fullName || snapshot.cvData?.personalInfo?.fullName || 'Unbenannt',
            matchScore: typeof matchData?.matchScore === 'number' ? matchData.matchScore : null,
            missingSkills: normalizeMatchList(matchData?.missingSkills),
            weaknesses: normalizeMatchList(matchData?.weaknesses),
            hasOptimizedCv: false
          };
        };

        const parallelResults = await Promise.allSettled(
          selectedCvSets.map((cv: any, index: number) => runMatchForCv(cv, index))
        );
        const successfulResults = parallelResults
          .filter((entry: any) => entry.status === 'fulfilled')
          .map((entry: any) => entry.value);
        const failedResults = parallelResults
          .filter((entry: any) => entry.status === 'rejected')
          .map((entry: any) => {
            const reason = (entry as any)?.reason;
            if (typeof reason === 'string') return reason;
            if (reason instanceof Error) return reason.message;
            if (reason && typeof reason === 'object' && typeof reason.message === 'string') return reason.message;
            return 'Unbekannter Fehler';
          });

        // Persistiere immer eine Zeile pro ausgewähltem CV-Daten-Set, damit die
        // Bewerbungs-Detailtabelle die Auswahl aus "CV-Daten Set" konsistent abbildet.
        const sourceApplicationForRows =
          applications.find((app: any) => app.id === targetApplicationId) ||
          (selectedApplication?.id === targetApplicationId ? selectedApplication : null);
        const previousCvMatchResults = Array.isArray(sourceApplicationForRows?.cvMatchResults)
          ? sourceApplicationForRows.cvMatchResults
          : [];

        const cvResultsForTable = selectedCvSets.map((cv: any, index: number) => {
          const settledResult = parallelResults[index];
          const baseEntry =
            settledResult && settledResult.status === 'fulfilled'
              ? settledResult.value
              : {
                  cvId: cv.cvId,
                  cvSetRef: getCvSetRef(cv),
                  cvName: cv.cvName || 'Unbenannt',
                  matchScore: null,
                  missingSkills: [],
                  weaknesses: [],
                  hasOptimizedCv: false,
                  calculationError:
                    settledResult && settledResult.status === 'rejected'
                      ? (
                          typeof (settledResult as any)?.reason === 'string'
                            ? (settledResult as any).reason
                            : ((settledResult as any)?.reason?.message || 'Nicht berechenbar')
                        )
                      : undefined
                };

          const previousEntry = previousCvMatchResults.find((row: any, candidateIndex: number) =>
            matchesCvRowByIdentity(baseEntry, row, index, candidateIndex)
          );

          return {
            ...baseEntry,
            hasOptimizedCv:
              typeof previousEntry?.hasOptimizedCv === 'boolean'
                ? previousEntry.hasOptimizedCv
                : !!baseEntry.hasOptimizedCv,
            rowStatus: (() => {
              const previousRowStatus =
                typeof (previousEntry as any)?.rowStatus === 'string'
                  ? (previousEntry as any).rowStatus.trim()
                  : '';
              if (previousRowStatus) return previousRowStatus;
              return typeof (baseEntry as any)?.rowStatus === 'string'
                ? (baseEntry as any).rowStatus
                : undefined;
            })()
          };
        });

        const shouldMergeSingleRowResult = !!activeRowEntry && cvResultsForTable.length === 1;
        const finalCvResultsForTable = shouldMergeSingleRowResult
          ? (() => {
              const nextRow = cvResultsForTable[0];
              if (previousCvMatchResults.length === 0) return [nextRow];

              let hasMatchedExistingRow = false;
              const mergedRows = previousCvMatchResults.map((row: any, candidateIndex: number) => {
                if (matchesCvRowByIdentity(nextRow, row, 0, candidateIndex)) {
                  hasMatchedExistingRow = true;
                  return {
                    ...row,
                    ...nextRow,
                    hasOptimizedCv:
                      typeof row?.hasOptimizedCv === 'boolean'
                        ? row.hasOptimizedCv
                        : !!nextRow.hasOptimizedCv,
                    calculationError:
                      typeof (nextRow as any)?.calculationError === 'string' && (nextRow as any).calculationError.trim()
                        ? (nextRow as any).calculationError
                        : row?.calculationError,
                    rowStatus:
                      typeof row?.rowStatus === 'string' && row.rowStatus.trim()
                        ? row.rowStatus.trim()
                        : nextRow.rowStatus
                  };
                }
                return row;
              });

              if (!hasMatchedExistingRow) {
                mergedRows.push(nextRow);
              }
              return mergedRows;
            })()
          : cvResultsForTable;

        const bestResult = successfulResults.length > 0
          ? successfulResults.reduce((best: any, current: any) => {
              const bestScore = typeof best?.matchScore === 'number' ? best.matchScore : -1;
              const currentScore = typeof current?.matchScore === 'number' ? current.matchScore : -1;
              return currentScore > bestScore ? current : best;
            }, successfulResults[0])
          : {
              matchScore: null,
              missingSkills: [],
              weaknesses: []
            };

        if (successfulResults.length === 0) {
          setError(
            `Passgenauigkeit konnte für kein ausgewähltes CV-Daten-Set berechnet werden.${failedResults.length > 0 ? ` Fehler: ${failedResults.join(' | ')}` : ''}`
          );
        } else if (failedResults.length > 0) {
          setError(`Passgenauigkeit für einige CV-Daten-Sets fehlgeschlagen: ${failedResults.join(' | ')}`);
        }

        // Bei genau einem ausgewählten CV-Daten-Set den globalen CV-Kontext explizit
        // auf dieses Set ziehen, damit Modal/Passgenauigkeit nicht mit einem alten
        // selectedCvId arbeiten.
        if (
          selectedCvSets.length === 1 &&
          successfulResults.length > 0 &&
          typeof bestResult?.cvId === 'string' &&
          bestResult.cvId &&
          bestResult.cvId !== selectedCvId
        ) {
          await handleSelectCv(bestResult.cvId, false, false);
          setSelectedApplicationId(targetApplicationId);
        }

        applyMatchDetails(bestResult.matchScore, bestResult.missingSkills, bestResult.weaknesses);

        await persistApplicationMatchData(
          targetApplicationId,
          bestResult.matchScore,
          bestResult.missingSkills,
          bestResult.weaknesses,
          idToken,
          finalCvResultsForTable
        );

        setHideMatchResults(false);
        setShowCvOptimierenButton(true);

        if (selectedCvSets.length > 1) {
          const mergedApplication = {
            ...(applications.find((app: any) => app.id === targetApplicationId) || {}),
            id: targetApplicationId,
            matchScore: bestResult.matchScore,
            missingSkills: bestResult.missingSkills,
            weaknesses: bestResult.weaknesses,
            cvMatchResults: finalCvResultsForTable
          };

          setApplications((prev: any[]) => {
            const exists = prev.some((app: any) => app.id === targetApplicationId);
            if (!exists) return [...prev, mergedApplication];
            return prev.map((app: any) => app.id === targetApplicationId ? { ...app, ...mergedApplication } : app);
          });

          // WICHTIG: Neu erstellte Bewerbung frisch vom Backend laden, bevor
          // die Hauptseiten-Jobinfos geleert werden. Sonst kann ein lokaler Race
          // mit "leerer" mergedApplication die Detailansicht ohne Jobinfos öffnen.
          await openApplicationDetailsForId(
            targetApplicationId,
            idToken,
            false,
            showCvDataModal,
            mergedApplication
          );
        } else if (!showCvDataModal) {
          await openCvDataModal(
            true,
            true,
            false,
            {
              matchScore: bestResult.matchScore,
              missingSkills: bestResult.missingSkills,
              weaknesses: bestResult.weaknesses
            }
          );
        }
        return;
      }

      if (isSingleRowRecalculate) {
        throw new Error('Passgenauigkeit für die ausgewählte Zeile konnte nicht berechnet werden.');
      }

      throw new Error('Passgenauigkeit konnte für die ausgewählten CV-Daten-Sets nicht berechnet werden.');
    } catch (err: any) {
      setError(t('error.match.score.unknown') + (err.message || ''));
    } finally {
      setCheckingMatch(false);
      setCheckingMatchInModal(false);
      setInfoMessage(getTranslatedInfoMessage('match_calculated'));
      // Setze State zurück, damit das Refresh-Icon wieder grau wird
      setHasCvDataChangedSinceLastMatch(false);
      setHasJobInfoChangedSinceLastMatch(false);
    }
  };
  
  // Öffentliche Funktion für die Passgenauigkeits-Berechnung (mit setCheckingMatch)
  const handleCheckMatchScore = async () => {
    // Icon-/Global-Flow darf keinen stale Tabellenzeilen-Kontext verwenden.
    // Sonst kann nach einem vorherigen Klick auf "%" versehentlich nur dieses
    // alte CV-Daten-Set erneut berechnet werden.
    activeCvPreviewRowContextRef.current = null;
    await saveExtractedJobInfoForSelectedApplication();
    const shouldRecalculateDueToJobInfoChanges = hasJobInfoChangedSinceLastMatch;
    const selectedCvIdsFromJobInfo = Array.isArray(extractedJobInfo?.cvIds)
      ? (extractedJobInfo?.cvIds || []).map((id: any) => getNormalizedCvId(id)).filter((id: string) => !!id)
      : [];
    const selectedCvRefsFallback = Array.isArray(extractedJobInfo?.cvSetRefs)
      ? (extractedJobInfo?.cvSetRefs || []).filter((ref: any) => typeof ref === 'string' && ref.trim())
      : [];
    const selectedCvIdsFallback = selectedCvRefsFallback
      .map((setRef: string) => resolveCvIdBySetRefStrict(setRef))
      .filter((id: string | null): id is string => !!id);
    const hasSelectedCvSets = (selectedCvIdsFromJobInfo.length > 0 ? selectedCvIdsFromJobInfo : selectedCvIdsFallback).length > 0;

    if (!hasSelectedCvSets) {
      setError('Bitte mindestens ein CV-Daten-Set im Dropdown "CV-Daten Set" auswählen.');
      return;
    }

    // Wenn bereits eine Passgenauigkeit vorhanden ist, einfach das Modal öffnen
    if (hasCompleteMatchData(matchScore, missingSkills, weaknesses) && !shouldRecalculateDueToJobInfoChanges) {
      console.log('✅ Vollständige Passgenauigkeitsdaten vorhanden - Öffne Modal ohne Neuberechnung');
      if (!showCvDataModal) {
        await openCvDataModal(true); // true = von Passgenauigkeit
      }
      return;
    }
    
    // Wenn keine Passgenauigkeit vorhanden, neu berechnen
    setError(null);
    setMatchScore(null);
    resetMatchData();
    setCheckingMatch(true);
    setCheckingMatchInModal(false); // Stelle sicher, dass Modal-Animation nicht angezeigt wird
    setHideJobDescription(true); // Verstecke das Stellenbeschreibung-Textfeld
    setHideMatchResults(false); // Zeige Match-Ergebnisse an
    setInfoMessage(getTranslatedInfoMessage('calculating_match'));
    
    // Rufe die interne Funktion auf
    await handleCheckMatchScoreInternal(undefined, 'calculate');
  };

  // Separate Optimierungsfunktionen für jeden Bereich
  
  // Hobby-Optimierung
  const handleHobbyOptimization = async (promptText: string, promptVersion: string, temperature: string, maxTokens: string) => {
    console.log('🎯 Starte Hobby-Optimierung...');
    
    try {
      setError(null);
      setOptimizing(true);
      
      // Prüfe ob User-Daten vorhanden sind
      if (!user) {
        setError('Benutzer nicht angemeldet.');
        setOptimizing(false);
        return;
      }

      // Hobby-Daten verarbeitet

      // Für Hobby-Optimierung: Bereite nur Hobby-spezifische Daten vor
      const hobbyData = {
        hobbies: hobbies || []
      };

      // Erstelle Hobby-spezifischen Text
      let hobbyText = '';
      if (hobbies && hobbies.length > 0) {
        hobbyText = 'Hobbys:\n' + hobbies.map(hobby => 
          `${hobby.hobby || 'Unbekannt'}: ${hobby.description || 'Keine Beschreibung'}`
        ).join('\n');
      } else {
        hobbyText = 'Keine Hobbys im CV gefunden';
      }

      console.log('🎯 Hobby-Daten für Backend:', hobbyData);
      console.log('🎯 Hobby-Text für Backend:', hobbyText);

      // Hole ID Token für Backend-Authentifizierung
      const idToken = await user.getIdToken();

              // Sende Request an Backend für Hobby-Optimierung
      const data = await requestOptimizeCvWithQueue({
        cvData: hobbyData, // Nur Hobby-Daten
        cvText: hobbyText, // Nur Hobby-Text
        jobDescription: jobDescription,
        optimizeType: 'hobbies',
        targetLanguage: targetLanguage,
        // Test-spezifische Parameter
        testPrompt: promptText,
        chatGptVersion: promptVersion,
        temperature: temperature,
        maxTokens: maxTokens
      }, idToken, true);
      
      // Backend-Antwort für Hobbys verarbeitet
      
      // Setze die relevanten Hobbys
      if (data.relevantHobbies) {
        let hobbiesArray;
        
        // Prüfe ob relevantHobbies ein String ist (JSON) oder bereits ein Array
        if (typeof data.relevantHobbies === 'string') {
          try {
            // Entferne Markdown-Code-Block-Formatierung falls vorhanden
            let cleanJsonString = data.relevantHobbies;
            if (cleanJsonString.includes('```json')) {
              cleanJsonString = cleanJsonString.replace(/```json\n?/g, '').replace(/```\n?/g, '');
              console.log('🔧 Markdown-Code-Block entfernt, bereinigter String:', cleanJsonString);
            }
            
            // Parse den bereinigten JSON-String zu einem Array
            hobbiesArray = JSON.parse(cleanJsonString);
            console.log('✅ JSON-String erfolgreich geparst zu Array:', hobbiesArray);
          } catch (parseError) {
            console.error('❌ Fehler beim Parsen des JSON-Strings:', parseError);
            setTestResult('Fehler beim Parsen der Hobby-Daten');
            return;
          }
        } else if (Array.isArray(data.relevantHobbies)) {
          // relevantHobbies ist bereits ein Array
          hobbiesArray = data.relevantHobbies;
          console.log('✅ relevantHobbies ist bereits ein Array:', hobbiesArray);
        } else {
          console.log('⚠️ relevantHobbies ist weder String noch Array:', typeof data.relevantHobbies);
          setTestResult('Unerwartetes Datenformat für Hobbys');
          return;
        }
        
        // Prüfe ob das geparste Array gültig ist
        if (hobbiesArray && Array.isArray(hobbiesArray) && hobbiesArray.length > 0) {
          // Setze die Hobbys im lokalen State
          setRelevantHobbies(normalizeHobbyList(hobbiesArray));
          console.log('✅ Relevante Hobbys gesetzt:', hobbiesArray.length, 'Hobbys');
          
          // Zeige nur die relevanten Hobbys im Test-Modal an
          setTestResult(JSON.stringify(hobbiesArray, null, 2));
        } else {
          console.log('⚠️ Geparste Hobbys sind leer oder ungültig:', hobbiesArray);
          setTestResult('Keine Hobbys gefunden');
        }
      } else {
        // Keine relevantHobbies vorhanden
        console.log('⚠️ Keine relevantHobbies in der Backend-Antwort gefunden');
        setTestResult('Keine Hobbys gefunden');
      }
      
      console.log('✅ Hobby-Optimierung erfolgreich abgeschlossen');
      
    } catch (err: any) {
      setError(t('error.optimize.cv.unknown') + (err.message || ''));
    } finally {
      setOptimizing(false);
    }
  };

  // IT-Skills-Optimierung
  const handleItSkillsOptimization = async (promptText: string, promptVersion: string, temperature: string, maxTokens: string) => {
    console.log('🎯 Starte IT-Skills-Optimierung...');
    
    try {
      setError(null);
      setOptimizing(true);
      
      // Prüfe ob User-Daten vorhanden sind
      if (!user) {
        setError('Benutzer nicht angemeldet.');
        setOptimizing(false);
        return;
      }

      // Für IT-Skills-Optimierung: Bereite nur IT-Skills-spezifische Daten vor
      const itSkillsData = {
        itSkills: itSkills || []
      };

      // Erstelle IT-Skills-spezifischen Text
      let itSkillsText = '';
      if (itSkills && itSkills.length > 0) {
        itSkillsText = 'IT-Skills:\n' + itSkills.map(skill => 
          `${skill.skill || 'Unbekannt'} (${skill.level || 'Kein Level'})`
        ).join('\n');
      } else {
        itSkillsText = 'Keine IT-Skills im CV gefunden';
      }

      console.log('🎯 IT-Skills-Daten für Backend:', itSkillsData);
      console.log('🎯 IT-Skills-Text für Backend:', itSkillsText);

      // Hole ID Token für Backend-Authentifizierung
      const idToken = await user.getIdToken();

      // Sende Request an Backend für IT-Skills-Optimierung
      const data = await requestOptimizeCvWithQueue({
        cvData: itSkillsData, // Nur IT-Skills-Daten
        cvText: itSkillsText, // Nur IT-Skills-Text
        jobDescription: jobDescription,
        optimizeType: 'itSkills',
        targetLanguage: targetLanguage,
        // Test-spezifische Parameter
        testPrompt: promptText,
        chatGptVersion: promptVersion,
        temperature: temperature,
        maxTokens: maxTokens
      }, idToken, true);
      
      // Backend-Antwort für IT-Skills verarbeitet
      
      // Setze die relevanten IT-Skills
      if (data.relevantItSkills) {
        let itSkillsArray;
        
        // Prüfe ob relevantItSkills ein String ist (JSON) oder bereits ein Array
        if (typeof data.relevantItSkills === 'string') {
          try {
            // Entferne Markdown-Code-Block-Formatierung falls vorhanden
            let cleanJsonString = data.relevantItSkills;
            if (cleanJsonString.includes('```json')) {
              cleanJsonString = cleanJsonString.replace(/```json\n?/g, '').replace(/```\n?/g, '');
              console.log('🔧 Markdown-Code-Block entfernt, bereinigter String:', cleanJsonString);
            }
            
            // Parse den bereinigten JSON-String zu einem Array
            itSkillsArray = JSON.parse(cleanJsonString);
            console.log('✅ JSON-String erfolgreich geparst zu Array:', itSkillsArray);
          } catch (parseError) {
            console.error('❌ Fehler beim Parsen des JSON-Strings:', parseError);
            setTestResult('Fehler beim Parsen der IT-Skills-Daten');
            return;
          }
        } else if (Array.isArray(data.relevantItSkills)) {
          // relevantItSkills ist bereits ein Array
          itSkillsArray = data.relevantItSkills;
          console.log('✅ relevantItSkills ist bereits ein Array:', itSkillsArray);
        } else {
          console.log('⚠️ relevantItSkills ist weder String noch Array:', typeof data.relevantItSkills);
          setTestResult('Unerwartetes Datenformat für IT-Skills');
          return;
        }
        
        // Prüfe ob das geparste Array gültig ist
        if (itSkillsArray && Array.isArray(itSkillsArray) && itSkillsArray.length > 0) {
          // Setze die IT-Skills im lokalen State
          setRelevantItSkills(itSkillsArray);
          console.log('✅ Relevante IT-Skills gesetzt:', itSkillsArray.length, 'Skills');
          
          // Zeige nur die relevanten IT-Skills im Test-Modal an
          setTestResult(JSON.stringify(itSkillsArray, null, 2));
        } else {
          console.log('⚠️ Geparste IT-Skills sind leer oder ungültig:', itSkillsArray);
          setTestResult('Keine IT-Skills gefunden');
        }
      } else {
        // Keine relevantItSkills vorhanden
        console.log('⚠️ Keine relevantItSkills in der Backend-Antwort gefunden');
        setTestResult('Keine IT-Skills gefunden');
      }
      
      console.log('✅ IT-Skills-Optimierung erfolgreich abgeschlossen');
      
    } catch (err: any) {
      setError(t('error.optimize.cv.unknown') + (err.message || ''));
    } finally {
      setOptimizing(false);
    }
  };

  // Kernkompetenzen-Optimierung
  const handleCoreCompetenciesOptimization = async (promptText: string, promptVersion: string, temperature: string, maxTokens: string) => {
    console.log('🎯 Starte Kernkompetenzen-Optimierung...');
    
    try {
      setError(null);
      setOptimizing(true);
      
      // Prüfe ob User-Daten vorhanden sind
      if (!user) {
        setError('Benutzer nicht angemeldet.');
        setOptimizing(false);
        return;
      }

      // Für Kernkompetenzen-Optimierung: Bereite nur Kernkompetenzen-spezifische Daten vor
      const coreCompetenciesData = {
        coreCompetencies: coreCompetencies || []
      };

      // Erstelle Kernkompetenzen-spezifischen Text
      let coreCompetenciesText = '';
      if (coreCompetencies && coreCompetencies.length > 0) {
        coreCompetenciesText = coreCompetencies.map(comp => 
          `${comp.competency || 'Keine Kompetenz'}`
        ).join('\n');
      } else {
        coreCompetenciesText = 'Keine Kernkompetenzen im CV gefunden';
      }

      console.log('🎯 Kernkompetenzen-Daten für Backend:', coreCompetenciesData);
      console.log('🎯 Kernkompetenzen-Text für Backend:', coreCompetenciesText);

      // Hole ID Token für Backend-Authentifizierung
      const idToken = await user.getIdToken();

      // Sende Request an Backend für Kernkompetenzen-Optimierung
      const data = await requestOptimizeCvWithQueue({
        cvData: coreCompetenciesData, // Nur Kernkompetenzen-Daten
        cvText: coreCompetenciesText, // Nur Kernkompetenzen-Text
        jobDescription: jobDescription,
        optimizeType: 'coreCompetencies',
        targetLanguage: targetLanguage,
        // Test-spezifische Parameter
        testPrompt: promptText,
        chatGptVersion: promptVersion,
        temperature: temperature,
        maxTokens: maxTokens
      }, idToken, true);
      
      // Backend-Antwort für Kernkompetenzen verarbeitet
      
      // Setze die relevanten Kernkompetenzen
      if (data.relevantCoreCompetencies) {
        let coreCompetenciesArray;
        
        // Prüfe ob relevantCoreCompetencies ein String ist (JSON) oder bereits ein Array
        if (typeof data.relevantCoreCompetencies === 'string') {
            // Entferne Markdown-Code-Block-Formatierung falls vorhanden
            let cleanJsonString = data.relevantCoreCompetencies;
            if (cleanJsonString.includes('```json')) {
              cleanJsonString = cleanJsonString.replace(/```json\n?/g, '').replace(/```\n?/g, '');
              console.log('🔧 Markdown-Code-Block entfernt, bereinigter String:', cleanJsonString);
            }
          
          try {
            // JSON-String verarbeitet
            
            // Parse den bereinigten JSON-String zu einem Array
            coreCompetenciesArray = JSON.parse(cleanJsonString);
            console.log('✅ JSON-String erfolgreich geparst zu Array:', coreCompetenciesArray);
          } catch (parseError) {
            console.error('❌ Fehler beim Parsen des JSON-Strings:', parseError);
            console.error('❌ Problematischer JSON-String:', cleanJsonString);
            console.error('❌ JSON-String Länge:', cleanJsonString.length);
            const errorMessage = parseError instanceof Error ? parseError.message : 'Unbekannter Fehler';
            setTestResult(`Fehler beim Parsen der Kernkompetenzen-Daten: ${errorMessage}`);
            return;
          }
        } else if (Array.isArray(data.relevantCoreCompetencies)) {
          // relevantCoreCompetencies ist bereits ein Array
          coreCompetenciesArray = data.relevantCoreCompetencies;
          console.log('✅ relevantCoreCompetencies ist bereits ein Array:', coreCompetenciesArray);
        } else {
          console.log('⚠️ relevantCoreCompetencies ist weder String noch Array:', typeof data.relevantCoreCompetencies);
          setTestResult('Unerwartetes Datenformat für Kernkompetenzen');
          return;
        }
        
        // Prüfe ob das geparste Array gültig ist
        if (coreCompetenciesArray && Array.isArray(coreCompetenciesArray) && coreCompetenciesArray.length > 0) {
          // Setze die Kernkompetenzen im lokalen State
          setRelevantCoreCompetencies(coreCompetenciesArray);
          console.log('✅ Relevante Kernkompetenzen gesetzt:', coreCompetenciesArray.length, 'Kompetenzen');
          
          // Zeige nur die relevanten Kernkompetenzen im Test-Modal an
          setTestResult(JSON.stringify(coreCompetenciesArray, null, 2));
        } else {
          console.log('⚠️ Geparste Kernkompetenzen sind leer oder ungültig:', coreCompetenciesArray);
          setTestResult('Keine Kernkompetenzen gefunden');
        }
      } else {
        // Keine relevantCoreCompetencies vorhanden
        console.log('⚠️ Keine relevantCoreCompetencies in der Backend-Antwort gefunden');
        setTestResult('Keine Kernkompetenzen gefunden');
      }
      
      console.log('✅ Kernkompetenzen-Optimierung erfolgreich abgeschlossen');
      
    } catch (err: any) {
      setError(t('error.optimize.cv.unknown') + (err.message || ''));
    } finally {
      setOptimizing(false);
    }
  };

  // Sprach-Optimierung
  const handleLanguageOptimization = async (promptText: string, promptVersion: string, temperature: string, maxTokens: string) => {
    console.log('🌍 Starte Sprach-Optimierung...');
    
    try {
      setError(null);
      setOptimizing(true);
      
      // Prüfe ob User-Daten vorhanden sind
      if (!user) {
        setError('Benutzer nicht angemeldet.');
        setOptimizing(false);
        return;
      }

      // Für Sprach-Optimierung: Bereite nur Sprach-spezifische Daten vor
      const languageData = {
        languages: languages || []
      };

      // Erstelle Sprach-spezifischen Text
      let languageText = '';
      if (languages && languages.length > 0) {
        languageText = languages.map(lang => 
          `${lang.language || 'Keine Sprache'} (${lang.level || 'Kein Niveau'})`
        ).join('\n');
      } else {
        languageText = 'Keine Sprachen im CV gefunden';
      }

      console.log('🌍 Sprach-Daten für Backend:', languageData);
      console.log('🌍 Sprach-Text für Backend:', languageText);

      // Hole ID Token für Backend-Authentifizierung
      const idToken = await user.getIdToken();

      // Sende Request an Backend für Sprach-Optimierung
      const data = await requestOptimizeCvWithQueue({
        cvData: languageData, // Nur Sprach-Daten
        cvText: languageText, // Nur Sprach-Text
        jobDescription: jobDescription,
        optimizeType: 'languages',
        targetLanguage: targetLanguage,
        // Test-spezifische Parameter
        testPrompt: promptText,
        chatGptVersion: promptVersion,
        temperature: temperature,
        maxTokens: maxTokens
      }, idToken, true);
      
      // Backend-Antwort für Sprachen verarbeitet
      
      // Setze die relevanten Sprachen - genauso wie bei der Ausbildung
      if (data.relevantLanguages) {
        let languageArray;
        
        // Prüfe ob relevantLanguages ein String ist (JSON) oder bereits ein Array
        if (typeof data.relevantLanguages === 'string') {
          try {
            // Entferne Markdown-Code-Block-Formatierung falls vorhanden
            let cleanJsonString = data.relevantLanguages;
            if (cleanJsonString.includes('```json')) {
              cleanJsonString = cleanJsonString.replace(/```json\n?/g, '').replace(/```\n?/g, '');
              console.log('🔧 Markdown-Code-Block entfernt, bereinigter String:', cleanJsonString);
            }
            
            // Parse den bereinigten JSON-String zu einem Array
            languageArray = JSON.parse(cleanJsonString);
            console.log('✅ JSON-String erfolgreich geparst zu Array:', languageArray);
          } catch (parseError) {
            console.error('❌ Fehler beim Parsen des JSON-Strings:', parseError);
            setTestResult('Fehler beim Parsen der Sprach-Daten');
            return;
          }
        } else if (Array.isArray(data.relevantLanguages)) {
          // relevantLanguages ist bereits ein Array
          languageArray = data.relevantLanguages;
          console.log('✅ relevantLanguages ist bereits ein Array:', languageArray);
        } else {
          console.log('⚠️ relevantLanguages ist weder String noch Array:', typeof data.relevantLanguages);
          setTestResult('Unerwartetes Datenformat für Sprachen');
          return;
        }
        
        // Prüfe ob das geparste Array gültig ist
        if (languageArray && Array.isArray(languageArray) && languageArray.length > 0) {
          // Setze die Sprachen im lokalen State
          setRelevantLanguages(languageArray);
          console.log('✅ Relevante Sprachen erfolgreich gesetzt:', languageArray.length, 'Sprachen');
          
          // Zeige nur die effektiven Sprach-Daten ohne zusätzlichen Text
          setTestResult(JSON.stringify(languageArray, null, 2));
        } else {
          console.log('⚠️ Keine gültigen Sprach-Daten gefunden');
          setTestResult('Keine relevanten Sprachen gefunden');
        }
      } else {
        console.log('⚠️ Keine relevantLanguages in der Backend-Antwort');
        setTestResult('Keine Sprach-Daten vom Backend erhalten');
      }
      
      console.log('✅ Sprach-Optimierung erfolgreich abgeschlossen');
      
    } catch (err: any) {
      console.error('❌ Fehler bei Sprach-Optimierung:', err);
      setError(t('error.optimize.cv.unknown') + (err.message || ''));
      setTestResult(`Fehler: ${err.message || 'Unbekannter Fehler'}`);
    } finally {
      setOptimizing(false);
    }
  };

  // Hauptfunktion für vollständige CV-Optimierung (alle Bereiche)
  const handleOptimizeCv = async (testMode = false, testPromptType = '', testPromptText = '', testPromptVersion = '', testTemperature = '', testMaxTokens = '') => {
    // Wenn bereits optimierte CV-Daten vorhanden sind und nicht im Test-Modus, öffne die CV Preview
    if (hasOptimizedCvData() && !testMode) {
      await handleOpenCvTemplate(undefined, true);
      return;
    }

    setError(null);
    setImprovedCvText(null);
    setOptimizing(true);
    setHideMatchResults(true); // Verstecke Match-Ergebnisse
    setInfoMessage(getTranslatedInfoMessage('optimizing_cv'));
    resetMatchData(); // Lösche alle Match-Daten
    setRelevantItSkills([]); // Lösche relevante IT-Kenntnisse
    setRelevantEducations([]); // Lösche relevante Ausbildungen
    setRelevantLanguages([]); // Lösche relevante Sprachen
    setRelevantIndustries([]); // Lösche relevante Branchen
    setRelevantHobbies([]); // Lösche relevante Hobbys
    setRelevantCoreCompetencies([]); // Lösche relevante Kernkompetenzen
    
    
    if (!jobDescription.trim()) {
      setError('Stellenbeschreibung ist erforderlich.');
      setOptimizing(false);
      return;
    }

    // Prüfe ob User-Daten vorhanden sind
    if (!user) {
      setError('Benutzer nicht angemeldet.');
      setOptimizing(false);
      return;
    }

    try {
      if (loadingCvDesignSettings) {
        setError('Text-Einstellungen werden noch geladen. Bitte kurz warten.');
        setOptimizing(false);
        return;
      }
      await ensureCvDesignSettingsReady();
      const effectiveTextSettings = getEffectiveTextSettings();

      // Verwende alle Daten aus den bereits geladenen Tabellendaten
      const personalInfo = getPersonalInfoForMotivation();

      // Erstelle strukturierte CV-Daten aus den bereits geladenen Tabellendaten
      const cvData = {
        personalInfo: {
          fullName: personalInfo.fullName || '',
          address: personalInfo.address || '',
          postalCode: personalInfo.postalCode || '',
          city: personalInfo.city || '',
          country: personalInfo.country || '',
          availableFrom: personalInfo.availableFrom || '',
          phoneNumber: personalInfo.phoneNumber || '',
          email: personalInfo.email || '',
          birthYear: birthYear || '',
          nationality: nationality || '',
          residencePermit: residencePermit || '',
          civilStatus: civilStatus || '',
          shortProfile: shortProfile || ''
        },
        workExperience: workExperiences || [],
        education: educations || [],
        certifications: certifications || [],
        languages: languages || [],
        itSkills: itSkills || [],
        coreCompetencies: coreCompetencies || [],
        industryExperiences: industryExperiences || [],
        hobbies: hobbies || [],
        additionalInfo: additionalInfo || []
      };

      // Erstelle auch den CV-Text für das Backend
      const cvText = createCvTextFromData(cvData);

      // Hole ID Token für Backend-Authentifizierung
      const idToken = await user.getIdToken();

      // Konvertiere browserLanguage in ausgeschriebene Form
      const browserLanguageMap: { [key: string]: string } = {
        'de': 'deutsch',
        'en': 'englisch',
        'fr': 'französisch',
        'it': 'italienisch'
      };
      const browserLanguageWritten = browserLanguageMap[currentLanguage] || 'deutsch';
      
      // Verwende bereits erstellten ID Token
      const normalizedTestType = (testPromptType || '').toString().toLowerCase();
      const isMotivationTest = normalizedTestType === 'motivation' || normalizedTestType.includes('motiv');
      const requestBody = testMode ? {
        cvData: cvData,
        cvText: cvText,
        jobDescription: jobDescription,
        optimizeType: isMotivationTest ? 'motivation' : (testPromptType || 'cv'),
        targetLanguage: targetLanguage,
        browserLanguage: browserLanguageWritten,
        useBulletPoints: effectiveTextSettings.useBulletPoints,
        tonalitySettings: effectiveTextSettings.tonalitySettings,
        shortProfileTextLength: effectiveTextSettings.shortProfileTextLength,
        workExperienceTextLength: effectiveTextSettings.workExperienceTextLength,
        ...(isMotivationTest ? { generateSeparateFields: true } : {}),
        // Test-spezifische Parameter
        testPrompt: testPromptText,
        chatGptVersion: testPromptVersion,
        temperature: testTemperature,
        maxTokens: testMaxTokens
      } : {
        cvData: cvData,
        cvText: cvText,
        jobDescription: jobDescription,
        optimizeType: 'cv',
        targetLanguage: targetLanguage,
        browserLanguage: browserLanguageWritten,
        useBulletPoints: effectiveTextSettings.useBulletPoints,
        tonalitySettings: effectiveTextSettings.tonalitySettings,
        shortProfileTextLength: effectiveTextSettings.shortProfileTextLength,
        workExperienceTextLength: effectiveTextSettings.workExperienceTextLength
      };

      const data = await requestOptimizeCvWithQueue(requestBody, idToken, true);
      setImprovedCvText(typeof data.optimizedCvText === 'string' ? data.optimizedCvText : null);
      
      // Setze das optimierte Kurzprofil
      console.log('📥 Backend Response Data:', data);
      console.log('📥 optimizedShortProfile:', data.optimizedShortProfile);
      console.log('📥 optimizedWorkExperiences:', data.optimizedWorkExperiences);
      
      if (data.optimizedShortProfile && typeof data.optimizedShortProfile === 'string') {
        console.log('✅ Setze optimiertes Kurzprofil:', data.optimizedShortProfile.substring(0, 100) + '...');
        setOptimizedShortProfile(applySwissGerman(data.optimizedShortProfile));
        console.log('📝 State-Update für optimizedShortProfile aufgerufen, Länge:', data.optimizedShortProfile.length);
      } else {
        console.log('❌ Kein optimiertes Kurzprofil in Response');
        // Kein Fallback: Setze auf leeren String
        setOptimizedShortProfile('');
      }
      
      // AI-basierte Auswahl der besten Arbeitserfahrungen
      if (data.optimizedWorkExperiences && Array.isArray(data.optimizedWorkExperiences)) {
        console.log('✅ Setze optimierte Arbeitserfahrungen:', data.optimizedWorkExperiences.length, 'Erfahrungen');
        // Aktualisiere die Arbeitserfahrungen mit den AI-optimierten
        let updatedWorkExperiences = data.optimizedWorkExperiences.map((exp: any, index: number) => ({
          position: exp.position || '',
          company: exp.company || '',
          industry: exp.industry || '',
          startDate: exp.startDate || '',
          endDate: exp.endDate || '',
          description: exp.description || '',
          relevant: exp.relevant,
          relevanzranking: exp.relevanzranking,
          relevanceRanking: exp.relevanceRanking,
          relevanceScore: exp.relevanceScore
        }));

        // Backend liefert relevant als Ranking (0-100): Nur Top 6 bleiben relevant=true.
        updatedWorkExperiences = applyTopRelevantWorkExperiences(updatedWorkExperiences, 6);
        
        // Fülle bis zu 3 Arbeitserfahrungen auf
        while (updatedWorkExperiences.length < 3) {
          updatedWorkExperiences.push({
            position: '',
            company: '',
            industry: '',
            startDate: '',
            endDate: '',
            description: '',
            relevant: false
          });
        }
        
        const swissFixedWorkExperiences = applySwissGermanToWorkExperiences(updatedWorkExperiences);
        setOptimizedWorkExperiences(swissFixedWorkExperiences);
        setRelevantWorkExperiences(
          swissFixedWorkExperiences.filter((exp: any) => exp.relevant === true || exp.relevant === 'true')
        );
        console.log('✅ Optimierte Berufserfahrungen gesetzt:', swissFixedWorkExperiences.length, 'Erfahrungen');
        console.log('📝 State-Update für optimizedWorkExperiences aufgerufen, Anzahl:', swissFixedWorkExperiences.length);
      }
      
      // Setze die relevanten IT-Kenntnisse
      if (data.relevantItSkills && Array.isArray(data.relevantItSkills)) {
        setRelevantItSkills(data.relevantItSkills);
        console.log('✅ Relevante IT-Skills gesetzt:', data.relevantItSkills.length, 'Skills');
      }
      
      // Setze NUR die AI-optimierten Ausbildungen vom Backend
      if (data.relevantEducations && Array.isArray(data.relevantEducations)) {
        setRelevantEducations(data.relevantEducations);
        console.log('✅ AI-optimierte Ausbildungen gesetzt:', data.relevantEducations.length, 'Ausbildungen');
      } else {
        setRelevantEducations([]);
        console.log('❌ Keine AI-optimierten Ausbildungen vom Backend');
      }
      
      // Setze die relevanten Zertifizierungen
      if (data.relevantCertifications && Array.isArray(data.relevantCertifications)) {
        setRelevantCertifications(data.relevantCertifications);
        console.log('✅ Relevante Zertifizierungen gesetzt:', data.relevantCertifications.length, 'Zertifizierungen');
      }
      
      // Setze NUR die AI-optimierten Kernkompetenzen vom Backend
      if (data.relevantCoreCompetencies && Array.isArray(data.relevantCoreCompetencies)) {
        setRelevantCoreCompetencies(data.relevantCoreCompetencies);
        console.log('✅ AI-optimierte Kernkompetenzen gesetzt:', data.relevantCoreCompetencies.length, 'Kompetenzen');
      } else {
        setRelevantCoreCompetencies([]);
        console.log('❌ Keine AI-optimierten Kernkompetenzen vom Backend');
      }
      
      // Setze die relevanten Branchen
      if (data.relevantIndustries && Array.isArray(data.relevantIndustries)) {
        setRelevantIndustries(data.relevantIndustries);
        console.log('✅ Relevante Branchen gesetzt:', data.relevantIndustries.length, 'Branchen');
      }
      
      // Setze die relevanten Hobbys
      // relevantHobbies verarbeitet
      if (data.relevantHobbies && Array.isArray(data.relevantHobbies)) {
        setRelevantHobbies(normalizeHobbyList(data.relevantHobbies));
        console.log('✅ Relevante Hobbys gesetzt:', data.relevantHobbies.length, 'Hobbys');
        console.log('✅ Relevante Hobbys Details:', data.relevantHobbies);
      } else {
        console.log('❌ Keine relevanten Hobbys in Response gefunden');
      }
      
      // Setze die relevanten weiteren Informationen
      if (data.relevantAdditionalInfo && Array.isArray(data.relevantAdditionalInfo)) {
        setRelevantAdditionalInfo(data.relevantAdditionalInfo);
        console.log('✅ Relevante weitere Informationen gesetzt:', data.relevantAdditionalInfo.length, 'Informationen');
      }
      
      // Setze NUR die AI-optimierten Sprachen vom Backend
      if (data.relevantLanguages && Array.isArray(data.relevantLanguages)) {
        setRelevantLanguages(data.relevantLanguages);
        console.log('✅ AI-optimierte Sprachen gesetzt:', data.relevantLanguages.length, 'Sprachen');
      } else {
        setRelevantLanguages([]);
        console.log('❌ Keine AI-optimierten Sprachen vom Backend');
      }
      
      // Im Test-Modus: Zeige Ergebnisse im Modal an
      if (testMode) {
        console.log('🧪 Test-Modus: Zeige Ergebnisse im Modal');
        
        // Spezielle Behandlung für Match-Score
        if (testPromptType === 'match') {
          const matchResult = {
            matchScore: data.matchScore || 0,
            missingSkills: data.missingSkills || [],
            weaknesses: data.weaknesses || []
          };
          setTestResult(JSON.stringify(matchResult, null, 2));
        } else {
          const result = data.optimizedCvText || data.result || 'Kein Ergebnis verfügbar';
          setTestResult(result);
        }
        
        // Fülle die entsprechenden Tabellen basierend auf dem Prompt-Typ
        if (data.parsedResult && Array.isArray(data.parsedResult)) {
          console.log('🔧 Fülle Tabellen mit Test-Ergebnissen:', testPromptType);
          
          switch (testPromptType) {
            case 'Hobbys-Optimierung':
              setRelevantHobbies(normalizeHobbyList(data.parsedResult));
              break;
            case 'IT-Skills':
              setRelevantItSkills(data.parsedResult);
              break;
            case 'Kernkompetenzen':
              setRelevantCoreCompetencies(data.parsedResult);
              break;
            case 'Zertifizierungen':
              setRelevantCertifications(data.parsedResult);
              break;
            case 'Relevante Ausbildungen':
              setRelevantEducations(data.parsedResult);
              break;
            case 'Relevante Sprachen':
              setRelevantLanguages(data.parsedResult);
              break;
            case 'Branchen-Optimierung':
              setRelevantIndustries(data.parsedResult);
              break;
          }
        }
      } else {
        // Normaler Modus: Öffne automatisch die Template Preview
        if (data.optimizedCvText) {
          await handleOpenCvTemplate(undefined, true);
          console.log('🎯 Template Preview automatisch geöffnet - optimierte Daten verfügbar');
        }
      }
    } catch (err: any) {
      setError(t('error.optimize.cv.unknown') + (err.message || ''));
    } finally {
      setOptimizing(false);
    }
  };

  // Prüfe ob bereits optimierte CV-Daten vorhanden sind
  const hasOptimizedCvData = () => {
    const hasShortProfile = !!optimizedShortProfile;
    const hasWorkExperiences = optimizedWorkExperiences && optimizedWorkExperiences.length > 0;
    const hasImprovedCvText = !!improvedCvText;
    
    const result = hasShortProfile || hasWorkExperiences || hasImprovedCvText;
    
    if (!result) {
      console.log('🔍 hasOptimizedCvData: Keine Daten gefunden', {
        optimizedShortProfile: optimizedShortProfile ? optimizedShortProfile.substring(0, 50) + '...' : 'leer',
        optimizedShortProfileLength: optimizedShortProfile?.length || 0,
        optimizedWorkExperiencesLength: optimizedWorkExperiences?.length || 0,
        improvedCvText: improvedCvText ? improvedCvText.substring(0, 50) + '...' : 'leer',
        improvedCvTextLength: improvedCvText?.length || 0
      });
    } else {
      console.log('✅ hasOptimizedCvData: Daten gefunden', {
        hasShortProfile,
        hasWorkExperiences,
        hasImprovedCvText
      });
    }
    
    return result;
  };

  // Neue parallele CV-Optimierung für bessere Performance
  const handleOptimizeCvParallel = async (jobDescriptionOverride?: string, cvDataOverride?: any) => {
    setError(null);
    setImprovedCvText(null);
    setOptimizing(true);
    setHideMatchResults(true);
    // Match-Details (missingSkills/weaknesses) bis nach Bewerbungserstellung behalten.
    // Sonst werden beim Anlegen der neuen Bewerbung leere Arrays gespeichert.
    setRelevantItSkills([]);
    setRelevantEducations([]);
    setRelevantLanguages([]);
    setRelevantIndustries([]);
    setRelevantHobbies([]);
    setRelevantCoreCompetencies([]);
    // Kontakt-Overrides explizit leeren, damit keine Daten aus vorherigem CV
    // in den aktuellen Optimierungs-/Speicherprozess hineinlaufen.
    setOptimizedFullName('');
    setOptimizedCompany('');
    setOptimizedAddress('');
    setOptimizedPostalCode('');
    setOptimizedCity('');
    setOptimizedPhoneNumber('');
    setOptimizedEmail('');
    setOptimizedBirthYear('');
    setOptimizedNationality('');
    setOptimizedResidencePermit('');
    setOptimizedCivilStatus('');
    // Zusätzliche Reset-Felder gegen Stale-Optimierungsdaten beim CV-Wechsel.
    setOptimizedShortProfile('');
    setOptimizedWorkExperiences([]);
    setOptimizedImages([]);
    setProfileImage(null);
    setSignature(null);
    setCvTemplateHasBeenOpened(false); // Reset: Template wurde noch nicht geöffnet
    
    const effectiveJobDescription = (jobDescriptionOverride ?? jobDescription ?? '').trim();

    if (!effectiveJobDescription) {
      setError('Stellenbeschreibung ist erforderlich.');
      setOptimizing(false);
      return;
    }

    if (!user) {
      setError('Benutzer nicht angemeldet.');
      setOptimizing(false);
      return;
    }

    // KEINE Speicherung vor der Optimierung - Design wird beim Öffnen der Preview aus Firebase geladen
    // Design-Einstellungen werden nur beim Schließen der Preview gespeichert

    try {
      if (loadingCvDesignSettings) {
        setError('Text-Einstellungen werden noch geladen. Bitte kurz warten.');
        setOptimizing(false);
        return;
      }
      await ensureCvDesignSettingsReady();
      const activeRowContext = activeCvPreviewRowContextRef.current;
      const activeRowEntry =
        activeRowContext && activeRowContext.applicationId === selectedApplicationId
          ? activeRowContext.rowEntry
          : null;
      const activeRowSetRef =
        typeof activeRowEntry?.cvSetRef === 'string' && activeRowEntry.cvSetRef.trim()
          ? activeRowEntry.cvSetRef.trim()
          : '';
      const hasExplicitCvOverride = !!cvDataOverride;
      const activeRowCvId =
        !hasExplicitCvOverride && typeof activeRowEntry?.cvId === 'string' && activeRowEntry.cvId.trim()
          ? activeRowEntry.cvId.trim()
          : null;
      const selectedApplicationCvId =
        !hasExplicitCvOverride && selectedApplicationId
          ? (() => {
              const app = applications.find((candidate: any) => candidate.id === selectedApplicationId);
              return typeof app?.cvId === 'string' && app.cvId.trim() ? app.cvId.trim() : null;
            })()
          : null;
      const overrideCvId =
        hasExplicitCvOverride && typeof cvDataOverride?.cvId === 'string' && cvDataOverride.cvId.trim()
          ? cvDataOverride.cvId.trim()
          : null;
      const selectedCvIdNormalized =
        !hasExplicitCvOverride && typeof selectedCvId === 'string' && selectedCvId.trim()
          ? selectedCvId.trim()
          : null;
      const effectiveCvIdForOptimization = hasExplicitCvOverride
        ? overrideCvId
        : (activeRowCvId || selectedApplicationCvId || selectedCvIdNormalized);
      if (!effectiveCvIdForOptimization) {
        throw new Error('CV-Optimierung abgebrochen: cvId fehlt.');
      }
      const forceSnapshotReload = !hasExplicitCvOverride && hasCvDataChangedSinceLastMatch;
      const snapshot = await resolveAndLoadCvSetOrThrow({
        cvId: effectiveCvIdForOptimization,
        cvSetRef: hasExplicitCvOverride
          ? (cvDataOverride?.cvSetRef || activeRowSetRef || '')
          : (activeRowSetRef || ''),
        sourceCvData: hasExplicitCvOverride ? cvDataOverride : null,
        forceReload: forceSnapshotReload,
        maxAgeMs: 20000,
        label: hasExplicitCvOverride ? (cvDataOverride?.cvName || 'CV') : (currentCvName || 'CV')
      });
      activeProcessCvSnapshotRef.current = {
        ...snapshot.cvData,
        cvId: snapshot.cvId || effectiveCvIdForOptimization,
        cvSetRef: snapshot.cvSetRef || cvDataOverride?.cvSetRef || activeRowSetRef || undefined
      };
      // Bild/Signatur wie andere Felder aus dem Snapshot neu laden, damit
      // ein vorheriger Reset nicht als null persistiert wird.
      const snapshotProfileImage = normalizeProfileImageValue(
        snapshot?.cvData?.profileImage ?? snapshot?.cvData?.personalInfo?.profileImage
      );
      setProfileImage(snapshotProfileImage || null);
      const snapshotSignature =
        typeof snapshot?.cvData?.signature === 'string' && snapshot.cvData.signature.trim()
          ? snapshot.cvData.signature.trim()
          : (snapshot?.cvData?.signature?.data
              ? `data:${snapshot.cvData.signature.type};base64,${snapshot.cvData.signature.data}`
              : null);
      setSignature(snapshotSignature || null);
      const cvData = buildCvDataFromSource(snapshot.cvData);

      // Hole ID Token für Backend-Authentifizierung
      const idToken = await user.getIdToken();
      const iconOptimizationRunId = `icon_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;

      // Definiere alle Optimierungsaufgaben
      const optimizationTasks = [
        { 
          name: 'Kurzprofil', 
          type: 'shortProfile',
          setter: (data: any) => setOptimizedShortProfile(applySwissGerman(data)),
          getter: () => optimizedShortProfile
        },
        { 
          name: 'Arbeitserfahrung', 
          type: 'workExperience',
          setter: (data: any) => {
            if (data && Array.isArray(data)) {
              const rankedWorkExperiences = applyTopRelevantWorkExperiences(
                data.map((exp: any, index: number) => ({
                  ...exp,
                  id: index + 1
                })),
                6
              );
              const updatedWorkExperiences = applySwissGermanToWorkExperiences(rankedWorkExperiences);
              setOptimizedWorkExperiences(updatedWorkExperiences);
            }
          },
          getter: () => optimizedWorkExperiences
        },
        { 
          name: 'Ausbildung', 
          type: 'education',
          setter: (data: any) => {
            // Ausbildung wird als relevante Ausbildung gesetzt
            if (data && Array.isArray(data)) {
              setRelevantEducations(data);
            } else if (data && typeof data === 'object') {
              // Falls es ein einzelnes Objekt ist, in Array umwandeln
              setRelevantEducations([data]);
            } else {
              console.warn('Ausbildungs-Daten sind nicht im erwarteten Format:', data);
              setRelevantEducations([]);
            }
          },
          getter: () => relevantEducations
        },
        { 
          name: 'IT-Skills', 
          type: 'itSkills',
          setter: (data: any) => {
            // IT-Skills werden als relevante IT-Skills gesetzt
            if (data && Array.isArray(data)) {
              setRelevantItSkills(data);
            } else if (data && typeof data === 'object') {
              // Falls es ein einzelnes Objekt ist, in Array umwandeln
              setRelevantItSkills([data]);
            } else {
              console.warn('IT-Skills-Daten sind nicht im erwarteten Format:', data);
              setRelevantItSkills([]);
            }
          },
          getter: () => relevantItSkills
        },
        { 
          name: 'Sprachen', 
          type: 'languages',
          setter: (data: any) => {
            // Sprachen werden als relevante Sprachen gesetzt
            if (data && Array.isArray(data)) {
              setRelevantLanguages(data);
            } else if (data && typeof data === 'object') {
              // Falls es ein einzelnes Objekt ist, in Array umwandeln
              setRelevantLanguages([data]);
            } else {
              console.warn('Sprachen-Daten sind nicht im erwarteten Format:', data);
              setRelevantLanguages([]);
            }
          },
          getter: () => relevantLanguages
        },
        { 
          name: 'Kernkompetenzen',
          type: 'coreCompetencies',
          setter: (data: any) => {
            // Kernkompetenzen werden als relevante Kernkompetenzen gesetzt
            if (data && Array.isArray(data)) {
              setRelevantCoreCompetencies(data);
            } else if (data && typeof data === 'object') {
              // Falls es ein einzelnes Objekt ist, in Array umwandeln
              setRelevantCoreCompetencies([data]);
            } else {
              console.warn('Kernkompetenzen-Daten sind nicht im erwarteten Format:', data);
              setRelevantCoreCompetencies([]);
            }
          },
          getter: () => relevantCoreCompetencies
        },
        { 
          name: 'Branchen', 
          type: 'industry',
          setter: (data: any) => {
            // Branchen werden als relevante Branchen gesetzt
            if (data && Array.isArray(data)) {
              setRelevantIndustries(data);
            } else if (data && typeof data === 'object') {
              // Falls es ein einzelnes Objekt ist, in Array umwandeln
              setRelevantIndustries([data]);
            } else {
              console.warn('Branchen-Daten sind nicht im erwarteten Format:', data);
              setRelevantIndustries([]);
            }
          },
          getter: () => relevantIndustries
        },
        { 
          name: 'Hobbys', 
          type: 'hobbies',
          setter: (data: any) => {
            // Hobbys werden als relevante Hobbys gesetzt
            if (data && Array.isArray(data)) {
              setRelevantHobbies(normalizeHobbyList(data));
            } else if (data && typeof data === 'object') {
              // Falls es ein einzelnes Objekt ist, in Array umwandeln
              setRelevantHobbies(normalizeHobbyList([data]));
            } else {
              console.warn('Hobbys-Daten sind nicht im erwarteten Format:', data);
              setRelevantHobbies([]);
            }
          },
          getter: () => relevantHobbies
        },
        { 
          name: 'Zertifikate', 
          type: 'certifications',
          setter: (data: any) => {
            // Zertifikate werden als relevante Zertifikate gesetzt
            if (data && Array.isArray(data)) {
              setRelevantCertifications(data);
            }
          },
          getter: () => relevantCertifications
        },
        { 
          name: 'Weitere Angaben', 
          type: 'additionalInfo',
          setter: (data: any) => {
            // Weitere Angaben werden als relevante weitere Angaben gesetzt
            if (data && Array.isArray(data)) {
              setRelevantAdditionalInfo(data);
            } else if (data && typeof data === 'object') {
              // Falls es ein einzelnes Objekt ist, in Array umwandeln
              setRelevantAdditionalInfo([data]);
            } else {
              console.warn('Weitere Angaben-Daten sind nicht im erwarteten Format:', data);
              setRelevantAdditionalInfo([]);
            }
          },
          getter: () => relevantAdditionalInfo
        }
      ];

      console.log('🚀 Starte parallele CV-Optimierung...');
      console.log(`📊 ${optimizationTasks.length} Optimierungsaufgaben werden parallel ausgeführt`);
      const effectiveTextSettings = getEffectiveTextSettings();

      // Initialisiere Progress-Tracking
      const initialProgress: {[key: string]: 'pending' | 'running' | 'completed' | 'failed'} = {};
      optimizationTasks.forEach(task => {
        initialProgress[task.name] = 'pending';
      });
      setOptimizationProgress(initialProgress);

      // Starte alle Optimierungen parallel
      const optimizationPromises = optimizationTasks.map(async (task, index) => {
        try {
          console.log(`🔄 Starte ${task.name}-Optimierung (${index + 1}/${optimizationTasks.length})`);
          
          // Setze Status auf "running"
          setOptimizationProgress(prev => ({
            ...prev,
            [task.name]: 'running'
          }));
          
          const requestBody = task.type === 'workExperience'
            ? {
                ...buildWorkExperienceOptimizePayload(
                  cvData,
                  JSON.stringify(cvData || {}),
                  effectiveJobDescription,
                  {
                    // Parameter aus Firebase für alle Optimierungen
                    promptText: '',
                    promptVersion: '',
                    temperature: '',
                    maxTokens: ''
                  }
                ),
                optimizationSource: 'cv-optimize-icon',
                iconOptimizationRunId
              }
            : {
                cvData: cvData,
                cvText: JSON.stringify(cvData || {}),
                jobDescription: effectiveJobDescription,
                optimizeType: task.type,
                targetLanguage: targetLanguage,
                useBulletPoints: effectiveTextSettings.useBulletPoints,
                tonalitySettings: effectiveTextSettings.tonalitySettings,
                optimizationSource: 'cv-optimize-icon',
                iconOptimizationRunId,
                // Parameter aus Firebase für alle Optimierungen
                promptText: '', // Wird vom Backend aus Firebase geladen
                promptVersion: '', // Wird vom Backend aus Firebase geladen
                temperature: '', // Wird vom Backend aus Firebase geladen
                maxTokens: '' // Wird vom Backend aus Firebase geladen
              };

          const data = await requestOptimizeCvWithQueue(requestBody, idToken, false);
          console.log(`✅ ${task.name}-Optimierung erfolgreich abgeschlossen`);
          
          // Setze Status auf "completed"
          setOptimizationProgress(prev => ({
            ...prev,
            [task.name]: 'completed'
          }));
          
          // Setze die optimierten Daten
          if (task.setter) {
            // Extrahiere die richtigen Daten basierend auf dem Optimierungstyp
            let optimizedData = null;
            
            // Versuche zuerst optimizedData, dann die spezifischen Felder
            if (data.optimizedData && Array.isArray(data.optimizedData)) {
              optimizedData = data.optimizedData;
            } else {
              // Fallback: Extrahiere aus den spezifischen Feldern der Backend-Response
              switch (task.type) {
                case 'shortProfile':
                  optimizedData = data.optimizedShortProfile;
                  break;
                case 'workExperience':
                  optimizedData = data.optimizedWorkExperiences;
                  break;
                case 'education':
                  optimizedData = data.relevantEducations;
                  break;
                case 'itSkills':
                  optimizedData = data.relevantItSkills;
                  break;
                case 'languages':
                  optimizedData = data.relevantLanguages;
                  break;
                case 'coreCompetencies':
                  optimizedData = data.relevantCoreCompetencies;
                  break;
                case 'industry':
                  optimizedData = data.relevantIndustries;
                  break;
                case 'hobbies':
                  optimizedData = data.relevantHobbies;
                  break;
                case 'certifications':
                  optimizedData = data.relevantCertifications;
                  break;
                case 'additionalInfo':
                  optimizedData = data.relevantAdditionalInfo;
                  break;
                default:
                  // Als letzter Fallback: das gesamte data-Objekt
                  optimizedData = data;
              }
            }
            
            // Backend Response für ${task.name} verarbeitet
            
            task.setter(optimizedData);
          }

          return { 
            success: true, 
            task: task.name, 
            data: data,
            index: index 
          };
        } catch (error) {
          console.error(`❌ ${task.name}-Optimierung fehlgeschlagen:`, error);
          
          // Setze Status auf "failed"
          setOptimizationProgress(prev => ({
            ...prev,
            [task.name]: 'failed'
          }));
          
          return { 
            success: false, 
            task: task.name, 
            error: error instanceof Error ? error.message : 'Unbekannter Fehler',
            index: index 
          };
        }
      });

      // Warte auf alle Optimierungen
      console.log('⏳ Warte auf alle parallelen Optimierungen...');
      const results = await Promise.allSettled(optimizationPromises);

      // Analysiere Ergebnisse
      const successful = results.filter(result => 
        result.status === 'fulfilled' && result.value.success
      ).length;
      
      const failed = results.filter(result => 
        result.status === 'rejected' || 
        (result.status === 'fulfilled' && !result.value.success)
      ).length;

      console.log(`📈 Optimierung abgeschlossen: ${successful} erfolgreich, ${failed} fehlgeschlagen`);
      
      // Sammle die Daten direkt aus den API-Responses, um sicherzustellen, dass sie verfügbar sind
      // bevor handleOpenCvTemplate aufgerufen wird
      const collectedData: any = {};
      results.forEach((result, index) => {
        if (result.status === 'fulfilled' && result.value.success && result.value.data) {
          const task = optimizationTasks[index];
          const data = result.value.data;
          
          // Sammle die relevanten Daten basierend auf dem Task-Typ
          if (task.name === 'Kurzprofil' && data.optimizedShortProfile) {
            collectedData.optimizedShortProfile = data.optimizedShortProfile;
          } else if (task.name === 'Arbeitserfahrung') {
            // Je nach Backend-Pfad kann Arbeitserfahrung als optimizedWorkExperiences
            // oder als relevantWorkExperience zurückkommen.
            let normalizedWorkExperiences: any[] | null = null;
            if (Array.isArray(data.optimizedWorkExperiences)) {
              normalizedWorkExperiences = data.optimizedWorkExperiences;
            } else if (Array.isArray(data.relevantWorkExperience)) {
              normalizedWorkExperiences = data.relevantWorkExperience;
            } else if (typeof data.relevantWorkExperience === 'string') {
              try {
                normalizedWorkExperiences = JSON.parse(data.relevantWorkExperience);
              } catch (parseError) {
                console.warn('⚠️ relevantWorkExperience konnte nicht geparst werden:', parseError);
              }
            }
            if (normalizedWorkExperiences) {
              collectedData.optimizedWorkExperiences = normalizedWorkExperiences;
            }
          } else if (task.name === 'Ausbildung' && data.relevantEducations) {
            collectedData.relevantEducations = data.relevantEducations;
          } else if (task.name === 'Zertifikate' && data.relevantCertifications) {
            collectedData.relevantCertifications = data.relevantCertifications;
          } else if (task.name === 'Kernkompetenzen' && data.relevantCoreCompetencies) {
            collectedData.relevantCoreCompetencies = data.relevantCoreCompetencies;
          } else if (task.name === 'Sprachen' && data.relevantLanguages) {
            collectedData.relevantLanguages = data.relevantLanguages;
          } else if (task.name === 'Branchen' && data.relevantIndustries) {
            collectedData.relevantIndustries = data.relevantIndustries;
          } else if (task.name === 'IT-Skills' && data.relevantItSkills) {
            collectedData.relevantItSkills = data.relevantItSkills;
          } else if (task.name === 'Hobbys' && data.relevantHobbies) {
            collectedData.relevantHobbies = data.relevantHobbies;
          } else if (task.name === 'Weitere Angaben' && data.relevantAdditionalInfo) {
            collectedData.relevantAdditionalInfo = data.relevantAdditionalInfo;
          }
        }
      });
      
      // Setze die gesammelten Daten direkt in den State, falls sie noch nicht gesetzt wurden
      if (collectedData.optimizedShortProfile && !optimizedShortProfile) {
        console.log('✅ Setze optimizedShortProfile aus gesammelten Daten');
        setOptimizedShortProfile(applySwissGerman(collectedData.optimizedShortProfile));
      }
      if (collectedData.optimizedWorkExperiences && (!optimizedWorkExperiences || optimizedWorkExperiences.length === 0)) {
        console.log('✅ Setze optimizedWorkExperiences aus gesammelten Daten');
        const rankedWorkExperiences = applyTopRelevantWorkExperiences(collectedData.optimizedWorkExperiences, 6);
        setOptimizedWorkExperiences(applySwissGermanToWorkExperiences(rankedWorkExperiences));
      }
      if (collectedData.relevantEducations) {
        setRelevantEducations(collectedData.relevantEducations);
      }
      if (collectedData.relevantCertifications) {
        setRelevantCertifications(collectedData.relevantCertifications);
      }
      if (collectedData.relevantCoreCompetencies) {
        setRelevantCoreCompetencies(collectedData.relevantCoreCompetencies);
      }
      if (collectedData.relevantLanguages) {
        setRelevantLanguages(collectedData.relevantLanguages);
      }
      if (collectedData.relevantIndustries) {
        setRelevantIndustries(collectedData.relevantIndustries);
      }
      if (collectedData.relevantItSkills) {
        setRelevantItSkills(collectedData.relevantItSkills);
      }
      if (collectedData.relevantHobbies) {
        setRelevantHobbies(normalizeHobbyList(collectedData.relevantHobbies));
      }
      if (collectedData.relevantAdditionalInfo) {
        setRelevantAdditionalInfo(collectedData.relevantAdditionalInfo);
      }

      // WICHTIG: Auch die gesammelten Daten für den späteren Application-Save normalisieren.
      // Sonst landen ggf. Rohwerte (0-100) in `relevant` und der Preview-Filter blendet alles aus.
      if (Array.isArray(collectedData.optimizedWorkExperiences)) {
        collectedData.optimizedWorkExperiences = applyTopRelevantWorkExperiences(
          collectedData.optimizedWorkExperiences,
          6
        );
      }
      
      // Speichere die gesammelten Daten in window, damit sie in handleOpenCvTemplate verwendet werden können
      (window as any).collectedCvData = collectedData;
      console.log('📊 Gesammelte Daten gespeichert:', {
        hasOptimizedShortProfile: !!collectedData.optimizedShortProfile,
        hasOptimizedWorkExperiences: !!collectedData.optimizedWorkExperiences,
        hasRelevantEducations: !!collectedData.relevantEducations,
        hasRelevantCertifications: !!collectedData.relevantCertifications,
        hasRelevantCoreCompetencies: !!collectedData.relevantCoreCompetencies,
        hasRelevantLanguages: !!collectedData.relevantLanguages,
        hasRelevantIndustries: !!collectedData.relevantIndustries,
        hasRelevantItSkills: !!collectedData.relevantItSkills,
        hasRelevantHobbies: !!collectedData.relevantHobbies,
        hasRelevantAdditionalInfo: !!collectedData.relevantAdditionalInfo
      });
      
      // Warte, damit die State-Updates verarbeitet werden können
      console.log('⏳ Warte auf State-Updates nach Optimierung...');
      await new Promise(resolve => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            setTimeout(() => {
              requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                  setTimeout(resolve, 500);
                });
              });
            }, 500);
          });
        });
      });

      // Zeige Fehler an, falls welche aufgetreten sind
      if (failed > 0) {
        const failedTasks = results
          .filter(result => result.status === 'rejected' || 
            (result.status === 'fulfilled' && !result.value.success))
          .map(result => {
            if (result.status === 'fulfilled') {
              return result.value.task;
            }
            return 'Unbekannte Aufgabe';
          });
        
        console.warn(`⚠️ Folgende Optimierungen sind fehlgeschlagen: ${failedTasks.join(', ')}`);
        setError(`Optimierung teilweise erfolgreich: ${successful}/${optimizationTasks.length} Bereiche optimiert. Fehlgeschlagen: ${failedTasks.join(', ')}`);
      } else {
        console.log('🎉 Alle Optimierungen erfolgreich abgeschlossen!');
      }

      // Erstelle einen kombinierten CV-Text aus allen optimierten Daten
      let combinedCvText = '';
      
      // Füge optimiertes Kurzprofil hinzu
      if (optimizedShortProfile) {
        combinedCvText += `Profil:\n${optimizedShortProfile}\n\n`;
      }

      // Füge optimierte Arbeitserfahrungen hinzu
      if (optimizedWorkExperiences && optimizedWorkExperiences.length > 0) {
        combinedCvText += `Berufserfahrung:\n`;
        optimizedWorkExperiences.forEach((exp: any) => {
          combinedCvText += `${exp.position} bei ${exp.company} (${exp.startDate} - ${exp.endDate})\n`;
          combinedCvText += `${exp.description}\n\n`;
        });
      }

      // Füge andere optimierte Bereiche hinzu
      if (relevantEducations && relevantEducations.length > 0) {
        combinedCvText += `Ausbildung:\n`;
        relevantEducations.forEach((edu: any) => {
          const description = edu.description ? ` - ${edu.description}` : '';
          combinedCvText += `${edu.degree}${description} an ${edu.institution}\n`;
        });
        combinedCvText += '\n';
      }

      if (relevantItSkills && relevantItSkills.length > 0) {
        combinedCvText += `IT-Skills:\n`;
        relevantItSkills.forEach((skill: any) => {
          combinedCvText += `${skill.skill} (${skill.level})\n`;
        });
        combinedCvText += '\n';
      }

      if (relevantLanguages && relevantLanguages.length > 0) {
        combinedCvText += `Sprachen:\n`;
        relevantLanguages.forEach((lang: any) => {
          combinedCvText += `${lang.language} (${lang.level})\n`;
        });
        combinedCvText += '\n';
      }

      if (relevantCoreCompetencies && relevantCoreCompetencies.length > 0) {
        combinedCvText += `Kernkompetenzen:\n`;
        relevantCoreCompetencies.forEach((comp: any) => {
          combinedCvText += `${comp.competency}\n`;
        });
        combinedCvText += '\n';
      }

      if (relevantIndustries && relevantIndustries.length > 0) {
        combinedCvText += `Branchenerfahrung:\n`;
        relevantIndustries.forEach((industry: any) => {
          combinedCvText += `${industry.industry} (${industry.years} Jahre)\n`;
        });
        combinedCvText += '\n';
      }

      if (relevantHobbies && relevantHobbies.length > 0) {
        combinedCvText += `Hobbys:\n`;
        relevantHobbies.forEach((hobby: any) => {
          combinedCvText += `${hobby.hobby}: ${hobby.description}\n`;
        });
        combinedCvText += '\n';
      }

      if (relevantCertifications && relevantCertifications.length > 0) {
        combinedCvText += `Zertifikate:\n`;
        relevantCertifications.forEach((cert: any) => {
          const certName = cert.name || cert.certification || '';
          const description = cert.description ? ` - ${cert.description}` : '';
          combinedCvText += `${certName}${description} - ${cert.issuer}\n`;
        });
      }

      // Setze den kombinierten CV-Text
      setImprovedCvText(combinedCvText);

      // Öffne automatisch die CV Preview, wenn mindestens eine Optimierung erfolgreich war
      if (successful > 0) {
        // Verstecke "CV optimieren" Button nach erfolgreicher Optimierung
        setShowCvOptimierenButton(false);
        
        // Warte, bis alle State-Updates verarbeitet wurden, bevor die Preview geöffnet wird
        // React's State-Updates sind asynchron, daher müssen wir warten, bis sie verarbeitet wurden
        console.log('⏳ Warte auf State-Updates nach Optimierung...');
        
        // Warte länger, damit alle State-Updates verarbeitet werden können
        // Die Daten werden in verschiedenen Promise-All-Blöcken gesetzt, daher brauchen wir mehr Zeit
        await new Promise(resolve => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              setTimeout(() => {
                requestAnimationFrame(() => {
                  requestAnimationFrame(() => {
                    setTimeout(resolve, 500); // Längere Verzögerung für State-Updates
                  });
                });
              }, 500);
            });
          });
        });
        
        // Prüfe, ob die Daten jetzt verfügbar sind
        console.log('🔍 Prüfe, ob optimierte Daten verfügbar sind...');
        const hasData = hasOptimizedCvData();
        console.log('📊 Optimierte Daten verfügbar?', hasData);
        
        // Öffne die Preview nach State-Updates und verwende vorhandene Bewerbung weiter.
        console.log('🎯 Öffne CV Preview nach Optimierung...');
        await handleOpenCvTemplate(undefined, true);
        console.log('🎯 Template Preview automatisch geöffnet - optimierte Daten verfügbar');
      }

    } catch (err: any) {
      console.error('❌ Fehler bei paralleler CV-Optimierung:', err);
      setError(t('error.optimize.cv.unknown') + (err.message || ''));
    } finally {
      setOptimizing(false);
    }
  };

  // Re-Optimierung aus dem CV-Preview Modal heraus (behält bestehende Application)
  const handleReOptimizeCv = async (useBulletPointsOverride?: boolean) => {
    // Fallback: Wenn jobDescription leer ist, aus der aktuellen Application laden
    let effectiveJobDescription = jobDescription.trim();
    if (!effectiveJobDescription && selectedApplicationId && applications.length > 0) {
      const currentApp = applications.find((app: any) => app.id === selectedApplicationId);
      if (currentApp?.jobDescription) {
        effectiveJobDescription = currentApp.jobDescription;
        setJobDescription(effectiveJobDescription);
      }
    }
    if (!effectiveJobDescription) {
      setError('Stellenbeschreibung ist erforderlich.');
      return;
    }
    if (!user) {
      setError('Benutzer nicht angemeldet.');
      return;
    }

    // Merke aktuelle Application-ID, damit sie erhalten bleibt
    const currentApplicationId = selectedApplicationId;
    // Wenn Bewerbungsdetails offen sind, soll die CV-Preview offen bleiben.
    const keepCvPreviewOpen = showApplicationDetailsModal;

    // CV-Preview nur schließen, wenn Bewerbungsdetails nicht offen sind.
    if (!keepCvPreviewOpen) {
      activeProcessCvSnapshotRef.current = null;
      setShowTemplatePreviewDialog(false);
    }
    
    // Lösche vorhandene optimierte Daten
    setError(null);
    setImprovedCvText(null);
    setOptimizing(true);
    setHideMatchResults(true);
    resetMatchData();
    setRelevantItSkills([]);
    setRelevantEducations([]);
    setRelevantLanguages([]);
    setRelevantIndustries([]);
    setRelevantHobbies([]);
    setRelevantCoreCompetencies([]);
    setRelevantCertifications([]);
    setRelevantAdditionalInfo([]);
    setOptimizedShortProfile('');
    setOptimizedWorkExperiences([]);
    setMotivationLetter(null);

    try {
      const personalInfo = getPersonalInfoForMotivation();
      const iconOptimizationRunId = `icon_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
      
      const cvData = {
        personalInfo: {
          fullName: personalInfo.fullName || '',
          address: personalInfo.address || '',
          postalCode: personalInfo.postalCode || '',
          city: personalInfo.city || '',
          country: personalInfo.country || '',
          availableFrom: personalInfo.availableFrom || '',
          phoneNumber: personalInfo.phoneNumber || '',
          email: personalInfo.email || '',
          birthYear: birthYear || '',
          nationality: nationality || '',
          residencePermit: residencePermit || '',
          civilStatus: civilStatus || '',
          shortProfile: shortProfile || ''
        },
        workExperience: workExperiences || [],
        education: educations || [],
        certifications: certifications || [],
        languages: languages || [],
        itSkills: itSkills || [],
        coreCompetencies: coreCompetencies || [],
        industryExperiences: industryExperiences || [],
        hobbies: hobbies || [],
        additionalInfo: additionalInfo || []
      };

      const idToken = await user.getIdToken();

      // Gleiche Optimierungsaufgaben wie in handleOptimizeCvParallel
      const optimizationTasks = [
        { name: 'Kurzprofil', type: 'shortProfile', setter: (data: any) => setOptimizedShortProfile(applySwissGerman(data)) },
        { name: 'Arbeitserfahrung', type: 'workExperience', setter: (data: any) => {
            if (data && Array.isArray(data)) {
              const rankedWorkExperiences = applyTopRelevantWorkExperiences(
                data.map((exp: any, i: number) => ({ ...exp, id: i + 1 })),
                6
              );
              setOptimizedWorkExperiences(applySwissGermanToWorkExperiences(rankedWorkExperiences));
            }
          }
        },
        { name: 'Ausbildung', type: 'education', setter: (data: any) => { if (data) setRelevantEducations(Array.isArray(data) ? data : [data]); } },
        { name: 'IT-Skills', type: 'itSkills', setter: (data: any) => { if (data && Array.isArray(data)) setRelevantItSkills(data); } },
        { name: 'Sprachen', type: 'languages', setter: (data: any) => { if (data && Array.isArray(data)) setRelevantLanguages(data); } },
        { name: 'Kernkompetenzen', type: 'coreCompetencies', setter: (data: any) => { if (data && Array.isArray(data)) setRelevantCoreCompetencies(data); } },
        { name: 'Branchen', type: 'industry', setter: (data: any) => { if (data && Array.isArray(data)) setRelevantIndustries(data); } },
        { name: 'Hobbys', type: 'hobbies', setter: (data: any) => { if (data && Array.isArray(data)) setRelevantHobbies(normalizeHobbyList(data)); } },
        { name: 'Zertifikate', type: 'certifications', setter: (data: any) => { if (data && Array.isArray(data)) setRelevantCertifications(data); } },
        { name: 'Weitere Angaben', type: 'additionalInfo', setter: (data: any) => { if (data && Array.isArray(data)) setRelevantAdditionalInfo(data); } }
      ];

      // targetLanguage (State) wird bereits über jobDescriptionLanguage gesetzt

      // Initialisiere Progress-Tracking (wie bei handleOptimizeCvParallel)
      const initialProgress: {[key: string]: 'pending' | 'running' | 'completed' | 'failed'} = {};
      optimizationTasks.forEach(task => {
        initialProgress[task.name] = 'pending';
      });
      setOptimizationProgress(initialProgress);

      const effectiveTextSettings = getEffectiveTextSettings(useBulletPointsOverride);
      const resolvedUseBulletPoints = effectiveTextSettings.useBulletPoints;

      const optimizationPromises = optimizationTasks.map(async (task) => {
        try {
          setOptimizationProgress(prev => ({ ...prev, [task.name]: 'running' }));

          const requestBody = task.type === 'workExperience'
            ? buildWorkExperienceOptimizePayload(
                cvData,
                JSON.stringify(cvData || {}),
                effectiveJobDescription,
                {
                  useBulletPoints: resolvedUseBulletPoints,
                  promptText: '',
                  promptVersion: '',
                  temperature: '',
                  maxTokens: '',
                  optimizationSource: 'cv-optimize-icon',
                  iconOptimizationRunId
                }
              )
            : {
                cvData: cvData,
                cvText: JSON.stringify(cvData || {}),
                jobDescription: effectiveJobDescription,
                optimizeType: task.type,
                targetLanguage: targetLanguage,
                useBulletPoints: resolvedUseBulletPoints,
                tonalitySettings: effectiveTextSettings.tonalitySettings,
                optimizationSource: 'cv-optimize-icon',
                iconOptimizationRunId,
                promptText: '',
                promptVersion: '',
                temperature: '',
                maxTokens: ''
              };

          const data = await requestOptimizeCvWithQueue(requestBody, idToken, false);
          
          setOptimizationProgress(prev => ({ ...prev, [task.name]: 'completed' }));

          // Extrahiere die richtigen Daten
          let optimizedData = null;
          if (data.optimizedData && Array.isArray(data.optimizedData)) {
            optimizedData = data.optimizedData;
          } else {
            switch (task.type) {
              case 'shortProfile': optimizedData = data.optimizedShortProfile; break;
              case 'workExperience':
                if (Array.isArray(data.optimizedWorkExperiences)) {
                  optimizedData = data.optimizedWorkExperiences;
                } else if (Array.isArray(data.relevantWorkExperience)) {
                  optimizedData = data.relevantWorkExperience;
                } else if (typeof data.relevantWorkExperience === 'string') {
                  try {
                    const parsedRelevantWorkExperience = JSON.parse(data.relevantWorkExperience);
                    optimizedData = Array.isArray(parsedRelevantWorkExperience) ? parsedRelevantWorkExperience : null;
                  } catch (parseError) {
                    console.warn('⚠️ relevantWorkExperience konnte nicht geparst werden:', parseError);
                  }
                } else {
                  optimizedData = null;
                }
                break;
              case 'education': optimizedData = data.relevantEducations; break;
              case 'itSkills': optimizedData = data.relevantItSkills; break;
              case 'languages': optimizedData = data.relevantLanguages; break;
              case 'coreCompetencies': optimizedData = data.relevantCoreCompetencies; break;
              case 'industry': optimizedData = data.relevantIndustries; break;
              case 'hobbies': optimizedData = data.relevantHobbies; break;
              case 'certifications': optimizedData = data.relevantCertifications; break;
              case 'additionalInfo': optimizedData = data.relevantAdditionalInfo; break;
              default: optimizedData = data;
            }
          }

          if (task.setter) task.setter(optimizedData);
          return { success: true, task: task.name };
        } catch (error) {
          console.error(`❌ Re-Optimierung ${task.name} fehlgeschlagen:`, error);
          setOptimizationProgress(prev => ({ ...prev, [task.name]: 'failed' }));
          return { success: false, task: task.name };
        }
      });

      const results = await Promise.allSettled(optimizationPromises);
      const successful = results.filter(r => r.status === 'fulfilled' && r.value.success).length;
      const failed = results.filter(r => r.status === 'rejected' || (r.status === 'fulfilled' && !r.value.success)).length;

      console.log(`📈 Re-Optimierung abgeschlossen: ${successful} erfolgreich, ${failed} fehlgeschlagen`);

      if (failed > 0) {
        const failedTasks = results
          .filter(r => r.status === 'rejected' || (r.status === 'fulfilled' && !r.value.success))
          .map(r => r.status === 'fulfilled' ? r.value.task : 'Unbekannt');
        setError(`Re-Optimierung teilweise erfolgreich: ${successful}/${optimizationTasks.length}. Fehlgeschlagen: ${failedTasks.join(', ')}`);
      }

      // Stelle Application-ID wieder her
      if (currentApplicationId) {
        setSelectedApplicationId(currentApplicationId);
      }

      // Setze improvedCvText damit die Optimierung als abgeschlossen erkannt wird
      setImprovedCvText('re-optimized');

      // Nur wieder öffnen, wenn die Preview vorher geschlossen wurde.
      if (successful > 0 && !keepCvPreviewOpen) {
        await new Promise(resolve => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              setTimeout(() => {
                requestAnimationFrame(() => {
                  requestAnimationFrame(() => {
                    setTimeout(resolve, 500);
                  });
                });
              }, 500);
            });
          });
        });
        setShowTemplatePreviewDialog(true);
      }

    } catch (err: any) {
      console.error('❌ Fehler bei Re-Optimierung:', err);
      setError('Fehler bei der Re-Optimierung: ' + (err.message || ''));
    } finally {
      setOptimizing(false);
    }
  };

  const handleOptimizeImage = async () => {
    if (!profileImage) {
      setError('Bitte laden Sie zuerst ein Profilbild hoch.');
      return;
    }
    setOptimizingImage(true);
    setError(null);
    
    // Benachrichtigung anzeigen
    setError('🤖 DALL-E optimiert Ihr Foto... Bitte warten Sie.');
    
    // Verwende das ursprüngliche Bild ohne Komprimierung
    const compressedImage = profileImage;
    console.log('📸 Verwende ursprüngliches Bild ohne Komprimierung:', profileImage.length, 'Bytes');
    
    try {
      console.log('🤖 Sende DALL-E Optimierung Request...');
      
      if (!user) {
        throw new Error('Benutzer nicht angemeldet');
      }
      
      const idToken = await user.getIdToken();
      const response = await fetch(`${config.backend.baseUrl}/api/optimize-photo-dalle`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({ 
          imageData: compressedImage,
          prompt: 'Replace only the background with a professional office environment. Keep the person completely unchanged - preserve exact facial features, skin tone, clothing, and proportions. Do not alter the person or composition. Only change the background to a blurred modern office scene.'
        }),
      });
      
      console.log('📡 Response Status:', response.status);
      console.log('📡 Response OK:', response.ok);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ Response Error:', errorText);
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }
      
      const data = await response.json();
      console.log('🤖 DALL-E Response:', data);
      
      if (data.success && data.optimizedImage) {
        console.log('✅ DALL-E Optimierung erfolgreich');
        
        // Erstelle Array mit Original, Maske und optimiertem Bild für Auswahl
        const imageOptions = [
          {
            id: 1,
            image: profileImage,
            name: 'Ursprüngliches Bild',
            description: 'Ihr ursprünglich hochgeladenes Foto',
            isOriginal: true,
            isOptimized: false
          },
          {
            id: 2,
            image: data.maskImage,
            name: 'Erkannte Person (Maske)',
            description: 'KI-basierte Personenerkennung mit grünem Hintergrund',
            isOriginal: false,
            isOptimized: false,
            isMask: true
          },
          {
            id: 3,
            image: data.optimizedImage,
            name: 'Optimiertes Bild',
            description: 'Mit DALL-E optimiertes Foto',
            isOriginal: false,
            isOptimized: true
          }
        ];
        
        setOptimizedImages(imageOptions);
        setShowImageOptimizer(true);
        setError('✅ Foto-Optimierung abgeschlossen! Wählen Sie Ihr bevorzugtes Bild aus.');
        
        // Nach 5 Sekunden die Erfolgsmeldung löschen
        setTimeout(() => setError(null), 5000);
      } else {
        console.error('❌ Keine optimierten Bilddaten in Response:', data);
        throw new Error('Kein optimiertes Bild von DALL-E erhalten');
      }
    } catch (err: any) {
      console.error('❌ DALL-E Optimierung Fehler:', err);
      setError('Fehler bei der DALL-E Optimierung: ' + (err.message || ''));
    } finally {
      setOptimizingImage(false);
    }
  };

  const handleSelectOptimizedImage = (selectedImage: string) => {
    setProfileImage(selectedImage);
    setShowImageOptimizer(false);
    setError('✅ Bild ausgewählt!');
    // Nach 3 Sekunden die Erfolgsmeldung löschen
    setTimeout(() => setError(null), 3000);
  };

  // Handler für Color-Picker-Modal
  const handleColorPickerClick = (type: 'header' | 'column' | 'name' | 'leftTitle' | 'leftText' | 'rightTitle' | 'rightText') => {
    setCurrentColorPicker(type);
    if (type === 'header') {
      setTempColor(topBoxColor);
      setTempAlpha(topBoxAlpha);
    } else if (type === 'column') {
      setTempColor(leftColumnColor);
      setTempAlpha(leftColumnAlpha);
    } else if (type === 'name') {
      setTempColor(nameTextColor);
      setTempAlpha(1); // Textfarben haben keine Transparenz
    } else if (type === 'leftTitle') {
      setTempColor(leftColumnTitleColor);
      setTempAlpha(1);
    } else if (type === 'leftText') {
      setTempColor(leftColumnTextColor);
      setTempAlpha(1);
    } else if (type === 'rightTitle') {
      setTempColor(rightColumnTitleColor);
      setTempAlpha(1);
    } else if (type === 'rightText') {
      setTempColor(rightColumnTextColor);
      setTempAlpha(1);
    }
    setOpenColorPickerModal(true);
  };

  const handleColorChange = (color: string, alpha: number) => {
    setTempColor(color);
    setTempAlpha(alpha);
  };

  const handleApplyColor = async () => {
    if (currentColorPicker === 'header') {
      setTopBoxColor(tempColor);
      setTopBoxAlpha(tempAlpha);
    } else if (currentColorPicker === 'column') {
      setLeftColumnColor(tempColor);
      setLeftColumnAlpha(tempAlpha);
    } else if (currentColorPicker === 'name') {
      setNameTextColor(tempColor);
    } else if (currentColorPicker === 'leftTitle') {
      setLeftColumnTitleColor(tempColor);
    } else if (currentColorPicker === 'leftText') {
      setLeftColumnTextColor(tempColor);
    } else if (currentColorPicker === 'rightTitle') {
      setRightColumnTitleColor(tempColor);
    } else if (currentColorPicker === 'rightText') {
      setRightColumnTextColor(tempColor);
    }
    setOpenColorPickerModal(false);
    
    // Speichere CV-Settings in Firebase
    if (user?.uid && selectedCvId) {
      try {
        const currentSettings = getCurrentCvSettings();
        await saveCvSettings(selectedCvId, currentSettings);
        console.log('✅ CV-Settings erfolgreich gespeichert (Farbe und Transparenz)');
      } catch (error) {
        console.error('❌ Fehler beim Speichern der CV-Settings:', error);
      }
    }
  };

  const handleCancelColor = () => {
    setOpenColorPickerModal(false);
    // Trigger Seitenberechnung im CV-Template
    window.dispatchEvent(new CustomEvent('modalClosed'));
  };

  // PDF-Download-Limit prüfen und tracken
  const [pdfUsage, setPdfUsage] = useState<{ count: number; limit: number | null; remaining: number | null } | null>(null);

  const checkAndTrackPdfDownload = async (): Promise<boolean> => {
    if (!user) return false;
    
    try {
      const token = await user.getIdToken();
      const response = await fetch(`${config.backend.fullApiUrl}/api/pdf/track`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
      });

      const data = await response.json();

      if (!response.ok || !data.allowed) {
        // Limit erreicht
        setPdfUsage({ count: data.count || 0, limit: data.limit || 0, remaining: 0 });
        setError(data.reason || 'PDF-Download-Limit erreicht');
        const isFreePlanOrNoPdfs = data?.limit === 0;
        setUpgradeModalReason(isFreePlanOrNoPdfs ? 'freePlan' : 'pdfLimitReached');
        setUpgradeModalOpen(true);
        return false;
      }

      // Erfolg: Zähler aktualisieren
      setPdfUsage({ count: data.count, limit: data.limit, remaining: data.remaining });
      return true;
    } catch (error) {
      console.error('Fehler beim PDF-Tracking:', error);
      // Bei Fehler trotzdem erlauben (graceful degradation)
      return true;
    }
  };

  // Bekannte PDF-Limits pro Plan (Frontend-Fallback)
  const PDF_LIMITS_LOCAL: Record<string, number> = {
    'Free': 3,
    'Basic': 50,
    'Pro': 200,
    'Beta-Testing': -1,
  };

  // PDF-Status beim Laden abrufen
  const loadPdfStatus = React.useCallback(async () => {
    if (!user) return;
    
    // Sofort Fallback-Werte setzen basierend auf bekannten Limits
    const localLimit = PDF_LIMITS_LOCAL[accountType] ?? 0;
    if (!pdfUsage) {
      setPdfUsage({ 
        count: 0, 
        limit: localLimit === -1 ? null : localLimit, 
        remaining: localLimit === -1 ? null : localLimit 
      });
    }

    try {
      const token = await user.getIdToken();
      console.log('📊 Lade PDF-Status...');
      const response = await fetch(`${config.backend.fullApiUrl}/api/pdf/status`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
      });
      if (response.ok) {
        const data = await response.json();
        console.log('📊 PDF-Status geladen:', data);
        setPdfUsage({ count: data.count, limit: data.limit, remaining: data.remaining });
      } else {
        console.warn('⚠️ PDF-Status Fehler:', response.status, response.statusText);
      }
    } catch (error) {
      console.error('❌ Fehler beim Laden des PDF-Status:', error);
    }
  }, [user, accountType]);

  React.useEffect(() => {
    if (user && accountId) {
      loadPdfStatus();
    }
  }, [user, accountId, loadPdfStatus]);

  const resolveCvIdFromRowEntry = (rowEntry: any): string | null => {
    const directCvId =
      typeof rowEntry?.cvId === 'string' && rowEntry.cvId.trim()
        ? rowEntry.cvId.trim()
        : null;
    if (directCvId) return directCvId;

    const rowSetRef =
      typeof rowEntry?.cvSetRef === 'string' && rowEntry.cvSetRef.trim()
        ? rowEntry.cvSetRef.trim()
        : '';
    if (!rowSetRef) return null;

    const matchingCvs = (userCvs || []).filter((cv: any) => doesCvMatchSetRef(cv, rowSetRef));
    if (matchingCvs.length !== 1) {
      console.error('❌ cvSetRef konnte nicht eindeutig zu cvId aufgelöst werden:', {
        rowSetRef,
        matches: matchingCvs.length
      });
      return null;
    }

    const resolvedCvId =
      typeof matchingCvs[0]?.cvId === 'string' && matchingCvs[0].cvId.trim()
        ? matchingCvs[0].cvId.trim()
        : null;
    if (!resolvedCvId) {
      console.error('❌ Eindeutiges CV gefunden, aber ohne gültige cvId:', {
        rowSetRef
      });
      return null;
    }

    return resolvedCvId;
  };

  const resolvePreferredCvIdForPersistence = (): string | null => {
    const activeRowContext = activeCvPreviewRowContextRef.current;
    const canUseActiveRowContext =
      !!activeRowContext &&
      (!selectedApplicationId || activeRowContext.applicationId === selectedApplicationId);
    if (canUseActiveRowContext) {
      const rowResolvedCvId = resolveCvIdFromRowEntry(activeRowContext!.rowEntry);
      if (rowResolvedCvId) {
        return rowResolvedCvId;
      }
    }

    if (selectedApplicationId) {
      const linkedApplication = applications.find((app: any) => app.id === selectedApplicationId);
      const linkedCvId =
        typeof linkedApplication?.cvId === 'string' && linkedApplication.cvId.trim()
          ? linkedApplication.cvId.trim()
          : null;
      if (linkedCvId) return linkedCvId;
    }

    return typeof selectedCvId === 'string' && selectedCvId.trim()
      ? selectedCvId.trim()
      : null;
  };

  const persistCvDataAndSettingsOnCvLevel = async (): Promise<boolean> => {
    if (!user?.uid) return true;

    // Stelle sicher, dass Änderungen aus dem Berufserfahrung-Modal
    // vor dem Persistieren in die Listen übernommen werden.
    const workExperienceOverrides = commitSelectedWorkExperienceChanges() || lastCommittedWorkExperienceRef.current;
    const profileOverride = lastCommittedProfileRef.current;
    const saveOverrides = {
      ...(workExperienceOverrides || {}),
      ...(profileOverride !== null ? { optimizedShortProfileOverride: profileOverride } : {})
    };

    const activeRowContext = activeCvPreviewRowContextRef.current;
    const activeRowPayload =
      activeRowContext && selectedApplicationId && activeRowContext.applicationId === selectedApplicationId
        ? buildCvMatchRowPayload(activeRowContext.rowEntry)
        : {};
    const hasActiveRowPayload =
      !!activeRowPayload.cvId || !!activeRowPayload.cvSetRef || !!activeRowPayload.cvName;

    // Beim row-spezifischen Bewerbungen-Flow niemals CV-Level speichern:
    // sonst können globale UI-States ein anderes CV überschreiben.
    if (hasActiveRowPayload) {
      await saveCvPreviewDataToApplication(Object.keys(saveOverrides).length > 0 ? saveOverrides : undefined);
      lastCommittedWorkExperienceRef.current = null;
      lastCommittedProfileRef.current = null;
      console.log('✅ Row-spezifischer Persist: nur Bewerbungs-Preview gespeichert (kein CV-Level-Save)');
      return true;
    }

    const availableCvIds = new Set((userCvs || []).map((cv: any) => cv.cvId).filter(Boolean));
    let targetCvIdForPersistence: string | null = resolvePreferredCvIdForPersistence();
    if (targetCvIdForPersistence && availableCvIds.size > 0 && !availableCvIds.has(targetCvIdForPersistence)) {
      console.warn('⚠️ selectedCvId ist nicht mehr verfügbar - überspringe CV-Level-Persistierung für diese ID:', {
        selectedCvId: targetCvIdForPersistence
      });
      targetCvIdForPersistence = null;
    }

    // Harte ID-Regel: ohne eindeutige cvId nie persistieren.
    if (!targetCvIdForPersistence) {
      console.error('❌ Persistieren abgebrochen: Keine eindeutige cvId für aktive Bewerbung vorhanden');
      setError('CV-Daten konnten nicht gespeichert werden: keine eindeutige cvId verfügbar.');
      return false;
    }

    const savedCvId = await saveAllCvDataToFirebase(
      Object.keys(saveOverrides).length > 0 ? saveOverrides : undefined,
      targetCvIdForPersistence
    );
    if (!savedCvId) {
      setError('❌ CV-Daten konnten nicht gespeichert werden');
      return false;
    }

    const currentSettings = getCurrentCvSettings();
    await saveCvSettings(savedCvId, currentSettings);
    // Halte die aktive Bewerbung synchron zur CV-Ebene, damit beim erneuten Öffnen
    // aus der Bewerbungsansicht keine veralteten Preview-Texte geladen werden.
    await saveCvPreviewDataToApplication(Object.keys(saveOverrides).length > 0 ? saveOverrides : undefined);
    // Erfolgreich persistiert: keine ausstehenden Overrides mehr offen halten.
    lastCommittedWorkExperienceRef.current = null;
    lastCommittedProfileRef.current = null;
    console.log('✅ CV-Daten, CV-Settings und Bewerbungs-Preview synchron gespeichert');
    return true;
  };

  const finalizeTemplatePreviewDialogClose = () => {
    activeProcessCvSnapshotRef.current = null;
    activeCvPreviewRowContextRef.current = null;
    setShowTemplatePreviewDialog(false);
    setHasUnsavedCvSettings(false);
    // Zeige "CV optimieren" Button nach dem Schließen des CV-Templates
    setShowCvOptimierenButton(true);
    // Aktiviere Motivationsschreiben-Icon beim Schließen der Preview
    setCvTemplateHasBeenOpened(true);
    // Trigger Seitenberechnung im CV-Template
    window.dispatchEvent(new CustomEvent('modalClosed'));
  };

  const closeTemplatePreviewDialog = async () => {
    if (downloadingPdf) return;

    // Flush ausstehender debouncter Preview-Saves vor finalem Schließen.
    await flushCvPreviewDataSave();

    const persisted = await persistCvDataAndSettingsOnCvLevel();
    if (!persisted) return;

    finalizeTemplatePreviewDialogClose();
  };

  // Funktion zum Erstellen einer PDF mit jsPDF + html2canvas
  const handleDownloadCvPdf = async () => {
    // PDF-Limit prüfen und tracken
    const allowed = await checkAndTrackPdfDownload();
    if (!allowed) return;

    try {
      console.log('🖨️ Starte PDF-Generierung mit ATS-Kompatibilität');

      // Beim Download immer zuerst Texte + Settings auf CV-Ebene speichern
      const persisted = await persistCvDataAndSettingsOnCvLevel();
      if (!persisted) {
        return;
      }
      
      // PDF-Export ändert keine CV-Daten, daher Checkbox-Status nicht ändern
      
      // Finde das CV-Template
      const cvTemplate = document.querySelector('.cv-template') || document.querySelector('[data-testid="cv-template"]');
      if (!cvTemplate) {
        throw new Error('CV-Template nicht gefunden');
      }

      // Zeige Ladeindikator
      setDownloadingPdf(true);
      
      // 1. VISUELLES DESIGN: Erstelle ein Canvas vom gesamten CV
      const canvas = await html2canvas(cvTemplate as HTMLElement, {
        allowTaint: true,
        useCORS: true,
        scrollX: 0,
        scrollY: 0,
        width: cvTemplate.scrollWidth,
        height: cvTemplate.scrollHeight,
        scale: 2.5, // Höhere Auflösung für bessere Qualität
        backgroundColor: '#ffffff',
        logging: false,
        // Spezielle Einstellungen für Profilbilder
        imageTimeout: 15000, // Längere Timeout für Bilder
        removeContainer: false, // Behalte Container für bessere Kontrolle
        foreignObjectRendering: false, // Deaktiviert Foreign Object Rendering für bessere Kompatibilität
        // CSS-spezifische Einstellungen für bessere Bildqualität
        onclone: (clonedDoc) => {
          // Profilbild mit originalen Proportionen (object-fit: contain)
          const images = clonedDoc.querySelectorAll('img[alt="Profilbild"]');
          images.forEach((img: any) => {
            const container = img.parentElement;
            if (!container) return;

            // Layout-Größe NICHT überschreiben: sonst weicht die PDF-Größe von der Preview ab.
            container.style.overflow = 'hidden';
            container.style.position = 'relative';
            container.style.display = 'block';

            // Robuster Snapshot für html2canvas: Contain über Background statt <img> object-fit.
            const imageUrl = (img.currentSrc || img.src || '').replace(/"/g, '\\"');
            if (imageUrl) {
              container.style.backgroundImage = `url("${imageUrl}")`;
              container.style.backgroundSize = 'contain';
              container.style.backgroundPosition = 'center center';
              container.style.backgroundRepeat = 'no-repeat';
            }

            // Original-IMG aus dem Snapshot nehmen, Layout aber beibehalten.
            img.style.opacity = '0';
            img.style.width = '100%';
            img.style.height = '100%';
            img.style.objectFit = 'contain';
            img.style.objectPosition = 'center center';
            img.style.position = 'static';
          });
        }
      });

      console.log('✅ Canvas erstellt:', {
        width: canvas.width,
        height: canvas.height
      });

      // 2. PDF ERSTELLEN: Konvertiere zu PDF mit optimierter Kompression
      const imgData = canvas.toDataURL('image/jpeg', 0.85); // 85% Qualität - guter Kompromiss
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
        compress: true // PDF-Kompression für kleinere Dateigröße
      });
      
      const imgWidth = 210; // A4 Breite in mm
      const pageHeight = 297; // A4 Höhe in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;

      let position = 0;
      let pageCount = 1;

      // 2a. PROFILBILD-LAYER FÜR ATS (ZUERST - HINTER DEM CANVAS)
      if (profileImage && (showPhotoInCv || showProfileImageInCv)) {
        try {
          console.log('📸 Füge Profilbild als separaten Layer hinzu (hinter Canvas)...');
          
          // Berechne Profilbild-Position und Größe basierend auf CV-Template-Einstellungen
          // Standard-Position im Template ist links oben (kann je nach Template variieren)
          const profileImageXPos = 15; // mm von links
          const profileImageYPos = 20; // mm von oben
          
          // Bildgröße basierend auf profileImageSize-Einstellung (Quadratischer Slot)
          let imageWidth = 35; // mm (Standard für 'M')
          if (profileImageSize === 'S') {
            imageWidth = 25;
          } else if (profileImageSize === 'L') {
            imageWidth = 45;
          }
          
          // Wende profileImageWidth-Prozentsatz an
          imageWidth = imageWidth * (profileImageWidth / 100);
          
          // Lade das Bild asynchron um die Originalmaße zu erhalten
          await new Promise<void>((resolve) => {
            const img = new Image();
            img.onload = () => {
              // object-fit: contain - Bild behält Seitenverhältnis und passt komplett in den Container
              const containerSize = imageWidth; // Quadrat in mm

              // Berechne das Seitenverhältnis des Bildes
              const imgAR = img.naturalWidth / img.naturalHeight;
              
              // Berechne die tatsächliche Bildgröße im Container (contain-Logik)
              let finalWidth: number, finalHeight: number;
              let offsetX: number, offsetY: number;
              
              if (imgAR > 1) {
                // Bild ist breiter als hoch -> Breite = Container, Höhe skaliert
                finalWidth = containerSize;
                finalHeight = containerSize / imgAR;
                offsetX = 0;
                offsetY = (containerSize - finalHeight) / 2; // Vertikal zentrieren
              } else {
                // Bild ist höher als breit oder quadratisch -> Höhe = Container, Breite skaliert
                finalHeight = containerSize;
                finalWidth = containerSize * imgAR;
                offsetX = (containerSize - finalWidth) / 2; // Horizontal zentrieren
                offsetY = 0;
              }

              // Füge das Bild mit seinen originalen Proportionen ein
              pdf.addImage(profileImage, 'JPEG', profileImageXPos + offsetX, profileImageYPos + offsetY, finalWidth, finalHeight, undefined, 'FAST');
              
              console.log(`✅ Profilbild als separater Layer hinzugefügt (${finalWidth.toFixed(1)}x${finalHeight.toFixed(1)}mm, originale Proportionen)`);
              resolve();
            };
            img.onerror = () => {
              console.error('⚠️ Fehler beim Laden des Profilbilds');
              resolve(); // Fahre trotzdem fort
            };
            img.src = profileImage;
          });
        } catch (imageError) {
          console.error('⚠️ Fehler beim Hinzufügen des Profilbild-Layers:', imageError);
          // Fehler beim Profilbild sollte die PDF-Generierung nicht stoppen
        }
      }

      // Füge erste Seite mit Canvas-Bild hinzu (ÜBER dem Profilbild)
      pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      // Füge weitere Seiten hinzu falls nötig
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
        pageCount++;
      }

      console.log(`✅ PDF-Bild erstellt mit ${pageCount} Seiten`);

      // 3. UNSICHTBARER TEXT-LAYER FÜR ATS-KOMPATIBILITÄT
      // Gehe zurück zur ersten Seite
      pdf.setPage(1);
      
      // Text-Einstellungen: Unsichtbar für Menschen, aber lesbar für ATS
      // Verwende normale Schriftgröße für korrekte Umlaute-Codierung
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(8); // Größer für korrekte Umlaute-Codierung (wird außerhalb des sichtbaren Bereichs platziert)
      pdf.setTextColor(255, 255, 255); // Weiß = unsichtbar auf weißem Hintergrund
      
      // CV-Text-Daten für ATS extrahieren und einfügen
      console.log('📝 Füge unsichtbaren Text-Layer für ATS hinzu...');
      
      const atsTextData: string[] = [];
      
      // Persönliche Daten (EXAKT wie in getCvDataForTemplate - mit optimierten Versionen)
      const nameToUse = optimizedFullName || fullName;
      const emailToUse = optimizedEmail || email;
      const phoneToUse = optimizedPhoneNumber || phoneNumber;
      const addressToUse = optimizedAddress || address;
      const postalCodeToUse = optimizedPostalCode || postalCode;
      const cityToUse = optimizedCity || city;
      
      if (nameToUse) atsTextData.push(`NAME: ${nameToUse}`);
      if (company) atsTextData.push(`FIRMA: ${company}`);
      if (addressToUse) atsTextData.push(`ADRESSE: ${addressToUse}`);
      if (postalCodeToUse || cityToUse) {
        const location = [postalCodeToUse, cityToUse].filter(Boolean).join(' ');
        if (location) atsTextData.push(`ORT: ${location}`);
      }
      if (country) atsTextData.push(`LAND: ${country}`);
      if (emailToUse) atsTextData.push(`EMAIL: ${emailToUse}`);
      if (phoneToUse) atsTextData.push(`TELEFON: ${phoneToUse}`);
      if (birthYear) atsTextData.push(`GEBURTSJAHR: ${birthYear}`);
      if (nationality) atsTextData.push(`NATIONALITÄT: ${nationality}`);
      if (residencePermit) atsTextData.push(`AUFENTHALTSBEWILLIGUNG: ${residencePermit}`);
      if (civilStatus) atsTextData.push(`FAMILIENSTAND: ${civilStatus}`);
      if (drivingLicense) atsTextData.push(`FÜHRERSCHEIN: ${drivingLicense}`);
      if (availableFrom) atsTextData.push(`VERFÜGBAR AB: ${availableFrom}`);
      atsTextData.push('');
      
      // Kurzprofil (EXAKT wie in getCvDataForTemplate - nur optimizedShortProfile)
      if (optimizedShortProfile && optimizedShortProfile.trim() && showProfileInCv) {
        atsTextData.push('KURZPROFIL:');
        // Teile lange Texte in mehrere Zeilen auf (max 100 Zeichen pro Zeile für bessere ATS-Lesbarkeit)
        const profileLines = optimizedShortProfile.match(/.{1,100}(\s|$)/g) || [optimizedShortProfile];
        profileLines.forEach(line => atsTextData.push(line.trim()));
        atsTextData.push('');
      }
      
      // Berufserfahrung - Relevante (EXAKT wie im CV-Template - mit relevant-Filter!)
      // Das CV-Template filtert optimizedWorkExperiences nach relevant === true
      const relevantWorkExp = optimizedWorkExperiences ? 
        optimizedWorkExperiences.filter((work: any) => work.relevant === true || work.relevant === 'true') : 
        (workExperiences || []);
      
      if (relevantWorkExp.length > 0) {
        atsTextData.push('BERUFLICHER WERDEGANG:');
        relevantWorkExp.forEach(exp => {
          atsTextData.push(`${exp.position} bei ${exp.company}`);
          atsTextData.push(`${exp.startDate} - ${exp.endDate}`);
          if (exp.description) {
            // Teile lange Beschreibungen auf
            const descLines = exp.description.match(/.{1,100}(\s|$)/g) || [exp.description];
            descLines.forEach(line => atsTextData.push(line.trim()));
          }
          atsTextData.push('');
        });
      }
      
      // Weitere Berufserfahrungen - Nicht-relevante (wenn im CV-Template angezeigt)
      const nonRelevantWorkExp = optimizedWorkExperiences ? 
        optimizedWorkExperiences.filter((work: any) => work.relevant !== true && work.relevant !== 'true') : 
        [];
      
      if (nonRelevantWorkExp.length > 0 && showAdditionalWorkExperienceInCv) {
        atsTextData.push('WEITERE BERUFSERFAHRUNGEN:');
        nonRelevantWorkExp.forEach(exp => {
          // Bei weiteren Berufserfahrungen werden oft nur Firma, Position und Zeitraum angezeigt
          atsTextData.push(`${exp.position} bei ${exp.company} (${exp.startDate} - ${exp.endDate})`);
          atsTextData.push('');
        });
      }
      
      // Ausbildung (EXAKT wie in getCvDataForTemplate - nur relevantEducations)
      if (relevantEducations && relevantEducations.length > 0) {
        atsTextData.push('AUSBILDUNG:');
        relevantEducations.forEach(edu => {
          const description = edu.description ? ` - ${edu.description}` : '';
          atsTextData.push(`${edu.degree}${description} - ${edu.institution}`);
          atsTextData.push(`${edu.startDate} - ${edu.endDate}`);
          atsTextData.push('');
        });
      }
      
      // Kernkompetenzen (EXAKT wie in getCvDataForTemplate - nur relevantCoreCompetencies)
      if (relevantCoreCompetencies && relevantCoreCompetencies.length > 0 && showCoreCompetenciesInCv) {
        atsTextData.push('KERNKOMPETENZEN:');
        relevantCoreCompetencies.forEach(c => atsTextData.push(c.competency));
        atsTextData.push('');
      }
      
      // IT-Skills (EXAKT wie in getCvDataForTemplate - nur relevantItSkills)
      if (relevantItSkills && relevantItSkills.length > 0 && showItSkillsInCv) {
        atsTextData.push('IT-SKILLS:');
        relevantItSkills.forEach(s => atsTextData.push(`${s.skill}: ${s.level}`));
        atsTextData.push('');
      }
      
      // Sprachen (EXAKT wie in getCvDataForTemplate - nur relevantLanguages)
      if (relevantLanguages && relevantLanguages.length > 0 && showLanguagesInCv) {
        atsTextData.push('SPRACHEN:');
        relevantLanguages.forEach(l => atsTextData.push(`${l.language}: ${l.level}`));
        atsTextData.push('');
      }
      
      // Branchen (EXAKT wie in getCvDataForTemplate - nur relevantIndustries)
      if (relevantIndustries && relevantIndustries.length > 0 && showIndustriesInCv) {
        atsTextData.push('BRANCHEN:');
        relevantIndustries.forEach(i => atsTextData.push(`${i.industry} (${i.years} Jahre)`));
        atsTextData.push('');
      }
      
      // Zertifizierungen (EXAKT wie in getCvDataForTemplate - nur relevantCertifications)
      if (relevantCertifications && relevantCertifications.length > 0 && showCertificationsInCv) {
        atsTextData.push('ZERTIFIZIERUNGEN:');
        relevantCertifications.forEach(cert => {
          const description = cert.description ? ` - ${cert.description}` : '';
          atsTextData.push(`${cert.name}${description} - ${cert.issuer} (${cert.date})`);
        });
        atsTextData.push('');
      }
      
      // Hobbies (EXAKT wie in getCvDataForTemplate - nur relevantHobbies)
      if (relevantHobbies && relevantHobbies.length > 0 && showHobbiesInCv) {
        atsTextData.push('HOBBIES:');
        relevantHobbies.forEach(h => {
          atsTextData.push(`${h.hobby}${h.description ? ': ' + h.description : ''}`);
        });
        atsTextData.push('');
      }
      
      // Weitere Angaben (EXAKT wie in getCvDataForTemplate - nur relevantAdditionalInfo)
      if (relevantAdditionalInfo && relevantAdditionalInfo.length > 0 && showAdditionalInfoInCv) {
        atsTextData.push('WEITERE ANGABEN:');
        relevantAdditionalInfo.forEach(item => {
          if (item.details) {
            atsTextData.push(`${item.info}:`);
            // Teile lange Details auf
            const detailLines = item.details.match(/.{1,100}(\s|$)/g) || [item.details];
            detailLines.forEach(line => atsTextData.push(line.trim()));
          } else {
            atsTextData.push(item.info);
          }
        });
      }
      
      // Füge den unsichtbaren Text zum PDF hinzu
      // Position WEIT außerhalb des druckbaren A4-Bereichs (210mm x 297mm)
      // Dadurch bleibt der Text im PDF-Layer, ist aber niemals sichtbar oder druckbar
      let yPos = 400; // Weit unterhalb der A4-Seite
      const xPos = 300; // Weit rechts außerhalb des A4-Bereichs
      const lineHeight = 4; // Größerer Zeilenabstand da Schrift größer ist
      let currentPage = 1;
      
      atsTextData.forEach(line => {
        // Wechsel zur nächsten Seite wenn nötig (wenn zu viele Zeilen)
        if (yPos > 800) {
          currentPage++;
          if (currentPage <= pageCount) {
            pdf.setPage(currentPage);
          } else {
            pdf.addPage();
            pageCount++;
          }
          yPos = 400; // Wieder weit außerhalb starten
        }
        
        // Text an Position einfügen - Umlaute werden bei Schriftgröße 8 korrekt codiert
        try {
          pdf.text(line, xPos, yPos, { maxWidth: 200, align: 'left' });
        } catch (e) {
          // Fallback falls Text-Codierung fehlschlägt
          console.warn('⚠️ Text-Codierung übersprungen für:', line.substring(0, 30));
        }
        yPos += lineHeight;
      });
      
      console.log(`✅ ATS Text-Layer hinzugefügt (${atsTextData.length} Zeilen)`);

      const fileName = `CV_${fullName || 'CV'}_${new Date().toISOString().split('T')[0]}.pdf`;
      // Lade PDF direkt herunter (ohne neues Fenster/Tab)
      pdf.save(fileName);
      
      console.log('✅ PDF erfolgreich heruntergeladen:', fileName);
      console.log('📊 PDF-Info: Visuell identisch, ATS-lesbar mit Text-Layer + Profilbild-Layer');
      
      // Schließe CV-Preview mit demselben Abschlussprozess wie beim normalen Schließen
      finalizeTemplatePreviewDialogClose();
      
    } catch (err: any) {
      console.error('❌ PDF-Generierung Fehler:', err);
      setError('Fehler bei der PDF-Generierung: ' + err.message);
    } finally {
      setDownloadingPdf(false);
    }
  };





  // Funktion zum Leeren der Stellenbeschreibung und abgeleiteten Felder
  const resetApplicationSelectionForNewJobDescription = () => {
    if (selectedApplicationId || selectedApplication?.id) {
      console.log('🔄 Neue Stellenbeschreibung erkannt - löse aktive Bewerbungszuordnung');
    }
    setSelectedApplicationId(null);
    setSelectedApplication(null);
    activeCvPreviewRowContextRef.current = null;
  };

  const handleClearJobDescription = () => {
    resetApplicationSelectionForNewJobDescription();
    setJobDescription('');
    setImprovedCvText(null);
    setShowMotivationDialog(false);
    setCvTemplateHasBeenOpened(false);
    setExtractedJobInfo(null);
    setJobKeywordInput('');
    setHasJobInfoChangedSinceLastMatch(false);
    setJobUrl(null);
    setHideMatchResults(false);
    clearOptimizedAndMatchData();
    console.log('Stellenbeschreibung und abgeleitete Felder geleert');
  };

  const handleCloseApplicationDetailsModal = async (options?: { saveBeforeClose?: boolean }) => {
    const shouldSaveBeforeClose = options?.saveBeforeClose !== false;
    if (shouldSaveBeforeClose) {
      await saveApplicationData();
    }

    // Beim Schliessen waehrend geoeffneter CV-Preview NICHT loeschen,
    // sonst koennen optimierte Daten beim spaeteren Save ueberschrieben werden.
    if (!showTemplatePreviewDialog) {
      clearOptimizedAndMatchData();
    }

    setShowApplicationDetailsModal(false);

    // Job-Informationen hinter dem Modal zuruecksetzen
    resetApplicationSelectionForNewJobDescription();
    setJobDescription('');
    setExtractedJobInfo(null);
    setJobKeywordInput('');
    setHasJobInfoChangedSinceLastMatch(false);
    setJobUrl(null);

    // Nach dem Schliessen immer Tabelle "Meine Bewerbungen" zeigen
    setCvTabIndex(0);
    setBewerbungenSubTabIndex(0);

    // Trigger Seitenberechnung im CV-Template
    window.dispatchEvent(new CustomEvent('modalClosed'));
  };

  const MIN_JOB_TEXT_PROCESS_LENGTH = 20;

  const normalizeJobDescriptionText = (text: string = '') =>
    text
      .replace(/[\u200B-\u200D\uFEFF]/g, '') // Zero-width Zeichen entfernen
      .replace(/\u00A0/g, ' ') // Non-breaking spaces normalisieren
      .trim();

  const hasMinimumJobDescriptionLength = (text: string = '') =>
    normalizeJobDescriptionText(text).length >= MIN_JOB_TEXT_PROCESS_LENGTH;

  const hasProcessableJobDescription = hasMinimumJobDescriptionLength(jobDescription);
  const hasManualMustSollKannText =
    (extractedJobInfo?.['requirements-muss']?.trim().length || 0) >= 10 ||
    (extractedJobInfo?.['requirements-soll']?.trim().length || 0) >= 10 ||
    (extractedJobInfo?.['requirements-kann']?.trim().length || 0) >= 10;
  const hasProcessableOrManualJobInfo = hasProcessableJobDescription || hasManualMustSollKannText;

  // Funktion zum Verarbeiten der Stellenbeschreibung mit automatischer Leerzeile
  const handleJobDescriptionChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    
    // Reset language detection when job description changes
    setLanguageDetected(false);
    
    // Prüfe, ob der Text über Copy/Paste eingefügt wurde (mehr als 1 Zeichen auf einmal)
    const isPaste = value.length > jobDescription.length + 1;
    
    if (isPaste) {
      // Füge eine zusätzliche Leerzeile am Ende hinzu, falls nicht bereits vorhanden
      const trimmedValue = value.trim();
      const normalizedValue = normalizeJobDescriptionText(value);
      if (!normalizedValue) {
        handleClearJobDescription();
        return;
      }
      const newValue = trimmedValue.endsWith('\n\n') ? trimmedValue : trimmedValue + '\n\n';
      resetApplicationSelectionForNewJobDescription();
      setJobDescription(newValue);
      
      // Extrahiere strukturierte Job-Informationen bei Copy/Paste
      if (trimmedValue.length > 100) {
        try {
          setExtractingJobInfo(true);
          console.log('🔍 Extrahiere Job-Informationen aus eingefügtem Text...');
          const response = await fetch(`${config.backend.baseUrl}/api/extract-job-info`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ text: trimmedValue })
          });
          
          if (response.ok) {
            const data = await response.json();
            if (data.jobInfo && Object.keys(data.jobInfo).length > 0) {
              setExtractedJobInfo(normalizeExtractedJobInfo(data.jobInfo));
              console.log('✅ Job-Informationen aus Text extrahiert:', data.jobInfo);
            }
          }
        } catch (error) {
          console.error('❌ Fehler bei Job-Info-Extraktion:', error);
        } finally {
          setExtractingJobInfo(false);
        }
      }
      
      // Prompt Spracherkennung nach Paste nur ab Mindestlänge
      if (hasMinimumJobDescriptionLength(trimmedValue)) {
        await handleLanguageDetection(trimmedValue);
      }
    } else {
      // Normale Eingabe - keine Änderung
      setJobDescription(value);
    }
  };

  // Funktion zum Extrahieren von Text aus URL
  const extractTextFromUrl = async (url: string) => {
    console.log('🌐 Extrahiere Text aus URL:', url);
    setExtractingJobUrl(true);
    setExtractingJobInfo(true);
    
    try {
      const response = await fetch(`${config.backend.fullApiUrl}/api/extract-job-url`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ url })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      if (data.text && data.text.trim()) {
        // Reset language detection
        setLanguageDetected(false);
        
        // Setze den extrahierten Text
        const trimmedText = data.text.trim();
        const newValue = trimmedText.endsWith('\n\n') ? trimmedText : trimmedText + '\n\n';
        resetApplicationSelectionForNewJobDescription();
        setJobDescription(newValue);
        
        // Setze URL wenn vorhanden
        if (data.url) {
          setJobUrl(data.url);
          console.log('🔗 Job-URL gespeichert:', data.url);
        }
        
        console.log('✅ Text erfolgreich extrahiert:', data.text.substring(0, 100) + '...');
        
        // Prompt Spracherkennung nach URL-Extraktion (vor Job-Infos)
        if (hasMinimumJobDescriptionLength(trimmedText)) {
          console.log('🔍 Starte Spracherkennung nach URL-Extraktion...');
          await handleLanguageDetection(trimmedText);
        }
        
        // Setze strukturierte Job-Informationen
        if (data.jobInfo) {
          console.log('📊 Empfangene Job-Informationen:', data.jobInfo);
          console.log('🏢 Firma:', data.jobInfo.company);
          console.log('📋 Rollentitel:', data.jobInfo.roleTitle);
          console.log('🏭 Branche:', data.jobInfo.industry);
          setExtractedJobInfo(normalizeExtractedJobInfo(data.jobInfo));
          console.log('✅ Strukturierte Job-Informationen gesetzt');
        } else {
          console.log('⚠️ Keine jobInfo in Response');
          setExtractingJobInfo(false);
        }
      } else {
        throw new Error('Kein Text gefunden');
      }
    } catch (error) {
      console.error('❌ Fehler beim Extrahieren:', error);
      setError(`Fehler beim Extrahieren der Stellenbeschreibung: ${error instanceof Error ? error.message : 'Unbekannter Fehler'}`);
    } finally {
      setExtractingJobUrl(false);
      setExtractingJobInfo(false);
    }
  };

  const handleExtractedJobRequirementChange = (
    field: 'requirements-muss' | 'requirements-soll' | 'requirements-kann' | 'requirements',
    value: string
  ) => {
    setHasJobInfoChangedSinceLastMatch(true);
    setExtractedJobInfo((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        [field]: value
      };
    });
  };

  const handleExtractedJobInfoFieldChange = (
    field: 'company' | 'publishDate' | 'startDate' | 'contactInfo' | 'industry' | 'roleTitle' | 'tasks' | 'applicationDetails' | 'workload',
    value: string
  ) => {
    setHasJobInfoChangedSinceLastMatch(true);
    setExtractedJobInfo((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        [field]: value
      };
    });
  };

  const handleAddExtractedJobKeyword = (rawValue: string) => {
    const keyword = rawValue.trim().replace(/,+$/, '');
    if (!keyword) return;

    setHasJobInfoChangedSinceLastMatch(true);
    setExtractedJobInfo((prev) => {
      if (!prev) return prev;
      const existingKeywords = Array.isArray(prev.keywords) ? prev.keywords : [];
      const alreadyExists = existingKeywords.some(
        (existingKeyword) => existingKeyword.toLowerCase() === keyword.toLowerCase()
      );
      if (alreadyExists) return prev;
      return {
        ...prev,
        keywords: [...existingKeywords, keyword]
      };
    });
    setJobKeywordInput('');
  };

  const handleRemoveExtractedJobKeyword = (keywordToRemove: string) => {
    setHasJobInfoChangedSinceLastMatch(true);
    setExtractedJobInfo((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        keywords: (prev.keywords || []).filter((keyword) => keyword !== keywordToRemove)
      };
    });
  };

  const enrichJobDescriptionWithExtractedInfo = (
    baseJobDescription: string,
    info: {
      roleTitle?: string;
      company?: string;
      industry?: string;
      workload?: string;
      publishDate?: string;
      startDate?: string;
      contactInfo?: string;
      keywords?: string[];
      tasks?: string;
      'requirements-muss'?: string;
      'requirements-soll'?: string;
      'requirements-kann'?: string;
      requirements?: string;
      applicationDetails?: string;
    } | null
  ) => {
    if (!info) return baseJobDescription;

    const sections: string[] = [];

    if (info.roleTitle && info.roleTitle.trim()) sections.push(`Rollentitel: ${info.roleTitle.trim()}`);
    if (info.company && info.company.trim()) sections.push(`Firma: ${info.company.trim()}`);
    if (info.industry && info.industry.trim()) sections.push(`Branche: ${info.industry.trim()}`);
    if (info.workload && info.workload.trim()) sections.push(`Auslastung: ${info.workload.trim()}`);
    if (info.publishDate && info.publishDate.trim()) sections.push(`Ausschreibedatum: ${info.publishDate.trim()}`);
    if (info.startDate && info.startDate.trim()) sections.push(`Startdatum: ${info.startDate.trim()}`);
    if (info.contactInfo && info.contactInfo.trim()) sections.push(`Kontaktdaten: ${info.contactInfo.trim()}`);
    if (Array.isArray(info.keywords) && info.keywords.length > 0) {
      sections.push(`Schlüsselstichworte: ${info.keywords.join(', ')}`);
    }
    if (info.tasks && info.tasks.trim()) sections.push(`Aufgaben: ${info.tasks.trim()}`);

    if (info['requirements-muss'] && info['requirements-muss'].trim()) {
      sections.push(`Muss-Anforderungen: ${info['requirements-muss'].trim()}`);
    }
    if (info['requirements-soll'] && info['requirements-soll'].trim()) {
      sections.push(`Soll-Anforderungen: ${info['requirements-soll'].trim()}`);
    }
    if (info['requirements-kann'] && info['requirements-kann'].trim()) {
      sections.push(`Kann-Anforderungen: ${info['requirements-kann'].trim()}`);
    }

    if ((!info['requirements-muss'] || !info['requirements-muss'].trim()) &&
        (!info['requirements-soll'] || !info['requirements-soll'].trim()) &&
        (!info['requirements-kann'] || !info['requirements-kann'].trim()) &&
        info.requirements && info.requirements.trim()) {
      sections.push(`Anforderungen: ${info.requirements.trim()}`);
    }

    if (info.applicationDetails && info.applicationDetails.trim()) {
      sections.push(`Bewerbungsdetails: ${info.applicationDetails.trim()}`);
    }

    if (sections.length === 0) return baseJobDescription;

    const structuredBlock = `\n\n--- Strukturierte Job-Informationen ---\n${sections.join('\n')}`;
    return `${baseJobDescription}${structuredBlock}`.trim();
  };

  // Separate State für AI-optimierte Arbeitserfahrungen (werden nicht gespeichert)
  const [optimizedWorkExperiences, setOptimizedWorkExperiences] = useState<Array<{ company: string; position: string; startDate: string; endDate: string; description: string; relevant?: boolean | string }>>([]);
  const [optimizedShortProfile, setOptimizedShortProfile] = useState<string>('');
  
  // Aktualisiere Info-Nachricht bei Zustandsänderungen - Optimiert für Performance
  React.useEffect(() => {
    if (!extracting && !optimizing && !creatingMotivation && !checkingMatch) {
      updateInfoMessage();
    }
  }, [jobDescription, matchScore, optimizedShortProfile, motivationLetter, extracting, optimizing, creatingMotivation, checkingMatch, cvTemplateHasBeenOpened]);
  
  // useEffect um das Profil-Modal beim Öffnen zu initialisieren
  React.useEffect(() => {
    if (showProfileModal) {
      // Initialisiere die temporären Werte beim Öffnen des Modals
      const currentProfile = optimizedShortProfile || shortProfile || '';
      console.log('🔧 Modal geöffnet - Initialisiere Profil:', {
        optimizedShortProfile,
        shortProfile,
        currentProfile
      });
      setTempOptimizedShortProfile(currentProfile);
      // History mit aktuellem Profil-Text initialisieren
      const initialHistory = [currentProfile];
      setProfileHistory(initialHistory);
      setProfileHistoryIndex(0);
      profileHistoryRef.current = { history: initialHistory, index: 0 };
    } else {
      // History beim Schließen des Modals zurücksetzen
      setProfileHistory([]);
      setProfileHistoryIndex(-1);
      profileHistoryRef.current = { history: [], index: -1 };
    }
  }, [showProfileModal]); // Nur showProfileModal als Dependency
  
  // State für optimierte persönliche Angaben
  const [optimizedFullName, setOptimizedFullName] = useState<string>('');
  const [, setOptimizedCompany] = useState<string>('');
  const [optimizedAddress, setOptimizedAddress] = useState<string>('');
  const [optimizedPostalCode, setOptimizedPostalCode] = useState<string>('');
  const [optimizedCity, setOptimizedCity] = useState<string>('');
  const [optimizedPhoneNumber, setOptimizedPhoneNumber] = useState<string>('');
  const [optimizedEmail, setOptimizedEmail] = useState<string>('');
  const [, setOptimizedBirthYear] = useState<string>('');
  const [, setOptimizedNationality] = useState<string>('');
  const [, setOptimizedResidencePermit] = useState<string>('');
  const [, setOptimizedCivilStatus] = useState<string>('');
  const [relevantItSkills, setRelevantItSkills] = useState<Array<{ skill: string; level: string; relevance?: string }>>([]);
  const [relevantCertifications, setRelevantCertifications] = useState<Array<{ name: string; description?: string; issuer: string; date: string }>>([]);
  const [relevantCoreCompetencies, setRelevantCoreCompetencies] = useState<Array<{ competency: string }>>([]);
  const [relevantIndustries, setRelevantIndustries] = useState<Array<{ industry: string; years: string }>>([]);
  const [relevantHobbies, setRelevantHobbies] = useState<Array<{ hobby: string; description: string }>>([]);
  const [relevantAdditionalInfo, setRelevantAdditionalInfo] = useState<Array<{ info: string; details: string }>>([]);
  const [relevantEducations, setRelevantEducations] = useState<Array<{ institution: string; degree: string; description?: string; startDate: string; endDate: string }>>([]);
  const [relevantWorkExperiences, setRelevantWorkExperiences] = useState<Array<{
    position: string;
    company: string;
    startDate: string;
    endDate: string;
    description: string;
    relevant?: boolean | string;
    relevanzranking?: number | string;
    relevanceRanking?: number | string;
    relevanceScore?: number | string;
  }>>([]);
  const [relevantLanguages, setRelevantLanguages] = useState<Array<{ language: string; level: string }>>([]);
  const [showItSkillSelector, setShowItSkillSelector] = useState(false);
  const [showCertificationSelector, setShowCertificationSelector] = useState(false);
  const [showCoreCompetencySelector, setShowCoreCompetencySelector] = useState(false);
  const [showAdditionalInfoSelector, setShowAdditionalInfoSelector] = useState(false);
  const [showEducationSelector, setShowEducationSelector] = useState(false);
  const [showIndustrySelector, setShowIndustrySelector] = useState(false);
  const [showHobbySelector, setShowHobbySelector] = useState(false);
  const [showLanguageSelector, setShowLanguageSelector] = useState(false);

  // Handler zum Löschen einer relevanten IT-Kenntnis
  const handleDeleteRelevantItSkill = (index: number) => {
    setRelevantItSkills(prev => prev.filter((_, i) => i !== index));
  };

  // Handler zum Löschen einer relevanten Zertifizierung
  const handleDeleteRelevantCertification = (index: number) => {
    setRelevantCertifications(prev => prev.filter((_, i) => i !== index));
  };

  // Handler zum Löschen einer relevanten Kernkompetenz
  const handleDeleteRelevantCoreCompetency = (index: number) => {
    setRelevantCoreCompetencies(prev => prev.filter((_, i) => i !== index));
  };

  // Handler zum Löschen einer relevanten Branche
  const handleDeleteRelevantIndustry = (index: number) => {
    setRelevantIndustries(prev => prev.filter((_, i) => i !== index));
  };

  // Handler zum Löschen eines relevanten Hobbys
  const handleDeleteRelevantHobby = (index: number) => {
    setRelevantHobbies(prev => prev.filter((_, i) => i !== index));
  };

  // Handler zum Löschen einer relevanten weiteren Information
  const handleDeleteRelevantAdditionalInfo = (index: number) => {
    setRelevantAdditionalInfo(prev => prev.filter((_, i) => i !== index));
  };

  // Handler zum Löschen einer relevanten Ausbildung
  const handleDeleteRelevantEducation = (index: number) => {
    setRelevantEducations(prev => prev.filter((_, i) => i !== index));
  };

  // Handler zum Löschen einer relevanten Sprache
  const handleDeleteRelevantLanguage = (index: number) => {
    setRelevantLanguages(prev => prev.filter((_, i) => i !== index));
  };

  // Handler zum Hinzufügen eines IT-Skills aus den gespeicherten Daten
  const handleAddItSkillFromStored = (skill: { skill: string; level: string }) => {
    // Prüfe ob der Skill bereits in der relevanten Liste ist
    const isAlreadyInList = relevantItSkills.some(
      relevantSkill => relevantSkill.skill === skill.skill && relevantSkill.level === skill.level
    );
    
    if (!isAlreadyInList) {
      setRelevantItSkills(prev => [{ 
        skill: skill.skill, 
        level: skill.level
      }, ...prev]);
    }
  };

  // Handler zum Hinzufügen einer Zertifizierung aus den gespeicherten Daten
  const handleAddCertificationFromStored = (certification: { name: string; issuer: string; date: string }) => {
    // Prüfe ob die Zertifizierung bereits in der relevanten Liste ist
    const isAlreadyInList = relevantCertifications.some(
      relevantCert => relevantCert.name === certification.name && relevantCert.issuer === certification.issuer
    );
    
    if (!isAlreadyInList) {
      setRelevantCertifications(prev => [{ 
        name: certification.name, 
        issuer: certification.issuer,
        date: certification.date
      }, ...prev]);
    }
  };

  // Handler zum Hinzufügen einer Kernkompetenz aus den gespeicherten Daten
  const handleAddCoreCompetencyFromStored = (competency: { competency: string }) => {
    // Prüfe ob die Kernkompetenz bereits in der relevanten Liste ist
    const isAlreadyInList = relevantCoreCompetencies.some(
      relevantComp => relevantComp.competency === competency.competency
    );
    
    if (!isAlreadyInList) {
      setRelevantCoreCompetencies(prev => [{ competency: competency.competency }, ...prev]);
    }
  };

  // Handler zum Hinzufügen einer Ausbildung aus den gespeicherten Daten
  const handleAddEducationFromStored = (education: { institution: string; degree: string; startDate: string; endDate: string }) => {
    // Prüfe ob die Ausbildung bereits in der relevanten Liste ist
    const isAlreadyInList = relevantEducations.some(
      relevantEdu => relevantEdu.institution === education.institution && relevantEdu.degree === education.degree
    );
    
    if (!isAlreadyInList) {
      setRelevantEducations(prev => [{ 
        institution: education.institution, 
        degree: education.degree,
        startDate: education.startDate,
        endDate: education.endDate
      }, ...prev]);
    }
  };

  // Handler für Profilbild Upload
  const handleProfileImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      // Prüfe Dateigröße (max 10MB)
      if (file.size > 10 * 1024 * 1024) {
        alert('Datei zu groß. Maximale Größe: 10MB');
        return;
      }
      
      // Prüfe Dateityp
      if (!file.type.startsWith('image/')) {
        alert('Bitte wählen Sie eine Bilddatei aus.');
        return;
      }
      
      const reader = new FileReader();
      reader.onload = (e) => {
        setProfileImage(e.target?.result as string);
        markCvDataAsChanged();
      };
      reader.onerror = (error) => {
        console.error('❌ Fehler beim Lesen der Datei:', error);
        alert('Fehler beim Lesen der Datei. Bitte versuchen Sie es erneut.');
      };
      reader.readAsDataURL(file);
    }
  };

  // Handler zum Entfernen des Profilbilds
  const handleRemoveProfileImage = () => {
    setProfileImage(null);
    markCvDataAsChanged();
  };


  // Handler zum Hinzufügen einer Branche aus den gespeicherten Daten
  const handleAddIndustryFromStored = (industry: { industry: string; years: string }) => {
    // Prüfe ob die Branche bereits in der relevanten Liste ist
    const isAlreadyInList = relevantIndustries.some(
      relevantIndustry => relevantIndustry.industry === industry.industry
    );
    
    if (!isAlreadyInList) {
      setRelevantIndustries(prev => [{ 
        industry: industry.industry, 
        years: industry.years
      }, ...prev]);
    }
  };

  // Handler zum Hinzufügen eines Hobbys aus den gespeicherten Daten
  const handleAddHobbyFromStored = (hobby: { hobby: string; description: string }) => {
    const normalizedHobby = normalizeHobbyItem(hobby);
    const hobbyKey = normalizeHobbyValue(normalizedHobby);
    if (!hobbyKey) return;

    // Prüfe ob das Hobby bereits in der relevanten Liste ist
    const isAlreadyInList = relevantHobbies.some(
      relevantHobby => isSameHobbyEntry(relevantHobby, normalizedHobby)
    );
    
    if (!isAlreadyInList) {
      setRelevantHobbies(prev => [{ 
        hobby: normalizedHobby.hobby,
        description: normalizedHobby.description
      }, ...prev]);
    }
  };

  // Handler zum Hinzufügen einer weiteren Information aus den gespeicherten Daten
  const handleAddAdditionalInfoFromStored = (additionalInfo: { info: string; details: string }) => {
    // Prüfe ob die weitere Information bereits in der relevanten Liste ist
    const isAlreadyInList = relevantAdditionalInfo.some(
      relevantInfo => relevantInfo.info === additionalInfo.info && relevantInfo.details === additionalInfo.details
    );
    
    if (!isAlreadyInList) {
      setRelevantAdditionalInfo(prev => [{ info: additionalInfo.info, details: additionalInfo.details }, ...prev]);
    }
  };

  // Handler zum Hinzufügen einer Sprache aus den gespeicherten Daten
  const handleAddLanguageFromStored = (language: { language: string; level: string }) => {
    // Prüfe ob die Sprache bereits in der relevanten Liste ist
    const isAlreadyInList = relevantLanguages.some(
      relevantLang => relevantLang.language === language.language && relevantLang.level === language.level
    );
    
    if (!isAlreadyInList) {
      setRelevantLanguages(prev => [{ 
        language: language.language, 
        level: language.level
      }, ...prev]);
    }
  };

  // Handler zum Editieren einer Arbeitserfahrung (CV-Daten)
  const handleWorkExperienceChange = (idx: number, field: string, value: string) => {
    // Aktualisiere beide Arrays synchron: relevante Arbeitserfahrungen UND optimierte Arbeitserfahrungen
    const updateFunction = (prev: any[]) => prev.map((exp, i) => i === idx ? { ...exp, [field]: value } : exp);
    setRelevantWorkExperiences(updateFunction);
    setOptimizedWorkExperiences(updateFunction);
    markCvDataAsChanged();
  };

  // Handler zum Umsortieren von Berufserfahrungen in der CV-Preview
  const handleWorkExperienceReorder = (originalIndex: number, direction: 'up' | 'down', isNonRelevant: boolean) => {
    setOptimizedWorkExperiences(prev => {
      const newArr = [...prev];
      // Filtere die gleiche Gruppe (relevant oder nicht-relevant) mit Original-Indizes
      const filtered = newArr
        .map((item, idx) => ({ item, idx }))
        .filter(({ item }) => isNonRelevant
          ? (item.relevant === false || item.relevant === 'false')
          : (item.relevant === true || item.relevant === 'true')
        );

      // Finde Position im gefilterten Array
      const currentFilteredIdx = filtered.findIndex(({ idx }) => idx === originalIndex);
      if (currentFilteredIdx === -1) return prev;

      const targetFilteredIdx = direction === 'up' ? currentFilteredIdx - 1 : currentFilteredIdx + 1;
      if (targetFilteredIdx < 0 || targetFilteredIdx >= filtered.length) return prev;

      // Tausche die beiden Elemente im Original-Array
      const fromOriginal = filtered[currentFilteredIdx].idx;
      const toOriginal = filtered[targetFilteredIdx].idx;
      [newArr[fromOriginal], newArr[toOriginal]] = [newArr[toOriginal], newArr[fromOriginal]];
      return newArr;
    });
    markCvDataAsChanged();
  };

  // Handler zum Editieren einer Arbeitserfahrung (nur CV-Daten) - Optimiert mit useCallback
  const handleCvWorkExperienceChange = useCallback((idx: number, field: 'company' | 'position' | 'startDate' | 'endDate' | 'description' | 'industry', value: string) => {
    setDraftWorkExperiences(prev => {
      const newExperiences = [...prev];
      newExperiences[idx] = { ...newExperiences[idx], [field]: value };
      return newExperiences;
    });
    
    markCvDataAsChanged();
  }, []);

  // Synchronisiere relevantWorkExperiences mit optimizedWorkExperiences
  const syncWorkExperiences = (updatedRelevantWorkExperiences: any[]) => {
    const normalizedRelevant = normalizeWorkExperienceRelevanceFlags(updatedRelevantWorkExperiences).map(exp => ({
      ...exp,
      relevant: true
    }));
    setRelevantWorkExperiences(normalizedRelevant);
    setOptimizedWorkExperiences(normalizedRelevant);
  };

  // Handler zum Löschen einer Arbeitserfahrung
  const handleDeleteWorkExperience = (idx: number) => {
    setDraftWorkExperiences(prev => prev.filter((_, i) => i !== idx));
    markCvDataAsChanged();
  };

  const handleNewWorkExperienceChange = useCallback((field: string, value: string) => {
    setNewWorkExperience(prev => ({ ...prev, [field]: value }));
  }, []);
  const handleAddNewWorkExperience = () => {
    if (!newWorkExperience.company && !newWorkExperience.position && !newWorkExperience.startDate && !newWorkExperience.endDate && !newWorkExperience.description) return;
    
    setDraftWorkExperiences(prev => [{ ...newWorkExperience }, ...prev]);
    markCvDataAsChanged();
    
    // Formular zurücksetzen
    setNewWorkExperience({ company: '', position: '', startDate: '', endDate: '', description: '', industry: '' });
    setShowNewWorkExperienceForm(false);
  };

  // Automatisches Speichern der Arbeitserfahrungen bei Änderung
  // Wird jetzt über den verschlüsselten Backend-Endpoint gehandhabt

  const handleAddLanguage = () => {
    setLanguages(prev => [{ language: '', level: '' }, ...prev]);
  };

  const handleDeleteLanguage = (idx: number) => {
    setLanguages(prev => prev.filter((_, i) => i !== idx));
  };

  const handleLanguageTableChange = useCallback((idx: number, field: 'language' | 'level', value: string) => {
    setLanguages(prev => {
      const newLanguages = [...prev];
      newLanguages[idx] = { ...newLanguages[idx], [field]: value };
      return newLanguages;
    });
    markCvDataAsChanged();
  }, []);

  const handleAddCoreCompetency = () => {
    setCoreCompetencies(prev => [{ competency: '' }, ...prev]);
    setHasUnsavedChanges(true);
  };


  const handleDeleteCoreCompetency = (idx: number) => {
    setCoreCompetencies(prev => prev.filter((_, i) => i !== idx));
    setHasUnsavedChanges(true);
  };

  const [optimizingImage, setOptimizingImage] = useState(false);


  const handleAddItSkill = () => {
    setItSkills(prev => [{ skill: '', level: '' }, ...prev]);
  };

  const handleDeleteItSkill = (idx: number) => {
    setItSkills(prev => prev.filter((_, i) => i !== idx));
  };

  const handleItSkillsChange = useCallback((idx: number, field: 'skill' | 'level', value: string) => {
    setItSkills(prev => {
      const newSkills = [...prev];
      newSkills[idx] = { ...newSkills[idx], [field]: value };
      return newSkills;
    });
    markCvDataAsChanged();
  }, []);

  const handleAddHobby = () => {
    setHobbies(prev => [{ hobby: '', description: '' }, ...prev]);
  };

  const handleRemoveHobby = (idx: number) => {
    setHobbies(prev => prev.filter((_, i) => i !== idx));
    setHasUnsavedChanges(true);
  };

  const handleAddAdditionalInfo = () => {
    setAdditionalInfo(prev => [{ info: '', details: '' }, ...prev]);
  };

  const handleDeleteAdditionalInfo = (idx: number) => {
    setAdditionalInfo(prev => prev.filter((_, i) => i !== idx));
    setHasUnsavedChanges(true);
  };

  const handleAdditionalInfoChange = useCallback((idx: number, field: 'info' | 'details', value: string) => {
    setAdditionalInfo(prev => {
      const newInfo = [...prev];
      newInfo[idx] = { ...newInfo[idx], [field]: value };
      return newInfo;
    });
  }, []);

  // Handler für Branchenerfahrungen
  const handleIndustryExperienceChange = useCallback((idx: number, field: 'industry' | 'years', value: string) => {
    setIndustryExperiences(prev => {
      const newExperiences = [...prev];
      newExperiences[idx] = { ...newExperiences[idx], [field]: value };
      return newExperiences;
    });
 // Setze Checkbox auf false bei manuellen Änderungen
    console.log(`📝 Branchenerfahrung ${idx} ${field} geändert:`, value);
  }, []);


  const handleAddIndustryExperience = () => {
    setIndustryExperiences(prev => [{ industry: '', years: '' }, ...prev]);
  };

  const handleDeleteIndustryExperience = (idx: number) => {
    setIndustryExperiences(prev => prev.filter((_, i) => i !== idx));
    setHasUnsavedChanges(true);
  };

  // Funktion zum Prüfen, ob Daten vorhanden sind
  const hasData = () => {
    const hasBasicData = !!(
      fullName ||
      company ||
      address ||
      postalCode ||
      city ||
      country ||
      availableFrom ||
      phoneNumber ||
      email ||
      birthYear ||
      nationality ||
      residencePermit ||
      civilStatus ||
      shortProfile ||
      workExperience ||
      education ||
      certificates ||
      profileImage ||
      signature
    );
    
    const hasArrayData = !!(
      (Array.isArray(workExperiences) && workExperiences.length > 0) ||
      (Array.isArray(educations) && educations.length > 0) ||
      (Array.isArray(certifications) && certifications.length > 0) ||
      (Array.isArray(industryExperiences) && industryExperiences.length > 0) ||
      (Array.isArray(languages) && languages.length > 0) ||
      (Array.isArray(coreCompetencies) && coreCompetencies.length > 0) ||
      (Array.isArray(itSkills) && itSkills.length > 0) ||
      (Array.isArray(hobbies) && hobbies.length > 0) ||
      (Array.isArray(additionalInfo) && additionalInfo.length > 0)
    );
    
    // Prüfe auch ob CVs in der userCvs Liste vorhanden sind
    const hasCvData = !!(userCvs && userCvs.length > 0);
    
    const result = hasBasicData || hasArrayData || hasCvData;
    
    return result;
  };

  // Funktion zum Zurücksetzen der Checkbox wenn CV-Daten geändert werden

  // Mapping-Funktion für AI-extrahierten Nationalität-Text zu Select-Werten
  const mapNationalityToSelectValue = (nationalityText: string): string => {
    if (!nationalityText) return '';
    
    // Bereits gültige Ländercodes oder Select-Werte direkt durchlassen
    const validCodes = new Set([
      'CH', 'DE', 'AT', 'FR', 'IT', 'ES', 'PT', 'NL', 'BE', 'LU',
      'DK', 'SE', 'NO', 'FI', 'IS', 'GB', 'IE', 'PL', 'CZ', 'SK',
      'HU', 'RO', 'BG', 'HR', 'SI', 'RS', 'BA', 'ME', 'MK', 'AL',
      'GR', 'CY', 'MT', 'EE', 'LV', 'LT', 'US', 'CA', 'AU', 'NZ',
      'JP', 'KR', 'CN', 'IN', 'PK', 'BD', 'LK', 'NP', 'BT', 'MV',
      'AF', 'IR', 'IQ', 'SY', 'LB', 'JO', 'IL', 'SA', 'AE', 'QA',
      'KW', 'BH', 'OM', 'YE', 'TR', 'EG', 'LY', 'TN', 'DZ', 'MA',
      'ZA', 'NG', 'KE', 'GH', 'ET', 'TZ', 'UG', 'SN', 'CI', 'CM',
      'BR', 'AR', 'MX', 'CO', 'CL', 'PE', 'VE', 'EC', 'UY', 'PY',
      'BO', 'CR', 'PA', 'CU', 'DO', 'GT', 'HN', 'SV', 'NI',
      'RU', 'UA', 'BY', 'GE', 'AM', 'AZ', 'KZ', 'UZ',
      'TH', 'VN', 'PH', 'ID', 'MY', 'SG', 'MM', 'KH', 'LA',
      'TW', 'HK', 'MN',
      'other'
    ]);
    const upper = nationalityText.trim().toUpperCase();
    if (validCodes.has(upper) || nationalityText.trim() === 'other') {
      return upper === 'OTHER' ? 'other' : upper;
    }
    
    const nationalityMap: { [key: string]: string } = {
      'schweiz': 'CH',
      'schweizer': 'CH',
      'deutschland': 'DE',
      'deutscher': 'DE',
      'deutsche': 'DE',
      'österreich': 'AT',
      'österreicher': 'AT',
      'österreicherin': 'AT',
      'frankreich': 'FR',
      'franzose': 'FR',
      'französin': 'FR',
      'italien': 'IT',
      'italiener': 'IT',
      'italienerin': 'IT',
      'spanien': 'ES',
      'spanier': 'ES',
      'spanierin': 'ES',
      'portugal': 'PT',
      'portugiese': 'PT',
      'portugiesin': 'PT',
      'niederlande': 'NL',
      'niederländer': 'NL',
      'niederländerin': 'NL',
      'belgien': 'BE',
      'belgier': 'BE',
      'belgierin': 'BE',
      'luxemburg': 'LU',
      'luxemburger': 'LU',
      'dänemark': 'DK',
      'däne': 'DK',
      'dänin': 'DK',
      'schweden': 'SE',
      'schwede': 'SE',
      'schwedin': 'SE',
      'norwegen': 'NO',
      'norweger': 'NO',
      'norwegerin': 'NO',
      'finnland': 'FI',
      'finne': 'FI',
      'finnin': 'FI',
      'island': 'IS',
      'isländer': 'IS',
      'isländerin': 'IS',
      'großbritannien': 'GB',
      'brite': 'GB',
      'britin': 'GB',
      'irland': 'IE',
      'ire': 'IE',
      'irin': 'IE',
      'polen': 'PL',
      'pole': 'PL',
      'polin': 'PL',
      'tschechien': 'CZ',
      'tscheche': 'CZ',
      'tschechin': 'CZ',
      'slowakei': 'SK',
      'slowake': 'SK',
      'slowakin': 'SK',
      'ungarn': 'HU',
      'ungar': 'HU',
      'ungarin': 'HU',
      'rumänien': 'RO',
      'rumäne': 'RO',
      'rumänin': 'RO',
      'bulgarien': 'BG',
      'bulgare': 'BG',
      'bulgarin': 'BG',
      'kroatien': 'HR',
      'kroate': 'HR',
      'kroatin': 'HR',
      'slowenien': 'SI',
      'slowene': 'SI',
      'slowenin': 'SI',
      'serbien': 'RS',
      'serbe': 'RS',
      'serbin': 'RS',
      'bosnien-herzegowina': 'BA',
      'bosnier': 'BA',
      'bosnierin': 'BA',
      'montenegro': 'ME',
      'montenegriner': 'ME',
      'montenegrinerin': 'ME',
      'nordmazedonien': 'MK',
      'mazedonier': 'MK',
      'mazedonierin': 'MK',
      'albanien': 'AL',
      'albaner': 'AL',
      'albanerin': 'AL',
      'griechenland': 'GR',
      'grieche': 'GR',
      'griechin': 'GR',
      'zypern': 'CY',
      'zypriot': 'CY',
      'zypriotin': 'CY',
      'malta': 'MT',
      'malteser': 'MT',
      'malteserin': 'MT',
      'estland': 'EE',
      'este': 'EE',
      'estin': 'EE',
      'lettland': 'LV',
      'lette': 'LV',
      'lettin': 'LV',
      'litauen': 'LT',
      'litauer': 'LT',
      'litauerin': 'LT',
      'usa': 'US',
      'amerikaner': 'US',
      'amerikanerin': 'US',
      'kanada': 'CA',
      'kanadier': 'CA',
      'kanadierin': 'CA',
      'australien': 'AU',
      'australier': 'AU',
      'australierin': 'AU',
      'neuseeland': 'NZ',
      'neuseeländer': 'NZ',
      'neuseeländerin': 'NZ',
      'japan': 'JP',
      'japaner': 'JP',
      'japanerin': 'JP',
      'südkorea': 'KR',
      'koreaner': 'KR',
      'koreanerin': 'KR',
      'china': 'CN',
      'chinese': 'CN',
      'chinesin': 'CN',
      'indien': 'IN',
      'inder': 'IN',
      'inderin': 'IN',
      'pakistan': 'PK',
      'pakistani': 'PK',
      'pakistanerin': 'PK',
      'bangladesch': 'BD',
      'bangladescher': 'BD',
      'bangladescherin': 'BD',
      'sri lanka': 'LK',
      'sri lanker': 'LK',
      'sri lankerin': 'LK',
      'nepal': 'NP',
      'nepalese': 'NP',
      'nepalesin': 'NP',
      'bhutan': 'BT',
      'bhutaneser': 'BT',
      'bhutaneserin': 'BT',
      'malediven': 'MV',
      'malediver': 'MV',
      'malediverin': 'MV',
      'afghanistan': 'AF',
      'afghane': 'AF',
      'afghanin': 'AF',
      'iran': 'IR',
      'iraner': 'IR',
      'iranerin': 'IR',
      'irak': 'IQ',
      'iraker': 'IQ',
      'irakerin': 'IQ',
      'kuwait': 'KW',
      'kuwaiter': 'KW',
      'kuwaiterin': 'KW',
      'bahrain': 'BH',
      'bahrainer': 'BH',
      'bahrainerin': 'BH',
      'katar': 'QA',
      'katarer': 'QA',
      'katarerin': 'QA',
      'andere': 'other',
      'anderes': 'other',
      'sonstige': 'other',
      'sonstiges': 'other'
    };
    
    const normalizedText = nationalityText.toLowerCase().trim();
    
    // Direkte Übereinstimmung
    if (nationalityMap[normalizedText]) {
      return nationalityMap[normalizedText];
    }
    
    // Teilübereinstimmung
    for (const [key, value] of Object.entries(nationalityMap)) {
      if (normalizedText.includes(key) || key.includes(normalizedText)) {
        return value;
      }
    }
    
    // Wenn keine Übereinstimmung gefunden wird, gib einen leeren String zurück
    // damit nur gültige Ländercodes angezeigt werden
    return '';
  };

  // Mapping-Funktion für AI-extrahierten Familienstand-Text zu Select-Werten
  const mapCivilStatusToSelectValue = (civilStatusText: string): string => {
    if (!civilStatusText) return '';
    
    const civilStatusMap: { [key: string]: string } = {
      'ledig': 'ledig',
      'single': 'ledig',
      'unverheiratet': 'ledig',
      'verheiratet': 'verheiratet',
      'married': 'verheiratet',
      'ehelich': 'verheiratet',
      'geschieden': 'geschieden',
      'divorced': 'geschieden',
      'getrennt': 'geschieden',
      'verwitwet': 'verwitwet',
      'widowed': 'verwitwet',
      'eingetragene partnerschaft': 'eingetragene-partnerschaft',
      'registered partnership': 'eingetragene-partnerschaft',
      'partnerschaft': 'eingetragene-partnerschaft'
    };
    
    const normalizedText = civilStatusText.toLowerCase().trim();
    
    // Direkte Übereinstimmung
    if (civilStatusMap[normalizedText]) {
      return civilStatusMap[normalizedText];
    }
    
    // Teilübereinstimmung
    for (const [key, value] of Object.entries(civilStatusMap)) {
      if (normalizedText.includes(key) || key.includes(normalizedText)) {
        return value;
      }
    }
    
    // Wenn keine Übereinstimmung gefunden wird, gib den ursprünglichen Text zurück
    return civilStatusText;
  };

  // Schweizer Deutsch: ß durch ss ersetzen wenn Land = CH
  const isSwissCountrySelected = (): boolean => {
    const normalizedCountry = (country || '').trim().toUpperCase();
    return normalizedCountry === 'CH' || normalizedCountry.startsWith('CH -');
  };

  const applySwissGerman = (text: string): string => {
    if (!text || !isSwissCountrySelected()) return text;
    return text.replace(/ß/g, 'ss');
  };

  const applySwissGermanToWorkExperiences = (experiences: any[]): any[] => {
    if (!experiences || !isSwissCountrySelected()) return experiences;
    return experiences.map(exp => ({
      ...exp,
      description: exp.description ? exp.description.replace(/ß/g, 'ss') : exp.description
    }));
  };

  const getWorkExperienceRelevanceScore = (experience: any): number => {
    const raw =
      experience?.relevanzranking ??
      experience?.relevanceRanking ??
      experience?.relevanceScore ??
      experience?.relevant;

    if (typeof raw === 'boolean') {
      return raw ? 100 : 0;
    }

    const parsed = typeof raw === 'string' ? Number(raw.replace(',', '.').trim()) : Number(raw);
    if (!Number.isFinite(parsed)) {
      return -1;
    }

    return Math.max(0, Math.min(100, parsed));
  };

  const normalizeWorkExperienceRelevanceFlags = (experiences: any[]): any[] => {
    if (!Array.isArray(experiences)) {
      return [];
    }

    return experiences.map((exp: any) => ({
      ...exp,
      relevant: exp?.relevant === true || exp?.relevant === 'true'
    }));
  };

  const sortWorkExperiencesByEndDateDesc = (experiences: any[]): any[] => {
    const getEndDateSortValue = (endDate: any): number => {
      if (endDate === null || endDate === undefined) {
        return Number.POSITIVE_INFINITY;
      }

      const normalized = String(endDate).trim().toLowerCase();
      if (!normalized || normalized === 'null') {
        return Number.POSITIVE_INFINITY;
      }

      if (normalized === 'heute' || normalized === 'today' || normalized === 'present' || normalized === 'aktuell') {
        return Number.POSITIVE_INFINITY - 1;
      }

      if (/^\d{4}-\d{2}$/.test(normalized)) {
        const parsed = Date.parse(`${normalized}-01T00:00:00Z`);
        return Number.isFinite(parsed) ? parsed : Number.NEGATIVE_INFINITY;
      }

      if (/^\d{4}$/.test(normalized)) {
        const parsed = Date.parse(`${normalized}-01-01T00:00:00Z`);
        return Number.isFinite(parsed) ? parsed : Number.NEGATIVE_INFINITY;
      }

      const parsed = Date.parse(normalized);
      return Number.isFinite(parsed) ? parsed : Number.NEGATIVE_INFINITY;
    };

    return [...(experiences || [])]
      .map((exp, index) => ({ exp, index }))
      .sort((a, b) => {
        const aValue = getEndDateSortValue(a.exp?.endDate);
        const bValue = getEndDateSortValue(b.exp?.endDate);
        return bValue - aValue || a.index - b.index;
      })
      .map(item => item.exp);
  };

  const sortWorkExperiencesByRelevanceDesc = (experiences: any[]): any[] => {
    return [...(experiences || [])]
      .map((exp, index) => ({ exp, index, score: getWorkExperienceRelevanceScore(exp) }))
      .sort((a, b) => b.score - a.score || a.index - b.index)
      .map(item => item.exp);
  };

  const sortWorkExperiencesForDisplay = (experiences: any[]): any[] => {
    return sortWorkExperienceByRelevance
      ? sortWorkExperiencesByRelevanceDesc(experiences)
      : sortWorkExperiencesByEndDateDesc(experiences);
  };

  const applyTopRelevantWorkExperiences = (experiences: any[], maxRelevant: number = 6): any[] => {
    if (!Array.isArray(experiences)) {
      return [];
    }

    const indexed = experiences.map((exp, index) => ({
      exp,
      index,
      score: getWorkExperienceRelevanceScore(exp)
    }));

    const sortedByScore = [...indexed].sort((a, b) => b.score - a.score || a.index - b.index);
    const keepRelevant = new Set(
      sortedByScore.slice(0, Math.min(maxRelevant, sortedByScore.length)).map(item => item.index)
    );

    const flagged = experiences.map((exp, index) => ({
      ...exp,
      relevant: keepRelevant.has(index)
    }));

    return sortWorkExperiencesForDisplay(normalizeWorkExperienceRelevanceFlags(flagged));
  };

  // Mapping-Funktion für Land-Text zu Select-Werten (Westeuropa)
  const mapCountryToSelectValue = (countryText: string): string => {
    if (!countryText) return '';
    
    const validCodes = new Set([
      'CH', 'DE', 'AT', 'FR', 'IT', 'ES', 'PT', 'NL', 'BE', 'LU',
      'GB', 'IE', 'DK', 'SE', 'NO', 'FI', 'IS', 'other'
    ]);
    const upper = countryText.trim().toUpperCase();
    if (validCodes.has(upper) || countryText.trim() === 'other') {
      return upper === 'OTHER' ? 'other' : upper;
    }
    
    const countryMap: { [key: string]: string } = {
      'schweiz': 'CH', 'switzerland': 'CH', 'suisse': 'CH', 'svizzera': 'CH',
      'deutschland': 'DE', 'germany': 'DE', 'allemagne': 'DE', 'germania': 'DE',
      'österreich': 'AT', 'austria': 'AT', 'autriche': 'AT',
      'frankreich': 'FR', 'france': 'FR', 'francia': 'FR',
      'italien': 'IT', 'italy': 'IT', 'italie': 'IT', 'italia': 'IT',
      'spanien': 'ES', 'spain': 'ES', 'espagne': 'ES', 'españa': 'ES', 'spagna': 'ES',
      'portugal': 'PT',
      'niederlande': 'NL', 'netherlands': 'NL', 'pays-bas': 'NL', 'paesi bassi': 'NL', 'holland': 'NL',
      'belgien': 'BE', 'belgium': 'BE', 'belgique': 'BE', 'belgio': 'BE',
      'luxemburg': 'LU', 'luxembourg': 'LU', 'lussemburgo': 'LU',
      'großbritannien': 'GB', 'grossbritannien': 'GB', 'great britain': 'GB', 'united kingdom': 'GB',
      'uk': 'GB', 'england': 'GB', 'grande-bretagne': 'GB', 'gran bretagna': 'GB',
      'irland': 'IE', 'ireland': 'IE', 'irlande': 'IE', 'irlanda': 'IE',
      'dänemark': 'DK', 'denmark': 'DK', 'danemark': 'DK', 'danimarca': 'DK',
      'schweden': 'SE', 'sweden': 'SE', 'suède': 'SE', 'svezia': 'SE',
      'norwegen': 'NO', 'norway': 'NO', 'norvège': 'NO', 'norvegia': 'NO',
      'finnland': 'FI', 'finland': 'FI', 'finlande': 'FI', 'finlandia': 'FI',
      'island': 'IS', 'iceland': 'IS', 'islande': 'IS', 'islanda': 'IS',
      'andere': 'other', 'anderes': 'other', 'sonstige': 'other'
    };
    
    const normalizedText = countryText.toLowerCase().trim();
    
    if (countryMap[normalizedText]) {
      return countryMap[normalizedText];
    }
    
    for (const [key, value] of Object.entries(countryMap)) {
      if (normalizedText.includes(key) || key.includes(normalizedText)) {
        return value;
      }
    }
    
    return 'other';
  };

  // Mapping-Funktion für Aufenthaltsbewilligung-Text zu Select-Werten
  const mapResidencePermitToSelectValue = (permitText: string): string => {
    if (!permitText) return '';
    const normalizedText = permitText.trim();
    const upperText = normalizedText.toUpperCase();
    
    // Gültige Select-Werte
    const validValues: { [key: string]: string } = {
      'B': 'B', 'C': 'C', 'G': 'G', 'L': 'L', 'F': 'F',
      'CI': 'Ci', 'N': 'N', 'S': 'S',
      'SCHWEIZER': 'Schweizer', 'SCHWEIZERIN': 'Schweizer',
      'EU/EFTA': 'EU/EFTA'
    };
    
    // Direkte Übereinstimmung (z.B. "B", "C", "Schweizer")
    if (validValues[upperText]) return validValues[upperText];
    
    // Teilübereinstimmung (z.B. "Ausweis B", "B-Bewilligung", "Bewilligung C")
    for (const [key, value] of Object.entries(validValues)) {
      if (key.length === 1) {
        // Einbuchstabige Permits: Suche nach "Ausweis X", "X-Ausweis", "Bewilligung X", "Permit X"
        const patterns = [
          `AUSWEIS ${key}`, `${key}-AUSWEIS`, `${key} AUSWEIS`,
          `BEWILLIGUNG ${key}`, `${key}-BEWILLIGUNG`, `${key} BEWILLIGUNG`,
          `PERMIT ${key}`, `${key}-PERMIT`,
          `PERMIS ${key}`, `${key}-PERMIS`
        ];
        if (patterns.some(p => upperText.includes(p))) return value;
      }
    }
    
    // EU/EFTA Varianten
    if (upperText.includes('EU') && upperText.includes('EFTA')) return 'EU/EFTA';
    if (upperText.includes('EU/EFTA')) return 'EU/EFTA';
    
    // Schweizer Varianten
    if (upperText.includes('SCHWEIZER') || upperText.includes('SWISS CITIZEN') || upperText.includes('SUISSE')) return 'Schweizer';
    
    // Wenn keine Übereinstimmung, gib den Originalwert zurück damit gespeicherte Werte nicht verloren gehen
    return permitText;
  };

  // Mapping-Funktion für Sprachlevel-Text zu CEFR Select-Werten
  const mapLanguageLevelToSelectValue = (levelText: string): string => {
    if (!levelText) return '';
    
    const normalizedText = levelText.toLowerCase().trim();
    
    // Direkte CEFR-Codes (bereits korrekt)
    const directMatch: { [key: string]: string } = {
      'a1': 'A1', 'a2': 'A2', 'b1': 'B1', 'b2': 'B2', 'c1': 'C1', 'c2': 'C2', 'native': 'native'
    };
    if (directMatch[normalizedText]) return directMatch[normalizedText];
    
    const levelMap: { [key: string]: string } = {
      // Muttersprache / Native
      'muttersprache': 'native',
      'langue maternelle': 'native',
      'madrelingua': 'native',
      'native': 'native',
      'native speaker': 'native',
      'muttersprachlich': 'native',
      'erstsprache': 'native',
      // C2
      'annähernd muttersprachlich': 'C2',
      'quasi langue maternelle': 'C2',
      'quasi madrelingua': 'C2',
      'near-native': 'C2',
      'near native': 'C2',
      'proficient': 'C2',
      'nahezu muttersprachlich': 'C2',
      // C1
      'fachkundig': 'C1',
      'fachkundige sprachkenntnisse': 'C1',
      'verhandlungssicher': 'C1',
      'fliessend': 'C1',
      'fließend': 'C1',
      'fluent': 'C1',
      'advanced': 'C1',
      'courant': 'C1',
      'compétences spécialisées': 'C1',
      'competenze specialistiche': 'C1',
      'sehr gut': 'C1',
      // B2
      'selbständige sprachverwendung': 'B2',
      'upper intermediate': 'B2',
      'gute kenntnisse': 'B2',
      'gut': 'B2',
      'good': 'B2',
      'bien': 'B2',
      'buono': 'B2',
      'fortgeschritten': 'B2',
      // B1
      'fortgeschrittene sprachverwendung': 'B1',
      'intermediate': 'B1',
      'mittelstufe': 'B1',
      'mittel': 'B1',
      'moyen': 'B1',
      'intermedio': 'B1',
      'befriedigend': 'B1',
      // A2
      'grundlegende kenntnisse': 'A2',
      'elementary': 'A2',
      'grundkenntnisse': 'A2',
      'connaissances de base': 'A2',
      'conoscenze di base': 'A2',
      'basiskenntnisse': 'A2',
      'basis': 'A2',
      // A1
      'anfänger': 'A1',
      'beginner': 'A1',
      'débutant': 'A1',
      'principiante': 'A1',
      'wenig': 'A1',
      'gering': 'A1'
    };
    
    // Direkte Übereinstimmung
    if (levelMap[normalizedText]) return levelMap[normalizedText];
    
    // Teilübereinstimmung
    for (const [key, value] of Object.entries(levelMap)) {
      if (normalizedText.includes(key) || key.includes(normalizedText)) {
        return value;
      }
    }
    
    // Prüfe ob der Text mit einem CEFR-Code beginnt (z.B. "C1 - Fachkundig")
    const ceferMatch = normalizedText.match(/^(a1|a2|b1|b2|c1|c2)\b/);
    if (ceferMatch) return ceferMatch[1].toUpperCase();
    
    // Wenn keine Übereinstimmung, gib leeren String zurück (zeigt Placeholder)
    return '';
  };

  // Mapping-Funktion für IT-Skill-Level-Text zu Select-Werten
  const mapItSkillLevelToSelectValue = (levelText: string): string => {
    if (!levelText) return '';
    const normalizedText = levelText.toLowerCase().trim();
    
    const directMatch: { [key: string]: string } = {
      'beginner': 'beginner', 'intermediate': 'intermediate', 'professional': 'professional', 'expert': 'expert'
    };
    if (directMatch[normalizedText]) return directMatch[normalizedText];
    
    const levelMap: { [key: string]: string } = {
      'anfänger': 'beginner', 'débutant': 'beginner', 'principiante': 'beginner',
      'grundkenntnisse': 'beginner', 'grundlegend': 'beginner', 'basic': 'beginner', 'wenig': 'beginner',
      'basiskenntnisse': 'beginner', 'gering': 'beginner',
      'fortgeschritten': 'intermediate', 'avancé': 'intermediate', 'avanzato': 'intermediate',
      'gute kenntnisse': 'intermediate', 'gut': 'intermediate', 'good': 'intermediate',
      'mittel': 'intermediate', 'moyen': 'intermediate', 'intermedio': 'intermediate',
      'profi': 'professional', 'professionnel': 'professional', 'professionista': 'professional',
      'sehr gute kenntnisse': 'professional', 'sehr gut': 'professional', 'very good': 'professional',
      'vertieft': 'professional', 'umfassend': 'professional',
      'experte': 'expert', 'expert': 'expert', 'esperto': 'expert',
      'hervorragend': 'expert', 'exzellent': 'expert', 'excellent': 'expert',
      'meister': 'expert', 'master': 'expert'
    };
    
    if (levelMap[normalizedText]) return levelMap[normalizedText];
    
    for (const [key, value] of Object.entries(levelMap)) {
      if (normalizedText.includes(key) || key.includes(normalizedText)) return value;
    }
    
    return '';
  };

  type WorkExperienceSaveOverrides = {
    updatedOptimizedWorkExperiences?: any[];
    updatedRelevantWorkExperiences?: any[];
    updatedWorkExperiences?: any[];
  updatedEducations?: any[];
  updatedCertifications?: any[];
    optimizedShortProfileOverride?: string;
  };

  // Temporäre States für modale Fenster - werden erst beim Schließen übernommen
  const [tempOptimizedShortProfile, setTempOptimizedShortProfile] = useState('');
  const [showProfilePromptInput, setShowProfilePromptInput] = useState(false);
  const [profilePromptText, setProfilePromptText] = useState('');
  const [optimizingProfilePrompt, setOptimizingProfilePrompt] = useState(false);
  // History-Stack für Undo/Redo im Profil-Modal
  const [profileHistory, setProfileHistory] = useState<string[]>([]);
  const [profileHistoryIndex, setProfileHistoryIndex] = useState(-1);
  const profileHistoryRef = React.useRef<{ history: string[]; index: number }>({ history: [], index: -1 });
  const isUndoRedoAction = React.useRef(false);
  const [showWorkExperiencePromptInput, setShowWorkExperiencePromptInput] = useState(false);
  const [workExperiencePromptText, setWorkExperiencePromptText] = useState('');
  const [optimizingWorkExperiencePrompt, setOptimizingWorkExperiencePrompt] = useState(false);
  // History-Stack für Undo/Redo im Berufserfahrung-Modal (Beschreibung)
  const [workExpHistory, setWorkExpHistory] = useState<string[]>([]);
  const [workExpHistoryIndex, setWorkExpHistoryIndex] = useState(-1);
  const workExpHistoryRef = React.useRef<{ history: string[]; index: number }>({ history: [], index: -1 });
  const lastCommittedWorkExperienceRef = React.useRef<WorkExperienceSaveOverrides | null>(null);
  const lastCommittedProfileRef = React.useRef<string | null>(null);
  const isWorkExpUndoRedoAction = React.useRef(false);
  
  // Helper: Pusht einen neuen Eintrag auf den Profil-History-Stack
  const pushProfileHistory = useCallback((text: string) => {
    setProfileHistory(prev => {
      const currentIndex = profileHistoryRef.current.index;
      // Schneide alles nach dem aktuellen Index ab (nach Undo eingefügte Änderungen löschen Redo-History)
      const newHistory = [...prev.slice(0, currentIndex + 1), text];
      const newIndex = newHistory.length - 1;
      profileHistoryRef.current = { history: newHistory, index: newIndex };
      setProfileHistoryIndex(newIndex);
      return newHistory;
    });
  }, []);

  // Undo: Einen Schritt zurück in der History
  const handleProfileUndo = useCallback(() => {
    const { history, index } = profileHistoryRef.current;
    if (index > 0) {
      const newIndex = index - 1;
      profileHistoryRef.current.index = newIndex;
      setProfileHistoryIndex(newIndex);
      isUndoRedoAction.current = true;
      setTempOptimizedShortProfile(history[newIndex]);
    }
  }, []);

  // Redo: Einen Schritt vorwärts in der History
  const handleProfileRedo = useCallback(() => {
    const { history, index } = profileHistoryRef.current;
    if (index < history.length - 1) {
      const newIndex = index + 1;
      profileHistoryRef.current.index = newIndex;
      setProfileHistoryIndex(newIndex);
      isUndoRedoAction.current = true;
      setTempOptimizedShortProfile(history[newIndex]);
    }
  }, []);

  // Optimierter Handler für Profil-Text-Änderungen
  const profileDebounceRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);
  const handleProfileTextChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setTempOptimizedShortProfile(newValue);
    // Debounced History-Eintrag für manuelle Eingaben (alle 500ms)
    if (profileDebounceRef.current) {
      clearTimeout(profileDebounceRef.current);
    }
    profileDebounceRef.current = setTimeout(() => {
      if (!isUndoRedoAction.current) {
        pushProfileHistory(newValue);
      }
      isUndoRedoAction.current = false;
    }, 500);
  }, [pushProfileHistory]);

  const toggleProfilePromptInput = useCallback(() => {
    setShowProfilePromptInput(prev => !prev);
  }, []);

  const handleProfilePromptChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setProfilePromptText(e.target.value);
  }, []);

  const toggleWorkExperiencePromptInput = useCallback(() => {
    setShowWorkExperiencePromptInput(prev => !prev);
  }, []);

  const handleWorkExperiencePromptChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setWorkExperiencePromptText(e.target.value);
  }, []);

  // Helper: Pusht einen neuen Eintrag auf den WorkExp-History-Stack
  const pushWorkExpHistory = useCallback((text: string) => {
    setWorkExpHistory(prev => {
      const currentIndex = workExpHistoryRef.current.index;
      const newHistory = [...prev.slice(0, currentIndex + 1), text];
      const newIndex = newHistory.length - 1;
      workExpHistoryRef.current = { history: newHistory, index: newIndex };
      setWorkExpHistoryIndex(newIndex);
      return newHistory;
    });
  }, []);

  // Helper: Aktualisiert die Beschreibung in selectedWorkExperience und den Listen
  const updateWorkExpDescription = useCallback((description: string) => {
    const normalizedDescription = applySwissGerman(description);
    setSelectedWorkExperience(prev => prev ? { ...prev, description: normalizedDescription } : prev);
    const updateList = (list: Array<any>) => list.map(exp => {
      const matchesOriginal = originalWorkExperience &&
        exp.position === originalWorkExperience.position &&
        exp.company === originalWorkExperience.company &&
        exp.startDate === originalWorkExperience.startDate &&
        exp.endDate === originalWorkExperience.endDate;
      const matchesSelected = !originalWorkExperience && selectedWorkExperience &&
        exp.position === selectedWorkExperience.position &&
        exp.company === selectedWorkExperience.company &&
        exp.startDate === selectedWorkExperience.startDate &&
        exp.endDate === selectedWorkExperience.endDate;
      if (matchesOriginal || matchesSelected) {
        return { ...exp, description: normalizedDescription };
      }
      return exp;
    });
    setRelevantWorkExperiences(updateList);
    setOptimizedWorkExperiences(updateList);
  }, [applySwissGerman, originalWorkExperience, selectedWorkExperience]);

  // Undo für Berufserfahrung-Beschreibung
  const handleWorkExpUndo = useCallback(() => {
    const { history, index } = workExpHistoryRef.current;
    if (index > 0) {
      const newIndex = index - 1;
      workExpHistoryRef.current.index = newIndex;
      setWorkExpHistoryIndex(newIndex);
      isWorkExpUndoRedoAction.current = true;
      updateWorkExpDescription(history[newIndex]);
    }
  }, [updateWorkExpDescription]);

  // Redo für Berufserfahrung-Beschreibung
  const handleWorkExpRedo = useCallback(() => {
    const { history, index } = workExpHistoryRef.current;
    if (index < history.length - 1) {
      const newIndex = index + 1;
      workExpHistoryRef.current.index = newIndex;
      setWorkExpHistoryIndex(newIndex);
      isWorkExpUndoRedoAction.current = true;
      updateWorkExpDescription(history[newIndex]);
    }
  }, [updateWorkExpDescription]);

  // Debounced Handler für manuelle Beschreibungs-Änderungen (Work Experience)
  const workExpDebounceRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);
  const handleWorkExpDescriptionChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setSelectedWorkExperience(prev => prev ? { ...prev, description: newValue } : prev);
    // Debounced History-Eintrag für manuelle Eingaben (alle 500ms)
    if (workExpDebounceRef.current) {
      clearTimeout(workExpDebounceRef.current);
    }
    workExpDebounceRef.current = setTimeout(() => {
      if (!isWorkExpUndoRedoAction.current) {
        pushWorkExpHistory(newValue);
      }
      isWorkExpUndoRedoAction.current = false;
    }, 500);
  }, [pushWorkExpHistory]);

  const toggleMotivationPromptInput = useCallback(() => {
    setShowMotivationPromptInput(prev => !prev);
  }, []);

  const handleMotivationPromptChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setMotivationPromptText(e.target.value);
  }, []);

  // Helper: Pusht einen neuen Eintrag auf den Motivation-History-Stack
  const pushMotivationHistory = useCallback((text: string) => {
    setMotivationHistory(prev => {
      const currentIndex = motivationHistoryRef.current.index;
      const newHistory = [...prev.slice(0, currentIndex + 1), text];
      const newIndex = newHistory.length - 1;
      motivationHistoryRef.current = { history: newHistory, index: newIndex };
      setMotivationHistoryIndex(newIndex);
      return newHistory;
    });
  }, []);

  // Undo für Motivationsschreiben
  const handleMotivationUndo = useCallback(() => {
    const { history, index } = motivationHistoryRef.current;
    if (index > 0) {
      const newIndex = index - 1;
      motivationHistoryRef.current.index = newIndex;
      setMotivationHistoryIndex(newIndex);
      isMotivationUndoRedoAction.current = true;
      setGeneratedMotivationText(history[newIndex]);
      setTempMotivationLetter(history[newIndex]);
    }
  }, []);

  // Redo für Motivationsschreiben
  const handleMotivationRedo = useCallback(() => {
    const { history, index } = motivationHistoryRef.current;
    if (index < history.length - 1) {
      const newIndex = index + 1;
      motivationHistoryRef.current.index = newIndex;
      setMotivationHistoryIndex(newIndex);
      isMotivationUndoRedoAction.current = true;
      setGeneratedMotivationText(history[newIndex]);
      setTempMotivationLetter(history[newIndex]);
    }
  }, []);

  // Debounced Handler für manuelle Motivationstext-Änderungen
  const motivationDebounceRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);
  const handleMotivationTextChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setGeneratedMotivationText(newValue);
    setTempMotivationLetter(newValue);
    // Debounced History-Eintrag für manuelle Eingaben (alle 500ms)
    if (motivationDebounceRef.current) {
      clearTimeout(motivationDebounceRef.current);
    }
    motivationDebounceRef.current = setTimeout(() => {
      if (!isMotivationUndoRedoAction.current) {
        pushMotivationHistory(newValue);
      }
      isMotivationUndoRedoAction.current = false;
    }, 500);
  }, [pushMotivationHistory]);
  
  // Optimierte TextField-Komponente entfernt - verursachte Fokus-Probleme

  const commitProfileChanges = useCallback((): WorkExperienceSaveOverrides => {
    const committedProfile = (tempOptimizedShortProfile ?? '').toString();
    setOptimizedShortProfile(committedProfile);
    // Merke letzten bestätigten Profiltext für robustes Persistieren
    // bei schnellem Download direkt nach Modal-Schließen.
    lastCommittedProfileRef.current = committedProfile;
    return { optimizedShortProfileOverride: committedProfile };
  }, [tempOptimizedShortProfile]);

  const commitSelectedWorkExperienceChanges = useCallback((): WorkExperienceSaveOverrides | null => {
    if (!selectedWorkExperience || !originalWorkExperience) {
      return null;
    }

    const updatedWorkExperience = {
      company: selectedWorkExperience.company || '',
      position: selectedWorkExperience.position || '',
      industry: selectedWorkExperience.industry || '',
      startDate: selectedWorkExperience.startDate || '',
      endDate: selectedWorkExperience.endDate || '',
      description: selectedWorkExperience.description || '',
      relevant: selectedWorkExperience.relevant,
      relevanzranking: selectedWorkExperience.relevanzranking ?? originalWorkExperience.relevanzranking,
      relevanceRanking: selectedWorkExperience.relevanceRanking ?? originalWorkExperience.relevanceRanking,
      relevanceScore: selectedWorkExperience.relevanceScore ?? originalWorkExperience.relevanceScore
    };

    const normalizeWorkExpField = (value: any) => (value ?? '').toString().trim();

    const isSameOriginalWorkExperience = (exp: any) =>
      normalizeWorkExpField(exp.position) === normalizeWorkExpField(originalWorkExperience.position) &&
      normalizeWorkExpField(exp.company) === normalizeWorkExpField(originalWorkExperience.company) &&
      normalizeWorkExpField(exp.startDate) === normalizeWorkExpField(originalWorkExperience.startDate) &&
      normalizeWorkExpField(exp.endDate) === normalizeWorkExpField(originalWorkExperience.endDate);

    const updatedOptimizedWorkExperiences = optimizedWorkExperiences.map(exp => (isSameOriginalWorkExperience(exp) ? updatedWorkExperience : exp));
    const updatedRelevantWorkExperiences = relevantWorkExperiences.map(exp => (isSameOriginalWorkExperience(exp) ? updatedWorkExperience : exp));
    const updatedWorkExperiences = workExperiences.map(exp => (isSameOriginalWorkExperience(exp) ? updatedWorkExperience : exp));

    setOptimizedWorkExperiences(updatedOptimizedWorkExperiences);
    setRelevantWorkExperiences(updatedRelevantWorkExperiences);
    setWorkExperiences(updatedWorkExperiences);

    const overrides = { updatedOptimizedWorkExperiences, updatedRelevantWorkExperiences, updatedWorkExperiences };
    lastCommittedWorkExperienceRef.current = overrides;
    return overrides;
  }, [selectedWorkExperience, originalWorkExperience, optimizedWorkExperiences, relevantWorkExperiences, workExperiences]);

  useEffect(() => {
    if (showWorkExperienceModal) {
      // History mit aktuellem Beschreibungstext initialisieren
      const currentDescription = selectedWorkExperience?.description || '';
      const initialHistory = [currentDescription];
      setWorkExpHistory(initialHistory);
      setWorkExpHistoryIndex(0);
      workExpHistoryRef.current = { history: initialHistory, index: 0 };
    } else {
      setShowWorkExperiencePromptInput(false);
      setWorkExperiencePromptText('');
      // History zurücksetzen
      setWorkExpHistory([]);
      setWorkExpHistoryIndex(-1);
      workExpHistoryRef.current = { history: [], index: -1 };
    }
  }, [showWorkExperienceModal]);

  // Funktion zum Initialisieren der temporären Werte beim Öffnen des Profil-Modals
  // Wird jetzt automatisch durch useEffect beim Öffnen des Modals aufgerufen
  const initializeProfileModal = () => {
    // Diese Funktion wird jetzt durch den useEffect ersetzt
    // Behalten für Kompatibilität, aber die eigentliche Initialisierung
    // passiert automatisch beim Öffnen des Modals
  };

  // Wrapper-Funktion für CV-Daten-Änderungen (nur für nicht-modale Felder)
  const handleCvDataChange = useCallback((setter: (value: string) => void, value: string) => {
    setter(value);
    // Markiere als ungespeicherte Änderungen
    markCvDataAsChanged();
    // Änderungen werden über hasUnsavedChanges getrackt
  }, []);

  // Funktion zum Speichern aller CV-Daten nach Firebase
  const saveAllCvDataToFirebase = async (
    overrides?: WorkExperienceSaveOverrides,
    forcedCvId?: string | null
  ): Promise<string | null> => {
    if (!user) return null;
    
    // Sicherheitsprüfung: Verhindere Speicherung wenn fullName leer ist
    if (!fullName || fullName.trim() === '') {
      console.warn('⚠️ Speicherung verhindert: fullName ist leer');
      alert(getTranslatedCvLabel('Speicherung nicht möglich: Vollständiger Name fehlt'));
      return null;
    }
    
    try {
      const idToken = await user.getIdToken();
      let resolvedCvId: string | null = forcedCvId ?? null;
      if (!resolvedCvId) {
        resolvedCvId = resolvePreferredCvIdForPersistence();
      }
      if (!resolvedCvId || (typeof resolvedCvId === 'string' && !resolvedCvId.trim())) {
        console.error('❌ Speichern abgebrochen: Keine gültige cvId verfügbar.');
        setError('CV-Daten konnten nicht gespeichert werden: keine gültige cvId verfügbar.');
        return null;
      }
      const availableCvIds = new Set((userCvs || []).map((cv: any) => cv.cvId).filter(Boolean));
      if (resolvedCvId && availableCvIds.size > 0 && !availableCvIds.has(resolvedCvId)) {
        console.warn('⚠️ Speichern abgebrochen: Ziel-CV existiert nicht mehr oder ist nicht zugreifbar', {
          resolvedCvId
        });
        return null;
      }

      let savedCvId: string | null = resolvedCvId;
      
      // Sammle alle CV-Daten
      const cvData = {
        fullName,
        company,
        address,
        postalCode,
        city,
        country,
        availableFrom,
        phoneNumber,
        email,
        birthYear,
        nationality,
        residencePermit,
        civilStatus,
        shortProfile,
        optimizedShortProfile: overrides?.optimizedShortProfileOverride ?? optimizedShortProfile,
        workExperiences: normalizeWorkExperienceRelevanceFlags(overrides?.updatedWorkExperiences || workExperiences),
        optimizedWorkExperiences: normalizeWorkExperienceRelevanceFlags(overrides?.updatedOptimizedWorkExperiences || optimizedWorkExperiences),
        relevantWorkExperiences: normalizeWorkExperienceRelevanceFlags(overrides?.updatedRelevantWorkExperiences || relevantWorkExperiences),
        educations: overrides?.updatedEducations || educations,
        coreCompetencies,
        relevantCoreCompetencies,
        certifications: overrides?.updatedCertifications || certifications,
        relevantCertifications,
        itSkills,
        relevantItSkills,
        languages,
        hobbies,
        additionalInfo,
        industryExperiences,
        profileImage,
        signature,
        // Sprache wird jetzt separat in der users Collection gespeichert
        // Letzte Änderung - wird bei jedem Speichern aktualisiert
        lastModified: new Date().toISOString()
      };
      
      const response = await fetch(`${config.backend.saveDataUrl}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({
          uid: user.uid,
          data: cvData,
          cvId: resolvedCvId, // Harte ID-Regel: Speicherung nur mit gültiger cvId
          cvName: currentCvName
        })
      });
      
      if (response.ok) {
        const result = await response.json();
        if (result.cvId) {
          savedCvId = result.cvId;
        }
        
        // Wenn ein neues CV erstellt wurde, setze selectedCvId und reset Flag
        if (result.isNewCv && result.cvId) {
          setSelectedCvId(result.cvId);
          setIsManualCvCreation(false); // Flag zurücksetzen - ab jetzt wird das bestehende CV aktualisiert
          await loadAndApplyCvSettingsForCv(result.cvId);
          console.log('✅ Neues CV erstellt, selectedCvId gesetzt:', result.cvId);
        }
        
        // Aktualisiere CV-Liste, damit der neue CV-Name angezeigt wird
        if (user) {
          try {
            const idToken = await user.getIdToken();
            const cvListResponse = await fetch(`${config.backend.baseUrl}/api/get-user-cvs`, {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${idToken}`
              }
            });
            
            if (cvListResponse.ok) {
              const cvListData = await cvListResponse.json();
              setUserCvs(cvListData.userCvs || []);
            }
          } catch (error) {
            // Fehler beim Aktualisieren der Liste ignorieren
          }
        }
        return savedCvId;
      } else {
        const errorText = await response.text();
        console.error('❌ Fehler beim Speichern der CV-Daten:', response.status, errorText);
        return null;
      }
    } catch (error) {
      console.error('❌ Fehler beim Speichern der CV-Daten:', error);
      return null;
    }
  };

  // Spezielle Funktion für das "Vollständiger Name" Feld - Performance-optimiert
  const handleFullNameChange = useCallback((value: string) => {
    // Manuelle Eingabe soll den zuvor optimierten Namen übersteuern
    setOptimizedFullName('');
    setFullName(value);
    setHasUnsavedChanges(true);
    // Checkbox wird nur bei spezifischen Aktionen gesetzt
  }, []);





  // Handler für Prompt-Editor Modal
  const handleClosePromptEditor = () => {
    setPromptEditorOpen(false);
    setEditingPromptIndex(null);
    setEditingPromptText('');
    setEditingPromptVersion('gpt-4o');
    setEditingPromptUsage('Optimierung');
    setEditingPromptTemperature('0.0');
    setEditingPromptMaxTokens('8000');
    setEditingPromptSystemRole('Du bist ein Experte für CV-Optimierung.');
    setEditingPromptName('');
    setOriginalPromptName(''); // Reset auch den ursprünglichen Namen
    setTestResult('');
  };

  // Handler für Prompt im Modal speichern
  const handleSavePromptInModal = async () => {
    console.log('🔧 handleSavePromptInModal aufgerufen');
    console.log('🔧 originalPromptName:', originalPromptName);
    console.log('🔧 editingPromptText:', editingPromptText);
    console.log('🔧 editingPromptName:', editingPromptName);
    
    if (!originalPromptName) {
      console.error('❌ originalPromptName ist nicht gesetzt');
      return;
    }
    
    try {
      if (!user) {
        console.error('❌ Kein User gefunden');
        return;
      }
      
      console.log('🔧 User gefunden:', user.uid);
      
      const idToken = await user.getIdToken();
      console.log('🔧 ID Token erhalten');
      
      // Sichere Identifikation des ursprünglichen Prompts über den ursprünglichen Namen
      const originalPrompt = prompts.find(p => p.type === originalPromptName);
      if (!originalPrompt) {
        console.error('❌ Ursprünglicher Prompt nicht gefunden für Namen:', originalPromptName);
        alert('Fehler: Ursprünglicher Prompt nicht gefunden');
        return;
      }
      
      const nameChanged = editingPromptName !== originalPromptName;
      
      console.log('🔧 Name geändert:', nameChanged);
      console.log('🔧 Original Name:', originalPrompt.type);
      console.log('🔧 Neuer Name:', editingPromptName);
      
      if (nameChanged) {
        // Prompt umbenennen: Altes löschen, neues erstellen
        console.log('🔄 Prompt wird umbenannt...');
        
        // 1. Neuen Prompt erstellen
        const createResponse = await fetch(`${config.backend.baseUrl}/api/prompts`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
          },
          body: JSON.stringify({
            promptType: editingPromptName,
            promptText: editingPromptText,
            chatGptVersion: editingPromptVersion,
            temperature: editingPromptTemperature,
            maxTokens: editingPromptMaxTokens,
            usage: editingPromptUsage
          })
        });
        
        if (createResponse.ok) {
          console.log('✅ Neuer Prompt erstellt');
          
          // 2. Alten Prompt löschen (nur wenn er existiert)
          try {
            const deleteResponse = await fetch(`${config.backend.baseUrl}/api/delete-prompt/${originalPromptName}`, {
              method: 'DELETE',
              headers: {
                'Authorization': `Bearer ${idToken}`,
                'Content-Type': 'application/json'
              }
            });
            
            if (deleteResponse.ok) {
              console.log('✅ Alter Prompt gelöscht');
            } else {
              const errorData = await deleteResponse.json();
              if (errorData.error && errorData.error.includes('existiert nicht')) {
                console.log('⚠️ Alter Prompt existierte nicht, überspringe Löschung');
              } else {
                console.error('❌ Fehler beim Löschen des alten Prompts:', errorData);
                // Trotzdem fortfahren, da der neue Prompt bereits erstellt wurde
              }
            }
          } catch (deleteError) {
            console.error('❌ Fehler beim Löschen des alten Prompts:', deleteError);
            // Trotzdem fortfahren, da der neue Prompt bereits erstellt wurde
          }
          
          // Local state aktualisieren
          setPrompts(prev => prev.map((prompt) => 
            prompt.type === originalPromptName ? { 
              ...prompt, 
              type: editingPromptName,
              text: editingPromptText, 
              chatGptVersion: editingPromptVersion, 
              usage: editingPromptUsage,
              temperature: editingPromptTemperature,
              maxTokens: editingPromptMaxTokens
            } : prompt
          ));
          
          // Prompt-Liste neu laden, damit Änderungen in der Tabelle sichtbar sind
          console.log('🔄 Lade Prompt-Liste neu nach Umbenennung...');
          await loadPromptsFromFirebase();
          console.log('✅ Prompt-Liste nach Umbenennung aktualisiert');
          
          // Modal schließen
          setPromptEditorOpen(false);
          setEditingPromptIndex(null);
          setEditingPromptText('');
          setEditingPromptVersion('gpt-4o');
          setEditingPromptTemperature('0.0');
          setEditingPromptMaxTokens('8000');
          setEditingPromptUsage('Optimierung');
          setEditingPromptSystemRole('Du bist ein Experte für CV-Optimierung.');
          setEditingPromptName('');
          setOriginalPromptName('');
          
          // Prompt erfolgreich umbenannt
        } else {
          const errorData = await createResponse.json();
          console.error('❌ Fehler beim Erstellen des neuen Prompts:', errorData);
          alert(`Fehler beim Erstellen des neuen Prompts: ${errorData.error}`);
        }
      } else {
        // Nur Inhalt aktualisieren (keine Umbenennung)
        console.log('🔄 Prompt-Inhalt wird aktualisiert...');
        
        const requestBody = {
          promptType: originalPromptName, // Verwende den ursprünglichen Namen
          promptText: editingPromptText,
          chatGptVersion: editingPromptVersion,
          usage: editingPromptUsage,
          temperature: editingPromptTemperature,
          maxTokens: editingPromptMaxTokens,
          systemRole: editingPromptSystemRole
        };
        
        console.log('🔧 Request Body:', requestBody);
        console.log('🔧 Backend URL:', `${config.backend.baseUrl}/api/prompts`);
        
        const response = await fetch(`${config.backend.baseUrl}/api/prompts`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
          },
          body: JSON.stringify(requestBody)
        });

        console.log('🔧 Response Status:', response.status);
        console.log('🔧 Response OK:', response.ok);

        if (response.ok) {
          const responseData = await response.json();
          console.log('✅ Prompt gespeichert:', originalPrompt.type, responseData);
          
          // Local state aktualisieren
          console.log('🔧 Aktualisiere Local State...');
          setPrompts(prev => prev.map((prompt) => 
            prompt.type === originalPromptName ? { 
              ...prompt, 
              text: editingPromptText, 
              chatGptVersion: editingPromptVersion, 
              usage: editingPromptUsage,
              temperature: editingPromptTemperature,
              maxTokens: editingPromptMaxTokens
            } : prompt
          ));
          console.log('✅ Local State aktualisiert');
          
          // Prompt-Liste neu laden, damit Änderungen in der Tabelle sichtbar sind
          console.log('🔄 Lade Prompt-Liste neu nach Speichern...');
          await loadPromptsFromFirebase();
          console.log('✅ Prompt-Liste nach Speichern aktualisiert');
          
          // Modal schließen
          setPromptEditorOpen(false);
          setEditingPromptIndex(null);
          setEditingPromptText('');
          setEditingPromptVersion('gpt-4o');
          setEditingPromptTemperature('0.0');
          setEditingPromptMaxTokens('8000');
          setEditingPromptUsage('Optimierung');
          setEditingPromptSystemRole('Du bist ein Experte für CV-Optimierung.');
          setEditingPromptName('');
          setOriginalPromptName('');
          
          // Prompt erfolgreich gespeichert
        } else {
          const errorText = await response.text();
          console.error('❌ Fehler beim Speichern des Prompts:', response.status, errorText);
          alert(`Fehler beim Speichern: ${response.status} - ${errorText}`);
        }
      }
    } catch (error) {
      console.error('❌ Fehler beim Speichern des Prompts:', error);
      const errorMessage = error instanceof Error ? error.message : 'Unbekannter Fehler';
      alert(`Fehler beim Speichern: ${errorMessage}`);
    }
  };

  // Handler für Prompt im Modal zurücksetzen
  const handleResetPromptInModal = () => {
    if (!originalPromptName) return;
    const originalPrompt = prompts.find(p => p.type === originalPromptName);
    if (!originalPrompt) return;
    
    setEditingPromptText(originalPrompt.originalText || originalPrompt.text);
    setEditingPromptVersion(originalPrompt.chatGptVersion || 'gpt-4o');
    setEditingPromptTemperature(originalPrompt.temperature || '0.0');
    setEditingPromptMaxTokens(originalPrompt.maxTokens || '8000');
    setEditingPromptSystemRole(originalPrompt.systemRole || 'Du bist ein Experte für CV-Optimierung.');
    setEditingPromptName(originalPrompt.type);
  };

  // Handler zum Ändern des Prompt-Namens
  const handlePromptNameChange = (newName: string) => {
    setEditingPromptName(newName);
  };

  // Handler zum Aktualisieren der Prompts aus Firebase
  const handleRefreshPrompts = async () => {
    try {
      console.log('🔄 Aktualisiere Prompts aus Firebase...');
      await loadPromptsFromFirebase();
              // Prompts erfolgreich aus Firebase aktualisiert
    } catch (error) {
      console.error('❌ Fehler beim Aktualisieren der Prompts:', error);
      alert('Fehler beim Aktualisieren der Prompts');
    }
  };

  // Handler zum Löschen eines Prompts
  const handleDeletePrompt = async () => {
    if (!originalPromptName || !user) return;
    
    // Verwende den ursprünglichen Namen für die Löschung
    const promptToDelete = prompts.find(p => p.type === originalPromptName);
    if (!promptToDelete) {
      console.error('❌ Prompt zum Löschen nicht gefunden');
      return;
    }
    
    const confirmed = window.confirm(`Möchten Sie den Prompt "${promptToDelete.type}" wirklich löschen?`);
    
    if (!confirmed) return;
    
    try {
      const idToken = await user.getIdToken();
      const response = await fetch(`${config.backend.baseUrl}/api/delete-prompt/${promptToDelete.type}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${idToken}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        console.log('✅ Prompt erfolgreich gelöscht:', promptToDelete.type);
        
        // Entferne den Prompt aus der lokalen Liste
        setPrompts(prev => prev.filter(prompt => prompt.type !== originalPromptName));
        
        // Schließe das Modal
        setEditingPromptIndex(null);
        setEditingPromptText('');
        setEditingPromptVersion('gpt-4o');
        setEditingPromptTemperature('0.0');
        setEditingPromptMaxTokens('8000');
        setEditingPromptUsage('Optimierung');
        setEditingPromptSystemRole('Du bist ein Experte für CV-Optimierung.');
        setEditingPromptName('');
        setOriginalPromptName(''); // Reset auch den ursprünglichen Namen
        setPromptEditorOpen(false);
        
        // Zeige Erfolgsmeldung
        // Prompt erfolgreich gelöscht
      } else {
        const errorData = await response.json();
        console.error('❌ Fehler beim Löschen des Prompts:', errorData);
        alert(`Fehler beim Löschen: ${errorData.error}`);
      }
    } catch (error) {
      console.error('❌ Fehler beim Löschen des Prompts:', error);
      alert('Fehler beim Löschen des Prompts');
    }
  };

  // Handler für expandierte Test-Bereiche


    // Handler für Zertifizierungen
  const handleCertificationOptimization = async (promptText: string, promptVersion: string, temperature: string, maxTokens: string) => {
    console.log('🏆 Starte Zertifizierungs-Optimierung...');
    
    try {
      setError(null);
      setOptimizing(true);
      
      // Prüfe ob User-Daten vorhanden sind
      if (!user) {
        setError('Benutzer nicht angemeldet.');
        setOptimizing(false);
        return;
      }

      // Für Zertifizierungs-Optimierung: Bereite nur Zertifizierungs-spezifische Daten vor
      const certificationData = {
        certifications: certifications || []
      };

      // Erstelle Zertifizierungs-spezifischen Text
      let certificationText = '';
      if (certifications && certifications.length > 0) {
        certificationText = certifications.map(cert => {
          const name = cert.name || 'Kein Name';
          const issuer = cert.issuer || 'Kein Aussteller';
          const date = cert.date || 'Kein Datum';
          const description = cert.description ? ` - ${cert.description}` : '';
          return `${name}${description} - ${issuer} (${date})`;
        }).join('\n');
      } else {
        certificationText = 'Keine Zertifizierungen im CV gefunden';
      }

      console.log('🏆 Zertifizierungs-Daten für Backend:', certificationData);
      console.log('🏆 Zertifizierungs-Text für Backend:', certificationText);

      // Hole ID Token für Backend-Authentifizierung
      const idToken = await user.getIdToken();

      // Sende Request an Backend für Zertifizierungs-Optimierung
      const data = await requestOptimizeCvWithQueue({
        cvData: certificationData, // Nur Zertifizierungs-Daten
        cvText: certificationText, // Nur Zertifizierungs-Text
        jobDescription: jobDescription,
        optimizeType: 'certifications',
        targetLanguage: targetLanguage,
        // Test-spezifische Parameter
        testPrompt: promptText,
        chatGptVersion: promptVersion,
        temperature: temperature,
        maxTokens: maxTokens
      }, idToken, true);
      
      // Backend-Antwort für Zertifizierungen verarbeitet
      
      // Setze die relevanten Zertifizierungen
      if (data.relevantCertifications) {
        let certificationArray;
        
        // Prüfe ob relevantCertifications ein String ist (JSON) oder bereits ein Array
        if (typeof data.relevantCertifications === 'string') {
          try {
            // Entferne Markdown-Code-Block-Formatierung falls vorhanden
            let cleanJsonString = data.relevantCertifications;
            if (cleanJsonString.includes('```json')) {
              cleanJsonString = cleanJsonString.replace(/```json\n?/g, '').replace(/```\n?/g, '');
              console.log('🔧 Markdown-Code-Block entfernt, bereinigter String:', cleanJsonString);
            }
            
            // Parse den bereinigten JSON-String zu einem Array
            certificationArray = JSON.parse(cleanJsonString);
            console.log('✅ JSON-String erfolgreich geparst zu Array:', certificationArray);
          } catch (parseError) {
            console.error('❌ Fehler beim Parsen des JSON-Strings:', parseError);
            setTestResult('Fehler beim Parsen der Zertifizierungs-Daten');
            return;
          }
        } else if (Array.isArray(data.relevantCertifications)) {
          // relevantCertifications ist bereits ein Array
          certificationArray = data.relevantCertifications;
          console.log('✅ relevantCertifications ist bereits ein Array:', certificationArray);
        } else {
          console.log('⚠️ relevantCertifications ist weder String noch Array:', typeof data.relevantCertifications);
          setTestResult('Unerwartetes Datenformat für Zertifizierungen');
          return;
        }
        
        // Prüfe ob das geparste Array gültig ist
        if (certificationArray && Array.isArray(certificationArray) && certificationArray.length > 0) {
          // Setze die Zertifizierungen im lokalen State
          setRelevantCertifications(certificationArray);
          console.log('✅ Relevante Zertifizierungen gesetzt:', certificationArray.length, 'Zertifizierungen');
          
          // Zeige nur die relevanten Zertifizierungen im Test-Modal an
          setTestResult(JSON.stringify(certificationArray, null, 2));
        } else {
          console.log('⚠️ Geparste Zertifizierungen sind leer oder ungültig:', certificationArray);
          setTestResult('Keine Zertifizierungen gefunden');
        }
      } else {
        // Keine relevantCertifications vorhanden
        console.log('⚠️ Keine relevantCertifications in der Backend-Antwort gefunden');
        setTestResult('Keine Zertifizierungen gefunden');
      }
      
      console.log('✅ Zertifizierungs-Optimierung erfolgreich abgeschlossen');
      
    } catch (err: any) {
      setError(t('error.optimize.cv.unknown') + (err.message || ''));
    } finally {
      setOptimizing(false);
    }
  };

  // Handler für Ausbildungen
  const handleEducationOptimization = async (promptText: string, promptVersion: string, temperature: string, maxTokens: string) => {
    console.log('🎓 Starte Ausbildungs-Optimierung...');
    
    try {
      setError(null);
      setOptimizing(true);
      
      // Prüfe ob User-Daten vorhanden sind
      if (!user) {
        setError('Benutzer nicht angemeldet.');
        setOptimizing(false);
        return;
      }

      // Für Ausbildungs-Optimierung: Bereite nur Ausbildungs-spezifische Daten vor
      const educationData = {
        education: educations || []
      };

      // Erstelle Ausbildungs-spezifischen Text
      let educationText = '';
      if (educations && educations.length > 0) {
        educationText = educations.map(edu => 
          (() => {
            const degree = edu.degree || 'Kein Abschluss';
            const institution = edu.institution || 'Keine Institution';
            const startDate = edu.startDate || 'Kein Start';
            const endDate = edu.endDate || 'Kein Ende';
            const description = edu.description ? ` - ${edu.description}` : '';
            return `${degree}${description} an ${institution} (${startDate} - ${endDate})`;
          })()
        ).join('\n');
      } else {
        educationText = 'Keine Ausbildungen im CV gefunden';
      }

      console.log('🎓 Ausbildungs-Daten für Backend:', educationData);
      console.log('🎓 Ausbildungs-Text für Backend:', educationText);

      // Hole ID Token für Backend-Authentifizierung
      const idToken = await user.getIdToken();

      // Sende Request an Backend für Ausbildungs-Optimierung
      const data = await requestOptimizeCvWithQueue({
        cvData: educationData, // Nur Ausbildungs-Daten
        cvText: educationText, // Nur Ausbildungs-Text
        jobDescription: jobDescription,
        optimizeType: 'education',
        targetLanguage: targetLanguage,
        // Test-spezifische Parameter
        testPrompt: promptText,
        chatGptVersion: promptVersion,
        temperature: temperature,
        maxTokens: maxTokens
      }, idToken, true);
      
      // Backend-Antwort für Ausbildungen verarbeitet
      
      // Setze die relevanten Ausbildungen
      if (data.relevantEducations) {
        let educationArray;
        
        // Prüfe ob relevantEducations ein String ist (JSON) oder bereits ein Array
        if (typeof data.relevantEducations === 'string') {
          try {
            // Entferne Markdown-Code-Block-Formatierung falls vorhanden
            let cleanJsonString = data.relevantEducations;
            if (cleanJsonString.includes('```json')) {
              cleanJsonString = cleanJsonString.replace(/```json\n?/g, '').replace(/```\n?/g, '');
              console.log('🔧 Markdown-Code-Block entfernt, bereinigter String:', cleanJsonString);
            }
            
            // Parse den bereinigten JSON-String zu einem Array
            educationArray = JSON.parse(cleanJsonString);
            console.log('✅ JSON-String erfolgreich geparst zu Array:', educationArray);
          } catch (parseError) {
            console.error('❌ Fehler beim Parsen des JSON-Strings:', parseError);
            setTestResult('Fehler beim Parsen der Ausbildungs-Daten');
            return;
          }
        } else if (Array.isArray(data.relevantEducations)) {
          // relevantEducations ist bereits ein Array
          educationArray = data.relevantEducations;
          console.log('✅ relevantEducations ist bereits ein Array:', educationArray);
        } else {
          console.log('⚠️ relevantEducations ist weder String noch Array:', typeof data.relevantEducations);
          setTestResult('Unerwartetes Datenformat für Ausbildungen');
          return;
        }
        
        // Prüfe ob das geparste Array gültig ist
        if (educationArray && Array.isArray(educationArray) && educationArray.length > 0) {
          // Setze die Ausbildungen im lokalen State
          setRelevantEducations(educationArray);
          console.log('✅ Relevante Ausbildungen gesetzt:', educationArray.length, 'Ausbildungen');
          
          // Zeige nur die relevanten Ausbildungen im Test-Modal an
          setTestResult(JSON.stringify(educationArray, null, 2));
        } else {
          console.log('⚠️ Geparste Ausbildungen sind leer oder ungültig:', educationArray);
          setTestResult('Keine Ausbildungen gefunden');
        }
      } else {
        // Keine relevantEducations vorhanden
        console.log('⚠️ Keine relevantEducations in der Backend-Antwort gefunden');
        setTestResult('Keine Ausbildungen gefunden');
      }
      
      console.log('✅ Ausbildungs-Optimierung erfolgreich abgeschlossen');
      
    } catch (err: any) {
      setError(t('error.optimize.cv.unknown') + (err.message || ''));
    } finally {
      setOptimizing(false);
    }
  };

  // Handler für Arbeitserfahrungen
  const handleWorkExperienceOptimization = async (promptText: string, promptVersion: string, temperature: string, maxTokens: string) => {
    console.log('💼 Starte Arbeitserfahrungs-Optimierung...');
    
    try {
      setError(null);
      setOptimizing(true);
      
      // Prüfe ob User-Daten vorhanden sind
      if (!user) {
        setError('Benutzer nicht angemeldet.');
        setOptimizing(false);
        return;
      }

      // Für Arbeitserfahrungs-Optimierung: Bereite nur Arbeitserfahrungs-spezifische Daten vor
      const workExperienceData = {
        workExperience: workExperiences || []
      };

      // Erstelle Arbeitserfahrungs-spezifischen Text
      let workExperienceText = '';
      if (workExperiences && workExperiences.length > 0) {
        workExperienceText = workExperiences.map(exp => 
          `${exp.position || 'Keine Position'} bei ${exp.company || 'Keine Firma'} (${exp.startDate || 'Kein Start'} - ${exp.endDate || 'Kein Ende'})\n${exp.description || 'Keine Beschreibung'}`
        ).join('\n\n');
      } else {
        workExperienceText = 'Keine Arbeitserfahrungen im CV gefunden';
      }

      console.log('💼 Arbeitserfahrungs-Daten für Backend:', workExperienceData);
      console.log('💼 Arbeitserfahrungs-Text für Backend:', workExperienceText);

      // Hole ID Token für Backend-Authentifizierung
      const idToken = await user.getIdToken();

      // Sende Request an Backend für Arbeitserfahrungs-Optimierung
      const data = await requestOptimizeCvWithQueue(
        buildWorkExperienceOptimizePayload(
          workExperienceData, // Nur Arbeitserfahrungs-Daten
          workExperienceText, // Nur Arbeitserfahrungs-Text
          jobDescription,
          {
            // Test-spezifische Parameter (beide Namenskonventionen für Kompatibilität)
            testPrompt: promptText,
            promptText: promptText,
            chatGptVersion: promptVersion,
            promptVersion: promptVersion,
            temperature: temperature,
            maxTokens: maxTokens
          }
        ),
        idToken,
        true
      );
      
      // Backend-Antwort für Arbeitserfahrungen verarbeitet
      // relevantWorkExperience verarbeitet
      
      // Setze die relevanten Arbeitserfahrungen
      if (data.relevantWorkExperience) {
        let workExperienceArray;
        
        // Prüfe ob relevantWorkExperience ein String ist (JSON) oder bereits ein Array
        if (typeof data.relevantWorkExperience === 'string') {
          try {
            // Entferne Markdown-Code-Block-Formatierung falls vorhanden
            let cleanJsonString = data.relevantWorkExperience;
            if (cleanJsonString.includes('```json')) {
              cleanJsonString = cleanJsonString.replace(/```json\n?/g, '').replace(/```\n?/g, '');
              console.log('🔧 Markdown-Code-Block entfernt, bereinigter String:', cleanJsonString);
            }
            
            // Parse den bereinigten JSON-String zu einem Array
            workExperienceArray = JSON.parse(cleanJsonString);
            console.log('✅ JSON-String erfolgreich geparst zu Array:', workExperienceArray);
          } catch (parseError) {
            console.error('❌ Fehler beim Parsen des JSON-Strings:', parseError);
            setTestResult('Fehler beim Parsen der Arbeitserfahrungs-Daten');
            return;
          }
        } else if (Array.isArray(data.relevantWorkExperience)) {
          // relevantWorkExperience ist bereits ein Array
          workExperienceArray = data.relevantWorkExperience;
          console.log('✅ relevantWorkExperience ist bereits ein Array:', workExperienceArray);
        } else {
          console.log('⚠️ relevantWorkExperience ist weder String noch Array:', typeof data.relevantWorkExperience);
          setTestResult('Unerwartetes Datenformat für Arbeitserfahrungen');
          return;
        }
        
        // Prüfe ob das geparste Array gültig ist
        if (workExperienceArray && Array.isArray(workExperienceArray) && workExperienceArray.length > 0) {
          // Setze die Arbeitserfahrungen im lokalen State
          setRelevantWorkExperiences(workExperienceArray);
          console.log('✅ Relevante Arbeitserfahrungen gesetzt:', workExperienceArray.length, 'Erfahrungen');
          
          // Zeige nur die relevanten Arbeitserfahrungen im Test-Modal an
          setTestResult(JSON.stringify(workExperienceArray, null, 2));
        } else {
          console.log('⚠️ Geparste Arbeitserfahrungen sind leer oder ungültig:', workExperienceArray);
          setTestResult('Keine Arbeitserfahrungen gefunden');
        }
      } else {
        // Keine relevantWorkExperience vorhanden
        console.log('⚠️ Keine relevantWorkExperience in der Backend-Antwort gefunden');
        setTestResult('Keine Arbeitserfahrungen gefunden');
      }
      
      console.log('✅ Arbeitserfahrungs-Optimierung erfolgreich abgeschlossen');
      
    } catch (err: any) {
      setError(t('error.optimize.cv.unknown') + (err.message || ''));
    } finally {
      setOptimizing(false);
    }
  };

  // Handler für Kurzprofil
  const handleShortProfileOptimization = async (
    promptText: string,
    promptVersion: string,
    temperature: string,
    maxTokens: string,
    options?: {
      customPrompt?: string;
      profileTextOverride?: string;
      suppressOptimizingState?: boolean;
      skipGlobalShortProfileUpdate?: boolean;
    }
  ) => {
    console.log('👤 Starte Kurzprofil-Optimierung (minimaler Payload)...');
    
    const handleFinish = () => {
      if (!options?.suppressOptimizingState) {
        setOptimizing(false);
      }
    };

    try {
      setError(null);
      if (!options?.suppressOptimizingState) {
        setOptimizing(true);
      }
      
      if (!user) {
        setError('Benutzer nicht angemeldet.');
        handleFinish();
        return;
      }

      const profileTextForOptimization = (options?.profileTextOverride ?? tempOptimizedShortProfile ?? optimizedShortProfile ?? shortProfile ?? '').trim();

      if (!profileTextForOptimization) {
        setError('Profil-Text ist erforderlich.');
        handleFinish();
        return;
      }

      const idToken = await user.getIdToken();

      const requestPayload: Record<string, any> = {
        cvData: {
          personalInfo: {
            shortProfile: profileTextForOptimization
          }
        },
        cvText: profileTextForOptimization,
        jobDescription: jobDescription || '',
        optimizeType: 'shortProfile',
        targetLanguage: targetLanguage,
        tonalitySettings: getEffectiveTextSettings().tonalitySettings,
        manualProfileText: profileTextForOptimization,
        chatGptVersion: SHORT_PROFILE_PROMPT_VERSION,
        maxTokens: SHORT_PROFILE_PROMPT_MAX_TOKENS,
        temperature: SHORT_PROFILE_PROMPT_TEMPERATURE,
        systemRole: SHORT_PROFILE_PROMPT_ROLE
      };

      const effectiveCustomPrompt = options?.customPrompt?.trim() || promptText?.trim();
      if (effectiveCustomPrompt) {
        requestPayload.customProfilePrompt = effectiveCustomPrompt;
        requestPayload.promptText = effectiveCustomPrompt;
        requestPayload.testPrompt = effectiveCustomPrompt;
      }

      const data = await requestOptimizeCvWithQueue(requestPayload, idToken, true);
      
      if (data.optimizedShortProfile) {
        const profileText = applySwissGerman(data.optimizedShortProfile);
        if (!options?.skipGlobalShortProfileUpdate) {
          setOptimizedShortProfile(profileText);
        }
        if (options?.profileTextOverride !== undefined || showProfileModal) {
          pushProfileHistory(profileText);
          setTempOptimizedShortProfile(profileText);
        }
        if (options?.customPrompt) {
          setProfilePromptText('');
        }
        setTestResult(profileText);
        console.log('✅ Optimiertes Kurzprofil erhalten (minimaler Payload).');
        return profileText;
      }
      
      console.log('❌ Kein optimiertes Kurzprofil in Response');
      setTestResult('Kein optimiertes Kurzprofil gefunden');
    } catch (err: any) {
      setError(t('error.optimize.cv.unknown') + (err.message || ''));
    } finally {
      handleFinish();
    }
    
    return undefined;
  };

  const handleProfilePromptOptimization = async () => {
    const trimmedPrompt = profilePromptText.trim();
    if (!trimmedPrompt || optimizingProfilePrompt) return;

    const profileTextOverride = (tempOptimizedShortProfile ?? optimizedShortProfile ?? shortProfile ?? '').trim();
    if (!profileTextOverride) {
      setError('Profil-Text ist erforderlich.');
      return;
    }

    try {
      if (!user) {
        setError('Benutzer nicht angemeldet.');
        return;
      }

      setOptimizingProfilePrompt(true);
      const idToken = await user.getIdToken();
      const response = await fetch(config.backend.customShortProfileUrl || `${config.backend.baseUrl}/api/custom-short-profile`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({
          profileText: profileTextOverride,
          customProfilePrompt: `${trimmedPrompt}\n\nGib nur den optimierten Text zurück.`,
          targetLanguage
        })
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || 'Kurzprofil konnte nicht optimiert werden.');
      }

      if (data.optimizedShortProfile) {
        const profileText = applySwissGerman(data.optimizedShortProfile);
        pushProfileHistory(profileText);
        setOptimizedShortProfile(profileText);
        setTempOptimizedShortProfile(profileText);
        setProfilePromptText('');
        setTestResult(profileText);
        return;
      }

      console.warn('⚠️ Kein optimiertes Kurzprofil vom Custom-Endpoint, fallback auf Standard-Optimierung');
      await handleShortProfileOptimization('', '', '', '', {
        customPrompt: trimmedPrompt,
        profileTextOverride,
        suppressOptimizingState: true,
        skipGlobalShortProfileUpdate: false,
      });
    } catch (error) {
      console.error('Prompt-basierte Kurzprofil-Optimierung fehlgeschlagen:', error);
      setError(t('error.optimize.cv.unknown') + (error instanceof Error ? error.message : ''));
    } finally {
      setOptimizingProfilePrompt(false);
    }
  };

  const handleMotivationPromptOptimization = async () => {
    console.log('🎯 handleMotivationPromptOptimization aufgerufen');
    const trimmedPrompt = motivationPromptText.trim();
    console.log('📝 Prompt:', { trimmedPrompt, hasPrompt: !!trimmedPrompt, optimizingMotivationPrompt });
    if (!trimmedPrompt || optimizingMotivationPrompt) {
      console.log('❌ Frühe Rückkehr: kein Prompt oder bereits optimierend');
      return;
    }

    const motivationTextOverride = (generatedMotivationText || tempMotivationLetter || '').trim();
    console.log('📄 Motivation Text:', { 
      hasGeneratedText: !!generatedMotivationText, 
      hasTempLetter: !!tempMotivationLetter,
      motivationTextOverride: motivationTextOverride.substring(0, 50) 
    });
    if (!motivationTextOverride) {
      console.log('❌ Frühe Rückkehr: kein Motivation-Text');
      setError('Motivationsschreiben-Text ist erforderlich.');
      return;
    }

    if (!user) {
      console.log('❌ Frühe Rückkehr: kein Benutzer');
      setError('Benutzer nicht angemeldet.');
      return;
    }

    if (!jobDescription.trim()) {
      console.log('❌ Frühe Rückkehr: keine Stellenbeschreibung');
      setError('Stellenbeschreibung ist erforderlich.');
      return;
    }

    try {
      console.log('🚀 Starte Motivationsschreiben-Optimierung über Zauberstab...');
      setOptimizingMotivationPrompt(true);
      const idToken = await user.getIdToken();
      
      const requestBody = {
        profileText: motivationTextOverride,
        customProfilePrompt: `${trimmedPrompt}\n\nGib nur den optimierten Text zurück.`,
        targetLanguage: targetLanguage
      };
      
      console.log('📤 Sende Request an /api/custom-short-profile:', { 
        profileText: motivationTextOverride ? motivationTextOverride.substring(0, 100) : 'LEER',
        profileTextLength: motivationTextOverride?.length || 0,
        customProfilePrompt: requestBody.customProfilePrompt.substring(0, 100),
        targetLanguage: targetLanguage
      });
      
      const response = await fetch(config.backend.customShortProfileUrl || `${config.backend.baseUrl}/api/custom-short-profile`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || 'Motivationsschreiben konnte nicht optimiert werden.');
      }

      if (data.optimizedShortProfile) {
        console.log('✅ Motivationsschreiben über Zauberstab optimiert');
        pushMotivationHistory(data.optimizedShortProfile);
        setGeneratedMotivationText(data.optimizedShortProfile);
        setTempMotivationLetter(data.optimizedShortProfile);
        setMotivationPromptText('');
      } else {
        console.warn('⚠️ Kein optimiertes Motivationsschreiben in Response:', data);
        setError('Kein optimiertes Motivationsschreiben vom Backend erhalten.');
      }
    } catch (error: any) {
      console.error('Fehler beim Optimieren des Motivationsschreibens:', error);
      setError(error.message || 'Fehler beim Optimieren des Motivationsschreibens');
    } finally {
      setOptimizingMotivationPrompt(false);
    }
  };

  const handleWorkExperiencePromptOptimization = async () => {
    const trimmedPrompt = workExperiencePromptText.trim();
    if (!trimmedPrompt || optimizingWorkExperiencePrompt) return;

    if (!selectedWorkExperience) {
      setError('Keine Berufserfahrung ausgewählt.');
      return;
    }

    const descriptionText = (selectedWorkExperience.description || '').trim();
    if (!descriptionText) {
      setError('Beschreibung ist erforderlich.');
      return;
    }

    if (!user) {
      setError('Benutzer nicht angemeldet.');
      return;
    }

    try {
      setOptimizingWorkExperiencePrompt(true);
      const idToken = await user.getIdToken();
      const response = await fetch(config.backend.customShortProfileUrl || `${config.backend.baseUrl}/api/custom-short-profile`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({
          profileText: descriptionText,
          customProfilePrompt: `${trimmedPrompt}\n\nGib nur den optimierten Text zurück.`,
          targetLanguage
        })
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || 'Beschreibung konnte nicht optimiert werden.');
      }

      if (data.optimizedShortProfile) {
        const updatedDescription = applySwissGerman(data.optimizedShortProfile);
        pushWorkExpHistory(updatedDescription);
        updateWorkExpDescription(updatedDescription);
        setWorkExperiencePromptText('');
        setTestResult(updatedDescription);
      } else {
        setTestResult('Keine optimierte Beschreibung vom Backend erhalten.');
      }
    } catch (error) {
      console.error('Prompt-basierte Beschreibung-Optimierung fehlgeschlagen:', error);
      setError(t('error.optimize.cv.unknown') + (error instanceof Error ? error.message : ''));
    } finally {
      setOptimizingWorkExperiencePrompt(false);
    }
  };

  // Handler für Branchen
  const handleIndustryOptimization = async (promptText: string, promptVersion: string, temperature: string, maxTokens: string) => {
    console.log('🏢 Starte Branchen-Optimierung...');
    
    try {
      setError(null);
      setOptimizing(true);
      
      // Prüfe ob User-Daten vorhanden sind
      if (!user) {
        setError('Benutzer nicht angemeldet.');
        setOptimizing(false);
        return;
      }

      // Für Branchen-Optimierung: Bereite nur Branchen-spezifische Daten vor
      const industryData = {
        industryExperiences: industryExperiences || []
      };

      // Erstelle Branchen-spezifischen Text
      let industryText = '';
      if (industryExperiences && industryExperiences.length > 0) {
        industryText = industryExperiences.map(exp => 
          `${exp.industry || 'Keine Branche'} (${exp.years || 'Keine Jahre'} Jahre)`
        ).join('\n');
      } else {
        industryText = 'Keine Branchen-Erfahrungen im CV gefunden';
      }

      console.log('🏢 Branchen-Daten für Backend:', industryData);
      console.log('🏢 Branchen-Text für Backend:', industryText);

      // Hole ID Token für Backend-Authentifizierung
      const idToken = await user.getIdToken();

      // Sende Request an Backend für Branchen-Optimierung
      const data = await requestOptimizeCvWithQueue({
        cvData: industryData, // Nur Branchen-Daten
        cvText: industryText, // Nur Branchen-Text
        jobDescription: jobDescription,
        optimizeType: 'industry',
        targetLanguage: targetLanguage,
        // Test-spezifische Parameter
        testPrompt: promptText,
        chatGptVersion: promptVersion,
        temperature: temperature,
        maxTokens: maxTokens
      }, idToken, true);
      
      // Backend-Antwort für Branchen verarbeitet
      
      // Setze die relevanten Branchen
      if (data.relevantIndustries) {
        let industryArray;
        
        // Prüfe ob relevantIndustries ein String ist (JSON) oder bereits ein Array
        if (typeof data.relevantIndustries === 'string') {
          try {
            // Entferne Markdown-Code-Block-Formatierung falls vorhanden
            let cleanJsonString = data.relevantIndustries;
            if (cleanJsonString.includes('```json')) {
              cleanJsonString = cleanJsonString.replace(/```json\n?/g, '').replace(/```\n?/g, '');
              console.log('🔧 Markdown-Code-Block entfernt, bereinigter String:', cleanJsonString);
            }
            
            // Parse den bereinigten JSON-String zu einem Array
            industryArray = JSON.parse(cleanJsonString);
            console.log('✅ JSON-String erfolgreich geparst zu Array:', industryArray);
          } catch (parseError) {
            console.error('❌ Fehler beim Parsen des JSON-Strings:', parseError);
            setTestResult('Fehler beim Parsen der Branchen-Daten');
            return;
          }
        } else if (Array.isArray(data.relevantIndustries)) {
          // relevantIndustries ist bereits ein Array
          industryArray = data.relevantIndustries;
          console.log('✅ relevantIndustries ist bereits ein Array:', industryArray);
        } else {
          console.log('⚠️ relevantIndustries ist weder String noch Array:', typeof data.relevantIndustries);
          setTestResult('Unerwartetes Datenformat für Branchen');
          return;
        }
        
        // Prüfe ob das geparste Array gültig ist
        if (industryArray && Array.isArray(industryArray) && industryArray.length > 0) {
          // Setze die Branchen im lokalen State
          setRelevantIndustries(industryArray);
          console.log('✅ Relevante Branchen gesetzt:', industryArray.length, 'Branchen');
          
          // Zeige nur die relevanten Branchen im Test-Modal an
          setTestResult(JSON.stringify(industryArray, null, 2));
        } else {
          console.log('⚠️ Geparste Branchen sind leer oder ungültig:', industryArray);
          setTestResult('Keine Branchen gefunden');
        }
      } else {
        // Keine relevantIndustries vorhanden
        console.log('⚠️ Keine relevantIndustries in der Backend-Antwort gefunden');
        setTestResult('Keine Branchen gefunden');
      }
      
      console.log('✅ Branchen-Optimierung erfolgreich abgeschlossen');
      
    } catch (err: any) {
      setError(t('error.optimize.cv.unknown') + (err.message || ''));
    } finally {
      setOptimizing(false);
    }
  };

  // Handler für weitere Informationen
  const handleAdditionalInfoOptimization = async (promptText: string, promptVersion: string, temperature: string, maxTokens: string) => {
    console.log('ℹ️ Starte Weitere-Angaben-Optimierung...');
    
    try {
      setError(null);
      setOptimizing(true);
      
      // Prüfe ob User-Daten vorhanden sind
      if (!user) {
        setError('Benutzer nicht angemeldet.');
        setOptimizing(false);
        return;
      }

      // Für Weitere-Angaben-Optimierung: Bereite nur Weitere-Angaben-spezifische Daten vor
      const additionalInfoData = {
        additionalInfo: additionalInfo || []
      };

      // Erstelle Weitere-Angaben-spezifischen Text
      let additionalInfoText = '';
      if (additionalInfo && additionalInfo.length > 0) {
        additionalInfoText = additionalInfo.map(info => {
          // Verwende nur Details wenn sie vorhanden und nicht leer sind
          if (info.details && info.details.trim() !== '' && info.details !== 'Keine Details') {
            return `${info.info || 'Keine Info'}: ${info.details}`;
          } else {
            // Nur die Info ohne Details verwenden
            return info.info || 'Keine Info';
          }
        }).join('\n');
      } else {
        additionalInfoText = 'Keine weiteren Angaben im CV gefunden';
      }

      console.log('ℹ️ Weitere-Angaben-Daten für Backend:', additionalInfoData);
      console.log('ℹ️ Weitere-Angaben-Text für Backend:', additionalInfoText);

      // Hole ID Token für Backend-Authentifizierung
      const idToken = await user.getIdToken();

      // Sende Request an Backend für Weitere-Angaben-Optimierung
      const data = await requestOptimizeCvWithQueue({
        cvData: additionalInfoData, // Nur Weitere-Angaben-Daten
        cvText: additionalInfoText, // Nur Weitere-Angaben-Text
        jobDescription: jobDescription,
        optimizeType: 'additionalInfo',
        targetLanguage: targetLanguage,
        // Test-spezifische Parameter
        testPrompt: promptText,
        chatGptVersion: promptVersion,
        temperature: temperature,
        maxTokens: maxTokens
      }, idToken, true);
      
      // Backend-Antwort für weitere Angaben verarbeitet
      
      // Setze die relevanten Weitere-Angaben
      if (data.relevantAdditionalInfo) {
        let additionalInfoArray;
        
        // Prüfe ob relevantAdditionalInfo ein String ist (JSON) oder bereits ein Array
        if (typeof data.relevantAdditionalInfo === 'string') {
          try {
            // Entferne Markdown-Code-Block-Formatierung falls vorhanden
            let cleanJsonString = data.relevantAdditionalInfo;
            if (cleanJsonString.includes('```json')) {
              cleanJsonString = cleanJsonString.replace(/```json\n?/g, '').replace(/```\n?/g, '');
              console.log('🔧 Markdown-Code-Block entfernt, bereinigter String:', cleanJsonString);
            }
            
            // Parse den bereinigten JSON-String zu einem Array
            additionalInfoArray = JSON.parse(cleanJsonString);
            console.log('✅ JSON-String erfolgreich geparst zu Array:', additionalInfoArray);
          } catch (parseError) {
            console.error('❌ Fehler beim Parsen des JSON-Strings:', parseError);
            setTestResult('Fehler beim Parsen der Weitere-Angaben-Daten');
            return;
          }
        } else if (Array.isArray(data.relevantAdditionalInfo)) {
          // relevantAdditionalInfo ist bereits ein Array
          additionalInfoArray = data.relevantAdditionalInfo;
          console.log('✅ relevantAdditionalInfo ist bereits ein Array:', additionalInfoArray);
        } else {
          console.log('⚠️ relevantAdditionalInfo ist weder String noch Array:', typeof data.relevantAdditionalInfo);
          setTestResult('Unerwartetes Datenformat für Weitere-Angaben');
          return;
        }
        
        // Prüfe ob das geparste Array gültig ist
        if (additionalInfoArray && Array.isArray(additionalInfoArray) && additionalInfoArray.length > 0) {
          // Setze die Weitere-Angaben im lokalen State
          setRelevantAdditionalInfo(additionalInfoArray);
          console.log('✅ Relevante Weitere-Angaben gesetzt:', additionalInfoArray.length, 'Einträge');
          
          // Zeige nur die relevanten Weitere-Angaben im Test-Modal an
          setTestResult(JSON.stringify(additionalInfoArray, null, 2));
        } else {
          console.log('⚠️ Geparste Weitere-Angaben sind leer oder ungültig:', additionalInfoArray);
          setTestResult('Keine Weitere-Angaben gefunden');
        }
      } else {
        // Keine relevantAdditionalInfo vorhanden
        console.log('⚠️ Keine relevantAdditionalInfo in der Backend-Antwort gefunden');
        setTestResult('Keine Weitere-Angaben gefunden');
      }
      
      console.log('✅ Weitere-Angaben-Optimierung erfolgreich abgeschlossen');
      
    } catch (err: any) {
      setError(t('error.optimize.cv.unknown') + (err.message || ''));
    } finally {
      setOptimizing(false);
    }
  };

  // Handler für Motivationsschreiben
  const handleMotivationLetterOptimization = async (promptText: string, promptVersion: string, temperature: string, maxTokens: string) => {
    console.log('✍️ Führe Motivationsschreiben-Optimierung durch...');
    await handleOptimizeCv(true, 'motivationLetter', promptText, promptVersion, temperature, maxTokens);
  };

  // Handler für Passgenauigkeit
  const handleMatchingOptimization = async (promptText: string, promptVersion: string, temperature: string, maxTokens: string) => {
    console.log('🎯 Führe Passgenauigkeit-Analyse durch...');

    await handleOptimizeCv(true, 'match', promptText, promptVersion, temperature, maxTokens);
  };

  // Handler für Spracherkennung (Prompt "Spracherkennung"). Optional textToAnalyze für Aufruf nach Paste/Drop/URL.
  // Handler für Spracherkennung - Parameter werden aus Firebase geladen, daher nur textToAnalyze benötigt
  const handleLanguageDetection = async (textToAnalyze?: string) => {
    console.log('🔍 Führe Spracherkennung durch...');
    
    const text = (textToAnalyze && textToAnalyze.trim()) ? textToAnalyze.trim() : (jobDescription || 'Kein Text zur Analyse verfügbar');
    if (text.length < 10) return;

    setDetectingLanguage(true);
    try {
      const user = auth.currentUser;
      if (!user) {
        throw new Error('Benutzer nicht angemeldet');
      }
      
      const idToken = await user.getIdToken();
      
      const response = await fetch(`${config.backend.baseUrl}/api/detect-language`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({
          text: text.substring(0, 600)
        })
      });
      
      if (response.ok) {
        const result = await response.json();
        console.log('✅ Spracherkennung erfolgreich:', result);
        
        setTestResult(JSON.stringify(result, null, 2));

        // Dropdown "Sprache Stellenbeschreibung" setzen
        if (result.success && result.language) {
          const languageMap: { [key: string]: string } = {
            'de': 'DE',
            'en': 'EN',
            'fr': 'FR',
            'it': 'IT'
          };
          const detectedLanguage = languageMap[result.language.toLowerCase()] || 'DE';
          setJobDescriptionLanguage(detectedLanguage);
          setLanguageDetected(true);
        }
      } else {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
    } catch (error) {
      console.error('❌ Fehler bei der Spracherkennung:', error);
      setTestResult(`Fehler: ${error instanceof Error ? error.message : 'Unbekannter Fehler'}`);
    } finally {
      setDetectingLanguage(false);
    }
  };

  // Handler für einzelne Prompt-Tests - VERWENDET PRODUKTIVEN HANDLER
  const handleTestSinglePrompt = async (promptText: string, promptType: string, promptVersion: string, temperature: string, maxTokens: string) => {
    console.log('🧪 Teste einzelnen Prompt (verwende produktiven Handler):', promptType);
    
    try {
      setIsTesting(true);
      setTestResult('');
      
      // SCHRITT 1: Prompt zuerst in Firebase speichern
      console.log('💾 Speichere Prompt zuerst in Firebase...');
      const user = auth.currentUser;
      if (!user) {
        throw new Error('Benutzer nicht angemeldet');
      }
      
      const idToken = await user.getIdToken();
      
      // Speichere den aktuellen Prompt
      const savePromptResponse = await fetch(`${config.backend.baseUrl}/api/prompts`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({
          promptType: promptType,
          promptText: promptText,
          chatGptVersion: promptVersion,
          usage: editingPromptUsage, // Verwende die aktuelle usage statt hartcodierter 'Optimierung'
          temperature: temperature,
          maxTokens: maxTokens,
          systemRole: editingPromptSystemRole
        })
      });
      
      if (!savePromptResponse.ok) {
        throw new Error(`Fehler beim Speichern des Prompts: ${savePromptResponse.statusText}`);
      }
      
      console.log('✅ Prompt erfolgreich in Firebase gespeichert');
      
      // SCHRITT 1.5: Prompt-Liste neu laden, damit Änderungen in der Tabelle sichtbar sind
      console.log('🔄 Lade Prompt-Liste neu...');
      await loadPromptsFromFirebase();
      console.log('✅ Prompt-Liste aktualisiert');
      
      // SCHRITT 2: Rufe die entsprechende spezifische Optimierungsfunktion auf
      console.log('🚀 Rufe spezifische Optimierungsfunktion auf...');
      console.log('🔍 Prompt-Typ für Switch:', JSON.stringify(promptType));
      console.log('🔍 Prompt-Typ Länge:', promptType?.length);
      console.log('🔍 Prompt-Typ Vergleich mit "Hobbys-Optimierung":', promptType === 'Hobbys-Optimierung');
      console.log('🔍 Prompt-Typ Vergleich mit "Weitere-Angaben":', promptType === 'Weitere-Angaben');
      console.log('🔍 Prompt-Typ Zeichen-für-Zeichen:', Array.from(promptType || '').map(c => c.charCodeAt(0)));
      
      switch (promptType) {
        case 'Hobbys':
          await handleHobbyOptimization(promptText, promptVersion, temperature, maxTokens);
          break;
          
        case 'IT-Skills':
          await handleItSkillsOptimization(promptText, promptVersion, temperature, maxTokens);
          break;
          
        case 'Kernkompetenzen':
          await handleCoreCompetenciesOptimization(promptText, promptVersion, temperature, maxTokens);
          break;
          
        case 'Zertifizierungen':
          await handleCertificationOptimization(promptText, promptVersion, temperature, maxTokens);
          break;
          
        case 'Ausbildung':
          console.log('🎓 Ausführung: Ausbildungs-Optimierung gefunden!');
          await handleEducationOptimization(promptText, promptVersion, temperature, maxTokens);
          break;
          
        case 'Arbeitserfahrungen':
        case 'Berufserfahrung':
          console.log('💼 Ausführung: Berufserfahrung-Optimierung gefunden!');
          await handleWorkExperienceOptimization(promptText, promptVersion, temperature, maxTokens);
          break;
          
        case 'Relevante Sprachen':
        case 'Sprachen':
          await handleLanguageOptimization(promptText, promptVersion, temperature, maxTokens);
          break;
          
                 case 'Branchen':
           await handleIndustryOptimization(promptText, promptVersion, temperature, maxTokens);
           break;
          
        case 'Weitere Informationen':
        case 'Weitere-Angaben-Extraktion':
        case 'Weitere-Angaben':
          console.log('ℹ️ Ausführung: Weitere-Angaben-Optimierung gefunden!');
          await handleAdditionalInfoOptimization(promptText, promptVersion, temperature, maxTokens);
          break;
          
        case 'Motivationsschreiben':
          await handleMotivationLetterOptimization(promptText, promptVersion, temperature, maxTokens);
          break;
          
        case 'Passgenauigkeit':
          await handleMatchingOptimization(promptText, promptVersion, temperature, maxTokens);
          break;
          
        case 'Spracherkennung':
          // Parameter werden aus Firebase geladen, daher keine Übergabe nötig
          await handleLanguageDetection();
          break;
          
        case 'Kurzprofil':
          console.log('👤 Ausführung: Kurzprofil-Optimierung gefunden!');
          await handleShortProfileOptimization(promptText, promptVersion, temperature, maxTokens);
          break;
          
        default:
          console.log('⚠️ Unbekannter Prompt-Typ, verwende allgemeinen Handler');
          await handleOptimizeCv(true, promptType, promptText, promptVersion, temperature, maxTokens);
      }
      
      console.log('✅ Prompt-Test erfolgreich abgeschlossen');
      
    } catch (error) {
      console.error('❌ Fehler beim Prompt-Test:', error);
      const errorMessage = error instanceof Error ? error.message : 'Unbekannter Fehler';
      setTestResult(`Fehler: ${errorMessage}`);
    } finally {
      setIsTesting(false);
    }
  };








  // Hilfsfunktion zum Normalisieren der Design-Einstellungen
  // Stellt sicher, dass alle erforderlichen Felder vorhanden sind
  const normalizeDesignSettings = (designSettings: any): any => {
    if (!designSettings) {
      return getCurrentCvDesignSettings();
    }
    
    // Wenn die Design-Einstellungen vollständig sind (haben selectedTemplate und templateName),
    // verwende sie direkt ohne State-Werte zu verwenden
    // Dies ist wichtig, wenn die State-Werte nach App-Start noch nicht aktualisiert wurden
    if (designSettings.selectedTemplate && designSettings.templateName) {
      // Design-Einstellungen sind vollständig normalisiert, verwende sie direkt
      return designSettings;
    }
    
    // Wenn die Design-Einstellungen nicht vollständig sind, ergänze fehlende Felder
    // WICHTIG: Verwende die übergebenen Settings als Basis, nicht die State-Werte
    // Nur für fehlende Felder verwende State-Werte als Fallback
    const currentSettings = getCurrentCvDesignSettings();
    
    // Bestimme Template-ID aus den übergebenen Settings oder State
    const templateId = designSettings.selectedTemplate || designSettings.selectedTemplateId || currentSettings.selectedTemplate || 'template1';
    const isProfessional = templateId === 'template2';
    
    // Erstelle normalisierte Settings mit übergebenen Settings als Basis
    return {
      // Verwende übergebene Settings als Basis
      ...designSettings,
      // Ergänze nur fehlende Felder mit Template-spezifischen Defaults oder State-Werten
      selectedTemplate: designSettings.selectedTemplate || designSettings.selectedTemplateId || templateId,
      selectedTemplateId: designSettings.selectedTemplateId || designSettings.selectedTemplate || templateId,
      templateName: designSettings.templateName || (templateId === 'template1' ? getTranslatedCvLabel('Modern') : 
                   templateId === 'template2' ? getTranslatedCvLabel('Professional') : getTranslatedCvLabel('Classic')),
      // Ergänze nur fehlende Farben mit Template-spezifischen Defaults
      leftColumnColor: designSettings.leftColumnColor || (isProfessional ? 'rgba(46,46,46,1)' : 'rgba(248,246,242,1)'),
      topBoxColor: designSettings.topBoxColor || (isProfessional ? 'rgba(46,46,46,1)' : 'rgba(248,246,242,1)'),
      nameTextColor: designSettings.nameTextColor || '#333333',
      leftColumnTextColor: designSettings.leftColumnTextColor || (isProfessional ? '#ffffff' : '#333333'),
      rightColumnTextColor: designSettings.rightColumnTextColor || '#333333',
      leftColumnTitleColor: designSettings.leftColumnTitleColor || (isProfessional ? '#ffffff' : '#333333'),
      rightColumnTitleColor: designSettings.rightColumnTitleColor || '#333333',
      // Ergänze nur fehlende andere Felder mit State-Werten als Fallback
      topBoxAlpha: designSettings.topBoxAlpha !== undefined ? designSettings.topBoxAlpha : (currentSettings.topBoxAlpha !== undefined ? currentSettings.topBoxAlpha : 0),
      topBoxImage: designSettings.topBoxImage || currentSettings.topBoxImage || '',
      topBoxHeightMode: 'nameBottom',
      leftColumnImage: designSettings.leftColumnImage || currentSettings.leftColumnImage || '',
      showCoreCompetenciesInCv: designSettings.showCoreCompetenciesInCv !== undefined ? designSettings.showCoreCompetenciesInCv : (currentSettings.showCoreCompetenciesInCv !== undefined ? currentSettings.showCoreCompetenciesInCv : true),
      showCertificationsInCv: designSettings.showCertificationsInCv !== undefined ? designSettings.showCertificationsInCv : (currentSettings.showCertificationsInCv !== undefined ? currentSettings.showCertificationsInCv : true),
      showItSkillsInCv: designSettings.showItSkillsInCv !== undefined ? designSettings.showItSkillsInCv : (currentSettings.showItSkillsInCv !== undefined ? currentSettings.showItSkillsInCv : true),
      showIndustriesInCv: designSettings.showIndustriesInCv !== undefined ? designSettings.showIndustriesInCv : (currentSettings.showIndustriesInCv !== undefined ? currentSettings.showIndustriesInCv : true),
      showLanguagesInCv: designSettings.showLanguagesInCv !== undefined ? designSettings.showLanguagesInCv : (currentSettings.showLanguagesInCv !== undefined ? currentSettings.showLanguagesInCv : true),
      showHobbiesInCv: designSettings.showHobbiesInCv !== undefined ? designSettings.showHobbiesInCv : (currentSettings.showHobbiesInCv !== undefined ? currentSettings.showHobbiesInCv : true),
      showEducationInCv: designSettings.showEducationInCv !== undefined ? designSettings.showEducationInCv : (currentSettings.showEducationInCv !== undefined ? currentSettings.showEducationInCv : true),
      showWorkExperienceInCv: designSettings.showWorkExperienceInCv !== undefined ? designSettings.showWorkExperienceInCv : (currentSettings.showWorkExperienceInCv !== undefined ? currentSettings.showWorkExperienceInCv : true),
      showProfileInCv: designSettings.showProfileInCv !== undefined ? designSettings.showProfileInCv : (currentSettings.showProfileInCv !== undefined ? currentSettings.showProfileInCv : true),
      showAdditionalInfoInCv: designSettings.showAdditionalInfoInCv !== undefined ? designSettings.showAdditionalInfoInCv : (currentSettings.showAdditionalInfoInCv !== undefined ? currentSettings.showAdditionalInfoInCv : true),
      showProfileImageInCv: designSettings.showProfileImageInCv !== undefined ? designSettings.showProfileImageInCv : (currentSettings.showProfileImageInCv !== undefined ? currentSettings.showProfileImageInCv : true),
      showContactInCv: designSettings.showContactInCv !== undefined ? designSettings.showContactInCv : (currentSettings.showContactInCv !== undefined ? currentSettings.showContactInCv : true),
      showCompanyNamesInCv: designSettings.showCompanyNamesInCv !== undefined ? designSettings.showCompanyNamesInCv : true,
      showIndustryInCv: designSettings.showIndustryInCv !== undefined ? designSettings.showIndustryInCv : true,
      showDateInCv: designSettings.showDateInCv !== undefined ? designSettings.showDateInCv : true,
      showProjectSearchInCv: designSettings.showProjectSearchInCv !== undefined ? designSettings.showProjectSearchInCv : false,
      showBulletPointsInCv: designSettings.showBulletPointsInCv !== undefined ? designSettings.showBulletPointsInCv : (currentSettings.showBulletPointsInCv !== undefined ? currentSettings.showBulletPointsInCv : false),
      showAdditionalWorkExperienceInCv: designSettings.showAdditionalWorkExperienceInCv !== undefined ? designSettings.showAdditionalWorkExperienceInCv : (currentSettings.showAdditionalWorkExperienceInCv !== undefined ? currentSettings.showAdditionalWorkExperienceInCv : true),
      showPhotoInCv: designSettings.showPhotoInCv !== undefined ? designSettings.showPhotoInCv : (currentSettings.showPhotoInCv !== undefined ? currentSettings.showPhotoInCv : true),
      sortWorkExperienceByRelevance: designSettings.sortWorkExperienceByRelevance !== undefined ? designSettings.sortWorkExperienceByRelevance : (currentSettings.sortWorkExperienceByRelevance !== undefined ? currentSettings.sortWorkExperienceByRelevance : false),
      profileImageBorderRadius: designSettings.profileImageBorderRadius !== undefined ? designSettings.profileImageBorderRadius : (currentSettings.profileImageBorderRadius !== undefined ? currentSettings.profileImageBorderRadius : ((isProfessional || templateId === 'template3') ? 0 : 50)),
      profileImageSize: designSettings.profileImageSize || currentSettings.profileImageSize || 'M',
      profileImageWidth: designSettings.profileImageWidth || currentSettings.profileImageWidth || 100,
      profileImagePosition: designSettings.profileImagePosition || currentSettings.profileImagePosition || { x: 50, y: 50 },
      profileImageAlignment: designSettings.profileImageAlignment || currentSettings.profileImageAlignment || (isProfessional ? 'left' : 'center'),
      profileImageBorder: designSettings.profileImageBorder !== undefined ? designSettings.profileImageBorder : (currentSettings.profileImageBorder !== undefined ? currentSettings.profileImageBorder : false),
      profileImageBorderColor: designSettings.profileImageBorderColor || currentSettings.profileImageBorderColor || '#333333',
      profileImageBorderThickness: designSettings.profileImageBorderThickness || currentSettings.profileImageBorderThickness || 2,
      nameFontSize: designSettings.nameFontSize || currentSettings.nameFontSize || 36,
      titleFont: designSettings.titleFont || currentSettings.titleFont || '"Times New Roman", Times, serif',
      bodyFont: designSettings.bodyFont || currentSettings.bodyFont || 'Arial, sans-serif',
      contactDisplayMode: designSettings.contactDisplayMode || currentSettings.contactDisplayMode || 'text',
      shortProfileTextLength: designSettings.shortProfileTextLength || currentSettings.shortProfileTextLength || shortProfileTextLength,
      workExperienceTextLength: designSettings.workExperienceTextLength || currentSettings.workExperienceTextLength || workExperienceTextLength,
    };
  };

  // CV-Daten für Template vorbereiten
  // Optional: designSettings können übergeben werden, um die State-Variablen zu überschreiben
  const getCvDataForTemplate = (designSettingsOverride?: any, sourceCvData?: any) => {
    // Normalisiere die Design-Einstellungen, damit alle erforderlichen Felder vorhanden sind
    const designSettings = normalizeDesignSettings(designSettingsOverride);
    const useSourceOnly = !!sourceCvData;
    const sourcePersonalInfo = sourceCvData?.personalInfo || {};
    const sourceProfileImage = sourceCvData?.profileImage || sourcePersonalInfo?.profileImage || null;
    const sourceSignature = sourceCvData?.signature || null;
    const sourceAddress = sourceCvData?.address || sourcePersonalInfo?.address || '';
    const sourcePostalCode = sourceCvData?.postalCode || sourcePersonalInfo?.postalCode || '';
    const sourceCity = sourceCvData?.city || sourcePersonalInfo?.city || '';
    
    return {
      personalInfo: {
        ...(() => {
          const street = (sourceAddress || (useSourceOnly ? '' : (optimizedAddress || address)) || '').trim();
          const zip = (sourcePostalCode || (useSourceOnly ? '' : (optimizedPostalCode || postalCode)) || '').trim();
          const cityValue = (sourceCity || (useSourceOnly ? '' : (optimizedCity || city)) || '').trim();
          const zipCity = [zip, cityValue].filter(Boolean).join(' ');
          const location = street
            ? `${street}${zipCity ? ', ' : ''}${zipCity}`
            : zipCity;
          return { location };
        })(),
        fullName: sourceCvData?.fullName || sourcePersonalInfo?.fullName || (useSourceOnly ? '' : (optimizedFullName || fullName)),
        shortProfile: useSourceOnly
          ? (sourceCvData?.shortProfile || sourcePersonalInfo?.shortProfile || sourceCvData?.optimizedShortProfile || '')
          : (optimizedShortProfile || ''),
        email: sourceCvData?.email || sourcePersonalInfo?.email || (useSourceOnly ? '' : (optimizedEmail || email)),
        phoneNumber: sourceCvData?.phoneNumber || sourcePersonalInfo?.phoneNumber || (useSourceOnly ? '' : (optimizedPhoneNumber || phoneNumber)),
        address: sourceAddress || (useSourceOnly ? '' : (optimizedAddress || address)),
        postalCode: sourcePostalCode || (useSourceOnly ? '' : (optimizedPostalCode || postalCode)),
        city: sourceCity || (useSourceOnly ? '' : (optimizedCity || city)),
        birthYear: sourceCvData?.birthYear || sourcePersonalInfo?.birthYear || (useSourceOnly ? '' : birthYear), // Jahrgang für CV Classic Template
        nationality: sourceCvData?.nationality || sourcePersonalInfo?.nationality || (useSourceOnly ? '' : nationality), // Nationalität für CV Classic Template
        residencePermit: sourceCvData?.residencePermit || sourcePersonalInfo?.residencePermit || (useSourceOnly ? '' : residencePermit), // Aufenthaltsbewilligung für CV Template
        maritalStatus: sourceCvData?.civilStatus || sourcePersonalInfo?.civilStatus || sourcePersonalInfo?.maritalStatus || (useSourceOnly ? '' : civilStatus), // Zivilstand für CV Classic Template
        availableFrom: sourceCvData?.availableFrom || sourcePersonalInfo?.availableFrom || (useSourceOnly ? '' : availableFrom) // Verfügbar ab für CV Classic Template
      },
      // Verwende ausschließlich relevante IT-Skills - keine Fallbacks
      itSkills: useSourceOnly
        ? (sourceCvData?.itSkills || [])
        : (relevantItSkills || []),
      relevantItSkills: useSourceOnly
        ? (sourceCvData?.relevantItSkills || sourceCvData?.itSkills || [])
        : (relevantItSkills || []),
      workExperience: useSourceOnly
        ? (sourceCvData?.workExperiences || sourceCvData?.workExperience || [])
        : ((relevantWorkExperiences && relevantWorkExperiences.length > 0)
        ? sortWorkExperiencesForDisplay(relevantWorkExperiences).map(exp => ({
            position: exp.position,
            company: exp.company,
            startDate: exp.startDate,
            endDate: exp.endDate,
            description: exp.description
          }))
        : workExperiences.map(exp => ({
            position: exp.position,
            company: exp.company,
            startDate: exp.startDate,
            endDate: exp.endDate,
            description: exp.description
          }))), // Verwende relevante Arbeitserfahrungen falls verfügbar, sonst ursprüngliche
      // Verwende ausschließlich relevante Ausbildungen - keine Fallbacks
      educations: (useSourceOnly ? (sourceCvData?.educations || sourceCvData?.education || []) : (relevantEducations || [])).map((edu: any) => ({
        degree: edu.degree,
        institution: edu.institution,
        description: edu.description,
        startDate: edu.startDate,
        endDate: edu.endDate
      })),
      // Verwende relevante Ausbildungen für das Template
      relevantEducations: (useSourceOnly ? (sourceCvData?.relevantEducations || sourceCvData?.educations || sourceCvData?.education || []) : (relevantEducations || [])).map((edu: any) => ({
        degree: edu.degree,
        institution: edu.institution,
        description: edu.description,
        startDate: edu.startDate,
        endDate: edu.endDate
      })),
      // Verwende relevante Zertifizierungen falls verfügbar, sonst normale Zertifizierungen
      // Verwende ausschließlich relevante Zertifikate - keine Fallbacks
      certifications: useSourceOnly ? (sourceCvData?.certifications || []) : (relevantCertifications || []),
      // Relevante Zertifizierungen als separates Feld (für CV-Share-Funktionalität)
      relevantCertifications: useSourceOnly ? (sourceCvData?.relevantCertifications || sourceCvData?.certifications || []) : (relevantCertifications || []),
      // Verwende ausschließlich relevante Sprachen - keine Fallbacks
      languages: (useSourceOnly ? (sourceCvData?.languages || []) : (relevantLanguages || [])).map((lang: any) => ({
        language: lang.language,
        level: lang.level
      })),
      relevantLanguages: (useSourceOnly ? (sourceCvData?.relevantLanguages || sourceCvData?.languages || []) : (relevantLanguages || [])).map((lang: any) => ({
        language: lang.language,
        level: lang.level
      })),
      // Verwende ausschließlich relevante Kernkompetenzen - keine Fallbacks
      coreCompetencies: (useSourceOnly ? (sourceCvData?.coreCompetencies || []) : (relevantCoreCompetencies || [])).map((comp: any) => ({
        competency: comp.competency
      })),
      // Relevante Kernkompetenzen als separates Feld (für CV-Share-Funktionalität)
      relevantCoreCompetencies: useSourceOnly ? (sourceCvData?.relevantCoreCompetencies || sourceCvData?.coreCompetencies || []) : (relevantCoreCompetencies || []),
      // Verwende ausschließlich relevante Branchen - keine Fallbacks
      industryExperiences: (useSourceOnly ? (sourceCvData?.industryExperiences || []) : (relevantIndustries || [])).map((exp: any) => ({
        industry: exp.industry,
        years: exp.years
      })),
      // Verwende relevante Branchen für das Template
      relevantIndustries: (useSourceOnly ? (sourceCvData?.relevantIndustries || sourceCvData?.industryExperiences || []) : (relevantIndustries || [])).map((exp: any) => ({
        industry: exp.industry,
        years: exp.years
      })),
      // Verwende ausschließlich relevante Hobbys - keine Fallbacks
      hobbies: useSourceOnly ? (sourceCvData?.hobbies || []) : (relevantHobbies || []),
      // Verwende relevante Hobbys für das Template
      relevantHobbies: useSourceOnly ? (sourceCvData?.relevantHobbies || sourceCvData?.hobbies || []) : (relevantHobbies || []),
      // Verwende ausschließlich relevante weitere Informationen - keine Fallbacks
      additionalInfo: useSourceOnly ? (sourceCvData?.additionalInfo || []) : (relevantAdditionalInfo || []),
      // Verwende relevante weitere Informationen für das Template
      relevantAdditionalInfo: useSourceOnly ? (sourceCvData?.relevantAdditionalInfo || sourceCvData?.additionalInfo || []) : (relevantAdditionalInfo || []),
      // Optimierte weitere Informationen für Classic Template
      additionalInfoOptimized: useSourceOnly ? (sourceCvData?.relevantAdditionalInfo || sourceCvData?.additionalInfo || []) : (relevantAdditionalInfo || []),
      // Optimierte Berufserfahrungen für das Template (mit relevant-Feld)
      optimizedWorkExperiences: useSourceOnly
        ? normalizeWorkExperienceRelevanceFlags(sourceCvData?.optimizedWorkExperiences || sourceCvData?.workExperience || [])
        : normalizeWorkExperienceRelevanceFlags(optimizedWorkExperiences || []),
      // Optimiertes Kurzprofil als separates Feld (für CV-Share-Funktionalität)
      optimizedShortProfile: useSourceOnly ? (sourceCvData?.optimizedShortProfile || sourceCvData?.shortProfile || sourcePersonalInfo?.shortProfile || '') : (optimizedShortProfile || ''),
      profileImage: useSourceOnly ? sourceProfileImage : (sourceProfileImage || profileImage),
      signature: useSourceOnly ? sourceSignature : (sourceSignature || signature),
      // Abschnittstitel (für Bewerbung speichern, damit alle CV-Änderungen erhalten bleiben)
      sectionTitles: {
        coreCompetencies: currentCoreCompetenciesTitle,
        certifications: currentCertificationsTitle,
        itSkills: currentItSkillsTitle,
        industries: currentIndustriesTitle,
        languages: currentLanguagesTitle,
        hobbies: currentHobbiesTitle,
        additionalInfo: currentAdditionalInfoTitle,
        education: currentEducationTitle,
        workExperience: currentWorkExperienceTitle,
        profile: currentProfileTitle
      },
      // Design-Settings - verwende übergebene Einstellungen oder aktuelle State-Werte
      designSettings: designSettings
    };
  };

  const getProcessScopedTemplateSource = (): any | null => {
    const base = activeProcessCvSnapshotRef.current;
    if (!base || typeof base !== 'object') return null;

    const resolvedWorkExperience =
      (Array.isArray(optimizedWorkExperiences) && optimizedWorkExperiences.length > 0
        ? optimizedWorkExperiences
        : (base.optimizedWorkExperiences || base.workExperiences || base.workExperience || []));
    const resolvedEducations =
      (Array.isArray(relevantEducations) && relevantEducations.length > 0
        ? relevantEducations
        : (base.relevantEducations || base.educations || base.education || []));
    const resolvedCertifications =
      (Array.isArray(relevantCertifications) && relevantCertifications.length > 0
        ? relevantCertifications
        : (base.relevantCertifications || base.certifications || []));
    const resolvedItSkills =
      (Array.isArray(relevantItSkills) && relevantItSkills.length > 0
        ? relevantItSkills
        : (base.relevantItSkills || base.itSkills || []));
    const resolvedLanguages =
      (Array.isArray(relevantLanguages) && relevantLanguages.length > 0
        ? relevantLanguages
        : (base.relevantLanguages || base.languages || []));
    const resolvedCoreCompetencies =
      (Array.isArray(relevantCoreCompetencies) && relevantCoreCompetencies.length > 0
        ? relevantCoreCompetencies
        : (base.relevantCoreCompetencies || base.coreCompetencies || []));
    const resolvedIndustries =
      (Array.isArray(relevantIndustries) && relevantIndustries.length > 0
        ? relevantIndustries
        : (base.relevantIndustries || base.industryExperiences || []));
    const resolvedHobbies =
      (Array.isArray(relevantHobbies) && relevantHobbies.length > 0
        ? relevantHobbies
        : (base.relevantHobbies || base.hobbies || []));
    const resolvedAdditionalInfo =
      (Array.isArray(relevantAdditionalInfo) && relevantAdditionalInfo.length > 0
        ? relevantAdditionalInfo
        : (base.relevantAdditionalInfo || base.additionalInfo || []));
    const resolvedOptimizedShortProfile =
      (typeof optimizedShortProfile === 'string' && optimizedShortProfile.trim())
        ? optimizedShortProfile
        : (base.optimizedShortProfile || base.shortProfile || base.personalInfo?.shortProfile || '');

    return {
      ...base,
      optimizedShortProfile: resolvedOptimizedShortProfile,
      optimizedWorkExperiences: resolvedWorkExperience,
      workExperiences: resolvedWorkExperience,
      workExperience: resolvedWorkExperience,
      educations: resolvedEducations,
      education: resolvedEducations,
      relevantEducations: resolvedEducations,
      certifications: resolvedCertifications,
      relevantCertifications: resolvedCertifications,
      itSkills: resolvedItSkills,
      relevantItSkills: resolvedItSkills,
      languages: resolvedLanguages,
      relevantLanguages: resolvedLanguages,
      coreCompetencies: resolvedCoreCompetencies,
      relevantCoreCompetencies: resolvedCoreCompetencies,
      industryExperiences: resolvedIndustries,
      relevantIndustries: resolvedIndustries,
      hobbies: resolvedHobbies,
      relevantHobbies: resolvedHobbies,
      additionalInfo: resolvedAdditionalInfo,
      relevantAdditionalInfo: resolvedAdditionalInfo,
      profileImage: base.profileImage || base.personalInfo?.profileImage || null,
      signature: base.signature || null
    };
  };

  // CV-Preview-Daten sofort in die Bewerbung speichern (z. B. beim Schließen von Unter-Modals)
  const saveCvPreviewDataToApplicationRow = async (
    applicationId: string,
    rowEntry: any,
    rowSourceCvData?: any,
    collectedDataOverride?: any
  ): Promise<boolean> => {
    if (!applicationId || !user) return false;
    const rowPayload = buildCvMatchRowPayload(rowEntry);
    if (!rowPayload.cvId && !rowPayload.cvSetRef && !rowPayload.cvName) return false;

    try {
      const token = await user.getIdToken();
      const cvPreviewData: any = getCvDataForTemplate(undefined, rowSourceCvData);
      cvPreviewData.cvId = rowEntry?.cvId || cvPreviewData.cvId;

      if (collectedDataOverride && typeof collectedDataOverride === 'object') {
        if (typeof collectedDataOverride.optimizedShortProfile === 'string') {
          cvPreviewData.optimizedShortProfile = collectedDataOverride.optimizedShortProfile;
          if (cvPreviewData.personalInfo) {
            cvPreviewData.personalInfo.shortProfile = collectedDataOverride.optimizedShortProfile;
          }
        }
        if (Array.isArray(collectedDataOverride.optimizedWorkExperiences)) {
          cvPreviewData.optimizedWorkExperiences = normalizeWorkExperienceRelevanceFlags(collectedDataOverride.optimizedWorkExperiences);
          cvPreviewData.workExperience = collectedDataOverride.optimizedWorkExperiences.map((exp: any) => ({
            position: exp.position,
            company: exp.company,
            startDate: exp.startDate,
            endDate: exp.endDate,
            description: exp.description,
            relevant: exp.relevant
          }));
        }
        if (Array.isArray(collectedDataOverride.relevantEducations)) cvPreviewData.relevantEducations = collectedDataOverride.relevantEducations;
        if (Array.isArray(collectedDataOverride.relevantCertifications)) cvPreviewData.relevantCertifications = collectedDataOverride.relevantCertifications;
        if (Array.isArray(collectedDataOverride.relevantCoreCompetencies)) cvPreviewData.relevantCoreCompetencies = collectedDataOverride.relevantCoreCompetencies;
        if (Array.isArray(collectedDataOverride.relevantLanguages)) cvPreviewData.relevantLanguages = collectedDataOverride.relevantLanguages;
        if (Array.isArray(collectedDataOverride.relevantIndustries)) cvPreviewData.relevantIndustries = collectedDataOverride.relevantIndustries;
        if (Array.isArray(collectedDataOverride.relevantItSkills)) cvPreviewData.relevantItSkills = collectedDataOverride.relevantItSkills;
        if (Array.isArray(collectedDataOverride.relevantHobbies)) cvPreviewData.relevantHobbies = collectedDataOverride.relevantHobbies;
        if (Array.isArray(collectedDataOverride.relevantAdditionalInfo)) cvPreviewData.relevantAdditionalInfo = collectedDataOverride.relevantAdditionalInfo;
      }

      if (!hasOptimizedFieldsInPreviewData(cvPreviewData)) {
        return false;
      }

      const response = await fetch(`${config.backend.baseUrl}/api/save-application-cv-preview-data`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          applicationId,
          cvPreviewData,
          ...rowPayload,
          storePerCvMatchRow: true
        })
      });

      return response.ok;
    } catch (error) {
      console.error('❌ Fehler beim Speichern der row-spezifischen CV-Preview-Daten:', error);
      return false;
    }
  };

  // CV-Preview-Daten sofort in die Bewerbung speichern (z. B. beim Schließen von Unter-Modals)
  const saveCvPreviewDataToApplication = async (
    overrides?: WorkExperienceSaveOverrides
  ) => {
    const targetApplicationId = selectedApplicationId || selectedApplication?.id;
    if (!targetApplicationId || !user) return;
    try {
      const token = await user.getIdToken();
      const cvPreviewData = getCvDataForTemplate();
      if (overrides?.updatedOptimizedWorkExperiences) {
        cvPreviewData.optimizedWorkExperiences = normalizeWorkExperienceRelevanceFlags(overrides.updatedOptimizedWorkExperiences);
      }
      if (overrides?.updatedRelevantWorkExperiences) {
        cvPreviewData.workExperience = overrides.updatedRelevantWorkExperiences.map((exp: any) => ({
          position: exp.position,
          company: exp.company,
          startDate: exp.startDate,
          endDate: exp.endDate,
          description: exp.description
        }));
      }
      if (overrides?.optimizedShortProfileOverride !== undefined) {
        cvPreviewData.optimizedShortProfile = overrides.optimizedShortProfileOverride;
        if (cvPreviewData.personalInfo) {
          cvPreviewData.personalInfo.shortProfile = overrides.optimizedShortProfileOverride;
        }
      }
      // Schutz vor unbeabsichtigtem Ueberschreiben mit leeren Optimierungsdaten:
      // Wenn der aktuelle State keine optimierten Felder enthaelt, uebernehme
      // bestehende optimierte Felder aus der gespeicherten Bewerbung.
      const optimizedFields = [
        'optimizedShortProfile',
        'optimizedWorkExperiences',
        'relevantItSkills',
        'relevantLanguages',
        'relevantCertifications',
        'relevantCoreCompetencies',
        'relevantAdditionalInfo',
        'relevantHobbies',
        'relevantIndustries',
        'relevantEducations'
      ] as const;
      const hasCurrentOptimizedData = optimizedFields.some((field) => {
        const value = (cvPreviewData as any)[field];
        if (Array.isArray(value)) return value.length > 0;
        if (typeof value === 'string') return value.trim().length > 0;
        return value !== undefined && value !== null;
      });
      if (!hasCurrentOptimizedData) {
        try {
          const existingResponse = await fetch(`${config.backend.baseUrl}/api/get-application-cv-preview-data/${targetApplicationId}`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });
          if (existingResponse.ok) {
            const existingResult = await existingResponse.json();
            const existingPreview = existingResult?.cvPreviewData || {};
            optimizedFields.forEach((field) => {
              const currentValue = (cvPreviewData as any)[field];
              const existingValue = (existingPreview as any)[field];
              const currentEmpty =
                currentValue === undefined ||
                currentValue === null ||
                (typeof currentValue === 'string' && currentValue.trim().length === 0) ||
                (Array.isArray(currentValue) && currentValue.length === 0);
              const existingHasData =
                existingValue !== undefined &&
                existingValue !== null &&
                !(typeof existingValue === 'string' && existingValue.trim().length === 0) &&
                !(Array.isArray(existingValue) && existingValue.length === 0);
              if (currentEmpty && existingHasData) {
                (cvPreviewData as any)[field] = existingValue;
              }
            });
          }
        } catch (preserveError) {
          console.warn('⚠️ Konnte bestehende Optimierungsdaten nicht zur Sicherung laden:', preserveError);
        }
      }
      const activeRowContext = activeCvPreviewRowContextRef.current;
      const activeRowPayload =
        activeRowContext && activeRowContext.applicationId === targetApplicationId
          ? buildCvMatchRowPayload(activeRowContext.rowEntry)
          : {};
      const hasActiveRowPayload =
        !!activeRowPayload.cvId || !!activeRowPayload.cvSetRef || !!activeRowPayload.cvName;

      const requestBody: any = {
        applicationId: targetApplicationId,
        cvPreviewData: cvPreviewData
      };
      if (hasActiveRowPayload) {
        requestBody.storePerCvMatchRow = true;
        Object.assign(requestBody, activeRowPayload);
      }

      await fetch(`${config.backend.baseUrl}/api/save-application-cv-preview-data`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });
    } catch (error) {
      console.error('❌ Fehler beim Speichern der CV-Preview-Daten:', error);
    }
  };

  // Entkoppelt schnelle Modal-Interaktionen von direkten Netzwerk-Saves.
  // Mehrere Save-Trigger in kurzer Zeit werden zusammengefasst.
  const previewSaveDebounceRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);
  const pendingPreviewSaveOverridesRef = React.useRef<WorkExperienceSaveOverrides | undefined>(undefined);

  const scheduleCvPreviewDataSave = React.useCallback((overrides?: WorkExperienceSaveOverrides) => {
    if (overrides) {
      pendingPreviewSaveOverridesRef.current = {
        ...(pendingPreviewSaveOverridesRef.current || {}),
        ...overrides
      };
    }

    if (previewSaveDebounceRef.current) {
      clearTimeout(previewSaveDebounceRef.current);
    }

    previewSaveDebounceRef.current = setTimeout(() => {
      const mergedOverrides = pendingPreviewSaveOverridesRef.current;
      pendingPreviewSaveOverridesRef.current = undefined;
      previewSaveDebounceRef.current = null;
      void saveCvPreviewDataToApplication(mergedOverrides);
    }, 250);
  }, [saveCvPreviewDataToApplication]);

  const flushCvPreviewDataSave = React.useCallback(async () => {
    if (previewSaveDebounceRef.current) {
      clearTimeout(previewSaveDebounceRef.current);
      previewSaveDebounceRef.current = null;
    }
    const mergedOverrides = pendingPreviewSaveOverridesRef.current;
    pendingPreviewSaveOverridesRef.current = undefined;
    if (mergedOverrides !== undefined) {
      await saveCvPreviewDataToApplication(mergedOverrides);
    }
  }, [saveCvPreviewDataToApplication]);

  React.useEffect(() => {
    return () => {
      if (previewSaveDebounceRef.current) {
        clearTimeout(previewSaveDebounceRef.current);
        previewSaveDebounceRef.current = null;
      }
    };
  }, []);

  const closeWorkExperienceModal = useCallback(() => {
    const updatedWorkExperienceLists = commitSelectedWorkExperienceChanges();
    scheduleCvPreviewDataSave(updatedWorkExperienceLists || undefined);
    setShowWorkExperienceModal(false);
    setSelectedWorkExperience(null);
    setOriginalWorkExperience(null);
    setIsNonRelevantWorkExperience(false);
  }, [commitSelectedWorkExperienceChanges, scheduleCvPreviewDataSave]);

  const closeProfileModal = useCallback(() => {
    const profileOverrides = commitProfileChanges();
    scheduleCvPreviewDataSave(profileOverrides);
    setShowProfileModal(false);
  }, [commitProfileChanges, scheduleCvPreviewDataSave]);

  // Persönliche Daten für Motivationsschreiben-Template vorbereiten
  const getPersonalInfoForMotivation = () => {
    return {
      fullName: optimizedFullName || fullName || '',
      address: optimizedAddress || address || '',
      postalCode: optimizedPostalCode || postalCode || '',
      city: optimizedCity || city || '',
      country: country || '',
      availableFrom: availableFrom || '',
      phoneNumber: optimizedPhoneNumber || phoneNumber || '',
      email: optimizedEmail || email || ''
    };
  };

  // Prompts beim Start laden
  React.useEffect(() => {
    if (user) {
      loadPromptsFromFirebase();
    } else {
     // Keine Fallback-Prompts - nur Firebase-Prompts verwenden
     setPrompts([]);
    }
  }, [user]);

  return (
    <Box sx={{ 
      minHeight: '100vh', 
      display: 'flex', 
      flexDirection: 'column', 
      backgroundColor: '#e8e8e8',
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23d0d0d0' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
    }}>
      {/* Kombiniertes Modal für AGB und Onboarding */}
      <Dialog 
        open={showAgbModal || showOnboardingModal} 
        onClose={() => {}}
        maxWidth="lg"
        fullWidth
        disableEscapeKeyDown
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          fontWeight: 700
        }}>
          {showOnboardingModal ? t('onboarding.title') : t('agb.title')}
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            {/* Onboarding-Bereich */}
            {showOnboardingModal && (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Box sx={{ height: 12 }} />
                {accountRole !== 'member' && (
                  <TextField
                    label={t('onboarding.company')}
                    value={onboardingCompany}
                    onChange={(e) => setOnboardingCompany(e.target.value)}
                    fullWidth
                    disabled={isAccepting || savingOnboarding}
                  />
                )}
                <TextField
                  label={t('onboarding.firstName')}
                  value={onboardingFirstName}
                  onChange={(e) => setOnboardingFirstName(e.target.value)}
                  fullWidth
                  required
                />
                <TextField
                  label={t('onboarding.lastName')}
                  value={onboardingLastName}
                  onChange={(e) => setOnboardingLastName(e.target.value)}
                  fullWidth
                  required
                />
                <FormControl fullWidth required>
                  <InputLabel>{t('onboarding.gender')}</InputLabel>
                  <Select
                    value={onboardingGender}
                    onChange={(e) => setOnboardingGender(e.target.value)}
                    label={t('onboarding.gender')}
                  >
                    <MenuItem value="männlich">{t('onboarding.gender.male')}</MenuItem>
                    <MenuItem value="weiblich">{t('onboarding.gender.female')}</MenuItem>
                    <MenuItem value="divers">{t('onboarding.gender.diverse')}</MenuItem>
                    <MenuItem value="keine-angabe">{t('onboarding.gender.unspecified')}</MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth required>
                  <InputLabel>{t('onboarding.country')}</InputLabel>
                  <Select
                    value={onboardingCountry}
                    onChange={(e) => setOnboardingCountry(e.target.value)}
                    label={t('onboarding.country')}
                  >
                    <MenuItem value="CH">{t('onboarding.country.ch')}</MenuItem>
                    <MenuItem value="DE">{t('onboarding.country.de')}</MenuItem>
                    <MenuItem value="AT">{t('onboarding.country.at')}</MenuItem>
                    <MenuItem value="FR">{t('onboarding.country.fr')}</MenuItem>
                    <MenuItem value="IT">{t('onboarding.country.it')}</MenuItem>
                  </Select>
                </FormControl>
                
                {/* AGB Checkbox */}
                {showAgbModal && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={hasReadAgb}
                        onChange={(e) => setHasReadAgb(e.target.checked)}
                        sx={{
                          color: '#667eea',
                          '&.Mui-checked': { color: '#667eea' }
                        }}
                        disabled={isAccepting}
                      />
                    }
                    label={
                      <Typography variant="body2">
                        {t('agb.confirmation.before')}{' '}
                        <Link 
                          href="https://www.acceler-8.ch/agb" 
                          target="_blank" 
                          rel="noopener noreferrer"
                          onClick={(e) => e.stopPropagation()}
                          sx={{ 
                            color: '#667eea',
                            fontWeight: 600,
                            textDecoration: 'underline',
                            '&:hover': { color: '#764ba2' }
                          }}
                        >
                          {t('agb.confirmation.link')}
                        </Link>
                        {' '}{t('agb.confirmation.after')}
                      </Typography>
                    }
                  />
                )}
              </Box>
            )}
            
            {/* AGB-Bereich - wird angezeigt wenn AGB-Modal aktiv ist und Onboarding nicht aktiv ist */}
            {showAgbModal && !showOnboardingModal && (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Box sx={{ height: 12 }} />
                <Typography variant="body1" sx={{ mb: 2, color: 'text.primary' }}>
                  {t('agb.welcome', 'Willkommen! Bitte lesen und akzeptieren Sie unsere Allgemeinen Geschäftsbedingungen, um die Anwendung nutzen zu können.')}
                </Typography>
                {accountRole !== 'member' && (
                  <TextField
                    label={t('onboarding.company')}
                    value={agbCompany}
                    onChange={(e) => setAgbCompany(e.target.value)}
                    fullWidth
                    disabled={isAccepting || savingAgbData}
                  />
                )}
                <TextField
                  label={t('onboarding.firstName')}
                  value={agbFirstName}
                  onChange={(e) => setAgbFirstName(e.target.value)}
                  fullWidth
                  required
                  disabled={isAccepting || savingAgbData}
                />
                <TextField
                  label={t('onboarding.lastName')}
                  value={agbLastName}
                  onChange={(e) => setAgbLastName(e.target.value)}
                  fullWidth
                  required
                  disabled={isAccepting || savingAgbData}
                />
                <FormControl fullWidth required>
                  <InputLabel>{t('onboarding.gender')}</InputLabel>
                  <Select
                    value={agbGender}
                    onChange={(e) => setAgbGender(e.target.value)}
                    label={t('onboarding.gender')}
                    disabled={isAccepting || savingAgbData}
                  >
                    <MenuItem value="männlich">{t('onboarding.gender.male')}</MenuItem>
                    <MenuItem value="weiblich">{t('onboarding.gender.female')}</MenuItem>
                    <MenuItem value="divers">{t('onboarding.gender.diverse')}</MenuItem>
                    <MenuItem value="keine-angabe">{t('onboarding.gender.unspecified')}</MenuItem>
                  </Select>
                </FormControl>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={hasReadAgb}
                      onChange={(e) => setHasReadAgb(e.target.checked)}
                      sx={{
                        color: '#667eea',
                        '&.Mui-checked': { color: '#667eea' }
                      }}
                      disabled={isAccepting || savingAgbData}
                    />
                  }
                  label={
                    <Typography variant="body2">
                      {t('agb.confirmation.before')}{' '}
                      <Link 
                        href="https://www.acceler-8.ch/agb" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                        sx={{ 
                          color: '#667eea',
                          fontWeight: 600,
                          textDecoration: 'underline',
                          '&:hover': { color: '#764ba2' }
                        }}
                      >
                        {t('agb.confirmation.link')}
                      </Link>
                      {' '}{t('agb.confirmation.after')}
                    </Typography>
                  }
                />
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3, justifyContent: 'space-between' }}>
          <Button
            onClick={async () => {
              await logout();
            }}
            variant="text"
            disableRipple
            disableElevation
            disableFocusRipple
            disabled={isAccepting || savingOnboarding || savingAgbData}
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 6,
              minWidth: 'auto',
              border: 'none !important',
              borderWidth: '0 !important',
              borderStyle: 'none !important',
              outline: 'none !important',
              outlineWidth: '0 !important',
              outlineStyle: 'none !important',
              boxShadow: 'none !important',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: 'transparent !important',
                border: 'none !important',
                borderWidth: '0 !important',
                borderStyle: 'none !important',
                outline: 'none !important',
                outlineWidth: '0 !important',
                outlineStyle: 'none !important',
                boxShadow: 'none !important',
                transform: 'none',
              },
              '&:focus': {
                border: 'none !important',
                borderWidth: '0 !important',
                borderStyle: 'none !important',
                outline: 'none !important',
                outlineWidth: '0 !important',
                outlineStyle: 'none !important',
                boxShadow: 'none !important',
              },
              '&:focus-visible': {
                border: 'none !important',
                borderWidth: '0 !important',
                borderStyle: 'none !important',
                outline: 'none !important',
                outlineWidth: '0 !important',
                outlineStyle: 'none !important',
                boxShadow: 'none !important',
              },
              '&.Mui-disabled': {
                border: 'none !important',
                borderWidth: '0 !important',
                borderStyle: 'none !important',
                outline: 'none !important',
                outlineWidth: '0 !important',
              },
              '& .MuiButton-root': {
                border: 'none !important',
                borderWidth: '0 !important',
              },
            }}
          >
            {t('common.cancel')}
          </Button>
          
          <Button
            onClick={async () => {
              // Zuerst AGB akzeptieren, dann Onboarding speichern
              if (showAgbModal) {
                await handleAcceptAgb();
              }
              if (showOnboardingModal) {
                await handleSaveOnboarding();
              }
            }}
            variant="outlined"
            disabled={
              (showOnboardingModal && (savingOnboarding || !onboardingFirstName || !onboardingLastName || !onboardingGender || !onboardingCountry || (showAgbModal && !hasReadAgb))) ||
              (showAgbModal && !showOnboardingModal && (!hasReadAgb || !agbFirstName || !agbLastName || !agbGender)) ||
              isAccepting ||
              savingAgbData
            }
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 6,
              borderWidth: 2,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
            startIcon={(isAccepting || savingOnboarding) ? <CircularProgress size={20} color="inherit" /> : undefined}
          >
            {(isAccepting || savingOnboarding) ? t('onboarding.saving') : t('onboarding.save')}
          </Button>
        </DialogActions>
      </Dialog>
      
      {/* Zeige Loading-Screen während AGB-Prüfung oder wenn Status noch nicht geladen */}
      {(agbLoading || (!agbLoading && agbAccepted === null && user)) && (
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '100vh' 
        }}>
          <CircularProgress />
        </Box>
      )}
      
      {/* Hauptinhalt - nur anzeigen wenn AGBs explizit akzeptiert wurden */}
      {!agbLoading && agbAccepted === true && (
        <>
          {config.frontend.isDevelopment && (
            <Box
              sx={{
                position: 'fixed',
                top: 20,
                left: 20,
                zIndex: 1000
              }}
            >
              <Tooltip title="DEV Umgebung" arrow>
                <IconButton
                  sx={{
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 1)',
                      transform: 'scale(1.1)'
                    },
                    transition: 'all 0.2s ease'
                  }}
                >
                  <DataObjectIcon sx={{ color: '#d32f2f' }} />
                </IconButton>
              </Tooltip>
            </Box>
          )}

          {/* Info-Icon für Versionsinformationen - weiter links */}
          <Box sx={{ 
            position: 'fixed', 
            top: 20, 
            right: 80, 
            zIndex: 1000 
          }}>
            {isAdmin() && (
            <IconButton
              onClick={() => {
                setShowVersionInfo(true);
                loadBackendVersionInfo(); // Lade Backend-Versionsinfo beim Öffnen
              }}
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(0, 0, 0, 0.1)',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 1)',
                  transform: 'scale(1.1)'
                },
                transition: 'all 0.2s ease'
              }}
            >
              <InfoOutlinedIcon sx={{ color: '#3b82f6' }} />
            </IconButton>
            )}
          </Box>

          {/* User-Menü-Icon - an der alten Info-Icon Position */}
          <Box sx={{ 
            position: 'fixed', 
            top: 20, 
            right: 20, 
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}>
            <IconButton
              onClick={handleUserMenuClick}
              sx={{ 
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(0, 0, 0, 0.1)',
                color: '#424242',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 1)',
                  transform: 'scale(1.1)'
                },
                transition: 'all 0.2s ease'
              }}
            >
              <PersonIcon />
            </IconButton>
          </Box>

          {/* User-Menü */}
          <Menu
              anchorEl={userMenuAnchorEl}
              open={isUserMenuOpen}
              onClose={handleUserMenuClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              {/* E-Mail-Adresse des angemeldeten Benutzers */}
              {auth.currentUser?.email && (
                <MenuItem disabled sx={{ 
                  color: 'text.secondary',
                  fontSize: '0.875rem',
                  cursor: 'default',
                  '&:hover': { backgroundColor: 'transparent' }
                }}>
                  {auth.currentUser.email}
                </MenuItem>
              )}
              <MenuItem onClick={handleUserMenuClose}>
                <ListItemIcon>
                  <LanguageOutlinedIcon fontSize="small" />
                </ListItemIcon>
            <FormControl size="small" sx={{ minWidth: 120 }}>
              <Select
                value={currentLanguage}
                    onChange={(e) => {
                      const newLang = e.target.value as string;
                      setCurrentLanguage(newLang);
                      changeLanguage(newLang);
                      
                      console.log('✅ Sprache geändert:', newLang, '(temporär - nach Refresh wird Browser-Sprache geladen)');
                    }}
                    displayEmpty
                    variant="standard"
                    sx={{ 
                      '&:before': { borderBottom: 'none' },
                      '&:after': { borderBottom: 'none' },
                      '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' }
                    }}
              >
                <MenuItem value="de">Deutsch</MenuItem>
                <MenuItem value="fr">Français</MenuItem>
                <MenuItem value="it">Italiano</MenuItem>
                <MenuItem value="en">English</MenuItem>
              </Select>
            </FormControl>
              </MenuItem>
              
              <Divider />
              
              <MenuItem onClick={handleAccountMenuClick}>
                <ListItemIcon>
                  <PersonIcon fontSize="small" />
                </ListItemIcon>
                {t('account')}
              </MenuItem>
              
              <Divider />
              
              <MenuItem onClick={handleLogout}>
                <ListItemIcon>
                  <LogoutIcon fontSize="small" />
                </ListItemIcon>
              {getTranslatedCvLabel('Logout')}
              </MenuItem>
            </Menu>

          {/* Konto-Modal */}
          <Dialog
            open={accountModalOpen}
            onClose={handleAccountModalClose}
            maxWidth="sm"
            fullWidth
            sx={{ zIndex: 1800 }}
            PaperProps={{
              sx: {
                borderRadius: 3
              }
            }}
          >
            <DialogTitle sx={{ 
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              borderBottom: 'none'
            }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                  {t('account')}
                </Typography>
                <IconButton 
                  onClick={handleAccountModalClose}
                  sx={{ color: 'white' }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </DialogTitle>
            
            <DialogContent sx={{ p: 3, pt: 4 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                {/* Account-Name */}
                <Box sx={{ mt: 2 }}>
                  <Typography variant="caption" sx={{ 
                    color: '#64748b', 
                    fontSize: '0.75rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    display: 'block',
                    mb: 1
                  }}>
                    {t('account.name')}
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    key={`account-name-${accountName || ''}`}
                    defaultValue={accountName}
                    onBlur={(e) => {
                      const nextValue = e.target.value;
                      if (nextValue !== accountName) setAccountName(nextValue);
                    }}
                    placeholder={t('account.name.placeholder')}
                    disabled={!accountUsers.some((u: any) => u.userId === user?.uid && u.role === 'owner')}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&.Mui-focused fieldset': {
                          borderColor: '#667eea',
                        },
                      },
                    }}
                  />
                </Box>

                {/* Aktueller Plan (read-only) */}
                <Box>
                  <Typography variant="caption" sx={{ 
                    color: '#64748b', 
                    fontSize: '0.75rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    display: 'block',
                    mb: 2
                  }}>
                    {t('account.plan')}
                  </Typography>
                  
                  {/* Plan-Anzeige Box */}
                  <Box sx={{
                    border: `2px solid ${accountType === 'Beta-Testing' ? '#10b981' : accountType === 'Pro' ? '#f59e0b' : accountType === 'Basic' ? '#667eea' : '#94a3b8'}`,
                    borderRadius: 2,
                    p: 2.5,
                    backgroundColor: accountType === 'Beta-Testing' ? 'rgba(16, 185, 129, 0.06)' : accountType === 'Pro' ? 'rgba(245, 158, 11, 0.06)' : accountType === 'Basic' ? 'rgba(102, 126, 234, 0.06)' : 'rgba(148, 163, 184, 0.06)',
                  }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Box>
                        <Typography sx={{ 
                          color: '#1e293b', 
                          fontWeight: 700,
                          fontSize: '1.15rem',
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                        }}>
                          {accountType === 'Beta-Testing' ? t('account.type.beta.testing') :
                           accountType === 'Pro' ? t('account.type.pro') :
                           accountType === 'Basic' ? t('account.type.basic') :
                           t('account.type.free')}
                        </Typography>
                        <Typography variant="body2" sx={{ 
                          color: '#64748b', 
                          fontSize: '0.875rem',
                          mt: 0.5,
                        }}>
                          {accountType === 'Beta-Testing' 
                            ? `${t('account.unlimited.users')} • ${t('account.unlimited.cv.data.sets')}`
                            : `${getAccountLimits(accountType).maxUsers} ${t('account.users')} • ${getAccountLimits(accountType).maxCvs} ${t('account.cv.data.sets')}`
                          }
                        </Typography>
                        <Typography variant="body2" sx={{ 
                          color: '#64748b', 
                          fontSize: '0.875rem',
                          mt: 0.25,
                        }}>
                          {accountType === 'Free'
                            ? `${pdfUsage?.count ?? 0}/${pdfUsage?.limit ?? PDF_LIMITS_LOCAL[accountType]} PDFs total`
                            : (accountType === 'Basic' || accountType === 'Pro')
                              ? `${pdfUsage?.count ?? 0}/${pdfUsage?.limit ?? PDF_LIMITS_LOCAL[accountType]} PDF-Downloads`
                              : t('account.pdf.downloads.included')
                          }
                        </Typography>
                        {hasStripeSubscription && currentPeriodEnd && (
                          <>
                            <Typography variant="body2" sx={{ 
                              color: '#64748b', 
                              fontSize: '0.875rem',
                              mt: 0.5,
                            }}>
                              {`${t('account.subscription.until')} ${new Date(currentPeriodEnd).toLocaleDateString(currentLanguage === 'en' ? 'en-GB' : currentLanguage === 'fr' ? 'fr-FR' : currentLanguage === 'it' ? 'it-IT' : 'de-CH')}`}
                            </Typography>
                            {cancelAtPeriodEnd ? (
                              <Typography variant="body2" sx={{ 
                                color: '#ef4444', 
                                fontSize: '0.875rem',
                                mt: 0.25,
                                fontWeight: 600,
                              }}>
                                {t('account.subscription.cancelled')}
                              </Typography>
                            ) : (
                              <Typography variant="body2" sx={{ 
                                color: '#64748b', 
                                fontSize: '0.875rem',
                                mt: 0.25,
                              }}>
                                {t('account.subscription.auto.renew')}
                              </Typography>
                            )}
                          </>
                        )}
                      </Box>
                    </Box>
                    
                    {/* Button zum Öffnen der Preispläne */}
                    <Button
                      variant="contained"
                      fullWidth
                      onClick={() => {
                        setAccountModalOpen(false);
                        setPricingModalOpen(true);
                      }}
                      sx={{
                        mt: 2,
                        py: 1.2,
                        borderRadius: 2,
                        background: accountType === 'Beta-Testing' 
                          ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
                          : accountType === 'Pro'
                          ? 'linear-gradient(135deg, #f59e0b 0%, #ef4444 100%)'
                          : accountType === 'Basic'
                          ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                          : 'linear-gradient(135deg, #94a3b8 0%, #64748b 100%)',
                        fontWeight: 600,
                        textTransform: 'none',
                        fontSize: '0.95rem',
                        '&:hover': {
                          background: accountType === 'Beta-Testing'
                            ? 'linear-gradient(135deg, #0d9668 0%, #047857 100%)'
                            : accountType === 'Pro'
                            ? 'linear-gradient(135deg, #d97706 0%, #dc2626 100%)'
                            : accountType === 'Basic'
                            ? 'linear-gradient(135deg, #5568d3 0%, #6a3f8f 100%)'
                            : 'linear-gradient(135deg, #64748b 0%, #475569 100%)',
                        }
                      }}
                    >
                      {hasStripeSubscription 
                        ? (currentLanguage === 'en' ? 'Manage Subscription' : currentLanguage === 'fr' ? 'Gérer l\'abonnement' : currentLanguage === 'it' ? 'Gestisci abbonamento' : 'Abo verwalten') 
                        : (currentLanguage === 'en' ? 'View Plans' : currentLanguage === 'fr' ? 'Voir les forfaits' : currentLanguage === 'it' ? 'Vedi i piani' : 'Preispläne anzeigen')}
                    </Button>
                  </Box>
                  
                </Box>
                
                {/* Account-Benutzer Liste - nur anzeigen wenn Plan mehr als 1 User erlaubt */}
                {getAccountLimits(accountType).maxUsers > 1 && (
                  <>
                    <Box sx={{ mt: 3 }}>
                      <Typography variant="caption" sx={{ 
                        fontWeight: 700, 
                        color: '#64748b', 
                        fontSize: '0.75rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        display: 'block',
                        mb: 2
                      }}>
                        {t('account.users')}
                      </Typography>
                      
                      {loadingAccountUsers ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                          <CircularProgress size={24} sx={{ color: '#667eea' }} />
                          <Typography variant="body2" sx={{ ml: 2, color: '#64748b' }}>
                            {t('account.users.loading')}
                          </Typography>
                        </Box>
                      ) : accountUsers.length === 0 ? (
                        <Typography variant="body2" sx={{ color: '#64748b', py: 2 }}>
                          {t('account.users.none')}
                        </Typography>
                      ) : (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                          {accountUsers.map((accountUser: any) => (
                            <Box
                              key={accountUser.userId}
                              sx={{
                                border: '1px solid #e2e8f0',
                                borderRadius: 2,
                                p: 2,
                                backgroundColor: '#f8fafc',
                                '&:hover': {
                                  backgroundColor: '#f1f5f9',
                                  borderColor: '#cbd5e1'
                                }
                              }}
                            >
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Box sx={{ flex: 1 }}>
                                  <Typography variant="body2" sx={{ 
                                    color: '#1e293b', 
                                    fontWeight: 600,
                                    mb: 0.5
                                  }}>
                                    {accountUser.firstName && accountUser.lastName
                                      ? `${accountUser.firstName} ${accountUser.lastName}`
                                      : accountUser.email || accountUser.userId}
                                  </Typography>
                                  {accountUser.email && (
                                    <Typography variant="caption" sx={{ 
                                      color: '#64748b',
                                      display: 'block'
                                    }}>
                                      {accountUser.email}
                                    </Typography>
                                  )}
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <Chip
                                    label={accountUser.role === 'owner' 
                                      ? t('account.users.role.owner')
                                      : t('account.users.role.member')}
                                    size="small"
                                    sx={{
                                      bgcolor: accountUser.role === 'owner' ? '#667eea' : '#94a3b8',
                                      color: 'white',
                                      fontWeight: 600,
                                      fontSize: '0.75rem'
                                    }}
                                  />
                                  {/* Rollenwechsel nur für andere User, nur für Owner sichtbar */}
                                  {accountUser.userId !== user?.uid && accountUsers.some((u: any) => u.userId === user?.uid && u.role === 'owner') && (
                                    <Tooltip
                                      title={accountUser.role === 'owner'
                                        ? t('account.users.role.change.demote')
                                        : t('account.users.role.change.promote')}
                                    >
                                      <span>
                                        <IconButton
                                          size="small"
                                          onClick={() => handleUpdateUserRole(
                                            accountUser.userId,
                                            accountUser.role === 'owner' ? 'member' : 'owner'
                                          )}
                                          disabled={
                                            updatingUserRoleId === accountUser.userId ||
                                            (accountUser.role === 'owner' && accountUsers.filter((u: any) => u.role === 'owner').length <= 1)
                                          }
                                          sx={{
                                            color: accountUser.role === 'owner' ? '#f59e0b' : '#0ea5e9',
                                            '&:hover': {
                                              backgroundColor: accountUser.role === 'owner' ? '#fef3c7' : '#e0f2fe',
                                            },
                                            '&.Mui-disabled': {
                                              color: '#cbd5e1',
                                            }
                                          }}
                                        >
                                          {updatingUserRoleId === accountUser.userId ? (
                                            <CircularProgress size={16} sx={{ color: '#64748b' }} />
                                          ) : accountUser.role === 'owner' ? (
                                            <RemoveIcon fontSize="small" />
                                          ) : (
                                            <AddIcon fontSize="small" />
                                          )}
                                        </IconButton>
                                      </span>
                                    </Tooltip>
                                  )}
                                  {/* Delete-Button nur für Mitglieder, nur für Owner sichtbar */}
                                  {accountUser.role === 'member' && accountUsers.some((u: any) => u.userId === user?.uid && u.role === 'owner') && (
                                    <IconButton
                                      size="small"
                                      onClick={() => handleDeleteUser(accountUser.userId, accountUser.email)}
                                      disabled={deletingUserId === accountUser.userId}
                                      sx={{
                                        color: '#ef4444',
                                        '&:hover': {
                                          backgroundColor: '#fee2e2',
                                        },
                                        '&.Mui-disabled': {
                                          color: '#fca5a5',
                                        }
                                      }}
                                    >
                                      {deletingUserId === accountUser.userId ? (
                                        <CircularProgress size={16} sx={{ color: '#ef4444' }} />
                                      ) : (
                                        <DeleteIcon fontSize="small" />
                                      )}
                                    </IconButton>
                                  )}
                                </Box>
                              </Box>
                            </Box>
                          ))}
                        </Box>
                      )}
                    </Box>

                    {/* Benutzer einladen (nur wenn Plan mehr als 1 User erlaubt) */}
                    {getAccountLimits(accountType).maxUsers > 1 && (
                  <Box sx={{ mt: 3 }}>
                    <Typography variant="caption" sx={{ 
                      fontWeight: 700, 
                      color: '#64748b', 
                      fontSize: '0.75rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      display: 'block',
                      mb: 1.5
                    }}>
                      {t('account.invite')}
                    </Typography>
                    <TextField
                      fullWidth
                      size="small"
                      type="email"
                      placeholder={t('account.invite.email.placeholder')}
                      key={`account-invite-email-${inviteEmail || ''}`}
                      defaultValue={inviteEmail}
                      onBlur={(e) => {
                        const nextValue = e.target.value;
                        if (nextValue !== inviteEmail) setInviteEmail(nextValue);
                      }}
                      disabled={invitingUser}
                      sx={{
                        mb: 1.5,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#667eea',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#667eea',
                          },
                        }
                      }}
                    />
                    <Button
                      variant="contained"
                      onClick={handleInviteUser}
                      disabled={invitingUser || !inviteEmail || accountUsers.length >= getAccountLimits(accountType).maxUsers}
                      fullWidth
                      sx={{
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: 'white',
                        fontWeight: 600,
                        py: 1.5,
                        '&:hover': {
                          background: 'linear-gradient(135deg, #5568d3 0%, #6a3f8f 100%)',
                        },
                        '&.Mui-disabled': {
                          background: 'linear-gradient(135deg, #cbd5e1 0%, #94a3b8 100%)',
                          color: 'white'
                        }
                      }}
                    >
                      {invitingUser ? (
                        <>
                          <CircularProgress size={16} sx={{ mr: 1, color: 'white' }} />
                          {t('account.invite.sending')}
                        </>
                      ) : (
                        t('account.invite.send')
                      )}
                    </Button>
                    {inviteSuccess && (
                      <Box sx={{ mt: 1.5 }}>
                        {emailSent ? (
                          <Alert severity="success">
                            {t('account.invite.success')}
                          </Alert>
                        ) : (
                          <Alert severity="warning">
                            <Typography variant="body2" sx={{ mb: 1 }}>
                              {t('account.invite.email.not.sent')}
                            </Typography>
                            {inviteLink && (
                              <Box sx={{ mt: 1 }}>
                                <Typography variant="caption" sx={{ display: 'block', mb: 0.5, fontWeight: 600 }}>
                                  {t('account.invite.link')}:
                                </Typography>
                                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                  <TextField
                                    fullWidth
                                    size="small"
                                    value={inviteLink}
                                    InputProps={{
                                      readOnly: true
                                    }}
                                    sx={{
                                      '& .MuiOutlinedInput-root': {
                                        backgroundColor: '#f8f9fa',
                                        fontSize: '0.75rem',
                                      }
                                    }}
                                  />
                                  <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={() => {
                                      navigator.clipboard.writeText(inviteLink);
                                    }}
                                    sx={{ whiteSpace: 'nowrap' }}
                                  >
                                    {t('account.invite.copy')}
                                  </Button>
                                </Box>
                              </Box>
                            )}
                          </Alert>
                        )}
                      </Box>
                    )}
                  </Box>
                    )}
                  </>
                )}
              </Box>
            </DialogContent>
            <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc', justifyContent: 'flex-end' }}>
              <Box sx={{ display: 'flex', gap: 1 }}>
                {/* Speichern-Button nur für Owner anzeigen */}
                {accountUsers.some((u: any) => u.userId === user?.uid && u.role === 'owner') && (
                  <Button 
                    onClick={handleSaveAccountType} 
                    variant="outlined"
                    disabled={savingAccountType}
                    sx={{
                      px: 3,
                      py: 1.5,
                      borderRadius: 3,
                      borderColor: '#667eea',
                      color: '#757575',
                      fontWeight: 600,
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        borderColor: '#764ba2',
                        backgroundColor: '#f5f5f5',
                        transform: 'translateY(-1px)',
                      },
                      '&.Mui-disabled': {
                        borderColor: '#cbd5e1',
                        color: '#94a3b8'
                      }
                    }}
                  >
                    {savingAccountType ? (
                      <>
                        <CircularProgress size={20} sx={{ mr: 1 }} />
                        {t('account.saving')}
                      </>
                    ) : (
                      t('account.save')
                    )}
                  </Button>
                )}
              </Box>
            </DialogActions>
          </Dialog>

          {/* Upgrade-Modal */}
          <Dialog
            open={upgradeModalOpen}
            onClose={handleUpgradeModalClose}
            maxWidth="sm"
            fullWidth
            sx={{ zIndex: 1800 }}
            PaperProps={{
              sx: {
                borderRadius: 3
              }
            }}
          >
            <DialogTitle sx={{ 
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              borderBottom: 'none'
            }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                  {upgradeModalReason === 'pdfLimitReached'
                    ? t('account.upgrade.limit.title')
                    : t('account.upgrade.title')}
                </Typography>
                <IconButton 
                  onClick={handleUpgradeModalClose}
                  sx={{ color: 'white' }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </DialogTitle>
            
            <DialogContent sx={{ p: 3, pt: 4 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, alignItems: 'center', textAlign: 'center' }}>
                <Typography variant="h6" sx={{ 
                  color: '#1e293b', 
                  fontWeight: 600,
                  mb: 1
                }}>
                  {upgradeModalReason === 'pdfLimitReached'
                    ? t('account.upgrade.limit.message')
                    : t('account.upgrade.message')}
                </Typography>
                <Typography variant="body1" sx={{ 
                  color: '#64748b', 
                  mb: 2
                }}>
                  {upgradeModalReason === 'pdfLimitReached'
                    ? t('account.upgrade.limit.description')
                    : t('account.upgrade.description')}
                </Typography>
              </Box>
            </DialogContent>
            
            <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc', justifyContent: 'flex-end', gap: 2 }}>
              <Button 
                onClick={handleUpgradeModalClose}
                variant="outlined"
                sx={{
                  px: 3,
                  py: 1.5,
                  borderRadius: 3,
                  borderColor: '#cbd5e1',
                  color: '#64748b',
                  fontWeight: 600,
                  '&:hover': {
                    borderColor: '#94a3b8',
                    backgroundColor: '#f1f5f9',
                  }
                }}
              >
                {t('common.cancel')}
              </Button>
              <Button 
                onClick={handleUpgradeToAccount}
                variant="contained"
                sx={{
                  px: 3,
                  py: 1.5,
                  borderRadius: 3,
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  fontWeight: 600,
                  '&:hover': {
                    background: 'linear-gradient(135deg, #5568d3 0%, #6a3f8f 100%)',
                  }
                }}
              >
                {t('account.upgrade.button')}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Pricing Plans Modal (Stripe) */}
          <PricingPlansWrapper
            open={pricingModalOpen}
            onClose={() => setPricingModalOpen(false)}
            currentPlan={accountType}
            user={user}
            onSubscriptionChange={() => {
              // Backend-Daten nachladen nach Plan-Wechsel
              setHasStripeSubscription(false);
              setTimeout(() => {
                loadSubscriptionStatus();
                loadAccountType();
              }, 300);
            }}
            language={currentLanguage}
            hasSubscription={hasStripeSubscription}
            cancelAtPeriodEnd={cancelAtPeriodEnd}
            currentPeriodEnd={currentPeriodEnd}
          />

          <Container maxWidth="md" sx={{ mt: 4, mb: 4, flex: 1, display: 'flex', flexDirection: 'column' }}>
            <Paper sx={{ p: 3, flex: 1, display: 'flex', flexDirection: 'column' }}>
        {/* Import-Fortschrittsanzeige mit Icons im Kreis um die Warte-Animation */}
        {extracting && (
          <Box sx={{ 
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            my: 10,
            minHeight: '360px'
          }}>
            <Box sx={{ 
              position: 'relative', 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center',
              minHeight: '136px'
            }}>
              {/* Zentrale Warte-Animation */}
              <CircularProgress size={54} sx={{ color: '#667eea' }} />
            
            {/* Icons im Kreis um die Animation */}
            {Object.keys(importProgress).length > 0 && (
              <>
                {Object.entries(importProgress).map(([taskName, status], index) => {
                  const totalIcons = Object.keys(importProgress).length;
                  const angle = (360 / totalIcons) * index;
                  const radius = 50; // Abstand vom Zentrum
                  const x = Math.cos((angle - 90) * Math.PI / 180) * radius;
                  const y = Math.sin((angle - 90) * Math.PI / 180) * radius;
                  
                  return (
                    <Box
                      key={`icon-${taskName}`}
                      title={taskName}
                      sx={{
                        position: 'absolute',
                        left: `calc(50% + ${x}px)`,
                        top: `calc(50% + ${y}px)`,
                        transform: 'translate(-50%, -50%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'help'
                      }}
                    >
                      {getTopicIcon(taskName, status)}
                    </Box>
                  );
                })}
              </>
            )}
            </Box>
            
            {/* Label unterhalb der Warte-Animation */}
            <Typography 
              variant="body2" 
              sx={{ 
                color: '#666',
                fontSize: '0.98rem',
                fontWeight: 500,
                textAlign: 'center',
                mt: 3
              }}
            >
              {getTranslatedCvLabel('CV Daten werden importiert...')}
            </Typography>
          </Box>
        )}
        
        {/* Warte-Animationen */}
        
            {/* Warte-Animation für Passgenauigkeit (nur wenn nicht im Modal) */}
            {checkingMatch && !checkingMatchInModal && (
              <Box sx={{ 
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center', 
                alignItems: 'center', 
                my: 10,
                minHeight: '360px'
              }}>
                <Box sx={{ 
                  position: 'relative', 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center',
                  minHeight: '136px'
                }}>
                  {/* Zentrale Warte-Animation */}
                  <CircularProgress size={54} sx={{ color: '#667eea' }} />
                  
                  {/* Passgenauigkeit-Icon in der Mitte */}
                  <Box
                    sx={{
                      position: 'absolute',
                      left: '50%',
                      top: '50%',
                      transform: 'translate(-50%, -50%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <AssessmentOutlinedIcon sx={{ fontSize: 27, color: '#667eea' }} />
                  </Box>
                </Box>
                
                {/* Label unterhalb der Passgenauigkeit Warte-Animation */}
                <Typography 
                  variant="body2" 
                  sx={{ 
                    color: '#666',
                    fontSize: '0.98rem',
                    fontWeight: 500,
                    textAlign: 'center',
                    mt: 3
                  }}
                >
                  {getTranslatedInfoMessage('calculating_match')}
                </Typography>
              </Box>
            )}
            
            
            {/* Progress-Anzeige für parallele Optimierung - Icons im Kreis */}
            {optimizing && Object.keys(optimizationProgress).length > 0 && (
              <Box sx={{ 
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                my: 10,
                minHeight: '360px'
              }}>
                {/* Icons im Kreis um eine zentrale Warte-Animation */}
                <Box sx={{ 
                  position: 'relative', 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center', 
                  minHeight: '136px'
                }}>
                  {/* Zentrale Warte-Animation */}
                  <CircularProgress size={54} sx={{ color: '#667eea' }} />
                  
                  {/* Icons im Kreis um die Animation */}
                  {Object.entries(optimizationProgress).map(([taskName, status], index) => {
                    const totalIcons = Object.keys(optimizationProgress).length;
                    const angle = (360 / totalIcons) * index;
                    const radius = 56; // Abstand vom Zentrum (20% kleiner als 70)
                    const x = Math.cos((angle - 90) * Math.PI / 180) * radius;
                    const y = Math.sin((angle - 90) * Math.PI / 180) * radius;
                    
                    return (
                      <Box
                        key={`opt-icon-${taskName}`}
                        title={taskName}
                        sx={{
                          position: 'absolute',
                          left: `calc(50% + ${x}px)`,
                          top: `calc(50% + ${y}px)`,
                          transform: 'translate(-50%, -50%) scale(1.12)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'help'
                        }}
                      >
                        {getOptimizationIcon(taskName, status)}
                      </Box>
                    );
                  })}
                </Box>
                
                {/* Label unterhalb der Warte-Animation */}
                <Typography 
                  variant="body2" 
                  sx={{ 
                    color: '#666',
                    fontSize: '0.98rem',
                    fontWeight: 500,
                    textAlign: 'center',
                    mt: 3
                  }}
                >
                  {getTranslatedInfoMessage('optimized_cv_being_created')}
                </Typography>
              </Box>
            )}
            
            {/* Optimierter CV Template-Anzeige */}
            {improvedCvText && (
              <Box sx={{ mb: 3 }}>

                

                




                {/* IT-Skill Selector Dialog */}
                <Dialog 
                  open={showItSkillSelector} 
                  onClose={() => setShowItSkillSelector(false)}
                  maxWidth="sm"
                  sx={{ zIndex: 1800 }}
                  BackdropProps={{
                    sx: {
                      backgroundColor: 'rgba(0, 0, 0, 0.25)'
                    }
                  }}
                >
                  <DialogTitle sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    borderBottom: 'none',
                    width: '100%',
                    maxWidth: '100%'
                  }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)', width: '100%', maxWidth: '100%' }}>
                        IT-Skill aus gespeicherten Daten hinzufügen
                      </Typography>
                      <IconButton onClick={() => setShowItSkillSelector(false)} sx={{ color: 'white' }}>
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  </DialogTitle>
                  <DialogContent sx={{ p: 3 }}>
                    <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
                      Wählen Sie einen IT-Skill aus Ihren gespeicherten Daten aus, um ihn zur relevanten Liste hinzuzufügen:
                    </Typography>
                    <Box sx={{ maxHeight: 400, overflow: 'auto' }}>
                            {itSkills && itSkills.length > 0 ? (
        itSkills
          .map((skill, index) => {
                          const isAlreadyInList = relevantItSkills.some(
                            relevantSkill => relevantSkill.skill === skill.skill && relevantSkill.level === skill.level
                          );
                          
                          return (
                            <Box
                              key={index}
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                p: 2,
                                mb: 1,
                                border: '1px solid #e2e8f0',
                                borderRadius: 2,
                                backgroundColor: isAlreadyInList ? '#f1f5f9' : 'white',
                                opacity: isAlreadyInList ? 0.6 : 1,
                                '&:hover': {
                                  backgroundColor: isAlreadyInList ? '#f1f5f9' : '#f8fafc',
                                  borderColor: '#cbd5e1'
                                }
                              }}
                            >
                              <Box>
                                <Typography variant="body1" sx={{ fontWeight: 600, color: '#1e293b' }}>
                                  {skill.skill || 'N/A'}
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#64748b' }}>
                                  Niveau: {skill.level || 'N/A'}
                                </Typography>
                              </Box>
                              <Button
                                variant="outlined"
                                size="small"
                                disabled={isAlreadyInList}
                                onClick={() => {
                                  handleAddItSkillFromStored(skill);
                                  setShowItSkillSelector(false);
                                }}
                                sx={{
                                  borderColor: '#10b981',
                                  color: '#10b981',
                                  '&:hover': {
                                    borderColor: '#059669',
                                    backgroundColor: '#f0fdf4'
                                  },
                                  '&:disabled': {
                                    borderColor: '#d1d5db',
                                    color: '#9ca3af'
                                  }
                                }}
                              >
                                {isAlreadyInList ? 'Bereits hinzugefügt' : 'Hinzufügen'}
                              </Button>
                            </Box>
                          );
                        })
                      ) : (
                        <Box sx={{ 
                          textAlign: 'center', 
                          py: 4,
                          color: '#94a3b8', 
                          fontStyle: 'italic'
                        }}>
                          Keine IT-Skills in gespeicherten Daten verfügbar
                        </Box>
                      )}
                    </Box>
                  </DialogContent>
                </Dialog>

                {/* Core Competency Selector Dialog */}
                <Dialog 
                  open={showCoreCompetencySelector} 
                  onClose={() => setShowCoreCompetencySelector(false)}
                  maxWidth="sm"
                  sx={{ zIndex: 1800 }}
                  BackdropProps={{
                    sx: {
                      backgroundColor: 'rgba(0, 0, 0, 0.25)'
                    }
                  }}
                >
                  <DialogTitle sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    borderBottom: 'none',
                    width: '100%',
                    maxWidth: '100%'
                  }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)', width: '100%', maxWidth: '100%' }}>
                        {getTranslatedCvLabel('Kernkompetenz aus gespeicherten Daten hinzufügen')}
                      </Typography>
                      <IconButton onClick={() => setShowCoreCompetencySelector(false)} sx={{ color: 'white' }}>
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  </DialogTitle>
                  <DialogContent sx={{ p: 3 }}>
                    <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
                      Wählen Sie eine Kernkompetenz aus Ihren gespeicherten Daten aus, um sie zur relevanten Liste hinzuzufügen:
                    </Typography>
                    <Box sx={{ maxHeight: 400, overflow: 'auto' }}>
                            {coreCompetencies && coreCompetencies.length > 0 ? (
        coreCompetencies
          .map((competency, index) => {
                          const isAlreadyInList = relevantCoreCompetencies.some(
                            relevantComp => relevantComp.competency === competency.competency
                          );
                          
                          return (
                            <Box
                              key={index}
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                p: 2,
                                mb: 1,
                                border: '1px solid #e2e8f0',
                                borderRadius: 2,
                                backgroundColor: isAlreadyInList ? '#f1f5f9' : 'white',
                                opacity: isAlreadyInList ? 0.6 : 1,
                                '&:hover': {
                                  backgroundColor: isAlreadyInList ? '#f1f5f9' : '#f8fafc',
                                  borderColor: '#cbd5e1'
                                }
                              }}
                            >
                              <Box>
                                <Typography variant="body1" sx={{ fontWeight: 600, color: '#1e293b' }}>
                                  {competency.competency || 'N/A'}
                                </Typography>
                              </Box>
                              <Button
                                variant="outlined"
                                size="small"
                                disabled={isAlreadyInList}
                                onClick={() => {
                                  handleAddCoreCompetencyFromStored(competency);
                                  setShowCoreCompetencySelector(false);
                                }}
                                sx={{
                                  borderColor: '#10b981',
                                  color: '#10b981',
                                  '&:hover': {
                                    borderColor: '#059669',
                                    backgroundColor: '#f0fdf4'
                                  },
                                  '&:disabled': {
                                    borderColor: '#d1d5db',
                                    color: '#9ca3af'
                                  }
                                }}
                              >
                                {isAlreadyInList ? 'Bereits hinzugefügt' : 'Hinzufügen'}
                              </Button>
                            </Box>
                          );
                        })
                      ) : (
                        <Box sx={{ 
                          textAlign: 'center', 
                          py: 4,
                          color: '#94a3b8', 
                          fontStyle: 'italic'
                        }}>
                          Keine Kernkompetenzen in gespeicherten Daten verfügbar
                        </Box>
                      )}
                    </Box>
                  </DialogContent>
                </Dialog>

                {/* Certification Selector Dialog */}
                <Dialog 
                  open={showCertificationSelector} 
                  onClose={() => setShowCertificationSelector(false)}
                  maxWidth="sm"
                  sx={{ zIndex: 1800 }}
                  BackdropProps={{
                    sx: {
                      backgroundColor: 'rgba(0, 0, 0, 0.25)'
                    }
                  }}
                >
                  <DialogTitle sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    borderBottom: 'none',
                    width: '100%',
                    maxWidth: '100%'
                  }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)', width: '100%', maxWidth: '100%' }}>
                        Zertifizierung aus gespeicherten Daten hinzufügen
                      </Typography>
                      <IconButton onClick={() => setShowCertificationSelector(false)} sx={{ color: 'white' }}>
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  </DialogTitle>
                  <DialogContent sx={{ p: 3 }}>
                    <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
                      Wählen Sie eine Zertifizierung aus Ihren gespeicherten Daten aus, um sie zur relevanten Liste hinzuzufügen:
                    </Typography>
                    <Box sx={{ maxHeight: 400, overflow: 'auto' }}>
                      {certifications && certifications.length > 0 ? (
                        certifications
                          .map((certification: { name: string; issuer: string; date: string }, index: number) => {
                          const isAlreadyInList = relevantCertifications.some(
                            relevantCert => relevantCert.name === certification.name && relevantCert.issuer === certification.issuer
                          );
                          
                          return (
                            <Box
                              key={index}
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                p: 2,
                                mb: 1,
                                border: '1px solid #e2e8f0',
                                borderRadius: 2,
                                backgroundColor: isAlreadyInList ? '#f1f5f9' : 'white',
                                opacity: isAlreadyInList ? 0.6 : 1,
                                '&:hover': {
                                  backgroundColor: isAlreadyInList ? '#f1f5f9' : '#f8fafc',
                                  borderColor: '#cbd5e1'
                                }
                              }}
                            >
                              <Box sx={{ flex: 1, mr: 2 }}>
                                <Typography variant="body1" sx={{ fontWeight: 600, color: '#1e293b', mb: 1 }}>
                                  {certification.name || 'N/A'}
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#64748b', fontSize: '0.85rem', mb: 0.5 }}>
                                  Aussteller: {certification.issuer || 'N/A'}
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#64748b', fontSize: '0.85rem' }}>
                                  Datum: {certification.date || 'N/A'}
                                </Typography>
                              </Box>
                              <Button
                                variant="outlined"
                                size="small"
                                disabled={isAlreadyInList}
                                onClick={() => {
                                  handleAddCertificationFromStored(certification);
                                  setShowCertificationSelector(false);
                                }}
                                sx={{
                                  borderColor: '#10b981',
                                  color: '#10b981',
                                  '&:hover': {
                                    borderColor: '#059669',
                                    backgroundColor: '#f0fdf4'
                                  },
                                  '&:disabled': {
                                    borderColor: '#d1d5db',
                                    color: '#9ca3af'
                                  }
                                }}
                              >
                                {isAlreadyInList ? 'Bereits hinzugefügt' : 'Hinzufügen'}
                              </Button>
                            </Box>
                          );
                        })
                      ) : (
                        <Box sx={{ 
                          textAlign: 'center', 
                          py: 4,
                          color: '#94a3b8', 
                          fontStyle: 'italic'
                        }}>
                          Keine Zertifizierungen in gespeicherten Daten verfügbar
                        </Box>
                      )}
                    </Box>
                  </DialogContent>
                </Dialog>

                {/* Additional Info Selector Dialog */}
                <Dialog 
                  open={showAdditionalInfoSelector} 
                  onClose={() => setShowAdditionalInfoSelector(false)}
                  maxWidth="sm"
                  sx={{ zIndex: 1800 }}
                  BackdropProps={{
                    sx: {
                      backgroundColor: 'rgba(0, 0, 0, 0.25)'
                    }
                  }}
                >
                  <DialogTitle sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    borderBottom: 'none',
                    width: '100%',
                    maxWidth: '100%'
                  }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)', width: '100%', maxWidth: '100%' }}>
                        Weitere Information aus gespeicherten Daten hinzufügen
                      </Typography>
                      <IconButton onClick={() => setShowAdditionalInfoSelector(false)} sx={{ color: 'white' }}>
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  </DialogTitle>
                  <DialogContent sx={{ p: 3 }}>
                    <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
                      Wählen Sie eine weitere Information aus Ihren gespeicherten Daten aus, um sie zur relevanten Liste hinzuzufügen:
                    </Typography>
                    <Box sx={{ maxHeight: 400, overflow: 'auto' }}>
                            {additionalInfo && additionalInfo.length > 0 ? (
        additionalInfo
          .map((info, index) => {
                          const isAlreadyInList = relevantAdditionalInfo.some(
                            relevantInfo => relevantInfo.info === info.info && relevantInfo.details === info.details
                          );
                          
                          return (
                            <Box
                              key={index}
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                p: 2,
                                mb: 1,
                                border: '1px solid #e2e8f0',
                                borderRadius: 2,
                                backgroundColor: isAlreadyInList ? '#f1f5f9' : 'white',
                                opacity: isAlreadyInList ? 0.6 : 1,
                                '&:hover': {
                                  backgroundColor: isAlreadyInList ? '#f1f5f9' : '#f8fafc',
                                  borderColor: '#cbd5e1'
                                }
                              }}
                            >
                              <Box sx={{ flex: 1, mr: 2 }}>
                                <Typography variant="body1" sx={{ fontWeight: 600, color: '#1e293b', mb: 1 }}>
                                  {info.info || 'N/A'}
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#64748b', fontSize: '0.85rem' }}>
                                  {info.details || 'N/A'}
                                </Typography>
                              </Box>
                              <Button
                                variant="outlined"
                                size="small"
                                disabled={isAlreadyInList}
                                onClick={() => {
                                  handleAddAdditionalInfoFromStored(info);
                                  setShowAdditionalInfoSelector(false);
                                }}
                                sx={{
                                  borderColor: '#10b981',
                                  color: '#10b981',
                                  '&:hover': {
                                    borderColor: '#059669',
                                    backgroundColor: '#f0fdf4'
                                  },
                                  '&:disabled': {
                                    borderColor: '#d1d5db',
                                    color: '#9ca3af'
                                  }
                                }}
                              >
                                {isAlreadyInList ? 'Bereits hinzugefügt' : 'Hinzufügen'}
                              </Button>
                            </Box>
                          );
                        })
                      ) : (
                        <Box sx={{ 
                          textAlign: 'center', 
                          py: 4,
                          color: '#94a3b8', 
                          fontStyle: 'italic'
                        }}>
                          Keine weiteren Informationen in gespeicherten Daten verfügbar
                        </Box>
                      )}
                    </Box>
                  </DialogContent>
                </Dialog>

                {/* Education Selector Dialog */}
                <Dialog 
                  open={showEducationSelector} 
                  onClose={() => setShowEducationSelector(false)}
                  maxWidth="sm"
                  sx={{ zIndex: 1800 }}
                  BackdropProps={{
                    sx: {
                      backgroundColor: 'rgba(0, 0, 0, 0.25)'
                    }
                  }}
                >
                  <DialogTitle sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    borderBottom: 'none',
                    width: '100%',
                    maxWidth: '100%'
                  }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)', width: '100%', maxWidth: '100%' }}>
                        Ausbildung aus gespeicherten Daten hinzufügen
                      </Typography>
                      <IconButton onClick={() => setShowEducationSelector(false)} sx={{ color: 'white' }}>
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  </DialogTitle>
                  <DialogContent sx={{ p: 3 }}>
                    <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
                      Wählen Sie eine Ausbildung aus Ihren gespeicherten Daten aus, um sie zur relevanten Liste hinzuzufügen:
                    </Typography>
                    <Box sx={{ maxHeight: 400, overflow: 'auto' }}>
                      {educations && educations.length > 0 ? (
                        educations.map((education, index) => {
                          const isAlreadyInList = relevantEducations.some(
                            relevantEdu => relevantEdu.institution === education.institution && relevantEdu.degree === education.degree
                          );
                          
                          return (
                            <Box
                              key={index}
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                p: 2,
                                mb: 1,
                                border: '1px solid #e2e8f0',
                                borderRadius: 2,
                                backgroundColor: isAlreadyInList ? '#f1f5f9' : 'white',
                                opacity: isAlreadyInList ? 0.6 : 1,
                                '&:hover': {
                                  backgroundColor: isAlreadyInList ? '#f1f5f9' : '#f8fafc',
                                  borderColor: '#cbd5e1'
                                }
                              }}
                            >
                              <Box>
                                <Typography variant="body1" sx={{ fontWeight: 600, color: '#1e293b' }}>
                                  {education.degree || 'N/A'}
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#64748b' }}>
                                  {education.institution || 'N/A'}
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#94a3b8', fontSize: '0.875rem' }}>
                                  {education.startDate} - {education.endDate}
                                </Typography>
                              </Box>
                              <Button
                                variant="outlined"
                                size="small"
                                disabled={isAlreadyInList}
                                onClick={() => {
                                  handleAddEducationFromStored(education);
                                  setShowEducationSelector(false);
                                }}
                                sx={{
                                  borderColor: '#10b981',
                                  color: '#10b981',
                                  '&:hover': {
                                    borderColor: '#059669',
                                    backgroundColor: '#f0fdf4'
                                  },
                                  '&:disabled': {
                                    borderColor: '#d1d5db',
                                    color: '#9ca3af'
                                  }
                                }}
                              >
                                {isAlreadyInList ? 'Bereits hinzugefügt' : 'Hinzufügen'}
                              </Button>
                            </Box>
                          );
                        })
                      ) : (
                        <Box sx={{ 
                          textAlign: 'center', 
                          py: 4,
                          color: '#94a3b8', 
                          fontStyle: 'italic'
                        }}>
                          Keine Ausbildungen in gespeicherten Daten verfügbar
                        </Box>
                      )}
                    </Box>
                  </DialogContent>
                </Dialog>

                {/* Industry Selector Dialog */}
                <Dialog 
                  open={showIndustrySelector} 
                  onClose={() => setShowIndustrySelector(false)}
                  maxWidth="sm"
                  sx={{ zIndex: 1800 }}
                  BackdropProps={{
                    sx: {
                      backgroundColor: 'rgba(0, 0, 0, 0.25)'
                    }
                  }}
                >
                  <DialogTitle sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    borderBottom: 'none',
                    width: '100%',
                    maxWidth: '100%'
                  }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)', width: '100%', maxWidth: '100%' }}>
                        Branche aus gespeicherten Daten hinzufügen
                      </Typography>
                      <IconButton onClick={() => setShowIndustrySelector(false)} sx={{ color: 'white' }}>
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  </DialogTitle>
                  <DialogContent sx={{ p: 3 }}>
                    <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
                      Wählen Sie eine Branche aus Ihren gespeicherten Daten aus, um sie zur relevanten Liste hinzuzufügen:
                    </Typography>
                    <Box sx={{ maxHeight: 400, overflow: 'auto' }}>
                      {industryExperiences && industryExperiences.length > 0 ? (
                        industryExperiences.map((industry, index) => {
                          const isAlreadyInList = relevantIndustries.some(
                            relevantIndustry => relevantIndustry.industry === industry.industry
                          );
                          
                          return (
                            <Box
                              key={index}
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                p: 2,
                                mb: 1,
                                border: '1px solid #e2e8f0',
                                borderRadius: 2,
                                backgroundColor: isAlreadyInList ? '#f1f5f9' : 'white',
                                opacity: isAlreadyInList ? 0.6 : 1,
                                '&:hover': {
                                  backgroundColor: isAlreadyInList ? '#f1f5f9' : '#f8fafc',
                                  borderColor: '#cbd5e1'
                                }
                              }}
                            >
                              <Box>
                                <Typography variant="body1" sx={{ fontWeight: 600, color: '#1e293b' }}>
                                  {industry.industry || 'N/A'}
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#64748b' }}>
                                  {industry.years} {translatedYears} Erfahrung
                                </Typography>
                              </Box>
                              <Button
                                variant="outlined"
                                size="small"
                                disabled={isAlreadyInList}
                                onClick={() => {
                                  handleAddIndustryFromStored(industry);
                                  setShowIndustrySelector(false);
                                }}
                                sx={{
                                  borderColor: '#10b981',
                                  color: '#10b981',
                                  '&:hover': {
                                    borderColor: '#059669',
                                    backgroundColor: '#f0fdf4'
                                  },
                                  '&:disabled': {
                                    borderColor: '#d1d5db',
                                    color: '#9ca3af'
                                  }
                                }}
                              >
                                {isAlreadyInList ? 'Bereits hinzugefügt' : 'Hinzufügen'}
                              </Button>
                            </Box>
                          );
                        })
                      ) : (
                        <Box sx={{ 
                          textAlign: 'center', 
                          py: 4,
                          color: '#94a3b8', 
                          fontStyle: 'italic'
                        }}>
                          Keine Branchen in gespeicherten Daten verfügbar
                        </Box>
                      )}
                    </Box>
                  </DialogContent>
                </Dialog>

                {/* Hobby Selector Dialog */}
                <Dialog 
                  open={showHobbySelector} 
                  onClose={() => setShowHobbySelector(false)}
                  maxWidth="sm"
                  sx={{ zIndex: 1800 }}
                  BackdropProps={{
                    sx: {
                      backgroundColor: 'rgba(0, 0, 0, 0.25)'
                    }
                  }}
                >
                  <DialogTitle sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    borderBottom: 'none',
                    width: '100%',
                    maxWidth: '100%'
                  }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)', width: '100%', maxWidth: '100%' }}>
                        Hobby aus gespeicherten Daten hinzufügen
                      </Typography>
                      <IconButton onClick={() => setShowHobbySelector(false)} sx={{ color: 'white' }}>
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  </DialogTitle>
                  <DialogContent sx={{ p: 3 }}>
                    <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
                      Wählen Sie ein Hobby aus Ihren gespeicherten Daten aus, um es zur relevanten Liste hinzuzufügen:
                    </Typography>
                    <Box sx={{ maxHeight: 400, overflow: 'auto' }}>
                            {hobbies && hobbies.length > 0 ? (
        hobbies.map((hobby, index) => {
                          const isAlreadyInList = relevantHobbies.some(
                            relevantHobby => isSameHobbyEntry(relevantHobby, hobby)
                          );
                          
                          return (
                            <Box
                              key={index}
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                p: 2,
                                mb: 1,
                                border: '1px solid #e2e8f0',
                                borderRadius: 2,
                                backgroundColor: isAlreadyInList ? '#f1f5f9' : 'white',
                                opacity: isAlreadyInList ? 0.6 : 1,
                                '&:hover': {
                                  backgroundColor: isAlreadyInList ? '#f1f5f9' : '#f8fafc',
                                  borderColor: '#cbd5e1'
                                }
                              }}
                            >
                              <Box>
                                <Typography variant="body1" sx={{ fontWeight: 600, color: '#1e293b' }}>
                                  {hobby.hobby || 'N/A'}
                                </Typography>
                                {hobby.description && (
                                  <Typography variant="body2" sx={{ color: '#64748b' }}>
                                    {hobby.description}
                                  </Typography>
                                )}
                              </Box>
                              <Button
                                variant="outlined"
                                size="small"
                                disabled={isAlreadyInList}
                                onClick={() => {
                                  handleAddHobbyFromStored(hobby);
                                  setShowHobbySelector(false);
                                }}
                                sx={{
                                  borderColor: '#10b981',
                                  color: '#10b981',
                                  '&:hover': {
                                    borderColor: '#059669',
                                    backgroundColor: '#f0fdf4'
                                  },
                                  '&:disabled': {
                                    borderColor: '#d1d5db',
                                    color: '#9ca3af'
                                  }
                                }}
                              >
                                {isAlreadyInList ? 'Bereits hinzugefügt' : 'Hinzufügen'}
                              </Button>
                            </Box>
                          );
                        })
                      ) : (
                        <Box sx={{ 
                          textAlign: 'center', 
                          py: 4,
                          color: '#94a3b8', 
                          fontStyle: 'italic'
                        }}>
                          Keine Hobbys in gespeicherten Daten verfügbar
                        </Box>
                      )}
                    </Box>
                  </DialogContent>
                </Dialog>

                {/* Language Selector Dialog */}
                <Dialog 
                  open={showLanguageSelector} 
                  onClose={() => setShowLanguageSelector(false)}
                  maxWidth="sm"
                  sx={{ zIndex: 1800 }}
                  BackdropProps={{
                    sx: {
                      backgroundColor: 'rgba(0, 0, 0, 0.25)'
                    }
                  }}
                >
                  <DialogTitle sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    borderBottom: 'none',
                    width: '100%',
                    maxWidth: '100%'
                  }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)', width: '100%', maxWidth: '100%' }}>
                        Sprache aus gespeicherten Daten hinzufügen
                      </Typography>
                      <IconButton onClick={() => setShowLanguageSelector(false)} sx={{ color: 'white' }}>
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  </DialogTitle>
                  <DialogContent sx={{ p: 3 }}>
                    <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
                      Wählen Sie eine Sprache aus Ihren gespeicherten Daten aus, um sie zur relevanten Liste hinzuzufügen:
                    </Typography>
                    <Box sx={{ maxHeight: 400, overflow: 'auto' }}>
                            {languages && languages.length > 0 ? (
        languages.map((language, index) => {
                          const isAlreadyInList = relevantLanguages.some(
                            relevantLang => relevantLang.language === language.language && relevantLang.level === language.level
                          );
                          
                          return (
                            <Box
                              key={index}
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                p: 2,
                                mb: 1,
                                border: '1px solid #e2e8f0',
                                borderRadius: 2,
                                backgroundColor: isAlreadyInList ? '#f1f5f9' : 'white',
                                opacity: isAlreadyInList ? 0.6 : 1,
                                '&:hover': {
                                  backgroundColor: isAlreadyInList ? '#f1f5f9' : '#f8fafc',
                                  borderColor: '#cbd5e1'
                                }
                              }}
                            >
                              <Box>
                                <Typography variant="body1" sx={{ fontWeight: 600, color: '#1e293b' }}>
                                  {language.language || 'N/A'}
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#64748b' }}>
                                  Niveau: {language.level || 'N/A'}
                                </Typography>
                              </Box>
                              <Button
                                variant="outlined"
                                size="small"
                                disabled={isAlreadyInList}
                                onClick={() => {
                                  handleAddLanguageFromStored(language);
                                  setShowLanguageSelector(false);
                                }}
                                sx={{
                                  borderColor: '#10b981',
                                  color: '#10b981',
                                  '&:hover': {
                                    borderColor: '#059669',
                                    backgroundColor: '#f0fdf4'
                                  },
                                  '&:disabled': {
                                    borderColor: '#d1d5db',
                                    color: '#9ca3af'
                                  }
                                }}
                              >
                                {isAlreadyInList ? 'Bereits hinzugefügt' : 'Hinzufügen'}
                              </Button>
                            </Box>
                          );
                        })
                      ) : (
                        <Box sx={{ 
                          textAlign: 'center', 
                          py: 4,
                          color: '#94a3b8', 
                          fontStyle: 'italic'
                        }}>
                          Keine Sprachen in gespeicherten Daten verfügbar
                        </Box>
                      )}
                    </Box>
                  </DialogContent>
                </Dialog>
              </Box>
            )}

            {/* Motivationsschreiben wird jetzt in einem Dialog angezeigt */}
        
        {/* Warte-Animation für CV-Preview - nicht anzeigen während CV optimiert wird */}
        {loadingCvPreview && !optimizing && (
            <Box sx={{ 
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              my: 10,
              minHeight: '360px'
            }}>
              <Box sx={{ 
                position: 'relative', 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                minHeight: '136px'
              }}>
                {/* Zentrale Warte-Animation */}
                <CircularProgress size={54} sx={{ color: '#667eea' }} />
                
                {/* CV-Icon in der Mitte */}
                <Box
                  sx={{
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <DescriptionOutlinedIcon sx={{ fontSize: 27, color: '#667eea' }} />
                </Box>
              </Box>
              
              {/* Label unterhalb der Warte-Animation */}
              <Typography 
                variant="body2" 
                sx={{ 
                  color: '#666',
                  fontSize: '0.98rem',
                  fontWeight: 500,
                  textAlign: 'center',
                  mt: 3
                }}
              >
                {getTranslatedInfoMessage('loading_cv_preview')}
              </Typography>
            </Box>
        )}
        
        {/* CV-Daten Tabs - versteckt während Warte-Animationen */}
        {!extracting && !checkingMatch && !optimizing && !loadingCvPreview && (
          <Box id="cv-data-section" sx={{ mb: 3 }}>
              <>
                {/* Tabs in einer Zeile */}
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Tabs value={cvTabIndex} onChange={handleCvTabChange} variant="scrollable" scrollButtons="auto">
                    <Tab label={t('cv.tab.start')} />
                    <Tab label={t('cv.tab.data')} />
                  </Tabs>
                </Box>
          
          {cvTabIndex === 1 && (
            <Box sx={{ mt: 3 }}>

              
              
            </Box>
          )}

          {cvTabIndex === 1 && (
            <Box sx={{ mt: 3 }}>
              {/* Info-Textbox für Tab 0 - nur anzeigen wenn nicht minimiert */}
              {!minimizedInfoBoxes['cvData'] && (
                <Box sx={{ mb: 3 }}>
                  <Alert 
                    severity="info" 
                    sx={{ 
                      borderRadius: 2,
                      backgroundColor: '#f0f7ff',
                      border: '1px solid #b3d9ff',
                      '& .MuiAlert-icon': {
                        color: '#1976d2'
                      }
                    }}
                    action={
                      <IconButton size="small" onClick={() => setMinimizedInfoBoxes(prev => ({ ...prev, cvData: true }))}>
                        <CloseIcon fontSize="small" sx={{ color: '#1976d2' }} />
                      </IconButton>
                    }
                  >
                    <Typography variant="body2" sx={{ color: '#1976d2', fontWeight: 500 }}>
                      {currentLanguage === 'de' ? 'Mit einem Klick auf "Hinzufügen" kannst du CV-Daten erfassen. Du kannst mehr als ein Daten-Set anlegen. Welche Daten für Bewerbungen verwendet werden, legst du über das Dropdown "CV-Daten Set" bei den Job-Informationen fest. Für eine neue Bewerbung wechsle in den Tab "Bewerbungen".' :
                       currentLanguage === 'en' ? 'With a click on "Add" you can capture CV data. You can create more than one data set. Which data set is used for applications is selected via the "CV Data Set" dropdown in Job Information. If you want to start a new application, switch to the "Applications" tab.' :
                       currentLanguage === 'fr' ? 'Avec un clic sur "Ajouter", vous pouvez saisir des données CV. Vous pouvez créer plus d\'un ensemble de données. Le jeu de données utilisé pour les candidatures se sélectionne via la liste déroulante "CV Data Set" dans les informations du poste. Pour commencer une nouvelle candidature, passez à l\'onglet "Candidatures".' :
                       'Con un clic su "Aggiungi" puoi acquisire i dati CV. Puoi creare più di un set di dati. Il set usato per le candidature si seleziona dal menu a tendina "CV Data Set" nelle informazioni del lavoro. Se vuoi iniziare una nuova candidatura, passa alla scheda "Candidature".'}
                    </Typography>
                  </Alert>
                </Box>
              )}
              {/* Tabelle: Meine CV Daten */}
              <Box 
                sx={{ 
                  border: '1px solid #e0e0e0',
                  borderRadius: 2,
                  bgcolor: 'white',
                  overflow: 'hidden',
                  mb: 3
                }}
              >
                <Box 
                  sx={{ 
                    py: 1.5, 
                    px: 2,
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    overflow: 'hidden'
                  }}
                  onDragOver={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                  onDrop={async (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    // Prüfe ob Dateien gedroppt wurden
                    const files = e.dataTransfer.files;
                    if (files && files.length > 0) {
                      const file = files[0];
                      
                      // Prüfe Dateityp
                      const fileExt = file.name.split('.').pop()?.toLowerCase();
                      if (!fileExt || !['docx', 'doc', 'pdf', 'txt'].includes(fileExt)) {
                        setError('Nur Word-Dateien (.docx, .doc), PDF-Dateien (.pdf) und Text-Dateien (.txt) werden unterstützt.');
                        return;
                      }
                      
                      // Prüfe Dateigröße (max 10MB)
                      if (file.size > 10 * 1024 * 1024) {
                        setError('Datei ist zu groß. Maximale Größe: 10MB.');
                        return;
                      }
                      
                      // Starte CV-Import-Prozess
                      console.log('📄 Datei per Drag & Drop auf Header empfangen:', file.name);
                      setCvFile(file);
                      uploadOriginalDocument(file);
                    }
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <StorageIcon sx={{ fontSize: 22 }} />
                      <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                        {getTranslatedCvLabel('Meine CV Daten')}
                      </Typography>
                      <Tooltip title={getTranslatedCvLabel('Info anzeigen')} arrow>
                        <IconButton
                          size="small"
                          onClick={() => setMinimizedInfoBoxes(prev => ({ ...prev, cvData: false }))}
                          sx={{
                            color: 'white',
                            p: 0.5,
                            '&:hover': {
                              bgcolor: 'rgba(255,255,255,0.1)'
                            }
                          }}
                        >
                          <InfoOutlinedIcon sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Tooltip>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <IconButton
                        size="small"
                        onClick={() => setShowCvDataFilters(!showCvDataFilters)}
                        sx={{
                          color: 'white',
                          '&:hover': {
                            bgcolor: 'rgba(255,255,255,0.1)'
                          }
                        }}
                        title={showCvDataFilters ? getTranslatedCvLabel('Filter verbergen') : getTranslatedCvLabel('Filter anzeigen')}
                      >
                        {showCvDataFilters ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => setShowAddCvModal(true)}
                        sx={{ 
                          bgcolor: 'rgba(255,255,255,0.2)',
                          border: '1px solid rgba(255,255,255,0.3)',
                          color: 'white',
                          width: 32,
                          height: 32,
                          borderRadius: '50%',
                          backdropFilter: 'blur(10px)',
                          boxShadow: (!userCvs || userCvs.length === 0)
                            ? '0 0 0 0 rgba(255,255,255,0.8)'
                            : 'none',
                          '@keyframes cvDataAddPulse': {
                            '0%': {
                              boxShadow: '0 0 0 0 rgba(255,255,255,0.8)',
                              transform: 'scale(1)',
                            },
                            '50%': {
                              boxShadow: '0 0 0 16px rgba(255,255,255,0)',
                              transform: 'scale(1.1)',
                            },
                            '100%': {
                              boxShadow: '0 0 0 0 rgba(255,255,255,0)',
                              transform: 'scale(1)',
                            }
                          },
                          animation: (!userCvs || userCvs.length === 0)
                            ? 'cvDataAddPulse 1.5s ease-in-out infinite'
                            : 'none',
                          '&:hover': {
                            bgcolor: 'rgba(255,255,255,0.3)',
                            borderColor: 'rgba(255,255,255,0.5)',
                            transform: 'translateY(-1px)',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                          },
                          transition: 'all 0.2s ease'
                        }}
                      >
                        <AddIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  </Box>
                </Box>
                
                {/* Such-Filter für CV Daten */}
                {showCvDataFilters && (
                <Box sx={{ p: 2, bgcolor: '#f8fafc', borderBottom: '1px solid #e2e8f0', display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
                  <TextField
                    label={getTranslatedCvLabel('Suche')}
                    placeholder={getTranslatedCvLabel('CV Name, E-Mail...')}
                    key={`cv-data-search-${cvDataSearchText || ''}`}
                    defaultValue={cvDataSearchText}
                    onBlur={(e) => {
                      const nextValue = e.target.value;
                      if (nextValue !== cvDataSearchText) setCvDataSearchText(nextValue);
                    }}
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{ 
                      width: '250px',
                      '& .MuiOutlinedInput-root': {
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#667eea'
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#667eea'
                        }
                      }
                    }}
                  />
                  {cvDataSearchText && (
                    <Button
                      size="small"
                      onClick={() => {
                        setCvDataSearchText('');
                      }}
                      sx={{
                        color: '#64748b',
                        textTransform: 'none',
                        '&:hover': {
                          bgcolor: 'rgba(0,0,0,0.04)'
                        }
                      }}
                    >
                      {getTranslatedCvLabel('Filter zurücksetzen')}
                    </Button>
                  )}
                </Box>
                )}
                
                <TableContainer sx={{ maxHeight: 'calc(100vh - 200px)', overflow: 'auto' }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.8rem', backgroundColor: '#f8fafc', position: 'sticky', top: 0, zIndex: 1, py: 1 }}>
                          {getTranslatedCvLabel('CV Name')}
                        </TableCell>
                        <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.8rem', backgroundColor: '#f8fafc', position: 'sticky', top: 0, zIndex: 1, py: 1 }}>
                          {getTranslatedCvLabel('Letzte Änderung')}
                        </TableCell>
                        <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.8rem', backgroundColor: '#f8fafc', position: 'sticky', top: 0, zIndex: 1, py: 1 }}>
                          {getTranslatedCvLabel('E-Mail')}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {userCvs.filter(cv => {
                        if (cvDataSearchText) {
                          const searchLower = cvDataSearchText.toLowerCase();
                          const nameMatch = (cv.cvName || '').toLowerCase().includes(searchLower);
                          const emailMatch = (cv.email || '').toLowerCase().includes(searchLower);
                          if (!nameMatch && !emailMatch) return false;
                        }
                        return true;
                      }).sort((a, b) => (b.cvName || '').localeCompare(a.cvName || '', currentLanguage, { sensitivity: 'base' })).length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={3} sx={{ textAlign: 'center', py: 4, color: '#6b7280' }}>
                            {getTranslatedCvLabel('Keine CV Daten vorhanden')}
                          </TableCell>
                        </TableRow>
                      ) : (
                        userCvs.filter(cv => {
                          if (cvDataSearchText) {
                            const searchLower = cvDataSearchText.toLowerCase();
                            const nameMatch = (cv.cvName || '').toLowerCase().includes(searchLower);
                            const emailMatch = (cv.email || '').toLowerCase().includes(searchLower);
                            if (!nameMatch && !emailMatch) return false;
                          }
                          return true;
                        }).sort((a, b) => (b.cvName || '').localeCompare(a.cvName || '', currentLanguage, { sensitivity: 'base' })).map((cv, index) => (
                          <TableRow 
                            key={cv.cvId || index} 
                            sx={{ 
                              '&:hover': { bgcolor: '#f8fafc', cursor: 'pointer' },
                              bgcolor: selectedCvId === cv.cvId ? '#f0f9ff' : 'transparent'
                            }}
                            onClick={async () => {
                              if (!cv.cvId) {
                                console.error('❌ Keine cvId gefunden für CV:', cv);
                                return;
                              }

                              // Beim Öffnen über Tabellenklick auf CV-Modus umschalten
                              clearOptimizedAndMatchData();
                              setSelectedApplicationId(null);
                              await handleSelectCv(cv.cvId, true, true, true); // openModal=true, setAsDefault=true, clearMatchScore=true
                            }}
                          >
                            <TableCell sx={{ fontWeight: 500 }}>
                              {cv.cvName || `CV ${index + 1}`}
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2" sx={{ color: '#64748b', fontSize: '0.85rem' }}>
                                {(() => {
                                  // Versuche lastModified zu parsen
                                  let date: Date | null = null;
                                  
                                  if (cv.lastModified?.seconds) {
                                    date = new Date(cv.lastModified.seconds * 1000);
                                  } else if (cv.lastModified?._seconds) {
                                    date = new Date(cv.lastModified._seconds * 1000);
                                  } else if (cv.lastModified && typeof cv.lastModified === 'string') {
                                    date = new Date(cv.lastModified);
                                  } else if (cv.createdAt?.seconds) {
                                    date = new Date(cv.createdAt.seconds * 1000);
                                  } else if (cv.createdAt?._seconds) {
                                    date = new Date(cv.createdAt._seconds * 1000);
                                  }
                                  
                                  // Prüfe ob Datum gültig ist
                                  if (date && !isNaN(date.getTime())) {
                                    const dateStr = date.toLocaleDateString(currentLanguage, {
                                      year: 'numeric',
                                      month: 'short',
                                      day: 'numeric'
                                    });
                                    const timeStr = date.toLocaleTimeString(currentLanguage, {
                                      hour: '2-digit',
                                      minute: '2-digit'
                                    });
                                    return `${dateStr}, ${timeStr}`;
                                  }
                                  return '-';
                                })()}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              {cv.email || '-'}
                            </TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>

              
            </Box>
          )}
          
          {cvTabIndex === 0 && (
            <Box sx={{ mt: 3 }}>
              {/* Sub-Tabs für Bewerbungen - Nur für Admin sichtbar */}
              {isAdmin() && (
                <Tabs 
                  value={bewerbungenSubTabIndex} 
                  onChange={(e, newValue) => {
                    setBewerbungenSubTabIndex(newValue);
                    // Beim Wechsel zum Tab "Stellenbeschreibung" optimierte CV-Daten zurücksetzen
                    if (newValue === 1) {
                      clearOptimizedAndMatchData();
                      setCvTemplateHasBeenOpened(false);
                    }
                  }} 
                  variant="scrollable" 
                  scrollButtons="auto" 
                  sx={{ 
                    mb: 3,
                    borderBottom: 1,
                    borderColor: 'divider'
                  }}
                >
                  <Tab label={t('cv.subtab.applications')} />
                  <Tab label={t('cv.subtab.job.description')} />
                </Tabs>
              )}
              
              {/* Sub-Tab Content: Bewerbungen */}
              {bewerbungenSubTabIndex === 0 && (
              <Box>
              {/* Info-Textbox für Tab 1 - nur anzeigen wenn nicht minimiert */}
              {!minimizedInfoBoxes['applications'] && (
                <Box sx={{ mb: 3 }}>
                  <Alert 
                    severity="info" 
                    sx={{ 
                      borderRadius: 2,
                      backgroundColor: '#f0f7ff',
                      border: '1px solid #b3d9ff',
                      '& .MuiAlert-icon': {
                        color: '#1976d2'
                      }
                    }}
                    action={
                      <IconButton size="small" onClick={() => setMinimizedInfoBoxes(prev => ({ ...prev, applications: true }))}>
                        <CloseIcon fontSize="small" sx={{ color: '#1976d2' }} />
                      </IconButton>
                    }
                  >
                    <Typography variant="body2" sx={{ color: '#1976d2', fontWeight: 500 }}>
                      {currentLanguage === 'de' ? 'Mit Klick auf "Hinzufügen" kannst du hier eine neue Bewerbung starten. In der Tabelle siehst du alle erstellten Bewerbungen. Mit Klick auf das Minimierungs-Icon kannst du Filter für die Tabelle einblenden.' :
                       currentLanguage === 'en' ? 'With a click on "Add" you can start a new application here. In the table you can see all created applications. With a click on the minimize icon you can show filters for the table.' :
                       currentLanguage === 'fr' ? 'Avec un clic sur "Ajouter", vous pouvez commencer une nouvelle candidature ici. Dans le tableau, vous pouvez voir toutes les candidatures créées. Avec un clic sur l\'icône de minimisation, vous pouvez afficher les filtres pour le tableau.' :
                       'Con un clic su "Aggiungi" puoi iniziare una nuova candidatura qui. Nella tabella puoi vedere tutte le candidature create. Con un clic sull\'icona di minimizzazione puoi mostrare i filtri per la tabella.'}
                    </Typography>
                  </Alert>
                </Box>
              )}
              
              
              
              {/* Tabelle: Meine Bewerbungen */}
              <Box 
                sx={{ 
                  border: '1px solid #e0e0e0',
                  borderRadius: 2,
                  bgcolor: 'white',
                  overflow: 'hidden',
                  mb: 3
                }}
              >
                <Box 
                  sx={{ 
                    py: 1.5, 
                    px: 2,
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    overflow: 'hidden'
                  }}
                  onDragOver={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                  onDrop={async (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    // Versuche URL aus verschiedenen Quellen zu extrahieren
                    let url = '';
                    
                    // 1. Aus text/uri-list (Standard für Links)
                    if (e.dataTransfer.types.includes('text/uri-list')) {
                      url = e.dataTransfer.getData('text/uri-list').split('\n')[0];
                    }
                    // 2. Aus text/plain (falls als Text gezogen)
                    else if (e.dataTransfer.types.includes('text/plain')) {
                      const text = e.dataTransfer.getData('text/plain').trim();
                      // Prüfe ob es eine URL ist
                      if (text.startsWith('http://') || text.startsWith('https://')) {
                        url = text;
                      }
                    }
                    
                    if (url && (url.startsWith('http://') || url.startsWith('https://'))) {
                      console.log('🔗 URL per Drag & Drop auf Header empfangen:', url);
                      // Wechsle zum Tab "Stellenbeschreibung"
                      setCvTabIndex(0);
                      setBewerbungenSubTabIndex(1);
                      clearOptimizedAndMatchData(); // Setze optimierte CV-Daten zurück
                      setCvTemplateHasBeenOpened(false); // Deaktiviere Motivationsschreiben-Icon
                      extractTextFromUrl(url);
                    } else {
                      console.log('⚠️ Keine gültige URL gefunden im Drop Event auf Header');
                      // Versuche trotzdem, den Text normal einzufügen
                      const text = e.dataTransfer.getData('text/plain');
                      if (text && text.trim()) {
                        // Wechsle zum Tab "Stellenbeschreibung"
                        setCvTabIndex(0);
                        setBewerbungenSubTabIndex(1);
                        clearOptimizedAndMatchData(); // Setze optimierte CV-Daten zurück
                        setCvTemplateHasBeenOpened(false); // Deaktiviere Motivationsschreiben-Icon
                        const trimmedText = text.trim();
                        resetApplicationSelectionForNewJobDescription();
                        setJobDescription(trimmedText.endsWith('\n\n') ? trimmedText : trimmedText + '\n\n');
                        // Extrahiere strukturierte Job-Informationen auch bei Drag&Drop von Text
                        if (trimmedText.length > 100) {
                          try {
                            setExtractingJobInfo(true);
                            console.log('🔍 Extrahiere Job-Informationen aus Drag&Drop-Text (Header)...');
                            const response = await fetch(`${config.backend.fullApiUrl}/api/extract-job-info`, {
                              method: 'POST',
                              headers: {
                                'Content-Type': 'application/json'
                              },
                              body: JSON.stringify({ text: trimmedText })
                            });
                            if (response.ok) {
                              const data = await response.json();
                              if (data.jobInfo && Object.keys(data.jobInfo).length > 0) {
                                setExtractedJobInfo(normalizeExtractedJobInfo(data.jobInfo));
                                console.log('✅ Job-Informationen aus Drag&Drop (Header) extrahiert:', data.jobInfo);
                              }
                            }
                          } catch (error) {
                            console.error('❌ Fehler bei Job-Info-Extraktion (Drag&Drop Header):', error);
                          } finally {
                            setExtractingJobInfo(false);
                          }
                        }
                        // Prompt Spracherkennung bei Text-Drop auf Header
                        if (hasMinimumJobDescriptionLength(trimmedText)) {
                          await handleLanguageDetection(trimmedText);
                        }
                      }
                    }
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <BusinessCenterOutlinedIcon sx={{ fontSize: 22 }} />
                      <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                        {getTranslatedCvLabel('Meine Bewerbungen')}
                      </Typography>
                      <Tooltip title={getTranslatedCvLabel('Info anzeigen')} arrow>
                        <IconButton
                          size="small"
                          onClick={() => setMinimizedInfoBoxes(prev => ({ ...prev, applications: false }))}
                          sx={{
                            color: 'white',
                            p: 0.5,
                            '&:hover': {
                              bgcolor: 'rgba(255,255,255,0.1)'
                            }
                          }}
                        >
                          <InfoOutlinedIcon sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Tooltip>
                    </Box>
                    
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <IconButton
                        size="small"
                        onClick={() => setShowDateFilters(!showDateFilters)}
                        sx={{
                          color: 'white',
                          '&:hover': {
                            bgcolor: 'rgba(255,255,255,0.1)'
                          }
                        }}
                        title={showDateFilters ? getTranslatedCvLabel('Datumsfilter verbergen') : getTranslatedCvLabel('Datumsfilter anzeigen')}
                      >
                        {showDateFilters ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                      </IconButton>
                      <Tooltip 
                        title={(!userCvs || userCvs.length === 0) ? getTranslatedInfoMessage('upload_cv_data_first') : ''}
                        arrow
                      >
                        <span>
                          <IconButton 
                            size="small"
                            onClick={() => {
                              // Lösche Stellenbeschreibung inkl. abgeleiteter Job-Informationen
                              handleClearJobDescription();
                              // Deaktiviere Motivationsschreiben-Icon
                              setCvTemplateHasBeenOpened(false);
                              // Wechsle zum Sub-Tab "Stellenbeschreibung"
                              setCvTabIndex(0);
                              setBewerbungenSubTabIndex(1);
                            }}
                            disabled={!userCvs || userCvs.length === 0}
                            sx={{
                              bgcolor: 'rgba(255,255,255,0.2)',
                              border: '1px solid rgba(255,255,255,0.3)',
                              color: 'white',
                              width: 32,
                              height: 32,
                              borderRadius: '50%',
                              backdropFilter: 'blur(10px)',
                              boxShadow: (userCvs && userCvs.length > 0 && applications.length === 0)
                                ? '0 0 0 0 rgba(255,255,255,0.8)'
                                : 'none',
                              '@keyframes applicationsAddPulse': {
                                '0%': {
                                  boxShadow: '0 0 0 0 rgba(255,255,255,0.8)',
                                  transform: 'scale(1)',
                                },
                                '50%': {
                                  boxShadow: '0 0 0 16px rgba(255,255,255,0)',
                                  transform: 'scale(1.1)',
                                },
                                '100%': {
                                  boxShadow: '0 0 0 0 rgba(255,255,255,0)',
                                  transform: 'scale(1)',
                                }
                              },
                              animation: (userCvs && userCvs.length > 0 && applications.length === 0)
                                ? 'applicationsAddPulse 1.5s ease-in-out infinite'
                                : 'none',
                              '&:hover': {
                                bgcolor: 'rgba(255,255,255,0.3)',
                                borderColor: 'rgba(255,255,255,0.5)',
                                transform: 'translateY(-1px)',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                              },
                              '&:disabled': {
                                opacity: 0.5,
                                bgcolor: 'rgba(255,255,255,0.1)',
                                cursor: 'not-allowed'
                              },
                              transition: 'all 0.2s ease'
                            }}
                          >
                            <AddIcon fontSize="small" />
                          </IconButton>
                        </span>
                      </Tooltip>
                    </Box>
                  </Box>
                </Box>
                
                {/* Datums-Filter und Checkbox */}
                {showDateFilters && (
                <Box sx={{ p: 2, bgcolor: '#f8fafc', borderBottom: '1px solid #e2e8f0', display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
                  <TextField
                    label={getTranslatedCvLabel('Suche')}
                    placeholder={getTranslatedCvLabel('Name, Firma, Rollentitel...')}
                    value={applicationSearchText}
                    onChange={(e) => setApplicationSearchText(e.target.value)}
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{ 
                      width: '250px',
                      '& .MuiOutlinedInput-root': {
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#667eea'
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#667eea'
                        }
                      }
                    }}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={showClosedApplications}
                        onChange={(e) => setShowClosedApplications(e.target.checked)}
                        disableRipple
                        disableFocusRipple
                        sx={{
                          '&:hover': { backgroundColor: 'transparent' },
                          '& .MuiTouchRipple-root': { display: 'none' },
                          color: '#667eea',
                          '&.Mui-checked': {
                            color: '#667eea',
                          },
                        }}
                      />
                    }
                    label={
                      <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 500 }}>
                        {getTranslatedCvLabel('Geschlossene Bewerbungen anzeigen')}
                      </Typography>
                    }
                  />
                  <TextField
                    label={getTranslatedCvLabel('Von')}
                    type="date"
                    value={applicationDateFrom}
                    onChange={(e) => setApplicationDateFrom(e.target.value)}
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{ 
                      width: '200px',
                      '& .MuiOutlinedInput-root': {
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#667eea'
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#667eea'
                        }
                      }
                    }}
                  />
                  <TextField
                    label={getTranslatedCvLabel('Bis')}
                    type="date"
                    value={applicationDateTo}
                    onChange={(e) => setApplicationDateTo(e.target.value)}
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{ 
                      width: '200px',
                      '& .MuiOutlinedInput-root': {
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#667eea'
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#667eea'
                        }
                      }
                    }}
                  />
                  {(applicationDateFrom || applicationDateTo || applicationSearchText) && (
                    <Button
                      size="small"
                      onClick={() => {
                        setApplicationDateFrom('');
                        setApplicationDateTo('');
                        setApplicationSearchText('');
                      }}
                      sx={{
                        color: '#64748b',
                        textTransform: 'none',
                        '&:hover': {
                          bgcolor: 'rgba(0,0,0,0.04)'
                        }
                      }}
                    >
                      Filter zurücksetzen
                    </Button>
                  )}
                </Box>
                )}
                
                {applications.filter(app => {
                  // Status-Filter
                  if (!showClosedApplications && app.status === 'Geschlossen') return false;
                  
                  // Such-Filter
                  if (applicationSearchText) {
                    const searchLower = applicationSearchText.toLowerCase();
                    const nameMatch = (app.fullName || app.cvName || fullName || '').toLowerCase().includes(searchLower);
                    const companyMatch = (app.company || '').toLowerCase().includes(searchLower);
                    const roleMatch = (app.roleTitle || app.position || '').toLowerCase().includes(searchLower);
                    if (!nameMatch && !companyMatch && !roleMatch) return false;
                  }
                  
                  // Datums-Filter
                  if (applicationDateFrom || applicationDateTo) {
                    const appDate = app.createdAt?.seconds 
                      ? new Date(app.createdAt.seconds * 1000)
                      : app.timestamp 
                        ? new Date(app.timestamp)
                        : null;
                    
                    if (!appDate) return false;
                    
                    if (applicationDateFrom) {
                      const fromDate = new Date(applicationDateFrom);
                      fromDate.setHours(0, 0, 0, 0);
                      if (appDate < fromDate) return false;
                    }
                    
                    if (applicationDateTo) {
                      const toDate = new Date(applicationDateTo);
                      toDate.setHours(23, 59, 59, 999);
                      if (appDate > toDate) return false;
                    }
                  }
                  
                  return true;
                }).length > 0 ? (
                  <TableContainer sx={{ maxHeight: 'calc(100vh - 300px)', overflow: 'auto' }}>
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.8rem', backgroundColor: '#f8fafc', position: 'sticky', top: 0, zIndex: 1, py: 1 }}>
                            {getTranslatedCvLabel('Firma')}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.8rem', backgroundColor: '#f8fafc', position: 'sticky', top: 0, zIndex: 1, py: 1 }}>
                            {getTranslatedCvLabel('Rollentitel')}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.8rem', backgroundColor: '#f8fafc', position: 'sticky', top: 0, zIndex: 1, minWidth: '120px', py: 1 }}>
                            {getTranslatedCvLabel('Erstellt am')}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.8rem', backgroundColor: '#f8fafc', position: 'sticky', top: 0, zIndex: 1, py: 1 }}>
                            {getTranslatedCvLabel('Status')}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {applications
                          .filter(app => {
                            // Status-Filter
                            if (!showClosedApplications && app.status === 'Geschlossen') return false;
                            
                            // Such-Filter
                            if (applicationSearchText) {
                              const searchLower = applicationSearchText.toLowerCase();
                              const nameMatch = (app.fullName || app.cvName || fullName || '').toLowerCase().includes(searchLower);
                              const companyMatch = (app.company || '').toLowerCase().includes(searchLower);
                              const roleMatch = (app.roleTitle || app.position || '').toLowerCase().includes(searchLower);
                              if (!nameMatch && !companyMatch && !roleMatch) return false;
                            }
                            
                            // Datums-Filter
                            if (applicationDateFrom || applicationDateTo) {
                              const appDate = app.createdAt?.seconds 
                                ? new Date(app.createdAt.seconds * 1000)
                                : app.timestamp 
                                  ? new Date(app.timestamp)
                                  : null;
                              
                              if (!appDate) return false;
                              
                              if (applicationDateFrom) {
                                const fromDate = new Date(applicationDateFrom);
                                fromDate.setHours(0, 0, 0, 0);
                                if (appDate < fromDate) return false;
                              }
                              
                              if (applicationDateTo) {
                                const toDate = new Date(applicationDateTo);
                                toDate.setHours(23, 59, 59, 999);
                                if (appDate > toDate) return false;
                              }
                            }
                            
                            return true;
                          })
                          .map((app) => (
                          <TableRow 
                            key={app.id} 
                            hover 
                            onClick={() => {
                              setSelectedApplication(app);
                              setEditableNotes(app.notes || '');
                              setEditableCompany(app.company || '');
                              setEditableIndustry(app.industry || '');
                              setEditableRoleTitle(app.roleTitle || '');
                              setEditableContactInfo(app.contactInfo || '');
                              setEditableRequirementsMuss(
                                app.anforderungenMuss ||
                                ((!app.anforderungenSoll && !app.anforderungenKann) ? (app.anforderungen || '') : '')
                              );
                              setEditableRequirementsSoll(app.anforderungenSoll || '');
                              setEditableRequirementsKann(app.anforderungenKann || '');
                              setEditableTasks(
                                Array.isArray(app.aufgaben)
                                  ? app.aufgaben.join('\n')
                                  : (app.aufgaben || '')
                              );
                              setEditableApplicationDetails(app.applicationDetails || '');
                              setEditableKeywords(Array.isArray(app.keywords) ? app.keywords : []);
                              setApplicationKeywordInput('');
                              console.log('🔗 Bewerbung geladen - jobUrl:', app.jobUrl);
                              setJobUrl(app.jobUrl || null);
                              setShowApplicationDetailsModal(true);
                            }}
                            sx={{ 
                              '&:hover': { backgroundColor: '#f8fafc', cursor: 'pointer' },
                              transition: 'all 0.2s ease'
                            }}
                          >
                            <TableCell>
                              <Typography variant="body2" sx={{ color: '#1e293b', fontWeight: 500, fontSize: '0.85rem' }}>
                                {app.company || '-'}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2" sx={{ color: '#1e293b', fontWeight: 600, fontSize: '0.9rem' }}>
                                {app.roleTitle || app.position || '-'}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 500, fontSize: '0.85rem' }}>
                                {app.createdAt?.seconds 
                                  ? new Date(app.createdAt.seconds * 1000).toLocaleDateString(currentLanguage, {
                                      year: 'numeric',
                                      month: 'short',
                                      day: 'numeric'
                                    })
                                  : app.timestamp 
                                    ? new Date(app.timestamp).toLocaleDateString(currentLanguage, {
                                        year: 'numeric',
                                        month: 'short',
                                        day: 'numeric'
                                      })
                                    : '-'
                                }
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Chip 
                                label={getTranslatedCvLabel(app.status || 'Offen')}
                                size="small"
                                sx={{ 
                                  bgcolor: app.status === 'Eingereicht' ? '#2563eb' :
                                           app.status === 'Vorstellungsgespräch' ? '#f59e0b' : 
                                           app.status === 'Geschlossen' ? '#6b7280' : '#3b82f6',
                                  color: 'white',
                                  fontWeight: 600,
                                  fontSize: '0.75rem'
                                }}
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <Box sx={{ p: 4, textAlign: 'center' }}>
                    <Typography variant="body2" sx={{ color: '#94a3b8', fontStyle: 'italic', fontSize: '0.9rem' }}>
                      {getTranslatedCvLabel('Keine Bewerbungen vorhanden')}
                    </Typography>
                  </Box>
                )}
              </Box>
              </Box>
              )}
              
              {/* Sub-Tab Content: Stellenbeschreibung */}
              {bewerbungenSubTabIndex === 1 && (
              <Box>
                {/* Info-Textbox für Stellenbeschreibung - nur anzeigen wenn nicht minimiert */}
                {!minimizedInfoBoxes['jobDescription'] && (
                  <Box sx={{ mb: 3 }}>
                    <Alert 
                      severity="info" 
                      sx={{ 
                        borderRadius: 2,
                        backgroundColor: '#f0f7ff',
                        border: '1px solid #b3d9ff',
                        '& .MuiAlert-icon': {
                          color: '#1976d2'
                        }
                      }}
                      action={
                        <IconButton size="small" onClick={() => setMinimizedInfoBoxes(prev => ({ ...prev, jobDescription: true }))}>
                          <CloseIcon fontSize="small" sx={{ color: '#1976d2' }} />
                        </IconButton>
                      }
                    >
                      <Typography variant="body2" sx={{ color: '#1976d2', fontWeight: 500 }}>
                        {currentLanguage === 'de' ? 'Bitte Stellenbeschreibung mit Copy&Paste oder über URL Drag&Drop eingeben.' :
                         currentLanguage === 'en' ? 'Please enter the job description here for which you want to optimize a CV. You can copy the job description text into the text field below or simply drag the website URL into the text field.' :
                         currentLanguage === 'fr' ? 'Veuillez saisir ici la description du poste pour lequel vous souhaitez optimiser un CV. Vous pouvez copier le texte de la description du poste dans le champ de texte ci-dessous ou simplement faire glisser l\'URL du site web dans le champ de texte.' :
                         'Si prega di inserire qui la descrizione del lavoro per cui si desidera ottimizzare un CV. Puoi copiare il testo della descrizione del lavoro nel campo di testo sottostante o semplicemente trascinare l\'URL del sito web nel campo di testo.'}
                      </Typography>
                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<AddIcon fontSize="small" />}
                        onClick={() => setExtractedJobInfo(normalizeExtractedJobInfo({}))}
                        sx={{
                          mt: 1.5,
                          textTransform: 'none',
                          color: '#667eea',
                          borderColor: '#667eea',
                          borderRadius: '999px',
                          '&:hover': {
                            backgroundColor: 'rgba(102, 126, 234, 0.08)',
                            borderColor: '#5a6fd6'
                          }
                        }}
                      >
                        {getTranslatedCvLabel('Job-Informationen manuell erfassen')}
                      </Button>
                    </Alert>
                  </Box>
                )}
                
                {/* Stellenbeschreibung Textfeld */}
                {(!jobDescription || !jobDescription.trim()) && !extractedJobInfo && (
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mb: 3 }}>
                    {/* Stellenbeschreibung Textfeld */}
                    <Box sx={{ position: 'relative', display: 'flex', flexDirection: 'column', height: '500px' }}>
                      {/* Info-Icon oben links */}
                      <Tooltip title={getTranslatedCvLabel('Info anzeigen')} arrow>
                        <IconButton
                          onClick={() => setMinimizedInfoBoxes(prev => ({ ...prev, jobDescription: false }))}
                          sx={{
                            position: 'absolute',
                            top: 8,
                            left: 8,
                            color: '#1976d2',
                            zIndex: 2,
                            bgcolor: 'rgba(255,255,255,0.9)',
                            '&:hover': {
                              bgcolor: 'rgba(25, 118, 210, 0.08)'
                            }
                          }}
                        >
                          <InfoOutlinedIcon sx={{ fontSize: 20 }} />
                        </IconButton>
                      </Tooltip>
                      {/* Text-Hinweis für Drag&Drop/Copy&Paste */}
                      {(!jobDescription || !jobDescription.trim()) && !extractingJobUrl && (
                        <Box sx={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          pointerEvents: 'none',
                          zIndex: 1
                        }}>
                          <Typography variant="body1" sx={{ 
                            color: '#64748b', 
                            fontWeight: 500, 
                            fontSize: '1rem',
                            textAlign: 'center',
                            whiteSpace: 'pre-line'
                          }}>
                            {getTranslatedCvLabel('Bitte Stellenbeschreibung eingeben. Copy&Paste oder URL Drag&Drop')}
                          </Typography>
                        </Box>
                      )}
                      {(!jobDescription || !jobDescription.trim()) && !extractingJobUrl && !extractedJobInfo && (
                        <Box
                          sx={{
                            position: 'absolute',
                            top: 'calc(50% + 42px)',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            zIndex: 2
                          }}
                        >
                          <Button
                            variant="outlined"
                            size="small"
                            startIcon={<AddIcon fontSize="small" />}
                            onClick={() => setExtractedJobInfo(normalizeExtractedJobInfo({}))}
                            sx={{
                              textTransform: 'none',
                              bgcolor: 'rgba(255,255,255,0.9)',
                              color: '#667eea',
                              borderColor: '#667eea',
                              borderRadius: '999px',
                              '&:hover': {
                                backgroundColor: 'rgba(102, 126, 234, 0.12)',
                                borderColor: '#5a6fd6'
                              }
                            }}
                          >
                            {getTranslatedCvLabel('Job-Informationen manuell erfassen')}
                          </Button>
                        </Box>
                      )}
                      <TextField 
                      value={jobDescription} 
                      onChange={handleJobDescriptionChange}
                      onKeyDown={(e) => {
                        // Enter: Passgenauigkeit prüfen (ohne Eingabe zu erlauben)
                        if (e.key === 'Enter' && !e.shiftKey) {
                          const isButtonEnabled = !checkingMatch && hasData() && hasProcessableJobDescription;
                          if (isButtonEnabled && !checkingMatch && !optimizing) {
                            e.preventDefault();
                            handleCheckMatchScore();
                            return;
                          }
                        }
                        // Erlaube nur Paste-Shortcuts und Navigations-Tasten, blockiere sonst Keyboard-Eingaben
                        const isPasteCombo = ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'v') || (e.shiftKey && e.key === 'Insert');
                        const navKeys = ['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End','PageUp','PageDown','Tab'];
                        if (isPasteCombo || navKeys.includes(e.key)) {
                          return;
                        }
                        // Blockiere alle anderen Tasten (inkl. Backspace/Delete)
                        e.preventDefault();
                      }}
                      onBeforeInput={(e: any) => {
                        // Erlaube Einfügen per Paste/Drop; blockiere sonstige Tastatureingaben
                        const inputType = e?.inputType || '';
                        if (inputType === 'insertFromPaste' || inputType === 'insertFromDrop') {
                          return;
                        }
                        e.preventDefault();
                      }}
                      onPaste={async (e) => {
                        // Explizites Handling für Paste per Maus/Shortcut
                        e.preventDefault();
                        const text = e.clipboardData.getData('text/plain');
                        const normalized = normalizeJobDescriptionText(text);
                        if (!normalized) {
                          handleClearJobDescription();
                          return;
                        }
                        if (text && text.trim()) {
                          const trimmed = text.trim();
                          const withBreak = trimmed.endsWith('\n\n') ? trimmed : trimmed + '\n\n';
                          resetApplicationSelectionForNewJobDescription();
                          setJobDescription(withBreak);
                          if (!hasMinimumJobDescriptionLength(trimmed)) {
                            return;
                          }
                          if (trimmed.length > 100) {
                            try {
                              setExtractingJobInfo(true);
                              console.log('🔍 Extrahiere Job-Informationen aus Paste-Text...');
                              const response = await fetch(`${config.backend.baseUrl}/api/extract-job-info`, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ text: trimmed })
                              });
                              if (response.ok) {
                                const data = await response.json();
                                if (data.jobInfo && Object.keys(data.jobInfo).length > 0) {
                                  setExtractedJobInfo(normalizeExtractedJobInfo(data.jobInfo));
                                  console.log('✅ Job-Informationen aus Paste extrahiert:', data.jobInfo);
                                }
                              }
                            } catch (err) {
                              console.error('❌ Fehler bei Job-Info-Extraktion (Paste):', err);
                            } finally {
                              setExtractingJobInfo(false);
                            }
                          }
                        }
                      }}
                      onDragOver={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      onDrop={async (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        
                        // Versuche URL aus verschiedenen Quellen zu extrahieren
                        let url = '';
                        
                        // 1. Aus text/uri-list (Standard für Links)
                        if (e.dataTransfer.types.includes('text/uri-list')) {
                          url = e.dataTransfer.getData('text/uri-list').split('\n')[0];
                        }
                        // 2. Aus text/plain (falls als Text gezogen)
                        else if (e.dataTransfer.types.includes('text/plain')) {
                          const text = e.dataTransfer.getData('text/plain').trim();
                          // Prüfe ob es eine URL ist
                          if (text.startsWith('http://') || text.startsWith('https://')) {
                            url = text;
                          }
                        }
                        
                        if (url && (url.startsWith('http://') || url.startsWith('https://'))) {
                          console.log('🔗 URL per Drag & Drop empfangen:', url);
                          extractTextFromUrl(url);
                        } else {
                          console.log('⚠️ Keine gültige URL gefunden im Drop Event');
                          // Versuche trotzdem, den Text normal einzufügen
                          const text = e.dataTransfer.getData('text/plain');
                          if (text && text.trim()) {
                            const trimmedText = text.trim();
                            resetApplicationSelectionForNewJobDescription();
                            setJobDescription(trimmedText.endsWith('\n\n') ? trimmedText : trimmedText + '\n\n');
                            // Extrahiere strukturierte Job-Informationen auch bei Drag&Drop von Text
                            if (trimmedText.length > 100) {
                              try {
                                setExtractingJobInfo(true);
                                console.log('🔍 Extrahiere Job-Informationen aus Drag&Drop-Text...');
                                const response = await fetch(`${config.backend.baseUrl}/api/extract-job-info`, {
                                  method: 'POST',
                                  headers: {
                                    'Content-Type': 'application/json'
                                  },
                                  body: JSON.stringify({ text: trimmedText })
                                });
                                if (response.ok) {
                                  const data = await response.json();
                                  if (data.jobInfo && Object.keys(data.jobInfo).length > 0) {
                                    setExtractedJobInfo(normalizeExtractedJobInfo(data.jobInfo));
                                    console.log('✅ Job-Informationen aus Drag&Drop extrahiert:', data.jobInfo);
                                  }
                                }
                              } catch (error) {
                                console.error('❌ Fehler bei Job-Info-Extraktion (Drag&Drop):', error);
                              } finally {
                                setExtractingJobInfo(false);
                              }
                            }
                            // Prompt Spracherkennung bei Text-Drop ins Stellenbeschreibungs-Feld
                            if (!hasMinimumJobDescriptionLength(trimmedText)) {
                              handleClearJobDescription();
                              return;
                            }
                            await handleLanguageDetection(trimmedText);
                          }
                        }
                      }}
                      disabled={extractingJobUrl}
                      fullWidth 
                      multiline 
                      placeholder=""
                      InputProps={{
                        endAdornment: extractingJobUrl ? (
                          <Box sx={{ 
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 2
                          }}>
                            <CircularProgress size={60} thickness={4} sx={{ color: '#667eea' }} />
                            <Typography variant="body2" sx={{ color: '#667eea', fontWeight: 500 }}>
                              {getTranslatedCvLabel("Extrahiere Text von Webseite...")}
                            </Typography>
                          </Box>
                        ) : null
                      }}
                      sx={{
                        height: '100%',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 3,
                          height: '100%',
                          alignItems: 'flex-start',
                          position: 'relative',
                          overflow: 'hidden',
                          border: '2px dashed #cbd5e1',
                          '&:hover': {
                            borderColor: '#667eea',
                            borderStyle: 'dashed'
                          }
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                          border: 'none'
                        },
                        '& .MuiOutlinedInput-input': {
                          height: '100% !important',
                          overflow: 'hidden !important',
                          textAlign: 'center',
                          scrollbarWidth: 'none',
                          msOverflowStyle: 'none',
                          '&::-webkit-scrollbar': {
                            display: 'none'
                          }
                        },
                        '& .MuiOutlinedInput-input:placeholder-shown': {
                          textAlign: 'center'
                        },
                        '& .MuiOutlinedInput-root.Mui-focused': {
                          borderColor: '#667eea',
                          borderWidth: '2px',
                          borderStyle: 'dashed'
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                          color: '#667eea'
                        },
                        // Verstecke das Label während der Extraktion
                        '& .MuiInputLabel-root': extractingJobUrl ? {
                          display: 'none'
                        } : {},
                        // Zentriere den Platzhalter-Text horizontal und vertikal
                        '& .MuiOutlinedInput-input::placeholder': {
                          textAlign: 'center',
                          lineHeight: '500px',
                          opacity: 1
                        },
                        '& .MuiOutlinedInput-input:not(:placeholder-shown)': {
                          textAlign: 'left',
                          lineHeight: 'normal'
                        }
                      }}
                    />
                    </Box>
                  </Box>
                )}
                
                {/* Job-Informationen unter der Textbox */}
                {(hasProcessableJobDescription || !!extractedJobInfo) && (
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mb: 3 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', height: '650px' }}>
                      <Paper 
                      sx={{ 
                        p: 3,
                        borderRadius: 3,
                        border: (extractedJobInfo || extractingJobInfo) ? '2px solid #e2e8f0' : '2px solid #e0e0e0',
                        boxShadow: (extractedJobInfo || extractingJobInfo) ? '0 2px 8px rgba(0,0,0,0.05)' : 'none',
                        bgcolor: (extractedJobInfo || extractingJobInfo) ? '#f8fafc' : '#f5f5f5',
                        opacity: (extractedJobInfo || extractingJobInfo) ? 1 : 0.5,
                        display: 'flex',
                        flexDirection: 'column',
                        transition: 'all 0.3s ease',
                        pointerEvents: (extractedJobInfo || extractingJobInfo) ? 'auto' : 'none',
                        height: '100%',
                        overflow: 'hidden',
                        position: 'relative'
                      }}
                    >
                      {!extractingJobInfo && (
                        <Box sx={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'space-between', 
                          mb: 2,
                          position: 'relative'
                        }}>
                          <Typography variant="h6" sx={{ fontWeight: 700, color: extractedJobInfo ? '#1e293b' : '#9e9e9e', fontSize: '1rem', mb: 0 }}>
                            {getTranslatedCvLabel('Job-Informationen')}
                          </Typography>
                        </Box>
                      )}
                      
                      {/* Container für beide Icons mit Rahmen */}
                      {!extractingJobInfo && (
                        <Box
                          sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 3,
                            bgcolor: 'white',
                            border: '2px solid #e2e8f0',
                            borderRadius: '47px',
                            p: 1,
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                            zIndex: 2
                          }}
                        >
                          {(() => {
                            const selectedCvRefs = Array.isArray(extractedJobInfo?.cvSetRefs)
                              ? (extractedJobInfo?.cvSetRefs || []).filter((ref) => typeof ref === 'string' && ref.trim())
                              : [];
                            const hasNoCvSetSelected = selectedCvRefs.length === 0;
                            const isSingleCvSetSelected = selectedCvRefs.length === 1;
                            const shouldShowCvActionIcons = selectedCvRefs.length <= 1;
                            const isPassgenauigkeitEnabled =
                              !hasNoCvSetSelected &&
                              !checkingMatch &&
                              hasData() &&
                              hasProcessableOrManualJobInfo;
                            const isCvOptimizeEnabled =
                              !optimizing &&
                              !checkingMatch &&
                              !loadingCvDesignSettings &&
                              hasData() &&
                              hasProcessableJobDescription &&
                              matchScore !== null;
                            const isMotivationEnabled =
                              isCvOptimizeEnabled &&
                              !creatingMotivation &&
                              cvTemplateHasBeenOpened;
                            return (
                              <>
                          {/* Delete-Icon links */}
                          <Tooltip title={getTranslatedCvLabel('Job-Informationen löschen')}>
                            <span>
                              <IconButton
                                aria-label={getTranslatedCvLabel('Löschen')}
                                onClick={handleClearJobDescription}
                                disabled={!extractedJobInfo}
                                size="small"
                                sx={{ 
                                  color: extractedJobInfo ? '#64748b' : '#bdbdbd',
                                  p: 0.5
                                }}
                              >
                                <DeleteIcon sx={{ fontSize: 32 }} />
                              </IconButton>
                            </span>
                          </Tooltip>
                          
                          {/* Passgenauigkeit-Icon rechts */}
                          <Tooltip title={getTranslatedCvLabel('Passgenauigkeit prüfen')}>
                            <span>
                              <IconButton
                                aria-label={getTranslatedCvLabel('Passgenauigkeit prüfen')}
                                onClick={handleCheckMatchScore}
                                disabled={!isPassgenauigkeitEnabled}
                                size="small"
                                sx={{ 
                                  color: isPassgenauigkeitEnabled ? '#667eea' : '#bdbdbd',
                                  bgcolor: 'transparent',
                                  p: 0.5,
                                  '&:hover .pg-circle': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 6px 16px rgba(102,126,234,0.35)'
                                  }
                                }}
                              >
                              <Box
                                className="pg-circle"
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  width: 72,
                                  height: 72,
                                  borderRadius: '50%',
                                  background: isPassgenauigkeitEnabled
                                    ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                                    : 'linear-gradient(135deg, #e5e7eb 0%, #e5e7eb 100%)',
                                  boxShadow: isPassgenauigkeitEnabled
                                    ? '0 4px 12px rgba(102,126,234,0.25)'
                                    : 'none',
                                  transition: 'all 0.15s ease',
                                  '@keyframes passMatchPulse': {
                                    '0%': {
                                      boxShadow: '0 0 0 0 rgba(102,126,234,0.7)',
                                      transform: 'scale(1)',
                                    },
                                    '50%': {
                                      boxShadow: '0 0 0 16px rgba(102,126,234,0)',
                                      transform: 'scale(1.1)',
                                    },
                                    '100%': {
                                      boxShadow: '0 0 0 0 rgba(102,126,234,0)',
                                      transform: 'scale(1)',
                                    }
                                  },
                                  // Puls-Animation nur bis die erste Passgenauigkeit berechnet ist
                                  animation: (isPassgenauigkeitEnabled && matchScore === null)
                                    ? 'passMatchPulse 1.5s ease-in-out infinite'
                                    : 'none'
                                }}
                              >
                                <AssessmentOutlinedIcon sx={{ fontSize: 44, color: 'white' }} />
                              </Box>
                            </IconButton>
                            </span>
                          </Tooltip>

                          {/* CV-Optimierung-Icon (bei 0/1 CV-Daten-Set sichtbar; nur bei 1 aktiv) */}
                          {shouldShowCvActionIcons && (
                          <Tooltip title={getTranslatedCvLabel('CV optimieren')}>
                            <span>
                              <IconButton
                                aria-label={getTranslatedCvLabel('CV optimieren')}
                                onClick={() => {
                                  if (!optimizing) {
                                    if (hasOptimizedCvData()) {
                                      handleOpenCvTemplate();
                                    } else {
                                      handleOptimizeCvParallel();
                                    }
                                  }
                                }}
                                disabled={!isSingleCvSetSelected || !isCvOptimizeEnabled}
                                size="small"
                                sx={{ 
                                  color: (isSingleCvSetSelected && isCvOptimizeEnabled) ? '#667eea' : '#bdbdbd',
                                  bgcolor: 'transparent',
                                  p: 0.5,
                                  '&:hover .cv-opt-circle': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 6px 16px rgba(102,126,234,0.35)'
                                  }
                                }}
                              >
                              <Box
                                className="cv-opt-circle"
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  width: 72,
                                  height: 72,
                                  borderRadius: '50%',
                                  background: (isSingleCvSetSelected && isCvOptimizeEnabled)
                                    ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                                    : 'linear-gradient(135deg, #e5e7eb 0%, #e5e7eb 100%)',
                                  boxShadow: (isSingleCvSetSelected && isCvOptimizeEnabled)
                                    ? '0 4px 12px rgba(102,126,234,0.25)'
                                    : 'none',
                                  transition: 'all 0.15s ease',
                                  '@keyframes cvOptimizePulse': {
                                    '0%': {
                                      boxShadow: '0 0 0 0 rgba(102,126,234,0.7)',
                                      transform: 'scale(1)',
                                    },
                                    '50%': {
                                      boxShadow: '0 0 0 16px rgba(102,126,234,0)',
                                      transform: 'scale(1.1)',
                                    },
                                    '100%': {
                                      boxShadow: '0 0 0 0 rgba(102,126,234,0)',
                                      transform: 'scale(1)',
                                    }
                                  },
                                  // Puls-Animation nur wenn CV-Optimierung aktiv ist und Motivationsschreiben inaktiv
                                  animation: ((isSingleCvSetSelected && isCvOptimizeEnabled) &&
                                             !(hasOptimizedCvData() && cvTemplateHasBeenOpened))
                                    ? 'cvOptimizePulse 1.5s ease-in-out infinite'
                                    : 'none'
                                }}
                              >
                                <DescriptionIcon sx={{ fontSize: 44, color: 'white' }} />
                              </Box>
                            </IconButton>
                            </span>
                          </Tooltip>
                          )}

                          {/* Motivationsschreiben-Icon (bei 0/1 CV-Daten-Set sichtbar; nur bei 1 aktiv) */}
                          {shouldShowCvActionIcons && (
                          <Tooltip title={getTranslatedCvLabel('Motivationsschreiben erstellen')}>
                            <span>
                              <IconButton
                                aria-label={getTranslatedCvLabel('Motivationsschreiben erstellen')}
                                onClick={handleOpenMotivationDialog}
                                disabled={!isSingleCvSetSelected || !isMotivationEnabled}
                                size="small"
                                sx={{ 
                                  color: (isSingleCvSetSelected && isMotivationEnabled) ? '#667eea' : '#bdbdbd',
                                  bgcolor: 'transparent',
                                  p: 0.5,
                                  '&:hover .motivation-circle': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 6px 16px rgba(102,126,234,0.35)'
                                  }
                                }}
                              >
                              <Box
                                className="motivation-circle"
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  width: 72,
                                  height: 72,
                                  borderRadius: '50%',
                                  background: (isSingleCvSetSelected && isMotivationEnabled)
                                    ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                                    : 'linear-gradient(135deg, #e5e7eb 0%, #e5e7eb 100%)',
                                  boxShadow: (isSingleCvSetSelected && isMotivationEnabled)
                                    ? '0 4px 12px rgba(102,126,234,0.25)'
                                    : 'none',
                                  transition: 'all 0.15s ease',
                                  '@keyframes motivationPulse': {
                                    '0%': {
                                      boxShadow: '0 0 0 0 rgba(102,126,234,0.7)',
                                      transform: 'scale(1)',
                                    },
                                    '50%': {
                                      boxShadow: '0 0 0 16px rgba(102,126,234,0)',
                                      transform: 'scale(1.1)',
                                    },
                                    '100%': {
                                      boxShadow: '0 0 0 0 rgba(102,126,234,0)',
                                      transform: 'scale(1)',
                                    }
                                  },
                                  // Puls-Animation wenn Motivationsschreiben aktiv ist (nur wenn Preview geschlossen wurde)
                                  animation: (isSingleCvSetSelected && isMotivationEnabled)
                                    ? 'motivationPulse 1.5s ease-in-out infinite'
                                    : 'none'
                                }}
                              >
                                <MailOutlineIcon sx={{ fontSize: 44, color: 'white' }} />
                              </Box>
                            </IconButton>
                            </span>
                          </Tooltip>
                          )}
                              </>
                            );
                          })()}
                        </Box>
                      )}
                      
                      <Box
                        sx={{
                          flex: 1,
                          display: 'flex',
                          flexDirection: 'column',
                          minHeight: 0,
                          overflowY: 'auto',
                          scrollbarGutter: 'stable',
                          pr: 1
                        }}
                      >
                      {extractingJobInfo ? (
                        <Box sx={{ 
                          flex: 1,
                          minHeight: '360px',
                          display: 'flex', 
                          flexDirection: 'column', 
                          alignItems: 'center', 
                          justifyContent: 'center',
                          gap: 2,
                          opacity: 1
                        }}>
                          <CircularProgress size={60} thickness={4} sx={{ color: '#667eea' }} />
                          <Typography variant="body2" sx={{ color: '#667eea', fontWeight: 500 }}>
                            {getTranslatedCvLabel("Extrahiere Job-Informationen...")}
                          </Typography>
                        </Box>
                      ) : extractedJobInfo ? (
                        <>
                        {(extractedJobInfo.roleTitle !== undefined && extractedJobInfo.roleTitle !== null) && (
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="caption" sx={{ 
                              fontWeight: 700, 
                              color: '#64748b', 
                              fontSize: '0.7rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block'
                            }}>
                              {getTranslatedCvLabel('Rollentitel')}
                            </Typography>
                            <TextField
                              fullWidth
                              value={extractedJobInfo.roleTitle || ''}
                              onChange={(e) => handleExtractedJobInfoFieldChange('roleTitle', e.target.value)}
                              variant="outlined"
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: 2,
                                  '&:hover fieldset': {
                                    borderColor: '#667eea',
                                  },
                                  '&.Mui-focused fieldset': {
                                    borderColor: '#667eea',
                                  },
                                }
                              }}
                            />
                          </Box>
                        )}
                        
                        {((extractedJobInfo.company !== undefined && extractedJobInfo.company !== null) ||
                          (extractedJobInfo.industry !== undefined && extractedJobInfo.industry !== null)) && (
                          <Box sx={{ mb: 2, display: 'flex', gap: 3 }}>
                            {(extractedJobInfo.company !== undefined && extractedJobInfo.company !== null) && (
                              <Box sx={{ flex: 1 }}>
                                <Typography variant="caption" sx={{ 
                                  fontWeight: 700, 
                                  color: '#64748b', 
                                  fontSize: '0.7rem',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.5px',
                                  display: 'block'
                                }}>
                                  {getTranslatedCvLabel('Firma')}
                                </Typography>
                                <TextField
                                  fullWidth
                                  value={extractedJobInfo.company || ''}
                                  onChange={(e) => handleExtractedJobInfoFieldChange('company', e.target.value)}
                                  variant="outlined"
                                  sx={{
                                    '& .MuiOutlinedInput-root': {
                                      borderRadius: 2,
                                      '&:hover fieldset': {
                                        borderColor: '#667eea',
                                      },
                                      '&.Mui-focused fieldset': {
                                        borderColor: '#667eea',
                                      },
                                    }
                                  }}
                                />
                              </Box>
                            )}
                            {(extractedJobInfo.industry !== undefined && extractedJobInfo.industry !== null) && (
                              <Box sx={{ flex: 1 }}>
                                <Typography variant="caption" sx={{ 
                                  fontWeight: 700, 
                                  color: '#64748b', 
                                  fontSize: '0.7rem',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.5px',
                                  display: 'block'
                                }}>
                                  {getTranslatedCvLabel('Branche')}
                                </Typography>
                                <TextField
                                  fullWidth
                                  value={extractedJobInfo.industry || ''}
                                  onChange={(e) => handleExtractedJobInfoFieldChange('industry', e.target.value)}
                                  variant="outlined"
                                  sx={{
                                    '& .MuiOutlinedInput-root': {
                                      borderRadius: 2,
                                      '&:hover fieldset': {
                                        borderColor: '#667eea',
                                      },
                                      '&.Mui-focused fieldset': {
                                        borderColor: '#667eea',
                                      },
                                    }
                                  }}
                                />
                              </Box>
                            )}
                          </Box>
                        )}
                        
                        <Box sx={{ mb: 2, display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'flex-start' }}>
                          <Box sx={{ display: 'flex', gap: 3, alignItems: 'flex-start', flexWrap: 'nowrap', width: '100%' }}>
                            {(extractedJobInfo.workload !== undefined && extractedJobInfo.workload !== null) && (
                              <Box sx={{ minWidth: 0, maxWidth: 'none', flex: '1 1 0' }}>
                                <Typography variant="caption" sx={{ 
                                  fontWeight: 700, 
                                  color: '#64748b', 
                                  fontSize: '0.7rem',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.5px',
                                  display: 'block'
                                }}>
                                  {getTranslatedCvLabel('Auslastung')}
                                </Typography>
                                <TextField
                                  fullWidth
                                  value={extractedJobInfo.workload || ''}
                                  onChange={(e) => handleExtractedJobInfoFieldChange('workload', e.target.value)}
                                  variant="outlined"
                                  sx={{
                                    '& .MuiOutlinedInput-root': {
                                      borderRadius: 2,
                                      '&:hover fieldset': {
                                        borderColor: '#667eea',
                                      },
                                      '&.Mui-focused fieldset': {
                                        borderColor: '#667eea',
                                      },
                                    }
                                  }}
                                />
                              </Box>
                            )}

                            {(extractedJobInfo.publishDate !== undefined && extractedJobInfo.publishDate !== null) && (
                              <Box sx={{ minWidth: 0, maxWidth: 'none', flex: '1 1 0' }}>
                                <Typography variant="caption" sx={{ 
                                  fontWeight: 700, 
                                  color: '#64748b', 
                                  fontSize: '0.7rem',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.5px',
                                  display: 'block'
                                }}>
                                  {getTranslatedCvLabel('Ausschreibedatum')}
                                </Typography>
                                <TextField
                                  fullWidth
                                  value={extractedJobInfo.publishDate || ''}
                                  onChange={(e) => handleExtractedJobInfoFieldChange('publishDate', e.target.value)}
                                  variant="outlined"
                                  sx={{
                                    '& .MuiOutlinedInput-root': {
                                      borderRadius: 2,
                                      '&:hover fieldset': {
                                        borderColor: '#667eea',
                                      },
                                      '&.Mui-focused fieldset': {
                                        borderColor: '#667eea',
                                      },
                                    }
                                  }}
                                />
                              </Box>
                            )}

                            <Box sx={{ minWidth: 0, maxWidth: 'none', flex: '1 1 0' }}>
                              <Typography variant="caption" sx={{ 
                                fontWeight: 700, 
                                color: '#64748b', 
                                fontSize: '0.7rem',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                display: 'block'
                              }}>
                                {getTranslatedCvLabel('Startdatum')}
                              </Typography>
                              <TextField
                                fullWidth
                                type="date"
                                value={extractedJobInfo.startDate || ''}
                                onChange={(e) => handleExtractedJobInfoFieldChange('startDate', e.target.value)}
                                variant="outlined"
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: 2,
                                    '&:hover fieldset': {
                                      borderColor: '#667eea',
                                    },
                                    '&.Mui-focused fieldset': {
                                      borderColor: '#667eea',
                                    },
                                  }
                                }}
                              />
                            </Box>
                          </Box>

                          {/* Sprachauswahl + CV-Daten-Set in derselben 2-Spalten-Logik wie Auslastung/Ausschreibedatum */}
                          <Box sx={{ width: '100%', display: 'flex', gap: 3, alignItems: 'flex-start', flexWrap: 'wrap' }}>
                            <Box sx={{ minWidth: 220, maxWidth: 420, flex: '1 1 320px' }}>
                              <Typography variant="caption" sx={{ 
                                fontWeight: 700, 
                                color: '#64748b', 
                                fontSize: '0.7rem',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                display: 'block',
                                mb: 1
                              }}>
                                {getTranslatedCvLabel('Sprache Stellenbeschreibung')}
                              </Typography>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <FormControl size="small" fullWidth>
                                  <Select
                                    value={jobDescriptionLanguage}
                                    onChange={(e) => setJobDescriptionLanguage(e.target.value)}
                                    disabled={detectingLanguage}
                                    displayEmpty
                                    sx={{
                                      '& .MuiOutlinedInput-root': {
                                        borderRadius: 2
                                      }
                                    }}
                                  >
                                    <MenuItem value="DE">DE</MenuItem>
                                    <MenuItem value="EN">EN</MenuItem>
                                    <MenuItem value="FR">FR</MenuItem>
                                    <MenuItem value="IT">IT</MenuItem>
                                  </Select>
                                </FormControl>
                                {detectingLanguage && (
                                  <CircularProgress size={16} />
                                )}
                              </Box>
                            </Box>
                            {userCvs && userCvs.length > 0 && (
                              <Box sx={{ minWidth: 220, maxWidth: 420, flex: '1 1 320px' }}>
                                <Typography variant="caption" sx={{ 
                                  fontWeight: 700, 
                                  color: '#64748b', 
                                  fontSize: '0.7rem',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.5px',
                                  display: 'block',
                                  mb: 1
                                }}>
                                  {getTranslatedCvLabel('CV-Daten Set')}
                                </Typography>
                                <Autocomplete
                                    multiple={isMultiCvSelectionAllowed}
                                    disableCloseOnSelect={isMultiCvSelectionAllowed}
                                    size="small"
                                    options={userCvs || []}
                                    value={(() => {
                                      const selectedOptions = (userCvs || []).filter((cv: any) =>
                                        (extractedJobInfo?.cvSetRefs || []).some((ref: string) => doesCvMatchSetRef(cv, ref))
                                      );
                                      return isMultiCvSelectionAllowed ? selectedOptions : (selectedOptions[0] || null);
                                    })()}
                                    inputValue={cvDropdownSearchText}
                                    onInputChange={(event, newInputValue) => {
                                      setCvDropdownSearchText(newInputValue);
                                    }}
                                    onOpen={() => setCvDropdownOpen(true)}
                                    onClose={() => {
                                      setCvDropdownOpen(false);
                                      setCvDropdownSearchText('');
                                    }}
                                    onChange={(event, newValues: any) => {
                                      const normalizedNewValues = Array.isArray(newValues)
                                        ? newValues
                                        : (newValues ? [newValues] : []);
                                      const selectedRefs = normalizedNewValues
                                        .map((cv: any) => getCvSetRef(cv))
                                        .filter((ref: string) => !!ref);
                                      const selectedCvIds = normalizedNewValues
                                        .map((cv: any) => getNormalizedCvId(cv?.cvId))
                                        .filter((id: string) => !!id);
                                      const limitedRefs = isMultiCvSelectionAllowed
                                        ? selectedRefs
                                        : selectedRefs.slice(-1);
                                      const limitedCvIds = isMultiCvSelectionAllowed
                                        ? selectedCvIds
                                        : selectedCvIds.slice(-1);
                                      setExtractedJobInfo((prev) =>
                                        prev
                                          ? { ...prev, cvSetRefs: limitedRefs, cvIds: limitedCvIds }
                                          : prev
                                      );
                                    }}
                                    getOptionLabel={(option: any) => {
                                      const cvId = getNormalizedCvId(option?.cvId);
                                      const matchPercent = cvId ? cvKeywordMatchPercentByCvId[cvId] : undefined;
                                      const cvNameLabel = option?.cvName || 'Unbenannt';
                                      return typeof matchPercent === 'number' ? `${matchPercent}% ${cvNameLabel}` : cvNameLabel;
                                    }}
                                    isOptionEqualToValue={(option: any, value: any) =>
                                      getCvSetRef(option) === getCvSetRef(value)
                                    }
                                    filterOptions={(options: any[], state) => {
                                      const search = (state.inputValue || '').toLowerCase();
                                      if (!search) return options;
                                      return options.filter((cv: any) => {
                                        const name = (cv.cvName || '').toLowerCase();
                                        const email = (cv.email || '').toLowerCase();
                                        return name.includes(search) || email.includes(search);
                                      });
                                    }}
                                    renderOption={(props, option: any) => {
                                      const cvId = getNormalizedCvId(option?.cvId);
                                      const matchPercent = cvId ? cvKeywordMatchPercentByCvId[cvId] : undefined;
                                      return (
                                        <li {...props}>
                                          <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 1 }}>
                                            <Typography
                                              variant="caption"
                                              sx={{
                                                minWidth: 42,
                                                textAlign: 'right',
                                                fontWeight: 700,
                                                color: typeof matchPercent === 'number' ? '#667eea' : '#94a3b8'
                                              }}
                                            >
                                              {typeof matchPercent === 'number' ? `${matchPercent}%` : '--'}
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: '#1e293b', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                              {option?.cvName || 'Unbenannt'}
                                            </Typography>
                                          </Box>
                                        </li>
                                      );
                                    }}
                                    renderTags={(tagValue: any[], getTagProps) =>
                                      tagValue.map((option: any, index: number) => {
                                        const cvId = getNormalizedCvId(option?.cvId);
                                        const matchPercent = cvId ? cvKeywordMatchPercentByCvId[cvId] : undefined;
                                        const cvNameLabel = option?.cvName || 'Unbenannt';
                                        const chipLabel = typeof matchPercent === 'number'
                                          ? `${matchPercent}% ${cvNameLabel}`
                                          : cvNameLabel;
                                        return (
                                          <Chip
                                            {...getTagProps({ index })}
                                            key={`${getCvSetRef(option)}-${index}`}
                                            label={chipLabel}
                                            size="small"
                                          />
                                        );
                                      })
                                    }
                                    noOptionsText={getTranslatedCvLabel('Keine CV Daten vorhanden')}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder={getTranslatedCvLabel('Suche')}
                                        sx={{
                                          '& .MuiOutlinedInput-root': {
                                            borderRadius: 2
                                          }
                                        }}
                                      />
                                    )}
                                  />
                              </Box>
                            )}
                          </Box>
                        </Box>
                        
                        {(extractedJobInfo.contactInfo !== undefined && extractedJobInfo.contactInfo !== null) && (
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="caption" sx={{ 
                              fontWeight: 700, 
                              color: '#64748b', 
                              fontSize: '0.7rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block'
                            }}>
                              {getTranslatedCvLabel('Kontaktdaten')}
                            </Typography>
                            <TextField
                              fullWidth
                              multiline
                              minRows={1}
                              maxRows={6}
                              value={extractedJobInfo.contactInfo || ''}
                              onChange={(e) => handleExtractedJobInfoFieldChange('contactInfo', e.target.value)}
                              variant="outlined"
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: 2,
                                  '&:hover fieldset': {
                                    borderColor: '#667eea',
                                  },
                                  '&.Mui-focused fieldset': {
                                    borderColor: '#667eea',
                                  },
                                }
                              }}
                            />
                          </Box>
                        )}

                        {(extractedJobInfo.keywords !== undefined && extractedJobInfo.keywords !== null) && (
                          <Box sx={{ mb: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
                              <Typography variant="caption" sx={{ 
                                fontWeight: 700, 
                                color: '#64748b', 
                                fontSize: '0.7rem',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                display: 'block'
                              }}>
                                {getTranslatedCvLabel('Schlüsselstichworte')}
                              </Typography>
                              {(accountType === 'Pro' || accountType === 'Beta-Testing') &&
                                (extractedJobInfo?.keywords || []).length > 0 && (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <Tooltip
                                    title={
                                      currentLanguage === 'de'
                                        ? 'CV-Daten Sets anhand Schlüsselstichworten abgleichen'
                                        : 'Match CV data sets by keywords'
                                    }
                                    arrow
                                  >
                                    <span>
                                      <IconButton
                                        size="small"
                                        onClick={handleMatchCvSetsByKeywords}
                                        disabled={matchingCvSetsByKeywords}
                                        sx={{ color: '#667eea', p: 0.25 }}
                                      >
                                        {matchingCvSetsByKeywords ? <CircularProgress size={16} /> : <SearchIcon fontSize="small" />}
                                      </IconButton>
                                    </span>
                                  </Tooltip>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 180 }}>
                                    <Slider
                                      value={keywordMatchMinPercent}
                                      onChange={(_, newValue) =>
                                        setKeywordMatchMinPercent(Array.isArray(newValue) ? newValue[0] : newValue)
                                      }
                                      min={0}
                                      max={100}
                                      step={1}
                                      size="small"
                                      valueLabelDisplay="auto"
                                      sx={{ color: '#667eea', flex: 1 }}
                                    />
                                    <Typography variant="caption" sx={{ color: '#64748b', minWidth: 38, textAlign: 'right' }}>
                                      {keywordMatchMinPercent}%
                                    </Typography>
                                  </Box>
                                </Box>
                              )}
                            </Box>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1 }}>
                              {(extractedJobInfo.keywords || []).map((keyword: string, idx: number) => (
                                <Chip
                                  key={`${keyword}-${idx}`}
                                  label={keyword}
                                  onDelete={() => handleRemoveExtractedJobKeyword(keyword)}
                                  sx={{
                                    bgcolor: '#667eea',
                                    color: 'white',
                                    fontWeight: 600
                                  }}
                                />
                              ))}
                            </Box>
                            <TextField
                              fullWidth
                              value={jobKeywordInput}
                              onChange={(e) => setJobKeywordInput(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ',') {
                                  e.preventDefault();
                                  handleAddExtractedJobKeyword(jobKeywordInput);
                                }
                              }}
                              onBlur={() => handleAddExtractedJobKeyword(jobKeywordInput)}
                              placeholder="Keyword eingeben und Enter drücken"
                              variant="outlined"
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: 2,
                                  '&:hover fieldset': {
                                    borderColor: '#667eea',
                                  },
                                  '&.Mui-focused fieldset': {
                                    borderColor: '#667eea',
                                  },
                                }
                              }}
                            />
                          </Box>
                        )}

                        {(extractedJobInfo['requirements-muss'] !== undefined && extractedJobInfo['requirements-muss'] !== null) && (
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="caption" sx={{
                              fontWeight: 700,
                              color: '#64748b',
                              fontSize: '0.7rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block'
                            }}>
                              {getTranslatedCvLabel('Muss-Anforderungen')}
                            </Typography>
                            <TextField
                              fullWidth
                              multiline
                              minRows={2}
                              maxRows={8}
                              value={extractedJobInfo['requirements-muss'] || ''}
                              onChange={(e) => handleExtractedJobRequirementChange('requirements-muss', e.target.value)}
                              variant="outlined"
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: 2,
                                  '&:hover fieldset': {
                                    borderColor: '#667eea',
                                  },
                                  '&.Mui-focused fieldset': {
                                    borderColor: '#667eea',
                                  },
                                }
                              }}
                            />
                          </Box>
                        )}

                        {(extractedJobInfo['requirements-soll'] !== undefined && extractedJobInfo['requirements-soll'] !== null) && (
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="caption" sx={{
                              fontWeight: 700,
                              color: '#64748b',
                              fontSize: '0.7rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block'
                            }}>
                              {getTranslatedCvLabel('Soll-Anforderungen')}
                            </Typography>
                            <TextField
                              fullWidth
                              multiline
                              minRows={2}
                              maxRows={8}
                              value={extractedJobInfo['requirements-soll'] || ''}
                              onChange={(e) => handleExtractedJobRequirementChange('requirements-soll', e.target.value)}
                              variant="outlined"
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: 2,
                                  '&:hover fieldset': {
                                    borderColor: '#667eea',
                                  },
                                  '&.Mui-focused fieldset': {
                                    borderColor: '#667eea',
                                  },
                                }
                              }}
                            />
                          </Box>
                        )}

                        {(extractedJobInfo['requirements-kann'] !== undefined && extractedJobInfo['requirements-kann'] !== null) && (
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="caption" sx={{
                              fontWeight: 700,
                              color: '#64748b',
                              fontSize: '0.7rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block'
                            }}>
                              {getTranslatedCvLabel('Kann-Anforderungen')}
                            </Typography>
                            <TextField
                              fullWidth
                              multiline
                              minRows={2}
                              maxRows={8}
                              value={extractedJobInfo['requirements-kann'] || ''}
                              onChange={(e) => handleExtractedJobRequirementChange('requirements-kann', e.target.value)}
                              variant="outlined"
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: 2,
                                  '&:hover fieldset': {
                                    borderColor: '#667eea',
                                  },
                                  '&.Mui-focused fieldset': {
                                    borderColor: '#667eea',
                                  },
                                }
                              }}
                            />
                          </Box>
                        )}

                        {(extractedJobInfo.requirements !== undefined && extractedJobInfo.requirements !== null) &&
                          (extractedJobInfo['requirements-muss'] === undefined || extractedJobInfo['requirements-muss'] === null) &&
                          (extractedJobInfo['requirements-soll'] === undefined || extractedJobInfo['requirements-soll'] === null) &&
                          (extractedJobInfo['requirements-kann'] === undefined || extractedJobInfo['requirements-kann'] === null) && (
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="caption" sx={{ 
                              fontWeight: 700, 
                              color: '#64748b', 
                              fontSize: '0.7rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block'
                            }}>
                              {getTranslatedCvLabel('Anforderungen')}
                            </Typography>
                            <TextField
                              fullWidth
                              multiline
                              minRows={2}
                              maxRows={8}
                              value={extractedJobInfo.requirements || ''}
                              onChange={(e) => handleExtractedJobRequirementChange('requirements', e.target.value)}
                              variant="outlined"
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: 2,
                                  '&:hover fieldset': {
                                    borderColor: '#667eea',
                                  },
                                  '&.Mui-focused fieldset': {
                                    borderColor: '#667eea',
                                  },
                                }
                              }}
                            />
                          </Box>
                        )}

                        {(extractedJobInfo.tasks !== undefined && extractedJobInfo.tasks !== null) && (
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="caption" sx={{
                              fontWeight: 700,
                              color: '#64748b',
                              fontSize: '0.7rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block'
                            }}>
                              {getTranslatedCvLabel('Aufgaben')}
                            </Typography>
                            <TextField
                              fullWidth
                              multiline
                              minRows={2}
                              maxRows={10}
                              value={extractedJobInfo.tasks || ''}
                              onChange={(e) => handleExtractedJobInfoFieldChange('tasks', e.target.value)}
                              variant="outlined"
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: 2,
                                  '&:hover fieldset': {
                                    borderColor: '#667eea',
                                  },
                                  '&.Mui-focused fieldset': {
                                    borderColor: '#667eea',
                                  },
                                }
                              }}
                            />
                          </Box>
                        )}

                        {(extractedJobInfo.applicationDetails !== undefined && extractedJobInfo.applicationDetails !== null) && (
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="caption" sx={{ 
                              fontWeight: 700, 
                              color: '#64748b', 
                              fontSize: '0.7rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block'
                            }}>
                              {getTranslatedCvLabel('Bewerbungsdetails')}
                            </Typography>
                            <TextField
                              fullWidth
                              multiline
                              minRows={2}
                              maxRows={10}
                              value={extractedJobInfo.applicationDetails || ''}
                              onChange={(e) => handleExtractedJobInfoFieldChange('applicationDetails', e.target.value)}
                              variant="outlined"
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: 2,
                                  '&:hover fieldset': {
                                    borderColor: '#667eea',
                                  },
                                  '&.Mui-focused fieldset': {
                                    borderColor: '#667eea',
                                  },
                                }
                              }}
                            />
                          </Box>
                        )}

                        </>
                      ) : (
                        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <Typography variant="body2" sx={{ color: '#9e9e9e', textAlign: 'center', fontStyle: 'italic' }}>
                            {/* Text entfernt */}
                          </Typography>
                        </Box>
                      )}
                      </Box>
                    </Paper>
                  </Box>
                </Box>
                )}
                
                {/* Zurück Button bleibt beim Scrollen oberhalb des Chatbot-Icons */}
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 3,
                    mb: 3,
                    position: 'sticky',
                    bottom: 24,
                    zIndex: 1200,
                    py: 1,
                    pr: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                  }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                    {/* Zurück Button */}
                    <Button
                      variant="outlined"
                      onClick={() => {
                        resetApplicationSelectionForNewJobDescription();
                        // Setze Stellenbeschreibung zurück
                        setJobDescription('');
                        // Zeige Stellenbeschreibung Textfeld an
                        setHideJobDescription(false);
                        // Zeige "Passgenauigkeit berechnen" Button an
                        setShowPassgenauigkeitButton(true);
                        // Verstecke CV-Optimieren Button
                        setShowCvOptimierenButton(false);
                        
                        // Lösche Passgenauigkeit
                        setMatchScore(null);
                        setMissingSkills([]);
                        setWeaknesses([]);
                        
                        // Lösche optimierte CV-Daten
                        setImprovedCvText(null);
                        setOptimizedShortProfile('');
                        setOptimizedWorkExperiences([]);
                        setMotivationLetter(null);
                        
                        // Lösche Job-Informationen
                        setExtractedJobInfo(null);
                        setJobUrl(null);
                        
                        // Wechsle zum "Start" Tab und Sub-Tab "Bewerbungen"
                        setCvTabIndex(0);
                        setBewerbungenSubTabIndex(0);
                        
                        // Deaktiviere Motivationsschreiben-Icon
                        setCvTemplateHasBeenOpened(false);
                        
                        // Leere nur die optimierten Ergebnisse, behalte Original-CV-Daten
                      }}
                      sx={{
                        width: 'auto',
                        px: 3,
                        py: 1.5,
                        borderRadius: 6,
                        borderColor: '#667eea',
                        color: '#757575',
                        fontWeight: 600,
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          borderColor: '#764ba2',
                          backgroundColor: '#f5f5f5',
                          transform: 'translateY(-1px)',
                        },
                      }}
                    >
                      {t('button.back.to.applications')}
                    </Button>
                  </Box>
                </Box>
              </Box>
              )}
              
            </Box>
          )}
              </>
          </Box>
        )}
        
        {/* CV-Daten Modal */}
        <Dialog 
          open={showCvDataModal}
          BackdropProps={{
            sx: {
              backgroundColor: 'rgba(0, 0, 0, 0.25)' // Halbierte Opazität (Standard: 0.5)
            }
          }}
          onClose={handleCloseCvDataModal}
          maxWidth="lg"
          fullWidth
          sx={{
            zIndex: 1600
          }}
          PaperProps={{
            sx: {
              maxHeight: '95vh',
              height: '95vh',
              margin: '20px',
              borderRadius: 3
            }
          }}
        >
          <DialogTitle sx={{ 
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            borderBottom: 'none',
            borderRadius: '12px 12px 0 0'
          }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                  {getTranslatedCvLabel('CV-Daten')}
                </Typography>
                <TextField
                  key={`cv-name-${currentCvName || ''}`}
                  defaultValue={currentCvName}
                  onBlur={(e) => {
                    const nextValue = e.target.value;
                    if (nextValue !== currentCvName) {
                      setCurrentCvName(nextValue);
                      setHasUnsavedChanges(true);
                    }
                  }}
                  placeholder="CV Name"
                  size="small"
                  sx={{
                    minWidth: '150px',
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      color: 'white',
                      bgcolor: 'rgba(255,255,255,0.08)',
                      width: currentCvName ? `${Math.max(150, currentCvName.length * 8.5 + 60)}px` : '150px',
                      minWidth: '150px',
                      transition: 'width 0.2s ease',
                      '& .MuiOutlinedInput-input': {
                        width: '100%',
                        color: 'white'
                      },
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(255,255,255,0.35)',
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(255,255,255,0.7)',
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'white',
                      },
                      '& input::placeholder': {
                        color: 'rgba(255,255,255,0.75)',
                        opacity: 1
                      }
                    }
                  }}
                />
                <Tooltip title={getTranslatedCvLabel('Info anzeigen')} arrow>
                  <IconButton
                    onClick={() => {
                      // Wenn Passgenauigkeit angezeigt wird, toggle matchScore Info
                      // Sonst toggle cvDataInfo
                      if ((matchScore !== null || missingSkills.length > 0 || weaknesses.length > 0 || checkingMatchInModal) && !optimizing) {
                        setMinimizedInfoBoxes(prev => ({ ...prev, matchScore: false }));
                      } else {
                        setMinimizedInfoBoxes(prev => ({ ...prev, cvDataInfo: !prev.cvDataInfo }));
                      }
                    }}
                    sx={{
                      color: 'white',
                      p: 0.5,
                      '&:hover': {
                        bgcolor: 'rgba(255,255,255,0.1)'
                      }
                    }}
                  >
                    <InfoOutlinedIcon sx={{ fontSize: 20 }} />
                  </IconButton>
                </Tooltip>
              </Box>
              <Box sx={{ display: 'flex', gap: 1 }}>
                {!openCvModalFromPassgenauigkeit && (
                  <>
                <Tooltip 
                  title="CV löschen"
                  arrow
                >
                  <span>
                    <IconButton 
                      size="small"
                      onClick={() => setShowDeleteCvDialog(true)}
                      disabled={!selectedCvId}
                      sx={{
                        color: 'white',
                        transition: 'all 0.2s ease',
                        borderRadius: '50%',
                        '&:hover': {
                          color: '#ffebee',
                          bgcolor: 'rgba(255,255,255,0.1)',
                          transform: 'scale(1.1)',
                          borderRadius: '50%'
                        },
                        '&:disabled': {
                          color: 'rgba(255,255,255,0.5)'
                        }
                      }}
                    >
                    <DeleteIcon />
                  </IconButton>
                  </span>
                </Tooltip>
                <Tooltip 
                  title="CV-Daten als CSV exportieren"
                  arrow
                >
                  <IconButton 
                    size="small"
                    onClick={exportCvDataAsCsv}
                    disabled={!selectedCvId}
                    sx={{
                      color: 'white',
                      transition: 'all 0.2s ease',
                      borderRadius: '50%',
                      '&:hover': {
                        color: 'white',
                        bgcolor: 'rgba(255,255,255,0.1)',
                        transform: 'scale(1.1)',
                        borderRadius: '50%'
                      },
                      '&:disabled': {
                        color: 'rgba(255,255,255,0.5)'
                      }
                    }}
                  >
                    <DownloadIcon />
                  </IconButton>
                </Tooltip>
                  </>
                )}
                <Tooltip 
                  title={hasUnsavedChanges ? getTranslatedCvLabel('Daten speichern') : getTranslatedCvLabel('Keine Änderungen zum Speichern')}
                  arrow
                >
                  <span>
                    <IconButton 
                      onClick={async () => {
                        if (user) {
                          try {
                            // Speichere alle CV-Daten nach Firebase
                            const committedWorkExperiences = (draftWorkExperiences || []).map(exp => ({ ...exp }));
                            const committedEducations = (draftEducations || []).map(edu => ({ ...edu }));
                            const committedCertifications = (draftCertifications || []).map(cert => ({ ...cert }));
                            const persistedCvId = await saveAllCvDataToFirebase({
                              updatedWorkExperiences: committedWorkExperiences,
                              updatedEducations: committedEducations,
                              updatedCertifications: committedCertifications
                            });
                            if (!persistedCvId) {
                              setError('❌ Speichern nicht möglich: keine eindeutige CV-Zuordnung');
                              setTimeout(() => setError(null), 3000);
                              return;
                            }
                            
                            // Setze ungespeicherte Änderungen zurück
                            setHasUnsavedChanges(false);
                            
                            // Zeige Erfolgs-Feedback
                            setError('✅ Daten gespeichert!');
                            setTimeout(() => setError(null), 2000);
                            
                            console.log('✅ CV-Daten erfolgreich in Firebase gespeichert und neu geladen');
                            
                            // Schließe das Modal nach dem Speichern
                            setShowCvDataModal(false);
                          } catch (error) {
                            console.error('❌ Fehler beim Speichern der CV-Daten:', error);
                            setError('❌ Fehler beim Speichern der Daten');
                            setTimeout(() => setError(null), 3000);
                          }
                        }
                      }}
                      disabled={!hasUnsavedChanges}
                      size="small"
                      sx={{
                        color: hasUnsavedChanges ? 'white' : 'rgba(255,255,255,0.5)',
                        transition: 'all 0.2s ease',
                        borderRadius: '50%',
                        '&:hover': {
                          bgcolor: hasUnsavedChanges ? 'rgba(255,255,255,0.1)' : 'transparent',
                          borderRadius: '50%',
                          transform: hasUnsavedChanges ? 'scale(1.1)' : 'none'
                        }
                      }}
                    >
                      <SaveOutlinedIcon />
                    </IconButton>
                  </span>
                </Tooltip>
                <IconButton 
                  onClick={handleCloseCvDataModal}
                  sx={{ 
                    color: 'white',
                    '&:hover': {
                      backgroundColor: 'rgba(255,255,255,0.1)'
                    }
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent sx={{ p: 3, overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
            {/* Allgemeine Info-Box für CV-Daten - wird nur gezeigt, wenn Passgenauigkeits-Bereich nicht sichtbar ist, keine Neuberechnung läuft UND nicht minimiert */}
            {!((matchScore !== null || missingSkills.length > 0 || weaknesses.length > 0 || checkingMatchInModal) && !optimizing) && !minimizedInfoBoxes['cvDataInfo'] && (
              <Box sx={{ mb: 2 }}>
                <Alert 
                  severity="info" 
                  sx={{ 
                    borderRadius: 2,
                    backgroundColor: '#e3f2fd',
                    border: '1px solid #90caf9',
                    '& .MuiAlert-icon': {
                      color: '#1976d2'
                    }
                  }}
                  action={
                    <IconButton size="small" onClick={() => setMinimizedInfoBoxes(prev => ({ ...prev, cvDataInfo: true }))}>
                      <CloseIcon fontSize="small" sx={{ color: '#1976d2' }} />
                    </IconButton>
                  }
                >
                  <Typography variant="body2" sx={{ color: '#1565c0', fontWeight: 500 }}>
                    {getTranslatedCvLabel('Bitte überprüfe deine CV-Daten genau und nimm nötige Änderungen direkt in dieser Maske vor.')}
                  </Typography>
                </Alert>
              </Box>
            )}
            
            {/* Info-Textbox oberhalb - nur wenn Passgenauigkeit vorhanden oder während Neuberechnung, und nicht minimiert */}
            {(matchScore !== null || missingSkills.length > 0 || weaknesses.length > 0 || checkingMatchInModal) && !optimizing && !minimizedInfoBoxes['matchScore'] && (
              <Box sx={{ mb: 2 }}>
                <Alert 
                  severity="info" 
                  sx={{ 
                    borderRadius: 2,
                    backgroundColor: '#f0f7ff',
                    border: '1px solid #b3d9ff',
                    '& .MuiAlert-icon': {
                      color: '#1976d2'
                    }
                  }}
                  action={
                    <IconButton size="small" onClick={() => setMinimizedInfoBoxes(prev => ({ ...prev, matchScore: true }))}>
                      <CloseIcon fontSize="small" sx={{ color: '#1976d2' }} />
                    </IconButton>
                  }
                >
                  <Typography variant="body2" sx={{ color: '#1976d2', fontWeight: 500 }}>
                    {currentLanguage === 'de' ? 'Hier siehst du die berechnete Passgenauigkeit. Diese sollte mindestens 75% betragen. Weiter findest du eine Liste mit fehlenden Erfahrungen und Schwächen, welche deine CV Daten im Vergleich mit der Stellenbeschreibung aufweisen. Du kannst nun deine CV Daten ergänzen, um die Passgenauigkeit zu erhöhen. Bleibe hier aber wahrheitsgetreu. Hast du eine Ergänzung vorgenommen, kannst du den Punkt mit der Checkbox bestätigen. Dies kann dir helfen die Übersicht nicht zu verlieren.' :
                     currentLanguage === 'en' ? 'Here you can see the calculated match score. This should be at least 75%. You will also find a list of missing experiences and weaknesses that your CV data has compared to the job description. You can now supplement your CV data to increase the match score. However, remain truthful. If you have made a supplement, you can confirm the point with the checkbox. This can help you not lose track.' :
                     currentLanguage === 'fr' ? 'Ici vous pouvez voir le score de correspondance calculé. Celui-ci devrait être d\'au moins 75%. Vous trouverez également une liste des expériences manquantes et des faiblesses que vos données CV ont par rapport à la description du poste. Vous pouvez maintenant compléter vos données CV pour augmenter le score de correspondance. Cependant, restez véridique. Si vous avez fait un complément, vous pouvez confirmer le point avec la case à cocher. Cela peut vous aider à ne pas perdre le fil.' :
                     'Qui puoi vedere il punteggio di corrispondenza calcolato. Questo dovrebbe essere almeno del 75%. Troverai anche un elenco di esperienze mancanti e debolezze che i tuoi dati CV hanno rispetto alla descrizione del lavoro. Ora puoi integrare i tuoi dati CV per aumentare il punteggio di corrispondenza. Tuttavia, rimani veritiero. Se hai fatto un\'integrazione, puoi confermare il punto con la casella di controllo. Questo può aiutarti a non perdere il filo.'}
                  </Typography>
                </Alert>
              </Box>
            )}
            
            {/* Flex Container für Sidebar (links) und Inhalt (rechts) */}
            <Box sx={{ display: 'flex', gap: 3, flex: 1, minHeight: 0 }}>
              {/* Linke Sidebar: Passgenauigkeit (sticky) - NUR anzeigen wenn Modal von "Passgenauigkeit prüfen" geöffnet wurde */}
              {(matchScore !== null || missingSkills.length > 0 || weaknesses.length > 0 || checkingMatchInModal) && !optimizing && openCvModalFromPassgenauigkeit && (
                <Box sx={{ 
                  width: '320px', 
                  flexShrink: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  mt: 3,
                  minHeight: 0,
                  maxHeight: 'calc(100vh - 120px)',
                  overflow: 'hidden'
                }}>
                  <Paper sx={{ py: 3, pl: 1.5, pr: 0.5, background: '#f8f9fa', border: '1px solid #dee2e6', flex: 1, display: 'flex', flexDirection: 'column', position: 'relative', minHeight: 0, overflow: 'hidden' }}>
                    {/* Refresh-Icon in der linken oberen Ecke */}
                    <IconButton
                      onClick={handleRecalculateMatchScoreFromModal}
                      disabled={
                        !hasUnsavedChanges ||
                        checkingMatchInModal ||
                        (
                          !(jobDescription && jobDescription.trim()) &&
                          !(selectedApplication?.jobDescription && selectedApplication.jobDescription.trim())
                        )
                      }
                      sx={{
                        position: 'absolute',
                        top: 8,
                        left: 8,
                        zIndex: 10,
                        color: (!hasUnsavedChanges || checkingMatchInModal) ? '#999' : '#667eea',
                        boxShadow: (
                          hasUnsavedChanges &&
                          !checkingMatchInModal &&
                          ((jobDescription && jobDescription.trim()) ||
                            (selectedApplication?.jobDescription && selectedApplication.jobDescription.trim()))
                        )
                          ? '0 0 0 0 rgba(102,126,234,0.7)'
                          : 'none',
                        '&:hover': {
                          backgroundColor: 'rgba(102, 126, 234, 0.1)',
                        },
                        '&.Mui-disabled': {
                          color: '#999',
                        },
                        '@keyframes chatbotPulse': {
                          '0%': {
                            boxShadow: '0 0 0 0 rgba(102,126,234,0.7)',
                            transform: 'scale(1)',
                          },
                          '50%': {
                            boxShadow: '0 0 0 16px rgba(102,126,234,0)',
                            transform: 'scale(1.1)',
                          },
                          '100%': {
                            boxShadow: '0 0 0 0 rgba(102,126,234,0)',
                            transform: 'scale(1)',
                          }
                        },
                        animation: (
                          hasUnsavedChanges &&
                          !checkingMatchInModal &&
                          ((jobDescription && jobDescription.trim()) ||
                            (selectedApplication?.jobDescription && selectedApplication.jobDescription.trim()))
                        )
                          ? 'chatbotPulse 1.5s ease-in-out infinite'
                          : 'none',
                      }}
                      title="Passgenauigkeit neu berechnen"
                    >
                      <RefreshIcon 
                        sx={{ 
                          fontSize: '2.5rem',
                          fontWeight: 'bold'
                        }} 
                      />
                    </IconButton>
                    
                    {/* Check-Icon in der rechten oberen Ecke - auf gleicher Höhe wie Refresh-Icon */}
                    <Tooltip title={getTranslatedCvLabel('Passgenauigkeit akzeptieren')}>
                      <IconButton
                        disabled={hasUnsavedChanges}
                        onClick={async () => {
                          const committedWorkExperiences = (draftWorkExperiences || []).map(exp => ({ ...exp }));
                          const committedEducations = (draftEducations || []).map(edu => ({ ...edu }));
                          const committedCertifications = (draftCertifications || []).map(cert => ({ ...cert }));
                          const persistedCvId = await saveAllCvDataToFirebase({
                            updatedWorkExperiences: committedWorkExperiences,
                            updatedEducations: committedEducations,
                            updatedCertifications: committedCertifications
                          });
                          if (!persistedCvId) {
                            setError('❌ Speichern nicht möglich: keine eindeutige CV-Zuordnung');
                            setTimeout(() => setError(null), 3000);
                            return;
                          }
                          handleCloseCvDataModal();
                        }}
                        sx={{
                          position: 'absolute',
                          top: 8,
                          right: 8,
                          zIndex: 10,
                          color: matchScore !== null
                            ? (matchScore >= 75 ? '#667eea' : matchScore >= 50 ? '#f59e0b' : '#ef4444')
                            : '#64748b',
                          boxShadow: (matchScore !== null && openCvModalFromPassgenauigkeit && !checkingMatchInModal && !hasUnsavedChanges)
                            ? (matchScore >= 75
                              ? '0 0 0 0 rgba(102,126,234,0.7)'
                              : matchScore >= 50
                                ? '0 0 0 0 rgba(245,158,11,0.7)'
                                : '0 0 0 0 rgba(239,68,68,0.7)')
                            : 'none',
                          '&:hover': {
                            backgroundColor: matchScore !== null
                              ? (matchScore >= 75
                                ? 'rgba(102, 126, 234, 0.1)'
                                : matchScore >= 50
                                  ? 'rgba(245, 158, 11, 0.1)'
                                  : 'rgba(239, 68, 68, 0.1)')
                              : 'rgba(100, 116, 139, 0.1)',
                          },
                          '&.Mui-disabled': {
                            color: '#bdbdbd',
                          },
                          '@keyframes chatbotPulse': {
                            '0%': {
                              boxShadow: matchScore !== null
                                ? (matchScore >= 75
                                  ? '0 0 0 0 rgba(102,126,234,0.7)'
                                  : matchScore >= 50
                                    ? '0 0 0 0 rgba(245,158,11,0.7)'
                                    : '0 0 0 0 rgba(239,68,68,0.7)')
                                : '0 0 0 0 rgba(100,116,139,0.7)',
                              transform: 'scale(1)',
                            },
                            '50%': {
                              boxShadow: matchScore !== null
                                ? (matchScore >= 75
                                  ? '0 0 0 16px rgba(102,126,234,0)'
                                  : matchScore >= 50
                                    ? '0 0 0 16px rgba(245,158,11,0)'
                                    : '0 0 0 16px rgba(239,68,68,0)')
                                : '0 0 0 16px rgba(100,116,139,0)',
                              transform: 'scale(1.1)',
                            },
                            '100%': {
                              boxShadow: matchScore !== null
                                ? (matchScore >= 75
                                  ? '0 0 0 0 rgba(102,126,234,0)'
                                  : matchScore >= 50
                                    ? '0 0 0 0 rgba(245,158,11,0)'
                                    : '0 0 0 0 rgba(239,68,68,0)')
                                : '0 0 0 0 rgba(100,116,139,0)',
                              transform: 'scale(1)',
                            }
                          },
                          animation: (matchScore !== null && openCvModalFromPassgenauigkeit && !checkingMatchInModal && !hasUnsavedChanges)
                            ? 'chatbotPulse 1.5s ease-in-out infinite'
                            : 'none',
                        }}
                      >
                        <CheckCircleIcon
                          sx={{
                            fontSize: '2.5rem'
                          }}
                        />
                      </IconButton>
                    </Tooltip>
                    
                    {/* Ringe Container - NUR anzeigen wenn Modal von "Passgenauigkeit prüfen" geöffnet wurde */}
                    {(matchScore !== null || checkingMatchInModal || (showCvDataModal && openCvModalFromPassgenauigkeit)) && openCvModalFromPassgenauigkeit && (
                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3, flexShrink: 0 }}>
                        <Box sx={{ position: 'relative', display: 'flex', width: '160px', height: '160px', justifyContent: 'center', alignItems: 'center', margin: '0 auto' }}>
                          {/* Grauer Hintergrund-Ring */}
                          <CircularProgress
                            variant={checkingMatchInModal ? "indeterminate" : "determinate"}
                            value={checkingMatchInModal ? undefined : 100}
                            size={160}
                            thickness={2}
                            sx={{
                              color: '#e0e0e0',
                              position: 'absolute',
                              top: 0,
                              left: 0,
                            }}
                          />
                          {/* Farbiger Fortschritts-Ring oder Warte-Animation */}
                          {checkingMatchInModal ? (
                            <CircularProgress
                              variant="indeterminate"
                              size={160}
                              thickness={2}
                              sx={{
                                color: '#667eea',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                              }}
                            />
                          ) : (
                            matchScore !== null && openCvModalFromPassgenauigkeit && (
                              <CircularProgress
                                variant="determinate"
                                value={matchScore}
                                size={160}
                                thickness={2}
                                sx={{
                                  color: matchScore >= 75 ? '#667eea' : matchScore >= 50 ? '#f59e0b' : '#ef4444',
                                  position: 'absolute',
                                  top: 0,
                                  left: 0,
                                }}
                              />
                            )
                          )}
                          {/* Ring auf 0, wenn matchScore null ist (nach Datenänderung) */}
                          {matchScore === null && !checkingMatchInModal && openCvModalFromPassgenauigkeit && (
                            <CircularProgress
                              variant="determinate"
                              value={0}
                              size={160}
                              thickness={2}
                              sx={{
                                color: '#e0e0e0',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                              }}
                            />
                          )}
                          <Box
                            sx={{
                              top: 0,
                              left: 0,
                              bottom: 0,
                              right: 0,
                              position: 'absolute',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            {(checkingMatchInModal || matchScore !== null || (showCvDataModal && openCvModalFromPassgenauigkeit)) && (
                              <Typography
                                variant="h5"
                                component="div"
                                sx={{ 
                                  fontWeight: 'normal',
                                  color: '#000000',
                                  m: 0,
                                  fontSize: '3rem'
                                }}
                              >
                                {checkingMatchInModal ? '..%' : (matchScore !== null ? `${Math.round(matchScore!)}%` : '..%')}
                              </Typography>
                            )}
                          </Box>
                        </Box>
                      </Box>
                    )}

                    {/* Liste Container */}
                    {(missingSkills.length > 0 || weaknesses.length > 0 || checkingMatchInModal) && (
                      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                        <Box sx={{ mb: 1, flexShrink: 0 }}>
                          <Typography variant="subtitle1" sx={{ fontWeight: 'normal', color: '#000000' }}>
                            {getTranslatedCvLabel('Fehlende Skills/Erfahrungen:')}
                          </Typography>
                        </Box>
                        <List 
                          dense
                          sx={{
                            flex: 1,
                            overflowY: 'auto',
                            pb: 1,
                            pr: 0.5,
                            minHeight: 0,
                            '&::-webkit-scrollbar': {
                              width: '8px',
                            },
                            '&::-webkit-scrollbar-track': {
                              backgroundColor: '#f1f1f1',
                              borderRadius: '4px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                              backgroundColor: '#9e9e9e',
                              borderRadius: '4px',
                              '&:hover': {
                                backgroundColor: '#757575',
                              },
                            },
                          }}
                        >
                          {missingSkills.map((skill, index) => {
                            const parsedSkill = parseMatchPriority(skill);
                            return !hiddenMissingSkills.has(index) && (
                              <ListItem key={index} sx={{ 
                                py: 0.5, 
                                pl: 2, 
                                border: '1px solid #e0e0e0',
                                borderRadius: 1,
                                mb: 1,
                                backgroundColor: 'white',
                                display: 'flex',
                                alignItems: 'center',
                                '&:hover': {
                                  backgroundColor: '#f5f5f5',
                                }
                              }}>
                                <ListItemText
                                  primary={
                                    <Box>
                                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.25 }}>
                                        <Typography
                                          variant="caption"
                                          sx={{
                                            display: 'block',
                                            color: '#667eea',
                                            fontWeight: 700,
                                            lineHeight: 1.2
                                          }}
                                        >
                                          {getTranslatedCvLabel('Fehlende Erfahrung')}
                                        </Typography>
                                        {parsedSkill.priority && (
                                          <Chip
                                            size="small"
                                            label={getPriorityChipLabel(parsedSkill.priority)}
                                            sx={getPriorityChipSx(parsedSkill.priority)}
                                          />
                                        )}
                                      </Box>
                                      <Typography
                                        sx={{
                                          fontSize: '0.875rem',
                                          wordBreak: 'break-word',
                                        }}
                                      >
                                        {parsedSkill.text}
                                      </Typography>
                                    </Box>
                                  }
                                  sx={{ flex: 1 }}
                                />
                                <Checkbox
                                  checked={false}
                                  onChange={() => handleHideMissingSkill(index)}
                                  size="small"
                                  disableRipple
                                  disableFocusRipple
                                  sx={{ 
                                    '&:hover': { backgroundColor: 'transparent' },
                                    '& .MuiTouchRipple-root': { display: 'none' },
                                    color: '#667eea',
                                    marginLeft: 'auto',
                                    mr: -2,
                                    '&.Mui-checked': {
                                      color: '#667eea',
                                    },
                                  }}
                                />
                              </ListItem>
                            )
                          })}
                          {weaknesses.map((weakness, index) => {
                            const parsedWeakness = parseMatchPriority(weakness);
                            return !hiddenWeaknesses.has(index) && (
                              <ListItem key={`weakness-${index}`} sx={{ 
                                py: 0.5, 
                                pl: 2, 
                                border: '1px solid #e0e0e0',
                                borderRadius: 1,
                                mb: 1,
                                backgroundColor: 'white',
                                display: 'flex',
                                alignItems: 'center',
                                '&:hover': {
                                  backgroundColor: '#f5f5f5',
                                }
                              }}>
                                <ListItemText
                                  primary={
                                    <Box>
                                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.25 }}>
                                        <Typography
                                          variant="caption"
                                          sx={{
                                            display: 'block',
                                            color: '#667eea',
                                            fontWeight: 700,
                                            lineHeight: 1.2
                                          }}
                                        >
                                          {getTranslatedCvLabel('Schwäche')}
                                        </Typography>
                                        {parsedWeakness.priority && (
                                          <Chip
                                            size="small"
                                            label={getPriorityChipLabel(parsedWeakness.priority)}
                                            sx={getPriorityChipSx(parsedWeakness.priority)}
                                          />
                                        )}
                                      </Box>
                                      <Typography
                                        sx={{
                                          fontSize: '0.875rem',
                                          wordBreak: 'break-word',
                                        }}
                                      >
                                        {parsedWeakness.text}
                                      </Typography>
                                    </Box>
                                  }
                                  sx={{ flex: 1 }}
                                />
                                <Checkbox
                                  checked={false}
                                  onChange={() => handleHideWeakness(index)}
                                  size="small"
                                  disableRipple
                                  disableFocusRipple
                                  sx={{ 
                                    '&:hover': { backgroundColor: 'transparent' },
                                    '& .MuiTouchRipple-root': { display: 'none' },
                                    color: '#667eea',
                                    marginLeft: 'auto',
                                    mr: -2,
                                    '&.Mui-checked': {
                                      color: '#667eea',
                                    },
                                  }}
                                />
                              </ListItem>
                            )
                          })}
                        </List>
                      </Box>
                    )}
                  </Paper>
                </Box>
              )}
              
              {/* Rechter Bereich: Tabs und Inhalte */}
              <Box ref={cvDataTabContentRef} sx={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', pr: 1, minHeight: 0 }}>
                <Tabs value={tabIndex} onChange={handleTabChange} variant="scrollable" scrollButtons="auto" sx={{ mb: 2, position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1, borderBottom: '1px solid #e0e0e0' }}>
                  <Tab label={t('cv.personal.info')} />
                  <Tab label={t('cv.work.experience')} />
                  <Tab label={t('cv.education')} />
                  <Tab label={getTranslatedCvLabel('Weitere Angaben')} />
                </Tabs>
          
          {tabIndex === 0 && (
            <Box sx={{ mt: 3 }}>
              {/* Persönliche Angaben + Profilbild */}
              <Box sx={{ display: 'flex', gap: 3, mb: 3 }}>
                {/* Linke Seite: Persönliche Angaben */}
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h6" gutterBottom>{t('cv.personal.info')}</Typography>
                  <TextField label={t('cv.personal.fullname')} key={`cv-fullname-${fullName || ''}`} defaultValue={fullName} onBlur={e => { const v = e.target.value; if (v !== fullName) handleFullNameChange(v); }} fullWidth sx={{ mb: 2 }} />
                  <TextField label={t('cv.personal.company')} key={`cv-company-${company || ''}`} defaultValue={company} onBlur={e => { const v = e.target.value; if (v !== company) handleCvDataChange(setCompany, v); }} fullWidth sx={{ mb: 2 }} />
                  <TextField label={t('cv.personal.address')} key={`cv-address-${address || ''}`} defaultValue={address} onBlur={e => { const v = e.target.value; if (v !== address) handleCvDataChange(setAddress, v); }} fullWidth sx={{ mb: 2 }} />
                  <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                    <TextField label={t('cv.personal.postal.code')} key={`cv-postal-${postalCode || ''}`} defaultValue={postalCode} onBlur={e => { const v = e.target.value; if (v !== postalCode) handleCvDataChange(setPostalCode, v); }} sx={{ width: '40%' }} />
                    <TextField label={t('cv.personal.city')} key={`cv-city-${city || ''}`} defaultValue={city} onBlur={e => { const v = e.target.value; if (v !== city) handleCvDataChange(setCity, v); }} sx={{ width: '60%' }} />
                  </Box>
                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>{getTranslatedCvLabel('Land:').replace(':', '')}</InputLabel>
                    <Select
                      value={country}
                      label={getTranslatedCvLabel('Land:').replace(':', '')}
                      onChange={e => handleCvDataChange(setCountry, e.target.value)}
                      MenuProps={CV_DATA_MODAL_SELECT_MENU_PROPS}
                    >
                      <MenuItem value="">-</MenuItem>
                      <MenuItem value="CH">CH - Schweiz</MenuItem>
                      <MenuItem value="DE">DE - Deutschland</MenuItem>
                      <MenuItem value="AT">AT - Österreich</MenuItem>
                      <MenuItem value="FR">FR - Frankreich</MenuItem>
                      <MenuItem value="IT">IT - Italien</MenuItem>
                      <MenuItem value="ES">ES - Spanien</MenuItem>
                      <MenuItem value="PT">PT - Portugal</MenuItem>
                      <MenuItem value="NL">NL - Niederlande</MenuItem>
                      <MenuItem value="BE">BE - Belgien</MenuItem>
                      <MenuItem value="LU">LU - Luxemburg</MenuItem>
                      <MenuItem value="GB">GB - Großbritannien</MenuItem>
                      <MenuItem value="IE">IE - Irland</MenuItem>
                      <MenuItem value="DK">DK - Dänemark</MenuItem>
                      <MenuItem value="SE">SE - Schweden</MenuItem>
                      <MenuItem value="NO">NO - Norwegen</MenuItem>
                      <MenuItem value="FI">FI - Finnland</MenuItem>
                      <MenuItem value="IS">IS - Island</MenuItem>
                      <MenuItem value="other">{t('cv.personal.nationality.other')}</MenuItem>
                    </Select>
                  </FormControl>
                  <TextField 
                    label={getTranslatedCvLabel('Verfügbar ab:').replace(':', '')} 
                    type="date"
                    key={`cv-available-from-${availableFrom || ''}`}
                    defaultValue={availableFrom || ''} 
                    onBlur={e => { const v = e.target.value; if (v !== (availableFrom || '')) handleCvDataChange(setAvailableFrom, v); }} 
                    fullWidth 
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{ mb: 2 }} 
                  />
                  <TextField label={t('cv.personal.phone')} key={`cv-phone-${phoneNumber || ''}`} defaultValue={phoneNumber} onBlur={e => { const v = e.target.value; if (v !== phoneNumber) handleCvDataChange(setPhoneNumber, v); }} fullWidth sx={{ mb: 2 }} />
                  <TextField label={t('cv.personal.email')} key={`cv-email-${email || ''}`} defaultValue={email} onBlur={e => { const v = e.target.value; if (v !== email) handleCvDataChange(setEmail, v); }} fullWidth sx={{ mb: 2 }} />
                  <TextField label={t('cv.personal.birthyear')} key={`cv-birthyear-${birthYear || ''}`} defaultValue={birthYear} onBlur={e => { const v = e.target.value; if (v !== birthYear) handleCvDataChange(setBirthYear, v); }} fullWidth sx={{ mb: 2 }} />
                                  <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel>{t('cv.personal.nationality')}</InputLabel>
                  <Select 
                    value={nationality} 
                    label={t('cv.personal.nationality')} 
                    onChange={e => handleCvDataChange(setNationality, e.target.value)}
                    MenuProps={{
                      ...CV_DATA_MODAL_SELECT_MENU_PROPS,
                      PaperProps: { sx: { maxHeight: 400 } },
                    }}
                  >
                    <MenuItem value="">{t('cv.personal.nationality.select')}</MenuItem>
                    <MenuItem value="CH">CH - Schweiz</MenuItem>
                    <MenuItem value="DE">DE - Deutschland</MenuItem>
                    <MenuItem value="AT">AT - Österreich</MenuItem>
                    <MenuItem value="FR">FR - Frankreich</MenuItem>
                    <MenuItem value="IT">IT - Italien</MenuItem>
                    <MenuItem value="ES">ES - Spanien</MenuItem>
                    <MenuItem value="PT">PT - Portugal</MenuItem>
                    <MenuItem value="NL">NL - Niederlande</MenuItem>
                    <MenuItem value="BE">BE - Belgien</MenuItem>
                    <MenuItem value="LU">LU - Luxemburg</MenuItem>
                    <MenuItem value="DK">DK - Dänemark</MenuItem>
                    <MenuItem value="SE">SE - Schweden</MenuItem>
                    <MenuItem value="NO">NO - Norwegen</MenuItem>
                    <MenuItem value="FI">FI - Finnland</MenuItem>
                    <MenuItem value="IS">IS - Island</MenuItem>
                    <MenuItem value="GB">GB - Großbritannien</MenuItem>
                    <MenuItem value="IE">IE - Irland</MenuItem>
                    <MenuItem value="PL">PL - Polen</MenuItem>
                    <MenuItem value="CZ">CZ - Tschechien</MenuItem>
                    <MenuItem value="SK">SK - Slowakei</MenuItem>
                    <MenuItem value="HU">HU - Ungarn</MenuItem>
                    <MenuItem value="RO">RO - Rumänien</MenuItem>
                    <MenuItem value="BG">BG - Bulgarien</MenuItem>
                    <MenuItem value="HR">HR - Kroatien</MenuItem>
                    <MenuItem value="SI">SI - Slowenien</MenuItem>
                    <MenuItem value="RS">RS - Serbien</MenuItem>
                    <MenuItem value="BA">BA - Bosnien-Herzegowina</MenuItem>
                    <MenuItem value="ME">ME - Montenegro</MenuItem>
                    <MenuItem value="MK">MK - Nordmazedonien</MenuItem>
                    <MenuItem value="AL">AL - Albanien</MenuItem>
                    <MenuItem value="GR">GR - Griechenland</MenuItem>
                    <MenuItem value="CY">CY - Zypern</MenuItem>
                    <MenuItem value="MT">MT - Malta</MenuItem>
                    <MenuItem value="EE">EE - Estland</MenuItem>
                    <MenuItem value="LV">LV - Lettland</MenuItem>
                    <MenuItem value="LT">LT - Litauen</MenuItem>
                    <MenuItem value="TR">TR - Türkei</MenuItem>
                    <MenuItem value="RU">RU - Russland</MenuItem>
                    <MenuItem value="UA">UA - Ukraine</MenuItem>
                    <MenuItem value="BY">BY - Belarus</MenuItem>
                    <MenuItem value="GE">GE - Georgien</MenuItem>
                    <MenuItem value="US">US - USA</MenuItem>
                    <MenuItem value="CA">CA - Kanada</MenuItem>
                    <MenuItem value="MX">MX - Mexiko</MenuItem>
                    <MenuItem value="BR">BR - Brasilien</MenuItem>
                    <MenuItem value="AR">AR - Argentinien</MenuItem>
                    <MenuItem value="CO">CO - Kolumbien</MenuItem>
                    <MenuItem value="CL">CL - Chile</MenuItem>
                    <MenuItem value="AU">AU - Australien</MenuItem>
                    <MenuItem value="NZ">NZ - Neuseeland</MenuItem>
                    <MenuItem value="JP">JP - Japan</MenuItem>
                    <MenuItem value="KR">KR - Südkorea</MenuItem>
                    <MenuItem value="CN">CN - China</MenuItem>
                    <MenuItem value="IN">IN - Indien</MenuItem>
                    <MenuItem value="PK">PK - Pakistan</MenuItem>
                    <MenuItem value="TH">TH - Thailand</MenuItem>
                    <MenuItem value="VN">VN - Vietnam</MenuItem>
                    <MenuItem value="PH">PH - Philippinen</MenuItem>
                    <MenuItem value="ID">ID - Indonesien</MenuItem>
                    <MenuItem value="MY">MY - Malaysia</MenuItem>
                    <MenuItem value="SG">SG - Singapur</MenuItem>
                    <MenuItem value="IL">IL - Israel</MenuItem>
                    <MenuItem value="SA">SA - Saudi-Arabien</MenuItem>
                    <MenuItem value="AE">AE - Vereinigte Arabische Emirate</MenuItem>
                    <MenuItem value="IR">IR - Iran</MenuItem>
                    <MenuItem value="IQ">IQ - Irak</MenuItem>
                    <MenuItem value="SY">SY - Syrien</MenuItem>
                    <MenuItem value="LB">LB - Libanon</MenuItem>
                    <MenuItem value="AF">AF - Afghanistan</MenuItem>
                    <MenuItem value="EG">EG - Ägypten</MenuItem>
                    <MenuItem value="MA">MA - Marokko</MenuItem>
                    <MenuItem value="TN">TN - Tunesien</MenuItem>
                    <MenuItem value="DZ">DZ - Algerien</MenuItem>
                    <MenuItem value="NG">NG - Nigeria</MenuItem>
                    <MenuItem value="ZA">ZA - Südafrika</MenuItem>
                    <MenuItem value="KE">KE - Kenia</MenuItem>
                    <MenuItem value="GH">GH - Ghana</MenuItem>
                    <MenuItem value="ET">ET - Äthiopien</MenuItem>
                    <MenuItem value="other">{t('cv.personal.nationality.other')}</MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel>{t('cv.personal.permit')}</InputLabel>
                  <Select 
                    value={residencePermit} 
                    label={t('cv.personal.permit')} 
                    onChange={e => handleCvDataChange(setResidencePermit, e.target.value)}
                    MenuProps={CV_DATA_MODAL_SELECT_MENU_PROPS}
                  >
                    <MenuItem value="">{t('cv.personal.permit.select')}</MenuItem>
                    <MenuItem value="B">B - Aufenthaltsbewilligung</MenuItem>
                    <MenuItem value="C">C - Niederlassungsbewilligung</MenuItem>
                    <MenuItem value="Ci">Ci - Aufenthaltsbewilligung mit Erwerbstätigkeit</MenuItem>
                    <MenuItem value="F">F - Vorläufig aufgenommen</MenuItem>
                    <MenuItem value="G">G - Grenzgängerbewilligung</MenuItem>
                    <MenuItem value="L">L - Kurzaufenthaltsbewilligung</MenuItem>
                    <MenuItem value="N">N - Asylsuchend</MenuItem>
                    <MenuItem value="S">S - Schutzbedürftige</MenuItem>
                    <MenuItem value="Schweizer">Schweizer</MenuItem>
                    <MenuItem value="EU/EFTA">EU/EFTA</MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel>{t('cv.personal.civilstatus')}</InputLabel>
                  <Select 
                    value={civilStatus} 
                    label={t('cv.personal.civilstatus')} 
                    onChange={e => handleCvDataChange(setCivilStatus, e.target.value)}
                    MenuProps={CV_DATA_MODAL_SELECT_MENU_PROPS}
                  >
                    <MenuItem value="">{t('cv.personal.civilstatus.select')}</MenuItem>
                    <MenuItem value="ledig">{t('cv.personal.civilstatus.single')}</MenuItem>
                    <MenuItem value="verheiratet">{t('cv.personal.civilstatus.married')}</MenuItem>
                    <MenuItem value="geschieden">{t('cv.personal.civilstatus.divorced')}</MenuItem>
                    <MenuItem value="verwitwet">{t('cv.personal.civilstatus.widowed')}</MenuItem>
                    <MenuItem value="eingetragene-partnerschaft">{t('cv.personal.civilstatus.registered-partnership')}</MenuItem>
                  </Select>
                </FormControl>
                </Box>
                
                {/* Rechte Seite: Profilbild und Signatur */}
                <Box sx={{ 
                  width: '220px', 
                  display: 'flex', 
                  flexDirection: 'column', 
                  gap: 3
                }}>
                  {/* Profilbild */}
                  <Box>
                    <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600 }}>
                      {getTranslatedCvLabel('Profilbild:')}
                    </Typography>
                    {profileImage ? (
                      <Box sx={{ position: 'relative', width: '100%', aspectRatio: '1/1' }}>
                        <img 
                          src={profileImage} 
                          alt="Profilbild" 
                          onClick={() => { setOriginalProfileImage(profileImage); setShowProfileImagePreviewModal(true); }}
                          style={{ 
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                            borderRadius: '8px',
                            border: '2px solid #e0e0e0',
                            cursor: 'pointer'
                          }} 
                        />
                        <IconButton
                          size="small"
                          onClick={handleRemoveProfileImage}
                          sx={{
                            position: 'absolute',
                            top: 5,
                            right: 5,
                            backgroundColor: 'rgba(255,255,255,0.8)',
                            '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' }
                          }}
                          aria-label="Foto entfernen"
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                        {userRole === 'Admin' && (
                          <IconButton
                            size="small"
                            onClick={handleOptimizeImage}
                            disabled={optimizingImage}
                            sx={{
                              position: 'absolute',
                              top: 5,
                              left: 5,
                              backgroundColor: optimizingImage ? 'rgba(255,255,255,0.9)' : 'rgba(255,255,255,0.8)',
                              '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' },
                              transition: 'all 0.2s ease'
                            }}
                            aria-label="Bild optimieren"
                          >
                            {optimizingImage ? <CircularProgress size={16} /> : <AutoFixHighIcon fontSize="small" />}
                          </IconButton>
                        )}
                      </Box>
                    ) : (
                      <Button
                        variant="outlined"
                        component="label"
                        fullWidth
                        sx={{ 
                          aspectRatio: '1/1',
                          border: '2px dashed #1976d2', 
                          borderRadius: 2,
                          color: '#1976d2',
                          backgroundColor: '#f0f7ff',
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 1,
                          '&:hover': {
                            backgroundColor: '#e3f2fd',
                            borderColor: '#1565c0'
                          }
                        }}
                      >
                        <CloudUploadIcon sx={{ fontSize: 40 }} />
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontSize: '0.8rem' }}>
                          <span>Foto hochladen</span>
                          <span>(Kamera/Galerie)</span>
                        </Box>
                        <input
                          type="file"
                          hidden
                          accept="image/*"
                          capture="environment"
                          onChange={handleProfileImageUpload}
                        />
                      </Button>
                    )}
                    
                    {/* QR-Code Button - nur für Admin sichtbar */}
                    {userRole === 'Admin' && !profileImage && (
                      <Button
                        variant="outlined"
                        onClick={generatePhotoQrCode}
                        disabled={isGeneratingQr}
                        fullWidth
                        sx={{ 
                          height: 80, 
                          border: '2px dashed #007bff', 
                          borderRadius: 2, 
                          color: '#007bff',
                          backgroundColor: '#f0f8ff',
                          mt: 1,
                          '&:hover': {
                            backgroundColor: '#e6f3ff',
                            borderColor: '#0056b3'
                          }
                        }}
                        startIcon={isGeneratingQr ? <CircularProgress size={16} /> : <QrCodeIcon sx={{ fontSize: 24 }} />}
                      >
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', fontSize: '0.75rem' }}>
                          <span>Foto von</span>
                          <span>Smartphone laden</span>
                        </Box>
                      </Button>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
          )}
          
          {tabIndex === 1 && (
            <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column' }}>
              {/* Kurzprofil */}
              <TextField 
                label={getTranslatedCvLabel('Kurzprofil')} 
                key={`cv-short-profile-${shortProfile || ''}`}
                defaultValue={shortProfile} 
                onBlur={e => { const v = e.target.value; if (v !== shortProfile) handleCvDataChange(setShortProfile, v); }} 
                fullWidth 
                multiline 
                minRows={3}
                maxRows={6}
                sx={{ 
                  mb: 3,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 3
                  }
                }}
              />
              
              {/* Kernkompetenzen */}
              <Box 
                sx={{ 
                  border: '1px solid #e0e0e0',
                  borderRadius: 2,
                  bgcolor: 'white',
                  overflow: 'hidden',
                  mb: 3,
                  order: 3
                }}
              >
                <Box sx={{ 
                  py: 1.5, 
                  px: 2,
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white'
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <StarOutlineIcon sx={{ fontSize: 22 }} />
                      <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                        {getTranslatedCvLabel('Kernkompetenzen')}
                      </Typography>
                      <IconButton 
                        size="small"
                        onClick={() => setShowCoreCompetenciesCollapsed(!showCoreCompetenciesCollapsed)}
                        sx={{ 
                          color: 'white',
                          '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' }
                        }}
                      >
                        {showCoreCompetenciesCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                      </IconButton>
                    </Box>
                    <IconButton 
                      size="small"
                      onClick={handleAddCoreCompetency}
                      sx={{
                        bgcolor: 'rgba(255,255,255,0.2)',
                        border: '1px solid rgba(255,255,255,0.3)',
                        color: 'white',
                        width: 32,
                        height: 32,
                        borderRadius: '50%',
                        backdropFilter: 'blur(10px)',
                        '&:hover': {
                          bgcolor: 'rgba(255,255,255,0.3)',
                          borderColor: 'rgba(255,255,255,0.5)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        },
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <AddIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Box>
                
                {!showCoreCompetenciesCollapsed && (
                  <>
                    <Table size="small">
                      <TableHead>
                        <TableRow sx={{ 
                          background: 'linear-gradient(90deg, #f8fafc 0%, #e2e8f0 100%)',
                          borderBottom: '1px solid #e2e8f0'
                        }}>
                          <TableCell sx={{ 
                            fontWeight: 600, 
                            color: '#1e293b', 
                            fontSize: '0.7rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.3px',
                            py: 0.5,
                            px: 1
                          }}>
                            {getTranslatedCvLabel('Beschreibung')}
                          </TableCell>
                          <TableCell sx={{ 
                            fontWeight: 600, 
                            color: '#1e293b', 
                            fontSize: '0.7rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.3px',
                            py: 0.5,
                            px: 1
                          }}>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {coreCompetencies.length > 0 ? (
                          [...coreCompetencies].map((comp, idx) => (
                            <TableRow key={idx} sx={{ 
                              borderBottom: '1px solid #f1f5f9',
                              transition: 'all 0.2s ease',
                              '&:hover': {
                                bgcolor: '#f8fafc',
                                transform: 'scale(1.01)',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                              }
                            }}>
                              <TableCell sx={{ py: 2 }}>
                                <TextField 
                                  variant="standard" 
                                  key={`core-competency-inline-${idx}-${comp.competency || ''}`}
                                  defaultValue={comp.competency || ''} 
                                  onBlur={(e) => {
                                    const nextValue = e.target.value;
                                    const currentValue = comp.competency || '';
                                    if (nextValue !== currentValue) {
                                      handleCoreCompetencyChange(idx, nextValue);
                                    }
                                  }}
                                  fullWidth 
                                  size="small"
                                  InputProps={{ 
                                    disableUnderline: false,
                                    style: { 
                                      color: '#1e293b', 
                                      fontWeight: 600,
                                      fontSize: '0.9rem'
                                    }
                                  }}
                                  sx={{
                                    '& .MuiInput-underline:before': {
                                      borderBottom: '1px dotted #e2e8f0'
                                    },
                                    '& .MuiInput-underline:hover:before': {
                                      borderBottom: '1px dotted #cbd5e1'
                                    },
                                    '& .MuiInput-underline:after': {
                                      borderBottom: '2px solid #3b82f6'
                                    }
                                  }}
                                />
                              </TableCell>
                              <TableCell sx={{ py: 2, textAlign: 'right', pr: 2 }}>
                                <IconButton 
                                  size="small" 
                                  onClick={() => handleDeleteCoreCompetency(idx)}
                                  sx={{ 
                                    color: '#94a3b8',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                      color: '#ef4444',
                                      bgcolor: '#fef2f2',
                                      transform: 'scale(1.1)'
                                    }
                                  }}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={2} align="center" sx={{ 
                              py: 4, 
                              color: '#94a3b8', 
                              fontStyle: 'italic',
                              fontSize: '0.9rem'
                            }}>
                              Keine Kernkompetenzen hinzugefügt
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </>
                )}
              </Box>
              
              {/* Branchenerfahrungen */}
              <Box 
                sx={{ 
                  border: '1px solid #e0e0e0',
                  borderRadius: 2,
                  bgcolor: 'white',
                  overflow: 'hidden',
                  mb: 3,
                  order: 2
                }}
              >
                <Box sx={{ 
                  py: 1.5, 
                  px: 2,
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white'
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <BusinessCenterOutlinedIcon sx={{ fontSize: 22 }} />
                      <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                        {getTranslatedCvLabel('Branchenerfahrung')}
                      </Typography>
                      <IconButton 
                        size="small"
                        onClick={() => setShowIndustryExperiencesCollapsed(!showIndustryExperiencesCollapsed)}
                        sx={{ 
                          color: 'white',
                          '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' }
                        }}
                      >
                        {showIndustryExperiencesCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                      </IconButton>
                    </Box>
                    <IconButton 
                      size="small"
                      onClick={handleAddIndustryExperience}
                      sx={{
                        bgcolor: 'rgba(255,255,255,0.2)',
                        border: '1px solid rgba(255,255,255,0.3)',
                        color: 'white',
                        width: 32,
                        height: 32,
                        borderRadius: '50%',
                        backdropFilter: 'blur(10px)',
                        '&:hover': {
                          bgcolor: 'rgba(255,255,255,0.3)',
                          borderColor: 'rgba(255,255,255,0.5)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        },
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <AddIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Box>
                
                {!showIndustryExperiencesCollapsed && (
                  <>
                {industryExperiences.length > 0 ? (
                  industryExperiences.map((exp, idx) => (
                    <Box key={idx} sx={{ 
                      border: '2px solid #e2e8f0',
                      borderRadius: 3,
                      mb: 2,
                      mt: idx === 0 ? 3 : 0,
                      mx: 2,
                      overflow: 'hidden',
                      bgcolor: 'white',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
                        transform: 'translateY(-2px)',
                        borderColor: '#cbd5e1'
                      }
                    }}>
                      <Table>
                        <TableHead>
                          <TableRow sx={{ 
                            background: 'linear-gradient(90deg, #f8fafc 0%, #e2e8f0 100%)',
                            borderBottom: '2px solid #e2e8f0'
                          }}>
                            <TableCell sx={{ 
                              fontWeight: 700, 
                              color: '#1e293b', 
                              fontSize: '0.875rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px'
                            }}>
                              {getTranslatedCvLabel('Branche')}
                            </TableCell>
                            <TableCell sx={{ 
                              fontWeight: 700, 
                              color: '#1e293b', 
                              fontSize: '0.875rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px'
                            }}>
                              {getTranslatedCvLabel('Jahre')}
                            </TableCell>
                            <TableCell sx={{ 
                              fontWeight: 700, 
                              color: '#1e293b', 
                              fontSize: '0.875rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px'
                            }}>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell sx={{ py: 2 }}>
                              <TextField 
                                variant="standard" 
                                key={`industry-exp-name-${idx}-${exp.industry || ''}`}
                                defaultValue={exp.industry || ''} 
                                onBlur={(e) => {
                                  const nextValue = e.target.value;
                                  const currentValue = exp.industry || '';
                                  if (nextValue !== currentValue) handleIndustryExperienceChange(idx, 'industry', nextValue);
                                }}
                                fullWidth 
                                size="small" 
                                InputProps={{ 
                                  disableUnderline: false,
                                  style: { 
                                    color: '#1e293b', 
                                    fontWeight: 600,
                                    fontSize: '0.9rem'
                                  }
                                }}
                                sx={{
                                  '& .MuiInput-underline:before': {
                                    borderBottom: '1px dotted #e2e8f0'
                                  },
                                  '& .MuiInput-underline:hover:before': {
                                    borderBottom: '1px dotted #cbd5e1'
                                  },
                                  '& .MuiInput-underline:after': {
                                    borderBottom: '2px solid #3b82f6'
                                  }
                                }}
                              />
                            </TableCell>
                            <TableCell sx={{ py: 2 }}>
                              <TextField 
                                variant="standard" 
                                key={`industry-exp-years-${idx}-${exp.years || ''}`}
                                defaultValue={exp.years || ''} 
                                onBlur={(e) => {
                                  const nextValue = e.target.value;
                                  const currentValue = exp.years || '';
                                  if (nextValue !== currentValue) handleIndustryExperienceChange(idx, 'years', nextValue);
                                }}
                                fullWidth 
                                size="small" 
                                InputProps={{ 
                                  disableUnderline: false,
                                  style: { 
                                    color: '#64748b', 
                                    fontWeight: 500,
                                    fontSize: '0.9rem'
                                  }
                                }}
                                sx={{
                                  '& .MuiInput-underline:before': {
                                    borderBottom: '1px dotted #e2e8f0'
                                  },
                                  '& .MuiInput-underline:hover:before': {
                                    borderBottom: '1px dotted #cbd5e1'
                                  },
                                  '& .MuiInput-underline:after': {
                                    borderBottom: '2px solid #3b82f6'
                                  }
                                }}
                              />
                            </TableCell>
                            <TableCell sx={{ py: 2, textAlign: 'right', pr: 2 }}>
                              <IconButton 
                                size="small" 
                                onClick={() => handleDeleteIndustryExperience(idx)}
                                sx={{ 
                                  color: '#94a3b8',
                                  transition: 'all 0.2s ease',
                                  '&:hover': {
                                    color: '#ef4444',
                                    bgcolor: '#fef2f2',
                                    transform: 'scale(1.1)'
                                  }
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </Box>
                  ))
                ) : (
                  <Box sx={{ 
                    textAlign: 'center', 
                    py: 4,
                    color: '#94a3b8', 
                    fontStyle: 'italic',
                    fontSize: '0.9rem'
                  }}>
                    Keine Branchenerfahrungen verfügbar
                  </Box>
                )}
                  </>
                )}
              </Box>
              
              {/* Berufserfahrungen */}
              <Box 
                sx={{ 
                  border: '1px solid #e0e0e0',
                  borderRadius: 2,
                  bgcolor: 'white',
                  overflow: 'hidden',
                  mb: 3,
                  order: 1
                }}
              >
                <Box sx={{ 
                  py: 1.5, 
                  px: 2,
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white'
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <WorkOutlineIcon sx={{ fontSize: 22 }} />
                      <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                        {t('cv.work.experience')}
                      </Typography>
                      <IconButton 
                        size="small"
                        onClick={() => setShowWorkExperiencesCollapsed(!showWorkExperiencesCollapsed)}
                        sx={{ 
                          color: 'white',
                          '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' }
                        }}
                      >
                        {showWorkExperiencesCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                      </IconButton>
                    </Box>
                    <IconButton 
                      size="small"
                      onClick={() => setShowNewWorkExperienceForm(true)}
                      sx={{
                        bgcolor: 'rgba(255,255,255,0.2)',
                        border: '1px solid rgba(255,255,255,0.3)',
                        color: 'white',
                        width: 32,
                        height: 32,
                        borderRadius: '50%',
                        backdropFilter: 'blur(10px)',
                        '&:hover': {
                          bgcolor: 'rgba(255,255,255,0.3)',
                          borderColor: 'rgba(255,255,255,0.5)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        },
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <AddIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Box>
                
                {!showWorkExperiencesCollapsed && (
                  <>
                {showNewWorkExperienceForm && (
                  <Box 
                    sx={{ 
                      border: '2px solid #e2e8f0',
                      borderRadius: 3,
                      mb: 3,
                      mt: 3,
                      mx: 2,
                      overflow: 'hidden',
                      bgcolor: 'white',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                      transition: 'all 0.2s ease'
                    }}
                  >
                    <Table>
                      <TableHead>
                        <TableRow sx={{ 
                          background: 'linear-gradient(90deg, #f8fafc 0%, #e2e8f0 100%)',
                          borderBottom: '2px solid #e2e8f0'
                        }}>
                          <TableCell sx={{ 
                            fontWeight: 700, 
                            color: '#1e293b', 
                            fontSize: '0.875rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                            {getTranslatedCvLabel('Firma')}
                          </TableCell>
                          <TableCell sx={{ 
                            fontWeight: 700, 
                            color: '#1e293b', 
                            fontSize: '0.875rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                            {getTranslatedCvLabel('Position')}
                          </TableCell>
                          <TableCell sx={{ 
                            fontWeight: 700, 
                            color: '#1e293b', 
                            fontSize: '0.875rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                            {getTranslatedCvLabel('Start')}
                          </TableCell>
                          <TableCell sx={{ 
                            fontWeight: 700, 
                            color: '#1e293b', 
                            fontSize: '0.875rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                            {getTranslatedCvLabel('Ende')}
                          </TableCell>
                          <TableCell sx={{ 
                            fontWeight: 700, 
                            color: '#1e293b', 
                            fontSize: '0.875rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell sx={{ py: 2 }}>
                            <TextField 
                              variant="standard" 
                              key={`new-work-company-${newWorkExperience.company || ''}`}
                              defaultValue={newWorkExperience.company || ''} 
                              onBlur={(e) => handleNewWorkExperienceChange('company', e.target.value)}
                              fullWidth 
                              size="small" 
                              InputProps={{ 
                                disableUnderline: true,
                                style: { 
                                  color: '#1e293b', 
                                  fontWeight: 600,
                                  fontSize: '0.9rem'
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ py: 2 }}>
                            <TextField 
                              variant="standard" 
                              key={`new-work-position-${newWorkExperience.position || ''}`}
                              defaultValue={newWorkExperience.position || ''} 
                              onBlur={(e) => handleNewWorkExperienceChange('position', e.target.value)}
                              fullWidth 
                              size="small" 
                              InputProps={{ 
                                disableUnderline: true,
                                style: { 
                                  color: '#1e293b', 
                                  fontWeight: 600,
                                  fontSize: '0.9rem'
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ py: 2 }}>
                            <TextField 
                              variant="standard" 
                              key={`new-work-start-${newWorkExperience.startDate || ''}`}
                              defaultValue={newWorkExperience.startDate || ''} 
                              onBlur={(e) => handleNewWorkExperienceChange('startDate', e.target.value)}
                              fullWidth 
                              size="small" 
                              InputProps={{ 
                                disableUnderline: true,
                                style: { 
                                  color: '#64748b', 
                                  fontWeight: 500,
                                  fontSize: '0.9rem'
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ py: 2 }}>
                            <TextField 
                              variant="standard" 
                              key={`new-work-end-${newWorkExperience.endDate || ''}`}
                              defaultValue={newWorkExperience.endDate || ''} 
                              onBlur={(e) => handleNewWorkExperienceChange('endDate', e.target.value)}
                              fullWidth 
                              size="small" 
                              InputProps={{ 
                                disableUnderline: true,
                                style: { 
                                  color: '#64748b', 
                                  fontWeight: 500,
                                  fontSize: '0.9rem'
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ py: 2 }}>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                              <Button 
                                variant="contained" 
                                onClick={handleAddNewWorkExperience}
                                sx={{
                                  bgcolor: '#667eea',
                                  color: 'white',
                                  textTransform: 'none',
                                  fontWeight: 600,
                                  px: 2,
                                  py: 0.5,
                                  fontSize: '0.875rem',
                                  '&:hover': {
                                    bgcolor: '#5568d3'
                                  }
                                }}
                              >
                                Hinzufügen
                              </Button>
                              <Button 
                                variant="outlined" 
                                onClick={() => setShowNewWorkExperienceForm(false)}
                                sx={{
                                  borderColor: '#e2e8f0',
                                  color: '#64748b',
                                  textTransform: 'none',
                                  fontWeight: 600,
                                  px: 2,
                                  py: 0.5,
                                  fontSize: '0.875rem',
                                  '&:hover': {
                                    borderColor: '#cbd5e1',
                                    bgcolor: '#f8fafc'
                                  }
                                }}
                              >
                                Abbrechen
                              </Button>
                            </Box>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                    <Box sx={{ p: 2, bgcolor: '#f8fafc', borderTop: '1px solid #e2e8f0' }}>
                      <Box sx={{ display: 'flex', gap: 3, mb: 2 }}>
                        <Box sx={{ flex: 1 }}>
                          <Typography variant="subtitle2" sx={{ 
                            fontWeight: 600, 
                            color: '#1e293b', 
                            mb: 1,
                            fontSize: '0.875rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                            {getTranslatedCvLabel('Branche')}
                          </Typography>
                          <TextField 
                            variant="standard" 
                            key={`new-work-industry-${newWorkExperience.industry || ''}`}
                            defaultValue={newWorkExperience.industry || ''} 
                            onBlur={(e) => handleNewWorkExperienceChange('industry', e.target.value)}
                            fullWidth 
                            size="small"
                            placeholder={currentLanguage === 'de' ? 'z.B. Finanzwesen, IT, Gesundheit...' : 'e.g. Finance, IT, Healthcare...'}
                            InputProps={{ 
                              disableUnderline: true,
                              style: { 
                                color: '#475569', 
                                fontWeight: 500,
                                fontSize: '0.9rem'
                              }
                            }}
                          />
                        </Box>
                      </Box>
                      <Typography variant="subtitle2" sx={{ 
                        fontWeight: 600, 
                        color: '#1e293b', 
                        mb: 1,
                        fontSize: '0.875rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}>
                        {getTranslatedCvLabel('Beschreibung')}
                      </Typography>
                      <TextField 
                        variant="standard" 
                        key={`new-work-description-${newWorkExperience.description || ''}`}
                        defaultValue={newWorkExperience.description || ''} 
                        onBlur={(e) => handleNewWorkExperienceChange('description', e.target.value)}
                        fullWidth 
                        multiline
                        InputProps={{ 
                          disableUnderline: true,
                          style: { 
                            color: '#475569', 
                            fontWeight: 500,
                            fontSize: '0.9rem'
                          }
                        }}
                      />
                    </Box>
                  </Box>
                )}
                
                {draftWorkExperiences.length > 0 ? (
                  draftWorkExperiences
                    .map((exp, originalIdx) => ({ ...exp, originalIdx }))
                    .sort((a, b) => {
                      const aEndDate = a.endDate === 'Heute' ? new Date() : new Date(a.endDate || '1900-01-01');
                      const bEndDate = b.endDate === 'Heute' ? new Date() : new Date(b.endDate || '1900-01-01');
                      return bEndDate.getTime() - aEndDate.getTime();
                    })
                    .map((exp, idx) => (
                      <Box key={idx} sx={{ 
                        border: '2px solid #e2e8f0',
                        borderRadius: 3,
                        mb: 2,
                        mt: idx === 0 ? 3 : 0,
                        mx: 2,
                        overflow: 'hidden',
                        bgcolor: 'white',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
                          transform: 'translateY(-2px)',
                          borderColor: '#cbd5e1'
                        }
                      }}>
                        <Box sx={{ p: 2, bgcolor: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                          <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                            <Box sx={{ flex: 1 }}>
                              <Typography variant="caption" sx={{ 
                                fontWeight: 700, 
                                color: '#1e293b', 
                                fontSize: '0.75rem',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                display: 'block',
                                mb: 0.5
                              }}>
                                {getTranslatedCvLabel('Start')}
                              </Typography>
                              <TextField 
                                variant="standard" 
                              key={`work-start-${exp.originalIdx}-${exp.startDate || ''}`}
                              defaultValue={exp.startDate || ''} 
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = exp.startDate || '';
                                if (nextValue !== currentValue) {
                                  handleCvWorkExperienceChange(exp.originalIdx, 'startDate', nextValue);
                                }
                              }}
                                fullWidth 
                                size="small" 
                                InputProps={{ 
                                  disableUnderline: false,
                                  style: { 
                                    color: '#64748b', 
                                    fontWeight: 500,
                                    fontSize: '0.9rem'
                                  }
                                }}
                                sx={{
                                  '& .MuiInput-underline:before': {
                                    borderBottom: '1px dotted #e2e8f0'
                                  },
                                  '& .MuiInput-underline:hover:before': {
                                    borderBottom: '1px dotted #cbd5e1'
                                  },
                                  '& .MuiInput-underline:after': {
                                    borderBottom: '2px solid #3b82f6'
                                  }
                                }}
                              />
                            </Box>
                            <Box sx={{ flex: 1 }}>
                              <Typography variant="caption" sx={{ 
                                fontWeight: 700, 
                                color: '#1e293b', 
                                fontSize: '0.75rem',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                display: 'block',
                                mb: 0.5
                              }}>
                                {getTranslatedCvLabel('Ende')}
                              </Typography>
                              <TextField 
                                variant="standard" 
                              key={`work-end-${exp.originalIdx}-${exp.endDate || ''}`}
                              defaultValue={exp.endDate || ''} 
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = exp.endDate || '';
                                if (nextValue !== currentValue) {
                                  handleCvWorkExperienceChange(exp.originalIdx, 'endDate', nextValue);
                                }
                              }}
                                fullWidth 
                                size="small" 
                                InputProps={{ 
                                  disableUnderline: false,
                                  style: { 
                                    color: '#64748b', 
                                    fontWeight: 500,
                                    fontSize: '0.9rem'
                                  }
                                }}
                                sx={{
                                  '& .MuiInput-underline:before': {
                                    borderBottom: '1px dotted #e2e8f0'
                                  },
                                  '& .MuiInput-underline:hover:before': {
                                    borderBottom: '1px dotted #cbd5e1'
                                  },
                                  '& .MuiInput-underline:after': {
                                    borderBottom: '2px solid #3b82f6'
                                  }
                                }}
                              />
                            </Box>
                          </Box>
                          <Box sx={{ display: 'flex', gap: 2 }}>
                            <Box sx={{ flex: 1 }}>
                              <Typography variant="caption" sx={{ 
                                fontWeight: 700, 
                                color: '#1e293b', 
                                fontSize: '0.75rem',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                display: 'block',
                                mb: 0.5
                              }}>
                                {getTranslatedCvLabel('Firma')}
                              </Typography>
                              <TextField 
                                variant="standard" 
                              key={`work-company-${exp.originalIdx}-${exp.company || ''}`}
                              defaultValue={exp.company || ''} 
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = exp.company || '';
                                if (nextValue !== currentValue) {
                                  handleCvWorkExperienceChange(exp.originalIdx, 'company', nextValue);
                                }
                              }}
                                fullWidth 
                                size="small" 
                                InputProps={{ 
                                  disableUnderline: false,
                                  style: { 
                                    color: '#1e293b', 
                                    fontWeight: 600,
                                    fontSize: '0.9rem'
                                  }
                                }}
                                sx={{
                                  '& .MuiInput-underline:before': {
                                    borderBottom: '1px dotted #e2e8f0'
                                  },
                                  '& .MuiInput-underline:hover:before': {
                                    borderBottom: '1px dotted #cbd5e1'
                                  },
                                  '& .MuiInput-underline:after': {
                                    borderBottom: '2px solid #3b82f6'
                                  }
                                }}
                              />
                            </Box>
                            <Box sx={{ flex: 1 }}>
                              <Typography variant="caption" sx={{ 
                                fontWeight: 700, 
                                color: '#1e293b', 
                                fontSize: '0.75rem',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                display: 'block',
                                mb: 0.5
                              }}>
                                {getTranslatedCvLabel('Position')}
                              </Typography>
                              <TextField 
                                variant="standard" 
                              key={`work-position-${exp.originalIdx}-${exp.position || ''}`}
                              defaultValue={exp.position || ''} 
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = exp.position || '';
                                if (nextValue !== currentValue) {
                                  handleCvWorkExperienceChange(exp.originalIdx, 'position', nextValue);
                                }
                              }}
                                fullWidth 
                                size="small"
                                multiline
                                InputProps={{ 
                                  disableUnderline: false,
                                  style: { 
                                    color: '#1e293b', 
                                    fontWeight: 600,
                                    fontSize: '0.9rem'
                                  }
                                }}
                                sx={{
                                  '& .MuiInput-underline:before': {
                                    borderBottom: '1px dotted #e2e8f0'
                                  },
                                  '& .MuiInput-underline:hover:before': {
                                    borderBottom: '1px dotted #cbd5e1'
                                  },
                                  '& .MuiInput-underline:after': {
                                    borderBottom: '2px solid #3b82f6'
                                  }
                                }}
                              />
                            </Box>
                          </Box>
                          <Box sx={{ mt: 2 }}>
                            <Typography variant="caption" sx={{ 
                              fontWeight: 700, 
                              color: '#1e293b', 
                              fontSize: '0.75rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block',
                              mb: 0.5
                            }}>
                              {getTranslatedCvLabel('Branche')}
                            </Typography>
                            <TextField 
                              variant="standard" 
                              key={`work-industry-${exp.originalIdx}-${exp.industry || ''}`}
                              defaultValue={exp.industry || ''} 
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = exp.industry || '';
                                if (nextValue !== currentValue) {
                                  handleCvWorkExperienceChange(exp.originalIdx, 'industry', nextValue);
                                }
                              }}
                              fullWidth 
                              size="small"
                              InputProps={{ 
                                disableUnderline: false,
                                style: { 
                                  color: '#475569', 
                                  fontWeight: 500,
                                  fontSize: '0.9rem'
                                }
                              }}
                              sx={{
                                '& .MuiInput-underline:before': {
                                  borderBottom: '1px dotted #e2e8f0'
                                },
                                '& .MuiInput-underline:hover:before': {
                                  borderBottom: '1px dotted #cbd5e1'
                                },
                                '& .MuiInput-underline:after': {
                                  borderBottom: '2px solid #3b82f6'
                                }
                              }}
                            />
                          </Box>
                          <Box>
                            <Typography variant="caption" sx={{ 
                              fontWeight: 700, 
                              color: '#1e293b', 
                              fontSize: '0.75rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block',
                              mb: 0.5,
                              mt: 2
                            }}>
                              {getTranslatedCvLabel('Beschreibung')}
                            </Typography>
                            <TextField 
                              key={`work-desc-${exp.originalIdx}-${exp.description || ''}`}
                              variant="standard" 
                              defaultValue={exp.description || ''} 
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = exp.description || '';
                                if (nextValue !== currentValue) {
                                  handleCvWorkExperienceChange(exp.originalIdx, 'description', nextValue);
                                }
                              }}
                              fullWidth 
                              multiline
                              InputProps={{ 
                                disableUnderline: false,
                                style: { 
                                  color: '#475569', 
                                  fontWeight: 500,
                                  fontSize: '0.9rem'
                                }
                              }}
                              sx={{
                                '& .MuiInput-underline:before': {
                                  borderBottom: '1px dotted #e2e8f0'
                                },
                                '& .MuiInput-underline:hover:before': {
                                  borderBottom: '1px dotted #cbd5e1'
                                },
                                '& .MuiInput-underline:after': {
                                  borderBottom: '2px solid #3b82f6'
                                }
                              }}
                            />
                          </Box>
                        </Box>
                        <Box sx={{ p: 2, textAlign: 'right', borderTop: '1px solid #e2e8f0' }}>
                          <IconButton 
                            size="small" 
                            onClick={() => handleDeleteWorkExperience(exp.originalIdx)}
                            sx={{ 
                              color: '#94a3b8',
                              transition: 'all 0.2s ease',
                              '&:hover': {
                                color: '#ef4444',
                                bgcolor: '#fef2f2',
                                transform: 'scale(1.1)'
                              }
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </Box>
                    ))
                ) : (
                  <Box sx={{ 
                    textAlign: 'center', 
                    py: 4,
                    color: '#94a3b8', 
                    fontStyle: 'italic',
                    fontSize: '0.9rem'
                  }}>
                    Keine Berufserfahrung hinzugefügt
                  </Box>
                )}
                  </>
                )}
              </Box>
            </Box>
          )}
          
          {tabIndex === 2 && (
            <Box sx={{ mt: 3 }}>
              
              {/* Ausbildung */}
              <Box 
                sx={{ 
                  border: '1px solid #e0e0e0',
                  borderRadius: 2,
                  bgcolor: 'white',
                  overflow: 'hidden',
                  mb: 3
                }}
              >
                <Box sx={{ 
                  py: 1.5, 
                  px: 2,
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white'
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <SchoolOutlinedIcon sx={{ fontSize: 22 }} />
                      <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                        {getTranslatedCvLabel('Ausbildung')}
                      </Typography>
                      <IconButton 
                        size="small"
                        onClick={() => setShowEducationCollapsed(!showEducationCollapsed)}
                        sx={{ 
                          color: 'white',
                          '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' }
                        }}
                      >
                        {showEducationCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                      </IconButton>
                    </Box>
                    <IconButton 
                      size="small"
                      onClick={handleAddEducation}
                      sx={{
                        bgcolor: 'rgba(255,255,255,0.2)',
                        border: '1px solid rgba(255,255,255,0.3)',
                        color: 'white',
                        width: 32,
                        height: 32,
                        borderRadius: '50%',
                        backdropFilter: 'blur(10px)',
                        '&:hover': {
                          bgcolor: 'rgba(255,255,255,0.3)',
                          borderColor: 'rgba(255,255,255,0.5)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        },
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <AddIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Box>
                
                {!showEducationCollapsed && (
                  <>
                {draftEducations.length > 0 ? (
                  draftEducations.map((edu, idx) => (
                    <Box key={idx} sx={{ 
                      border: '2px solid #e2e8f0',
                      borderRadius: 3,
                      mb: 2,
                      mt: idx === 0 ? 3 : 0,
                      mx: 2,
                      overflow: 'hidden',
                      bgcolor: 'white',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
                        transform: 'translateY(-2px)',
                        borderColor: '#cbd5e1'
                      }
                    }}>
                      <Box sx={{ p: 2, bgcolor: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="caption" sx={{ 
                              fontWeight: 700, 
                              color: '#1e293b', 
                              fontSize: '0.75rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block',
                              mb: 0.5
                            }}>
                              {getTranslatedCvLabel('Start')}
                            </Typography>
                            <TextField 
                              variant="standard" 
                              key={`edu-start-${idx}-${edu.startDate || ''}`}
                              defaultValue={edu.startDate || ''} 
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = edu.startDate || '';
                                if (nextValue !== currentValue) {
                                  handleEducationChange(idx, 'startDate', nextValue);
                                }
                              }}
                              fullWidth 
                              size="small" 
                              InputProps={{ 
                                disableUnderline: false,
                                style: { 
                                  color: '#64748b', 
                                  fontWeight: 500,
                                  fontSize: '0.9rem'
                                }
                              }}
                              sx={{
                                '& .MuiInput-underline:before': {
                                  borderBottom: '1px dotted #e2e8f0'
                                },
                                '& .MuiInput-underline:hover:before': {
                                  borderBottom: '1px dotted #cbd5e1'
                                },
                                '& .MuiInput-underline:after': {
                                  borderBottom: '2px solid #3b82f6'
                                }
                              }}
                            />
                          </Box>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="caption" sx={{ 
                              fontWeight: 700, 
                              color: '#1e293b', 
                              fontSize: '0.75rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block',
                              mb: 0.5
                            }}>
                              {getTranslatedCvLabel('Ende')}
                            </Typography>
                            <TextField 
                              variant="standard" 
                              key={`edu-end-${idx}-${edu.endDate || ''}`}
                              defaultValue={edu.endDate || ''} 
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = edu.endDate || '';
                                if (nextValue !== currentValue) {
                                  handleEducationChange(idx, 'endDate', nextValue);
                                }
                              }}
                              fullWidth 
                              size="small" 
                              InputProps={{ 
                                disableUnderline: false,
                                style: { 
                                  color: '#64748b', 
                                  fontWeight: 500,
                                  fontSize: '0.9rem'
                                }
                              }}
                              sx={{
                                '& .MuiInput-underline:before': {
                                  borderBottom: '1px dotted #e2e8f0'
                                },
                                '& .MuiInput-underline:hover:before': {
                                  borderBottom: '1px dotted #cbd5e1'
                                },
                                '& .MuiInput-underline:after': {
                                  borderBottom: '2px solid #3b82f6'
                                }
                              }}
                            />
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="caption" sx={{ 
                              fontWeight: 700, 
                              color: '#1e293b', 
                              fontSize: '0.75rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block',
                              mb: 0.5
                            }}>
                              {getTranslatedCvLabel('Abschluss')}
                            </Typography>
                            <TextField 
                              variant="standard" 
                              key={`edu-degree-${idx}-${edu.degree || ''}`}
                              defaultValue={edu.degree || ''} 
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = edu.degree || '';
                                if (nextValue !== currentValue) {
                                  handleEducationChange(idx, 'degree', nextValue);
                                }
                              }}
                              fullWidth 
                              size="small" 
                              InputProps={{ 
                                disableUnderline: false,
                                style: { 
                                  color: '#1e293b', 
                                  fontWeight: 600,
                                  fontSize: '0.9rem'
                                }
                              }}
                              sx={{
                                '& .MuiInput-underline:before': {
                                  borderBottom: '1px dotted #e2e8f0'
                                },
                                '& .MuiInput-underline:hover:before': {
                                  borderBottom: '1px dotted #cbd5e1'
                                },
                                '& .MuiInput-underline:after': {
                                  borderBottom: '2px solid #3b82f6'
                                }
                              }}
                            />
                          </Box>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="caption" sx={{ 
                              fontWeight: 700, 
                              color: '#1e293b', 
                              fontSize: '0.75rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block',
                              mb: 0.5
                            }}>
                              {getTranslatedCvLabel('Institution')}
                            </Typography>
                            <TextField 
                              variant="standard" 
                              key={`edu-institution-${idx}-${edu.institution || ''}`}
                              defaultValue={edu.institution || ''} 
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = edu.institution || '';
                                if (nextValue !== currentValue) {
                                  handleEducationChange(idx, 'institution', nextValue);
                                }
                              }}
                              fullWidth 
                              size="small" 
                              InputProps={{ 
                                disableUnderline: false,
                                style: { 
                                  color: '#475569', 
                                  fontWeight: 500,
                                  fontSize: '0.9rem'
                                }
                              }}
                              sx={{
                                '& .MuiInput-underline:before': {
                                  borderBottom: '1px dotted #e2e8f0'
                                },
                                '& .MuiInput-underline:hover:before': {
                                  borderBottom: '1px dotted #cbd5e1'
                                },
                                '& .MuiInput-underline:after': {
                                  borderBottom: '2px solid #3b82f6'
                                }
                              }}
                            />
                          </Box>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="caption" sx={{ 
                              fontWeight: 700, 
                              color: '#1e293b', 
                              fontSize: '0.75rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block',
                              mb: 0.5
                            }}>
                              {getTranslatedCvLabel('Beschreibung')} (optional)
                            </Typography>
                            <TextField 
                              variant="standard" 
                              key={`edu-description-${idx}-${edu.description || ''}`}
                              defaultValue={edu.description || ''} 
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = edu.description || '';
                                if (nextValue !== currentValue) {
                                  handleEducationChange(idx, 'description', nextValue);
                                }
                              }}
                              fullWidth 
                              size="small" 
                              InputProps={{ 
                                disableUnderline: false,
                                style: { 
                                  color: '#475569', 
                                  fontWeight: 500,
                                  fontSize: '0.9rem'
                                }
                              }}
                              sx={{
                                '& .MuiInput-underline:before': {
                                  borderBottom: '1px dotted #e2e8f0'
                                },
                                '& .MuiInput-underline:hover:before': {
                                  borderBottom: '1px dotted #cbd5e1'
                                },
                                '& .MuiInput-underline:after': {
                                  borderBottom: '2px solid #3b82f6'
                                }
                              }}
                            />
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{ p: 2, textAlign: 'right', borderTop: '1px solid #e2e8f0' }}>
                        <IconButton 
                          size="small" 
                          onClick={() => handleDeleteEducation(idx)}
                          sx={{ 
                            color: '#94a3b8',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                              color: '#ef4444',
                              bgcolor: '#fef2f2',
                              transform: 'scale(1.1)'
                            }
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Box>
                    </Box>
                  ))
                ) : (
                  <Box sx={{ 
                    textAlign: 'center', 
                    py: 4,
                    color: '#94a3b8', 
                    fontStyle: 'italic',
                    fontSize: '0.9rem'
                  }}>
                    Keine Ausbildung hinzugefügt
                  </Box>
                )}
                  </>
                )}
              </Box>

              {/* Zertifikate */}
              <Box 
                sx={{ 
                  border: '1px solid #e0e0e0',
                  borderRadius: 2,
                  bgcolor: 'white',
                  overflow: 'hidden',
                  mb: 3
                }}
              >
                <Box sx={{ 
                  py: 1.5, 
                  px: 2,
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white'
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <WorkspacePremiumOutlinedIcon sx={{ fontSize: 22 }} />
                      <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                        {getTranslatedCvLabel('Zertifikate')}
                      </Typography>
                      <IconButton 
                        size="small"
                        onClick={() => setShowCertificationsCollapsed(!showCertificationsCollapsed)}
                        sx={{ 
                          color: 'white',
                          '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' }
                        }}
                      >
                        {showCertificationsCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                      </IconButton>
                    </Box>
                    <IconButton 
                      size="small"
                      onClick={handleAddCertification}
                      sx={{
                        bgcolor: 'rgba(255,255,255,0.2)',
                        border: '1px solid rgba(255,255,255,0.3)',
                        color: 'white',
                        width: 32,
                        height: 32,
                        borderRadius: '50%',
                        backdropFilter: 'blur(10px)',
                        '&:hover': {
                          bgcolor: 'rgba(255,255,255,0.3)',
                          borderColor: 'rgba(255,255,255,0.5)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        },
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <AddIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Box>
                {!showCertificationsCollapsed && (
                  <>
                    {draftCertifications.length > 0 ? (
                      draftCertifications.map((cert, idx) => (
                        <Box key={idx} sx={{ 
                          border: '2px solid #e2e8f0',
                          borderRadius: 3,
                          mb: 2,
                          mt: idx === 0 ? 3 : 0,
                          mx: 2,
                          overflow: 'hidden',
                          bgcolor: 'white',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
                            transform: 'translateY(-2px)',
                            borderColor: '#cbd5e1'
                          }
                        }}>
                          <Box sx={{ p: 2, bgcolor: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                            <Box sx={{ mb: 2 }}>
                              <Typography variant="caption" sx={{ 
                                fontWeight: 700, 
                                color: '#1e293b', 
                                fontSize: '0.75rem',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                display: 'block',
                                mb: 0.5
                              }}>
                                {getTranslatedCvLabel('Datum')}
                              </Typography>
                              <TextField
                                variant="standard"
                                key={`cert-date-${idx}-${cert.date || ''}`}
                                defaultValue={cert.date || ''}
                                onBlur={(e) => {
                                  const nextValue = e.target.value;
                                  const currentValue = cert.date || '';
                                  if (nextValue !== currentValue) {
                                    handleCertificationChange(idx, 'date', nextValue);
                                  }
                                }}
                                fullWidth
                                size="small"
                                InputProps={{
                                  disableUnderline: false,
                                  style: {
                                    color: '#475569',
                                    fontWeight: 500,
                                    fontSize: '0.9rem'
                                  }
                                }}
                                sx={{
                                  '& .MuiInput-underline:before': {
                                    borderBottom: '1px dotted #e2e8f0'
                                  },
                                  '& .MuiInput-underline:hover:before': {
                                    borderBottom: '1px dotted #cbd5e1'
                                  },
                                  '& .MuiInput-underline:after': {
                                    borderBottom: '2px solid #3b82f6'
                                  }
                                }}
                              />
                            </Box>
                            <Box sx={{ display: 'flex', gap: 2 }}>
                              <Box sx={{ flex: 1 }}>
                                <Typography variant="caption" sx={{ 
                                  fontWeight: 700, 
                                  color: '#1e293b', 
                                  fontSize: '0.75rem',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.5px',
                                  display: 'block',
                                  mb: 0.5
                                }}>
                                  {getTranslatedCvLabel('Name')}
                                </Typography>
                                <TextField 
                                  variant="standard" 
                                  key={`cert-name-${idx}-${cert.name || ''}`}
                                  defaultValue={cert.name || ''} 
                                  onBlur={(e) => {
                                    const nextValue = e.target.value;
                                    const currentValue = cert.name || '';
                                    if (nextValue !== currentValue) {
                                      handleCertificationChange(idx, 'name', nextValue);
                                    }
                                  }}
                                  fullWidth
                                  size="small"
                                  InputProps={{
                                    disableUnderline: false,
                                    style: {
                                      color: '#1e293b',
                                      fontWeight: 600,
                                      fontSize: '0.9rem'
                                    }
                                  }}
                                  sx={{
                                    '& .MuiInput-underline:before': {
                                      borderBottom: '1px dotted #e2e8f0'
                                    },
                                    '& .MuiInput-underline:hover:before': {
                                      borderBottom: '1px dotted #cbd5e1'
                                    },
                                    '& .MuiInput-underline:after': {
                                      borderBottom: '2px solid #3b82f6'
                                    }
                                  }}
                                />
                              </Box>
                            </Box>
                            <Box sx={{ mb: 2 }}>
                              <Typography variant="caption" sx={{ 
                                fontWeight: 700, 
                                color: '#1e293b', 
                                fontSize: '0.75rem',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                display: 'block',
                                mb: 0.5
                              }}>
                                {getTranslatedCvLabel('Beschreibung')}
                              </Typography>
                              <TextField
                                variant="standard"
                                key={`cert-description-${idx}-${cert.description || ''}`}
                                defaultValue={cert.description || ''}
                                onBlur={(e) => {
                                  const nextValue = e.target.value;
                                  const currentValue = cert.description || '';
                                  if (nextValue !== currentValue) {
                                    handleCertificationChange(idx, 'description', nextValue);
                                  }
                                }}
                                fullWidth
                                size="small"
                                InputProps={{
                                  disableUnderline: false,
                                  style: {
                                    color: '#475569',
                                    fontWeight: 500,
                                    fontSize: '0.9rem'
                                  }
                                }}
                                sx={{
                                  '& .MuiInput-underline:before': {
                                    borderBottom: '1px dotted #e2e8f0'
                                  },
                                  '& .MuiInput-underline:hover:before': {
                                    borderBottom: '1px dotted #cbd5e1'
                                  },
                                  '& .MuiInput-underline:after': {
                                    borderBottom: '2px solid #3b82f6'
                                  }
                                }}
                              />
                            </Box>
                            <Box sx={{ display: 'flex', gap: 2 }}>
                              <Box sx={{ flex: 1 }}>
                                <Typography variant="caption" sx={{ 
                                  fontWeight: 700, 
                                  color: '#1e293b', 
                                  fontSize: '0.75rem',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.5px',
                                  display: 'block',
                                  mb: 0.5
                                }}>
                                  {getTranslatedCvLabel('Aussteller')}
                                </Typography>
                                <TextField 
                                  variant="standard" 
                                  key={`cert-issuer-${idx}-${cert.issuer || ''}`}
                                  defaultValue={cert.issuer || ''} 
                                  onBlur={(e) => {
                                    const nextValue = e.target.value;
                                    const currentValue = cert.issuer || '';
                                    if (nextValue !== currentValue) {
                                      handleCertificationChange(idx, 'issuer', nextValue);
                                    }
                                  }}
                                  fullWidth 
                                  size="small" 
                                  InputProps={{ 
                                    disableUnderline: false,
                                    style: { 
                                      color: '#64748b', 
                                      fontWeight: 500,
                                      fontSize: '0.9rem'
                                    }
                                  }}
                                  sx={{
                                    '& .MuiInput-underline:before': {
                                      borderBottom: '1px dotted #e2e8f0'
                                    },
                                    '& .MuiInput-underline:hover:before': {
                                      borderBottom: '1px dotted #cbd5e1'
                                    },
                                    '& .MuiInput-underline:after': {
                                      borderBottom: '2px solid #3b82f6'
                                    }
                                  }}
                                />
                              </Box>
                            </Box>
                          </Box>
                          <Box sx={{ p: 2, textAlign: 'right', borderTop: '1px solid #e2e8f0' }}>
                            <IconButton 
                              size="small" 
                              onClick={() => handleDeleteCertification(idx)}
                              sx={{ 
                                color: '#94a3b8',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                  color: '#ef4444',
                                  bgcolor: '#fef2f2',
                                  transform: 'scale(1.1)'
                                }
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Box>
                        </Box>
                      ))
                    ) : (
                      <Box sx={{ 
                        textAlign: 'center', 
                        py: 4,
                        color: '#64748b', 
                        fontStyle: 'italic',
                        fontSize: '0.9rem'
                      }}>
                        Keine Zertifikate hinzugefügt
                      </Box>
                    )}
                  </>
                )}
              </Box>

              {/* Sprachen */}
              <Box 
                sx={{ 
                  border: '1px solid #e0e0e0',
                  borderRadius: 2,
                  bgcolor: 'white',
                  overflow: 'hidden',
                  mb: 3
                }}
              >
                <Box sx={{ 
                  py: 1.5, 
                  px: 2,
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white'
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <LanguageOutlinedIcon sx={{ fontSize: 22 }} />
                      <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                        {getTranslatedCvLabel('Sprachkenntnisse')}
                      </Typography>
                      <IconButton 
                        size="small"
                        onClick={() => setShowLanguagesCollapsed(!showLanguagesCollapsed)}
                        sx={{ 
                          color: 'white',
                          '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' }
                        }}
                      >
                        {showLanguagesCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                      </IconButton>
                    </Box>
                    <IconButton 
                      size="small"
                      onClick={handleAddLanguage}
                      sx={{
                        bgcolor: 'rgba(255,255,255,0.2)',
                        border: '1px solid rgba(255,255,255,0.3)',
                        color: 'white',
                        width: 32,
                        height: 32,
                        borderRadius: '50%',
                        backdropFilter: 'blur(10px)',
                        '&:hover': {
                          bgcolor: 'rgba(255,255,255,0.3)',
                          borderColor: 'rgba(255,255,255,0.5)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        },
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <AddIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Box>
                {!showLanguagesCollapsed && (
                  <>
                    <Table size="small">
                      <TableHead>
                        <TableRow sx={{ 
                          background: 'linear-gradient(90deg, #f8fafc 0%, #e2e8f0 100%)',
                          borderBottom: '1px solid #e2e8f0'
                        }}>
                          <TableCell sx={{ 
                            fontWeight: 600, 
                            color: '#1e293b', 
                            fontSize: '0.7rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.3px',
                            py: 0.5,
                            px: 1
                          }}>
                            {getTranslatedCvLabel('Sprache')}
                          </TableCell>
                      <TableCell sx={{ 
                        fontWeight: 600, 
                        color: '#1e293b', 
                        fontSize: '0.7rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.3px',
                        py: 0.5,
                        px: 1
                      }}>
                        {getTranslatedCvLabel('Niveau')}
                      </TableCell>
                      <TableCell sx={{ 
                        fontWeight: 600, 
                        color: '#1e293b', 
                        fontSize: '0.7rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.3px',
                        py: 0.5,
                        px: 1
                      }}>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                          {languages.length > 0 ? (
        languages.map((lang, idx) => (
                        <TableRow key={idx} sx={{ 
                          borderBottom: '1px solid #f1f5f9',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            bgcolor: '#f8fafc',
                            transform: 'scale(1.01)',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                          }
                        }}>
                          <TableCell sx={{ py: 2 }}>
                            <TextField 
                              variant="standard" 
                              key={`lang-name-${idx}-${lang.language || ''}`}
                              defaultValue={lang.language || ''} 
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = lang.language || '';
                                if (nextValue !== currentValue) {
                                  handleLanguageTableChange(idx, 'language', nextValue);
                                }
                              }}
                              fullWidth 
                              size="small" 
                              InputProps={{ 
                                disableUnderline: false,
                                style: { 
                                  color: '#1e293b', 
                                  fontWeight: 600,
                                  fontSize: '0.9rem'
                                }
                              }}
                              sx={{
                                '& .MuiInput-underline:before': {
                                  borderBottom: '1px dotted #e2e8f0'
                                },
                                '& .MuiInput-underline:hover:before': {
                                  borderBottom: '1px dotted #cbd5e1'
                                },
                                '& .MuiInput-underline:after': {
                                  borderBottom: '2px solid #3b82f6'
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ py: 2 }}>
                            <Select 
                              variant="standard" 
                              value={lang.level || ''} 
                              onChange={(e) => handleLanguageTableChange(idx, 'level', e.target.value)}
                              fullWidth 
                              size="small"
                              displayEmpty
                              MenuProps={CV_DATA_MODAL_SELECT_MENU_PROPS}
                              sx={{
                                color: '#64748b', 
                                fontWeight: 500,
                                fontSize: '0.9rem',
                                '&:before': {
                                  borderBottom: '1px dotted #e2e8f0'
                                },
                                '&:hover:not(.Mui-disabled):before': {
                                  borderBottom: '1px dotted #cbd5e1'
                                },
                                '&:after': {
                                  borderBottom: '2px solid #3b82f6'
                                }
                              }}
                            >
                              <MenuItem value="">{t('cv.languages.level.select')}</MenuItem>
                              <MenuItem value="A1">{t('cv.languages.level.A1')}</MenuItem>
                              <MenuItem value="A2">{t('cv.languages.level.A2')}</MenuItem>
                              <MenuItem value="B1">{t('cv.languages.level.B1')}</MenuItem>
                              <MenuItem value="B2">{t('cv.languages.level.B2')}</MenuItem>
                              <MenuItem value="C1">{t('cv.languages.level.C1')}</MenuItem>
                              <MenuItem value="C2">{t('cv.languages.level.C2')}</MenuItem>
                              <MenuItem value="native">{t('cv.languages.level.native')}</MenuItem>
                            </Select>
                          </TableCell>
                          <TableCell sx={{ py: 2, textAlign: 'right' }}>
                            <IconButton 
                              onClick={() => handleDeleteLanguage(idx)} 
                              size="small"
                              sx={{ 
                                color: '#94a3b8',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                  color: '#ef4444',
                                  bgcolor: '#fef2f2',
                                  transform: 'scale(1.1)'
                                }
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} sx={{ textAlign: 'center', py: 4, color: '#64748b', fontStyle: 'italic' }}>
                          Keine Sprachen hinzugefügt
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                  </>
                )}
              </Box>

              {/* IT Skills */}
              <Box 
                sx={{ 
                  border: '1px solid #e0e0e0',
                  borderRadius: 2,
                  bgcolor: 'white',
                  overflow: 'hidden',
                  mb: 3
                }}
              >
                <Box sx={{ 
                  py: 1.5, 
                  px: 2,
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white'
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <ComputerOutlinedIcon sx={{ fontSize: 22 }} />
                      <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                        {getTranslatedCvLabel('IT-Kenntnisse')}
                      </Typography>
                      <IconButton 
                        size="small"
                        onClick={() => setShowItSkillsCollapsed(!showItSkillsCollapsed)}
                        sx={{ 
                          color: 'white',
                          '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' }
                        }}
                      >
                        {showItSkillsCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                      </IconButton>
                    </Box>
                    <IconButton 
                      size="small"
                      onClick={handleAddItSkill}
                      sx={{
                        bgcolor: 'rgba(255,255,255,0.2)',
                        border: '1px solid rgba(255,255,255,0.3)',
                        color: 'white',
                        width: 32,
                        height: 32,
                        borderRadius: '50%',
                        backdropFilter: 'blur(10px)',
                        '&:hover': {
                          bgcolor: 'rgba(255,255,255,0.3)',
                          borderColor: 'rgba(255,255,255,0.5)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        },
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <AddIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Box>
                {!showItSkillsCollapsed && (
                  <>
                    <Table size="small">
                      <TableHead>
                        <TableRow sx={{ 
                          background: 'linear-gradient(90deg, #f8fafc 0%, #e2e8f0 100%)',
                          borderBottom: '1px solid #e2e8f0'
                        }}>
                          <TableCell sx={{ 
                            fontWeight: 600, 
                            color: '#1e293b', 
                            fontSize: '0.7rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.3px',
                            py: 0.5,
                            px: 1
                          }}>
                            {getTranslatedCvLabel('Skill')}
                          </TableCell>
                      <TableCell sx={{ 
                        fontWeight: 600, 
                        color: '#1e293b', 
                        fontSize: '0.7rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.3px',
                        py: 0.5,
                        px: 1
                      }}>
                        {getTranslatedCvLabel('Niveau')}
                      </TableCell>
                      <TableCell sx={{ 
                        fontWeight: 600, 
                        color: '#1e293b', 
                        fontSize: '0.7rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.3px',
                        py: 0.5,
                        px: 1
                      }}>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                          {itSkills.length > 0 ? (
        itSkills.map((skill, idx) => (
                        <TableRow key={idx} sx={{ 
                          borderBottom: '1px solid #f1f5f9',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            bgcolor: '#f8fafc',
                            transform: 'scale(1.01)',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                          }
                        }}>
                          <TableCell sx={{ py: 2 }}>
                            <TextField 
                              variant="standard" 
                              key={`it-skill-${idx}-${skill.skill || ''}`}
                              defaultValue={skill.skill || ''} 
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = skill.skill || '';
                                if (nextValue !== currentValue) {
                                  handleItSkillsChange(idx, 'skill', nextValue);
                                }
                              }}
                              fullWidth 
                              size="small" 
                              InputProps={{ 
                                disableUnderline: false,
                                style: { 
                                  color: '#1e293b', 
                                  fontWeight: 600,
                                  fontSize: '0.9rem'
                                }
                              }}
                              sx={{
                                '& .MuiInput-underline:before': {
                                  borderBottom: '1px dotted #e2e8f0'
                                },
                                '& .MuiInput-underline:hover:before': {
                                  borderBottom: '1px dotted #cbd5e1'
                                },
                                '& .MuiInput-underline:after': {
                                  borderBottom: '2px solid #3b82f6'
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ py: 2 }}>
                            <Select 
                              variant="standard" 
                              value={skill.level || ''} 
                              onChange={(e) => handleItSkillsChange(idx, 'level', e.target.value)}
                              fullWidth 
                              size="small"
                              displayEmpty
                              MenuProps={CV_DATA_MODAL_SELECT_MENU_PROPS}
                              sx={{
                                color: '#64748b', 
                                fontWeight: 500,
                                fontSize: '0.9rem',
                                '&:before': {
                                  borderBottom: '1px dotted #e2e8f0'
                                },
                                '&:hover:not(.Mui-disabled):before': {
                                  borderBottom: '1px dotted #cbd5e1'
                                },
                                '&:after': {
                                  borderBottom: '2px solid #3b82f6'
                                }
                              }}
                            >
                              <MenuItem value="">{t('cv.it.skills.level.select')}</MenuItem>
                              <MenuItem value="beginner">{t('cv.it.skills.level.beginner')}</MenuItem>
                              <MenuItem value="intermediate">{t('cv.it.skills.level.intermediate')}</MenuItem>
                              <MenuItem value="professional">{t('cv.it.skills.level.professional')}</MenuItem>
                              <MenuItem value="expert">{t('cv.it.skills.level.expert')}</MenuItem>
                            </Select>
                          </TableCell>
                          <TableCell sx={{ py: 2, textAlign: 'right', pr: 2 }}>
                            <IconButton 
                              size="small" 
                              onClick={() => handleDeleteItSkill(idx)}
                              sx={{ 
                                color: '#94a3b8',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                  color: '#ef4444',
                                  bgcolor: '#fef2f2',
                                  transform: 'scale(1.1)'
                                }
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} align="center" sx={{ 
                          color: '#94a3b8', 
                          fontStyle: 'italic', 
                          py: 4,
                          fontSize: '0.9rem'
                        }}>
                          Keine IT-Kenntnisse hinzugefügt
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                  </>
                )}
              </Box>
            </Box>
          )}
          
          {tabIndex === 3 && (
            <Box sx={{ mt: 3 }}>
              
              {/* Hobbys */}
              <Box 
                sx={{ 
                  border: '1px solid #e0e0e0',
                  borderRadius: 2,
                  bgcolor: 'white',
                  overflow: 'hidden',
                  mb: 3
                }}
              >
                <Box sx={{ 
                  py: 1.5, 
                  px: 2,
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white'
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <SportsOutlinedIcon sx={{ fontSize: 22 }} />
                      <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                        {getTranslatedCvLabel('Hobbys')}
                      </Typography>
                      <IconButton 
                        size="small"
                        onClick={() => setShowHobbiesCollapsed(!showHobbiesCollapsed)}
                        sx={{ 
                          color: 'white',
                          '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' }
                        }}
                      >
                        {showHobbiesCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                      </IconButton>
                    </Box>
                    <IconButton 
                      size="small"
                      onClick={handleAddHobby}
                      sx={{
                        bgcolor: 'rgba(255,255,255,0.2)',
                        border: '1px solid rgba(255,255,255,0.3)',
                        color: 'white',
                        width: 32,
                        height: 32,
                        borderRadius: '50%',
                        backdropFilter: 'blur(10px)',
                        '&:hover': {
                          bgcolor: 'rgba(255,255,255,0.3)',
                          borderColor: 'rgba(255,255,255,0.5)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        },
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <AddIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Box>
                {!showHobbiesCollapsed && (
                  <>
                    <Table size="small">
                      <TableHead>
                        <TableRow sx={{ 
                          background: 'linear-gradient(90deg, #f8fafc 0%, #e2e8f0 100%)',
                          borderBottom: '1px solid #e2e8f0'
                        }}>
                          <TableCell sx={{ 
                            fontWeight: 600, 
                            color: '#1e293b', 
                            fontSize: '0.7rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.3px',
                            py: 0.5,
                            px: 1
                          }}>
                            {getTranslatedCvLabel('Hobby')}
                          </TableCell>
                          <TableCell sx={{ 
                            fontWeight: 600, 
                            color: '#1e293b', 
                            fontSize: '0.7rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.3px',
                            py: 0.5,
                            px: 1
                          }}>
                            {getTranslatedCvLabel('Beschreibung')}
                          </TableCell>
                          <TableCell sx={{ 
                            fontWeight: 600, 
                            color: '#1e293b', 
                            fontSize: '0.7rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.3px',
                            py: 0.5,
                            px: 1
                          }}>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                              {hobbies.length > 0 ? (
        hobbies.map((hobby, idx) => (
                            <TableRow key={idx} sx={{ 
                              borderBottom: '1px solid #f1f5f9',
                              transition: 'all 0.2s ease',
                              '&:hover': {
                                bgcolor: '#f8fafc',
                                transform: 'scale(1.01)',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                              }
                            }}>
                              <TableCell sx={{ py: 2 }}>
                                <TextField 
                                  variant="standard" 
                                  key={`hobby-name-${idx}-${hobby.hobby || ''}`}
                                  defaultValue={hobby.hobby || ''} 
                                  onBlur={(e) => {
                                    const nextValue = e.target.value;
                                    const currentValue = hobby.hobby || '';
                                    if (nextValue !== currentValue) {
                                      handleHobbyChange(idx, 'hobby', nextValue);
                                    }
                                  }}
                                  fullWidth 
                                  size="small" 
                                  InputProps={{ 
                                    disableUnderline: false,
                                    style: { 
                                      color: '#1e293b', 
                                      fontWeight: 600,
                                      fontSize: '0.9rem'
                                    }
                                  }}
                                  sx={{
                                    '& .MuiInput-underline:before': {
                                      borderBottom: '1px dotted #e2e8f0'
                                    },
                                    '& .MuiInput-underline:hover:before': {
                                      borderBottom: '1px dotted #cbd5e1'
                                    },
                                    '& .MuiInput-underline:after': {
                                      borderBottom: '2px solid #3b82f6'
                                    }
                                  }}
                                />
                              </TableCell>
                              <TableCell sx={{ py: 2 }}>
                                <TextField 
                                  variant="standard" 
                                  key={`hobby-description-${idx}-${hobby.description || ''}`}
                                  defaultValue={hobby.description || ''} 
                                  onBlur={(e) => {
                                    const nextValue = e.target.value;
                                    const currentValue = hobby.description || '';
                                    if (nextValue !== currentValue) {
                                      handleHobbyChange(idx, 'description', nextValue);
                                    }
                                  }}
                                  fullWidth 
                                  multiline
                                  size="small" 
                                  InputProps={{ 
                                    disableUnderline: false,
                                    style: { 
                                      color: '#64748b', 
                                      fontWeight: 500,
                                      fontSize: '0.9rem'
                                    }
                                  }}
                                  sx={{
                                    '& .MuiInput-underline:before': {
                                      borderBottom: '1px dotted #e2e8f0'
                                    },
                                    '& .MuiInput-underline:hover:before': {
                                      borderBottom: '1px dotted #cbd5e1'
                                    },
                                    '& .MuiInput-underline:after': {
                                      borderBottom: '2px solid #3b82f6'
                                    }
                                  }}
                                />
                              </TableCell>
                              <TableCell sx={{ py: 2, textAlign: 'right', pr: 2 }}>
                                <IconButton 
                                  size="small" 
                                  onClick={() => handleRemoveHobby(idx)}
                                  sx={{ 
                                    color: '#94a3b8',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                      color: '#ef4444',
                                      bgcolor: '#fef2f2',
                                      transform: 'scale(1.1)'
                                    }
                                  }}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={3} align="center" sx={{ 
                              color: '#94a3b8', 
                              fontStyle: 'italic', 
                              py: 4,
                              fontSize: '0.9rem'
                            }}>
                              Keine Hobbys hinzugefügt
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </>
                )}
              </Box>

              {/* Zusätzliche Angaben */}
              <Box 
                sx={{ 
                  border: '1px solid #e0e0e0',
                  borderRadius: 2,
                  bgcolor: 'white',
                  overflow: 'hidden',
                  mb: 3
                }}
              >
                <Box sx={{ 
                  py: 1.5, 
                  px: 2,
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white'
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <InfoOutlinedIcon sx={{ fontSize: 22 }} />
                      <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                        {getTranslatedCvLabel('Weitere Angaben')}
                      </Typography>
                      <IconButton 
                        size="small"
                        onClick={() => setShowAdditionalInfoCollapsed(!showAdditionalInfoCollapsed)}
                        sx={{ 
                          color: 'white',
                          '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' }
                        }}
                      >
                        {showAdditionalInfoCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                      </IconButton>
                    </Box>
                    <IconButton 
                      size="small"
                      onClick={handleAddAdditionalInfo}
                      sx={{
                        bgcolor: 'rgba(255,255,255,0.2)',
                        border: '1px solid rgba(255,255,255,0.3)',
                        color: 'white',
                        width: 32,
                        height: 32,
                        borderRadius: '50%',
                        backdropFilter: 'blur(10px)',
                        '&:hover': {
                          bgcolor: 'rgba(255,255,255,0.3)',
                          borderColor: 'rgba(255,255,255,0.5)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        },
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <AddIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Box>
                {!showAdditionalInfoCollapsed && (
                  <>
                    <Table size="small">
                      <TableHead>
                        <TableRow sx={{ 
                          background: 'linear-gradient(90deg, #f8fafc 0%, #e2e8f0 100%)',
                          borderBottom: '1px solid #e2e8f0'
                        }}>
                          <TableCell sx={{ 
                            fontWeight: 600, 
                            color: '#1e293b', 
                            fontSize: '0.7rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.3px',
                            py: 0.5,
                            px: 1
                          }}>
                            {getTranslatedCvLabel('Angabe')}
                          </TableCell>
                      <TableCell sx={{ 
                        fontWeight: 600, 
                        color: '#1e293b', 
                        fontSize: '0.7rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.3px',
                        py: 0.5,
                        px: 1
                      }}>
                        {getTranslatedCvLabel('Beschreibung')}
                      </TableCell>
                      <TableCell sx={{ 
                        fontWeight: 600, 
                        color: '#1e293b', 
                        fontSize: '0.7rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.3px',
                        py: 0.5,
                        px: 1
                      }}>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                          {additionalInfo.length > 0 ? (
        additionalInfo.map((info, idx) => (
                        <TableRow key={idx} sx={{ 
                          borderBottom: '1px solid #f1f5f9',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            bgcolor: '#f8fafc',
                            transform: 'scale(1.01)',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                          }
                        }}>
                          <TableCell sx={{ py: 2 }}>
                            <TextField 
                              variant="standard" 
                              key={`info-title-${idx}-${info.info || ''}`}
                              defaultValue={info.info || ''} 
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = info.info || '';
                                if (nextValue !== currentValue) {
                                  handleAdditionalInfoChange(idx, 'info', nextValue);
                                }
                              }}
                              fullWidth 
                              size="small" 
                              InputProps={{ 
                                disableUnderline: false,
                                style: { 
                                  color: '#1e293b', 
                                  fontWeight: 600,
                                  fontSize: '0.9rem'
                                }
                              }}
                              sx={{
                                '& .MuiInput-underline:before': {
                                  borderBottom: '1px dotted #e2e8f0'
                                },
                                '& .MuiInput-underline:hover:before': {
                                  borderBottom: '1px dotted #cbd5e1'
                                },
                                '& .MuiInput-underline:after': {
                                  borderBottom: '2px solid #3b82f6'
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ py: 2 }}>
                            <TextField 
                              variant="standard" 
                              key={`info-details-${idx}-${info.details || ''}`}
                              defaultValue={info.details || ''} 
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = info.details || '';
                                if (nextValue !== currentValue) {
                                  handleAdditionalInfoChange(idx, 'details', nextValue);
                                }
                              }}
                              fullWidth 
                              multiline
                              size="small" 
                              InputProps={{ 
                                disableUnderline: false,
                                style: { 
                                  color: '#64748b', 
                                  fontWeight: 500,
                                  fontSize: '0.9rem'
                                }
                              }}
                              sx={{
                                '& .MuiInput-underline:before': {
                                  borderBottom: '1px dotted #e2e8f0'
                                },
                                '& .MuiInput-underline:hover:before': {
                                  borderBottom: '1px dotted #cbd5e1'
                                },
                                '& .MuiInput-underline:after': {
                                  borderBottom: '2px solid #3b82f6'
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ py: 2, textAlign: 'right', pr: 2 }}>
                            <IconButton 
                              size="small" 
                              onClick={() => handleDeleteAdditionalInfo(idx)}
                              sx={{ 
                                color: '#94a3b8',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                  color: '#ef4444',
                                  bgcolor: '#fef2f2',
                                  transform: 'scale(1.1)'
                                }
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} align="center" sx={{ 
                          color: '#94a3b8', 
                          fontStyle: 'italic', 
                          py: 4,
                          fontSize: '0.9rem'
                        }}>
                          Keine weiteren Angaben hinzugefügt
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                  </>
                )}
              </Box>
            </Box>
          )}
              </Box>
            </Box>
          </DialogContent>
        </Dialog>

        {/* CV-Import Warnungs-Dialog */}
        <Dialog
          open={showCvImportWarningDialog}
          onClose={undefined}
          maxWidth="sm"
          fullWidth
          disableEscapeKeyDown
          sx={{ zIndex: 1700 }}
        >
          <DialogTitle sx={{ 
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}>
            <WarningIcon />
            {t('cv.import.warning.title')}
          </DialogTitle>
          <DialogContent sx={{ p: 3, pt: 5 }}>
            <Box sx={{ mb: 3 }}></Box>
            <Typography variant="body1" sx={{ mb: 2, fontWeight: 500 }}>
              ⚠️ {t('cv.import.warning.message')}
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, color: '#666' }}>
              {t('cv.import.warning.description')}
            </Typography>
            <Box component="ul" sx={{ pl: 2, mb: 2 }}>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#666' }}>
                {t('cv.import.warning.item1')}
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#666' }}>
                {t('cv.import.warning.item2')}
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#666' }}>
                {t('cv.import.warning.item3')}
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#666' }}>
                {t('cv.import.warning.item4')}
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ color: '#666', fontStyle: 'italic' }}>
              {t('cv.import.warning.footer')}
            </Typography>
          </DialogContent>
          <DialogActions sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={dontShowImportWarning}
                  onChange={(e) => setDontShowImportWarning(e.target.checked)}
                  disableRipple
                  disableFocusRipple
                  sx={{ color: '#667eea', '&:hover': { backgroundColor: 'transparent' }, '& .MuiTouchRipple-root': { display: 'none' } }}
                />
              }
              label={t('cv.import.warning.dontShowAgain')}
              sx={{ color: '#666', margin: 0 }}
            />
            <Button 
              onClick={async () => {
                setShowCvImportWarningDialog(false);
                // Speichere Präferenz wenn Checkbox aktiviert
                if (dontShowImportWarning) {
                  await saveUserWarningPreferences(true, dontShowTemplateWarning);
                }
              }}
              variant="outlined"
              sx={{
                px: 3,
                py: 1.5,
                borderRadius: 6,
                borderColor: '#667eea',
                color: '#757575',
                fontWeight: 600,
                transition: 'all 0.2s ease',
                '&:hover': {
                  borderColor: '#764ba2',
                  backgroundColor: '#f5f5f5',
                  transform: 'translateY(-1px)',
                },
              }}
            >
              {t('cv.import.warning.button')}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Bestätigungsdialog für CV-Löschung */}
        <Dialog
          open={showDeleteCvDialog}
          onClose={() => setShowDeleteCvDialog(false)}
          maxWidth="sm"
          fullWidth
          sx={{ zIndex: 1700 }}
        >
          <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#f44336' }}>
            <DeleteIcon />
            CV löschen
          </DialogTitle>
          <DialogContent>
            <Typography>
              Möchten Sie den CV "{currentCvName || 'Unbenannt'}" wirklich löschen?
            </Typography>
            <Typography variant="body2" sx={{ mt: 2, color: '#666' }}>
              Diese Aktion kann nicht rückgängig gemacht werden.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowDeleteCvDialog(false)}>
              Abbrechen
            </Button>
            <Button 
              onClick={handleDeleteCv}
              variant="contained"
              color="error"
              startIcon={<DeleteIcon />}
            >
              Löschen
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal für CV hinzufügen */}
        <Dialog 
          open={showAddCvModal} 
          onClose={() => {
            setShowAddCvModal(false);
            setCvModalManuallyClosed(true);
          }}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              maxHeight: '90vh',
              margin: '20px'
            }
          }}
        >
          <DialogTitle>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="h6">
                {getTranslatedCvLabel('CV-Daten hinzufügen')}
              </Typography>
              <IconButton onClick={() => {
                setShowAddCvModal(false);
                setCvModalManuallyClosed(true);
              }}>
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          
          <DialogContent sx={{ p: 3, overflow: 'hidden' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
              {/* Eingabefeld für CV-Name */}
              <TextField
                fullWidth
                label={getTranslatedCvLabel('CV-Name (optional)')}
                key={`new-cv-name-${newCvName || ''}`}
                defaultValue={newCvName}
                onBlur={(e) => {
                  const nextValue = e.target.value;
                  if (nextValue !== newCvName) setNewCvName(nextValue);
                }}
                placeholder={`z.B. Bewerbung bei ${currentLanguage === 'de' ? 'Firma XYZ' : currentLanguage === 'en' ? 'Company XYZ' : currentLanguage === 'fr' ? 'Entreprise XYZ' : 'Azienda XYZ'}`}
                variant="outlined"
                sx={{ mb: 1 }}
                helperText={currentLanguage === 'de' ? 'Gib deinem CV einen aussagekräftigen Namen für bessere Übersicht' :
                           currentLanguage === 'en' ? 'Give your CV a meaningful name for better overview' :
                           currentLanguage === 'fr' ? 'Donnez à votre CV un nom significatif pour une meilleure vue d\'ensemble' :
                           'Dai al tuo CV un nome significativo per una migliore panoramica'}
              />
              
              {/* Button: CV hochladen */}
              <Button
                variant="contained"
                component="label"
                fullWidth
                disabled={extracting}
                startIcon={<CloudUploadIcon />}
                sx={{
                  py: 2,
                  borderRadius: 2,
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  fontWeight: 600,
                  fontSize: '0.95rem',
                  textTransform: 'none',
                  boxShadow: '0 2px 8px rgba(102, 126, 234, 0.25)',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)',
                    boxShadow: '0 4px 12px rgba(102, 126, 234, 0.35)',
                  },
                  '&:disabled': {
                    opacity: 0.6,
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                  },
                }}
              >
                {extracting ? t('extraction.processing') : t('upload.cv')}
                <input
                  type="file"
                  accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  hidden
                  onChange={(e) => {
                    handleFileChange(e);
                    setShowAddCvModal(false);
                    setCvModalManuallyClosed(true);
                    setNewCvName(''); // Reset CV-Name
                  }}
                />
              </Button>

              {/* Trennlinie mit "oder" */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, my: 1 }}>
                <Box sx={{ flex: 1, height: '1px', bgcolor: '#e0e0e0' }} />
                <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500, fontSize: '0.875rem' }}>
                  {getTranslatedCvLabel('oder')}
                </Typography>
                <Box sx={{ flex: 1, height: '1px', bgcolor: '#e0e0e0' }} />
              </Box>

              {/* Button: Daten manuell befüllen */}
              <Button
                variant="outlined"
                fullWidth
                disabled={extracting || userCvs.length >= getAccountLimits(accountType).maxCvs}
                startIcon={<EditIcon />}
                onClick={async () => {
                  // Prüfe CV-Limit
                  const limits = getAccountLimits(accountType);
                  if (userCvs.length >= limits.maxCvs) {
                    alert(t('account.limit.cvs.reached', { max: limits.maxCvs }));
                    return;
                  }
                  
                  // Schließe Add-Modal
                  setShowAddCvModal(false);
                  setCvModalManuallyClosed(true);
                  
                  // Verstecke Upload-Buttons nach Klick auf "Daten manuell befüllen"
                  setHideUploadButtons(true);
                  
                  // Setze Flag für manuelle CV-Erstellung - beim Speichern wird ein neues CV erstellt
                  setIsManualCvCreation(true);
                  
                  // Erstelle einen neuen CV - lösche alle aktuellen Daten
                  clearAllCvData();
                  
                  // Öffne CV-Daten Modal mit "Persönliche Informationen" Tab
                  setShowCvDataModal(true);
                  setTabIndex(0); // Setze Modal auf Tab "Persönliche Informationen"
                  setCvDataEditMode(true);
                  setHasUnsavedChanges(false); // Beim Öffnen keine ungespeicherten Änderungen
                  
                  // Zeige "Passgenauigkeit prüfen" Button wieder an, verstecke andere Buttons
                  setShowPassgenauigkeitButton(true);
                  setShowCvOptimierenButton(false);
                  
                  // Erzwinge Anzeige der CV-Daten, auch wenn keine Daten vorhanden sind
                  setForceShowCvData(true);
                }}
                sx={{
                  py: 2,
                  borderRadius: 2,
                  borderColor: 'primary.main',
                  color: 'primary.main',
                  fontWeight: 600,
                  fontSize: '0.95rem',
                  textTransform: 'none',
                  '&:hover': {
                    borderColor: 'primary.dark',
                    backgroundColor: 'rgba(102, 126, 234, 0.04)',
                  },
                }}
              >
                {getTranslatedCvLabel('Daten manuell befüllen')}
              </Button>
            </Box>
          </DialogContent>
        </Dialog>

        {/* CV-Template Warnungs-Dialog */}
        <Dialog
          open={showCvTemplateWarningDialog}
          onClose={undefined}
          maxWidth="sm"
          fullWidth
          disableEscapeKeyDown
        >
          <DialogTitle sx={{ 
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}>
            <WarningIcon />
            {t('cv.template.warning.title')}
          </DialogTitle>
          <DialogContent sx={{ p: 3, pt: 5 }}>
            {/* Abstand zwischen Header und Text */}
            <Box sx={{ mb: 3 }}></Box>
            <Typography variant="body1" sx={{ mb: 2, fontWeight: 500 }}>
              ⚠️ {t('cv.template.warning.message')}
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, color: '#666' }}>
              {t('cv.template.warning.description')}
            </Typography>
            <Box component="ul" sx={{ pl: 2, mb: 2 }}>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#666' }}>
                {t('cv.template.warning.item1')}
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#666' }}>
                {t('cv.template.warning.item2')}
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#666' }}>
                {t('cv.template.warning.item3')}
              </Typography>
            </Box>
            <Typography
              variant="body2"
              sx={{
                mb: 2,
                color: '#374151',
                backgroundColor: '#f8fafc',
                border: '1px solid #e2e8f0',
                borderRadius: 2,
                p: 1.5,
              }}
            >
              {t('cv.template.warning.disclaimer')}
            </Typography>
            <Typography variant="body2" sx={{ color: '#666', fontStyle: 'italic' }}>
              {t('cv.template.warning.footer')}
            </Typography>
          </DialogContent>
          <DialogActions sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={dontShowTemplateWarning}
                  onChange={(e) => setDontShowTemplateWarning(e.target.checked)}
                  disableRipple
                  disableFocusRipple
                  sx={{ color: '#667eea', '&:hover': { backgroundColor: 'transparent' }, '& .MuiTouchRipple-root': { display: 'none' } }}
                />
              }
              label={t('cv.template.warning.dontShowAgain')}
              sx={{ color: '#666', margin: 0 }}
            />
            <Button 
              onClick={async () => {
                setShowCvTemplateWarningDialog(false);
                
                // Warte, bis optimierte CV-Daten verfügbar sind, bevor die Preview geöffnet wird
                console.log('⏳ Warte auf optimierte CV-Daten (Modal)...');
                const hasOptimizedData = await waitForOptimizedCvData();
                
                if (!hasOptimizedData) {
                  console.error('❌ Keine optimierten CV-Daten verfügbar - Preview wird nicht geöffnet');
                  setError('Optimierte CV-Daten sind noch nicht verfügbar. Bitte versuche es erneut.');
                  return;
                }
                
                // Verwende den gleichen Prozess wie beim Modal "Bewerbungen" (funktioniert korrekt)
                // 1. Priorität: CV-spezifische Settings. Account-Design nur als Fallback ohne cvId.
                let designSettingsForApplication: any | undefined;
                if (selectedCvId) {
                  await loadAndApplyCvSettingsForCv(selectedCvId);
                } else {
                  const loadedDesignSettings = await loadCvDesignSettingsForPreview();
                  const normalizedDesignSettings = loadedDesignSettings || getCurrentCvDesignSettings();
                  if (normalizedDesignSettings) {
                    console.log('✅ Design-Einstellungen geladen und normalisiert (Fallback):', normalizedDesignSettings);
                    applyCvDesignSettings(normalizedDesignSettings);
                    console.log('✅ CV-Design-Einstellungen explizit angewendet (Fallback):', normalizedDesignSettings);
                    designSettingsForApplication = normalizedDesignSettings;
                  }
                }
                
                // Speichere Präferenz wenn Checkbox aktiviert
                if (dontShowTemplateWarning) {
                  await saveUserWarningPreferences(dontShowImportWarning, true);
                }
                
                let previewAbortController: AbortController | null = null;
                let isLatestPreviewRequest = () => true;
                try {
                  // Neue Preview-Anfrage: ältere Anfrage abbrechen und nur die letzte Antwort anwenden.
                  const previewRequestId = cvPreviewRequestIdRef.current + 1;
                  cvPreviewRequestIdRef.current = previewRequestId;
                  cvPreviewAbortControllerRef.current?.abort();
                  previewAbortController = new AbortController();
                  cvPreviewAbortControllerRef.current = previewAbortController;
                  isLatestPreviewRequest = () =>
                    cvPreviewRequestIdRef.current === previewRequestId &&
                    cvPreviewAbortControllerRef.current === previewAbortController &&
                    !previewAbortController!.signal.aborted;

                  // 3. Verwende bestehende Bewerbung, erstelle nur beim ersten Öffnen eine neue
                  let applicationId = selectedApplicationId;
                  if (applicationId) {
                    const existingApplication = applications.find((app: any) => app.id === applicationId);
                    const isValidForCurrentCv = selectedCvId
                      ? !!existingApplication?.cvId && existingApplication.cvId === selectedCvId
                      : !!existingApplication;
                    if (!isValidForCurrentCv) {
                      console.warn('⚠️ Verwerfe veraltete selectedApplicationId im Warning-Dialog:', {
                        applicationId,
                        selectedCvId,
                        applicationCvId: existingApplication?.cvId || null
                      });
                      applicationId = null;
                      setSelectedApplicationId(null);
                    }
                  }
                  if (!applicationId) {
                    // Bei vorhandenem selectedCvId basieren die Daten auf CV-Ebene aus dem State.
                    applicationId = await createApplicationFromCvPreviewWithLock(designSettingsForApplication);
                    if (!isLatestPreviewRequest()) return;
                  }
                  
                  if (!applicationId) {
                    throw new Error('Fehler beim Erstellen der Application');
                  }
                  if (!isLatestPreviewRequest()) return;

                  // Halte die aktive Bewerbung explizit synchron, damit Download/Close
                  // in genau dieselbe Application schreibt, aus der später wieder geladen wird.
                  setSelectedApplicationId(applicationId);
                  setSelectedApplication(null);
                  
                  // 4. Lade Design-Settings aus der erstellten Application (wie beim Modal Bewerbungen)
                  // Dies stellt sicher, dass die Design-Einstellungen korrekt angewendet werden
                  if (!user) {
                    throw new Error('Benutzer nicht angemeldet');
                  }
                  
                  // Kurze Verzögerung, um sicherzustellen, dass die Application vollständig gespeichert wurde
                  await new Promise(resolve => setTimeout(resolve, 100));
                  if (!isLatestPreviewRequest()) return;
                  
                  const token = await user.getIdToken();
                  const response = await fetch(`${config.backend.baseUrl}/api/get-application-cv-preview-data/${applicationId}`, {
                    method: 'GET',
                    headers: {
                      'Authorization': `Bearer ${token}`,
                      'Content-Type': 'application/json'
                    },
                    signal: previewAbortController.signal
                  });
                  if (!isLatestPreviewRequest()) return;

                  if (!response.ok) {
                    throw new Error('Fehler beim Laden der Application-Daten');
                  }

                  const data = await response.json();
                  if (!isLatestPreviewRequest()) return;
                  const cvPreviewData = data.cvPreviewData;

                  if (!cvPreviewData) {
                    throw new Error('Keine cvPreviewData in Application gefunden');
                  }

                  // Bei Öffnen aus Bewerbung haben bewerbungsspezifische Design-/Sichtbarkeitswerte Priorität.
                  const cvIdForPreview = data.cvId || cvPreviewData?.cvId || null;
                  if (cvPreviewData?.designSettings) {
                    applyCvDesignSettings(cvPreviewData.designSettings);
                    console.log('✅ Bewerbungsspezifische Design-Einstellungen angewendet (Warning Dialog)');
                  } else if (cvIdForPreview) {
                    await loadAndApplyCvSettingsForCv(cvIdForPreview);
                    if (!isLatestPreviewRequest()) return;
                    console.log('✅ CV-spezifische Settings für Preview geladen:', cvIdForPreview);
                  } else {
                    applyCvSettings(buildDefaultCvLevelSettings());
                    console.warn('⚠️ Keine cvId/designSettings auflösbar - verwende CV-Defaults');
                  }
                  
                  // 5. Warte, bis alle State-Updates verarbeitet wurden, bevor die Preview geöffnet wird
                  // Verwende requestAnimationFrame, um sicherzustellen, dass React die State-Updates verarbeitet hat
                  await new Promise(resolve => {
                    requestAnimationFrame(() => {
                      requestAnimationFrame(() => {
                        setTimeout(resolve, 100);
                      });
                    });
                  });
                  if (!isLatestPreviewRequest()) return;
                  
                  // 6. Öffne CV-Preview Modal NACH dem Laden der Design-Einstellungen (wie beim Modal Bewerbungen)
                  // Die Design-Einstellungen wurden bereits explizit angewendet und die State-Updates wurden verarbeitet
                  setShowTemplatePreviewDialog(true);
                  setShowCvOptimierenButton(false);
                  // NICHT hier setzen - wird erst beim Schließen der Preview gesetzt
                  // setCvTemplateHasBeenOpened(true);
                } catch (error) {
                  if (previewAbortController?.signal.aborted || (error as any)?.name === 'AbortError') {
                    console.log('ℹ️ Preview-Ladevorgang im Warning-Dialog abgebrochen');
                    return;
                  }
                  console.error('❌ Fehler beim Öffnen der CV-Preview:', error);
                  setError('Fehler beim Öffnen der CV-Preview: ' + (error instanceof Error ? error.message : 'Unbekannter Fehler'));
                }
              }}
              variant="outlined"
              sx={{
                px: 3,
                py: 1.5,
                borderRadius: 6,
                borderColor: '#667eea',
                color: '#757575',
                fontWeight: 600,
                transition: 'all 0.2s ease',
                '&:hover': {
                  borderColor: '#764ba2',
                  backgroundColor: '#f5f5f5',
                  transform: 'translateY(-1px)',
                },
              }}
            >
              {t('cv.template.warning.button')}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Motivationsschreiben Warnungs-Dialog */}
        <Dialog
          open={showMotivationWarningDialog}
          onClose={() => setShowMotivationWarningDialog(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: '12px',
              boxShadow: '0 8px 32px rgba(0,0,0,0.12)'
            }
          }}
        >
          <DialogTitle sx={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}>
            <WarningIcon />
            {t('cv.motivation.warning.title')}
          </DialogTitle>
          <DialogContent sx={{ p: 3, pt: 5 }}>
            {/* Abstand zwischen Header und Text */}
            <Box sx={{ mb: 3 }}></Box>
            <Typography variant="body1" sx={{ mb: 2, fontWeight: 500 }}>
              ⚠️ {t('cv.motivation.warning.message')}
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, color: '#666' }}>
              {t('cv.motivation.warning.description')}
            </Typography>
            <Box component="ul" sx={{ pl: 2, mb: 2 }}>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#666' }}>
                {t('cv.motivation.warning.item1')}
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#666' }}>
                {t('cv.motivation.warning.item2')}
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#666' }}>
                {t('cv.motivation.warning.item3')}
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#666' }}>
                {t('cv.motivation.warning.item4')}
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ color: '#666', fontStyle: 'italic' }}>
              {t('cv.motivation.warning.footer')}
            </Typography>
          </DialogContent>
          <DialogActions sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={dontShowMotivationWarning}
                  onChange={(e) => setDontShowMotivationWarning(e.target.checked)}
                  disableRipple
                  disableFocusRipple
                  sx={{ color: '#667eea', '&:hover': { backgroundColor: 'transparent' }, '& .MuiTouchRipple-root': { display: 'none' } }}
                />
              }
              label={t('cv.motivation.warning.dontShowAgain')}
              sx={{ color: '#666', margin: 0 }}
            />
            <Button 
              onClick={async () => {
                setShowMotivationWarningDialog(false);
                // Speichere Präferenz wenn Checkbox aktiviert
                if (dontShowMotivationWarning) {
                  await saveUserWarningPreferences(dontShowImportWarning, dontShowTemplateWarning, true);
                }
                // Öffne das Motivationsschreiben nach Schliessen des Pop-ups
                if (motivationLetter) {
                  handleOpenMotivationDialog();
                }
              }}
              variant="outlined"
              sx={{
                px: 3,
                py: 1.5,
                borderRadius: 6,
                borderColor: '#667eea',
                color: '#757575',
                fontWeight: 600,
                transition: 'all 0.2s ease',
                '&:hover': {
                  borderColor: '#764ba2',
                  backgroundColor: '#f5f5f5',
                  transform: 'translateY(-1px)',
                },
              }}
            >
              {t('cv.motivation.warning.button')}
            </Button>
          </DialogActions>
        </Dialog>
        
        {/* Label für optimierte CV-Daten (Administrator) */}
      {isAdmin() && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <Typography variant="body2">Optimierte CV-Daten (Administrator)</Typography>
            <IconButton 
              onClick={() => {
                const newHideState = !hideOptimizedCvData;
                setHideOptimizedCvData(newHideState);
              }}
              sx={{ 
                color: 'primary.main',
                '&:hover': { bgcolor: 'rgba(25, 118, 210, 0.1)' }
              }}
            >
              {hideOptimizedCvData ? <ExpandMoreIcon /> : <ExpandLessIcon />}
            </IconButton>
          </Box>
        )}




        {/* Alle Elemente - minimierbar */}
        {!hideOptimizedCvData && (
          <>
            {/* Alle Daten löschen Button - nur für Admin sichtbar */}
            {isAdmin() && (
              <Box sx={{ mb: 2 }}>
                <Button
                  variant="outlined"
                  color="error"
                  size="small"
                  onClick={handleClearAllData}
                  startIcon={<ClearIcon />}
                  sx={{ 
                    minWidth: 'auto', 
                    px: 2,
                    borderColor: 'error.main',
                    color: 'error.main',
                    '&:hover': {
                      bgcolor: 'rgba(244, 67, 54, 0.1)',
                      borderColor: 'error.dark'
                    }
                  }}
                >
                  {t('clear.all.data')}
                </Button>
              </Box>
            )}

            {/* Template Vorschau Button */}
            <Box sx={{ mb: 3, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
              <Button
                variant="outlined"
                onClick={() => handleOpenCvTemplate()}
                startIcon={<VisibilityIcon />}
                sx={{ mb: 2 }}
              >
                Optimierten CV anzeigen
              </Button>
              
              {motivationLetter && (
                <Button
                  variant="outlined"
                  onClick={handleOpenMotivationDialog}
                  startIcon={<VisibilityIcon />}
                  sx={{ mb: 2 }}
                >
                  Motivationsschreiben anzeigen
                </Button>
              )}
            </Box>

            {/* Persönliche Angaben - immer sichtbar */}
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6">
                Persönliche Angaben
              </Typography>
              <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2, mb: 3 }}>
                <TextField
                  label={getTranslatedCvLabel('Name:').replace(':', '')}
                  key={`opt-personal-name-${fullName || ''}`}
                  defaultValue={fullName || ''}
                  onBlur={(e) => {
                    const nextValue = e.target.value;
                    const currentValue = fullName || '';
                    if (nextValue !== currentValue) handleFullNameChange(nextValue);
                  }}
                  fullWidth
                  variant="outlined"
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: '#f8f9fa',
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset': {
                        borderColor: '#bdbdbd',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#1976d2',
                      },
                    },
                  }}
                />
                <TextField
                  label={getTranslatedCvLabel('Email:').replace(':', '')}
                  key={`opt-personal-email-${email || ''}`}
                  defaultValue={email || ''}
                  onBlur={(e) => {
                    const nextValue = e.target.value;
                    const currentValue = email || '';
                    if (nextValue !== currentValue) handleCvDataChange(setEmail, nextValue);
                  }}
                  fullWidth
                  variant="outlined"
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: '#f8f9fa',
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset': {
                        borderColor: '#bdbdbd',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#1976d2',
                      },
                    },
                  }}
                />
                <TextField
                  label={getTranslatedCvLabel('Telefon:').replace(':', '')}
                  key={`opt-personal-phone-${phoneNumber || ''}`}
                  defaultValue={phoneNumber || ''}
                  onBlur={(e) => {
                    const nextValue = e.target.value;
                    const currentValue = phoneNumber || '';
                    if (nextValue !== currentValue) handleCvDataChange(setPhoneNumber, nextValue);
                  }}
                  fullWidth
                  variant="outlined"
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: '#f8f9fa',
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset': {
                        borderColor: '#bdbdbd',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#1976d2',
                      },
                    },
                  }}
                />
                <TextField
                  label={getTranslatedCvLabel('Adresse:').replace(':', '')}
                  key={`opt-personal-address-${address || ''}`}
                  defaultValue={address || ''}
                  onBlur={(e) => {
                    const nextValue = e.target.value;
                    const currentValue = address || '';
                    if (nextValue !== currentValue) handleCvDataChange(setAddress, nextValue);
                  }}
                  fullWidth
                  variant="outlined"
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: '#f8f9fa',
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset': {
                        borderColor: '#bdbdbd',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#1976d2',
                      },
                    },
                  }}
                />
                <TextField
                  label={getTranslatedCvLabel('PLZ:').replace(':', '')}
                  key={`opt-personal-postal-${postalCode || ''}`}
                  defaultValue={postalCode || ''}
                  onBlur={(e) => {
                    const nextValue = e.target.value;
                    const currentValue = postalCode || '';
                    if (nextValue !== currentValue) handleCvDataChange(setPostalCode, nextValue);
                  }}
                  fullWidth
                  variant="outlined"
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: '#f8f9fa',
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset': {
                        borderColor: '#bdbdbd',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#1976d2',
                      },
                    },
                  }}
                />
                <TextField
                  label={getTranslatedCvLabel('Stadt:').replace(':', '')}
                  key={`opt-personal-city-${city || ''}`}
                  defaultValue={city || ''}
                  onBlur={(e) => {
                    const nextValue = e.target.value;
                    const currentValue = city || '';
                    if (nextValue !== currentValue) handleCvDataChange(setCity, nextValue);
                  }}
                  fullWidth
                  variant="outlined"
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: '#f8f9fa',
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset': {
                        borderColor: '#bdbdbd',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#1976d2',
                      },
                    },
                  }}
                />
                <TextField
                  label={t('cv.personal.birthyear')} 
                  type="number"
                  key={`opt-personal-birthyear-${birthYear || ''}`}
                  defaultValue={birthYear}
                  onBlur={(e) => {
                    const nextValue = e.target.value;
                    if (nextValue !== birthYear) handleCvDataChange(setBirthYear, nextValue);
                  }} 
                  fullWidth 
                  inputProps={{ min: 1900, max: new Date().getFullYear(), step: 1 }}
                  placeholder="z.B. 1990"
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: '#f8f9fa',
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset': {
                        borderColor: '#bdbdbd',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#1976d2',
                      },
                    },
                  }}
                />
                <TextField
                  label={getTranslatedCvLabel('Verfügbar ab:').replace(':', '')}
                  type="date"
                  key={`opt-personal-available-${availableFrom || ''}`}
                  defaultValue={availableFrom || ''}
                  onBlur={(e) => {
                    const nextValue = e.target.value;
                    const currentValue = availableFrom || '';
                    if (nextValue !== currentValue) handleCvDataChange(setAvailableFrom, nextValue);
                  }}
                  fullWidth
                  variant="outlined"
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: '#f8f9fa',
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset': {
                        borderColor: '#bdbdbd',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#1976d2',
                      },
                    },
                  }}
                />
                <FormControl fullWidth size="small" sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                    backgroundColor: '#f8f9fa',
                    '& fieldset': {
                      borderColor: '#e0e0e0',
                    },
                    '&:hover fieldset': {
                      borderColor: '#bdbdbd',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#1976d2',
                    },
                  },
                }}>
                  <InputLabel>Nationalität</InputLabel>
                  <Select 
                    value={nationality || ''} 
                    label="Nationalität" 
                    onChange={(e) => handleCvDataChange(setNationality, e.target.value)}
                  >
                    <MenuItem value="">Bitte wählen</MenuItem>
                    <MenuItem value="CH">CH - Schweiz</MenuItem>
                    <MenuItem value="DE">DE - Deutschland</MenuItem>
                    <MenuItem value="AT">AT - Österreich</MenuItem>
                    <MenuItem value="FR">FR - Frankreich</MenuItem>
                    <MenuItem value="IT">IT - Italien</MenuItem>
                    <MenuItem value="ES">ES - Spanien</MenuItem>
                    <MenuItem value="PT">PT - Portugal</MenuItem>
                    <MenuItem value="NL">NL - Niederlande</MenuItem>
                    <MenuItem value="BE">BE - Belgien</MenuItem>
                    <MenuItem value="LU">LU - Luxemburg</MenuItem>
                    <MenuItem value="DK">DK - Dänemark</MenuItem>
                    <MenuItem value="SE">SE - Schweden</MenuItem>
                    <MenuItem value="NO">NO - Norwegen</MenuItem>
                    <MenuItem value="FI">FI - Finnland</MenuItem>
                    <MenuItem value="IS">IS - Island</MenuItem>
                    <MenuItem value="GB">GB - Großbritannien</MenuItem>
                    <MenuItem value="IE">IE - Irland</MenuItem>
                    <MenuItem value="PL">PL - Polen</MenuItem>
                    <MenuItem value="CZ">CZ - Tschechien</MenuItem>
                    <MenuItem value="SK">SK - Slowakei</MenuItem>
                    <MenuItem value="HU">HU - Ungarn</MenuItem>
                    <MenuItem value="RO">RO - Rumänien</MenuItem>
                    <MenuItem value="BG">BG - Bulgarien</MenuItem>
                    <MenuItem value="HR">HR - Kroatien</MenuItem>
                    <MenuItem value="SI">SI - Slowenien</MenuItem>
                    <MenuItem value="RS">RS - Serbien</MenuItem>
                    <MenuItem value="BA">BA - Bosnien-Herzegowina</MenuItem>
                    <MenuItem value="ME">ME - Montenegro</MenuItem>
                    <MenuItem value="MK">MK - Nordmazedonien</MenuItem>
                    <MenuItem value="AL">AL - Albanien</MenuItem>
                    <MenuItem value="GR">GR - Griechenland</MenuItem>
                    <MenuItem value="CY">CY - Zypern</MenuItem>
                    <MenuItem value="MT">MT - Malta</MenuItem>
                    <MenuItem value="EE">EE - Estland</MenuItem>
                    <MenuItem value="LV">LV - Lettland</MenuItem>
                    <MenuItem value="LT">LT - Litauen</MenuItem>
                    <MenuItem value="US">US - USA</MenuItem>
                    <MenuItem value="CA">CA - Kanada</MenuItem>
                    <MenuItem value="AU">AU - Australien</MenuItem>
                    <MenuItem value="NZ">NZ - Neuseeland</MenuItem>
                    <MenuItem value="JP">JP - Japan</MenuItem>
                    <MenuItem value="KR">KR - Südkorea</MenuItem>
                    <MenuItem value="CN">CN - China</MenuItem>
                    <MenuItem value="IN">IN - Indien</MenuItem>
                    <MenuItem value="PK">PK - Pakistan</MenuItem>
                    <MenuItem value="BD">BD - Bangladesch</MenuItem>
                    <MenuItem value="LK">LK - Sri Lanka</MenuItem>
                    <MenuItem value="NP">NP - Nepal</MenuItem>
                    <MenuItem value="BT">BT - Bhutan</MenuItem>
                    <MenuItem value="MV">MV - Malediven</MenuItem>
                    <MenuItem value="AF">AF - Afghanistan</MenuItem>
                    <MenuItem value="IR">IR - Iran</MenuItem>
                    <MenuItem value="IQ">IQ - Irak</MenuItem>
                    <MenuItem value="KW">KW - Kuwait</MenuItem>
                    <MenuItem value="BH">BH - Bahrain</MenuItem>
                    <MenuItem value="QA">QA - Katar</MenuItem>
                    <MenuItem value="Vereinigte Arabische Emirate">Vereinigte Arabische Emirate</MenuItem>
                    <MenuItem value="Omaner">Omaner</MenuItem>
                    <MenuItem value="Jemenit">Jemenit</MenuItem>
                    <MenuItem value="Saudi-Araber">Saudi-Araber</MenuItem>
                    <MenuItem value="Jordanier">Jordanier</MenuItem>
                    <MenuItem value="Libanese">Libanese</MenuItem>
                    <MenuItem value="Syrier">Syrier</MenuItem>
                    <MenuItem value="Palästinenser">Palästinenser</MenuItem>
                    <MenuItem value="Israeli">Israeli</MenuItem>
                    <MenuItem value="Ägypter">Ägypter</MenuItem>
                    <MenuItem value="Sudanese">Sudanese</MenuItem>
                    <MenuItem value="Südsudanese">Südsudanese</MenuItem>
                    <MenuItem value="Libyer">Libyer</MenuItem>
                    <MenuItem value="Tunesier">Tunesier</MenuItem>
                    <MenuItem value="Algerier">Algerier</MenuItem>
                    <MenuItem value="Marokkaner">Marokkaner</MenuItem>
                    <MenuItem value="Mauretanier">Mauretanier</MenuItem>
                    <MenuItem value="Senegalese">Senegalese</MenuItem>
                    <MenuItem value="Gambier">Gambier</MenuItem>
                    <MenuItem value="Guinea-Bissauer">Guinea-Bissauer</MenuItem>
                    <MenuItem value="Guineer">Guineer</MenuItem>
                    <MenuItem value="Sierra Leoner">Sierra Leoner</MenuItem>
                    <MenuItem value="Liberianer">Liberianer</MenuItem>
                    <MenuItem value="Elfenbeinküstler">Elfenbeinküstler</MenuItem>
                    <MenuItem value="Ghanaer">Ghanaer</MenuItem>
                    <MenuItem value="Togoer">Togoer</MenuItem>
                    <MenuItem value="Beniner">Beniner</MenuItem>
                    <MenuItem value="Nigerianer">Nigerianer</MenuItem>
                    <MenuItem value="Kameruner">Kameruner</MenuItem>
                    <MenuItem value="Tschader">Tschader</MenuItem>
                    <MenuItem value="Zentralafrikaner">Zentralafrikaner</MenuItem>
                    <MenuItem value="Äquatorialguineer">Äquatorialguineer</MenuItem>
                    <MenuItem value="Gabuner">Gabuner</MenuItem>
                    <MenuItem value="Kongolese">Kongolese</MenuItem>
                    <MenuItem value="Kongolese (DRC)">Kongolese (DRC)</MenuItem>
                    <MenuItem value="Angolaner">Angolaner</MenuItem>
                    <MenuItem value="Sambier">Sambier</MenuItem>
                    <MenuItem value="Malawier">Malawier</MenuItem>
                    <MenuItem value="Mosambikaner">Mosambikaner</MenuItem>
                    <MenuItem value="Simbabweer">Simbabweer</MenuItem>
                    <MenuItem value="Botswaner">Botswaner</MenuItem>
                    <MenuItem value="Namibier">Namibier</MenuItem>
                    <MenuItem value="Südafrikaner">Südafrikaner</MenuItem>
                    <MenuItem value="Lesothoer">Lesothoer</MenuItem>
                    <MenuItem value="Eswatini">Eswatini</MenuItem>
                    <MenuItem value="Madagasse">Madagasse</MenuItem>
                    <MenuItem value="Mauritier">Mauritier</MenuItem>
                    <MenuItem value="Seycheller">Seycheller</MenuItem>
                    <MenuItem value="Komorer">Komorer</MenuItem>
                    <MenuItem value="Dschibutier">Dschibutier</MenuItem>
                    <MenuItem value="Somalier">Somalier</MenuItem>
                    <MenuItem value="Äthiopier">Äthiopier</MenuItem>
                    <MenuItem value="Eritreer">Eritreer</MenuItem>
                    <MenuItem value="Keniaer">Keniaer</MenuItem>
                    <MenuItem value="Ugander">Ugander</MenuItem>
                    <MenuItem value="Tansanier">Tansanier</MenuItem>
                    <MenuItem value="Ruander">Ruander</MenuItem>
                    <MenuItem value="Burunder">Burunder</MenuItem>
                    <MenuItem value="Kongolese (Republik)">Kongolese (Republik)</MenuItem>
                    <MenuItem value="Gabuner">Gabuner</MenuItem>
                    <MenuItem value="Äquatorialguineer">Äquatorialguineer</MenuItem>
                    <MenuItem value="São Toméer">São Toméer</MenuItem>
                    <MenuItem value="Kap Verdeaner">Kap Verdeaner</MenuItem>
                    <MenuItem value="Brasilianer">Brasilianer</MenuItem>
                    <MenuItem value="Argentinier">Argentinier</MenuItem>
                    <MenuItem value="Chilene">Chilene</MenuItem>
                    <MenuItem value="Peruaner">Peruaner</MenuItem>
                    <MenuItem value="Bolivianer">Bolivianer</MenuItem>
                    <MenuItem value="Paraguayer">Paraguayer</MenuItem>
                    <MenuItem value="Uruguayer">Uruguayer</MenuItem>
                    <MenuItem value="Ecuadorianer">Ecuadorianer</MenuItem>
                    <MenuItem value="Kolumbianer">Kolumbianer</MenuItem>
                    <MenuItem value="Venezolaner">Venezolaner</MenuItem>
                    <MenuItem value="Guyaner">Guyaner</MenuItem>
                    <MenuItem value="Surinamer">Surinamer</MenuItem>
                    <MenuItem value="Franzose (Guyana)">Franzose (Guyana)</MenuItem>
                    <MenuItem value="Mexikaner">Mexikaner</MenuItem>
                    <MenuItem value="Guatemalteke">Guatemalteke</MenuItem>
                    <MenuItem value="Belizer">Belizer</MenuItem>
                    <MenuItem value="Salvadorianer">Salvadorianer</MenuItem>
                    <MenuItem value="Honduraner">Honduraner</MenuItem>
                    <MenuItem value="Nicaraguaner">Nicaraguaner</MenuItem>
                    <MenuItem value="Costa Ricaner">Costa Ricaner</MenuItem>
                    <MenuItem value="Panamaer">Panamaer</MenuItem>
                    <MenuItem value="Kubaner">Kubaner</MenuItem>
                    <MenuItem value="Jamaikaner">Jamaikaner</MenuItem>
                    <MenuItem value="Haitianer">Haitianer</MenuItem>
                    <MenuItem value="Dominikaner">Dominikaner</MenuItem>
                    <MenuItem value="Puerto Ricaner">Puerto Ricaner</MenuItem>
                    <MenuItem value="Bahamaer">Bahamaer</MenuItem>
                    <MenuItem value="Barbadier">Barbadier</MenuItem>
                    <MenuItem value="Trinidad und Tobagoer">Trinidad und Tobagoer</MenuItem>
                    <MenuItem value="Grenadier">Grenadier</MenuItem>
                    <MenuItem value="St. Lucianer">St. Lucianer</MenuItem>
                    <MenuItem value="St. Vincentianer">St. Vincentianer</MenuItem>
                    <MenuItem value="Antiguaner">Antiguaner</MenuItem>
                    <MenuItem value="Dominikaner (Commonwealth)">Dominikaner (Commonwealth)</MenuItem>
                    <MenuItem value="St. Kitts und Neviser">St. Kitts und Neviser</MenuItem>
                    <MenuItem value="Andere">Andere</MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel>{t('cv.personal.civilstatus')}</InputLabel>
                  <Select 
                    value={civilStatus} 
                    label={t('cv.personal.civilstatus')} 
                    onChange={e => handleCvDataChange(setCivilStatus, e.target.value)}
                  >
                    <MenuItem value="">{t('cv.personal.civilstatus.select')}</MenuItem>
                    <MenuItem value="ledig">{t('cv.personal.civilstatus.single')}</MenuItem>
                    <MenuItem value="verheiratet">{t('cv.personal.civilstatus.married')}</MenuItem>
                    <MenuItem value="geschieden">{t('cv.personal.civilstatus.divorced')}</MenuItem>
                    <MenuItem value="verwitwet">{t('cv.personal.civilstatus.widowed')}</MenuItem>
                    <MenuItem value="eingetragene-partnerschaft">{t('cv.personal.civilstatus.registered-partnership')}</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Box>

            {/* Optimiertes Kurzprofil - immer sichtbar */}
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6">
                Optimiertes Kurzprofil
              </Typography>
              <TextField
                multiline
                rows={4}
                key={`optimized-short-profile-${optimizedShortProfile || ''}`}
                defaultValue={optimizedShortProfile || ''}
                onBlur={(e) => {
                  const nextValue = e.target.value;
                  const currentValue = optimizedShortProfile || '';
                  if (nextValue !== currentValue) {
                    setOptimizedShortProfile(nextValue);
                  }
                }}
                fullWidth
                variant="outlined"
                placeholder="AI-optimiertes Kurzprofil wird hier angezeigt..."
                helperText={`Aktueller Wert: ${optimizedShortProfile ? optimizedShortProfile.substring(0, 50) + '...' : 'Leer'}`}
                sx={{
                  mb: 3,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                    backgroundColor: '#f8f9fa',
                    '& fieldset': {
                      borderColor: '#e0e0e0',
                    },
                    '&:hover fieldset': {
                      borderColor: '#bdbdbd',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#1976d2',
                    },
                  },
                }}
              />
            </Box>

            {/* Relevante Kernkompetenzen Tabelle - vereinfacht */}
            {relevantCoreCompetencies && (
              <Box sx={{ mt: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="h6">
                    {getTranslatedCvLabel('Relevante Kernkompetenzen')}
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowCoreCompetencySelector(true)}
                    startIcon={<AddIcon />}
                    sx={{
                      borderColor: '#10b981',
                      color: '#10b981',
                      '&:hover': {
                        borderColor: '#059669',
                        backgroundColor: '#f0fdf4'
                      }
                    }}
                  >
                    Kernkompetenz hinzufügen
                  </Button>
                </Box>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Kernkompetenz</TableCell>
                      <TableCell>Aktion</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {relevantCoreCompetencies.length > 0 ? (
                      relevantCoreCompetencies.map((comp, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <TextField
                              key={`legacy-rel-core-${index}-${comp.competency || ''}`}
                              defaultValue={comp.competency || ''}
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = comp.competency || '';
                                if (nextValue === currentValue) return;
                                const updatedCompetencies = [...relevantCoreCompetencies];
                                updatedCompetencies[index] = {
                                  ...updatedCompetencies[index],
                                  competency: nextValue
                                };
                                setRelevantCoreCompetencies(updatedCompetencies);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <IconButton
                              size="small"
                              onClick={() => handleDeleteRelevantCoreCompetency(index)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={2} sx={{ textAlign: 'center' }}>
                          Keine relevanten Kernkompetenzen für diese Stelle verfügbar
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Box>
            )}

            {/* Relevante Branchen Tabelle */}
            {relevantIndustries && relevantIndustries.length > 0 && (
              <Box sx={{ mt: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="h6">
                    Relevante Branchen
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowIndustrySelector(true)}
                    startIcon={<AddIcon />}
                    sx={{
                      borderColor: '#10b981',
                      color: '#10b981',
                      '&:hover': {
                        borderColor: '#059669',
                        backgroundColor: '#f0fdf4'
                      }
                    }}
                  >
                    Branche hinzufügen
                  </Button>
                </Box>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Branche</TableCell>
                      <TableCell>Jahre</TableCell>
                      <TableCell>Aktion</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {relevantIndustries.map((industry, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          <TextField
                            key={`legacy-rel-industry-${index}-${industry.industry || ''}`}
                            defaultValue={industry.industry || ''}
                            onBlur={(e) => {
                              const nextValue = e.target.value;
                              const currentValue = industry.industry || '';
                              if (nextValue === currentValue) return;
                              const updatedIndustries = [...relevantIndustries];
                              updatedIndustries[index] = {
                                ...updatedIndustries[index],
                                industry: nextValue
                              };
                              setRelevantIndustries(updatedIndustries);
                            }}
                            variant="standard"
                            size="small"
                            fullWidth
                            sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            key={`legacy-rel-industry-years-${index}-${industry.years || ''}`}
                            defaultValue={industry.years || ''}
                            onBlur={(e) => {
                              const nextValue = e.target.value;
                              const currentValue = industry.years || '';
                              if (nextValue === currentValue) return;
                              const updatedIndustries = [...relevantIndustries];
                              updatedIndustries[index] = {
                                ...updatedIndustries[index],
                                years: nextValue
                              };
                              setRelevantIndustries(updatedIndustries);
                            }}
                            variant="standard"
                            size="small"
                            fullWidth
                            sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                          />
                        </TableCell>
                        <TableCell>
                          <IconButton
                            size="small"
                            onClick={() => handleDeleteRelevantIndustry(index)}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            )}

            {/* Relevante Hobbys Tabelle */}
            <Box sx={{ mt: 4 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6">
                  Relevante Hobbys
                </Typography>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => setShowHobbySelector(true)}
                  startIcon={<AddIcon />}
                  sx={{
                    borderColor: '#10b981',
                    color: '#10b981',
                    '&:hover': {
                      borderColor: '#059669',
                      backgroundColor: '#f0fdf4'
                    }
                  }}
                >
                  Hobby hinzufügen
                </Button>
              </Box>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Hobby</TableCell>
                    <TableCell>Beschreibung</TableCell>
                    <TableCell>Aktion</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {relevantHobbies && relevantHobbies.length > 0 ? (
                    relevantHobbies.map((hobby, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          <TextField
                            key={`legacy-rel-hobby-${index}-${hobby.hobby || ''}`}
                            defaultValue={hobby.hobby || ''}
                            onBlur={(e) => {
                              const nextValue = e.target.value;
                              const currentValue = hobby.hobby || '';
                              if (nextValue === currentValue) return;
                              const updatedHobbies = [...relevantHobbies];
                              updatedHobbies[index] = {
                                ...updatedHobbies[index],
                                hobby: nextValue
                              };
                              setRelevantHobbies(normalizeHobbyList(updatedHobbies));
                            }}
                            variant="standard"
                            size="small"
                            fullWidth
                            sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            key={`legacy-rel-hobby-desc-${index}-${hobby.description || ''}`}
                            defaultValue={hobby.description || ''}
                            onBlur={(e) => {
                              const nextValue = e.target.value;
                              const currentValue = hobby.description || '';
                              if (nextValue === currentValue) return;
                              const updatedHobbies = [...relevantHobbies];
                              updatedHobbies[index] = {
                                ...updatedHobbies[index],
                                description: nextValue
                              };
                              setRelevantHobbies(normalizeHobbyList(updatedHobbies));
                            }}
                            variant="standard"
                            size="small"
                            fullWidth
                            sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                          />
                        </TableCell>
                        <TableCell>
                          <IconButton
                            size="small"
                            onClick={() => handleDeleteRelevantHobby(index)}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={3} sx={{ textAlign: 'center' }}>
                        Keine relevanten Hobbys für diese Stelle verfügbar
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Box>

            {/* Optimierte Berufserfahrungen Tabelle - nur relevante */}
            {optimizedWorkExperiences && (
              <Box sx={{ mt: 4 }}>
                <Typography variant="h6">
                  Optimierte Berufserfahrungen
                </Typography>
                {sortWorkExperiencesForDisplay(optimizedWorkExperiences.filter(exp => exp.relevant === true || exp.relevant === 'true')).length > 0 ? (
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Firma</TableCell>
                        <TableCell>Position</TableCell>
                        <TableCell>Start</TableCell>
                        <TableCell>Ende</TableCell>
                        <TableCell>Beschreibung</TableCell>
                        <TableCell>Aktion</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {sortWorkExperiencesForDisplay(optimizedWorkExperiences.filter(exp => exp.relevant === true || exp.relevant === 'true')).map((exp, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <TextField
                              key={`opt-rel-company-${index}-${exp.company || ''}`}
                              defaultValue={exp.company || ''}
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = exp.company || '';
                                if (nextValue === currentValue) return;
                                const updatedExperiences = [...optimizedWorkExperiences];
                                const originalIndex = optimizedWorkExperiences.findIndex(originalExp => originalExp === exp);
                                updatedExperiences[originalIndex] = {
                                  ...updatedExperiences[originalIndex],
                                  company: nextValue
                                };
                                setOptimizedWorkExperiences(updatedExperiences);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              key={`opt-rel-position-${index}-${exp.position || ''}`}
                              defaultValue={exp.position || ''}
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = exp.position || '';
                                if (nextValue === currentValue) return;
                                const updatedExperiences = [...optimizedWorkExperiences];
                                const originalIndex = optimizedWorkExperiences.findIndex(originalExp => originalExp === exp);
                                updatedExperiences[originalIndex] = {
                                  ...updatedExperiences[originalIndex],
                                  position: nextValue
                                };
                                setOptimizedWorkExperiences(updatedExperiences);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              key={`opt-rel-start-${index}-${exp.startDate || ''}`}
                              defaultValue={exp.startDate || ''}
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = exp.startDate || '';
                                if (nextValue === currentValue) return;
                                const updatedExperiences = [...optimizedWorkExperiences];
                                const originalIndex = optimizedWorkExperiences.findIndex(originalExp => originalExp === exp);
                                updatedExperiences[originalIndex] = {
                                  ...updatedExperiences[originalIndex],
                                  startDate: nextValue
                                };
                                setOptimizedWorkExperiences(updatedExperiences);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              key={`opt-rel-end-${index}-${exp.endDate || ''}`}
                              defaultValue={exp.endDate || ''}
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = exp.endDate || '';
                                if (nextValue === currentValue) return;
                                const updatedExperiences = [...optimizedWorkExperiences];
                                const originalIndex = optimizedWorkExperiences.findIndex(originalExp => originalExp === exp);
                                updatedExperiences[originalIndex] = {
                                  ...updatedExperiences[originalIndex],
                                  endDate: nextValue
                                };
                                setOptimizedWorkExperiences(updatedExperiences);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              key={`opt-rel-desc-${index}-${exp.description || ''}`}
                              defaultValue={exp.description || ''}
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = exp.description || '';
                                if (nextValue === currentValue) return;
                                const updatedExperiences = [...optimizedWorkExperiences];
                                const originalIndex = optimizedWorkExperiences.findIndex(originalExp => originalExp === exp);
                                updatedExperiences[originalIndex] = {
                                  ...updatedExperiences[originalIndex],
                                  description: nextValue
                                };
                                setOptimizedWorkExperiences(updatedExperiences);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <IconButton
                              size="small"
                              onClick={() => {
                                const updatedExperiences = optimizedWorkExperiences.filter((_, i) => i !== optimizedWorkExperiences.findIndex(originalExp => originalExp === exp));
                                setOptimizedWorkExperiences(updatedExperiences);
                              }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  <Box sx={{ textAlign: 'center', py: 4 }}>
                    Keine relevanten Arbeitserfahrungen verfügbar
                  </Box>
                )}
              </Box>
            )}

            {/* Nicht relevante Berufserfahrungen Tabelle */}
            {optimizedWorkExperiences && (
              <Box sx={{ mt: 4 }}>
                <Typography variant="h6">
                  Nicht relevante Berufserfahrung
                </Typography>
                {sortWorkExperiencesForDisplay(optimizedWorkExperiences.filter(exp => exp.relevant === false || exp.relevant === 'false')).length > 0 ? (
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Firma</TableCell>
                        <TableCell>Position</TableCell>
                        <TableCell>Start</TableCell>
                        <TableCell>Ende</TableCell>
                        <TableCell>Beschreibung</TableCell>
                        <TableCell>Aktion</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {sortWorkExperiencesForDisplay(optimizedWorkExperiences.filter(exp => exp.relevant === false || exp.relevant === 'false')).map((exp, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <TextField
                              key={`opt-nonrel-company-${index}-${exp.company || ''}`}
                              defaultValue={exp.company || ''}
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = exp.company || '';
                                if (nextValue === currentValue) return;
                                const updatedExperiences = [...optimizedWorkExperiences];
                                const originalIndex = optimizedWorkExperiences.findIndex(originalExp => originalExp === exp);
                                updatedExperiences[originalIndex] = {
                                  ...updatedExperiences[originalIndex],
                                  company: nextValue
                                };
                                setOptimizedWorkExperiences(updatedExperiences);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              key={`opt-nonrel-position-${index}-${exp.position || ''}`}
                              defaultValue={exp.position || ''}
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = exp.position || '';
                                if (nextValue === currentValue) return;
                                const updatedExperiences = [...optimizedWorkExperiences];
                                const originalIndex = optimizedWorkExperiences.findIndex(originalExp => originalExp === exp);
                                updatedExperiences[originalIndex] = {
                                  ...updatedExperiences[originalIndex],
                                  position: nextValue
                                };
                                setOptimizedWorkExperiences(updatedExperiences);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              key={`opt-nonrel-start-${index}-${exp.startDate || ''}`}
                              defaultValue={exp.startDate || ''}
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = exp.startDate || '';
                                if (nextValue === currentValue) return;
                                const updatedExperiences = [...optimizedWorkExperiences];
                                const originalIndex = optimizedWorkExperiences.findIndex(originalExp => originalExp === exp);
                                updatedExperiences[originalIndex] = {
                                  ...updatedExperiences[originalIndex],
                                  startDate: nextValue
                                };
                                setOptimizedWorkExperiences(updatedExperiences);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              key={`opt-nonrel-end-${index}-${exp.endDate || ''}`}
                              defaultValue={exp.endDate || ''}
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = exp.endDate || '';
                                if (nextValue === currentValue) return;
                                const updatedExperiences = [...optimizedWorkExperiences];
                                const originalIndex = optimizedWorkExperiences.findIndex(originalExp => originalExp === exp);
                                updatedExperiences[originalIndex] = {
                                  ...updatedExperiences[originalIndex],
                                  endDate: nextValue
                                };
                                setOptimizedWorkExperiences(updatedExperiences);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              key={`opt-nonrel-desc-${index}-${exp.description || ''}`}
                              defaultValue={exp.description || ''}
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = exp.description || '';
                                if (nextValue === currentValue) return;
                                const updatedExperiences = [...optimizedWorkExperiences];
                                const originalIndex = optimizedWorkExperiences.findIndex(originalExp => originalExp === exp);
                                updatedExperiences[originalIndex] = {
                                  ...updatedExperiences[originalIndex],
                                  description: nextValue
                                };
                                setOptimizedWorkExperiences(updatedExperiences);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <IconButton
                              size="small"
                              onClick={() => {
                                const updatedExperiences = optimizedWorkExperiences.filter((_, i) => i !== optimizedWorkExperiences.findIndex(originalExp => originalExp === exp));
                                setOptimizedWorkExperiences(updatedExperiences);
                              }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  <Box sx={{ textAlign: 'center', py: 4 }}>
                    Keine nicht relevanten Arbeitserfahrungen verfügbar
                  </Box>
                )}
              </Box>
            )}

            {/* Relevante Zertifizierungen Tabelle - vereinfacht */}
            {relevantCertifications && (
              <Box sx={{ mt: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="h6">
                    Relevante Zertifizierungen
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowCertificationSelector(true)}
                    startIcon={<AddIcon />}
                    sx={{
                      borderColor: '#10b981',
                      color: '#10b981',
                      '&:hover': {
                        borderColor: '#059669',
                        backgroundColor: '#f0fdf4'
                      }
                    }}
                  >
                    Zertifizierung hinzufügen
                  </Button>
                </Box>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Zertifizierung</TableCell>
                      <TableCell>Aussteller</TableCell>
                      <TableCell>Datum</TableCell>
                      <TableCell>Aktion</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {relevantCertifications.length > 0 ? (
                      relevantCertifications.map((cert, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <TextField
                              key={`legacy-rel-cert-name-${index}-${cert.name || ''}`}
                              defaultValue={cert.name || ''}
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = cert.name || '';
                                if (nextValue === currentValue) return;
                                const updatedCertifications = [...relevantCertifications];
                                updatedCertifications[index] = {
                                  ...updatedCertifications[index],
                                  name: nextValue
                                };
                                setRelevantCertifications(updatedCertifications);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              key={`legacy-rel-cert-issuer-${index}-${cert.issuer || ''}`}
                              defaultValue={cert.issuer || ''}
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = cert.issuer || '';
                                if (nextValue === currentValue) return;
                                const updatedCertifications = [...relevantCertifications];
                                updatedCertifications[index] = {
                                  ...updatedCertifications[index],
                                  issuer: nextValue
                                };
                                setRelevantCertifications(updatedCertifications);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              key={`legacy-rel-cert-date-${index}-${cert.date || ''}`}
                              defaultValue={cert.date || ''}
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = cert.date || '';
                                if (nextValue === currentValue) return;
                                const updatedCertifications = [...relevantCertifications];
                                updatedCertifications[index] = {
                                  ...updatedCertifications[index],
                                  date: nextValue
                                };
                                setRelevantCertifications(updatedCertifications);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <IconButton
                              size="small"
                              onClick={() => handleDeleteRelevantCertification(index)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={4} sx={{ textAlign: 'center' }}>
                          Keine relevanten Zertifizierungen für diese Stelle verfügbar
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Box>
            )}

            {/* IT-Kenntnisse Tabelle - vereinfacht */}
            {relevantItSkills && (
              <Box sx={{ mt: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="h6">
                    Relevante IT-Kenntnisse
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowItSkillSelector(true)}
                    startIcon={<AddIcon />}
                    sx={{
                      borderColor: '#10b981',
                      color: '#10b981',
                      '&:hover': {
                        borderColor: '#059669',
                        backgroundColor: '#f0fdf4'
                      }
                    }}
                  >
                    IT-Skill hinzufügen
                  </Button>
                </Box>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>IT-Skill</TableCell>
                      <TableCell>Niveau</TableCell>
                      <TableCell>Aktion</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {relevantItSkills.length > 0 ? (
                      relevantItSkills.map((skill, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <TextField
                              key={`legacy-rel-skill-${index}-${skill.skill || ''}`}
                              defaultValue={skill.skill || ''}
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = skill.skill || '';
                                if (nextValue === currentValue) return;
                                const updatedSkills = [...relevantItSkills];
                                updatedSkills[index] = {
                                  ...updatedSkills[index],
                                  skill: nextValue
                                };
                                setRelevantItSkills(updatedSkills);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <Select
                              value={skill.level || ''}
                              onChange={(e) => {
                                const updatedSkills = [...relevantItSkills];
                                updatedSkills[index] = {
                                  ...updatedSkills[index],
                                  level: e.target.value
                                };
                                setRelevantItSkills(updatedSkills);
                                markCvDataAsChanged();
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              displayEmpty
                              sx={{ fontSize: '0.875rem' }}
                            >
                              <MenuItem value="">{t('cv.it.skills.level.select')}</MenuItem>
                              <MenuItem value="beginner">{t('cv.it.skills.level.beginner')}</MenuItem>
                              <MenuItem value="intermediate">{t('cv.it.skills.level.intermediate')}</MenuItem>
                              <MenuItem value="professional">{t('cv.it.skills.level.professional')}</MenuItem>
                              <MenuItem value="expert">{t('cv.it.skills.level.expert')}</MenuItem>
                            </Select>
                          </TableCell>
                          <TableCell>
                            <IconButton
                              size="small"
                              onClick={() => handleDeleteRelevantItSkill(index)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} sx={{ textAlign: 'center' }}>
                          Keine relevanten IT-Kenntnisse für diese Stelle verfügbar
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Box>
            )}

            {/* Relevante Ausbildungen Tabelle - vereinfacht */}
            {relevantEducations && (
              <Box sx={{ mt: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="h6">
                    Relevante Ausbildungen
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowEducationSelector(true)}
                    startIcon={<AddIcon />}
                    sx={{
                      borderColor: '#10b981',
                      color: '#10b981',
                      '&:hover': {
                        borderColor: '#059669',
                        backgroundColor: '#f0fdf4'
                      }
                    }}
                  >
                    Ausbildung hinzufügen
                  </Button>
                </Box>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Institution</TableCell>
                      <TableCell>Abschluss</TableCell>
                      <TableCell>Startdatum</TableCell>
                      <TableCell>Enddatum</TableCell>
                      <TableCell>Aktion</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {relevantEducations.length > 0 ? (
                      relevantEducations.map((education, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <TextField
                              key={`legacy-rel-edu-inst-${index}-${education.institution || ''}`}
                              defaultValue={education.institution || ''}
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = education.institution || '';
                                if (nextValue === currentValue) return;
                                const updatedEducations = [...relevantEducations];
                                updatedEducations[index] = {
                                  ...updatedEducations[index],
                                  institution: nextValue
                                };
                                setRelevantEducations(updatedEducations);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              key={`legacy-rel-edu-degree-${index}-${education.degree || ''}`}
                              defaultValue={education.degree || ''}
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = education.degree || '';
                                if (nextValue === currentValue) return;
                                const updatedEducations = [...relevantEducations];
                                updatedEducations[index] = {
                                  ...updatedEducations[index],
                                  degree: nextValue
                                };
                                setRelevantEducations(updatedEducations);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              key={`legacy-rel-edu-start-${index}-${education.startDate || ''}`}
                              defaultValue={education.startDate || ''}
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = education.startDate || '';
                                if (nextValue === currentValue) return;
                                const updatedEducations = [...relevantEducations];
                                updatedEducations[index] = {
                                  ...updatedEducations[index],
                                  startDate: nextValue
                                };
                                setRelevantEducations(updatedEducations);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              key={`legacy-rel-edu-end-${index}-${education.endDate || ''}`}
                              defaultValue={education.endDate || ''}
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = education.endDate || '';
                                if (nextValue === currentValue) return;
                                const updatedEducations = [...relevantEducations];
                                updatedEducations[index] = {
                                  ...updatedEducations[index],
                                  endDate: nextValue
                                };
                                setRelevantEducations(updatedEducations);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <IconButton
                              size="small"
                              onClick={() => handleDeleteRelevantEducation(index)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={5} sx={{ textAlign: 'center' }}>
                          Keine relevanten Ausbildungen für diese Stelle verfügbar
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Box>
            )}

            {/* Relevante Sprachen Tabelle - vereinfacht */}
            {relevantLanguages !== null && (
              <Box sx={{ mt: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="h6">
                    Relevante Sprachen
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowLanguageSelector(true)}
                    startIcon={<AddIcon />}
                    sx={{
                      borderColor: '#10b981',
                      color: '#10b981',
                      '&:hover': {
                        borderColor: '#059669',
                        backgroundColor: '#f0fdf4'
                      }
                    }}
                  >
                    Sprache hinzufügen
                  </Button>
                </Box>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Sprache</TableCell>
                      <TableCell>Niveau</TableCell>
                      <TableCell>Aktion</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {relevantLanguages.length > 0 ? (
                      relevantLanguages.map((language, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <TextField
                              key={`legacy-rel-language-${index}-${language.language || ''}`}
                              defaultValue={language.language || ''}
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = language.language || '';
                                if (nextValue === currentValue) return;
                                const updatedLanguages = [...relevantLanguages];
                                updatedLanguages[index] = {
                                  ...updatedLanguages[index],
                                  language: nextValue
                                };
                                setRelevantLanguages(updatedLanguages);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <Select
                              value={language.level || ''}
                              onChange={(e) => {
                                const updatedLanguages = [...relevantLanguages];
                                updatedLanguages[index] = {
                                  ...updatedLanguages[index],
                                  level: e.target.value
                                };
                                setRelevantLanguages(updatedLanguages);
                                markCvDataAsChanged();
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              displayEmpty
                              sx={{ fontSize: '0.875rem' }}
                            >
                              <MenuItem value="">{t('cv.languages.level.select')}</MenuItem>
                              <MenuItem value="A1">{t('cv.languages.level.A1')}</MenuItem>
                              <MenuItem value="A2">{t('cv.languages.level.A2')}</MenuItem>
                              <MenuItem value="B1">{t('cv.languages.level.B1')}</MenuItem>
                              <MenuItem value="B2">{t('cv.languages.level.B2')}</MenuItem>
                              <MenuItem value="C1">{t('cv.languages.level.C1')}</MenuItem>
                              <MenuItem value="C2">{t('cv.languages.level.C2')}</MenuItem>
                              <MenuItem value="native">{t('cv.languages.level.native')}</MenuItem>
                            </Select>
                          </TableCell>
                          <TableCell>
                            <IconButton
                              size="small"
                              onClick={() => handleDeleteRelevantLanguage(index)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} sx={{ textAlign: 'center' }}>
                          Keine relevanten Sprachen für diese Stelle verfügbar
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Box>
            )}

            {/* Relevante weitere Informationen Tabelle - vereinfacht */}
            {relevantAdditionalInfo && (
              <Box sx={{ mt: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="h6">
                    Relevante weitere Angaben
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowAdditionalInfoSelector(true)}
                    startIcon={<AddIcon />}
                    sx={{
                      borderColor: '#10b981',
                      color: '#10b981',
                      '&:hover': {
                        borderColor: '#059669',
                        backgroundColor: '#f0fdf4'
                      }
                    }}
                  >
                    Information hinzufügen
                  </Button>
                </Box>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Kategorie</TableCell>
                      <TableCell>Beschreibung</TableCell>
                      <TableCell>Aktion</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {relevantAdditionalInfo.length > 0 ? (
                      relevantAdditionalInfo.map((info, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <TextField
                              key={`legacy-rel-add-info-${index}-${info.info || ''}`}
                              defaultValue={info.info || ''}
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = info.info || '';
                                if (nextValue === currentValue) return;
                                const updatedInfo = [...relevantAdditionalInfo];
                                updatedInfo[index] = {
                                  ...updatedInfo[index],
                                  info: nextValue
                                };
                                setRelevantAdditionalInfo(updatedInfo);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              key={`legacy-rel-add-details-${index}-${info.details || ''}`}
                              defaultValue={info.details || ''}
                              onBlur={(e) => {
                                const nextValue = e.target.value;
                                const currentValue = info.details || '';
                                if (nextValue === currentValue) return;
                                const updatedInfo = [...relevantAdditionalInfo];
                                updatedInfo[index] = {
                                  ...updatedInfo[index],
                                  details: nextValue
                                };
                                setRelevantAdditionalInfo(updatedInfo);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <IconButton
                              size="small"
                              onClick={() => handleDeleteRelevantAdditionalInfo(index)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} sx={{ textAlign: 'center' }}>
                          Keine relevanten weiteren Informationen für diese Stelle verfügbar
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Box>
            )}
          </>
        )}

        {/* Label für Prompt (Administrator) - innerhalb des Paper Containers */}
        {isAdmin() && (
          <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2, mt: 4 }}>
        <Typography variant="body2">Prompt (Administrator)</Typography>
        <IconButton 
          onClick={() => {
            const newHideState = !hidePromptData;
            setHidePromptData(newHideState);
          }}
          sx={{ 
            color: 'primary.main',
            '&:hover': { bgcolor: 'rgba(25, 118, 210, 0.1)' }
          }}
        >
          {hidePromptData ? <ExpandMoreIcon /> : <ExpandLessIcon />}
        </IconButton>
      </Box>

            {/* Prompt-Tabelle - minimierbar, innerhalb des Paper Containers */}
      {!hidePromptData && (
        <Box sx={{ mb: 3 }}>
          <TableContainer component={Paper} sx={{ maxHeight: 1600, overflow: 'auto' }}>
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', width: '20%' }}>Prompt-Typ</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', width: '10%' }}>Verwendung</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', width: '15%' }}>ChatGPT-Version</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', width: '10%' }}>Temperatur</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', width: '10%' }}>Max Tokens</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', width: '8%' }}>Aktionen</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortPrompts([...prompts])
                  .map((prompt, index) => (
                  <React.Fragment key={index}>
                    <TableRow hover>
                      <TableCell sx={{ fontWeight: 'bold', verticalAlign: 'top' }}>
                        {prompt.type}
                      </TableCell>
                      <TableCell sx={{ verticalAlign: 'top', textAlign: 'center' }}>
                        <Chip 
                          label={prompt.usage || 'N/A'} 
                          color={
                            prompt.usage === 'Extraktion' ? 'primary' : 
                            prompt.usage === 'Foto' ? 'success' :
                            prompt.usage === 'Check' ? 'warning' :
                            prompt.usage === 'Chatbot' ? 'info' :
                            'secondary'
                          }
                          size="small"
                          variant="outlined"
                        />
                      </TableCell>
                      <TableCell sx={{ verticalAlign: 'top', textAlign: 'center' }}>
                        {prompt.chatGptVersion || 'N/A'}
                      </TableCell>
                      <TableCell sx={{ verticalAlign: 'top', textAlign: 'center' }}>
                        {prompt.temperature || '0.0'}
                      </TableCell>
                      <TableCell sx={{ verticalAlign: 'top', textAlign: 'center' }}>
                        {prompt.maxTokens || '8000'}
                      </TableCell>
                      <TableCell sx={{ verticalAlign: 'top' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                          <IconButton
                            size="small"
                            color="primary"
                            onClick={() => {
                              // Verwende den Prompt-Namen direkt für Identifikation (nicht Index!)
                              const sortedPrompts = sortPrompts([...prompts]);
                              const updatedPrompt = sortedPrompts[index];
                              
                              if (!updatedPrompt) {
                                console.error('❌ Prompt nicht gefunden für Index:', index);
                                return;
                              }
                              
                              // Verwende den Prompt-Namen direkt, nicht den Index
                              setEditingPromptIndex(null); // Setze Index auf null, da wir den Namen verwenden
                              setEditingPromptText(updatedPrompt.text);
                              setEditingPromptVersion(updatedPrompt.chatGptVersion || 'gpt-4o');
                              setEditingPromptUsage(updatedPrompt.usage || 'Optimierung');
                              setEditingPromptTemperature(updatedPrompt.temperature || '0.0');
                              setEditingPromptMaxTokens(updatedPrompt.maxTokens || '8000');
                              setEditingPromptSystemRole(updatedPrompt.systemRole || 'Du bist ein Experte für CV-Optimierung.');
                              setEditingPromptName(updatedPrompt.type);
                              setOriginalPromptName(updatedPrompt.type); // Speichere den ursprünglichen Namen
                              setPromptEditorOpen(true);
                            }}
                            title="Bearbeiten"
                          >
                            <SettingsIcon />
                          </IconButton>

                        </Box>
                      </TableCell>
                    </TableRow>
                    

                  </React.Fragment>
            ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
          )}
        </>
      )}

      {/* Modal für Bildoptimierung */}
      <Modal
        open={showImageOptimizer}
        onClose={() => setShowImageOptimizer(false)}
        aria-labelledby="image-optimizer-modal"
        aria-describedby="image-optimizer-description"
        sx={{ zIndex: 1800 }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.25)'
          }
        }}
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: 800,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          maxHeight: '90vh',
          overflow: 'auto'
        }}>
          <Typography variant="h6" component="h2" gutterBottom>
            Optimierte Bildvarianten
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Hier sehen Sie Ihr Profilbild in verschiedenen optimierten Versionen:
          </Typography>
          
          <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: 3 }}>
            {optimizedImages.map((image) => (
              <Box key={image.id} sx={{ 
                border: '2px solid #e0e0e0', 
                borderRadius: 2, 
                p: 2,
                cursor: 'pointer',
                '&:hover': { borderColor: 'primary.main' }
              }} onClick={() => handleSelectOptimizedImage(image.image)}>
                <Box sx={{ position: 'relative' }}>
                  <img 
                    src={image.image} 
                    alt={image.name}
                    style={{ 
                      height: 200, 
                      objectFit: 'cover',
                      borderRadius: 8
                    }} 
                  />
                  {image.isOriginal && (
                    <Box sx={{
                      position: 'absolute',
                      top: 8,
                      right: 8,
                      backgroundColor: 'rgba(0,0,0,0.7)',
                      color: 'white',
                      px: 1,
                      py: 0.5,
                      borderRadius: 1,
                      fontSize: '0.75rem'
                    }}>
                      Ursprünglich
                    </Box>
                  )}
                  {image.isOptimized && (
                    <Box sx={{
                      position: 'absolute',
                      top: 8,
                      right: 8,
                      backgroundColor: 'rgba(76,175,80,0.9)',
                      color: 'white',
                      px: 1,
                      py: 0.5,
                      borderRadius: 1,
                      fontSize: '0.75rem'
                    }}>
                      Optimiert
                    </Box>
                  )}
                  {image.isMask && (
                    <Box sx={{
                      position: 'absolute',
                      top: 8,
                      right: 8,
                      backgroundColor: 'rgba(255,193,7,0.9)',
                      color: 'white',
                      px: 1,
                      py: 0.5,
                      borderRadius: 1,
                      fontSize: '0.75rem'
                    }}>
                      Maske
                    </Box>
                  )}
                </Box>
                <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
                  {image.name}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  {image.description}
                </Typography>
                {image.optimizationInstructions && (
                  <Box sx={{ 
                    backgroundColor: '#f5f5f5', 
                    p: 2, 
                    borderRadius: 1,
                    border: '1px solid #e0e0e0'
                  }}>
                    <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
                      Optimierungsanweisungen:
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {image.optimizationInstructions}
                    </Typography>
                  </Box>
                )}
              </Box>
            ))}
          </Box>
          
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
            <Button onClick={() => setShowImageOptimizer(false)}>
              Abbrechen
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Grafik-Upload-Modal */}
      <Dialog
        open={showImageUploadModal}
        onClose={() => {
          setShowImageUploadModal(false);
          setImageTypeToUpload(null);
        }}
        maxWidth="lg"
        fullWidth
        sx={{ zIndex: 1800 }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.25)'
          }
        }}
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          p: 3
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <ImageIcon sx={{ fontSize: 32, color: 'white' }} />
            <Typography variant="h5" sx={{ fontWeight: 700, color: 'white', textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              {imageTypeToUpload === 'header' 
                ? t('cv.image.upload.title.header')
                : t('cv.image.upload.title.column')}
            </Typography>
          </Box>
        </DialogTitle>
        
        <DialogContent sx={{ p: 4 }}>
          <Box sx={{ height: 40 }} /> {/* Zusätzlicher Abstand */}
          <Box sx={{ mb: 4 }}>
            <Alert severity="info" sx={{ mb: 3 }}>
              <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                {t('cv.image.upload.maxSize')}
              </Typography>
              <Typography variant="body2">
                {imageTypeToUpload === 'header' 
                  ? t('cv.image.upload.maxSize.header')
                  : t('cv.image.upload.maxSize.column')}
              </Typography>
              <Typography variant="body2" sx={{ mt: 1, fontSize: '0.875rem', color: '#666' }}>
                {t('cv.image.upload.info')}
              </Typography>
              <Typography variant="body2" sx={{ mt: 2, fontSize: '0.875rem', color: '#666', fontStyle: 'italic' }}>
                {t('cv.image.upload.alignment')}
              </Typography>
            </Alert>
            
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center' }}>
              <input
                id="imageUploadFile"
                type="file"
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (file) {
                    const reader = new FileReader();
                    reader.onload = (event) => {
                      const img = new Image();
                      img.onload = () => {
                        const maxWidth = imageTypeToUpload === 'header' ? 794 : 318;
                        const maxHeight = imageTypeToUpload === 'header' ? 228 : 1123;
                        
                        if (img.width > maxWidth || img.height > maxHeight) {
                          alert(t('cv.image.upload.error.tooLarge', {
                            maxWidth,
                            maxHeight,
                            width: img.width,
                            height: img.height
                          }));
                          e.target.value = ''; // Reset file input
                          return;
                        }
                        
                        // Bild setzen
                        if (imageTypeToUpload === 'header') {
                          setTopBoxImage(event.target?.result as string);
                        } else {
                          setLeftColumnImage(event.target?.result as string);
                        }
                        
                        // Modal schließen
                        setShowImageUploadModal(false);
                        setImageTypeToUpload(null);
                      };
                      img.src = event.target?.result as string;
                    };
                    reader.readAsDataURL(file);
                  }
                }}
                style={{ display: 'none' }}
              />
              <label htmlFor="imageUploadFile">
                <Button
                  variant="contained"
                  component="span"
                  startIcon={<CloudUploadIcon />}
                  size="large"
                  sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    textTransform: 'none',
                    fontSize: '1.05rem',
                    fontWeight: 600,
                    px: 4,
                    py: 1.5,
                    borderRadius: 2,
                    boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #5568d3 0%, #6a4091 100%)',
                      boxShadow: '0 6px 16px rgba(102, 126, 234, 0.4)',
                    },
                  }}
                >
                  {t('cv.image.upload.select')}
                </Button>
              </label>
            </Box>
          </Box>
        </DialogContent>
        
        <DialogActions sx={{ 
          p: 3, 
          bgcolor: 'rgba(0,0,0,0.02)', 
          justifyContent: 'space-between',
          borderTop: '1px solid',
          borderColor: 'divider'
        }}>
          <Button
            onClick={() => {
              setShowImageUploadModal(false);
              setImageTypeToUpload(null);
            }}
            sx={{
              color: 'text.secondary',
              textTransform: 'none',
              fontSize: '1rem',
              '&:hover': {
                bgcolor: 'rgba(0,0,0,0.05)'
              }
            }}
          >
            {t('common.cancel')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Tonalität Modal */}
      <Dialog
        open={showTonalityModal}
        onClose={closeTextSettingsModal}
        TransitionProps={{
          onExited: handleTextSettingsModalExited
        }}
        maxWidth="sm"
        fullWidth
        sx={{ zIndex: 1800 }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.25)'
          }
        }}
        PaperProps={{
          sx: { borderRadius: 3 }
        }}
      >
        <DialogTitle sx={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          py: 2
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              {getUiLanguageDictionaryLabel('Text Einstellungen')}
            </Typography>
            <IconButton onClick={closeTextSettingsModal} sx={{ color: 'white', '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' } }}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ pt: '24px !important', px: 4, pb: 3 }}>
          {[
            { key: 'formalitaet', left: 'Locker', right: 'Formell' },
            { key: 'selbstbewusstsein', left: 'Bescheiden', right: 'Selbstbewusst' },
            { key: 'kreativitaet', left: 'Sachlich', right: 'Kreativ' },
            { key: 'tonAktiv', left: 'Passiv', right: 'Aktiv' },
            { key: 'tonErgebnisorientiert', left: 'Beschreibend', right: 'Ergebnisorientiert' },
            { key: 'tonKompakt', left: 'Detail', right: 'Kompakt' },
          ].map(({ key, left, right }) => (
            <Box key={key} sx={{ mb: 3 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography variant="body2" sx={{ color: '#666', fontSize: '0.85rem' }}>
                  {getDictionaryLabel(left)}
                </Typography>
                <Typography variant="body2" sx={{ color: '#666', fontSize: '0.85rem' }}>
                  {getDictionaryLabel(right)}
                </Typography>
              </Box>
              <Slider
                value={tonalitySettings[key as keyof TonalitySectionSettings]}
                onChange={(_, val) => setTonalitySettings(prev => ({
                  ...prev,
                  [key]: val as number
                }))}
                min={0}
                max={100}
                sx={{
                  color: '#667eea',
                  '& .MuiSlider-thumb': {
                    width: 16,
                    height: 16,
                  },
                  '& .MuiSlider-track': {
                    opacity: 0.5
                  }
                }}
              />
            </Box>
          ))}
          <Box sx={{ mt: 2, display: 'grid', gap: 2 }}>
            <Box
              sx={{
                border: '1px solid',
                borderColor: '#e5e7eb',
                borderRadius: 2,
                p: 2,
                bgcolor: '#ffffff',
                boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
              }}
            >
              <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1.25, color: '#374151' }}>
                {getDictionaryLabel('Kurzprofil')}
              </Typography>
              <FormControl size="small" fullWidth>
                <InputLabel>{getDictionaryLabel('Textlänge')}</InputLabel>
                <Select
                  label={getDictionaryLabel('Textlänge')}
                  value={shortProfileTextLength}
                  onChange={(e) => setShortProfileTextLength(e.target.value as 'S' | 'M' | 'L')}
                  MenuProps={{
                    sx: { zIndex: 2200 }
                  }}
                  sx={{ bgcolor: '#fff' }}
                >
                  <MenuItem value="S">S</MenuItem>
                  <MenuItem value="M">M</MenuItem>
                  <MenuItem value="L">L</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box
              sx={{
                border: '1px solid',
                borderColor: '#e5e7eb',
                borderRadius: 2,
                p: 2,
                bgcolor: '#ffffff',
                boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
              }}
            >
              <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1.25, color: '#374151' }}>
                {getDictionaryLabel('Berufserfahrung')}
              </Typography>
              <FormControl size="small" fullWidth>
                <InputLabel>{getDictionaryLabel('Textlänge')}</InputLabel>
                <Select
                  label={getDictionaryLabel('Textlänge')}
                  value={workExperienceTextLength}
                  onChange={(e) => setWorkExperienceTextLength(e.target.value as 'S' | 'M' | 'L')}
                  MenuProps={{
                    sx: { zIndex: 2200 }
                  }}
                  sx={{ bgcolor: '#fff' }}
                >
                  <MenuItem value="S">S</MenuItem>
                  <MenuItem value="M">M</MenuItem>
                  <MenuItem value="L">L</MenuItem>
                </Select>
              </FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={tempShowBulletPointsInCv}
                    disabled={optimizing}
                    onChange={() => setTempShowBulletPointsInCv(!tempShowBulletPointsInCv)}
                    size="small"
                    disableRipple
                    disableFocusRipple
                    sx={{
                      mt: 0.5,
                      p: 1,
                      '&:hover': { backgroundColor: 'transparent' },
                      '& .MuiTouchRipple-root': { display: 'none' },
                      '& .MuiSvgIcon-root': {
                        borderRadius: '50%',
                      },
                      color: '#667eea',
                      '&.Mui-checked': {
                        color: '#667eea',
                      }
                    }}
                  />
                }
                label={getDictionaryLabel('Bullet Points')}
                sx={{ mt: 0.5, '& .MuiFormControlLabel-label': { fontSize: '0.85rem' } }}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={tempSortWorkExperienceByRelevance}
                    onChange={() => setTempSortWorkExperienceByRelevance(!tempSortWorkExperienceByRelevance)}
                    size="small"
                    disableRipple
                    disableFocusRipple
                    sx={{
                      mt: 0.5,
                      p: 1,
                      '&:hover': { backgroundColor: 'transparent' },
                      '& .MuiTouchRipple-root': { display: 'none' },
                      '& .MuiSvgIcon-root': {
                        borderRadius: '50%',
                      },
                      color: '#667eea',
                      '&.Mui-checked': {
                        color: '#667eea',
                      }
                    }}
                  />
                }
                label={getDictionaryLabel('Nach Relevanz sortieren')}
                sx={{ mt: 0.25, '& .MuiFormControlLabel-label': { fontSize: '0.85rem' } }}
              />
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Template Preview Dialog */}
      <Dialog
        open={showTemplatePreviewDialog}
        TransitionProps={{
          onEntered: () => {
            // Reflow erst nach abgeschlossenem Dialog-Enter triggern,
            // damit die Messung nicht gegen den Mount/Transition-Rahmen läuft.
            triggerTemplateReflowAfterApplicationPreviewOpen();
          }
        }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.25)' // Halbierte Opazität (Standard: 0.5)
          }
        }}
        onClose={() => { void closeTemplatePreviewDialog(); }}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            margin: '20px',
            borderRadius: 3,
            maxHeight: '95vh',
            height: '95vh',
            '@media print': {
              boxShadow: 'none',
              margin: '0px',
              maxWidth: 'none',
              height: '100%',
              minHeight: 'auto'
            }
          }
        }}
        sx={{
          zIndex: 1700,
          '@media print': {
            '& .MuiDialogTitle-root': {
              display: 'none'
            },
            '& .MuiDialogActions-root': {
              display: 'none'
            },
            '& button': {
              display: 'none !important'
            }
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          borderRadius: '12px 12px 0 0'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                {getTranslatedCvLabel('CV-Vorschau')}
              </Typography>
              <Tooltip title={getTranslatedCvLabel('Info anzeigen')} arrow>
                <IconButton
                  onClick={() => setMinimizedInfoBoxes(prev => ({ ...prev, cvTemplate: false }))}
                  sx={{
                    color: 'white',
                    p: 0.5,
                    '&:hover': {
                      bgcolor: 'rgba(255,255,255,0.1)'
                    }
                  }}
                >
                  <InfoOutlinedIcon sx={{ fontSize: 20 }} />
                </IconButton>
              </Tooltip>
            </Box>
            <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
              {/* Alle Rahmen Button - nur für Admin sichtbar */}
              {isAdmin() && (
                <Button
                  variant="outlined"
                  onClick={toggleAllBorders}
                  size="small"
                  sx={{ 
                    backgroundColor: (showCvBorder || showFrames) ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.1)',
                    color: 'white',
                    borderColor: 'rgba(255,255,255,0.3)',
                    fontSize: '0.65rem',
                    minWidth: 'auto',
                    px: 0.25,
                    py: 0.25,
                    whiteSpace: 'nowrap',
                    '&:hover': {
                      backgroundColor: (showCvBorder || showFrames) ? 'rgba(255,255,255,0.3)' : 'rgba(255,255,255,0.2)',
                      borderColor: 'rgba(255,255,255,0.5)'
                    }
                  }}
                >
                  {(showCvBorder || showFrames) ? 'Rahmen aus' : 'Rahmen an'}
                </Button>
              )}

              {/* Re-Optimierung Button */}
              <Tooltip
                title={getTranslatedCvLabel('CV neu optimieren') || 'CV neu optimieren'}
                arrow
                slotProps={{
                  popper: {
                    sx: { zIndex: 2100 }
                  }
                }}
              >
                <span>
                  <IconButton 
                    onClick={() => { void handleReOptimizeCv(); }}
                    disabled={optimizing}
                    size="small"
                    sx={{ 
                      color: 'white',
                      '&:hover': {
                        backgroundColor: 'rgba(255,255,255,0.1)'
                      },
                      '&.Mui-disabled': {
                        color: 'rgba(255,255,255,0.3)'
                      }
                    }}
                  >
                    {optimizing ? <CircularProgress size={18} sx={{ color: 'white' }} /> : <RefreshIcon fontSize="small" />}
                  </IconButton>
                </span>
              </Tooltip>

              {/* Refresh Button für Template-Rendering */}
              <IconButton 
                onClick={() => {
                  // Soft-Reflow statt Hard-Rebuild, um Toggle-Effekte bei Mehrfachklicks zu vermeiden.
                  window.dispatchEvent(new CustomEvent('refreshTemplate'));
                }}
                size="small"
                sx={{ 
                  color: 'white',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.1)'
                  }
                }}
                title="Template neu rendern"
              >
                <DescriptionIcon fontSize="small" />
              </IconButton>

              <IconButton
                onClick={handleDownloadCvPdf}
                disabled={downloadingPdf}
                size="small"
                sx={{ 
                  color: 'white',
                  border: '1px solid rgba(255,255,255,0.3)',
                  borderRadius: '4px',
                  padding: '2px',
                  minWidth: 'auto',
                  width: '28px',
                  height: '28px',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    borderColor: 'rgba(255,255,255,0.5)'
                  },
                  '&:disabled': {
                    color: 'rgba(255,255,255,0.5)',
                    borderColor: 'rgba(255,255,255,0.2)'
                  }
                }}
                title="CV als PDF herunterladen / aktualisieren"
              >
                {downloadingPdf ? (
                  <CircularProgress 
                    size={20} 
                    sx={{ 
                      color: 'white' // Weiß für bessere Sichtbarkeit auf Gradient-Hintergrund
                    }} 
                  />
                ) : (
                  <DownloadIcon />
                )}
              </IconButton>
                  <IconButton 
                    onClick={() => { void closeTemplatePreviewDialog(); }} 
                    disabled={downloadingPdf}
                    size="small"
                    sx={{ 
                      color: 'white',
                      minWidth: 'auto',
                      padding: '2px',
                      width: '28px',
                      height: '28px',
                      '&:hover': { 
                        bgcolor: 'rgba(255,255,255,0.1)'
                      }
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
            </Box>
          </Box>
        </DialogTitle>
        
        {/* Info-Textfeld oberhalb der CV Template Tabs - nur anzeigen wenn nicht minimiert */}
        {!minimizedInfoBoxes['cvTemplate'] && (
          <Box sx={{ px: 2, py: 1 }}>
            <Alert 
              severity="info" 
              sx={{ 
                borderRadius: 2,
                backgroundColor: '#f0f7ff',
                border: '1px solid #b3d9ff',
                '& .MuiAlert-icon': {
                  color: '#1976d2'
                }
              }}
              action={
                <IconButton size="small" onClick={() => setMinimizedInfoBoxes(prev => ({ ...prev, cvTemplate: true }))}>
                  <CloseIcon fontSize="small" sx={{ color: '#1976d2' }} />
                </IconButton>
              }
            >
              <Typography variant="body2" sx={{ color: '#1976d2', fontWeight: 500 }}>
                {getTranslatedCvLabel('Hier kannst du dir deinen CV in 3 verschiedenen Designs anzeigen lassen. Wähle ein Design aus und lies die Texte sorgfältig durch. Wenn du etwas ändern willst, klicke auf das entsprechende Element. Die Einstellungen findest du links neben der CV-Vorschau. Willst du den CV herunterladen, klicke auf das Download Icon oben rechts.')}
              </Typography>
            </Alert>
          </Box>
        )}
        
        {/* Template-Tabs */}
        <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
          <Tabs 
            value={selectedTemplateId} 
            onChange={(_, newValue) => handleTemplateChange(newValue)}
            variant="fullWidth"
            sx={{
              '& .MuiTab-root': {
                minHeight: 48,
                textTransform: 'none',
                fontWeight: 500
              }
            }}
          >
            <Tab 
              label={getTranslatedCvLabel('Modern')} 
              value="template1"
              sx={{ 
                color: selectedTemplateId === 'template1' ? '#667eea' : '#666',
                '&.Mui-selected': { color: '#667eea' }
              }}
            />
            <Tab 
              label={getTranslatedCvLabel('Professional')} 
              value="template2"
              sx={{ 
                color: selectedTemplateId === 'template2' ? '#667eea' : '#666',
                '&.Mui-selected': { color: '#667eea' }
              }}
            />
            <Tab 
              label={getTranslatedCvLabel('Classic')} 
              value="template3"
              sx={{ 
                color: selectedTemplateId === 'template3' ? '#667eea' : '#666',
                '&.Mui-selected': { color: '#667eea' }
              }}
            />
          </Tabs>
        </Box>
        
        <DialogContent sx={{ 
          padding: '20px',
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflow: 'hidden',
          '@media print': {
            padding: '0px',
            '& .MuiDialogTitle-root': {
              display: 'none'
            },
            '& .MuiDialogActions-root': {
              display: 'none'
            },
            '& button': {
              display: 'none !important'
            }
          }
        }}>
          {/* Settings und CV Preview in zwei Spalten */}
          <Box sx={{ 
            display: 'flex', 
            gap: 2, 
            flex: 1,
            minHeight: 0,
            '@media (max-width: 800px)': {
              flexDirection: 'column',
              height: 'auto'
            }
          }}>
            {/* Settings Panel links */}
            <Box sx={{ 
              width: '220px', 
              minWidth: '220px',
              borderRight: '1px solid #e0e0e0',
              pr: 2,
              overflowY: 'auto',
              maxHeight: '100%',
              '& .MuiFormControlLabel-root': { 
                mb: 0.125,
                '&:last-child': { mb: 0 }
              },
              '@media (max-width: 800px)': {
                width: '100%',
                minWidth: 'auto',
                borderRight: 'none',
                borderBottom: '1px solid #e0e0e0',
                pr: 0,
                pb: 2,
                maxHeight: '300px'
              }
            }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mb: 2 }}>
                <Typography variant="h6" sx={{ color: '#333', fontWeight: 600 }}>
                  {getTranslatedCvLabel('CV-Einstellungen')}
                </Typography>
                <Box sx={{ display: 'flex', gap: 0.5 }}>
                  <IconButton
                    onClick={async () => {
                      // Toggle zurücksetzen, damit jeder Save-Klick als neues Abschluss-Event erfasst wird
                      setCvTemplateSettingsSaved(false);
                      if (user?.uid) {
                        try {
                          // Speichere auf Account-Ebene
                          await saveCvDesignSettings();

                          // Speichere zusätzlich auf CV-Ebene, damit Template-Wechsel
                          // sofort die neuesten Einstellungen aus loadCvSettings lädt.
                          if (selectedCvId) {
                            const currentSettings = getCurrentCvSettings();
                            await saveCvSettings(selectedCvId, currentSettings);
                          }
                          
                          setHasUnsavedCvSettings(false);
                          setCvTemplateSettingsSaved(true);
                          setError('✅ Einstellungen gespeichert!');
                          setTimeout(() => setError(null), 2000);
                        } catch (error) {
                          console.error('❌ Fehler beim Speichern der CV-Settings:', error);
                          setError('❌ Fehler beim Speichern');
                          setTimeout(() => setError(null), 3000);
                        }
                      }
                    }}
                    disabled={!hasUnsavedCvSettings}
                    size="small"
                    sx={{ 
                      color: hasUnsavedCvSettings ? '#667eea' : 'rgba(102, 102, 102, 0.3)',
                      '&:hover': {
                        backgroundColor: hasUnsavedCvSettings ? 'rgba(102, 126, 234, 0.1)' : 'transparent',
                        color: hasUnsavedCvSettings ? '#5a6fd6' : 'rgba(102, 102, 102, 0.3)'
                      }
                    }}
                    title="Einstellungen speichern"
                  >
                    <SaveOutlinedIcon />
                  </IconButton>
                  <IconButton
                    onClick={handleResetDesign}
                    size="small"
                    sx={{ 
                      color: '#666',
                      '&:hover': {
                        backgroundColor: 'rgba(102, 102, 102, 0.1)',
                        color: '#333'
                      }
                    }}
                    title="Reset Design"
                  >
                    <RestoreIcon />
                  </IconButton>
                </Box>
              </Box>
              
              {/* Grafik-Einstellungen */}
              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle2" sx={{ mb: 1, color: '#666', fontWeight: 600 }}>
                  {getTranslatedCvLabel('Grafik')}
                </Typography>
                <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 1, p: 1, backgroundColor: '#fafafa', mt: 0.5 }}>
                {/* Header-Bild-Einstellungen */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                  <Typography variant="body2" sx={{ color: '#666', fontSize: '0.7rem', minWidth: '60px' }}>
                    {getTranslatedCvLabel('Header')}:
                  </Typography>
                  {!topBoxImage ? (
                    <button
                      onClick={() => {
                        setImageTypeToUpload('header');
                        setShowImageUploadModal(true);
                      }}
                      style={{
                        flex: 1,
                        padding: '4px 8px',
                        border: '1px solid #ccc',
                        borderRadius: '3px',
                        backgroundColor: '#f5f5f5',
                        cursor: 'pointer',
                        fontSize: '0.7rem',
                        textAlign: 'center'
                      }}
                    >
                      {getTranslatedCvLabel('Datei wählen')}
                    </button>
                  ) : (
                    <button
                      onClick={() => setTopBoxImage('')}
                      style={{
                        flex: 1,
                        padding: '4px 8px',
                        fontSize: '0.7rem',
                        border: '1px solid #ccc',
                        borderRadius: '3px',
                        backgroundColor: '#f5f5f5',
                        cursor: 'pointer',
                        color: '#d32f2f'
                      }}
                    >
                      {getTranslatedCvLabel('Entfernen')}
                    </button>
                  )}
                </Box>
                
                {/* Linke Spalte Bild-Einstellungen */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                  <Typography variant="body2" sx={{ color: '#666', fontSize: '0.7rem', minWidth: '60px' }}>
                    {getTranslatedCvLabel('Spalte:')}
                  </Typography>
                  {!leftColumnImage ? (
                    <button
                      onClick={() => {
                        setImageTypeToUpload('column');
                        setShowImageUploadModal(true);
                      }}
                      style={{
                        flex: 1,
                        padding: '4px 8px',
                        border: '1px solid #ccc',
                        borderRadius: '3px',
                        backgroundColor: '#f5f5f5',
                        cursor: 'pointer',
                        fontSize: '0.7rem',
                        textAlign: 'center'
                      }}
                    >
                      {getTranslatedCvLabel('Datei wählen')}
                    </button>
                  ) : (
                    <button
                      onClick={() => setLeftColumnImage('')}
                      style={{
                        flex: 1,
                        padding: '4px 8px',
                        fontSize: '0.7rem',
                        border: '1px solid #ccc',
                        borderRadius: '3px',
                        backgroundColor: '#f5f5f5',
                        cursor: 'pointer',
                        color: '#d32f2f'
                      }}
                    >
                      {getTranslatedCvLabel('Entfernen')}
                    </button>
                  )}
                </Box>
                </Box>
              </Box>
              
              {/* Design-Einstellungen */}
              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle2" sx={{ mb: 1, color: '#666', fontWeight: 600 }}>
                  {getTranslatedCvLabel('Design')}
                </Typography>
                
                {/* Wrapper für alle Farb-Picker */}
                <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 1, p: 1, backgroundColor: '#fafafa', mt: 0.5, mb: 1 }}>
                  <Box sx={{ mb: 1 }}>
                  <Typography variant="body2" sx={{ mb: 0.5, color: '#666', fontSize: '0.75rem' }}>
                    {getTranslatedCvLabel('Farben')}
                  </Typography>
                  
                  {/* Header Farbe */}
                  <Box sx={{ mb: 0.5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                      <button
                        onClick={() => handleColorPickerClick('header')}
                        style={{
                          width: '20px',
                          height: '20px',
                          border: '1px solid #ccc',
                          borderRadius: '50%',
                          cursor: 'pointer',
                          backgroundColor: topBoxColor,
                          padding: 0
                        }}
                      />
                      <Typography variant="body2" sx={{ color: '#666', fontSize: '0.7rem' }}>
                        {getTranslatedCvLabel('Header')}
                      </Typography>
                    </Box>
                  </Box>
                  
                  {/* Spaltenfarbe */}
                  <Box sx={{ mb: 0.5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                      <button
                        onClick={() => handleColorPickerClick('column')}
                        style={{
                          width: '20px',
                          height: '20px',
                          border: '1px solid #ccc',
                          borderRadius: '50%',
                          cursor: 'pointer',
                          backgroundColor: leftColumnColor,
                          padding: 0
                        }}
                      />
                      <Typography variant="body2" sx={{ color: '#666', fontSize: '0.7rem' }}>
                        {getTranslatedCvLabel('Spalte')}
                      </Typography>
                    </Box>
                  </Box>
                  
                  {/* Name Text Color */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                    <button
                      onClick={() => handleColorPickerClick('name')}
                      style={{
                        width: '20px',
                        height: '20px',
                        border: '1px solid #ccc',
                        borderRadius: '50%',
                        cursor: 'pointer',
                        backgroundColor: nameTextColor,
                        padding: 0
                      }}
                    />
                    <Typography variant="body2" sx={{ color: '#666', fontSize: '0.7rem' }}>
                      {getTranslatedCvLabel('Name')}
                    </Typography>
                  </Box>
                  
                  {/* Left Column Title Color */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                    <button
                      onClick={() => handleColorPickerClick('leftTitle')}
                      style={{
                        width: '20px',
                        height: '20px',
                        border: '1px solid #ccc',
                        borderRadius: '50%',
                        cursor: 'pointer',
                        backgroundColor: leftColumnTitleColor,
                        padding: 0
                      }}
                    />
                    <Typography variant="body2" sx={{ color: '#666', fontSize: '0.7rem' }}>
                      {getTranslatedCvLabel('Titel links')}
                    </Typography>
                  </Box>
                  
                  {/* Left Column Text Color */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                    <button
                      onClick={() => handleColorPickerClick('leftText')}
                      style={{
                        width: '20px',
                        height: '20px',
                        border: '1px solid #ccc',
                        borderRadius: '50%',
                        cursor: 'pointer',
                        backgroundColor: leftColumnTextColor,
                        padding: 0
                      }}
                    />
                    <Typography variant="body2" sx={{ color: '#666', fontSize: '0.7rem' }}>
                      {getTranslatedCvLabel('Text links')}
                    </Typography>
                  </Box>
                </Box>
                  
                  {/* Right Column Title Color */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                    <button
                      onClick={() => handleColorPickerClick('rightTitle')}
                      style={{
                        width: '20px',
                        height: '20px',
                        border: '1px solid #ccc',
                        borderRadius: '50%',
                        cursor: 'pointer',
                        backgroundColor: rightColumnTitleColor,
                        padding: 0
                      }}
                    />
                    <Typography variant="body2" sx={{ color: '#666', fontSize: '0.7rem' }}>
                      {getTranslatedCvLabel('Titel rechts')}
                    </Typography>
                  </Box>
                  
                  {/* Right Column Text Color */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                    <button
                      onClick={() => handleColorPickerClick('rightText')}
                      style={{
                        width: '20px',
                        height: '20px',
                        border: '1px solid #ccc',
                        borderRadius: '50%',
                        cursor: 'pointer',
                        backgroundColor: rightColumnTextColor,
                        padding: 0
                      }}
                    />
                    <Typography variant="body2" sx={{ color: '#666', fontSize: '0.7rem' }}>
                      {getTranslatedCvLabel('Text rechts')}
                    </Typography>
                  </Box>
                
                  {/* Schriftarten-Auswahl */}
                  <Box sx={{ mt: 1.5 }}>
                  <Typography variant="body2" sx={{ mb: 0.5, color: '#666', fontSize: '0.75rem' }}>
                    {getTranslatedCvLabel('Schriftarten')}
                  </Typography>
                    <Typography variant="body2" sx={{ color: '#666', fontSize: '0.7rem', mb: 0.5 }}>
                      {getTranslatedCvLabel('Titel-Schrift')}
                    </Typography>
                    <Select
                      value={titleFont}
                      onChange={(e) => {
                        setTitleFont(e.target.value);
                        window.dispatchEvent(new CustomEvent('refreshTemplate'));
                      }}
                      MenuProps={{
                        sx: { zIndex: 2200 }
                      }}
                      size="small"
                      fullWidth
                      sx={{ 
                        fontSize: '0.75rem', 
                        mb: 1,
                        '& .MuiSelect-select': { 
                          fontFamily: titleFont,
                          py: 0.5 
                        }
                      }}
                    >
                      <MenuItem value='"Times New Roman", Times, serif' sx={{ fontFamily: '"Times New Roman", Times, serif' }}>Times New Roman</MenuItem>
                      <MenuItem value='Georgia, serif' sx={{ fontFamily: 'Georgia, serif' }}>Georgia</MenuItem>
                      <MenuItem value='"Palatino Linotype", "Book Antiqua", Palatino, serif' sx={{ fontFamily: '"Palatino Linotype", "Book Antiqua", Palatino, serif' }}>Palatino</MenuItem>
                      <MenuItem value='Cambria, serif' sx={{ fontFamily: 'Cambria, serif' }}>Cambria</MenuItem>
                      <MenuItem value='"Garamond", "EB Garamond", serif' sx={{ fontFamily: '"Garamond", "EB Garamond", serif' }}>Garamond</MenuItem>
                      <MenuItem value='Arial, Helvetica, sans-serif' sx={{ fontFamily: 'Arial, Helvetica, sans-serif' }}>Arial</MenuItem>
                      <MenuItem value='"Segoe UI", Tahoma, Geneva, sans-serif' sx={{ fontFamily: '"Segoe UI", Tahoma, Geneva, sans-serif' }}>Segoe UI</MenuItem>
                      <MenuItem value='Verdana, Geneva, sans-serif' sx={{ fontFamily: 'Verdana, Geneva, sans-serif' }}>Verdana</MenuItem>
                      <MenuItem value='"Trebuchet MS", Helvetica, sans-serif' sx={{ fontFamily: '"Trebuchet MS", Helvetica, sans-serif' }}>Trebuchet MS</MenuItem>
                      <MenuItem value='Calibri, "Gill Sans", sans-serif' sx={{ fontFamily: 'Calibri, "Gill Sans", sans-serif' }}>Calibri</MenuItem>
                      <MenuItem value='"Roboto", sans-serif' sx={{ fontFamily: '"Roboto", sans-serif' }}>Roboto</MenuItem>
                      <MenuItem value='"Open Sans", sans-serif' sx={{ fontFamily: '"Open Sans", sans-serif' }}>Open Sans</MenuItem>
                      <MenuItem value='"Lato", sans-serif' sx={{ fontFamily: '"Lato", sans-serif' }}>Lato</MenuItem>
                      <MenuItem value='"Montserrat", sans-serif' sx={{ fontFamily: '"Montserrat", sans-serif' }}>Montserrat</MenuItem>
                      <MenuItem value='"Playfair Display", serif' sx={{ fontFamily: '"Playfair Display", serif' }}>Playfair Display</MenuItem>
                    </Select>
                    
                    <Typography variant="body2" sx={{ color: '#666', fontSize: '0.7rem', mb: 0.5 }}>
                      {getTranslatedCvLabel('Text-Schrift')}
                    </Typography>
                    <Select
                      value={bodyFont}
                      onChange={(e) => {
                        setBodyFont(e.target.value);
                        window.dispatchEvent(new CustomEvent('refreshTemplate'));
                      }}
                      MenuProps={{
                        sx: { zIndex: 2200 }
                      }}
                      size="small"
                      fullWidth
                      sx={{ 
                        fontSize: '0.75rem',
                        '& .MuiSelect-select': { 
                          fontFamily: bodyFont,
                          py: 0.5
                        }
                      }}
                    >
                      <MenuItem value='Arial, sans-serif' sx={{ fontFamily: 'Arial, sans-serif' }}>Arial</MenuItem>
                      <MenuItem value='Arial, Helvetica, sans-serif' sx={{ fontFamily: 'Arial, Helvetica, sans-serif' }}>Arial / Helvetica</MenuItem>
                      <MenuItem value='"Segoe UI", Tahoma, Geneva, sans-serif' sx={{ fontFamily: '"Segoe UI", Tahoma, Geneva, sans-serif' }}>Segoe UI</MenuItem>
                      <MenuItem value='Verdana, Geneva, sans-serif' sx={{ fontFamily: 'Verdana, Geneva, sans-serif' }}>Verdana</MenuItem>
                      <MenuItem value='Tahoma, Geneva, sans-serif' sx={{ fontFamily: 'Tahoma, Geneva, sans-serif' }}>Tahoma</MenuItem>
                      <MenuItem value='"Trebuchet MS", Helvetica, sans-serif' sx={{ fontFamily: '"Trebuchet MS", Helvetica, sans-serif' }}>Trebuchet MS</MenuItem>
                      <MenuItem value='Calibri, "Gill Sans", sans-serif' sx={{ fontFamily: 'Calibri, "Gill Sans", sans-serif' }}>Calibri</MenuItem>
                      <MenuItem value='"Times New Roman", Times, serif' sx={{ fontFamily: '"Times New Roman", Times, serif' }}>Times New Roman</MenuItem>
                      <MenuItem value='Georgia, serif' sx={{ fontFamily: 'Georgia, serif' }}>Georgia</MenuItem>
                      <MenuItem value='"Roboto", sans-serif' sx={{ fontFamily: '"Roboto", sans-serif' }}>Roboto</MenuItem>
                      <MenuItem value='"Open Sans", sans-serif' sx={{ fontFamily: '"Open Sans", sans-serif' }}>Open Sans</MenuItem>
                      <MenuItem value='"Lato", sans-serif' sx={{ fontFamily: '"Lato", sans-serif' }}>Lato</MenuItem>
                      <MenuItem value='"Montserrat", sans-serif' sx={{ fontFamily: '"Montserrat", sans-serif' }}>Montserrat</MenuItem>
                      <MenuItem value='"Source Sans Pro", sans-serif' sx={{ fontFamily: '"Source Sans Pro", sans-serif' }}>Source Sans Pro</MenuItem>
                    </Select>
                  </Box>
                </Box>
                  
                  <Typography variant="subtitle2" sx={{ mb: 1, color: '#666', fontWeight: 600, mt: 2 }}>
                    {getTranslatedCvLabel('Sichtbarkeit')}
                  </Typography>
                
                <Box sx={{ pl: 3, border: '1px solid #e0e0e0', borderRadius: 1, p: 1, backgroundColor: '#fafafa' }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={showProfileImageInCv}
                      onChange={() => {
                        setShowProfileImageInCv(!showProfileImageInCv);
                        window.dispatchEvent(new CustomEvent('refreshTemplate'));
                      }}
                      size="small"
                      disableRipple
                      disableFocusRipple
                      sx={{
                        p: 1,
                        '&:hover': { backgroundColor: 'transparent' },
                        '& .MuiTouchRipple-root': { display: 'none' },
                        '& .MuiSvgIcon-root': { 
                          borderRadius: '50%',
                        },
                        color: '#667eea',
                        '&.Mui-checked': {
                          color: '#667eea',
                        }
                      }}
                    />
                  }
                  label={getTranslatedCvLabel('Profilbild')}
                  sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                />
                
                  <FormControlLabel
                  control={
                    <Checkbox
                      checked={showContactInCv}
                      onChange={() => {
                        setShowContactInCv(!showContactInCv);
                        window.dispatchEvent(new CustomEvent('refreshTemplate'));
                      }}
                      size="small"
                      disableRipple
                      disableFocusRipple
                      sx={{
                        p: 1,
                        '&:hover': { backgroundColor: 'transparent' },
                        '& .MuiTouchRipple-root': { display: 'none' },
                        '& .MuiSvgIcon-root': { 
                          borderRadius: '50%',
                        },
                        color: '#667eea',
                        '&.Mui-checked': {
                          color: '#667eea',
                        }
                      }}
                    />
                  }
                  label={getTranslatedCvLabel('Kontakt')}
                  sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                />
                
                  <FormControlLabel
                  control={
                    <Checkbox
                      checked={showProfileInCv}
                      onChange={() => {
                        setShowProfileInCv(!showProfileInCv);
                        window.dispatchEvent(new CustomEvent('refreshTemplate'));
                      }}
                      size="small"
                      disableRipple
                      disableFocusRipple
                      sx={{
                        p: 1,
                        '&:hover': { backgroundColor: 'transparent' },
                        '& .MuiTouchRipple-root': { display: 'none' },
                        '& .MuiSvgIcon-root': { 
                          borderRadius: '50%',
                        },
                        color: '#667eea',
                        '&.Mui-checked': {
                          color: '#667eea',
                        }
                      }}
                    />
                  }
                  label={getTranslatedCvLabel('Kurzprofil')}
                  sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                />
                
                  <FormControlLabel
                  control={
                    <Checkbox
                      checked={showCoreCompetenciesInCv}
                      onChange={() => {
                        setShowCoreCompetenciesInCv(!showCoreCompetenciesInCv);
                        window.dispatchEvent(new CustomEvent('refreshTemplate'));
                      }}
                      size="small"
                      disableRipple
                      disableFocusRipple
                      sx={{
                        p: 1,
                        '&:hover': { backgroundColor: 'transparent' },
                        '& .MuiTouchRipple-root': { display: 'none' },
                        '& .MuiSvgIcon-root': { 
                          borderRadius: '50%',
                        },
                        color: '#667eea',
                        '&.Mui-checked': {
                          color: '#667eea',
                        }
                      }}
                    />
                  }
                  label={getTranslatedCvLabel('Kernkompetenzen')}
                  sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                />
                
                  <FormControlLabel
                  control={
                    <Checkbox
                      checked={showEducationInCv}
                      onChange={() => {
                        setShowEducationInCv(!showEducationInCv);
                        window.dispatchEvent(new CustomEvent('refreshTemplate'));
                      }}
                      size="small"
                      disableRipple
                      disableFocusRipple
                      sx={{
                        p: 1,
                        '&:hover': { backgroundColor: 'transparent' },
                        '& .MuiTouchRipple-root': { display: 'none' },
                        '& .MuiSvgIcon-root': { 
                          borderRadius: '50%',
                        },
                        color: '#667eea',
                        '&.Mui-checked': {
                          color: '#667eea',
                        }
                      }}
                    />
                  }
                  label={getTranslatedCvLabel('Ausbildung')}
                  sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                />
                
                  <FormControlLabel
                  control={
                    <Checkbox
                      checked={showCertificationsInCv}
                      onChange={() => {
                        setShowCertificationsInCv(!showCertificationsInCv);
                        window.dispatchEvent(new CustomEvent('refreshTemplate'));
                      }}
                      size="small"
                      disableRipple
                      disableFocusRipple
                      sx={{
                        p: 1,
                        '&:hover': { backgroundColor: 'transparent' },
                        '& .MuiTouchRipple-root': { display: 'none' },
                        '& .MuiSvgIcon-root': { 
                          borderRadius: '50%',
                        },
                        color: '#667eea',
                        '&.Mui-checked': {
                          color: '#667eea',
                        }
                      }}
                    />
                  }
                  label={getTranslatedCvLabel('Zertifizierungen')}
                  sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                />
                
                  <FormControlLabel
                  control={
                    <Checkbox
                      checked={showItSkillsInCv}
                      onChange={() => {
                        setShowItSkillsInCv(!showItSkillsInCv);
                        window.dispatchEvent(new CustomEvent('refreshTemplate'));
                      }}
                      size="small"
                      disableRipple
                      disableFocusRipple
                      sx={{
                        p: 1,
                        '&:hover': { backgroundColor: 'transparent' },
                        '& .MuiTouchRipple-root': { display: 'none' },
                        '& .MuiSvgIcon-root': { 
                          borderRadius: '50%',
                        },
                        color: '#667eea',
                        '&.Mui-checked': {
                          color: '#667eea',
                        }
                      }}
                    />
                  }
                  label={getTranslatedCvLabel('IT-Skills')}
                  sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                />
                
                  <FormControlLabel
                  control={
                    <Checkbox
                      checked={showIndustriesInCv}
                      onChange={() => {
                        setShowIndustriesInCv(!showIndustriesInCv);
                        window.dispatchEvent(new CustomEvent('refreshTemplate'));
                      }}
                      size="small"
                      disableRipple
                      disableFocusRipple
                      sx={{
                        p: 1,
                        '&:hover': { backgroundColor: 'transparent' },
                        '& .MuiTouchRipple-root': { display: 'none' },
                        '& .MuiSvgIcon-root': { 
                          borderRadius: '50%',
                        },
                        color: '#667eea',
                        '&.Mui-checked': {
                          color: '#667eea',
                        }
                      }}
                    />
                  }
                  label={getTranslatedCvLabel('Branchen')}
                  sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                />
                
                  <FormControlLabel
                  control={
                    <Checkbox
                      checked={showLanguagesInCv}
                      onChange={() => {
                        setShowLanguagesInCv(!showLanguagesInCv);
                        window.dispatchEvent(new CustomEvent('refreshTemplate'));
                      }}
                      size="small"
                      disableRipple
                      disableFocusRipple
                      sx={{
                        p: 1,
                        '&:hover': { backgroundColor: 'transparent' },
                        '& .MuiTouchRipple-root': { display: 'none' },
                        '& .MuiSvgIcon-root': { 
                          borderRadius: '50%',
                        },
                        color: '#667eea',
                        '&.Mui-checked': {
                          color: '#667eea',
                        }
                      }}
                    />
                  }
                  label={getTranslatedCvLabel('Sprachen')}
                  sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                />
                
                  <FormControlLabel
                  control={
                    <Checkbox
                      checked={showWorkExperienceInCv}
                      onChange={() => {
                        setShowWorkExperienceInCv(!showWorkExperienceInCv);
                        window.dispatchEvent(new CustomEvent('refreshTemplate'));
                      }}
                      size="small"
                      disableRipple
                      disableFocusRipple
                      sx={{
                        p: 1,
                        '&:hover': { backgroundColor: 'transparent' },
                        '& .MuiTouchRipple-root': { display: 'none' },
                        '& .MuiSvgIcon-root': { 
                          borderRadius: '50%',
                        },
                        color: '#667eea',
                        '&.Mui-checked': {
                          color: '#667eea',
                        }
                      }}
                    />
                  }
                  label={getTranslatedCvLabel('Berufserfahrung')}
                  sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                />
                
                  <FormControlLabel
                  control={
                    <Checkbox
                      checked={showAdditionalWorkExperienceInCv}
                      onChange={() => {
                        setShowAdditionalWorkExperienceInCv(!showAdditionalWorkExperienceInCv);
                        window.dispatchEvent(new CustomEvent('refreshTemplate'));
                      }}
                      size="small"
                      disableRipple
                      disableFocusRipple
                      sx={{
                        p: 1,
                        '&:hover': { backgroundColor: 'transparent' },
                        '& .MuiTouchRipple-root': { display: 'none' },
                        '& .MuiSvgIcon-root': { 
                          borderRadius: '50%',
                        },
                        color: '#667eea',
                        '&.Mui-checked': {
                          color: '#667eea',
                        }
                      }}
                    />
                  }
                  label={getTranslatedCvLabel('Weitere Berufserfahrungen')}
                  sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                />
                
                  <FormControlLabel
                  control={
                    <Checkbox
                      checked={showHobbiesInCv}
                      onChange={() => {
                        setShowHobbiesInCv(!showHobbiesInCv);
                        window.dispatchEvent(new CustomEvent('refreshTemplate'));
                      }}
                      size="small"
                      disableRipple
                      disableFocusRipple
                      sx={{
                        p: 1,
                        '&:hover': { backgroundColor: 'transparent' },
                        '& .MuiTouchRipple-root': { display: 'none' },
                        '& .MuiSvgIcon-root': { 
                          borderRadius: '50%',
                        },
                        color: '#667eea',
                        '&.Mui-checked': {
                          color: '#667eea',
                        }
                      }}
                    />
                  }
                  label={getTranslatedCvLabel('Hobbys')}
                  sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                />
                
                  <FormControlLabel
                  control={
                    <Checkbox
                      checked={showAdditionalInfoInCv}
                      onChange={() => {
                        setShowAdditionalInfoInCv(!showAdditionalInfoInCv);
                        window.dispatchEvent(new CustomEvent('refreshTemplate'));
                      }}
                      size="small"
                      disableRipple
                      disableFocusRipple
                      sx={{
                        p: 1,
                        '&:hover': { backgroundColor: 'transparent' },
                        '& .MuiTouchRipple-root': { display: 'none' },
                        '& .MuiSvgIcon-root': { 
                          borderRadius: '50%',
                        },
                        color: '#667eea',
                        '&.Mui-checked': {
                          color: '#667eea',
                        }
                      }}
                    />
                  }
                  label={getTranslatedCvLabel('Zusätzliche Infos')}
                  sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                />
                </Box>
                
                  <Typography variant="subtitle2" sx={{ mb: 1, color: '#666', fontWeight: 600, mt: 2 }}>
                    {getTranslatedCvLabel('Weitere Sichtbarkeit')}
                  </Typography>
                
                <Box sx={{ pl: 3, border: '1px solid #e0e0e0', borderRadius: 1, p: 1, backgroundColor: '#fafafa' }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={showCompanyNamesInCv}
                        onChange={() => {
                          const nextValue = !showCompanyNamesInCv;
                          setShowCompanyNamesInCv(nextValue);
                          window.dispatchEvent(new CustomEvent('refreshTemplate'));
                        }}
                        size="small"
                        disableRipple
                        disableFocusRipple
                        sx={{
                          p: 1,
                          '&:hover': { backgroundColor: 'transparent' },
                          '& .MuiTouchRipple-root': { display: 'none' },
                          '& .MuiSvgIcon-root': { 
                            borderRadius: '50%',
                          },
                          color: '#667eea',
                          '&.Mui-checked': {
                            color: '#667eea',
                          }
                        }}
                      />
                    }
                    label={getTranslatedCvLabel('Firmennamen')}
                    sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={showIndustryInCv}
                        onChange={() => {
                          const nextValue = !showIndustryInCv;
                          setShowIndustryInCv(nextValue);
                          window.dispatchEvent(new CustomEvent('refreshTemplate'));
                        }}
                        size="small"
                        disableRipple
                        disableFocusRipple
                        sx={{
                          p: 1,
                          '&:hover': { backgroundColor: 'transparent' },
                          '& .MuiTouchRipple-root': { display: 'none' },
                          '& .MuiSvgIcon-root': { 
                            borderRadius: '50%',
                          },
                          color: '#667eea',
                          '&.Mui-checked': {
                            color: '#667eea',
                          }
                        }}
                      />
                    }
                    label={getTranslatedCvLabel('Branche')}
                    sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={showDateInCv}
                        onChange={() => {
                          const nextValue = !showDateInCv;
                          setShowDateInCv(nextValue);
                          window.dispatchEvent(new CustomEvent('refreshTemplate'));
                        }}
                        size="small"
                        disableRipple
                        disableFocusRipple
                        sx={{
                          p: 1,
                          '&:hover': { backgroundColor: 'transparent' },
                          '& .MuiTouchRipple-root': { display: 'none' },
                          '& .MuiSvgIcon-root': { 
                            borderRadius: '50%',
                          },
                          color: '#667eea',
                          '&.Mui-checked': {
                            color: '#667eea',
                          }
                        }}
                      />
                    }
                    label={getTranslatedCvLabel('Datum')}
                    sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={showProjectSearchInCv}
                        onChange={() => {
                          const nextValue = !showProjectSearchInCv;
                          setShowProjectSearchInCv(nextValue);
                          window.dispatchEvent(new CustomEvent('refreshTemplate'));
                        }}
                        size="small"
                        disableRipple
                        disableFocusRipple
                        sx={{
                          p: 1,
                          '&:hover': { backgroundColor: 'transparent' },
                          '& .MuiTouchRipple-root': { display: 'none' },
                          '& .MuiSvgIcon-root': { 
                            borderRadius: '50%',
                          },
                          color: '#667eea',
                          '&.Mui-checked': {
                            color: '#667eea',
                          }
                        }}
                      />
                    }
                    label={getTranslatedCvLabel('Projektsuche')}
                    sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                  />
                  <Button
                    variant="outlined"
                    size="small"
                    fullWidth
                    disabled={optimizing}
                    onClick={openTextSettingsModal}
                    startIcon={<SettingsIcon fontSize="small" />}
                    sx={{
                      mt: 1,
                      fontSize: '0.7rem',
                      textTransform: 'none',
                      color: '#667eea',
                      borderColor: '#667eea',
                      '&:hover': {
                        borderColor: '#5a6fd6',
                        backgroundColor: 'rgba(102, 126, 234, 0.08)'
                      }
                    }}
                  >
                    {getUiLanguageDictionaryLabel('Text Einstellungen')}
                  </Button>
                </Box>
              </Box>

              {/* Schließe linke Einstellungs-Spalte */}
            </Box>

            {/* CV Preview rechts */}
            <Box sx={{ 
              flex: 1, 
              overflow: 'auto',
              '@media (max-width: 800px)': {
                flex: 'none',
                height: '70vh'
              }
            }}>
              {!showCvDataModal && (
              (() => {
                const cvDataForPreview = getCvDataForTemplate();
                const profileImageForPreview = normalizeProfileImageValue(profileImage);
                return (
              <CvTemplate
            cvData={cvDataForPreview}
            profileImage={showPhotoInCv ? (profileImageForPreview || profileImage || undefined) : undefined}
            onPageCountChange={setCvPreviewPageCount}
            templateStyle={getTemplateStyle(selectedTemplateId)}
            nameTextColor={nameTextColor}
            leftColumnTextColor={leftColumnTextColor}
            rightColumnTextColor={rightColumnTextColor}
            leftColumnTitleColor={leftColumnTitleColor}
            rightColumnTitleColor={rightColumnTitleColor}
            showBorder={showCvBorder}
            showFrames={showFrames}
            onWorkExperienceChange={handleWorkExperienceChange}
            onWorkExperienceReorder={handleWorkExperienceReorder}
            onCoreCompetenciesTitleChange={handleCoreCompetenciesTitleChange}
            onCertificationsTitleChange={handleCertificationsTitleChange}
            onItSkillsTitleChange={handleItSkillsTitleChange}
            onIndustriesTitleChange={handleIndustriesTitleChange}
            onLanguagesTitleChange={handleLanguagesTitleChange}
            onHobbiesTitleChange={handleHobbiesTitleChange}
            onEducationTitleChange={handleEducationTitleChange}
            onWorkExperienceTitleChange={handleWorkExperienceTitleChange}
            onProfileTitleChange={handleProfileTitleChange}
            targetLanguage={targetLanguage}
            translatedYears={translatedYears}
            leftColumnColor={hexToRgba(leftColumnColor, leftColumnAlpha)}
            topBoxColor={hexToRgba(topBoxColor, topBoxAlpha)}
            topBoxImage={topBoxImage}
            topBoxHeightMode={'nameBottom'}
            leftColumnImage={leftColumnImage}
            isEditMode={true}
            showCoreCompetenciesInCv={showCoreCompetenciesInCv}
            showCertificationsInCv={showCertificationsInCv}
            showItSkillsInCv={showItSkillsInCv}
            showIndustriesInCv={showIndustriesInCv}
            showLanguagesInCv={showLanguagesInCv}
            showHobbiesInCv={showHobbiesInCv}
            showEducationInCv={showEducationInCv}
            showWorkExperienceInCv={showWorkExperienceInCv}
            showAdditionalWorkExperienceInCv={showAdditionalWorkExperienceInCv}
            showProfileInCv={showProfileInCv}
            showAdditionalInfoInCv={showAdditionalInfoInCv}
            showProfileImageInCv={showProfileImageInCv}
            showContactInCv={showContactInCv}
            showCompanyNamesInCv={showCompanyNamesInCv}
            showIndustryInCv={showIndustryInCv}
            showDateInCv={showDateInCv}
            showProjectSearchInCv={showProjectSearchInCv}
            showBulletPointsInCv={showBulletPointsInCv}
            profileImageBorderRadius={profileImageBorderRadius}
            profileImageSize={profileImageSize}
            profileImageWidth={profileImageWidth}
            profileImagePosition={profileImagePosition}
            profileImageAlignment={profileImageAlignment}
            profileImageBorder={profileImageBorder}
            profileImageBorderColor={profileImageBorderColor}
            profileImageBorderThickness={profileImageBorderThickness}
            contactDisplayMode={contactDisplayMode}
            onContactDisplayModeChange={handleContactDisplayModeChange}
            nameFontSize={nameFontSize}
            onNameFontSizeChange={handleNameFontSizeChange}
            titleFont={titleFont}
            bodyFont={bodyFont}
            data-testid="cv-template"
          />
                );
              })()
              )}
          </Box>
          </Box>
        </DialogContent>
      </Dialog>



      {/* Bestaetigungsdialog fuer ungespeicherte Aenderungen */}
      <Dialog
        open={showUnsavedChangesDialog}
        onClose={() => setShowUnsavedChangesDialog(false)}
        maxWidth="sm"
        sx={{ zIndex: 1700 }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.25)'
          }
        }}
      >
        <DialogTitle>
          {getTranslatedCvLabel('Ungespeicherte Änderungen')}
        </DialogTitle>
        <DialogContent>
          <Typography>
            {getTranslatedCvLabel('Sie haben ungespeicherte Änderungen. Möchten Sie wirklich schließen ohne zu speichern?')}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => setShowUnsavedChangesDialog(false)}
            variant="outlined"
          >
            {getTranslatedCvLabel('Abbrechen')}
          </Button>
          <Button 
            onClick={confirmCloseCvDataModal}
            variant="contained"
            color="error"
          >
            {getTranslatedCvLabel('Ohne Speichern schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* QR-Code Dialog */}
      <Dialog
        open={showQrCodeDialog}
        onClose={() => {
          setShowQrCodeDialog(false);
          // Trigger Seitenberechnung im CV-Template
          window.dispatchEvent(new CustomEvent('modalClosed'));
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ width: '100%', maxWidth: '100%' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6">Foto über Smartphone hochladen</Typography>
            <Button onClick={() => setShowQrCodeDialog(false)} size="small">
              Schließen
            </Button>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, py: 2 }}>
            <Typography variant="body1" textAlign="center">
              Scannen Sie diesen QR-Code mit Ihrem Smartphone, um ein Foto hochzuladen:
            </Typography>
            
            {qrCodeData ? (
              <Box sx={{ border: '2px solid #e0e0e0', borderRadius: 2, p: 2, backgroundColor: 'white' }}>
                <img 
                  src={qrCodeData} 
                  alt="QR-Code für Foto-Upload" 
                  style={{ width: 300, height: 300, display: 'block' }}
                  onLoad={() => console.log('✅ QR-Code Bild geladen')}
                  onError={(e) => console.error('❌ QR-Code Bild Fehler:', e)}
                />
              </Box>
            ) : (
              <Box sx={{ border: '2px solid #e0e0e0', borderRadius: 2, p: 2, backgroundColor: 'white', width: 300, height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography color="text.secondary">
                  {getTranslatedCvLabel('QR-Code wird geladen...')}
                </Typography>
              </Box>
            )}
            
            <Typography variant="body2" color="text.secondary" textAlign="center">
              {getTranslatedCvLabel('Der QR-Code ist 10 Minuten gültig. Das Foto wird automatisch als Profilbild übernommen.')}
            </Typography>
            
            {qrExpiresAt && (
              <Typography variant="caption" color="text.secondary">
                Gültig bis: {new Date(qrExpiresAt).toLocaleString('de-DE')}
              </Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button 
            variant="outlined"
            onClick={() => setShowQrCodeDialog(false)}
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            Schließen
          </Button>
        </DialogActions>
      </Dialog>

      {/* Motivationsschreiben Dialog */}
      <Dialog
        open={showMotivationDialog}
        onClose={handleCloseMotivationDialog}
        maxWidth="md"
        fullWidth
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.25)'
          }
        }}
        PaperProps={{
          sx: {
            margin: '20px',
            overflowX: 'hidden',
            '@media print': {
              boxShadow: 'none',
              margin: '0px',
              maxWidth: 'none',
              height: '100%'
            }
          }
        }}
        sx={{
          zIndex: 1800,
          '@media print': {
            '& .MuiDialogTitle-root': {
              display: 'none'
            },
            '& .MuiDialogActions-root': {
              display: 'none'
            },
            '& button': {
              display: 'none !important'
            }
          }
        }}
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6">{getTranslatedCvLabel('Motivationsschreiben')}</Typography>
            <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
              {isAdmin() && (
                <Button
                  variant="outlined"
                  onClick={() => setShowMotivationBorder(!showMotivationBorder)}
                  size="small"
                  sx={{ 
                    backgroundColor: showMotivationBorder ? '#e0e0e0' : 'transparent',
                    '&:hover': {
                      backgroundColor: showMotivationBorder ? '#d0d0d0' : '#f5f5f5'
                    }
                  }}
                >
                  {showMotivationBorder ? 'Rahmen entfernen' : 'Rahmen anzeigen'}
                </Button>
              )}
              <IconButton 
                onClick={handleCloseMotivationDialog} 
                size="small"
                sx={{ 
                  color: 'error.main',
                  minWidth: 'auto',
                  padding: '2px',
                  width: '28px',
                  height: '28px',
                  '&:hover': { bgcolor: 'rgba(244, 67, 54, 0.1)' }
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        </DialogTitle>
        
        <DialogContent sx={{ p: 0, overflowX: 'hidden' }}>
        {/* Info-Textfeld oberhalb des Motivationsschreibens */}
        <Box sx={{ px: 2, py: 1 }}>
          {minimizedInfoBoxes['motivation'] ? (
            <Tooltip title={currentLanguage === 'de' ? 'Info anzeigen' : currentLanguage === 'en' ? 'Show info' : currentLanguage === 'fr' ? 'Afficher info' : 'Mostra info'} arrow>
              <IconButton 
                onClick={() => setMinimizedInfoBoxes(prev => ({ ...prev, motivation: false }))}
                sx={{ color: '#1976d2', '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.08)' } }}
              >
                <InfoOutlinedIcon />
              </IconButton>
            </Tooltip>
          ) : (
            <Alert 
              severity="info" 
              sx={{ 
                borderRadius: 2,
                backgroundColor: '#f0f7ff',
                border: '1px solid #b3d9ff',
                '& .MuiAlert-icon': {
                  color: '#1976d2'
                }
              }}
              action={
                <IconButton size="small" onClick={() => setMinimizedInfoBoxes(prev => ({ ...prev, motivation: true }))}>
                  <CloseIcon fontSize="small" sx={{ color: '#1976d2' }} />
                </IconButton>
              }
            >
              <Typography variant="body2" sx={{ color: '#1976d2', fontWeight: 500 }}>
                {getTranslatedCvLabel('Bitte lies das Motivationsschreiben gut durch. Willst du etwas ändern, klicke auf den entsprechenden Text. Willst du es herunter laden, klicke auf das Download Icon oben rechts.')}
              </Typography>
            </Alert>
          )}
        </Box>
        
        {/* Eingabefeld für Motivation */}
        <Box sx={{ px: 2, py: 2, overflowX: 'hidden' }}>
          <TextField
            fullWidth
            multiline
            rows={4}
            label="Motivation eingeben (optional)"
            key={`motivation-input-${motivationInput || ''}`}
            defaultValue={motivationInput}
            onBlur={(e) => {
              const nextValue = e.target.value;
              if (nextValue !== motivationInput) setMotivationInput(nextValue);
            }}
            placeholder="Geben Sie hier Ihre Motivation ein (optional)..."
            variant="outlined"
            sx={{ mb: 2 }}
          />
          
          {/* Button zur Erstellung des Motivationsschreibens */}
          <Button
            variant="contained"
            onClick={async () => {
              if (!jobDescription.trim()) {
                setError('Stellenbeschreibung ist erforderlich.');
                return;
              }
              if (!user) {
                setError('Benutzer nicht angemeldet.');
                return;
              }
              
              setCreatingMotivation(true);
              setError(null);
              
              try {
                const idToken = await user.getIdToken();
                let userData: any = {};
                
                try {
                  const response = await fetch(`${config.backend.userDataUrl}/${user.uid}`, {
                    method: 'GET',
                    headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `Bearer ${idToken}`
                    }
                  });

                  if (response.ok) {
                    const result = await response.json();
                    userData = result.data || {};
                  }
                } catch (fetchError) {
                  console.log('Keine CV-Daten gefunden, verwende Standarddaten für Motivationsschreiben');
                  userData = {};
                }
                
                const cvData = {
                  personalInfo: {
                    fullName: optimizedFullName || userData?.fullName || '',
                    shortProfile: optimizedShortProfile || '',
                    nationality: userData?.nationality || '',
                    residencePermit: userData?.residencePermit || ''
                  },
                  workExperience: optimizedWorkExperiences || [],
                  education: userData?.educations || [],
                  certifications: userData?.certifications || [],
                  languages: userData?.languagesExtracted || [],
                  itSkills: userData?.itSkillsExtracted || [],
                  hobbiesExtracted: userData?.hobbiesExtracted || [],
                  additionalInfoExtracted: userData?.additionalInfoExtracted || []
                };

                const data = await requestOptimizeCvWithQueue({
                  cvData: cvData,
                  jobDescription: jobDescription,
                  optimizeType: 'motivation',
                  generateSeparateFields: true,
                  targetLanguage: targetLanguage,
                  motivationInput: motivationInput // Zusätzliche Motivation-Eingabe
                }, idToken, true);
                
                if (data.motivationText) {
                  // Neuer Baseline: History neu initialisieren (kein Undo nötig für initiale Erstellung)
                  const newHistory = [data.motivationText];
                  setMotivationHistory(newHistory);
                  setMotivationHistoryIndex(0);
                  motivationHistoryRef.current = { history: newHistory, index: 0 };
                  setGeneratedMotivationText(data.motivationText);
                  setTempMotivationLetter(data.motivationText);
                  if (data.motivationTitle) {
                    setTempMotivationTitle(data.motivationTitle);
                  }
                  if (data.motivationGreeting) {
                    setTempMotivationGreeting(data.motivationGreeting);
                  }
                  if (data.recipientInfo) {
                    setMotivationRecipientInfo(data.recipientInfo);
                  }
                } else if (data.motivationLetter) {
                  const motivationText = typeof data.motivationLetter === 'string' ? data.motivationLetter : '';
                  // Neuer Baseline: History neu initialisieren
                  const newHistory = [motivationText];
                  setMotivationHistory(newHistory);
                  setMotivationHistoryIndex(0);
                  motivationHistoryRef.current = { history: newHistory, index: 0 };
                  setGeneratedMotivationText(motivationText);
                  setTempMotivationLetter(motivationText);
                }
              } catch (error: any) {
                console.error('Fehler beim Erstellen des Motivationsschreibens:', error);
                setError(error.message || 'Fehler beim Erstellen des Motivationsschreibens');
              } finally {
                setCreatingMotivation(false);
              }
            }}
            disabled={creatingMotivation}
            sx={{
              mb: 2,
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              fontWeight: 600,
              borderRadius: 6,
              textTransform: 'none',
              py: 1.2,
              '&:hover': {
                background: 'linear-gradient(135deg, #5568d3 0%, #6a3f8f 100%)',
              },
              '&.Mui-disabled': {
                background: 'linear-gradient(135deg, #cbd5e1 0%, #94a3b8 100%)',
                color: 'white',
              },
            }}
            startIcon={creatingMotivation ? <CircularProgress size={20} sx={{ color: 'white' }} /> : null}
          >
            {creatingMotivation ? getTranslatedInfoMessage('creating_motivation') : getTranslatedCvLabel('Motivationsschreiben erstellen')}
          </Button>
          
          {/* Anzeigefeld für das erstellte Motivationsschreiben */}
          <Box sx={{ position: 'relative', mb: 2, overflowX: 'hidden' }}>
            <TextField
              fullWidth
              multiline
              minRows={4}
              maxRows={20}
              label="Erstelltes Motivationsschreiben"
              key={`generated-motivation-${generatedMotivationText || ''}`}
              defaultValue={generatedMotivationText}
              onBlur={(e) => {
                const nextValue = e.target.value;
                if (nextValue !== generatedMotivationText) {
                  handleMotivationTextChange({
                    target: { value: nextValue }
                  } as React.ChangeEvent<HTMLInputElement>);
                }
              }}
              placeholder="Das erstellte Motivationsschreiben erscheint hier..."
              variant="outlined"
              sx={{ 
                pr: ((motivationHistoryIndex > 0 || motivationHistoryIndex < motivationHistory.length - 1) || (!showMotivationPromptInput && generatedMotivationText.trim())) ? 10 : 5,
                '& .MuiOutlinedInput-root': {
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#3b82f6'
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#3b82f6'
                  },
                  '& textarea': {
                    overflowX: 'hidden !important',
                    overflowY: 'auto'
                  }
                }
              }}
            />
            {/* Undo/Redo Icons */}
            <Box sx={{ position: 'absolute', bottom: 8, right: (!showMotivationPromptInput && generatedMotivationText.trim()) ? 40 : 8, display: 'flex', gap: 0.5, zIndex: 10 }}>
              {motivationHistoryIndex > 0 && (
                <IconButton
                  aria-label="Rückgängig"
                  onClick={handleMotivationUndo}
                  size="small"
                  sx={{
                    color: '#94a3b8',
                    backgroundColor: 'white',
                    boxShadow: '0 2px 8px rgba(15, 23, 42, 0.12)',
                    '&:hover': {
                      backgroundColor: '#fee2e2',
                      color: '#ef4444'
                    },
                    transition: 'all 0.2s ease-in-out'
                  }}
                >
                  <UndoIcon sx={{ fontSize: '18px' }} />
                </IconButton>
              )}
              {motivationHistoryIndex < motivationHistory.length - 1 && (
                <IconButton
                  aria-label="Wiederherstellen"
                  onClick={handleMotivationRedo}
                  size="small"
                  sx={{
                    color: '#94a3b8',
                    backgroundColor: 'white',
                    boxShadow: '0 2px 8px rgba(15, 23, 42, 0.12)',
                    '&:hover': {
                      backgroundColor: '#e0f2fe',
                      color: '#3b82f6'
                    },
                    transition: 'all 0.2s ease-in-out'
                  }}
                >
                  <RedoIcon sx={{ fontSize: '18px' }} />
                </IconButton>
              )}
            </Box>
            {!showMotivationPromptInput && generatedMotivationText.trim() && (
              <IconButton
                aria-label="Prompts zur Verbesserung des Motivationsschreibens"
                onClick={toggleMotivationPromptInput}
                size="small"
                disabled={optimizingMotivationPrompt}
                sx={{
                  position: 'absolute',
                  bottom: 8,
                  right: 8,
                  color: optimizingMotivationPrompt ? '#cbd5f5' : '#94a3b8',
                  backgroundColor: 'white',
                  boxShadow: '0 2px 8px rgba(15, 23, 42, 0.12)',
                  '&:hover': {
                    backgroundColor: '#e0e7ff',
                    color: '#6366f1'
                  }
                }}
              >
                <ExpandMoreIcon />
              </IconButton>
            )}
          </Box>

          {showMotivationPromptInput && (
            <Box sx={{ mt: 2, position: 'relative', overflowX: 'hidden' }}>
              <TextField
                label="Prompts zur Verbesserung des Motivationsschreibens"
                defaultValue={motivationPromptText}
                onChange={handleMotivationPromptChange}
                onBlur={(e) => {
                  const nextValue = e.target.value;
                  if (nextValue !== motivationPromptText) setMotivationPromptText(nextValue);
                }}
                variant="outlined"
                multiline
                rows={4}
                fullWidth
                placeholder="Beschreiben Sie, welche Aspekte des Motivationsschreibens verbessert werden sollen..."
                sx={{ 
                  '& .MuiInputLabel-root': { 
                    fontSize: '0.875rem',
                    color: '#64748b'
                  },
                  '& .MuiOutlinedInput-root': { 
                    fontSize: '0.875rem',
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#3b82f6'
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#3b82f6'
                    }
                  }
                }}
              />
              <IconButton
                aria-label="Motivationsschreiben mit Prompt verbessern"
                size="small"
                onClick={handleMotivationPromptOptimization}
                disabled={!motivationPromptText.trim() || optimizingMotivationPrompt}
                sx={{
                  position: 'absolute',
                  bottom: 8,
                  right: 8,
                  color: (!motivationPromptText.trim() || optimizingMotivationPrompt) ? '#cbd5f5' : '#94a3b8',
                  backgroundColor: 'white',
                  boxShadow: '0 2px 8px rgba(15, 23, 42, 0.12)',
                  '&:hover': {
                    backgroundColor: '#e0e7ff',
                    color: '#6366f1'
                  },
                  '&.Mui-disabled': {
                    backgroundColor: '#f8fafc',
                    boxShadow: 'none'
                  }
                }}
              >
                {optimizingMotivationPrompt ? <CircularProgress size={16} /> : <AutoFixHighIcon />}
              </IconButton>
            </Box>
          )}
        </Box>
        </DialogContent>

      </Dialog>

      {/* Modal für Prompt-Editor */}
      <Dialog
        open={promptEditorOpen}
        onClose={handleClosePromptEditor}
        maxWidth={false}
        fullWidth
        PaperProps={{
          sx: {
            maxHeight: '90vh',
            minHeight: '70vh',
            width: '95vw',
            maxWidth: '1800px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ width: '100%', maxWidth: '100%', overflowX: 'hidden' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box>
              <Typography variant="h6">
                {originalPromptName ? `Prompt bearbeiten: ${originalPromptName}` : 'Prompt bearbeiten'}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {prompts.length} Prompts aus Firebase geladen
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 1, mr: 10 }}>
              <IconButton 
                onClick={handleRefreshPrompts}
                title="Prompts aus Firebase aktualisieren"
              >
                <RestoreIcon />
              </IconButton>
              <IconButton 
                color="error" 
                onClick={handleDeletePrompt}
                title="Prompt löschen"
                disabled={!originalPromptName}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton onClick={handleClosePromptEditor}>
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        </DialogTitle>
        
        <DialogContent sx={{ overflowX: 'hidden' }}>
          {/* Prompt-Name Bearbeitung */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              Prompt-Name
            </Typography>
            <TextField
              fullWidth
              label="Prompt-Name"
              key={`editing-prompt-name-${editingPromptName || ''}`}
              defaultValue={editingPromptName}
              onBlur={(e) => {
                const nextValue = e.target.value;
                if (nextValue !== editingPromptName) handlePromptNameChange(nextValue);
              }}
              disabled={editingPromptIndex === null}
              helperText="Der Name des Prompts (wird beim Speichern oder Testen übernommen)"
              sx={{ mb: 2 }}
            />
          </Box>

          {/* Verwendung und ChatGPT-Version Dropdowns */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              Prompt-Konfiguration
            </Typography>
            
            {/* Zeile 1: Verwendung und ChatGPT-Version nebeneinander */}
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              {/* Verwendung Dropdown */}
              <FormControl sx={{ flex: 1 }}>
                <InputLabel>Verwendung</InputLabel>
                <Select
                  value={editingPromptUsage}
                  onChange={(e) => setEditingPromptUsage(e.target.value)}
                  label="Verwendung"
                >
                  <MenuItem value="Extraktion">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Chip 
                        label="Extraktion" 
                        color="primary"
                        size="small"
                        variant="outlined"
                      />
                      <Typography variant="body2" color="text.secondary">
                        - Extrahiert Daten aus CV-Dokumenten
                      </Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem value="Optimierung">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Chip 
                        label="Optimierung" 
                        color="secondary"
                        size="small"
                        variant="outlined"
                      />
                      <Typography variant="body2" color="text.secondary">
                        - Optimiert Daten für Stellenausschreibungen
                      </Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem value="Foto">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Chip 
                        label="Foto" 
                        color="success"
                        size="small"
                        variant="outlined"
                      />
                      <Typography variant="body2" color="text.secondary">
                        - Optimiert und bearbeitet Profilbilder
                      </Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem value="Check">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Chip 
                        label="Check" 
                        color="warning"
                        size="small"
                        variant="outlined"
                      />
                      <Typography variant="body2" color="text.secondary">
                        - Überprüft und validiert Daten
                      </Typography>
                    </Box>
                  </MenuItem>
                </Select>
              </FormControl>
              
              {/* ChatGPT-Version Dropdown */}
              <FormControl sx={{ flex: 1 }}>
                <InputLabel>ChatGPT-Version</InputLabel>
                <Select
                  value={editingPromptVersion}
                  onChange={(e) => setEditingPromptVersion(e.target.value)}
                  label="ChatGPT-Version"
                >
                  {chatGptVersions.map((version) => (
                    <MenuItem key={version.value} value={version.value}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                          {version.label}
                        </Typography>
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            
            {/* Zeile 2: Temperatur und Max Tokens nebeneinander */}
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <FormControl fullWidth>
                <TextField
                  label="Temperatur"
                  type="number"
                  key={`editing-prompt-temperature-${editingPromptTemperature || ''}`}
                  defaultValue={editingPromptTemperature}
                  onBlur={(e) => {
                    const nextValue = e.target.value;
                    if (nextValue !== editingPromptTemperature) setEditingPromptTemperature(nextValue);
                  }}
                  inputProps={{ 
                    min: 0, 
                    max: 2, 
                    step: 0.1 
                  }}
                  helperText="0.0 = deterministisch, 2.0 = sehr kreativ"
                />
              </FormControl>
              
              <FormControl fullWidth>
                <TextField
                  label="Max Tokens"
                  type="number"
                  key={`editing-prompt-max-tokens-${editingPromptMaxTokens || ''}`}
                  defaultValue={editingPromptMaxTokens}
                  onBlur={(e) => {
                    const nextValue = e.target.value;
                    if (nextValue !== editingPromptMaxTokens) setEditingPromptMaxTokens(nextValue);
                  }}
                  inputProps={{ 
                    min: 1, 
                    max: 32000, 
                    step: 1 
                  }}
                  helperText="Maximale Anzahl der Tokens in der Antwort"
                />
              </FormControl>
            </Box>
            
            {/* System-Rolle */}
            <Box sx={{ mb: 2 }}>
              <TextField
                fullWidth
                label="System-Rolle (ChatGPT Identität)"
                key={`editing-prompt-system-role-${editingPromptSystemRole || ''}`}
                defaultValue={editingPromptSystemRole}
                onBlur={(e) => {
                  const nextValue = e.target.value;
                  if (nextValue !== editingPromptSystemRole) setEditingPromptSystemRole(nextValue);
                }}
                multiline
                minRows={2}
                helperText="Die Rolle definiert, wie sich ChatGPT verhält (z.B. 'Du bist ein Experte für...')"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    fontSize: '13px'
                  }
                }}
              />
            </Box>
            
            {/* Informationen zur ausgewählten Version */}
            {(() => {
              const selectedVersion = chatGptVersions.find(v => v.value === editingPromptVersion);
              if (!selectedVersion) return null;
              
              return (
                <Box sx={{ 
                  p: 2, 
                  border: '1px solid #e0e0e0', 
                  borderRadius: 1, 
                  backgroundColor: '#f8f8f8' 
                }}>
                  <Typography variant="h6" gutterBottom>
                    {selectedVersion.label} - {selectedVersion.description}
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 3, mb: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                        Geschwindigkeit:
                      </Typography>
                      <Chip 
                        label={selectedVersion.speed} 
                        size="small" 
                        sx={{ 
                          backgroundColor: selectedVersion.speedColor, 
                          color: 'white',
                          fontWeight: 'bold'
                        }} 
                      />
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                        Qualität:
                      </Typography>
                      <Chip 
                        label={selectedVersion.quality} 
                        size="small" 
                        sx={{ 
                          backgroundColor: selectedVersion.qualityColor, 
                          color: 'white',
                          fontWeight: 'bold'
                        }} 
                      />
                    </Box>
                  </Box>
                  <Typography variant="body2" color="text.secondary">
                    {selectedVersion.details}
                  </Typography>
                </Box>
              );
            })()}
          </Box>

          {/* Target Language Anzeige */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              Aktuelle Zielsprache
            </Typography>
            <Box sx={{ 
              p: 2, 
              border: '1px solid #e0e0e0', 
              borderRadius: 1, 
              backgroundColor: '#f8f8f8',
              display: 'flex',
              alignItems: 'center',
              gap: 2
            }}>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                targetLanguage:
              </Typography>
              <Chip 
                label={targetLanguage} 
                color="primary"
                size="small"
                sx={{ fontWeight: 'bold' }}
              />
              <Typography variant="body2" color="text.secondary">
                (Diese Variable wird in Prompts als {`{targetLanguage}`} ersetzt)
              </Typography>
            </Box>
          </Box>

          <TextField
            multiline
            minRows={10}
            key={`editing-prompt-text-${editingPromptText || ''}`}
            defaultValue={editingPromptText}
            onBlur={(e) => {
              const nextValue = e.target.value;
              if (nextValue !== editingPromptText) setEditingPromptText(nextValue);
            }}
            variant="outlined"
            fullWidth
            sx={{
              '& .MuiOutlinedInput-root': {
                fontSize: '12px',
                fontFamily: 'monospace'
              },
              '& .MuiInputBase-input': {
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word'
              }
            }}
          />
          
          {/* Test-Ergebnis - Immer sichtbar */}
          <Box sx={{ mt: 3 }}>
            <Typography variant="h6" gutterBottom>
              Test-Ergebnis:
            </Typography>
            <TextField
              multiline
              minRows={5}
              value={testResult || 'Klicke auf "Prompt testen" um ein Ergebnis zu erhalten...'}
              variant="outlined"
              fullWidth
              InputProps={{
                readOnly: true
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: '12px',
                  fontFamily: 'monospace',
                  backgroundColor: testResult ? '#f5f5f5' : '#fafafa'
                }
              }}
            />
          </Box>
          
          {/* Mitgelieferte Daten - Minimierbar */}
          <Box sx={{ mt: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
              <Typography variant="h6">
                Mitgelieferte Daten
              </Typography>
              <IconButton 
                onClick={() => setShowMitgelieferteDaten(!showMitgelieferteDaten)}
                size="small"
                sx={{ 
                  color: 'primary.main',
                  '&:hover': { bgcolor: 'rgba(25, 118, 210, 0.1)' }
                }}
              >
                {showMitgelieferteDaten ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            </Box>
            
            {showMitgelieferteDaten && (
              <TextField
                multiline
                minRows={3}
                value={getMitgelieferteDatenText()}
                variant="outlined"
                fullWidth
                InputProps={{
                  readOnly: true
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    fontSize: '11px',
                    fontFamily: 'monospace',
                    backgroundColor: '#f0f8ff'
                  }
                }}
                helperText="Nur die Daten, die mit dem Prompt mitgegeben werden (ohne Stellenbeschreibung oder andere Texte)"
              />
            )}
          </Box>
          
          {/* Datenset-Übersicht */}
          <Box sx={{ mt: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
              <Typography variant="h6">
                Verwendete Datensets
              </Typography>
              <IconButton 
                onClick={() => setShowVerwendeteDatensets(!showVerwendeteDatensets)}
                size="small"
                sx={{ 
                  color: 'primary.main',
                  '&:hover': { bgcolor: 'rgba(25, 118, 210, 0.1)' }
                }}
              >
                {showVerwendeteDatensets ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            </Box>
            
            {showVerwendeteDatensets && (
              <Box sx={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
                gap: 2 
              }}>
                  <Box sx={{ 
                    p: 2, 
                    border: '1px solid #e0e0e0', 
                    borderRadius: 1, 
                    backgroundColor: '#f8f8f8' 
                  }}>
                    <Typography variant="subtitle2" gutterBottom>
                      Persönliche Daten
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '11px', color: '#666', mb: 1 }}>
                      Platzhalter: {fullName ? '{fullName}' : '{cvText}'}
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '10px', color: '#888', mb: 1 }}>
                      Spezifische Datasets: {fullName ? '{fullName}, {shortProfile}' : 'Keine spezifischen Daten'}
                    </Typography>
                    <Typography variant="body2">
                      Name: {fullName || 'Nicht verfügbar'}
                    </Typography>
                    <Typography variant="body2">
                      Profil: {shortProfile ? `${shortProfile.substring(0, 50)}...` : 'Nicht verfügbar'}
                    </Typography>
                  </Box>
                  
                  <Box sx={{ 
                    p: 2, 
                    border: '1px solid #e0e0e0', 
                    borderRadius: 1, 
                    backgroundColor: '#f8f8f8' 
                  }}>
                    <Typography variant="subtitle2" gutterBottom>
                      Arbeitserfahrung
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '11px', color: '#666', mb: 1 }}>
                      Platzhalter: {jobDescription ? '{jobDescription}, {cvText}' : '{jobDescription}, {cvText}'}
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '10px', color: '#888', mb: 1 }}>
                      Spezifische Datasets: {workExperiences && workExperiences.length > 0 ? '{workExperienceData}' : 'Keine spezifischen Daten'}
                    </Typography>
                    <Typography variant="body2">
                      Anzahl: {workExperiences ? workExperiences.length : 0} Einträge
                    </Typography>
                    {workExperiences && workExperiences.length > 0 && (
                      <Typography variant="body2">
                        Letzte: {workExperiences[0].position} bei {workExperiences[0].company}
                      </Typography>
                    )}
                  </Box>
                  
                  <Box sx={{ 
                    p: 2, 
                    border: '1px solid #e0e0e0', 
                    borderRadius: 1, 
                    backgroundColor: '#f8f8f8' 
                  }}>
                    <Typography variant="subtitle2" gutterBottom>
                      Ausbildung
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '11px', color: '#666', mb: 1 }}>
                      Platzhalter: {jobDescription ? '{jobDescription}, {cvText}' : '{jobDescription}, {cvText}'}
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '10px', color: '#888', mb: 1 }}>
                      Spezifische Datasets: {educations && educations.length > 0 ? '{educationData}' : 'Keine spezifischen Daten'}
                    </Typography>
                    <Typography variant="body2">
                      Anzahl: {educations ? educations.length : 0} Einträge
                    </Typography>
                    {educations && educations.length > 0 && (
                      <Typography variant="body2">
                        Letzte: {educations[0].degree} an {educations[0].institution}
                      </Typography>
                    )}
                  </Box>
                  
                  <Box sx={{ 
                    p: 2, 
                    border: '1px solid #e0e0e0', 
                    borderRadius: 1, 
                    backgroundColor: '#f8f8f8' 
                  }}>
                    <Typography variant="subtitle2" gutterBottom>
                      IT-Skills
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '11px', color: '#666', mb: 1 }}>
                      Platzhalter: {jobDescription ? '{jobDescription}, {cvText}' : '{jobDescription}, {cvText}'}
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '10px', color: '#888', mb: 1 }}>
                      Spezifische Datasets: {itSkills && itSkills.length > 0 ? '{itSkillData}' : 'Keine spezifischen Daten'}
                    </Typography>
                    <Typography variant="body2">
                      Anzahl: {itSkills ? itSkills.length : 0} Skills
                    </Typography>
                    {itSkills && itSkills.length > 0 && (
                      <Typography variant="body2">
                        Beispiele: {itSkills.slice(0, 3).map(s => s.skill).join(', ')}
                      </Typography>
                    )}
                  </Box>
                  
                  <Box sx={{ 
                    p: 2, 
                    border: '1px solid #e0e0e0', 
                    borderRadius: 1, 
                    backgroundColor: '#f8f8f8' 
                  }}>
                    <Typography variant="subtitle2" gutterBottom>
                      Sprachen
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '11px', color: '#666', mb: 1 }}>
                      Platzhalter: {jobDescription ? '{jobDescription}, {cvText}' : '{jobDescription}, {cvText}'}
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '10px', color: '#888', mb: 1 }}>
                      Spezifische Datasets: {languages && languages.length > 0 ? '{languageData}' : 'Keine spezifischen Daten'}
                    </Typography>
                    <Typography variant="body2">
                      Anzahl: {languages ? languages.length : 0} Sprachen
                    </Typography>
                    {languages && languages.length > 0 && (
                      <Typography variant="body2">
                        Beispiele: {languages.slice(0, 3).map(l => `${l.language} (${l.level})`).join(', ')}
                      </Typography>
                    )}
                  </Box>
                  
                  <Box sx={{ 
                    p: 2, 
                    border: '1px solid #e0e0e0', 
                    borderRadius: 1, 
                    backgroundColor: '#f8f8f8' 
                  }}>
                    <Typography variant="subtitle2" gutterBottom>
                      Hobbys
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '11px', color: '#666', mb: 1 }}>
                      Platzhalter: {jobDescription ? '{jobDescription}, {cvText}' : '{jobDescription}, {cvText}'}
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '10px', color: '#888', mb: 1 }}>
                      Spezifische Datasets: {hobbies && hobbies.length > 0 ? '{hobbyData}' : 'Keine spezifischen Daten'}
                    </Typography>
                    <Typography variant="body2">
                      Anzahl: {hobbies ? hobbies.length : 0} Hobbys
                    </Typography>
                    {hobbies && hobbies.length > 0 && (
                      <Typography variant="body2">
                        Beispiele: {hobbies.slice(0, 3).map(h => h.hobby).join(', ')}
                      </Typography>
                    )}
                  </Box>
                  
                  <Box sx={{ 
                    p: 2, 
                    border: '1px solid #e0e0e0', 
                    borderRadius: 1, 
                    backgroundColor: '#f8f8f8' 
                  }}>
                    <Typography variant="subtitle2" gutterBottom>
                      Kernkompetenzen
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '11px', color: '#666', mb: 1 }}>
                      Platzhalter: {jobDescription ? '{jobDescription}, {cvText}' : '{jobDescription}, {cvText}'}
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '10px', color: '#888', mb: 1 }}>
                      Spezifische Datasets: {coreCompetencies && coreCompetencies.length > 0 ? '{coreCompetencyData}' : 'Keine spezifischen Daten'}
                    </Typography>
                    <Typography variant="body2">
                      Anzahl: {coreCompetencies ? coreCompetencies.length : 0} Kompetenzen
                    </Typography>
                    {coreCompetencies && coreCompetencies.length > 0 && (
                      <Typography variant="body2">
                        Beispiele: {coreCompetencies.slice(0, 3).map(c => c.competency).join(', ')}
                      </Typography>
                    )}
                  </Box>
                  
                  <Box sx={{ 
                    p: 2, 
                    border: '1px solid #e0e0e0', 
                    borderRadius: 1, 
                    backgroundColor: '#f8f8f8' 
                  }}>
                    <Typography variant="subtitle2" gutterBottom>
                      Zusätzliche Info
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '11px', color: '#666', mb: 1 }}>
                      Platzhalter: {jobDescription ? '{jobDescription}, {cvText}' : '{jobDescription}, {cvText}'}
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '10px', color: '#888', mb: 1 }}>
                      Spezifische Datasets: {additionalInfo && additionalInfo.length > 0 ? '{additionalInfoData}' : 'Keine spezifischen Daten'}
                    </Typography>
                    <Typography variant="body2">
                      Anzahl: {additionalInfo ? additionalInfo.length : 0} Einträge
                    </Typography>
                    {additionalInfo && additionalInfo.length > 0 && (
                      <Typography variant="body2">
                        Beispiele: {additionalInfo.slice(0, 3).map(a => a.info).join(', ')}
                      </Typography>
                    )}
                  </Box>
                  
                  <Box sx={{ 
                    p: 2, 
                    border: '1px solid #e0e0e0', 
                    borderRadius: 1, 
                    backgroundColor: '#f8f8f8' 
                  }}>
                    <Typography variant="subtitle2" gutterBottom>
                      Branchenerfahrung
                    </Typography>
                    <Typography variant="body2">
                      Anzahl: {industryExperiences ? industryExperiences.length : 0} Branchen
                    </Typography>
                    {industryExperiences && industryExperiences.length > 0 && (
                      <Typography variant="body2">
                        Beispiele: {industryExperiences.slice(0, 3).map(i => i.industry).join(', ')}
                      </Typography>
                    )}
                  </Box>
                  
                  <Box sx={{ 
                    p: 2, 
                    border: '1px solid #e0e0e0', 
                    borderRadius: 1, 
                    backgroundColor: '#f8f8f8' 
                  }}>
                    <Typography variant="subtitle2" gutterBottom>
                      Stellenausschreibung
                    </Typography>
                    <Typography variant="body2">
                      Länge: {jobDescription ? jobDescription.length : 0} Zeichen
                    </Typography>
                    {jobDescription && (
                      <Typography variant="body2">
                        Anfang: {jobDescription.substring(0, 50)}...
                      </Typography>
                    )}
                  </Box>
                </Box>
              )}
          </Box>
        </DialogContent>
        
        <DialogActions sx={{ p: 3, justifyContent: 'flex-end' }}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleResetPromptInModal}
            startIcon={<RestoreIcon />}
          >
            Zurücksetzen
          </Button>

          <Button
            variant="contained"
            onClick={handleSavePromptInModal}
            startIcon={<SaveIcon />}
          >
            Speichern
          </Button>
          
          <Button
            variant="outlined"
            color="primary"
            onClick={() => handleTestSinglePrompt(
              editingPromptText,
              originalPromptName || 'Unbekannt',
              editingPromptVersion,
              editingPromptTemperature,
              editingPromptMaxTokens
            )}
            disabled={isTesting}
            startIcon={isTesting ? <CircularProgress size={16} /> : <AutoFixHighIcon />}
          >
            {isTesting ? 'Teste...' : 'Prompt testen'}
          </Button>
          
          <Button
            variant="outlined"
            onClick={handleClosePromptEditor}
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            Schließen
          </Button>
        </DialogActions>
      </Dialog>

      {/* Versions-Info Modal */}
      <Dialog
        open={showVersionInfo}
        onClose={() => setShowVersionInfo(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
          color: 'white',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ color: 'white', fontWeight: 600 }}>
              Versionsinformationen
            </Typography>
            <IconButton onClick={() => setShowVersionInfo(false)} sx={{ color: 'white' }}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box sx={{ 
              p: 2, 
              border: '1px solid #e2e8f0', 
              borderRadius: 2, 
              backgroundColor: '#f8fafc' 
            }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b', mb: 1 }}>
                Frontend Information
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography variant="body1" sx={{ color: '#475569', fontWeight: 500 }}>
                  Version: {frontendVersion}
                </Typography>
                <Typography variant="body2" sx={{ color: '#64748b' }}>
                  Deployment: {new Date(buildTime).toLocaleString('de-DE')}
                </Typography>
              </Box>
            </Box>
            
            <Box sx={{ 
              p: 2, 
              border: '1px solid #e2e8f0', 
              borderRadius: 2, 
              backgroundColor: '#f8fafc' 
            }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b', mb: 1 }}>
                Backend Version
              </Typography>
              {loadingVersionInfo ? (
                <CircularProgress size={16} />
              ) : backendVersionInfo ? (
                <Box>
                  <Typography variant="body1" sx={{ color: '#475569', mb: 1 }}>
                    Version: {backendVersionInfo.backend.version}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#64748b' }}>
                    Deployment: {new Date(backendVersionInfo.backend.deploymentTime).toLocaleString('de-DE')}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#64748b' }}>
                    Function: {backendVersionInfo.backend.functionVersion}
                  </Typography>
                </Box>
              ) : (
                <Typography variant="body2" sx={{ color: '#64748b' }}>
                  Versionsinfo nicht verfügbar
                </Typography>
              )}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <Button
            variant="outlined"
            onClick={() => setShowVersionInfo(false)}
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            Schließen
          </Button>
        </DialogActions>
      </Dialog>

      {/* Kernkompetenzen Modal */}
      <Dialog
        open={showCoreCompetenciesModal}
        onClose={() => {
          scheduleCvPreviewDataSave();
          setShowCoreCompetenciesModal(false);
        }}
        TransitionProps={{
          onExited: () => {
            window.dispatchEvent(new CustomEvent('modalClosed'));
            // Zweiter Reflow-Pass, falls sich nach dem Close noch Zeilenumbrüche/Höhen stabilisieren
            setTimeout(() => {
              window.dispatchEvent(new CustomEvent('refreshTemplate'));
            }, 180);
          }
        }}
        maxWidth="sm"
        sx={{ zIndex: 1800 }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.25)'
          }
        }}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '600px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
            <TextField
              key={`title-core-competencies-${currentCoreCompetenciesTitle || ''}`}
              defaultValue={currentCoreCompetenciesTitle}
              onBlur={(e) => {
                const nextValue = e.target.value;
                if (nextValue !== currentCoreCompetenciesTitle) {
                  setCurrentCoreCompetenciesTitle(nextValue);
                }
              }}
              variant="standard"
                        sx={{
                          flex: 1,
                          mr: 4,
                          '& .MuiInput-root': {
                            fontSize: '1.25rem',
                            fontWeight: 700,
                            color: 'white',
                            textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                            '&:before': { borderBottom: 'none' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
                            '&:after': { borderBottom: '2px solid white' }
                          }
                        }}
            />
            <IconButton 
              onClick={() => {
                scheduleCvPreviewDataSave();
                setShowCoreCompetenciesModal(false);
              }}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 5, overflowX: 'hidden' }}>
          {/* Sichtbarkeits-Schalter */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showCoreCompetenciesInCv}
                  onChange={(e) => setShowCoreCompetenciesInCv(e.target.checked)}
                  sx={{
                    color: '#667eea',
                    '&.Mui-checked': {
                      color: '#667eea',
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                  {getTranslatedCvLabel('Kernkompetenzen im CV-Template anzeigen')}
                </Typography>
              }
            />
          </Box>
          
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="body2" sx={{ color: '#64748b' }}>
              {getTranslatedCvLabel('Hier sind alle optimierten Kernkompetenzen aus Ihren CV-Daten:')}
            </Typography>
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddIcon />}
              onClick={() => {
                setShowAvailableCoreCompetenciesModal(true);
              }}
              sx={{ 
                borderColor: '#3b82f6',
                color: '#3b82f6',
                '&:hover': { 
                  borderColor: '#2563eb',
                  backgroundColor: 'rgba(59, 130, 246, 0.04)'
                }
              }}
            >
              {getTranslatedCvLabel('Hinzufügen')}
            </Button>
          </Box>
          
          <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                    {getTranslatedCvLabel('Kernkompetenz')}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                    {getTranslatedCvLabel('Aktionen')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(relevantCoreCompetencies || []).map((comp: any, index: number) => (
                  <TableRow key={index} hover>
                    <TableCell>
                      <TextField
                        key={`rel-core-${index}-${comp.competency || comp || ''}`}
                        defaultValue={comp.competency || comp}
                        onBlur={(e) => {
                          const nextValue = e.target.value;
                          const currentValue = comp.competency || comp || '';
                          if (nextValue !== currentValue) {
                            setRelevantCoreCompetencies(prev => 
                              prev.map((item, i) => 
                                i === index ? { ...item, competency: nextValue } : item
                              )
                            );
                          }
                        }}
                        variant="standard"
                        fullWidth
                        multiline
                        sx={{ 
                          '& .MuiInput-root': { 
                            fontSize: '0.875rem',
                            '&:before': { borderBottom: '1px solid #e0e0e0' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                            '&:after': { borderBottom: '2px solid #1976d2' }
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setRelevantCoreCompetencies(prev => 
                            prev.filter((_, i) => i !== index)
                          );
                        }}
                        sx={{ 
                          color: '#94a3b8',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            color: '#ef4444',
                            bgcolor: '#fef2f2',
                            transform: 'scale(1.1)'
                          }
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                {(!relevantCoreCompetencies || relevantCoreCompetencies.length === 0) && (
                  <TableRow>
                    <TableCell colSpan={2} sx={{ textAlign: 'center', color: '#64748b', fontStyle: 'italic' }}>
                      {getTranslatedCvLabel('Keine Kernkompetenzen verfügbar')}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => {
              scheduleCvPreviewDataSave();
              setShowCoreCompetenciesModal(false);
            }}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal für verfügbare Kernkompetenzen */}
      <Dialog
        open={showAvailableCoreCompetenciesModal}
        onClose={() => {
          setShowAvailableCoreCompetenciesModal(false);
          // Trigger Seitenberechnung im CV-Template
          window.dispatchEvent(new CustomEvent('modalClosed'));
        }}
        maxWidth="md"
        sx={{ zIndex: 1900 }}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '700px',
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          py: 3,
          position: 'relative'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6" sx={{ fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              {getTranslatedCvLabel('Verfügbare Kernkompetenzen aus CV-Daten')}
            </Typography>
            <IconButton 
              onClick={() => {
                setShowAvailableCoreCompetenciesModal(false);
                // Trigger Seitenberechnung im CV-Template
                window.dispatchEvent(new CustomEvent('modalClosed'));
              }}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 3 }}>
          <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
            {getTranslatedCvLabel('Wählen Sie Kernkompetenzen aus, die Sie zum CV-Template hinzufügen möchten:')}
          </Typography>
          
          {getAvailableCoreCompetencies().length > 0 ? (
            <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                      {getTranslatedCvLabel('Kernkompetenz')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                      {getTranslatedCvLabel('Aktionen')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getAvailableCoreCompetencies().map((comp: any, index: number) => (
                    <TableRow key={index} hover>
                      <TableCell>{comp.competency || '-'}</TableCell>
                      <TableCell>
                        <IconButton
                          size="small"
                          onClick={() => {
                            // Füge die Kernkompetenz zu relevantCoreCompetencies hinzu
                            setRelevantCoreCompetencies(prev => [...prev, comp]);
                          }}
                          sx={{ 
                            color: '#10b981',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                              color: '#059669',
                              bgcolor: '#f0fdf4',
                              transform: 'scale(1.1)'
                            }
                          }}
                        >
                          <AddIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <Typography variant="body2" sx={{ color: '#64748b', fontStyle: 'italic' }}>
                {getTranslatedCvLabel('Alle Kernkompetenzen sind bereits im CV-Template enthalten')}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => {
              setShowAvailableCoreCompetenciesModal(false);
              // Trigger Seitenberechnung im CV-Template
              window.dispatchEvent(new CustomEvent('modalClosed'));
            }}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Zertifizierungen Modal */}
      <Dialog
        open={showCertificationsModal}
        onClose={() => {
          scheduleCvPreviewDataSave();
          setShowCertificationsModal(false);
        }}
        TransitionProps={{
          onExited: () => {
            window.dispatchEvent(new CustomEvent('modalClosed'));
            // Zweiter Reflow-Pass, falls sich nach dem Close noch Zeilenumbrüche/Höhen stabilisieren
            setTimeout(() => {
              window.dispatchEvent(new CustomEvent('refreshTemplate'));
            }, 180);
          }
        }}
        maxWidth="sm"
        sx={{ zIndex: 1800 }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.25)'
          }
        }}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '600px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
            <TextField
              key={`title-certifications-${currentCertificationsTitle || ''}`}
                        defaultValue={currentCertificationsTitle}
                        onBlur={(e) => {
                          const nextValue = e.target.value;
                          if (nextValue !== currentCertificationsTitle) {
                            setCurrentCertificationsTitle(nextValue);
                          }
                        }}
                        variant="standard"
                        sx={{
                          flex: 1,
                          mr: 4,
                          '& .MuiInput-root': {
                            fontSize: '1.25rem',
                            fontWeight: 700,
                            color: 'white',
                            textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                            '&:before': { borderBottom: 'none' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
                            '&:after': { borderBottom: '2px solid white' }
                          }
                        }}
            />
            <IconButton 
              onClick={() => {
                scheduleCvPreviewDataSave();
                setShowCertificationsModal(false);
              }}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 5, overflowX: 'hidden' }}>
          {/* Sichtbarkeits-Schalter */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showCertificationsInCv}
                  onChange={(e) => setShowCertificationsInCv(e.target.checked)}
                  sx={{
                    color: '#667eea',
                    '&.Mui-checked': {
                      color: '#667eea',
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                  {getTranslatedCvLabel('Zertifizierungen im CV-Template anzeigen')}
                </Typography>
              }
            />
          </Box>
          
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="body2" sx={{ color: '#64748b' }}>
              {getTranslatedCvLabel('Hier sind alle optimierten Zertifizierungen aus Ihren CV-Daten:')}
            </Typography>
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddIcon />}
              onClick={() => {
                setShowAvailableCertificationsModal(true);
              }}
              sx={{ 
                borderColor: '#3b82f6',
                color: '#3b82f6',
                '&:hover': { 
                  borderColor: '#2563eb',
                  backgroundColor: 'rgba(59, 130, 246, 0.04)'
                }
              }}
            >
              {getTranslatedCvLabel('Hinzufügen')}
            </Button>
          </Box>
          
          <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                    {getTranslatedCvLabel('Zertifizierung')}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                    {getTranslatedCvLabel('Aktionen')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(relevantCertifications || []).map((cert: any, index: number) => (
                  <TableRow key={index} hover>
                    <TableCell>
                      <TextField
                        key={`rel-cert-${index}-${cert.name || cert || ''}`}
                        defaultValue={cert.name || cert}
                        onBlur={(e) => {
                          const nextValue = e.target.value;
                          const currentValue = cert.name || cert || '';
                          if (nextValue !== currentValue) {
                            setRelevantCertifications(prev => 
                              prev.map((item, i) => 
                                i === index ? { ...item, name: nextValue } : item
                              )
                            );
                          }
                        }}
                        variant="standard"
                        fullWidth
                        multiline
                        sx={{ 
                          '& .MuiInput-root': { 
                            fontSize: '0.875rem',
                            '&:before': { borderBottom: '1px solid #e0e0e0' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                            '&:after': { borderBottom: '2px solid #1976d2' }
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setRelevantCertifications(prev => 
                            prev.filter((_, i) => i !== index)
                          );
                        }}
                        sx={{ 
                          color: '#94a3b8',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            color: '#ef4444',
                            bgcolor: '#fef2f2',
                            transform: 'scale(1.1)'
                          }
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                {(!relevantCertifications || relevantCertifications.length === 0) && (
                  <TableRow>
                    <TableCell colSpan={2} sx={{ textAlign: 'center', color: '#64748b', fontStyle: 'italic' }}>
                      {getTranslatedCvLabel('Keine Zertifizierungen verfügbar')}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => {
              scheduleCvPreviewDataSave();
              setShowCertificationsModal(false);
            }}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal für verfügbare Zertifizierungen */}
      <Dialog
        open={showAvailableCertificationsModal}
        onClose={() => {
          setShowAvailableCertificationsModal(false);
          // Trigger Seitenberechnung im CV-Template
          window.dispatchEvent(new CustomEvent('modalClosed'));
        }}
        maxWidth="md"
        sx={{ zIndex: 1900 }}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '700px',
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          py: 3,
          position: 'relative'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6" sx={{ fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              {getTranslatedCvLabel('Verfügbare Zertifizierungen aus CV-Daten')}
            </Typography>
            <IconButton 
              onClick={() => {
                setShowAvailableCertificationsModal(false);
                // Trigger Seitenberechnung im CV-Template
                window.dispatchEvent(new CustomEvent('modalClosed'));
              }}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 3 }}>
          <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
            {getTranslatedCvLabel('Wählen Sie Zertifizierungen aus, die Sie zum CV-Template hinzufügen möchten:')}
          </Typography>
          
          {getAvailableCertifications().length > 0 ? (
            <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                      {getTranslatedCvLabel('Zertifizierung')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '200px' }}>
                      {getTranslatedCvLabel('Beschreibung')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '150px' }}>
                      {getTranslatedCvLabel('Aussteller')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '100px' }}>
                      {getTranslatedCvLabel('Datum')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                      {getTranslatedCvLabel('Aktionen')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getAvailableCertifications().map((cert: any, index: number) => (
                    <TableRow key={index} hover>
                      <TableCell>{cert.name || '-'}</TableCell>
                      <TableCell>{cert.description || '-'}</TableCell>
                      <TableCell>{cert.issuer || '-'}</TableCell>
                      <TableCell>{cert.date || '-'}</TableCell>
                      <TableCell>
                        <IconButton
                          size="small"
                          onClick={() => {
                            // Füge die Zertifizierung zu relevantCertifications hinzu
                            setRelevantCertifications(prev => [...prev, cert]);
                          }}
                          sx={{ 
                            color: '#10b981',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                              color: '#059669',
                              bgcolor: '#f0fdf4',
                              transform: 'scale(1.1)'
                            }
                          }}
                        >
                          <AddIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <Typography variant="body2" sx={{ color: '#64748b', fontStyle: 'italic' }}>
                {getTranslatedCvLabel('Alle Zertifizierungen sind bereits im CV-Template enthalten')}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => {
              setShowAvailableCertificationsModal(false);
              // Trigger Seitenberechnung im CV-Template
              window.dispatchEvent(new CustomEvent('modalClosed'));
            }}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* IT-Skills Modal */}
      <Dialog
        open={showItSkillsModal}
        onClose={() => {
          scheduleCvPreviewDataSave();
          setShowItSkillsModal(false);
        }}
        TransitionProps={{
          onExited: () => {
            window.dispatchEvent(new CustomEvent('modalClosed'));
            // Zweiter Reflow-Pass, falls sich nach dem Close noch Zeilenumbrüche/Höhen stabilisieren
            setTimeout(() => {
              window.dispatchEvent(new CustomEvent('refreshTemplate'));
            }, 180);
          }
        }}
        maxWidth="sm"
        sx={{ zIndex: 1800 }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.25)'
          }
        }}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '600px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
            <TextField
              key={`title-it-skills-${currentItSkillsTitle || ''}`}
              defaultValue={currentItSkillsTitle}
              onBlur={(e) => {
                const nextValue = e.target.value;
                if (nextValue !== currentItSkillsTitle) {
                  setCurrentItSkillsTitle(nextValue);
                }
              }}
              variant="standard"
                        sx={{
                          flex: 1,
                          mr: 4,
                          '& .MuiInput-root': {
                            fontSize: '1.25rem',
                            fontWeight: 700,
                            color: 'white',
                            textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                            '&:before': { borderBottom: 'none' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
                            '&:after': { borderBottom: '2px solid white' }
                          }
                        }}
            />
            <IconButton 
              onClick={() => {
                scheduleCvPreviewDataSave();
                setShowItSkillsModal(false);
              }}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 5, overflowX: 'hidden' }}>
          {/* Sichtbarkeits-Schalter */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showItSkillsInCv}
                  onChange={(e) => setShowItSkillsInCv(e.target.checked)}
                  sx={{
                    color: '#667eea',
                    '&.Mui-checked': {
                      color: '#667eea',
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                  {getTranslatedCvLabel('IT-Skills im CV-Template anzeigen')}
                </Typography>
              }
            />
          </Box>
          
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="body2" sx={{ color: '#64748b' }}>
              {getTranslatedCvLabel('Hier sind alle optimierten IT-Skills aus Ihren CV-Daten:')}
            </Typography>
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddIcon />}
              onClick={() => {
                setShowAvailableItSkillsModal(true);
              }}
              sx={{ 
                borderColor: '#3b82f6',
                color: '#3b82f6',
                '&:hover': { 
                  borderColor: '#2563eb',
                  backgroundColor: 'rgba(59, 130, 246, 0.04)'
                }
              }}
            >
              {getTranslatedCvLabel('Hinzufügen')}
            </Button>
          </Box>
          
          <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                    {getTranslatedCvLabel('IT-Skill')}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                    {getTranslatedCvLabel('Aktionen')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(relevantItSkills || []).map((skill: any, index: number) => (
                  <TableRow key={index} hover>
                    <TableCell>
                      <TextField
                        key={`rel-it-${index}-${skill.skill || skill || ''}`}
                        defaultValue={skill.skill || skill}
                        onBlur={(e) => {
                          const nextValue = e.target.value;
                          const currentValue = skill.skill || skill || '';
                          if (nextValue !== currentValue) {
                            setRelevantItSkills(prev => 
                              prev.map((item, i) => 
                                i === index ? { ...item, skill: nextValue } : item
                              )
                            );
                          }
                        }}
                        variant="standard"
                        fullWidth
                        multiline
                        sx={{ 
                          '& .MuiInput-root': { 
                            fontSize: '0.875rem',
                            '&:before': { borderBottom: '1px solid #e0e0e0' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                            '&:after': { borderBottom: '2px solid #1976d2' }
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setRelevantItSkills(prev => 
                            prev.filter((_, i) => i !== index)
                          );
                        }}
                        sx={{ 
                          color: '#94a3b8',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            color: '#ef4444',
                            bgcolor: '#fef2f2',
                            transform: 'scale(1.1)'
                          }
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                {(!relevantItSkills || relevantItSkills.length === 0) && (
                  <TableRow>
                    <TableCell colSpan={2} sx={{ textAlign: 'center', color: '#64748b', fontStyle: 'italic' }}>
                      {getTranslatedCvLabel('Keine IT-Skills verfügbar')}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => {
              scheduleCvPreviewDataSave();
              setShowItSkillsModal(false);
            }}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal für verfügbare IT-Skills */}
      <Dialog
        open={showAvailableItSkillsModal}
        onClose={() => {
          setShowAvailableItSkillsModal(false);
          // Trigger Seitenberechnung im CV-Template
          window.dispatchEvent(new CustomEvent('modalClosed'));
        }}
        maxWidth="md"
        sx={{ zIndex: 1900 }}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '700px',
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          py: 3,
          position: 'relative'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6" sx={{ fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              {getTranslatedCvLabel('Verfügbare IT-Skills aus CV-Daten')}
            </Typography>
            <IconButton 
              onClick={() => {
                setShowAvailableItSkillsModal(false);
                // Trigger Seitenberechnung im CV-Template
                window.dispatchEvent(new CustomEvent('modalClosed'));
              }}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 3 }}>
          <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
            {getTranslatedCvLabel('Wählen Sie IT-Skills aus, die Sie zum CV-Template hinzufügen möchten:')}
          </Typography>
          
          {getAvailableItSkills().length > 0 ? (
            <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                      {getTranslatedCvLabel('Skill')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '150px' }}>
                      {getTranslatedCvLabel('Level')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                      {getTranslatedCvLabel('Aktionen')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getAvailableItSkills().map((skill: any, index: number) => (
                    <TableRow key={index} hover>
                      <TableCell>{skill.skill || '-'}</TableCell>
                      <TableCell>{skill.level || '-'}</TableCell>
                      <TableCell>
                        <IconButton
                          size="small"
                          onClick={() => {
                            // Füge den IT-Skill zu relevantItSkills hinzu
                            setRelevantItSkills(prev => [...prev, skill]);
                          }}
                          sx={{ 
                            color: '#10b981',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                              color: '#059669',
                              bgcolor: '#f0fdf4',
                              transform: 'scale(1.1)'
                            }
                          }}
                        >
                          <AddIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <Typography variant="body2" sx={{ color: '#64748b', fontStyle: 'italic' }}>
                {getTranslatedCvLabel('Alle IT-Skills sind bereits im CV-Template enthalten')}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => {
              setShowAvailableItSkillsModal(false);
              // Trigger Seitenberechnung im CV-Template
              window.dispatchEvent(new CustomEvent('modalClosed'));
            }}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Branchen Modal */}
      <Dialog
        open={showIndustriesModal}
        onClose={() => {
          scheduleCvPreviewDataSave();
          setShowIndustriesModal(false);
        }}
        TransitionProps={{
          onExited: () => {
            window.dispatchEvent(new CustomEvent('modalClosed'));
            // Zweiter Reflow-Pass, falls sich nach dem Close noch Zeilenumbrüche/Höhen stabilisieren
            setTimeout(() => {
              window.dispatchEvent(new CustomEvent('refreshTemplate'));
            }, 180);
          }
        }}
        maxWidth="sm"
        sx={{ zIndex: 1800 }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.25)'
          }
        }}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '600px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
            <TextField
              key={`title-industries-${currentIndustriesTitle || ''}`}
              defaultValue={currentIndustriesTitle}
              onBlur={(e) => {
                const nextValue = e.target.value;
                if (nextValue !== currentIndustriesTitle) {
                  setCurrentIndustriesTitle(nextValue);
                }
              }}
              variant="standard"
                        sx={{
                          flex: 1,
                          mr: 4,
                          '& .MuiInput-root': {
                            fontSize: '1.25rem',
                            fontWeight: 700,
                            color: 'white',
                            textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                            '&:before': { borderBottom: 'none' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
                            '&:after': { borderBottom: '2px solid white' }
                          }
                        }}
            />
            <IconButton 
              onClick={() => {
                scheduleCvPreviewDataSave();
                setShowIndustriesModal(false);
              }}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 5, overflowX: 'hidden' }}>
          {/* Sichtbarkeits-Schalter */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showIndustriesInCv}
                  onChange={(e) => setShowIndustriesInCv(e.target.checked)}
                  sx={{
                    color: '#667eea',
                    '&.Mui-checked': {
                      color: '#667eea',
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                  {getTranslatedCvLabel('Branchen im CV-Template anzeigen')}
                </Typography>
              }
            />
          </Box>
          
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="body2" sx={{ color: '#64748b' }}>
              {getTranslatedCvLabel('Hier sind alle optimierten Branchen aus Ihren CV-Daten:')}
            </Typography>
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddIcon />}
              onClick={() => {
                setShowAvailableIndustriesModal(true);
              }}
              sx={{ 
                borderColor: '#3b82f6',
                color: '#3b82f6',
                '&:hover': { 
                  borderColor: '#2563eb',
                  backgroundColor: 'rgba(59, 130, 246, 0.04)'
                }
              }}
            >
              {getTranslatedCvLabel('Hinzufügen')}
            </Button>
          </Box>
          
          <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                    {getTranslatedCvLabel('Branche')}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '120px' }}>
                    {translatedYears}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                    {getTranslatedCvLabel('Aktionen')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(relevantIndustries || []).map((industry: any, index: number) => (
                  <TableRow key={index} hover>
                    <TableCell>
                      <TextField
                        key={`rel-industry-name-${index}-${industry.industry || industry || ''}`}
                        defaultValue={industry.industry || industry}
                        onBlur={(e) => {
                          const nextValue = e.target.value;
                          const currentValue = industry.industry || industry || '';
                          if (nextValue !== currentValue) {
                            setRelevantIndustries(prev => 
                              prev.map((item, i) => 
                                i === index ? { ...item, industry: nextValue } : item
                              )
                            );
                          }
                        }}
                        variant="standard"
                        fullWidth
                        sx={{ 
                          '& .MuiInput-root': { 
                            fontSize: '0.875rem',
                            '&:before': { borderBottom: '1px solid #e0e0e0' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                            '&:after': { borderBottom: '2px solid #1976d2' }
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        key={`rel-industry-years-${index}-${industry.years || ''}`}
                        defaultValue={industry.years || ''}
                        onBlur={(e) => {
                          const nextValue = e.target.value;
                          const currentValue = industry.years || '';
                          if (nextValue !== currentValue) {
                            setRelevantIndustries(prev => 
                              prev.map((item, i) => 
                                i === index ? { ...item, years: nextValue } : item
                              )
                            );
                          }
                        }}
                        variant="standard"
                        fullWidth
                        placeholder={translatedYears}
                        sx={{ 
                          '& .MuiInput-root': { 
                            fontSize: '0.875rem',
                            '&:before': { borderBottom: '1px solid #e0e0e0' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                            '&:after': { borderBottom: '2px solid #1976d2' }
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setRelevantIndustries(prev => 
                            prev.filter((_, i) => i !== index)
                          );
                        }}
                        sx={{ 
                          color: '#94a3b8',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            color: '#ef4444',
                            bgcolor: '#fef2f2',
                            transform: 'scale(1.1)'
                          }
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                {(!relevantIndustries || relevantIndustries.length === 0) && (
                  <TableRow>
                    <TableCell colSpan={3} sx={{ textAlign: 'center', color: '#64748b', fontStyle: 'italic' }}>
                      {getTranslatedCvLabel('Keine Branchen verfügbar')}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => {
              scheduleCvPreviewDataSave();
              setShowIndustriesModal(false);
            }}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal für verfügbare Branchen */}
      <Dialog
        open={showAvailableIndustriesModal}
        onClose={() => {
          setShowAvailableIndustriesModal(false);
          // Trigger Seitenberechnung im CV-Template
          window.dispatchEvent(new CustomEvent('modalClosed'));
        }}
        maxWidth="md"
        sx={{ zIndex: 1900 }}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '800px',
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          py: 3,
          position: 'relative'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6" sx={{ fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              {getTranslatedCvLabel('Verfügbare Branchen aus CV-Daten')}
            </Typography>
            <IconButton 
              onClick={() => {
                setShowAvailableIndustriesModal(false);
                // Trigger Seitenberechnung im CV-Template
                window.dispatchEvent(new CustomEvent('modalClosed'));
              }}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 3 }}>
          <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
            {getTranslatedCvLabel('Wählen Sie Branchen aus, die Sie zum CV-Template hinzufügen möchten:')}
          </Typography>
          
          {getAvailableIndustries().length > 0 ? (
            <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                      {getTranslatedCvLabel('Branche')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '100px' }}>
                      {getTranslatedCvLabel('Jahre')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                      {getTranslatedCvLabel('Aktionen')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getAvailableIndustries().map((industry: any, index: number) => (
                    <TableRow key={index} hover>
                      <TableCell>{industry.industry || '-'}</TableCell>
                      <TableCell>{industry.years || '-'}</TableCell>
                      <TableCell>
                        <IconButton
                          size="small"
                          onClick={() => {
                            // Füge die Branche zu relevantIndustries hinzu
                            setRelevantIndustries(prev => [...prev, industry]);
                          }}
                          sx={{ 
                            color: '#10b981',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                              color: '#059669',
                              bgcolor: '#f0fdf4',
                              transform: 'scale(1.1)'
                            }
                          }}
                        >
                          <AddIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <Typography variant="body2" sx={{ color: '#64748b', fontStyle: 'italic' }}>
                {getTranslatedCvLabel('Alle Branchen sind bereits im CV-Template enthalten')}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => {
              setShowAvailableIndustriesModal(false);
              // Trigger Seitenberechnung im CV-Template
              window.dispatchEvent(new CustomEvent('modalClosed'));
            }}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Sprachen Modal */}
      <Dialog
        open={showLanguagesModal}
        onClose={() => {
          scheduleCvPreviewDataSave();
          setShowLanguagesModal(false);
        }}
        TransitionProps={{
          onExited: () => {
            window.dispatchEvent(new CustomEvent('modalClosed'));
            // Zweiter Reflow-Pass, falls sich nach dem Close noch Zeilenumbrüche/Höhen stabilisieren
            setTimeout(() => {
              window.dispatchEvent(new CustomEvent('refreshTemplate'));
            }, 180);
          }
        }}
        maxWidth="sm"
        sx={{ zIndex: 1800 }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.25)'
          }
        }}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '600px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
            <TextField
              key={`title-languages-${currentLanguagesTitle || ''}`}
              defaultValue={currentLanguagesTitle}
              onBlur={(e) => {
                const nextValue = e.target.value;
                if (nextValue !== currentLanguagesTitle) {
                  setCurrentLanguagesTitle(nextValue);
                }
              }}
              variant="standard"
                        sx={{
                          flex: 1,
                          mr: 4,
                          '& .MuiInput-root': {
                            fontSize: '1.25rem',
                            fontWeight: 700,
                            color: 'white',
                            textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                            '&:before': { borderBottom: 'none' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
                            '&:after': { borderBottom: '2px solid white' }
                          }
                        }}
            />
            <IconButton 
              onClick={() => {
                scheduleCvPreviewDataSave();
                setShowLanguagesModal(false);
              }}
              size="small"
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 5, overflowX: 'hidden' }}>
          {/* Sichtbarkeits-Schalter */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showLanguagesInCv}
                  onChange={(e) => setShowLanguagesInCv(e.target.checked)}
                  sx={{
                    color: '#667eea',
                    '&.Mui-checked': {
                      color: '#667eea',
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                  {getTranslatedCvLabel('Sprachen im CV-Template anzeigen')}
                </Typography>
              }
            />
          </Box>
          
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="body2" sx={{ color: '#64748b' }}>
              {getTranslatedCvLabel('Hier sind alle optimierten Sprachen aus Ihren CV-Daten:')}
            </Typography>
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddIcon />}
              onClick={() => {
                setShowAvailableLanguagesModal(true);
              }}
              sx={{ 
                borderColor: '#3b82f6',
                color: '#3b82f6',
                '&:hover': { 
                  borderColor: '#2563eb',
                  backgroundColor: 'rgba(59, 130, 246, 0.04)'
                }
              }}
            >
              {getTranslatedCvLabel('Hinzufügen')}
            </Button>
          </Box>
          
          <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                    {getTranslatedCvLabel('Sprache')}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '120px' }}>
                    {getTranslatedCvLabel('Niveau')}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                    {getTranslatedCvLabel('Aktionen')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(relevantLanguages || []).map((language: any, index: number) => (
                  <TableRow key={index} hover>
                    <TableCell>
                      <TextField
                        key={`rel-language-name-${index}-${language.language || language || ''}`}
                        defaultValue={language.language || language}
                        onBlur={(e) => {
                          const nextValue = e.target.value;
                          const currentValue = language.language || language || '';
                          if (nextValue !== currentValue) {
                            setRelevantLanguages(prev => 
                              prev.map((item, i) => 
                                i === index ? { ...item, language: nextValue } : item
                              )
                            );
                          }
                        }}
                        variant="standard"
                        fullWidth
                        sx={{ 
                          '& .MuiInput-root': { 
                            fontSize: '0.875rem',
                            '&:before': { borderBottom: '1px solid #e0e0e0' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                            '&:after': { borderBottom: '2px solid #1976d2' }
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <Select
                        value={language.level || ''}
                        onChange={(e) => {
                          setRelevantLanguages(prev => 
                            prev.map((item, i) => 
                              i === index ? { ...item, level: e.target.value } : item
                            )
                          );
                          markCvDataAsChanged();
                        }}
                        variant="standard"
                        fullWidth
                        displayEmpty
                        sx={{ 
                          fontSize: '0.875rem',
                          '&:before': { borderBottom: '1px solid #e0e0e0' },
                          '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                          '&:after': { borderBottom: '2px solid #1976d2' }
                        }}
                      >
                        <MenuItem value="">{t('cv.languages.level.select')}</MenuItem>
                        <MenuItem value="A1">{t('cv.languages.level.A1')}</MenuItem>
                        <MenuItem value="A2">{t('cv.languages.level.A2')}</MenuItem>
                        <MenuItem value="B1">{t('cv.languages.level.B1')}</MenuItem>
                        <MenuItem value="B2">{t('cv.languages.level.B2')}</MenuItem>
                        <MenuItem value="C1">{t('cv.languages.level.C1')}</MenuItem>
                        <MenuItem value="C2">{t('cv.languages.level.C2')}</MenuItem>
                        <MenuItem value="native">{t('cv.languages.level.native')}</MenuItem>
                      </Select>
                    </TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setRelevantLanguages(prev => 
                            prev.filter((_, i) => i !== index)
                          );
                        }}
                        sx={{ 
                          color: '#94a3b8',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            color: '#ef4444',
                            bgcolor: '#fef2f2',
                            transform: 'scale(1.1)'
                          }
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                {(!relevantLanguages || relevantLanguages.length === 0) && (
                  <TableRow>
                    <TableCell colSpan={3} sx={{ textAlign: 'center', color: '#64748b', fontStyle: 'italic' }}>
                      {getTranslatedCvLabel('Keine Sprachen verfügbar')}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => {
              scheduleCvPreviewDataSave();
              setShowLanguagesModal(false);
            }}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal für verfügbare Sprachen */}
      <Dialog
        open={showAvailableLanguagesModal}
        onClose={() => {
          setShowAvailableLanguagesModal(false);
          // Trigger Seitenberechnung im CV-Template
          window.dispatchEvent(new CustomEvent('modalClosed'));
        }}
        maxWidth="md"
        sx={{ zIndex: 1900 }}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '700px',
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          py: 3,
          position: 'relative'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6" sx={{ fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              {getTranslatedCvLabel('Verfügbare Sprachen aus CV-Daten')}
            </Typography>
            <IconButton 
              onClick={() => {
                setShowAvailableLanguagesModal(false);
                // Trigger Seitenberechnung im CV-Template
                window.dispatchEvent(new CustomEvent('modalClosed'));
              }}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 3 }}>
          <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
            {getTranslatedCvLabel('Wählen Sie Sprachen aus, die Sie zum CV-Template hinzufügen möchten:')}
          </Typography>
          
          {getAvailableLanguages().length > 0 ? (
            <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                      {getTranslatedCvLabel('Sprache')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '150px' }}>
                      {getTranslatedCvLabel('Level')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                      {getTranslatedCvLabel('Aktionen')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getAvailableLanguages().map((lang: any, index: number) => (
                    <TableRow key={index} hover>
                      <TableCell>{lang.language || '-'}</TableCell>
                      <TableCell>{lang.level || '-'}</TableCell>
                      <TableCell>
                        <IconButton
                          size="small"
                          onClick={() => {
                            // Füge die Sprache zu relevantLanguages hinzu
                            setRelevantLanguages(prev => [...prev, lang]);
                          }}
                          sx={{ 
                            color: '#10b981',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                              color: '#059669',
                              bgcolor: '#f0fdf4',
                              transform: 'scale(1.1)'
                            }
                          }}
                        >
                          <AddIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <Typography variant="body2" sx={{ color: '#64748b', fontStyle: 'italic' }}>
                {getTranslatedCvLabel('Alle Sprachen sind bereits im CV-Template enthalten')}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => {
              setShowAvailableLanguagesModal(false);
              // Trigger Seitenberechnung im CV-Template
              window.dispatchEvent(new CustomEvent('modalClosed'));
            }}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Hobbies Modal */}
      <Dialog
        open={showHobbiesModal}
        onClose={() => {
          scheduleCvPreviewDataSave();
          setShowHobbiesModal(false);
        }}
        TransitionProps={{
          onExited: () => {
            window.dispatchEvent(new CustomEvent('modalClosed'));
            // Zweiter Reflow-Pass, falls sich nach dem Close noch Zeilenumbrüche/Höhen stabilisieren
            setTimeout(() => {
              window.dispatchEvent(new CustomEvent('refreshTemplate'));
            }, 180);
          }
        }}
        maxWidth="sm"
        sx={{ zIndex: 1800 }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.25)'
          }
        }}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '600px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
            <TextField
              key={`title-hobbies-${currentHobbiesTitle || ''}`}
              defaultValue={currentHobbiesTitle}
              onBlur={(e) => {
                const nextValue = e.target.value;
                if (nextValue !== currentHobbiesTitle) {
                  setCurrentHobbiesTitle(nextValue);
                }
              }}
              variant="standard"
                        sx={{
                          flex: 1,
                          mr: 4,
                          '& .MuiInput-root': {
                            fontSize: '1.25rem',
                            fontWeight: 700,
                            color: 'white',
                            textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                            '&:before': { borderBottom: 'none' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
                            '&:after': { borderBottom: '2px solid white' }
                          }
                        }}
            />
            <IconButton 
              onClick={() => {
                scheduleCvPreviewDataSave();
                setShowHobbiesModal(false);
              }}
              size="small"
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 5, overflowX: 'hidden' }}>
          {/* Sichtbarkeits-Schalter */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showHobbiesInCv}
                  onChange={(e) => setShowHobbiesInCv(e.target.checked)}
                  sx={{
                    color: '#667eea',
                    '&.Mui-checked': {
                      color: '#667eea',
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                  {getTranslatedCvLabel('Hobbies im CV-Template anzeigen')}
                </Typography>
              }
            />
          </Box>
          
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="body2" sx={{ color: '#64748b' }}>
              {getTranslatedCvLabel('Hier sind alle optimierten Hobbies aus Ihren CV-Daten:')}
            </Typography>
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddIcon />}
              onClick={() => {
                setShowAvailableHobbiesModal(true);
              }}
              sx={{ 
                borderColor: '#3b82f6',
                color: '#3b82f6',
                '&:hover': { 
                  borderColor: '#2563eb',
                  backgroundColor: 'rgba(59, 130, 246, 0.04)'
                }
              }}
            >
              {getTranslatedCvLabel('Hinzufügen')}
            </Button>
          </Box>
          
          <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                    {getTranslatedCvLabel('Hobby')}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                    {getTranslatedCvLabel('Aktionen')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(Array.isArray(relevantHobbies) ? relevantHobbies : []).map((hobby: any, index: number) => (
                  <TableRow key={index} hover>
                    <TableCell>
                      <TextField
                        key={`rel-hobby-${index}-${hobby.hobby || hobby || ''}`}
                        defaultValue={hobby.hobby || hobby}
                        onBlur={(e) => {
                          const nextValue = e.target.value;
                          const currentValue = hobby.hobby || hobby || '';
                          if (nextValue !== currentValue) {
                            setRelevantHobbies(prev => 
                              prev.map((item, i) => 
                                i === index ? { ...item, hobby: nextValue } : item
                              )
                            );
                          }
                        }}
                        variant="standard"
                        fullWidth
                        multiline
                        sx={{ 
                          '& .MuiInput-root': { 
                            fontSize: '0.875rem',
                            '&:before': { borderBottom: '1px solid #e0e0e0' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                            '&:after': { borderBottom: '2px solid #1976d2' }
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setRelevantHobbies(prev => 
                            prev.filter((_, i) => i !== index)
                          );
                        }}
                        sx={{ 
                          color: '#94a3b8',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            color: '#ef4444',
                            bgcolor: '#fef2f2',
                            transform: 'scale(1.1)'
                          }
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                {(!relevantHobbies || relevantHobbies.length === 0) && (
                  <TableRow>
                    <TableCell colSpan={2} sx={{ textAlign: 'center', color: '#64748b', fontStyle: 'italic' }}>
                      {getTranslatedCvLabel('Keine Hobbies verfügbar')}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => {
              scheduleCvPreviewDataSave();
              setShowHobbiesModal(false);
            }}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal für verfügbare Hobbys */}
      <Dialog
        open={showAvailableHobbiesModal}
        onClose={() => {
          setShowAvailableHobbiesModal(false);
          // Trigger Seitenberechnung im CV-Template
          window.dispatchEvent(new CustomEvent('modalClosed'));
        }}
        maxWidth="md"
        sx={{ zIndex: 1900 }}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '700px',
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          py: 3,
          position: 'relative'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6" sx={{ fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              {getTranslatedCvLabel('Verfügbare Hobbys aus CV-Daten')}
            </Typography>
            <IconButton 
              onClick={() => {
                setShowAvailableHobbiesModal(false);
                // Trigger Seitenberechnung im CV-Template
                window.dispatchEvent(new CustomEvent('modalClosed'));
              }}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 3 }}>
          <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
            {getTranslatedCvLabel('Wählen Sie Hobbys aus, die Sie zum CV-Template hinzufügen möchten:')}
          </Typography>
          
          {getAvailableHobbies().length > 0 ? (
            <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                      {getTranslatedCvLabel('Hobby')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '250px' }}>
                      {getTranslatedCvLabel('Beschreibung')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                      {getTranslatedCvLabel('Aktionen')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getAvailableHobbies().map((hobby: any, index: number) => (
                    <TableRow key={index} hover>
                      <TableCell sx={{ fontWeight: 600 }}>{hobby.hobby || '-'}</TableCell>
                      <TableCell>{hobby.description || '-'}</TableCell>
                      <TableCell>
                        <IconButton
                          size="small"
                          onClick={() => {
                            // Verhindere doppelte Einträge auch bei gemischten Datenformaten (String/Objekt).
                            setRelevantHobbies(prev => {
                              const hobbyKey = normalizeHobbyValue(hobby);
                              if (!hobbyKey) return prev;
                              const alreadyExists = prev.some(item => isSameHobbyEntry(item, hobby));
                              return alreadyExists ? prev : [...prev, normalizeHobbyItem(hobby)];
                            });
                          }}
                          sx={{ 
                            color: '#10b981',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                              color: '#059669',
                              bgcolor: '#f0fdf4',
                              transform: 'scale(1.1)'
                            }
                          }}
                        >
                          <AddIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <Typography variant="body2" sx={{ color: '#64748b', fontStyle: 'italic' }}>
                {getTranslatedCvLabel('Alle Hobbys sind bereits im CV-Template enthalten')}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => {
              setShowAvailableHobbiesModal(false);
              // Trigger Seitenberechnung im CV-Template
              window.dispatchEvent(new CustomEvent('modalClosed'));
            }}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Weitere Angaben Modal */}
      <Dialog
        open={showAdditionalInfoModal}
        onClose={() => {
          scheduleCvPreviewDataSave();
          setShowAdditionalInfoModal(false);
        }}
        TransitionProps={{
          onExited: () => {
            window.dispatchEvent(new CustomEvent('modalClosed'));
            // Zweiter Reflow-Pass, falls sich nach dem Close noch Zeilenumbrüche/Höhen stabilisieren
            setTimeout(() => {
              window.dispatchEvent(new CustomEvent('refreshTemplate'));
            }, 180);
          }
        }}
        maxWidth="sm"
        sx={{ zIndex: 1800 }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.25)'
          }
        }}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '600px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
            <TextField
              key={`title-additional-info-${currentAdditionalInfoTitle || ''}`}
              defaultValue={currentAdditionalInfoTitle}
              onBlur={(e) => {
                const nextValue = e.target.value;
                if (nextValue !== currentAdditionalInfoTitle) {
                  setCurrentAdditionalInfoTitle(nextValue);
                }
              }}
              variant="standard"
                        sx={{
                          flex: 1,
                          mr: 4,
                          '& .MuiInput-root': {
                            fontSize: '1.25rem',
                            fontWeight: 700,
                            color: 'white',
                            textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                            '&:before': { borderBottom: 'none' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
                            '&:after': { borderBottom: '2px solid white' }
                          }
                        }}
            />
            <IconButton 
              onClick={() => {
                scheduleCvPreviewDataSave();
                setShowAdditionalInfoModal(false);
              }}
              size="small"
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 5, overflowX: 'hidden' }}>
          {/* Sichtbarkeits-Schalter */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showAdditionalInfoInCv}
                  onChange={(e) => setShowAdditionalInfoInCv(e.target.checked)}
                  sx={{
                    color: '#667eea',
                    '&.Mui-checked': {
                      color: '#667eea',
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                  {getTranslatedCvLabel('Weitere Angaben im CV-Template anzeigen')}
                </Typography>
              }
            />
          </Box>
          
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="body2" sx={{ color: '#64748b' }}>
              {getTranslatedCvLabel('Hier sind alle optimierten Weitere Angaben aus Ihren CV-Daten:')}
            </Typography>
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddIcon />}
              onClick={() => {
                setShowAvailableAdditionalInfoModal(true);
              }}
              sx={{ 
                borderColor: '#3b82f6',
                color: '#3b82f6',
                '&:hover': { 
                  borderColor: '#2563eb',
                  backgroundColor: 'rgba(59, 130, 246, 0.04)'
                }
              }}
            >
              {getTranslatedCvLabel('Hinzufügen')}
            </Button>
          </Box>
          
          <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                    {getTranslatedCvLabel('Info')}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                    {getTranslatedCvLabel('Details')}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                    {getTranslatedCvLabel('Aktionen')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(Array.isArray(relevantAdditionalInfo) ? relevantAdditionalInfo : []).map((item: any, index: number) => (
                  <TableRow key={index} hover>
                    <TableCell>
                      <TextField
                        key={`rel-info-title-${index}-${item.info || ''}`}
                        defaultValue={item.info || ''}
                        onBlur={(e) => {
                          const nextValue = e.target.value;
                          const currentValue = item.info || '';
                          if (nextValue !== currentValue) {
                            setRelevantAdditionalInfo(prev => 
                              prev.map((infoItem, i) => 
                                i === index ? { ...infoItem, info: nextValue } : infoItem
                              )
                            );
                          }
                        }}
                        variant="standard"
                        fullWidth
                        multiline
                        sx={{ 
                          '& .MuiInput-root': { 
                            fontSize: '0.875rem',
                            '&:before': { borderBottom: '1px solid #e0e0e0' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                            '&:after': { borderBottom: '2px solid #1976d2' }
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        key={`rel-info-details-${index}-${item.details || ''}`}
                        defaultValue={item.details || ''}
                        onBlur={(e) => {
                          const nextValue = e.target.value;
                          const currentValue = item.details || '';
                          if (nextValue !== currentValue) {
                            setRelevantAdditionalInfo(prev => 
                              prev.map((infoItem, i) => 
                                i === index ? { ...infoItem, details: nextValue } : infoItem
                              )
                            );
                          }
                        }}
                        variant="standard"
                        fullWidth
                        multiline
                        sx={{ 
                          '& .MuiInput-root': { 
                            fontSize: '0.875rem',
                            '&:before': { borderBottom: '1px solid #e0e0e0' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                            '&:after': { borderBottom: '2px solid #1976d2' }
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setRelevantAdditionalInfo(prev => 
                            prev.filter((_, i) => i !== index)
                          );
                        }}
                        sx={{ 
                          color: '#94a3b8',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            color: '#ef4444',
                            bgcolor: '#fef2f2',
                            transform: 'scale(1.1)'
                          }
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                {(!relevantAdditionalInfo || relevantAdditionalInfo.length === 0) && (
                  <TableRow>
                    <TableCell colSpan={3} sx={{ textAlign: 'center', color: '#64748b', fontStyle: 'italic' }}>
                      {getTranslatedCvLabel('Keine Weitere Angaben verfügbar')}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => {
              scheduleCvPreviewDataSave();
              setShowAdditionalInfoModal(false);
            }}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal für verfügbare Weitere Angaben */}
      <Dialog
        open={showAvailableAdditionalInfoModal}
        onClose={() => {
          setShowAvailableAdditionalInfoModal(false);
          // Trigger Seitenberechnung im CV-Template
          window.dispatchEvent(new CustomEvent('modalClosed'));
        }}
        maxWidth="md"
        sx={{ zIndex: 1900 }}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '700px',
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          py: 3,
          position: 'relative'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6" sx={{ fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              {getTranslatedCvLabel('Verfügbare Weitere Angaben aus CV-Daten')}
            </Typography>
            <IconButton 
              onClick={() => {
                setShowAvailableAdditionalInfoModal(false);
                // Trigger Seitenberechnung im CV-Template
                window.dispatchEvent(new CustomEvent('modalClosed'));
              }}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 3 }}>
          <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
            {getTranslatedCvLabel('Wählen Sie Weitere Angaben aus, die Sie zum CV-Template hinzufügen möchten:')}
          </Typography>
          
          {getAvailableAdditionalInfo().length > 0 ? (
            <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                      {getTranslatedCvLabel('Info')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '250px' }}>
                      {getTranslatedCvLabel('Details')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                      {getTranslatedCvLabel('Aktionen')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getAvailableAdditionalInfo().map((info: any, index: number) => (
                    <TableRow key={index} hover>
                      <TableCell>{info.info || '-'}</TableCell>
                      <TableCell>{info.details || '-'}</TableCell>
                      <TableCell>
                        <IconButton
                          size="small"
                          onClick={() => {
                            // Füge die Weitere Angabe zu relevantAdditionalInfo hinzu
                            setRelevantAdditionalInfo(prev => [...prev, info]);
                          }}
                          sx={{ 
                            color: '#10b981',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                              color: '#059669',
                              bgcolor: '#f0fdf4',
                              transform: 'scale(1.1)'
                            }
                          }}
                        >
                          <AddIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <Typography variant="body2" sx={{ color: '#64748b', fontStyle: 'italic' }}>
                {getTranslatedCvLabel('Alle Weiteren Angaben sind bereits im CV-Template enthalten')}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => {
              setShowAvailableAdditionalInfoModal(false);
              // Trigger Seitenberechnung im CV-Template
              window.dispatchEvent(new CustomEvent('modalClosed'));
            }}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Ausbildung Modal */}
      <Dialog
        open={showEducationModal}
        onClose={() => {
          scheduleCvPreviewDataSave();
          setShowEducationModal(false);
        }}
        TransitionProps={{
          onExited: () => {
            window.dispatchEvent(new CustomEvent('modalClosed'));
            // Zweiter Reflow-Pass, falls sich nach dem Close noch Zeilenumbrüche/Höhen stabilisieren
            setTimeout(() => {
              window.dispatchEvent(new CustomEvent('refreshTemplate'));
            }, 180);
          }
        }}
        maxWidth="sm"
        sx={{ zIndex: 1800 }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.25)'
          }
        }}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '600px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
            <TextField
              key={`title-education-${currentEducationTitle || ''}`}
              defaultValue={currentEducationTitle}
              onBlur={(e) => {
                const nextValue = e.target.value;
                if (nextValue !== currentEducationTitle) {
                  setCurrentEducationTitle(nextValue);
                }
              }}
              variant="standard"
                        sx={{
                          flex: 1,
                          mr: 4,
                          '& .MuiInput-root': {
                            fontSize: '1.25rem',
                            fontWeight: 700,
                            color: 'white',
                            textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                            '&:before': { borderBottom: 'none' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
                            '&:after': { borderBottom: '2px solid white' }
                          }
                        }}
            />
            <IconButton 
              onClick={() => {
                scheduleCvPreviewDataSave();
                setShowEducationModal(false);
              }}
              size="small"
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 5, overflowX: 'hidden' }}>
          {/* Sichtbarkeits-Schalter */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showEducationInCv}
                  onChange={(e) => setShowEducationInCv(e.target.checked)}
                  sx={{
                    color: '#667eea',
                    '&.Mui-checked': {
                      color: '#667eea',
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                  {getTranslatedCvLabel('Ausbildungen im CV-Template anzeigen')}
                </Typography>
              }
            />
          </Box>
          
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="body2" sx={{ color: '#64748b' }}>
              {getTranslatedCvLabel('Hier sind alle optimierten Ausbildungen aus Ihren CV-Daten:')}
            </Typography>
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddIcon />}
              onClick={() => {
                setRelevantEducations(prev => [{ degree: '', institution: '', startDate: '', endDate: '' }, ...prev]);
              }}
              sx={{ 
                borderColor: '#3b82f6',
                color: '#3b82f6',
                '&:hover': { 
                  borderColor: '#2563eb',
                  backgroundColor: 'rgba(59, 130, 246, 0.04)'
                }
              }}
            >
              {getTranslatedCvLabel('Hinzufügen')}
            </Button>
          </Box>
          
          <Box sx={{ maxHeight: 400, overflowY: 'auto' }}>
            {(relevantEducations || []).map((edu: any, index: number) => (
              <Box key={index} sx={{ 
                p: 2, 
                border: '1px solid #e2e8f0', 
                borderRadius: 2, 
                backgroundColor: '#fafbfc',
                mb: 2,
                '&:hover': {
                  borderColor: '#3b82f6',
                  boxShadow: '0 2px 8px rgba(59, 130, 246, 0.1)'
                }
              }}>
                {/* Abschluss auf einer Zeile */}
                <Box sx={{ mb: 2 }}>
                  <TextField
                    label={getTranslatedCvLabel('Abschluss')}
                    key={`rel-edu-degree-${index}-${edu.degree || ''}`}
                    defaultValue={edu.degree || ''}
                    onBlur={(e) => {
                      const nextValue = e.target.value;
                      const currentValue = edu.degree || '';
                      if (nextValue !== currentValue) {
                        setRelevantEducations(prev => 
                          prev.map((item, i) => 
                            i === index ? { ...item, degree: nextValue } : item
                          )
                        );
                      }
                    }}
                    variant="outlined"
                    fullWidth
                    size="small"
                    sx={{ 
                      '& .MuiInputLabel-root': { 
                        fontSize: '0.875rem',
                        color: '#64748b'
                      },
                      '& .MuiOutlinedInput-root': { 
                        fontSize: '0.875rem',
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#3b82f6'
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#3b82f6'
                        }
                      }
                    }}
                  />
                </Box>
                
                {/* Institution auf einer Zeile */}
                <Box sx={{ mb: 2 }}>
                  <TextField
                    label={getTranslatedCvLabel('Institution')}
                    key={`rel-edu-institution-${index}-${edu.institution || ''}`}
                    defaultValue={edu.institution || ''}
                    onBlur={(e) => {
                      const nextValue = e.target.value;
                      const currentValue = edu.institution || '';
                      if (nextValue !== currentValue) {
                        setRelevantEducations(prev => 
                          prev.map((item, i) => 
                            i === index ? { ...item, institution: nextValue } : item
                          )
                        );
                      }
                    }}
                    variant="outlined"
                    fullWidth
                    size="small"
                    sx={{ 
                      '& .MuiInputLabel-root': { 
                        fontSize: '0.875rem',
                        color: '#64748b'
                      },
                      '& .MuiOutlinedInput-root': { 
                        fontSize: '0.875rem',
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#3b82f6'
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#3b82f6'
                        }
                      }
                    }}
                  />
                </Box>
                
                {/* Von und Bis auf der gleichen Zeile */}
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start', justifyContent: 'space-between' }}>
                  <TextField
                    label={getTranslatedCvLabel('Von')}
                    key={`rel-edu-start-${index}-${edu.startDate || ''}`}
                    defaultValue={edu.startDate || ''}
                    onBlur={(e) => {
                      const nextValue = e.target.value;
                      const currentValue = edu.startDate || '';
                      if (nextValue !== currentValue) {
                        setRelevantEducations(prev => 
                          prev.map((item, i) => 
                            i === index ? { ...item, startDate: nextValue } : item
                          )
                        );
                      }
                    }}
                    variant="outlined"
                    placeholder="YYYY"
                    size="small"
                    sx={{ 
                      flex: 1,
                      '& .MuiInputLabel-root': { 
                        fontSize: '0.875rem',
                        color: '#64748b'
                      },
                      '& .MuiOutlinedInput-root': { 
                        fontSize: '0.875rem',
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#3b82f6'
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#3b82f6'
                        }
                      }
                    }}
                  />
                  <TextField
                    label={getTranslatedCvLabel('Bis')}
                    key={`rel-edu-end-${index}-${edu.endDate || ''}`}
                    defaultValue={edu.endDate || ''}
                    onBlur={(e) => {
                      const nextValue = e.target.value;
                      const currentValue = edu.endDate || '';
                      if (nextValue !== currentValue) {
                        setRelevantEducations(prev => 
                          prev.map((item, i) => 
                            i === index ? { ...item, endDate: nextValue } : item
                          )
                        );
                      }
                    }}
                    variant="outlined"
                    placeholder="YYYY"
                    size="small"
                    sx={{ 
                      flex: 1,
                      '& .MuiInputLabel-root': { 
                        fontSize: '0.875rem',
                        color: '#64748b'
                      },
                      '& .MuiOutlinedInput-root': { 
                        fontSize: '0.875rem',
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#3b82f6'
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#3b82f6'
                        }
                      }
                    }}
                  />
                  <IconButton
                    onClick={() => {
                      setRelevantEducations(prev => prev.filter((_, i) => i !== index));
                    }}
                    size="small"
                    sx={{ 
                      color: '#94a3b8',
                      transition: 'all 0.2s ease',
                      ml: 1,
                      alignSelf: 'center',
                      '&:hover': {
                        color: '#ef4444',
                        bgcolor: '#fef2f2',
                        transform: 'scale(1.1)'
                      }
                    }}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Box>
              </Box>
            ))}
            {(!relevantEducations || relevantEducations.length === 0) && (
              <Box sx={{ 
                p: 3, 
                textAlign: 'center', 
                color: '#64748b', 
                fontStyle: 'italic',
                border: '1px dashed #e2e8f0',
                borderRadius: 2
              }}>
                {getTranslatedCvLabel('Keine Ausbildungen verfügbar')}
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => {
              scheduleCvPreviewDataSave();
              setShowEducationModal(false);
            }}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Berufserfahrungen Modal */}
      <Dialog
        open={showWorkExperienceModal}
        onClose={closeWorkExperienceModal}
        TransitionProps={{
          onExited: () => {
            window.dispatchEvent(new CustomEvent('modalClosed'));
            // Zweiter Reflow-Pass, falls sich nach dem Close noch Zeilenumbrüche/Höhen stabilisieren
            setTimeout(() => {
              window.dispatchEvent(new CustomEvent('refreshTemplate'));
            }, 180);
          }
        }}
        maxWidth="sm"
        sx={{ zIndex: 1800 }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.25)'
          }
        }}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '600px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', flex: 1, mr: 2 }}>
              <TextField
                key={`title-work-experience-${currentWorkExperienceTitle || ''}`}
                defaultValue={currentWorkExperienceTitle}
                onBlur={(e) => {
                  const nextValue = e.target.value;
                  if (nextValue !== currentWorkExperienceTitle) {
                    setCurrentWorkExperienceTitle(nextValue);
                  }
                }}
                variant="standard"
                inputProps={{ size: Math.max((currentWorkExperienceTitle?.length || 10) + 5, 15) }}
                sx={{
                  flexShrink: 1,
                  minWidth: 0,
                  '& .MuiInput-root': {
                    fontSize: '1.25rem',
                    fontWeight: 700,
                    color: 'white',
                    textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                    '&:before': { borderBottom: 'none' },
                    '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
                    '&:after': { borderBottom: '2px solid white' }
                  }
                }}
              />
              <Tooltip title={currentLanguage === 'de' ? 'Info anzeigen' : currentLanguage === 'en' ? 'Show info' : currentLanguage === 'fr' ? 'Afficher info' : 'Mostra info'} arrow>
                <IconButton
                  onClick={() => setMinimizedInfoBoxes(prev => ({ ...prev, relevance: !prev.relevance }))}
                  sx={{
                    color: 'white',
                    p: 0.5,
                    ml: 0.5,
                    flexShrink: 0,
                    '&:hover': {
                      bgcolor: 'rgba(255,255,255,0.1)'
                    }
                  }}
                >
                  <InfoOutlinedIcon sx={{ fontSize: 20 }} />
                </IconButton>
              </Tooltip>
            </Box>
            <IconButton 
              onClick={closeWorkExperienceModal}
              size="small"
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        
        {/* Info-Textfeld für Relevanz - direkt unter dem Header */}
        {!minimizedInfoBoxes['relevance'] && (
          <Box sx={{ px: 2, py: 1 }}>
            <Alert 
              severity="info" 
              sx={{ 
                borderRadius: 2,
                backgroundColor: '#f0f7ff',
                border: '1px solid #b3d9ff',
                '& .MuiAlert-icon': {
                  color: '#1976d2'
                }
              }}
              action={
                <IconButton size="small" onClick={() => setMinimizedInfoBoxes(prev => ({ ...prev, relevance: true }))}>
                  <CloseIcon fontSize="small" sx={{ color: '#1976d2' }} />
                </IconButton>
              }
            >
              <Typography variant="body2" sx={{ color: '#1976d2', fontWeight: 500 }}>
                {getTranslatedCvLabel('Mit Relevanz kannst du angeben, ob eine Berufserfahrung mit Beschreibung unter BERUFLICHER WERDEGANG oder mit minimalen Informationen unter WEITERE BERUFSERFAHRUNGEN aufgeführt werden soll.')}
              </Typography>
            </Alert>
          </Box>
        )}
        
        <DialogContent sx={{ p: 3, pt: 5, overflowX: 'hidden' }}>
          {/* Sichtbarkeits-Schalter */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isNonRelevantWorkExperience ? showAdditionalWorkExperienceInCv : showWorkExperienceInCv}
                  onChange={(e) => {
                    if (isNonRelevantWorkExperience) {
                      setShowAdditionalWorkExperienceInCv(e.target.checked);
                    } else {
                      setShowWorkExperienceInCv(e.target.checked);
                    }
                  }}
                  sx={{
                    color: '#667eea',
                    '&.Mui-checked': {
                      color: '#667eea',
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                  {isNonRelevantWorkExperience 
                    ? getTranslatedCvLabel('Weitere Berufserfahrungen im CV-Template anzeigen')
                    : getTranslatedCvLabel('Berufserfahrungen im CV-Template anzeigen')
                  }
                </Typography>
              }
            />
          </Box>
          
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="body2" sx={{ color: '#64748b' }}>
              {selectedWorkExperience ? getTranslatedCvLabel('Bearbeiten Sie diese Berufserfahrung:') : getTranslatedCvLabel('Hier sind alle optimierten Berufserfahrungen aus Ihren CV-Daten:')}
            </Typography>
            {!selectedWorkExperience && (
              <Button
                variant="outlined"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => {
                  syncWorkExperiences([...relevantWorkExperiences, { 
                    position: '', 
                    company: '', 
                    industry: '',
                    startDate: '', 
                    endDate: '', 
                    description: '',
                    responsibilities: [],
                    relevant: true
                  }]);
                }}
                sx={{ 
                  borderColor: '#3b82f6',
                  color: '#3b82f6',
                  '&:hover': { 
                    borderColor: '#2563eb',
                    backgroundColor: 'rgba(59, 130, 246, 0.04)'
                  }
                }}
              >
                {getTranslatedCvLabel('Hinzufügen')}
              </Button>
            )}
          </Box>
          
          {selectedWorkExperience ? (
            // Einzelne Berufserfahrung - Einzelne Felder
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <TextField
                  label={getTranslatedCvLabel('Position')}
                  key={`selected-work-position-${selectedWorkExperience.position || ''}`}
                  defaultValue={selectedWorkExperience.position || ''}
                  onBlur={(e) => {
                    const nextValue = e.target.value;
                    const currentValue = selectedWorkExperience.position || '';
                    if (nextValue !== currentValue) {
                      setSelectedWorkExperience(prev => ({ ...prev, position: nextValue }));
                    }
                  }}
                  variant="outlined"
                  fullWidth
                  sx={{ 
                    '& .MuiInputLabel-root': { 
                      fontSize: '0.875rem',
                      color: '#64748b'
                    },
                    '& .MuiOutlinedInput-root': { 
                      fontSize: '0.875rem',
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#3b82f6'
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#3b82f6'
                      }
                    }
                  }}
                />
                <TextField
                  label={getTranslatedCvLabel('Unternehmen')}
                  key={`selected-work-company-${selectedWorkExperience.company || ''}`}
                  defaultValue={selectedWorkExperience.company || ''}
                  onBlur={(e) => {
                    const nextValue = e.target.value;
                    const currentValue = selectedWorkExperience.company || '';
                    if (nextValue !== currentValue) {
                      setSelectedWorkExperience(prev => ({ ...prev, company: nextValue }));
                    }
                  }}
                  variant="outlined"
                  fullWidth
                  sx={{ 
                    '& .MuiInputLabel-root': { 
                      fontSize: '0.875rem',
                      color: '#64748b'
                    },
                    '& .MuiOutlinedInput-root': { 
                      fontSize: '0.875rem',
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#3b82f6'
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#3b82f6'
                      }
                    }
                  }}
                />
                <TextField
                  label={getTranslatedCvLabel('Branche')}
                  key={`selected-work-industry-${selectedWorkExperience.industry || ''}`}
                  defaultValue={selectedWorkExperience.industry || ''}
                  onBlur={(e) => {
                    const nextValue = e.target.value;
                    const currentValue = selectedWorkExperience.industry || '';
                    if (nextValue !== currentValue) {
                      setSelectedWorkExperience(prev => ({ ...prev, industry: nextValue }));
                    }
                  }}
                  variant="outlined"
                  fullWidth
                  sx={{ 
                    '& .MuiInputLabel-root': { 
                      fontSize: '0.875rem',
                      color: '#64748b'
                    },
                    '& .MuiOutlinedInput-root': { 
                      fontSize: '0.875rem',
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#3b82f6'
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#3b82f6'
                      }
                    }
                  }}
                />
              </Box>
              
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField
                  label={getTranslatedCvLabel('Von')}
                  key={`selected-work-start-${selectedWorkExperience.startDate || ''}`}
                  defaultValue={selectedWorkExperience.startDate || ''}
                  onBlur={(e) => {
                    const nextValue = e.target.value;
                    const currentValue = selectedWorkExperience.startDate || '';
                    if (nextValue !== currentValue) {
                      setSelectedWorkExperience(prev => ({ ...prev, startDate: nextValue }));
                    }
                  }}
                  variant="outlined"
                  placeholder="MM/YYYY"
                  sx={{ 
                    width: '200px',
                    '& .MuiInputLabel-root': { 
                      fontSize: '0.875rem',
                      color: '#64748b'
                    },
                    '& .MuiOutlinedInput-root': { 
                      fontSize: '0.875rem',
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#3b82f6'
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#3b82f6'
                      }
                    }
                  }}
                />
                <TextField
                  label={getTranslatedCvLabel('Bis')}
                  key={`selected-work-end-${selectedWorkExperience.endDate || ''}`}
                  defaultValue={selectedWorkExperience.endDate || ''}
                  onBlur={(e) => {
                    const nextValue = e.target.value;
                    const currentValue = selectedWorkExperience.endDate || '';
                    if (nextValue !== currentValue) {
                      setSelectedWorkExperience(prev => ({ ...prev, endDate: nextValue }));
                    }
                  }}
                  variant="outlined"
                  placeholder="MM/YYYY"
                  sx={{ 
                    width: '200px',
                    '& .MuiInputLabel-root': { 
                      fontSize: '0.875rem',
                      color: '#64748b'
                    },
                    '& .MuiOutlinedInput-root': { 
                      fontSize: '0.875rem',
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#3b82f6'
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#3b82f6'
                      }
                    }
                  }}
                />
              </Box>
              
              {!isNonRelevantWorkExperience && (
                <>
                  <Box sx={{ position: 'relative' }}>
                    <TextField
                      label={`${getTranslatedCvLabel('Beschreibung')} (${(selectedWorkExperience?.description || '').length})`}
                      key={`selected-work-description-${selectedWorkExperience.description || ''}`}
                      defaultValue={selectedWorkExperience.description || ''}
                      onBlur={(e) => {
                        const nextValue = e.target.value;
                        const currentValue = selectedWorkExperience.description || '';
                        if (nextValue !== currentValue) {
                          handleWorkExpDescriptionChange({
                            target: { value: nextValue }
                          } as React.ChangeEvent<HTMLInputElement>);
                        }
                      }}
                      variant="outlined"
                      multiline
                      minRows={4}
                      maxRows={Infinity}
                      fullWidth
                      sx={{ 
                        pr: ((workExpHistoryIndex > 0 || workExpHistoryIndex < workExpHistory.length - 1) || (!showWorkExperiencePromptInput && selectedWorkExperience?.description)) ? 10 : 5,
                        '& .MuiInputLabel-root': { 
                          fontSize: '0.875rem',
                          color: '#64748b'
                        },
                        '& .MuiOutlinedInput-root': { 
                          fontSize: '0.875rem',
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#3b82f6'
                          },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#3b82f6'
                          }
                        }
                      }}
                    />
                    {/* Undo/Redo Icons */}
                    <Box sx={{ position: 'absolute', bottom: 8, right: (!showWorkExperiencePromptInput && selectedWorkExperience?.description) ? 40 : 8, display: 'flex', gap: 0.5, zIndex: 10 }}>
                      {workExpHistoryIndex > 0 && (
                        <IconButton
                          aria-label="Rückgängig"
                          onClick={handleWorkExpUndo}
                          size="small"
                          sx={{
                            color: '#94a3b8',
                            backgroundColor: 'white',
                            boxShadow: '0 2px 8px rgba(15, 23, 42, 0.12)',
                            '&:hover': {
                              backgroundColor: '#fee2e2',
                              color: '#ef4444'
                            },
                            transition: 'all 0.2s ease-in-out'
                          }}
                        >
                          <UndoIcon sx={{ fontSize: '18px' }} />
                        </IconButton>
                      )}
                      {workExpHistoryIndex < workExpHistory.length - 1 && (
                        <IconButton
                          aria-label="Wiederherstellen"
                          onClick={handleWorkExpRedo}
                          size="small"
                          sx={{
                            color: '#94a3b8',
                            backgroundColor: 'white',
                            boxShadow: '0 2px 8px rgba(15, 23, 42, 0.12)',
                            '&:hover': {
                              backgroundColor: '#e0f2fe',
                              color: '#3b82f6'
                            },
                            transition: 'all 0.2s ease-in-out'
                          }}
                        >
                          <RedoIcon sx={{ fontSize: '18px' }} />
                        </IconButton>
                      )}
                    </Box>
                    {!showWorkExperiencePromptInput && (
                      <IconButton
                        aria-label={getTranslatedCvLabel('Prompts zur Verbesserung der Beschreibung')}
                        size="small"
                        onClick={toggleWorkExperiencePromptInput}
                        disabled={optimizingWorkExperiencePrompt}
                        sx={{
                          position: 'absolute',
                          bottom: 8,
                          right: 8,
                          color: optimizingWorkExperiencePrompt ? '#cbd5f5' : '#94a3b8',
                          backgroundColor: 'white',
                          boxShadow: '0 2px 8px rgba(15, 23, 42, 0.12)',
                          '&:hover': {
                            backgroundColor: '#e0e7ff',
                            color: '#6366f1'
                          }
                        }}
                      >
                        <ExpandMoreIcon />
                      </IconButton>
                    )}
                  </Box>
                  {showWorkExperiencePromptInput && (
                    <Box sx={{ mt: 2, position: 'relative' }}>
                      <TextField
                        label={getTranslatedCvLabel('Prompts zur Verbesserung der Beschreibung')}
                        defaultValue={workExperiencePromptText}
                        onChange={handleWorkExperiencePromptChange}
                        onBlur={(e) => {
                          const nextValue = e.target.value;
                          if (nextValue !== workExperiencePromptText) {
                            setWorkExperiencePromptText(nextValue);
                          }
                        }}
                        variant="outlined"
                        multiline
                        rows={4}
                        fullWidth
                        placeholder={getTranslatedCvLabel('Beschreiben Sie, welche Aspekte dieser Berufserfahrung verbessert werden sollen...')}
                        sx={{ 
                          '& .MuiInputLabel-root': { 
                            fontSize: '0.875rem',
                            color: '#64748b'
                          },
                          '& .MuiOutlinedInput-root': { 
                            fontSize: '0.875rem',
                            pr: 5,
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#3b82f6'
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#3b82f6'
                            }
                          }
                        }}
                      />
                      <IconButton
                        aria-label={getTranslatedCvLabel('Prompts zur Verbesserung der Beschreibung')}
                        size="small"
                        disabled={!workExperiencePromptText.trim() || optimizingWorkExperiencePrompt}
                        onClick={handleWorkExperiencePromptOptimization}
                        sx={{
                          position: 'absolute',
                          bottom: 8,
                          right: 8,
                          color: (!workExperiencePromptText.trim() || optimizingWorkExperiencePrompt) ? '#cbd5f5' : '#94a3b8',
                          backgroundColor: 'white',
                          boxShadow: '0 2px 8px rgba(15, 23, 42, 0.12)',
                          '&:hover': {
                            backgroundColor: '#e0e7ff',
                            color: '#6366f1'
                          },
                          '&.Mui-disabled': {
                            backgroundColor: '#f8fafc',
                            boxShadow: 'none'
                          }
                        }}
                      >
                        {optimizingWorkExperiencePrompt ? <CircularProgress size={16} /> : <AutoFixHighIcon />}
                      </IconButton>
                    </Box>
                  )}
                </>
              )}
              
              <FormControl variant="outlined" fullWidth>
                <InputLabel sx={{ 
                  fontSize: '0.875rem',
                  color: '#64748b'
                }}>
                  {(() => {
                    const score = getWorkExperienceRelevanceScore(selectedWorkExperience);
                    const baseLabel = getTranslatedCvLabel('Relevant');
                    return score >= 0 ? `${baseLabel} (${Math.round(score)})` : baseLabel;
                  })()}
                </InputLabel>
                <Select
                  value={selectedWorkExperience.relevant === true || selectedWorkExperience.relevant === 'true' ? 'true' : 'false'}
                  onChange={(e) => {
                    setSelectedWorkExperience(prev => ({ ...prev, relevant: e.target.value === 'true' }));
                  }}
                  MenuProps={{
                    sx: {
                      zIndex: 4000
                    },
                    PaperProps: {
                      sx: {
                        zIndex: 4000
                      }
                    }
                  }}
                  label={(() => {
                    const score = getWorkExperienceRelevanceScore(selectedWorkExperience);
                    const baseLabel = getTranslatedCvLabel('Relevant');
                    return score >= 0 ? `${baseLabel} (${Math.round(score)})` : baseLabel;
                  })()}
                  sx={{ 
                    fontSize: '0.875rem',
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#3b82f6'
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#3b82f6'
                    }
                  }}
                >
                  <MenuItem value="true">{getTranslatedCvLabel('Relevant')}</MenuItem>
                  <MenuItem value="false">{getTranslatedCvLabel('Nicht relevant')}</MenuItem>
                </Select>
              </FormControl>
              
            </Box>
          ) : (
            // Übersicht - Tabelle
            <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ backgroundColor: '#f8fafc', width: '150px' }}>
                      {getTranslatedCvLabel('Position')}
                    </TableCell>
                    <TableCell sx={{ backgroundColor: '#f8fafc', width: '150px' }}>
                      {getTranslatedCvLabel('Unternehmen')}
                    </TableCell>
                    <TableCell sx={{ backgroundColor: '#f8fafc', width: '100px' }}>
                      {getTranslatedCvLabel('Von')}
                    </TableCell>
                    <TableCell sx={{ backgroundColor: '#f8fafc', width: '100px' }}>
                      {getTranslatedCvLabel('Bis')}
                    </TableCell>
                    <TableCell sx={{ backgroundColor: '#f8fafc' }}>
                      {getTranslatedCvLabel('Beschreibung')}
                    </TableCell>
                    <TableCell sx={{ backgroundColor: '#f8fafc', width: '120px' }}>
                      {getTranslatedCvLabel('Relevant')}
                    </TableCell>
                    <TableCell sx={{ backgroundColor: '#f8fafc', width: '80px' }}>
                      {getTranslatedCvLabel('Aktionen')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sortWorkExperiencesForDisplay(relevantWorkExperiences || []).map((work: any) => {
                    const originalIndex = relevantWorkExperiences.findIndex((item: any) => item === work);
                    return (
                    <TableRow key={originalIndex >= 0 ? originalIndex : `${work.company || ''}-${work.position || ''}-${work.startDate || ''}`} hover>
                      <TableCell>
                        <TextField
                          key={`table-work-position-${originalIndex}-${work.position || ''}`}
                          defaultValue={work.position || ''}
                          onBlur={(e) => {
                            const nextValue = e.target.value;
                            const currentValue = work.position || '';
                            if (nextValue !== currentValue) {
                              const updated = relevantWorkExperiences.map((item, i) => 
                                i === originalIndex ? { ...item, position: nextValue } : item
                              );
                              syncWorkExperiences(updated);
                            }
                          }}
                          variant="standard"
                          fullWidth
                          sx={{ 
                            '& .MuiInput-root': { 
                              fontSize: '0.875rem',
                              fontWeight: 'normal',
                              '&:before': { borderBottom: '1px solid #e0e0e0' },
                              '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                              '&:after': { borderBottom: '2px solid #1976d2' }
                            },
                            '& .MuiInputBase-input': {
                              fontWeight: 'normal'
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          key={`table-work-company-${originalIndex}-${work.company || ''}`}
                          defaultValue={work.company || ''}
                          onBlur={(e) => {
                            const nextValue = e.target.value;
                            const currentValue = work.company || '';
                            if (nextValue !== currentValue) {
                              const updated = relevantWorkExperiences.map((item, i) => 
                                i === originalIndex ? { ...item, company: nextValue } : item
                              );
                              syncWorkExperiences(updated);
                            }
                          }}
                          variant="standard"
                          fullWidth
                          sx={{ 
                            '& .MuiInput-root': { 
                              fontSize: '0.875rem',
                              fontWeight: 'normal',
                              '&:before': { borderBottom: '1px solid #e0e0e0' },
                              '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                              '&:after': { borderBottom: '2px solid #1976d2' }
                            },
                            '& .MuiInputBase-input': {
                              fontWeight: 'normal'
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          key={`table-work-start-${originalIndex}-${work.startDate || ''}`}
                          defaultValue={work.startDate || ''}
                          onBlur={(e) => {
                            const nextValue = e.target.value;
                            const currentValue = work.startDate || '';
                            if (nextValue !== currentValue) {
                              const updated = relevantWorkExperiences.map((item, i) => 
                                i === originalIndex ? { ...item, startDate: nextValue } : item
                              );
                              syncWorkExperiences(updated);
                            }
                          }}
                          variant="standard"
                          fullWidth
                          placeholder="MM/YYYY"
                          sx={{ 
                            '& .MuiInput-root': { 
                              fontSize: '0.875rem',
                              '&:before': { borderBottom: '1px solid #e0e0e0' },
                              '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                              '&:after': { borderBottom: '2px solid #1976d2' }
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          key={`table-work-end-${originalIndex}-${work.endDate || ''}`}
                          defaultValue={work.endDate || ''}
                          onBlur={(e) => {
                            const nextValue = e.target.value;
                            const currentValue = work.endDate || '';
                            if (nextValue !== currentValue) {
                              const updated = relevantWorkExperiences.map((item, i) => 
                                i === originalIndex ? { ...item, endDate: nextValue } : item
                              );
                              syncWorkExperiences(updated);
                            }
                          }}
                          variant="standard"
                          fullWidth
                          placeholder="MM/YYYY"
                          sx={{ 
                            '& .MuiInput-root': { 
                              fontSize: '0.875rem',
                              '&:before': { borderBottom: '1px solid #e0e0e0' },
                              '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                              '&:after': { borderBottom: '2px solid #1976d2' }
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          key={`table-work-description-${originalIndex}-${work.description || ''}`}
                          defaultValue={work.description || ''}
                          onBlur={(e) => {
                            const nextValue = e.target.value;
                            const currentValue = work.description || '';
                            if (nextValue !== currentValue) {
                              const updated = relevantWorkExperiences.map((item, i) => 
                                i === originalIndex ? { ...item, description: nextValue } : item
                              );
                              syncWorkExperiences(updated);
                            }
                          }}
                          variant="standard"
                          fullWidth
                          multiline
                          rows={2}
                          sx={{ 
                            '& .MuiInput-root': { 
                              fontSize: '0.875rem',
                              '&:before': { borderBottom: '1px solid #e0e0e0' },
                              '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                              '&:after': { borderBottom: '2px solid #1976d2' }
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <FormControl variant="standard" fullWidth>
                          <Select
                            value={work.relevant === true || work.relevant === 'true' ? 'true' : 'false'}
                            onChange={(e) => {
                              const updated = relevantWorkExperiences.map((item, i) => 
                                i === originalIndex ? { ...item, relevant: e.target.value === 'true' } : item
                              );
                              syncWorkExperiences(updated);
                            }}
                            MenuProps={{
                              sx: {
                                zIndex: 4000
                              },
                              PaperProps: {
                                sx: {
                                  zIndex: 4000
                                }
                              }
                            }}
                            sx={{ 
                              fontSize: '0.875rem',
                              '&:before': { borderBottom: '1px solid #e0e0e0' },
                              '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                              '&:after': { borderBottom: '2px solid #1976d2' }
                            }}
                          >
                            <MenuItem value="true">{getTranslatedCvLabel('Relevant')}</MenuItem>
                            <MenuItem value="false">{getTranslatedCvLabel('Nicht relevant')}</MenuItem>
                          </Select>
                        </FormControl>
                      </TableCell>
                      <TableCell>
                        <IconButton
                          size="small"
                          onClick={() => {
                            const updated = relevantWorkExperiences.filter((_, i) => i !== originalIndex);
                            syncWorkExperiences(updated);
                          }}
                          sx={{ 
                            color: '#ef4444',
                            '&:hover': { 
                              backgroundColor: 'rgba(239, 68, 68, 0.1)' 
                            }
                          }}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  )})}
                  {(!relevantWorkExperiences || relevantWorkExperiences.length === 0) && (
                    <TableRow>
                      <TableCell colSpan={7} sx={{ textAlign: 'center', color: '#64748b', fontStyle: 'italic' }}>
                        {getTranslatedCvLabel('Keine Berufserfahrungen verfügbar')}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={closeWorkExperienceModal}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Profil Modal */}
      <Dialog
        open={showProfileModal}
        onClose={closeProfileModal}
        TransitionProps={{
          onExited: () => {
            window.dispatchEvent(new CustomEvent('modalClosed'));
            // Zweiter Reflow-Pass, falls sich nach dem Close noch Zeilenumbrüche/Höhen stabilisieren
            setTimeout(() => {
              window.dispatchEvent(new CustomEvent('refreshTemplate'));
            }, 180);
          }
        }}
        maxWidth="sm"
        sx={{ zIndex: 1800 }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.25)'
          }
        }}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '600px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
            <TextField
              key={`title-profile-${currentProfileTitle || ''}`}
              defaultValue={currentProfileTitle}
              onBlur={(e) => {
                const nextValue = e.target.value;
                if (nextValue !== currentProfileTitle) {
                  setCurrentProfileTitle(nextValue);
                }
              }}
              variant="standard"
              fullWidth
                        sx={{
                          flex: 1,
                          mr: 4,
                          '& .MuiInput-root': {
                            fontSize: '1.25rem',
                            fontWeight: 700,
                            color: 'white',
                            textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                            '&:before': { borderBottom: 'none' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
                            '&:after': { borderBottom: '2px solid white' }
                          }
                        }}
            />
            <IconButton 
              onClick={closeProfileModal}
              size="small"
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 5, overflowX: 'hidden' }}>
          {/* Sichtbarkeits-Schalter */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showProfileInCv}
                  onChange={(e) => setShowProfileInCv(e.target.checked)}
                  sx={{
                    color: '#667eea',
                    '&.Mui-checked': {
                      color: '#667eea',
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                  {getTranslatedCvLabel('Profil im CV-Template anzeigen')}
                </Typography>
              }
            />
          </Box>
          
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="body2" sx={{ color: '#64748b' }}>
              {getTranslatedCvLabel('Bearbeiten Sie Ihr Profil:')}
            </Typography>
          </Box>
          
          <Box sx={{ position: 'relative' }}>
            <TextField
              label={`${getTranslatedCvLabel('Profil-Text')} (${(tempOptimizedShortProfile || '').length})`}
              key={`profile-text-${tempOptimizedShortProfile || ''}`}
              defaultValue={tempOptimizedShortProfile || ''}
              onBlur={(e) => {
                const nextValue = e.target.value;
                const currentValue = tempOptimizedShortProfile || '';
                if (nextValue !== currentValue) {
                  handleProfileTextChange({
                    target: { value: nextValue }
                  } as React.ChangeEvent<HTMLInputElement>);
                }
              }}
              variant="outlined"
              multiline
              minRows={4}
              maxRows={20}
              fullWidth
              placeholder={getTranslatedCvLabel('Beschreiben Sie sich selbst, Ihre Ziele und Ihre Stärken...')}
              sx={{ 
                '& .MuiInputLabel-root': { 
                  fontSize: '0.875rem',
                  color: '#64748b'
                },
                '& .MuiOutlinedInput-root': { 
                  fontSize: '0.875rem',
                  pr: ((profileHistoryIndex > 0 || profileHistoryIndex < profileHistory.length - 1) || (!showProfilePromptInput && tempOptimizedShortProfile?.trim())) ? 10 : 5,
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#3b82f6'
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#3b82f6'
                  }
                }
              }}
            />
            {/* Undo/Redo Icons */}
            <Box sx={{ position: 'absolute', bottom: 8, right: (!showProfilePromptInput && tempOptimizedShortProfile?.trim()) ? 40 : 8, display: 'flex', gap: 0.5, zIndex: 10 }}>
              {profileHistoryIndex > 0 && (
                <IconButton
                  aria-label="Rückgängig"
                  onClick={handleProfileUndo}
                  size="small"
                  sx={{
                    color: '#94a3b8',
                    backgroundColor: 'white',
                    boxShadow: '0 2px 8px rgba(15, 23, 42, 0.12)',
                    '&:hover': {
                      backgroundColor: '#fee2e2',
                      color: '#ef4444'
                    },
                    transition: 'all 0.2s ease-in-out'
                  }}
                >
                  <UndoIcon sx={{ fontSize: '18px' }} />
                </IconButton>
              )}
              {profileHistoryIndex < profileHistory.length - 1 && (
                <IconButton
                  aria-label="Wiederherstellen"
                  onClick={handleProfileRedo}
                  size="small"
                  sx={{
                    color: '#94a3b8',
                    backgroundColor: 'white',
                    boxShadow: '0 2px 8px rgba(15, 23, 42, 0.12)',
                    '&:hover': {
                      backgroundColor: '#e0f2fe',
                      color: '#3b82f6'
                    },
                    transition: 'all 0.2s ease-in-out'
                  }}
                >
                  <RedoIcon sx={{ fontSize: '18px' }} />
                </IconButton>
              )}
            </Box>
            {!showProfilePromptInput && tempOptimizedShortProfile?.trim() && (
              <IconButton
                aria-label={getTranslatedCvLabel('Prompts zur Verbesserung des Kurzprofils')}
                onClick={toggleProfilePromptInput}
                size="small"
                sx={{
                  position: 'absolute',
                  bottom: 8,
                  right: 8,
                  color: '#94a3b8',
                  backgroundColor: 'white',
                  boxShadow: '0 2px 8px rgba(15, 23, 42, 0.12)',
                  '&:hover': {
                    backgroundColor: '#e0e7ff',
                    color: '#6366f1'
                  }
                }}
              >
                <ExpandMoreIcon />
              </IconButton>
            )}
          </Box>

          {showProfilePromptInput && (
            <Box sx={{ mt: 2, position: 'relative' }}>
              <TextField
                label={getTranslatedCvLabel('Prompts zur Verbesserung des Kurzprofils')}
                defaultValue={profilePromptText}
                onChange={handleProfilePromptChange}
                onBlur={(e) => {
                  const nextValue = e.target.value;
                  if (nextValue !== profilePromptText) {
                    setProfilePromptText(nextValue);
                  }
                }}
                variant="outlined"
                multiline
                rows={4}
                fullWidth
                placeholder={getTranslatedCvLabel('Beschreiben Sie, welche Aspekte verbessert werden sollen...')}
                sx={{ 
                  '& .MuiInputLabel-root': { 
                    fontSize: '0.875rem',
                    color: '#64748b'
                  },
                  '& .MuiOutlinedInput-root': { 
                    fontSize: '0.875rem',
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#3b82f6'
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#3b82f6'
                    }
                  }
                }}
              />
              <IconButton
                aria-label={getTranslatedCvLabel('Kurzprofil mit Prompt verbessern')}
                size="small"
                onClick={handleProfilePromptOptimization}
                disabled={!profilePromptText.trim() || optimizingProfilePrompt}
                sx={{
                  position: 'absolute',
                  bottom: 8,
                  right: 8,
                  color: (!profilePromptText.trim() || optimizingProfilePrompt) ? '#cbd5f5' : '#94a3b8',
                  backgroundColor: 'white',
                  boxShadow: '0 2px 8px rgba(15, 23, 42, 0.12)',
                  '&.Mui-disabled': {
                    backgroundColor: '#f8fafc',
                    boxShadow: 'none'
                  }
                }}
              >
                {optimizingProfilePrompt ? <CircularProgress size={16} /> : <AutoFixHighIcon />}
              </IconButton>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={closeProfileModal}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Profilbild-Vorschau Modal */}
      <Dialog
        open={showProfileImagePreviewModal}
        onClose={handleSaveProfileImageCrop}
        maxWidth="lg"
        sx={{ zIndex: 1800 }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.25)'
          }
        }}
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: 'hidden',
            width: '900px',
            maxWidth: '95vw',
            maxHeight: '95vh'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          borderRadius: '12px 12px 0 0'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ fontWeight: 700, color: 'white', textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              {getTranslatedCvLabel('Profilbild')}
            </Typography>
            <IconButton 
              onClick={handleSaveProfileImageCrop}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: '32px !important' }}>
          {profileImage && (
            <>
            <Box sx={{ display: 'flex', gap: 3, alignItems: 'flex-start' }}>
              {/* Bild links + Zurücksetzen */}
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', minWidth: '400px' }}>
                <Box sx={{ 
                  width: '400px', 
                  height: '400px', 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center', 
                  border: '1px solid #e0e0e0',
                  borderRadius: 2,
                  overflow: 'hidden',
                  position: 'relative'
                }}>
                  <img 
                    src={profileImage} 
                    alt="Profilbild" 
                    style={{ 
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                      transform: `scale(${previewImageZoom / 100}) translate(${(previewImagePositionX - 50) * 2}%, ${(previewImagePositionY - 50) * 2}%) rotate(${previewImageRotation}deg)`,
                      filter: `brightness(${previewImageBrightness}%) contrast(${previewImageContrast}%) saturate(${previewImageSaturation}%)${previewImageGrayscale ? ' grayscale(100%)' : ''}`
                    }} 
                  />
                  <IconButton
                    size="small"
                    onClick={() => {
                      setPreviewImageZoom(100);
                      setPreviewImagePositionX(50);
                      setPreviewImagePositionY(50);
                      setPreviewImageBrightness(100);
                      setPreviewImageContrast(100);
                      setPreviewImageSaturation(100);
                      setPreviewImageGrayscale(false);
                      setPreviewImageRotation(0);
                      if (originalProfileImage) {
                        setProfileImage(originalProfileImage);
                      }
                    }}
                    sx={{
                      position: 'absolute',
                      top: 5,
                      left: 5,
                      backgroundColor: 'rgba(255,255,255,0.8)',
                      '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' }
                    }}
                    aria-label="Alle Einstellungen zurücksetzen"
                  >
                    <RefreshIcon fontSize="small" />
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={handleRemoveProfileImage}
                    sx={{
                      position: 'absolute',
                      top: 5,
                      right: 5,
                      backgroundColor: 'rgba(255,255,255,0.8)',
                      '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' }
                    }}
                    aria-label="Foto entfernen"
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                  <Tooltip title={getTranslatedCvLabel('Hintergrund entfernen')} placement="top">
                    <span>
                      <IconButton
                        size="small"
                        onClick={handleRemoveBackground}
                        disabled={removingBackground}
                        sx={{
                          position: 'absolute',
                          top: 5,
                          left: 40,
                          backgroundColor: 'rgba(255,255,255,0.8)',
                          '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' },
                          '&.Mui-disabled': { backgroundColor: 'rgba(255,255,255,0.9)' }
                        }}
                        aria-label={getTranslatedCvLabel('Hintergrund entfernen')}
                      >
                        {removingBackground ? <CircularProgress size={18} /> : <AutoFixHighIcon fontSize="small" />}
                      </IconButton>
                    </span>
                  </Tooltip>
                  {removingBackground && (
                    <Box sx={{
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      right: 0,
                      backgroundColor: 'rgba(102, 126, 234, 0.85)',
                      color: 'white',
                      textAlign: 'center',
                      py: 0.5,
                      fontSize: '0.8rem',
                      fontWeight: 600
                    }}>
                      {getTranslatedCvLabel('Hintergrund wird entfernt...')}
                    </Box>
                  )}
                </Box>
              </Box>
              
              {/* Steuerelemente rechts */}
              <Box sx={{ flex: 1, pr: 1 }}>
                {/* Zoom */}
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600, color: '#64748b', minWidth: '130px', flexShrink: 0 }}>
                    {getTranslatedCvLabel('Zoom')}: {previewImageZoom}%
                  </Typography>
                  <IconButton 
                    size="small" 
                    onClick={() => setPreviewImageZoom(Math.max(50, previewImageZoom - 2))}
                    sx={{ color: '#667eea', border: '1px solid #667eea', borderRadius: 1, p: 0.5 }}
                  >
                    <RemoveIcon fontSize="small" />
                  </IconButton>
                  <Slider
                    value={previewImageZoom}
                    onChange={(e, value) => setPreviewImageZoom(value as number)}
                    min={50}
                    max={200}
                    sx={{ color: '#667eea', flex: 1 }}
                  />
                  <IconButton 
                    size="small" 
                    onClick={() => setPreviewImageZoom(Math.min(200, previewImageZoom + 2))}
                    sx={{ color: '#667eea', border: '1px solid #667eea', borderRadius: 1, p: 0.5 }}
                  >
                    <AddIcon fontSize="small" />
                  </IconButton>
                </Box>
                
                {/* Horizontal */}
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600, color: '#64748b', minWidth: '130px', flexShrink: 0 }}>
                    {getTranslatedCvLabel('Horizontal')}
                  </Typography>
                  <IconButton 
                    size="small" 
                    onClick={() => setPreviewImagePositionX(Math.max(0, previewImagePositionX - 1))}
                    sx={{ color: '#667eea', border: '1px solid #667eea', borderRadius: 1, p: 0.5 }}
                  >
                    <RemoveIcon fontSize="small" />
                  </IconButton>
                  <Slider
                    value={previewImagePositionX}
                    onChange={(e, value) => setPreviewImagePositionX(value as number)}
                    min={0}
                    max={100}
                    sx={{ color: '#667eea', flex: 1 }}
                  />
                  <IconButton 
                    size="small" 
                    onClick={() => setPreviewImagePositionX(Math.min(100, previewImagePositionX + 1))}
                    sx={{ color: '#667eea', border: '1px solid #667eea', borderRadius: 1, p: 0.5 }}
                  >
                    <AddIcon fontSize="small" />
                  </IconButton>
                </Box>
                
                {/* Vertikal */}
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600, color: '#64748b', minWidth: '130px', flexShrink: 0 }}>
                    {getTranslatedCvLabel('Vertikal')}
                  </Typography>
                  <IconButton 
                    size="small" 
                    onClick={() => setPreviewImagePositionY(Math.max(0, previewImagePositionY - 1))}
                    sx={{ color: '#667eea', border: '1px solid #667eea', borderRadius: 1, p: 0.5 }}
                  >
                    <RemoveIcon fontSize="small" />
                  </IconButton>
                  <Slider
                    value={previewImagePositionY}
                    onChange={(e, value) => setPreviewImagePositionY(value as number)}
                    min={0}
                    max={100}
                    sx={{ color: '#667eea', flex: 1 }}
                  />
                  <IconButton 
                    size="small" 
                    onClick={() => setPreviewImagePositionY(Math.min(100, previewImagePositionY + 1))}
                    sx={{ color: '#667eea', border: '1px solid #667eea', borderRadius: 1, p: 0.5 }}
                  >
                    <AddIcon fontSize="small" />
                  </IconButton>
                </Box>

                {/* Trennlinie */}
                <Box sx={{ borderTop: '1px solid #e2e8f0', my: 2 }} />

                {/* Helligkeit */}
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600, color: '#64748b', minWidth: '130px', flexShrink: 0 }}>
                    {getTranslatedCvLabel('Helligkeit')}: {previewImageBrightness}%
                  </Typography>
                  <IconButton 
                    size="small" 
                    onClick={() => setPreviewImageBrightness(Math.max(50, previewImageBrightness - 5))}
                    sx={{ color: '#667eea', border: '1px solid #667eea', borderRadius: 1, p: 0.5 }}
                  >
                    <RemoveIcon fontSize="small" />
                  </IconButton>
                  <Slider
                    value={previewImageBrightness}
                    onChange={(e, value) => setPreviewImageBrightness(value as number)}
                    min={50}
                    max={150}
                    sx={{ color: '#667eea', flex: 1 }}
                  />
                  <IconButton 
                    size="small" 
                    onClick={() => setPreviewImageBrightness(Math.min(150, previewImageBrightness + 5))}
                    sx={{ color: '#667eea', border: '1px solid #667eea', borderRadius: 1, p: 0.5 }}
                  >
                    <AddIcon fontSize="small" />
                  </IconButton>
                </Box>

                {/* Kontrast */}
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600, color: '#64748b', minWidth: '130px', flexShrink: 0 }}>
                    {getTranslatedCvLabel('Kontrast')}: {previewImageContrast}%
                  </Typography>
                  <IconButton 
                    size="small" 
                    onClick={() => setPreviewImageContrast(Math.max(50, previewImageContrast - 5))}
                    sx={{ color: '#667eea', border: '1px solid #667eea', borderRadius: 1, p: 0.5 }}
                  >
                    <RemoveIcon fontSize="small" />
                  </IconButton>
                  <Slider
                    value={previewImageContrast}
                    onChange={(e, value) => setPreviewImageContrast(value as number)}
                    min={50}
                    max={150}
                    sx={{ color: '#667eea', flex: 1 }}
                  />
                  <IconButton 
                    size="small" 
                    onClick={() => setPreviewImageContrast(Math.min(150, previewImageContrast + 5))}
                    sx={{ color: '#667eea', border: '1px solid #667eea', borderRadius: 1, p: 0.5 }}
                  >
                    <AddIcon fontSize="small" />
                  </IconButton>
                </Box>

                {/* Sättigung */}
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600, color: '#64748b', minWidth: '130px', flexShrink: 0 }}>
                    {getTranslatedCvLabel('Sättigung')}: {previewImageSaturation}%
                  </Typography>
                  <IconButton 
                    size="small" 
                    onClick={() => setPreviewImageSaturation(Math.max(0, previewImageSaturation - 5))}
                    sx={{ color: '#667eea', border: '1px solid #667eea', borderRadius: 1, p: 0.5 }}
                  >
                    <RemoveIcon fontSize="small" />
                  </IconButton>
                  <Slider
                    value={previewImageSaturation}
                    onChange={(e, value) => setPreviewImageSaturation(value as number)}
                    min={0}
                    max={200}
                    sx={{ color: '#667eea', flex: 1 }}
                  />
                  <IconButton 
                    size="small" 
                    onClick={() => setPreviewImageSaturation(Math.min(200, previewImageSaturation + 5))}
                    sx={{ color: '#667eea', border: '1px solid #667eea', borderRadius: 1, p: 0.5 }}
                  >
                    <AddIcon fontSize="small" />
                  </IconButton>
                </Box>

                {/* Rotation & Graustufen */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 2 }}>
                  {/* Rotation */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: '#64748b', minWidth: '130px', flexShrink: 0 }}>
                      {getTranslatedCvLabel('Rotation')}: {previewImageRotation}°
                    </Typography>
                    <IconButton 
                      size="small" 
                      onClick={() => setPreviewImageRotation(Math.max(-45, previewImageRotation - 1))}
                      sx={{ color: '#667eea', border: '1px solid #667eea', borderRadius: 1, p: 0.5 }}
                    >
                      <RemoveIcon fontSize="small" />
                    </IconButton>
                    <Slider
                      value={previewImageRotation}
                      onChange={(e, value) => setPreviewImageRotation(value as number)}
                      min={-45}
                      max={45}
                      sx={{ color: '#667eea', flex: 1 }}
                    />
                    <IconButton 
                      size="small" 
                      onClick={() => setPreviewImageRotation(Math.min(45, previewImageRotation + 1))}
                      sx={{ color: '#667eea', border: '1px solid #667eea', borderRadius: 1, p: 0.5 }}
                    >
                      <AddIcon fontSize="small" />
                    </IconButton>
                  </Box>

                  {/* Graustufen */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: '#64748b', minWidth: '130px', flexShrink: 0 }}>
                      {getTranslatedCvLabel('Graustufen')}
                    </Typography>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={previewImageGrayscale}
                          onChange={(e) => setPreviewImageGrayscale(e.target.checked)}
                          sx={{
                            color: '#667eea',
                            '&.Mui-checked': { color: '#667eea' }
                          }}
                        />
                      }
                      label={
                        <Typography variant="body2" sx={{ color: '#64748b' }}>
                          {getTranslatedCvLabel('Schwarz-Weiss')}
                        </Typography>
                      }
                    />
                  </Box>
                </Box>

              </Box>
            </Box>

            </>
          )}
          {!profileImage && (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
              <Button
                variant="outlined"
                component="label"
                sx={{ 
                  width: '300px',
                  height: '300px',
                  border: '2px dashed #667eea', 
                  borderRadius: 2,
                  color: '#667eea',
                  backgroundColor: '#f0f0ff',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                  '&:hover': {
                    backgroundColor: '#e8e8ff',
                    borderColor: '#5a6fd8'
                  }
                }}
              >
                <CloudUploadIcon sx={{ fontSize: 48 }} />
                <Typography variant="body2" sx={{ color: '#667eea' }}>
                  Foto hochladen
                </Typography>
                <input
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={handleProfileImageUpload}
                />
              </Button>
            </Box>
          )}
        </DialogContent>
      </Dialog>

      {/* Profilbild Modal */}
      <Dialog
        open={showProfileImageModal}
        onClose={handleCloseProfileImageModal}
        TransitionProps={{
          onExited: () => {
            window.dispatchEvent(new CustomEvent('modalClosed'));
            // Zweiter Reflow-Pass, falls sich nach dem Close noch Zeilenumbrüche/Höhen stabilisieren
            setTimeout(() => {
              window.dispatchEvent(new CustomEvent('refreshTemplate'));
            }, 180);
          }
        }}
        maxWidth="md"
        sx={{ zIndex: 1800 }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.25)'
          }
        }}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '600px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              {getTranslatedCvLabel('Profilbild:')}
            </Typography>
            <IconButton 
              onClick={handleCloseProfileImageModal}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 5, overflowX: 'hidden' }}>
          {/* Sichtbarkeits-Schalter */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showProfileImageInCv}
                  onChange={(e) => setShowProfileImageInCv(e.target.checked)}
                  sx={{
                    color: '#667eea',
                    '&.Mui-checked': {
                      color: '#667eea',
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                  {getTranslatedCvLabel('Profilbild im CV-Template anzeigen')}
                </Typography>
              }
            />
          </Box>
          
          {/* Profilbild-Vorschau */}
          {showProfileImageInCv && profileImage && (
            <Box sx={{ 
              mb: 3, 
              p: 2, 
              backgroundColor: '#f8fafc', 
              borderRadius: 2, 
              border: '1px solid #e2e8f0'
            }}>
              <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151', mb: 2, textAlign: 'left' }}>
                {getTranslatedCvLabel('Vorschau')}
              </Typography>
              <Box sx={{ 
                textAlign: profileImageAlignment === 'left' ? 'left' : 
                         profileImageAlignment === 'right' ? 'right' : 'center'
              }}>
                <Box
                  sx={{
                    width: '300px',
                    aspectRatio: '1 / 1', // Quadratischer Container wie im CV-Template
                    margin: profileImageAlignment === 'left' ? '0 0 5px 0' :
                            profileImageAlignment === 'right' ? '0 0 5px auto' :
                            '0 auto 5px auto',
                    overflow: 'hidden',
                    borderRadius: `${profileImageBorderRadius}%`,
                    display: 'block',
                    border: tempProfileImageBorder ? `${tempProfileImageBorderThickness}px solid ${tempProfileImageBorderColor}` : 'none'
                  }}
                >
                  <img
                    src={profileImage}
                    alt="Profilbild"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                      userSelect: 'none'
                    }}
                  />
                </Box>
              </Box>
            </Box>
          )}
          
          {/* Rundungs-Slider */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151', mb: 2 }}>
              {getTranslatedCvLabel('Rundung:')} {profileImageBorderRadius === 0 ? getTranslatedCvLabel('Eckig') : profileImageBorderRadius === 50 ? getTranslatedCvLabel('Rund') : `${profileImageBorderRadius}%`}
            </Typography>
            <Slider
              value={profileImageBorderRadius}
              onChange={(_, value: number | number[]) => setProfileImageBorderRadius(value as number)}
              min={0}
              max={50}
              step={5}
              marks={[
                { value: 0, label: getTranslatedCvLabel('Eckig') },
                { value: 25, label: '25%' },
                { value: 50, label: getTranslatedCvLabel('Rund') },
              ]}
              valueLabelDisplay="auto"
              sx={{
                color: '#667eea',
                '& .MuiSlider-thumb': {
                  backgroundColor: '#667eea',
                },
                '& .MuiSlider-track': {
                  backgroundColor: '#667eea',
                },
                '& .MuiSlider-rail': {
                  backgroundColor: '#e2e8f0',
                },
              }}
            />
          </Box>

          {/* Rahmen-Einstellungen */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151', mb: 2 }}>
              {getTranslatedCvLabel('Rahmen')}
            </Typography>
            <FormControlLabel
              control={
                <Checkbox
                  checked={tempProfileImageBorder}
                  onChange={(e) => setTempProfileImageBorder(e.target.checked)}
                  sx={{
                    color: '#667eea',
                    '&.Mui-checked': {
                      color: '#667eea',
                    }
                  }}
                />
              }
              label={getTranslatedCvLabel('Rahmen um das Profilbild anzeigen')}
              sx={{ mb: 2 }}
            />
            {tempProfileImageBorder && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151', mb: 1 }}>
                  {getTranslatedCvLabel('Rahmenfarbe')}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                  <input
                    type="color"
                    value={tempProfileImageBorderColor}
                    onChange={(e) => setTempProfileImageBorderColor(e.target.value)}
                    style={{
                      width: '40px',
                      height: '40px',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}
                  />
                  <TextField
                    value={tempProfileImageBorderColor}
                    onChange={(e) => setTempProfileImageBorderColor(e.target.value)}
                    size="small"
                    sx={{
                      width: '100px',
                      '& .MuiOutlinedInput-root': {
                        fontSize: '12px'
                      }
                    }}
                  />
                </Box>
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151', mb: 1 }}>
                  {getTranslatedCvLabel('Rahmendicke:')} {tempProfileImageBorderThickness}px
                </Typography>
                <Slider
                  value={tempProfileImageBorderThickness}
                  onChange={(_, value: number | number[]) => setTempProfileImageBorderThickness(value as number)}
                  min={1}
                  max={20}
                  step={1}
                  marks={[
                    { value: 1, label: '1px' },
                    { value: 5, label: '5px' },
                    { value: 10, label: '10px' },
                    { value: 15, label: '15px' },
                    { value: 20, label: '20px' },
                  ]}
                  valueLabelDisplay="auto"
                  sx={{
                    color: '#667eea',
                    '& .MuiSlider-thumb': {
                      backgroundColor: '#667eea',
                    },
                    '& .MuiSlider-track': {
                      backgroundColor: '#667eea',
                    },
                    '& .MuiSlider-rail': {
                      backgroundColor: '#e2e8f0',
                    }
                  }}
                />
              </Box>
            )}
          </Box>
          
          {/* Größen-Auswahl */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151', mb: 2 }}>
              {getTranslatedCvLabel('Profilbild-Größe')}
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
              {['S', 'M', 'L'].map((size) => (
                <FormControlLabel
                  key={size}
                  control={
                    <Checkbox
                      checked={profileImageSize === size}
                      onChange={() => setProfileImageSize(size)}
                      sx={{
                        color: '#667eea',
                        '&.Mui-checked': {
                          color: '#667eea',
                        },
                      }}
                    />
                  }
                  label={
                    <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                      {size}
                    </Typography>
                  }
                />
              ))}
            </Box>
          </Box>
          
          {/* Breiten-Anpassung - nur für Admin sichtbar */}
          {isAdmin() && (
            <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
              <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151', mb: 2 }}>
                {getTranslatedCvLabel('Breite:')} {profileImageWidth}%
              </Typography>
              <Slider
                value={profileImageWidth}
                onChange={(_, value: number | number[]) => setProfileImageWidth(value as number)}
                min={50}
                max={100}
                step={10}
                marks={[
                  { value: 50, label: '50%' },
                  { value: 75, label: '75%' },
                  { value: 100, label: '100%' },
                ]}
                valueLabelDisplay="auto"
                sx={{
                  color: '#667eea',
                  '& .MuiSlider-thumb': {
                    backgroundColor: '#667eea',
                  },
                  '& .MuiSlider-track': {
                    backgroundColor: '#667eea',
                  },
                  '& .MuiSlider-rail': {
                    backgroundColor: '#e2e8f0',
                  },
                }}
              />
            </Box>
          )}
          
          {/* Ausrichtungs-Auswahl - nur für Admin sichtbar */}
          {isAdmin() && (
            <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
              <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151', mb: 2 }}>
                {getTranslatedCvLabel('Profilbild-Ausrichtung')}
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
                {[
                  { value: 'left', label: 'Links' },
                  { value: 'center', label: 'Mittig' },
                  { value: 'right', label: 'Rechts' }
                ].map((alignment) => (
                  <FormControlLabel
                    key={alignment.value}
                    control={
                      <Checkbox
                        checked={profileImageAlignment === alignment.value}
                        onChange={() => setProfileImageAlignment(alignment.value)}
                        sx={{
                          color: '#667eea',
                          '&.Mui-checked': {
                            color: '#667eea',
                          },
                        }}
                      />
                    }
                    label={
                      <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                        {getTranslatedCvLabel(alignment.label)}
                      </Typography>
                    }
                  />
                ))}
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            variant="outlined" 
            onClick={handleCloseProfileImageModal}
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              }
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Textfarben-Modal */}
      <Dialog
        open={showTextColorPalette}
        onClose={handleCloseTextColorPalette}
        maxWidth="lg"
        sx={{ zIndex: 1800 }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.25)'
          }
        }}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '800px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
            <Typography variant="h5" sx={{ fontWeight: 700, color: 'white', textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              Textfarben anpassen
            </Typography>
            <IconButton 
              onClick={handleCloseTextColorPalette}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.1)'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        
        <DialogContent sx={{ p: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            {renderTextColorPalette('name', tempNameTextColor)}
            {renderTextColorPalette('left', tempLeftColumnTextColor)}
            {renderTextColorPalette('right', tempRightColumnTextColor)}
            {renderTextColorPalette('leftTitle', tempLeftColumnTitleColor)}
            {renderTextColorPalette('rightTitle', tempRightColumnTitleColor)}
          </Box>
        </DialogContent>
        
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={handleCloseTextColorPalette}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            Schließen
          </Button>
        </DialogActions>
      </Dialog>

      {/* Bewerbungsdetails Modal */}
      <Dialog
        open={showApplicationDetailsModal}
        hideBackdrop={showCvDataModal}
        disableEnforceFocus={showCvDataModal}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.25)' // Halbierte Opazität (Standard: 0.5)
          }
        }}
        onClose={async () => {
          await handleCloseApplicationDetailsModal();
        }}
        maxWidth="lg"
        fullWidth
        sx={{
          zIndex: showCvDataModal ? 1300 : 1400
        }}
        PaperProps={{
          sx: {
            maxHeight: '95vh',
            height: '95vh',
            width: 'min(920px, calc(100vw - 40px))',
            margin: '20px',
            borderRadius: 3
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              {getTranslatedCvLabel('Bewerbungsdetails')}
            </Typography>
            {selectedApplication && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', flex: 1, mr: 2 }}>
                <Box sx={{ minWidth: 250 }}>
                  <FormControl fullWidth size="small">
                    {(() => {
                      const allowedModalStatuses = ['Offen', 'Eingereicht', 'Vorstellungsgespräch', 'Zusage', 'Absage', 'Geschlossen'];
                      const normalizedStatus = selectedApplication.status || 'Offen';
                      const selectedStatusForModal = allowedModalStatuses.includes(normalizedStatus) ? normalizedStatus : 'Offen';
                      return (
                        <Select
                          value={selectedStatusForModal}
                          MenuProps={{ disablePortal: true }}
                          onChange={async (e) => {
                            const newStatus = e.target.value;

                            setSelectedApplication((prev: any) => ({ ...prev, status: newStatus }));

                            setApplications((prev: any[]) =>
                              prev.map(app =>
                                app.id === selectedApplication.id
                                  ? { ...app, status: newStatus }
                                  : app
                              )
                            );

                            try {
                              const token = await user?.getIdToken();
                              await fetch(`${config.backend.baseUrl}/api/update-application-status`, {
                                method: 'PUT',
                                headers: {
                                  'Authorization': `Bearer ${token}`,
                                  'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                  id: selectedApplication.id,
                                  status: newStatus
                                })
                              });
                              console.log('✅ Status aktualisiert:', newStatus);
                            } catch (error) {
                              console.error('❌ Fehler beim Aktualisieren des Status:', error);
                            }
                          }}
                          sx={{
                            color: 'white',
                            bgcolor: 'transparent',
                            '& .MuiSelect-select': {
                              display: 'flex',
                              justifyContent: 'flex-end',
                              textAlign: 'right',
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'transparent',
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'transparent',
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'transparent',
                            },
                            '& .MuiSelect-icon': {
                              color: 'white'
                            }
                          }}
                        >
                          <MenuItem value="Offen">
                            <Chip
                              label={getTranslatedCvLabel('Offen')}
                              size="small"
                              sx={{ bgcolor: '#3b82f6', color: 'white', fontWeight: 600 }}
                            />
                          </MenuItem>
                          <MenuItem value="Eingereicht">
                            <Chip
                              label={getTranslatedCvLabel('Eingereicht')}
                              size="small"
                              sx={{ bgcolor: '#2563eb', color: 'white', fontWeight: 600 }}
                            />
                          </MenuItem>
                          <MenuItem value="Vorstellungsgespräch">
                            <Chip
                              label={getTranslatedCvLabel('Vorstellungsgespräch')}
                              size="small"
                              sx={{ bgcolor: '#f59e0b', color: 'white', fontWeight: 600 }}
                            />
                          </MenuItem>
                          <MenuItem value="Zusage">
                            <Chip
                              label={getTranslatedCvLabel('Zusage')}
                              size="small"
                              sx={{ bgcolor: '#059669', color: 'white', fontWeight: 600 }}
                            />
                          </MenuItem>
                          <MenuItem value="Absage">
                            <Chip
                              label={getTranslatedCvLabel('Absage')}
                              size="small"
                              sx={{ bgcolor: '#ef4444', color: 'white', fontWeight: 600 }}
                            />
                          </MenuItem>
                          <MenuItem value="Geschlossen">
                            <Chip
                              label={getTranslatedCvLabel('Geschlossen')}
                              size="small"
                              sx={{ bgcolor: '#6b7280', color: 'white', fontWeight: 600 }}
                            />
                          </MenuItem>
                        </Select>
                      );
                    })()}
                  </FormControl>
                </Box>
              </Box>
            )}
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <Tooltip title={getTranslatedCvLabel('Bewerbung löschen')} arrow>
                <IconButton 
                  size="small"
                  onClick={async () => {
                    if (!selectedApplication) return;
                    try {
                      const idToken = await user?.getIdToken();
                      await fetch(`${config.backend.baseUrl}/api/delete-job-description/${selectedApplication.id}`, {
                        method: 'DELETE',
                        headers: {
                          'Authorization': `Bearer ${idToken}`
                        }
                      });
                      setApplications(prev => prev.filter(a => a.id !== selectedApplication.id));
                      console.log('✅ Application gelöscht');
                      await handleCloseApplicationDetailsModal({ saveBeforeClose: false });
                    } catch (error) {
                      console.error('❌ Fehler beim Löschen:', error);
                    }
                  }}
                  sx={{
                    color: 'white',
                    transition: 'all 0.2s ease',
                    borderRadius: '50%',
                    '&:hover': {
                      color: '#ffebee',
                      bgcolor: 'rgba(255,255,255,0.1)',
                      transform: 'scale(1.1)',
                      borderRadius: '50%'
                    }
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
              <IconButton 
                onClick={async () => {
                  await handleCloseApplicationDetailsModal();
                }}
                sx={{ 
                  color: 'white',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.1)'
                  }
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        </DialogTitle>
        
        <DialogContent sx={{ p: 3, pt: 6, pb: 6, overflowY: 'auto' }}>
          {selectedApplication && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              {/* Passgenauigkeit (Fallback einzeln) */}
              {(!Array.isArray((selectedApplication as any).cvMatchResults) || (selectedApplication as any).cvMatchResults.length === 0) &&
                selectedApplication.matchScore !== null && selectedApplication.matchScore !== undefined && (
              <Box sx={{ display: 'flex', gap: 3, alignItems: 'flex-start', mt: 3 }}>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="caption" sx={{ 
                      fontWeight: 700, 
                      color: '#64748b', 
                      fontSize: '0.95rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      display: 'block',
                      mb: 1
                    }}>
                      {getTranslatedCvLabel('Bewerbung')}
                    </Typography>
                    <Chip
                      label={`${selectedApplication.matchScore}%`}
                      size="small"
                      onClick={async () => {
                        if (!selectedApplication?.id) return;

                        const prefetchedScore =
                          typeof selectedApplication.matchScore === 'number'
                            ? selectedApplication.matchScore
                            : null;
                        const prefetchedMissingSkills = normalizeMatchList(selectedApplication.missingSkills);
                        const prefetchedWeaknesses = normalizeMatchList(selectedApplication.weaknesses);

                        setSelectedApplicationId(selectedApplication.id);
                        if (selectedApplication.cvId) {
                          // Lade zuerst den richtigen CV-Datensatz vollständig, bevor das Modal geöffnet wird.
                          // Nur setSelectedCvId(...) kann zu gemischten/stale States führen.
                          await handleSelectCv(selectedApplication.cvId, false, false);
                        }
                        await openCvDataModal(
                          true,
                          true,
                          false,
                          {
                            matchScore: prefetchedScore,
                            missingSkills: prefetchedMissingSkills,
                            weaknesses: prefetchedWeaknesses
                          }
                        );
                      }}
                      sx={{
                        bgcolor: selectedApplication.matchScore >= 75 ? '#667eea' : selectedApplication.matchScore >= 50 ? '#f59e0b' : '#ef4444',
                        color: 'white',
                        fontWeight: 700,
                        cursor: 'pointer',
                        '&:hover': {
                          opacity: 0.9
                        }
                      }}
                    />
                  </Box>
              </Box>
              )}

              {/* Job-Informationen - einklappbar */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                <Typography variant="caption" sx={{
                  fontWeight: 700,
                  color: '#64748b',
                  fontSize: '0.95rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  display: 'block'
                }}>
                  {getTranslatedCvLabel('Job-Informationen')}
                </Typography>
                <IconButton
                  size="small"
                  onClick={() => setIsJobInformationCollapsed((prev) => !prev)}
                  sx={{ color: '#64748b', p: 0.25 }}
                >
                  {isJobInformationCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                </IconButton>
              </Box>
              {!isJobInformationCollapsed && (
              <>
              <Box sx={{ mb: 2 }}>
                <Typography variant="caption" sx={{
                  fontWeight: 700,
                  color: '#64748b',
                  fontSize: '0.75rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  display: 'block',
                  mb: 1
                }}>
                  {getTranslatedCvLabel('Rollentitel')}
                </Typography>
                <TextField
                  fullWidth
                  value={editableRoleTitle}
                  onChange={(e) => setEditableRoleTitle(e.target.value)}
                  placeholder={getTranslatedCvLabel('Rollentitel eingeben...')}
                  variant="outlined"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      '&:hover fieldset': {
                        borderColor: '#667eea',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#667eea',
                      },
                    }
                  }}
                />
              </Box>
              <Box sx={{ display: 'flex', gap: 3, alignItems: 'flex-start' }}>
                {/* Firma */}
                <Box sx={{ flex: 1 }}>
                  <Typography variant="caption" sx={{ 
                    fontWeight: 700, 
                    color: '#64748b', 
                    fontSize: '0.75rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    display: 'block',
                    mb: 1
                  }}>
                    {getTranslatedCvLabel('Firma')}
                  </Typography>
                  <TextField
                    fullWidth
                    value={editableCompany}
                    onChange={(e) => setEditableCompany(e.target.value)}
                    placeholder={getTranslatedCvLabel('Firmenname eingeben...')}
                    variant="outlined"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#667eea',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#667eea',
                        },
                      }
                    }}
                  />
                </Box>
                
                {/* Branche */}
                <Box sx={{ flex: 1 }}>
                  <Typography variant="caption" sx={{ 
                    fontWeight: 700, 
                    color: '#64748b', 
                    fontSize: '0.75rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    display: 'block',
                    mb: 1
                  }}>
                    {getTranslatedCvLabel('Branche')}
                  </Typography>
                  <TextField
                    fullWidth
                    value={editableIndustry}
                    onChange={(e) => setEditableIndustry(e.target.value)}
                    placeholder={getTranslatedCvLabel('Branche eingeben...')}
                    variant="outlined"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#667eea',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#667eea',
                        },
                      }
                    }}
                  />
                </Box>
              </Box>
              </>
              )}

              {/* Passgenauigkeiten pro CV-Daten-Set als Tabelle */}
              <Box sx={{ mt: 3, order: -1 }}>
                <Typography variant="caption" sx={{
                  fontWeight: 700,
                  color: '#64748b',
                  fontSize: '0.95rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  display: 'block',
                  mb: 1
                }}>
                  {getTranslatedCvLabel('Bewerbung')}
                </Typography>
                <TableContainer sx={{ border: '1px solid #e2e8f0', borderRadius: 2 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem', bgcolor: '#f8fafc' }}>
                          {getTranslatedCvLabel('CV-Daten Set')}
                        </TableCell>
                        <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem', bgcolor: '#f8fafc', width: '140px' }}>
                          {getTranslatedCvLabel('Passgenauigkeit:')}
                        </TableCell>
                        <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem', bgcolor: '#f8fafc', width: '70px', textAlign: 'center' }}>
                          CV
                        </TableCell>
                        {(accountType === 'Pro' || accountType === 'Beta-Testing') && (
                          <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem', bgcolor: '#f8fafc', width: '90px', textAlign: 'center' }}>
                            Share
                          </TableCell>
                        )}
                        {(accountType === 'Pro' || accountType === 'Beta-Testing') && (
                          <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem', bgcolor: '#f8fafc', width: '120px', textAlign: 'center' }}>
                            {getTranslatedCvLabel('Status')}
                          </TableCell>
                        )}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {getCvMatchResultsForApplication(selectedApplication).length > 0 ? (
                        (() => {
                          const cvMatchResultsForSelected = getCvMatchResultsForApplication(selectedApplication);
                          const hasMultipleCvRows = cvMatchResultsForSelected.length > 1;
                          return cvMatchResultsForSelected.map((entry: any, index: number) => {
                          const rowKey = `${selectedApplication?.id || 'app'}-${entry.cvId || entry.cvSetRef || entry.cvName || 'cv'}-${index}`;
                          const isRowOptimizing = optimizingCvRowKey === rowKey;
                          const hasPersistedPreviewForRow =
                            !hasMultipleCvRows &&
                            !!selectedApplication?.cvPreviewData?.encrypted &&
                            matchesCvRowByIdentity(
                              selectedApplication,
                              entry
                            );
                          const rowHasOptimizedCv = hasPersistedPreviewForRow || !!(entry as any)?.hasOptimizedCv;
                          const rowReviewStatus =
                            typeof (entry as any)?.rowStatus === 'string' && (entry as any).rowStatus.trim()
                              ? (entry as any).rowStatus.trim()
                              : null;
                          const rowStatusForSelect =
                            rowReviewStatus || (rowHasOptimizedCv ? 'Optimiert' : 'Nicht optimiert');
                          const getRowStatusChipSx = (statusValue: string) => {
                            if (statusValue === 'Eingereicht') return { bgcolor: '#2563eb', color: 'white', fontWeight: 600 };
                            if (statusValue === 'Vorstellungsgespräch') return { bgcolor: '#f59e0b', color: 'white', fontWeight: 600 };
                            if (statusValue === 'Zusage') return { bgcolor: '#059669', color: 'white', fontWeight: 600 };
                            if (statusValue === 'Absage') return { bgcolor: '#ef4444', color: 'white', fontWeight: 600 };
                            if (statusValue === 'In Prüfung') return { bgcolor: '#8b5cf6', color: 'white', fontWeight: 600 };
                            if (statusValue === 'Freigegeben') return { bgcolor: '#10b981', color: 'white', fontWeight: 600 };
                            if (statusValue === 'Optimiert') return { bgcolor: '#16a34a', color: 'white', fontWeight: 600 };
                            return { bgcolor: '#64748b', color: 'white', fontWeight: 600 };
                          };
                          return (
                          <TableRow key={`${entry.cvId || entry.cvSetRef || entry.cvName || 'cv'}-${index}`}>
                            <TableCell sx={{ fontSize: '0.85rem', color: '#1e293b', fontWeight: 500 }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <span>{entry.cvName || 'CV'}</span>
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Chip
                                label={
                                  typeof entry.matchScore === 'number'
                                    ? `${entry.matchScore}%`
                                    : (typeof entry.calculationError === 'string' && entry.calculationError.trim()
                                      ? (currentLanguage === 'de' ? 'Nicht berechenbar' : 'Not calculable')
                                      : '--')
                                }
                                size="small"
                                onClick={async () => {
                                  if (typeof entry.matchScore !== 'number') return;
                                  if (!selectedApplication?.id) return;

                                  // Stelle sicher, dass Änderungen aus dem Bewerbungsdetails-Modal
                                  // vor dem Öffnen der Match-Details persistiert sind.
                                  await saveApplicationData();

                                  const prefetchedScore = typeof entry.matchScore === 'number' ? entry.matchScore : null;
                                  const prefetchedMissingSkills = normalizeMatchList(entry.missingSkills);
                                  const prefetchedWeaknesses = normalizeMatchList(entry.weaknesses);

                                  setSelectedApplicationId(selectedApplication.id);
                                  try {
                                    const resolved = await selectCvForMatchEntry(entry);
                                    const snapshot = await resolveAndLoadCvSetOrThrow({
                                      cv: resolved.resolvedCv,
                                      cvId: resolved.resolvedCvId,
                                      cvSetRef: resolved.resolvedCvSetRef,
                                      sourceCvData: resolved.resolvedCv?.data && typeof resolved.resolvedCv.data === 'object'
                                        ? resolved.resolvedCv.data
                                        : null,
                                      forceReload: hasCvDataChangedSinceLastMatch,
                                      maxAgeMs: 20000,
                                      label: resolved.resolvedCv?.cvName || entry?.cvName || 'CV'
                                    });
                                    const applied = applyCvSourceToEditorState(
                                      snapshot.cvData,
                                      resolved.resolvedCv?.cvName || entry?.cvName || ''
                                    );
                                    if (!applied) {
                                      setError('CV-Daten-Set konnte nicht geladen werden.');
                                      return;
                                    }
                                  } catch (selectionError: any) {
                                    setError(selectionError?.message || 'CV-Daten-Set konnte nicht geladen werden.');
                                    return;
                                  }
                                  activeCvPreviewRowContextRef.current = {
                                    applicationId: selectedApplication.id,
                                    rowEntry: entry
                                  };
                                  await openCvDataModal(
                                    true,
                                    true,
                                    false,
                                    {
                                      matchScore: prefetchedScore,
                                      missingSkills: prefetchedMissingSkills,
                                      weaknesses: prefetchedWeaknesses
                                    }
                                  );
                                }}
                                sx={{
                                  bgcolor: typeof entry.matchScore === 'number'
                                    ? (entry.matchScore >= 75 ? '#667eea' : entry.matchScore >= 50 ? '#f59e0b' : '#ef4444')
                                    : (typeof entry.calculationError === 'string' && entry.calculationError.trim() ? '#ef4444' : '#64748b'),
                                  color: 'white',
                                  fontWeight: 700,
                                  cursor: typeof entry.matchScore === 'number' ? 'pointer' : 'default'
                                }}
                              />
                              {typeof entry.calculationError === 'string' && entry.calculationError.trim() && (
                                <Typography variant="caption" sx={{ color: '#ef4444', display: 'block', mt: 0.5 }}>
                                  {entry.calculationError}
                                </Typography>
                              )}
                            </TableCell>
                            <TableCell sx={{ textAlign: 'center' }}>
                              <IconButton
                                size="small"
                                disabled={isRowOptimizing}
                                onClick={async () => {
                                  if (!selectedApplication?.id) return;

                                  setSelectedApplicationId(selectedApplication.id);

                                  let resolvedCvIdForRow: string | null = null;
                                  let resolvedCvForRow: any = null;
                                  let resolvedCvSetRefForRow: string = '';
                                  try {
                                    const resolved = await selectCvForMatchEntry(entry);
                                    resolvedCvIdForRow = resolved.resolvedCvId;
                                    resolvedCvForRow = resolved.resolvedCv;
                                    resolvedCvSetRefForRow = resolved.resolvedCvSetRef;
                                  } catch (selectionError: any) {
                                    setError(selectionError?.message || 'CV-Daten-Set konnte nicht geladen werden.');
                                    return;
                                  }

                                  // Legacy-Fall: Optimierte Preview liegt direkt auf der Application.
                                  const hasPersistedApplicationPreviewForRow =
                                    !hasMultipleCvRows &&
                                    !!selectedApplication?.cvPreviewData?.encrypted &&
                                    matchesCvRowByIdentity(
                                      selectedApplication,
                                      entry
                                    );
                                  // Neuer Fall: Optimierung wird pro CV-Zeile in cvMatchResults markiert.
                                  const hasOptimizedCvForRow = !!(entry as any)?.hasOptimizedCv;
                                  const hasExistingPreviewForRow = hasPersistedApplicationPreviewForRow || hasOptimizedCvForRow;

                                  if (hasExistingPreviewForRow) {
                                    await handleOpenCvPreviewFromApplication(selectedApplication.id, false, entry);
                                  } else {
                                    // Row-spezifischer Optimierungsflow:
                                    // globales selectedCvId explizit leeren, damit kein fremdes CV
                                    // als Fallback in den Prozess einfließt.
                                    setSelectedCvId(null);
                                    localStorage.removeItem('selectedCvId');

                                    // Stelle sicher, dass für die Optimierung eine Job-Beschreibung vorhanden ist.
                                    const fallbackJobDescription =
                                      selectedApplication?.jobDescription && selectedApplication.jobDescription.trim()
                                        ? selectedApplication.jobDescription.trim()
                                        : '';
                                    if ((!jobDescription || !jobDescription.trim()) && fallbackJobDescription) {
                                      setJobDescription(fallbackJobDescription);
                                    }

                                    // Bei Icon-Klick soll die Optimierung direkt bis zur Preview laufen
                                    // (ohne den optionalen Warn-Dialog als Zwischenstopp).
                                    skipTemplateWarningForIconFlowRef.current = true;
                                    setOptimizingCvRowKey(rowKey);
                                    let cvDataForRow: any = null;
                                    try {
                                      const snapshot = await resolveAndLoadCvSetOrThrow({
                                        cv: resolvedCvForRow,
                                        cvId: resolvedCvIdForRow,
                                        cvSetRef: resolvedCvSetRefForRow,
                                        sourceCvData: resolvedCvForRow?.data && typeof resolvedCvForRow.data === 'object'
                                          ? resolvedCvForRow.data
                                          : null,
                                        forceReload: hasCvDataChangedSinceLastMatch,
                                        maxAgeMs: 20000,
                                        label: (resolvedCvForRow as any)?.cvName || entry?.cvName || 'CV'
                                      });
                                      cvDataForRow = {
                                        ...snapshot.cvData,
                                        cvId: snapshot.cvId || resolvedCvIdForRow || undefined,
                                        cvSetRef: snapshot.cvSetRef || resolvedCvSetRefForRow || undefined
                                      };
                                      await handleOptimizeCvParallel(
                                        fallbackJobDescription || jobDescription || '',
                                        cvDataForRow
                                      );
                                    } finally {
                                      setOptimizingCvRowKey(null);
                                      skipTemplateWarningForIconFlowRef.current = false;
                                    }

                                    const collectedData = (window as any).collectedCvData || null;
                                    const rowPreviewSaved = await saveCvPreviewDataToApplicationRow(
                                      selectedApplication.id,
                                      entry,
                                      cvDataForRow || undefined,
                                      collectedData
                                    );

                                    if (rowPreviewSaved || hasOptimizedCvData()) {
                                      const currentCvMatchResults = getCvMatchResultsForApplication(selectedApplication);
                                      const updatedCvMatchResults = currentCvMatchResults.map((row: any, candidateIndex: number) => {
                                        if (matchesCvRowByIdentity(entry, row, index, candidateIndex)) {
                                          return { ...row, hasOptimizedCv: true };
                                        }
                                        return row;
                                      });

                                      await persistApplicationMatchData(
                                        selectedApplication.id,
                                        typeof selectedApplication.matchScore === 'number' ? selectedApplication.matchScore : null,
                                        Array.isArray(selectedApplication.missingSkills) ? selectedApplication.missingSkills : [],
                                        Array.isArray(selectedApplication.weaknesses) ? selectedApplication.weaknesses : [],
                                        undefined,
                                        updatedCvMatchResults
                                      );

                                      await handleOpenCvPreviewFromApplication(selectedApplication.id, false, entry);
                                    }
                                  }
                                }}
                                sx={{
                                  color: isRowOptimizing ? '#94a3b8' : '#667eea',
                                  p: 0.75,
                                  '&:hover': {
                                    bgcolor: isRowOptimizing ? 'transparent' : '#f0f4ff'
                                  }
                                }}
                              >
                                {isRowOptimizing ? (
                                  <CircularProgress size={16} sx={{ color: '#667eea' }} />
                                ) : (
                                  <DescriptionOutlinedIcon sx={{ fontSize: 22 }} />
                                )}
                              </IconButton>
                            </TableCell>
                            {(accountType === 'Pro' || accountType === 'Beta-Testing') && (
                              <TableCell sx={{ textAlign: 'center' }}>
                                <Tooltip title={rowHasOptimizedCv ? getTranslatedCvLabel('Share-Link erstellen') : getTranslatedCvLabel('CV-Vorschau öffnen')}>
                                  <span>
                                    <IconButton
                                      size="small"
                                      onClick={async () => {
                                        if (!selectedApplication?.id || !rowHasOptimizedCv) return;
                                        await generateShareLink(selectedApplication.id, undefined, entry, rowKey, index);
                                      }}
                                      disabled={generatingShareLinkRowKey === rowKey || !rowHasOptimizedCv}
                                      sx={{
                                        color: rowHasOptimizedCv ? '#667eea' : '#cbd5e1',
                                        p: 0.75,
                                        '&:hover': {
                                          bgcolor: rowHasOptimizedCv ? '#f0f4ff' : 'transparent'
                                        }
                                      }}
                                    >
                                      {generatingShareLinkRowKey === rowKey && rowHasOptimizedCv ? (
                                        <CircularProgress size={16} sx={{ color: '#667eea' }} />
                                      ) : (
                                        <ShareIcon sx={{ fontSize: 22 }} />
                                      )}
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              </TableCell>
                            )}
                            {(accountType === 'Pro' || accountType === 'Beta-Testing') && (
                              <TableCell sx={{ textAlign: 'center' }}>
                                <FormControl size="small" sx={{ minWidth: 145 }}>
                                  <Select
                                    value={rowStatusForSelect}
                                    disabled={isRowOptimizing}
                                    MenuProps={{ disablePortal: true }}
                                    renderValue={(selectedValue) => (
                                      <Chip
                                        label={getTranslatedCvLabel(selectedValue as string)}
                                        size="small"
                                        sx={getRowStatusChipSx(selectedValue as string)}
                                      />
                                    )}
                                    onChange={async (e) => {
                                      if (!selectedApplication?.id) return;
                                      const newRowStatus = e.target.value as string;

                                      const currentCvMatchResults = getCvMatchResultsForApplication(selectedApplication);
                                      const updatedCvMatchResults = currentCvMatchResults.map((row: any, candidateIndex: number) => {
                                        if (matchesCvRowByIdentity(entry, row, index, candidateIndex)) {
                                          return { ...row, rowStatus: newRowStatus };
                                        }
                                        return row;
                                      });

                                      await persistApplicationMatchData(
                                        selectedApplication.id,
                                        typeof selectedApplication.matchScore === 'number' ? selectedApplication.matchScore : null,
                                        Array.isArray(selectedApplication.missingSkills) ? selectedApplication.missingSkills : [],
                                        Array.isArray(selectedApplication.weaknesses) ? selectedApplication.weaknesses : [],
                                        undefined,
                                        updatedCvMatchResults
                                      );
                                    }}
                                    sx={{
                                      '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#e2e8f0',
                                      },
                                      '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#667eea',
                                      },
                                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#667eea',
                                      },
                                      '&.Mui-disabled': {
                                        opacity: 0.8
                                      }
                                    }}
                                  >
                                    <MenuItem value="Nicht optimiert">
                                      <Chip
                                        label={getTranslatedCvLabel('Nicht optimiert')}
                                        size="small"
                                        sx={getRowStatusChipSx('Nicht optimiert')}
                                      />
                                    </MenuItem>
                                    <MenuItem value="Optimiert">
                                      <Chip
                                        label={getTranslatedCvLabel('Optimiert')}
                                        size="small"
                                        sx={getRowStatusChipSx('Optimiert')}
                                      />
                                    </MenuItem>
                                    <MenuItem value="In Prüfung">
                                      <Chip
                                        label={getTranslatedCvLabel('In Prüfung')}
                                        size="small"
                                        sx={getRowStatusChipSx('In Prüfung')}
                                      />
                                    </MenuItem>
                                    <MenuItem value="Freigegeben">
                                      <Chip
                                        label={getTranslatedCvLabel('Freigegeben')}
                                        size="small"
                                        sx={getRowStatusChipSx('Freigegeben')}
                                      />
                                    </MenuItem>
                                    <MenuItem value="Eingereicht">
                                      <Chip
                                        label={getTranslatedCvLabel('Eingereicht')}
                                        size="small"
                                        sx={getRowStatusChipSx('Eingereicht')}
                                      />
                                    </MenuItem>
                                    <MenuItem value="Vorstellungsgespräch">
                                      <Chip
                                        label={getTranslatedCvLabel('Vorstellungsgespräch')}
                                        size="small"
                                        sx={getRowStatusChipSx('Vorstellungsgespräch')}
                                      />
                                    </MenuItem>
                                    <MenuItem value="Zusage">
                                      <Chip
                                        label={getTranslatedCvLabel('Zusage')}
                                        size="small"
                                        sx={getRowStatusChipSx('Zusage')}
                                      />
                                    </MenuItem>
                                    <MenuItem value="Absage">
                                      <Chip
                                        label={getTranslatedCvLabel('Absage')}
                                        size="small"
                                        sx={getRowStatusChipSx('Absage')}
                                      />
                                    </MenuItem>
                                  </Select>
                                </FormControl>
                              </TableCell>
                            )}
                          </TableRow>
                          );
                        });
                        })()
                      ) : (
                        <TableRow>
                          <TableCell colSpan={(accountType === 'Pro' || accountType === 'Beta-Testing') ? 5 : 3} sx={{ textAlign: 'center', color: '#94a3b8', fontStyle: 'italic' }}>
                            {getTranslatedCvLabel('Keine Passgenauigkeit vorhanden')}
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
              
              {/* Notizen - Editierbar */}
              <Box sx={{ order: -1 }}>
                <Typography variant="caption" sx={{ 
                  fontWeight: 700, 
                  color: '#64748b', 
                  fontSize: '0.75rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  display: 'block',
                  mb: 1
                }}>
                  {getTranslatedCvLabel('Notizen')}
                </Typography>
                <TextField
                  multiline
                  rows={3}
                  fullWidth
                  value={editableNotes}
                  onChange={(e) => setEditableNotes(e.target.value)}
                  placeholder={getTranslatedCvLabel('Notizen zur Bewerbung hinzufügen...')}
                  variant="outlined"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      '&:hover fieldset': {
                        borderColor: '#667eea',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#667eea',
                      },
                    }
                  }}
                />
              </Box>

              {!isJobInformationCollapsed && (
              <>
              {/* Kontaktdaten (unterhalb von Notizen) */}
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'stretch', 
                gap: 2
              }}>
                <Box sx={{ 
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                  <Typography variant="caption" sx={{ 
                    fontWeight: 700, 
                    color: '#64748b', 
                    fontSize: '0.75rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    display: 'block',
                    mb: 1
                  }}>
                    {getTranslatedCvLabel('Kontaktdaten')}
                  </Typography>
                  <TextField
                    fullWidth
                    multiline
                    minRows={1}
                    maxRows={6}
                    value={editableContactInfo}
                    onChange={(e) => setEditableContactInfo(e.target.value)}
                    placeholder={getTranslatedCvLabel('Kontaktdaten eingeben...')}
                    variant="outlined"
                    sx={{
                      flex: 1,
                      '& .MuiOutlinedInput-root': {
                        height: '100%',
                        alignItems: 'flex-start',
                        borderRadius: 2,
                        fontSize: '0.875rem',
                        '&:hover fieldset': {
                          borderColor: '#667eea',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#667eea',
                        },
                      }
                    }}
                  />
                </Box>
              </Box>

              {/* Schlüsselstichworte (editierbar wie im Hauptfenster) */}
              <Box sx={{ mb: 1 }}>
                <Typography variant="caption" sx={{ 
                  fontWeight: 700, 
                  color: '#64748b', 
                  fontSize: '0.75rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  display: 'block',
                  mb: 1
                }}>
                  {getTranslatedCvLabel('Schlüsselstichworte')}
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1 }}>
                  {editableKeywords.map((keyword: string, idx: number) => (
                    <Chip
                      key={`${keyword}-${idx}`}
                      label={keyword}
                      onDelete={() => handleRemoveApplicationKeyword(keyword)}
                      sx={{ 
                        bgcolor: '#667eea',
                        color: 'white',
                        fontWeight: 600
                      }}
                    />
                  ))}
                </Box>
                <TextField
                  fullWidth
                  value={applicationKeywordInput}
                  onChange={(e) => setApplicationKeywordInput(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ',') {
                      e.preventDefault();
                      handleAddApplicationKeyword(applicationKeywordInput);
                    }
                  }}
                  onBlur={() => handleAddApplicationKeyword(applicationKeywordInput)}
                  placeholder={getTranslatedCvLabel('Keyword eingeben und Enter drücken') || 'Keyword eingeben und Enter drücken'}
                  variant="outlined"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      '&:hover fieldset': {
                        borderColor: '#667eea',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#667eea',
                      },
                    }
                  }}
                />
              </Box>
              
              {/* Aufgaben und Anforderungen aus Job-Informationen */}
              <>
                {/* Anforderungen (editierbar) */}
                <Box sx={{ mb: 3 }}>
                    <Typography variant="caption" sx={{
                      fontWeight: 700,
                      color: '#64748b',
                      fontSize: '0.75rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      display: 'block',
                      mb: 1
                    }}>
                      {getTranslatedCvLabel('Muss-Anforderungen')}
                    </Typography>
                    <TextField
                      fullWidth
                      multiline
                      minRows={2}
                      maxRows={8}
                      value={editableRequirementsMuss}
                      onChange={(e) => setEditableRequirementsMuss(e.target.value)}
                      variant="outlined"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#667eea',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#667eea',
                          },
                        }
                      }}
                    />
                  </Box>

                  <Box sx={{ mb: 3 }}>
                    <Typography variant="caption" sx={{
                      fontWeight: 700,
                      color: '#64748b',
                      fontSize: '0.75rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      display: 'block',
                      mb: 1
                    }}>
                      {getTranslatedCvLabel('Soll-Anforderungen')}
                    </Typography>
                    <TextField
                      fullWidth
                      multiline
                      minRows={2}
                      maxRows={8}
                      value={editableRequirementsSoll}
                      onChange={(e) => setEditableRequirementsSoll(e.target.value)}
                      variant="outlined"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#667eea',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#667eea',
                          },
                        }
                      }}
                    />
                  </Box>

                  <Box sx={{ mb: 3 }}>
                    <Typography variant="caption" sx={{
                      fontWeight: 700,
                      color: '#64748b',
                      fontSize: '0.75rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      display: 'block',
                      mb: 1
                    }}>
                      {getTranslatedCvLabel('Kann-Anforderungen')}
                    </Typography>
                    <TextField
                      fullWidth
                      multiline
                      minRows={2}
                      maxRows={8}
                      value={editableRequirementsKann}
                      onChange={(e) => setEditableRequirementsKann(e.target.value)}
                      variant="outlined"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#667eea',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#667eea',
                          },
                        }
                      }}
                    />
                  </Box>

                  {/* Aufgaben (editierbar) */}
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="caption" sx={{
                      fontWeight: 700,
                      color: '#64748b',
                      fontSize: '0.75rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      display: 'block',
                      mb: 1
                    }}>
                      {getTranslatedCvLabel('Aufgaben')}
                    </Typography>
                    <TextField
                      fullWidth
                      multiline
                      minRows={3}
                      maxRows={10}
                      value={editableTasks}
                      onChange={(e) => setEditableTasks(e.target.value)}
                      variant="outlined"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#667eea',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#667eea',
                          },
                        }
                      }}
                    />
                </Box>

                  {/* Bewerbungsdetails (editierbar) */}
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="caption" sx={{
                      fontWeight: 700,
                      color: '#64748b',
                      fontSize: '0.75rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      display: 'block',
                      mb: 1
                    }}>
                      {getTranslatedCvLabel('Bewerbungsdetails')}
                    </Typography>
                    <TextField
                      fullWidth
                      multiline
                      minRows={2}
                      maxRows={8}
                      value={editableApplicationDetails}
                      onChange={(e) => setEditableApplicationDetails(e.target.value)}
                      variant="outlined"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#667eea',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#667eea',
                          },
                        }
                      }}
                    />
                  </Box>
              </>
              
              {/* Firma und Branche (unten entfernt, bleibt nur oben editierbar) */}

              {/* Erste Zeile: Auslastung (Firma wird oben angezeigt und hier nicht erneut) */}
              <Box sx={{ display: 'flex', gap: 3 }}>
                {selectedApplication.workload && (
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="caption" sx={{ 
                      fontWeight: 700, 
                      color: '#64748b', 
                      fontSize: '0.75rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      display: 'block',
                      mb: 1
                    }}>
                      {getTranslatedCvLabel('Auslastung')}
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#1e293b', fontWeight: 500 }}>
                      {selectedApplication.workload}
                    </Typography>
                  </Box>
                )}
              </Box>
              
              {/* Zweite Zeile: Ausschreibedatum, Startdatum, Kontaktdaten */}
              <Box sx={{ display: 'flex', gap: 3 }}>
                {selectedApplication.publishDate && (
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="caption" sx={{ 
                      fontWeight: 700, 
                      color: '#64748b', 
                      fontSize: '0.75rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      display: 'block',
                      mb: 1
                    }}>
                      {getTranslatedCvLabel('Ausschreibedatum')}
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#1e293b', fontWeight: 500 }}>
                      {selectedApplication.publishDate}
                    </Typography>
                  </Box>
                )}

                <Box sx={{ flex: 1 }}>
                  <Typography variant="caption" sx={{ 
                    fontWeight: 700, 
                    color: '#64748b', 
                    fontSize: '0.75rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    display: 'block',
                    mb: 1
                  }}>
                    {getTranslatedCvLabel('Startdatum')}
                  </Typography>
                  <Typography variant="body1" sx={{ color: '#1e293b', fontWeight: 500 }}>
                    {selectedApplication.startDate || '-'}
                  </Typography>
                </Box>
                
                {/* Kontaktdaten werden im PDF-Bereich links angezeigt */}
              </Box>
              
              {/* URL - wenn vorhanden */}
              {(selectedApplication.jobUrl || jobUrl) && (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="caption" sx={{ 
                    fontWeight: 700, 
                    color: '#64748b', 
                    fontSize: '0.75rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    display: 'block',
                    mb: 0.5
                  }}>
                    URL
                  </Typography>
                  <Link 
                    href={selectedApplication.jobUrl || jobUrl || ''} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    sx={{ 
                      color: '#667eea',
                      textDecoration: 'none',
                      fontSize: '0.9rem',
                      wordBreak: 'break-all',
                      '&:hover': {
                        textDecoration: 'underline'
                      }
                    }}
                  >
                    {selectedApplication.jobUrl || jobUrl}
                  </Link>
                </Box>
              )}
              </>
              )}
              
              {/* Verantwortliche Person */}
              {!isJobInformationCollapsed && user && (
                <Box sx={{ mt: 2 }}>
                  <Typography variant="caption" sx={{ 
                    fontWeight: 700, 
                    color: '#64748b', 
                    fontSize: '0.75rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    display: 'block',
                    mb: 1
                  }}>
                    {t('application.responsible.person', 'Verantwortliche Person')}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#1e293b' }}>
                    {(() => {
                      // Versuche den User-Namen aus accountUsers zu holen
                      const currentUser = accountUsers.find((u: any) => u.userId === user.uid);
                      if (currentUser && currentUser.firstName && currentUser.lastName) {
                        return `${currentUser.firstName} ${currentUser.lastName}`;
                      }
                      // Fallback auf E-Mail
                      return user.email || user.uid;
                    })()}
                  </Typography>
                </Box>
              )}
              <Box sx={{ height: '24px', flexShrink: 0 }} />
            </Box>
          )}
        </DialogContent>
        <Box sx={{ height: '14px', flexShrink: 0 }} />
      </Dialog>

      {/* Color Picker Modal */}
      <Dialog
        open={openColorPickerModal}
        onClose={handleCancelColor}
        maxWidth="sm"
        sx={{ zIndex: 1800 }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.25)'
          }
        }}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '600px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
            <Typography sx={{ 
              fontSize: '1.25rem',
              fontWeight: 700,
              color: 'white',
              textShadow: '0 1px 2px rgba(0,0,0,0.1)',
              textTransform: 'uppercase'
            }}>
              {currentColorPicker === 'header' && getTranslatedCvLabel('Header Farbe')}
              {currentColorPicker === 'column' && getTranslatedCvLabel('Spaltenfarbe')}
              {currentColorPicker === 'name' && 'Name Farbe'}
              {currentColorPicker === 'leftTitle' && 'Titel links Farbe'}
              {currentColorPicker === 'leftText' && 'Text links Farbe'}
              {currentColorPicker === 'rightTitle' && 'Titel rechts Farbe'}
              {currentColorPicker === 'rightText' && 'Text rechts Farbe'}
            </Typography>
            <IconButton 
              onClick={handleCancelColor}
              size="small"
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 5, overflowX: 'hidden' }}>
          <Box sx={{ mb: 2 }} />
          {/* Farbpicker */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#374151' }}>
              {getTranslatedCvLabel('Farbe:')}
            </Typography>
            <input
              type="color"
              value={tempColor}
              onChange={(e) => handleColorChange(e.target.value, tempAlpha)}
              style={{
                width: '100%',
                height: '60px',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                cursor: 'pointer'
              }}
            />
          </Box>

          {/* Sichtbarkeit Eingabefeld - nur für Header und Spalte */}
          {(currentColorPicker === 'header' || currentColorPicker === 'column') && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#374151' }}>
                {getTranslatedCvLabel('Sichtbarkeit (0-100%):')}
              </Typography>
              <TextField
                type="number"
                inputProps={{ min: 0, max: 100 }}
                key={`color-alpha-${Math.round(tempAlpha * 100)}`}
                defaultValue={Math.round(tempAlpha * 100)}
                onBlur={(e) => {
                  const value = parseInt(e.target.value) || 0;
                  const clampedValue = Math.max(0, Math.min(100, value));
                  handleColorChange(tempColor, clampedValue / 100);
                }}
                fullWidth
                variant="outlined"
                sx={{ 
                  '& .MuiInputLabel-root': { 
                    fontSize: '0.875rem',
                    color: '#64748b'
                  },
                  '& .MuiOutlinedInput-root': { 
                    fontSize: '0.875rem',
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#667eea'
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#667eea'
                    }
                  }
                }}
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc', justifyContent: 'flex-end' }}>
          <Button
            onClick={handleApplyColor}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>
      
      {/* Share-Link Dialog */}
      <Dialog
        open={showShareLinkDialog}
        onClose={() => setShowShareLinkDialog(false)}
        maxWidth="sm"
        fullWidth
        sx={{ zIndex: 1700 }}
      >
        <DialogTitle>
          Share-Link generiert
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Der Link wurde erfolgreich generiert. Sie können ihn kopieren und manuell versenden, oder er wurde bereits per E-Mail versendet.
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <TextField
              fullWidth
              value={shareLinkUrl || ''}
              variant="outlined"
              InputProps={{
                readOnly: true
              }}
              sx={{ flex: 1 }}
            />
            <Button
              variant="outlined"
              startIcon={<ContentCopyIcon />}
              onClick={copyShareLinkToClipboard}
            >
              Kopieren
            </Button>
          </Box>
          <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
            Dieser Link ist 7 Tage gültig.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowShareLinkDialog(false)}>
            Schließen
          </Button>
        </DialogActions>
      </Dialog>

            </Paper>
          </Container>
        </>
      )}

      <Box
        sx={{
          mt: 'auto',
          px: 2,
          py: 1.5,
          textAlign: 'center',
          borderTop: '1px solid rgba(0,0,0,0.08)',
          backgroundColor: 'rgba(255,255,255,0.85)',
          backdropFilter: 'blur(2px)',
        }}
      >
        <Typography
          variant="caption"
          sx={{
            color: 'text.secondary',
            fontSize: '0.75rem',
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.5,
            whiteSpace: 'nowrap',
          }}
        >
          {t('footer.copyright', { year: new Date().getFullYear() })}
          {' | '}
          <Link href={`${legalBaseUrl}/impressum`} target="_blank" rel="noopener noreferrer" underline="hover" color="inherit">
            {t('footer.impressum')}
          </Link>
          {' | '}
          <Link href={`${legalBaseUrl}/datenschutz`} target="_blank" rel="noopener noreferrer" underline="hover" color="inherit">
            {t('footer.privacy')}
          </Link>
          {' | '}
          <Link href={`${legalBaseUrl}/agb`} target="_blank" rel="noopener noreferrer" underline="hover" color="inherit">
            {t('footer.terms')}
          </Link>
        </Typography>
      </Box>

      {/* AI-Hilfe-Assistent */}
      <AiAssistant
        onTutorialReset={() => {
          setCvTemplateSettingsSaved(false);
        }}
        context={{
          currentMainTab: mainTabIndex,
          currentCvTab: cvTabIndex,
          currentTabIndex: tabIndex,
          hasProfilePhoto: !!profileImage,
          workExperienceCount: workExperiences.length,
          educationCount: educations.length,
          hasJobDescription: !!jobDescription && !!jobDescription.trim(),
          hasMotivationLetter: !!generatedMotivationText,
          matchScore: matchScore,
          hasData: hasData(),
          hasApplications: applications.length > 0,
          cvDataSetCount: userCvs.length,
          applicationCount: applications.length,
          hasOptimizedCv: hasOptimizedCvData(),
          cvTemplateSettingsSaved,
          cvPreviewPageCount,
          language: currentLanguage,
          activeModal: showCvDataModal ? 'cvData'
            : showProfileModal ? 'profile'
            : showWorkExperienceModal ? 'workExperience'
            : showEducationModal ? 'education'
            : showCoreCompetenciesModal ? 'coreCompetencies'
            : showCertificationsModal ? 'certifications'
            : showItSkillsModal ? 'itSkills'
            : showIndustriesModal ? 'industries'
            : showLanguagesModal ? 'languages'
            : showHobbiesModal ? 'hobbies'
            : showAdditionalInfoModal ? 'additionalInfo'
            : showProfileImageModal ? 'profileImage'
            : showTemplatePreviewDialog ? 'cvPreview'
            : showMotivationDialog ? 'motivationLetter'
            : showApplicationDetailsModal ? 'applicationDetails'
            : showShareLinkDialog ? 'shareLink'
            : null,
          userId: user?.uid || null,
          agbAccepted: agbAccepted === true,
        }}
      />

      {/* Feedback-Button fuer alle Preisplaene */}
      <FeedbackFab
        visible={true}
        user={user}
        language={currentLanguage}
      />
    </Box>
  );
}

function EmailVerificationHandler() {
  const [verificationStatus, setVerificationStatus] = useState<'verifying' | 'success' | 'error'>('verifying');
  const [errorMessage, setErrorMessage] = useState<string>('');

  useEffect(() => {
    const handleVerification = async () => {
      try {
        // Extrahiere oobCode und mode aus URL-Parametern
        const urlParams = new URLSearchParams(window.location.search);
        const oobCode = urlParams.get('oobCode');
        const mode = urlParams.get('mode');

        console.log('🔍 Email-Verifizierung - mode:', mode, 'oobCode:', oobCode ? 'vorhanden' : 'fehlt');

        if (mode === 'verifyEmail' && oobCode) {
          // Verifiziere E-Mail mit Firebase
          await applyActionCode(auth, oobCode);
          console.log('✅ E-Mail erfolgreich verifiziert');
          setVerificationStatus('success');
          
          // Entferne URL-Parameter nach erfolgreicher Verifizierung
          window.history.replaceState({}, document.title, window.location.pathname);
        } else {
          throw new Error('Ungültige Verifizierungs-URL');
        }
      } catch (error: any) {
        console.error('❌ Fehler bei E-Mail-Verifizierung:', error);
        setErrorMessage(error.message || 'Fehler bei der E-Mail-Verifizierung');
        setVerificationStatus('error');
      }
    };

    handleVerification();
  }, []);

  if (verificationStatus === 'verifying') {
    return (
      <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
        <CircularProgress />
        <Typography variant="h6" sx={{ mt: 2 }}>
          E-Mail wird verifiziert...
        </Typography>
      </Container>
    );
  }

  if (verificationStatus === 'success') {
    return (
      <Container maxWidth="sm" sx={{ mt: 8 }}>
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <CheckCircleIcon color="success" sx={{ fontSize: 64, mb: 2 }} />
          <Typography variant="h5" gutterBottom>
            E-Mail erfolgreich verifiziert!
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Ihre E-Mail-Adresse wurde erfolgreich bestätigt. Sie können sich jetzt anmelden.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => window.location.href = '/'}
          >
            Zur Anmeldung
          </Button>
        </Paper>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <ErrorOutlineIcon color="error" sx={{ fontSize: 64, mb: 2 }} />
        <Typography variant="h5" gutterBottom>
          Verifizierung fehlgeschlagen
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          {errorMessage || 'Der Verifizierungslink ist ungültig oder abgelaufen.'}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => window.location.href = '/'}
        >
          Zur Anmeldung
        </Button>
      </Paper>
    </Container>
  );
}

function PasswordResetHandler() {
  const { t } = useTranslation();
  const [status, setStatus] = useState<'form' | 'loading' | 'success' | 'error'>('form');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPw, setConfirmPw] = useState('');
  const [formError, setFormError] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const urlParams = new URLSearchParams(window.location.search);
  const oobCode = urlParams.get('oobCode') || '';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormError('');

    if (newPassword.length < 6) {
      setFormError(t('login.reset.new.too.short'));
      return;
    }
    if (newPassword !== confirmPw) {
      setFormError(t('login.reset.new.mismatch'));
      return;
    }

    setStatus('loading');
    try {
      await confirmPasswordReset(auth, oobCode, newPassword);
      setStatus('success');
      window.history.replaceState({}, document.title, window.location.pathname);
    } catch (err: any) {
      console.error('Password reset error:', err);
      setErrorMessage(err.message || '');
      setStatus('error');
    }
  };

  if (status === 'loading') {
    return (
      <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
        <CircularProgress />
      </Container>
    );
  }

  if (status === 'success') {
    return (
      <Container maxWidth="sm" sx={{ mt: 8 }}>
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <CheckCircleIcon color="success" sx={{ fontSize: 64, mb: 2 }} />
          <Typography variant="h5" gutterBottom>
            {t('login.reset.new.title')}
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            {t('login.reset.new.success')}
          </Typography>
          <Button
            variant="contained"
            onClick={() => window.location.href = '/'}
            sx={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white !important',
              fontWeight: 600,
              textTransform: 'none',
              borderRadius: 2,
              px: 3,
              '&:hover': {
                background: 'linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)',
              },
            }}
          >
            {t('login.reset.new.to.login')}
          </Button>
        </Paper>
      </Container>
    );
  }

  if (status === 'error') {
    return (
      <Container maxWidth="sm" sx={{ mt: 8 }}>
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <ErrorOutlineIcon color="error" sx={{ fontSize: 64, mb: 2 }} />
          <Typography variant="h5" gutterBottom>
            {t('login.reset.new.title')}
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            {t('login.reset.new.error')}
            {errorMessage && (
              <Typography variant="caption" display="block" sx={{ mt: 1, color: 'text.secondary' }}>
                {errorMessage}
              </Typography>
            )}
          </Typography>
          <Button
            variant="contained"
            onClick={() => window.location.href = '/'}
            sx={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white !important',
              fontWeight: 600,
              textTransform: 'none',
              borderRadius: 2,
              px: 3,
              '&:hover': {
                background: 'linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)',
              },
            }}
          >
            {t('login.reset.new.to.login')}
          </Button>
        </Paper>
      </Container>
    );
  }

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      px: { xs: 2, sm: 3 },
      pt: { xs: 2, sm: 4 },
      pb: 4,
    }}>
      <Box sx={{ maxWidth: 400, width: '100%' }}>
        <Typography variant="h5" sx={{ mb: 1, fontWeight: 600 }}>
          {t('login.reset.new.title')}
        </Typography>
        <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary' }}>
          {t('login.reset.new.info')}
        </Typography>

        <form onSubmit={handleSubmit}>
          <TextField
            label={t('login.reset.new.password')}
            type="password"
            value={newPassword}
            onChange={e => { setNewPassword(e.target.value); setFormError(''); }}
            fullWidth
            sx={{ mb: 2 }}
            error={!!formError && formError === t('login.reset.new.too.short')}
            helperText={newPassword && newPassword.length < 6 ? t('login.reset.new.too.short') : ''}
            autoFocus
          />
          <TextField
            label={t('login.reset.new.confirm')}
            type="password"
            value={confirmPw}
            onChange={e => { setConfirmPw(e.target.value); setFormError(''); }}
            fullWidth
            sx={{ mb: 2 }}
            error={confirmPw !== '' && newPassword !== confirmPw}
            helperText={confirmPw !== '' && newPassword !== confirmPw ? t('login.reset.new.mismatch') : ''}
          />

          {formError && (
            <Alert severity="error" sx={{ mb: 2 }}>{formError}</Alert>
          )}

          <Button
            type="submit"
            variant="contained"
            fullWidth
            disabled={!newPassword || !confirmPw || newPassword.length < 6 || newPassword !== confirmPw}
            sx={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white !important',
              fontWeight: 600,
              fontSize: '1rem',
              textTransform: 'none',
              padding: '12px 24px',
              borderRadius: 3,
              transition: 'all 0.3s ease',
              '&:hover': {
                background: 'linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)',
                transform: 'translateY(-2px)',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              },
              '&:disabled': {
                opacity: 0.7,
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white !important',
                transform: 'none',
              },
            }}
          >
            {t('login.reset.new.submit')}
          </Button>
        </form>
      </Box>
    </Box>
  );
}

function App() {
  const { user } = useAuth();

  useEffect(() => {
    document.title = config.frontend.isDevelopment ? 'DEV - Curriculum' : 'Curriculum';
  }, []);
  
  // Prüfe, ob wir auf der Share-Seite oder Einladungsseite sind
  const pathname = window.location.pathname;
  console.log('📍 Aktueller Pfad:', pathname);
  const shareMatch = pathname.match(/^\/share\/([a-f0-9]+)$/);
  const inviteMatch = pathname.match(/^\/invite\/([a-f0-9A-F]+)$/);
  
  // Prüfe, ob Email-Verifizierung ansteht
  const urlParams = new URLSearchParams(window.location.search);
  const mode = urlParams.get('mode');
  const oobCode = urlParams.get('oobCode');
  
  console.log('🔍 Route Check - pathname:', pathname);
  console.log('🔍 Route Check - shareMatch:', shareMatch);
  console.log('🔍 Route Check - inviteMatch:', inviteMatch);
  console.log('🔍 Route Check - mode:', mode, 'oobCode:', oobCode ? 'vorhanden' : 'fehlt');
  
  // Email-Verifizierung hat Priorität
  if (mode === 'verifyEmail' && oobCode) {
    return <EmailVerificationHandler />;
  }

  // Passwort-Reset Handler
  if (mode === 'resetPassword' && oobCode) {
    return <PasswordResetHandler />;
  }
  
  if (shareMatch) {
    const token = shareMatch[1];
    console.log('🔗 Share-Seite erkannt, Token:', token);
    // Share-Seite rendern (keine Authentifizierung erforderlich)
    return <CvSharePage token={token} />;
  }
  
  if (inviteMatch) {
    const token = inviteMatch[1];
    console.log('🔗 Einladungsseite erkannt, Token:', token);
    console.log('🔗 Token-Länge:', token.length);
    console.log('🔗 Token-Format:', /^[a-f0-9A-F]+$/.test(token) ? 'Gültig' : 'Ungültig');
    // Einladungsseite rendern (keine Authentifizierung erforderlich)
    // Dynamischer Import für Code-Splitting
    const InviteAccept = React.lazy(() => import('./components/InviteAccept'));
    return (
      <React.Suspense fallback={
        <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
          <CircularProgress />
        </Container>
      }>
        <InviteAccept token={token} />
      </React.Suspense>
    );
  }
  
  // Normale App (erfordert Login)
  return user ? <ProtectedApp /> : <Login />;
}

export default function Root() {
  return (
    <AuthProvider>
      <App />
    </AuthProvider>
  );
}